
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0b1c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0b1c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("irwyI", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d6d401235435b965$export$ffb0004e005737fa, (v) => $d6d401235435b965$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d6d401235435b965$export$34b9dba7ce09269b, (v) => $d6d401235435b965$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d6d401235435b965$export$25062201e9e25d76, (v) => $d6d401235435b965$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d6d401235435b965$export$ffb0004e005737fa;
var $d6d401235435b965$export$34b9dba7ce09269b;
var $d6d401235435b965$export$25062201e9e25d76;
"use strict";
var $d6d401235435b965$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d6d401235435b965$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $d6d401235435b965$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $d6d401235435b965$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$d6d401235435b965$export$ffb0004e005737fa = $d6d401235435b965$var$REACT_FRAGMENT_TYPE;
$d6d401235435b965$export$34b9dba7ce09269b = $d6d401235435b965$var$jsxProd;
$d6d401235435b965$export$25062201e9e25d76 = $d6d401235435b965$var$jsxProd;

});

parcelRegister("eij5T", function(module, exports) {

$parcel$export(module.exports, "Children", () => $a6818ed42b6582f8$export$dca3b0875bd9a954, (v) => $a6818ed42b6582f8$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $a6818ed42b6582f8$export$16fa2f45be04daa8, (v) => $a6818ed42b6582f8$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $a6818ed42b6582f8$export$ffb0004e005737fa, (v) => $a6818ed42b6582f8$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $a6818ed42b6582f8$export$e2c29f18771995cb, (v) => $a6818ed42b6582f8$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $a6818ed42b6582f8$export$221d75b3f55bb0bd, (v) => $a6818ed42b6582f8$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $a6818ed42b6582f8$export$5f8d39834fd61797, (v) => $a6818ed42b6582f8$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a6818ed42b6582f8$export$74bf444e3cd11ea5, (v) => $a6818ed42b6582f8$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $a6818ed42b6582f8$export$1ced07cd6b1985ce, (v) => $a6818ed42b6582f8$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $a6818ed42b6582f8$export$abd8e32b826d7ea7, (v) => $a6818ed42b6582f8$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $a6818ed42b6582f8$export$69a3209f1a06c04d, (v) => $a6818ed42b6582f8$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $a6818ed42b6582f8$export$e530037191fcd5d7, (v) => $a6818ed42b6582f8$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $a6818ed42b6582f8$export$fd42f52fd3ae1109, (v) => $a6818ed42b6582f8$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $a6818ed42b6582f8$export$c8a8987d4410bf2d, (v) => $a6818ed42b6582f8$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $a6818ed42b6582f8$export$7d1e3a5e95ceca43, (v) => $a6818ed42b6582f8$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $a6818ed42b6582f8$export$257a8862b851cb5b, (v) => $a6818ed42b6582f8$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $a6818ed42b6582f8$export$a8257692ac88316c, (v) => $a6818ed42b6582f8$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $a6818ed42b6582f8$export$488013bae63b21da, (v) => $a6818ed42b6582f8$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $a6818ed42b6582f8$export$7c73462e0d25e514, (v) => $a6818ed42b6582f8$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $a6818ed42b6582f8$export$7568632d0d33d16d, (v) => $a6818ed42b6582f8$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $a6818ed42b6582f8$export$f93f40ac0ca7e3a8, (v) => $a6818ed42b6582f8$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $a6818ed42b6582f8$export$1f96ae73734a86cc, (v) => $a6818ed42b6582f8$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $a6818ed42b6582f8$export$9a47ced3238df325, (v) => $a6818ed42b6582f8$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $a6818ed42b6582f8$export$35808ee640e87ca7, (v) => $a6818ed42b6582f8$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $a6818ed42b6582f8$export$fae74005e78b1a27, (v) => $a6818ed42b6582f8$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $a6818ed42b6582f8$export$dc8fbce3eb94dc1e, (v) => $a6818ed42b6582f8$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $a6818ed42b6582f8$export$6a7bc4e911dc01cf, (v) => $a6818ed42b6582f8$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $a6818ed42b6582f8$export$6d9c69b0de29b591, (v) => $a6818ed42b6582f8$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $a6818ed42b6582f8$export$f680877a34711e37, (v) => $a6818ed42b6582f8$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $a6818ed42b6582f8$export$d5a552a76deda3c2, (v) => $a6818ed42b6582f8$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $a6818ed42b6582f8$export$aaabe4eda9ed9969, (v) => $a6818ed42b6582f8$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $a6818ed42b6582f8$export$e5c5a5f917a5871c, (v) => $a6818ed42b6582f8$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $a6818ed42b6582f8$export$1538c33de8887b59, (v) => $a6818ed42b6582f8$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $a6818ed42b6582f8$export$fca7f784ae7a249a, (v) => $a6818ed42b6582f8$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $a6818ed42b6582f8$export$13e3392192263954, (v) => $a6818ed42b6582f8$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $a6818ed42b6582f8$export$b8f5890fc79d6aca, (v) => $a6818ed42b6582f8$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $a6818ed42b6582f8$export$60241385465d0a34, (v) => $a6818ed42b6582f8$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $a6818ed42b6582f8$export$306c0aa65ff9ec16, (v) => $a6818ed42b6582f8$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $a6818ed42b6582f8$export$7b286972b8d8ccbf, (v) => $a6818ed42b6582f8$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $a6818ed42b6582f8$export$83d89fbfd8236492, (v) => $a6818ed42b6582f8$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a6818ed42b6582f8$export$dca3b0875bd9a954;
var $a6818ed42b6582f8$export$16fa2f45be04daa8;
var $a6818ed42b6582f8$export$ffb0004e005737fa;
var $a6818ed42b6582f8$export$e2c29f18771995cb;
var $a6818ed42b6582f8$export$221d75b3f55bb0bd;
var $a6818ed42b6582f8$export$5f8d39834fd61797;
var $a6818ed42b6582f8$export$74bf444e3cd11ea5;
var $a6818ed42b6582f8$export$1ced07cd6b1985ce;
var $a6818ed42b6582f8$export$abd8e32b826d7ea7;
var $a6818ed42b6582f8$export$69a3209f1a06c04d;
var $a6818ed42b6582f8$export$e530037191fcd5d7;
var $a6818ed42b6582f8$export$fd42f52fd3ae1109;
var $a6818ed42b6582f8$export$c8a8987d4410bf2d;
var $a6818ed42b6582f8$export$7d1e3a5e95ceca43;
var $a6818ed42b6582f8$export$257a8862b851cb5b;
var $a6818ed42b6582f8$export$a8257692ac88316c;
var $a6818ed42b6582f8$export$488013bae63b21da;
var $a6818ed42b6582f8$export$7c73462e0d25e514;
var $a6818ed42b6582f8$export$7568632d0d33d16d;
var $a6818ed42b6582f8$export$f93f40ac0ca7e3a8;
var $a6818ed42b6582f8$export$1f96ae73734a86cc;
var $a6818ed42b6582f8$export$9a47ced3238df325;
var $a6818ed42b6582f8$export$35808ee640e87ca7;
var $a6818ed42b6582f8$export$fae74005e78b1a27;
var $a6818ed42b6582f8$export$dc8fbce3eb94dc1e;
var $a6818ed42b6582f8$export$6a7bc4e911dc01cf;
var $a6818ed42b6582f8$export$6d9c69b0de29b591;
var $a6818ed42b6582f8$export$f680877a34711e37;
var $a6818ed42b6582f8$export$d5a552a76deda3c2;
var $a6818ed42b6582f8$export$aaabe4eda9ed9969;
var $a6818ed42b6582f8$export$e5c5a5f917a5871c;
var $a6818ed42b6582f8$export$1538c33de8887b59;
var $a6818ed42b6582f8$export$fca7f784ae7a249a;
var $a6818ed42b6582f8$export$13e3392192263954;
var $a6818ed42b6582f8$export$b8f5890fc79d6aca;
var $a6818ed42b6582f8$export$60241385465d0a34;
var $a6818ed42b6582f8$export$306c0aa65ff9ec16;
var $a6818ed42b6582f8$export$7b286972b8d8ccbf;
var $a6818ed42b6582f8$export$83d89fbfd8236492;
"use strict";
var $a6818ed42b6582f8$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $a6818ed42b6582f8$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $a6818ed42b6582f8$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $a6818ed42b6582f8$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $a6818ed42b6582f8$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $a6818ed42b6582f8$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $a6818ed42b6582f8$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $a6818ed42b6582f8$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $a6818ed42b6582f8$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $a6818ed42b6582f8$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $a6818ed42b6582f8$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $a6818ed42b6582f8$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $a6818ed42b6582f8$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $a6818ed42b6582f8$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$a6818ed42b6582f8$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $a6818ed42b6582f8$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $a6818ed42b6582f8$var$assign = Object.assign, $a6818ed42b6582f8$var$emptyObject = {};
function $a6818ed42b6582f8$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $a6818ed42b6582f8$var$emptyObject;
    this.updater = updater || $a6818ed42b6582f8$var$ReactNoopUpdateQueue;
}
$a6818ed42b6582f8$var$Component.prototype.isReactComponent = {};
$a6818ed42b6582f8$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$a6818ed42b6582f8$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $a6818ed42b6582f8$var$ComponentDummy() {}
$a6818ed42b6582f8$var$ComponentDummy.prototype = $a6818ed42b6582f8$var$Component.prototype;
function $a6818ed42b6582f8$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $a6818ed42b6582f8$var$emptyObject;
    this.updater = updater || $a6818ed42b6582f8$var$ReactNoopUpdateQueue;
}
var $a6818ed42b6582f8$var$pureComponentPrototype = $a6818ed42b6582f8$var$PureComponent.prototype = new $a6818ed42b6582f8$var$ComponentDummy();
$a6818ed42b6582f8$var$pureComponentPrototype.constructor = $a6818ed42b6582f8$var$PureComponent;
$a6818ed42b6582f8$var$assign($a6818ed42b6582f8$var$pureComponentPrototype, $a6818ed42b6582f8$var$Component.prototype);
$a6818ed42b6582f8$var$pureComponentPrototype.isPureReactComponent = !0;
var $a6818ed42b6582f8$var$isArrayImpl = Array.isArray, $a6818ed42b6582f8$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $a6818ed42b6582f8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $a6818ed42b6582f8$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $a6818ed42b6582f8$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $a6818ed42b6582f8$var$cloneAndReplaceKey(oldElement, newKey) {
    return $a6818ed42b6582f8$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $a6818ed42b6582f8$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $a6818ed42b6582f8$var$REACT_ELEMENT_TYPE;
}
function $a6818ed42b6582f8$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $a6818ed42b6582f8$var$userProvidedKeyEscapeRegex = /\/+/g;
function $a6818ed42b6582f8$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $a6818ed42b6582f8$var$escape("" + element.key) : index.toString(36);
}
function $a6818ed42b6582f8$var$noop$1() {}
function $a6818ed42b6582f8$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($a6818ed42b6582f8$var$noop$1, $a6818ed42b6582f8$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $a6818ed42b6582f8$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $a6818ed42b6582f8$var$REACT_ELEMENT_TYPE:
                case $a6818ed42b6582f8$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $a6818ed42b6582f8$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $a6818ed42b6582f8$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $a6818ed42b6582f8$var$getElementKey(children, 0) : nameSoFar, $a6818ed42b6582f8$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($a6818ed42b6582f8$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $a6818ed42b6582f8$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($a6818ed42b6582f8$var$isValidElement(callback) && (callback = $a6818ed42b6582f8$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($a6818ed42b6582f8$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($a6818ed42b6582f8$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $a6818ed42b6582f8$var$getElementKey(nameSoFar, i), invokeCallback += $a6818ed42b6582f8$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $a6818ed42b6582f8$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $a6818ed42b6582f8$var$getElementKey(nameSoFar, i++), invokeCallback += $a6818ed42b6582f8$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $a6818ed42b6582f8$var$mapIntoArray($a6818ed42b6582f8$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $a6818ed42b6582f8$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $a6818ed42b6582f8$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $a6818ed42b6582f8$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $a6818ed42b6582f8$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $a6818ed42b6582f8$var$noop() {}
$a6818ed42b6582f8$export$dca3b0875bd9a954 = {
    map: $a6818ed42b6582f8$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $a6818ed42b6582f8$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $a6818ed42b6582f8$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $a6818ed42b6582f8$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$a6818ed42b6582f8$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$a6818ed42b6582f8$export$16fa2f45be04daa8 = $a6818ed42b6582f8$var$Component;
$a6818ed42b6582f8$export$ffb0004e005737fa = $a6818ed42b6582f8$var$REACT_FRAGMENT_TYPE;
$a6818ed42b6582f8$export$e2c29f18771995cb = $a6818ed42b6582f8$var$REACT_PROFILER_TYPE;
$a6818ed42b6582f8$export$221d75b3f55bb0bd = $a6818ed42b6582f8$var$PureComponent;
$a6818ed42b6582f8$export$5f8d39834fd61797 = $a6818ed42b6582f8$var$REACT_STRICT_MODE_TYPE;
$a6818ed42b6582f8$export$74bf444e3cd11ea5 = $a6818ed42b6582f8$var$REACT_SUSPENSE_TYPE;
$a6818ed42b6582f8$export$1ced07cd6b1985ce = $a6818ed42b6582f8$var$ReactSharedInternals;
$a6818ed42b6582f8$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $a6818ed42b6582f8$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$a6818ed42b6582f8$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$a6818ed42b6582f8$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $a6818ed42b6582f8$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$a6818ed42b6582f8$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $a6818ed42b6582f8$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$a6818ed42b6582f8$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $a6818ed42b6582f8$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $a6818ed42b6582f8$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$a6818ed42b6582f8$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$a6818ed42b6582f8$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $a6818ed42b6582f8$var$ReactElement(type, key, void 0, void 0, null, props);
};
$a6818ed42b6582f8$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$a6818ed42b6582f8$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $a6818ed42b6582f8$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$a6818ed42b6582f8$export$a8257692ac88316c = $a6818ed42b6582f8$var$isValidElement;
$a6818ed42b6582f8$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $a6818ed42b6582f8$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $a6818ed42b6582f8$var$lazyInitializer
    };
};
$a6818ed42b6582f8$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $a6818ed42b6582f8$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$a6818ed42b6582f8$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $a6818ed42b6582f8$var$ReactSharedInternals.T, currentTransition = {};
    $a6818ed42b6582f8$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $a6818ed42b6582f8$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($a6818ed42b6582f8$var$noop, $a6818ed42b6582f8$var$reportGlobalError);
    } catch (error) {
        $a6818ed42b6582f8$var$reportGlobalError(error);
    } finally{
        $a6818ed42b6582f8$var$ReactSharedInternals.T = prevTransition;
    }
};
$a6818ed42b6582f8$export$f93f40ac0ca7e3a8 = function() {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useCacheRefresh();
};
$a6818ed42b6582f8$export$1f96ae73734a86cc = function(usable) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.use(usable);
};
$a6818ed42b6582f8$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$a6818ed42b6582f8$export$35808ee640e87ca7 = function(callback, deps) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$a6818ed42b6582f8$export$fae74005e78b1a27 = function(Context) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useContext(Context);
};
$a6818ed42b6582f8$export$dc8fbce3eb94dc1e = function() {};
$a6818ed42b6582f8$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$a6818ed42b6582f8$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $a6818ed42b6582f8$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$a6818ed42b6582f8$export$f680877a34711e37 = function() {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useId();
};
$a6818ed42b6582f8$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$a6818ed42b6582f8$export$aaabe4eda9ed9969 = function(create, deps) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$a6818ed42b6582f8$export$e5c5a5f917a5871c = function(create, deps) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$a6818ed42b6582f8$export$1538c33de8887b59 = function(create, deps) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useMemo(create, deps);
};
$a6818ed42b6582f8$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$a6818ed42b6582f8$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$a6818ed42b6582f8$export$b8f5890fc79d6aca = function(initialValue) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useRef(initialValue);
};
$a6818ed42b6582f8$export$60241385465d0a34 = function(initialState) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useState(initialState);
};
$a6818ed42b6582f8$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$a6818ed42b6582f8$export$7b286972b8d8ccbf = function() {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useTransition();
};
$a6818ed42b6582f8$export$83d89fbfd8236492 = "19.1.0";

});

parcelRegister("5xaMB", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $407866112e362b76$export$882461b6382ed46c, (v) => $407866112e362b76$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $407866112e362b76$export$757ceba2d55c277e, (v) => $407866112e362b76$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $407866112e362b76$export$83d89fbfd8236492, (v) => $407866112e362b76$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $407866112e362b76$export$882461b6382ed46c;
var $407866112e362b76$export$757ceba2d55c277e;
var $407866112e362b76$export$83d89fbfd8236492;
"use strict";

var $hNfVH = parcelRequire("hNfVH");

var $8vqx4 = parcelRequire("8vqx4");

var $hiyfL = parcelRequire("hiyfL");
function $407866112e362b76$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $407866112e362b76$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $407866112e362b76$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $407866112e362b76$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $407866112e362b76$var$assertIsMounted(fiber) {
    if ($407866112e362b76$var$getNearestMountedFiber(fiber) !== fiber) throw Error($407866112e362b76$var$formatProdErrorMessage(188));
}
function $407866112e362b76$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $407866112e362b76$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($407866112e362b76$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $407866112e362b76$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $407866112e362b76$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($407866112e362b76$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($407866112e362b76$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($407866112e362b76$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($407866112e362b76$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $407866112e362b76$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $407866112e362b76$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $407866112e362b76$var$assign = Object.assign, $407866112e362b76$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $407866112e362b76$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $407866112e362b76$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $407866112e362b76$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $407866112e362b76$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $407866112e362b76$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $407866112e362b76$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $407866112e362b76$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $407866112e362b76$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $407866112e362b76$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $407866112e362b76$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $407866112e362b76$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $407866112e362b76$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $407866112e362b76$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $407866112e362b76$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $407866112e362b76$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $407866112e362b76$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $407866112e362b76$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $407866112e362b76$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$407866112e362b76$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $407866112e362b76$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $407866112e362b76$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $407866112e362b76$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $407866112e362b76$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $407866112e362b76$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $407866112e362b76$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $407866112e362b76$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $407866112e362b76$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $407866112e362b76$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $407866112e362b76$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $407866112e362b76$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $407866112e362b76$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $407866112e362b76$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $407866112e362b76$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $407866112e362b76$var$getComponentNameFromType(type.type) || "Memo";
        case $407866112e362b76$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $407866112e362b76$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $407866112e362b76$var$isArrayImpl = Array.isArray, $407866112e362b76$var$ReactSharedInternals = $8vqx4.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $407866112e362b76$var$ReactDOMSharedInternals = $hiyfL.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $407866112e362b76$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $407866112e362b76$var$valueStack = [], $407866112e362b76$var$index = -1;
function $407866112e362b76$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $407866112e362b76$var$pop(cursor) {
    0 > $407866112e362b76$var$index || (cursor.current = $407866112e362b76$var$valueStack[$407866112e362b76$var$index], $407866112e362b76$var$valueStack[$407866112e362b76$var$index] = null, $407866112e362b76$var$index--);
}
function $407866112e362b76$var$push(cursor, value) {
    $407866112e362b76$var$index++;
    $407866112e362b76$var$valueStack[$407866112e362b76$var$index] = cursor.current;
    cursor.current = value;
}
var $407866112e362b76$var$contextStackCursor = $407866112e362b76$var$createCursor(null), $407866112e362b76$var$contextFiberStackCursor = $407866112e362b76$var$createCursor(null), $407866112e362b76$var$rootInstanceStackCursor = $407866112e362b76$var$createCursor(null), $407866112e362b76$var$hostTransitionProviderCursor = $407866112e362b76$var$createCursor(null);
function $407866112e362b76$var$pushHostContainer(fiber, nextRootInstance) {
    $407866112e362b76$var$push($407866112e362b76$var$rootInstanceStackCursor, nextRootInstance);
    $407866112e362b76$var$push($407866112e362b76$var$contextFiberStackCursor, fiber);
    $407866112e362b76$var$push($407866112e362b76$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $407866112e362b76$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $407866112e362b76$var$getOwnHostContext(nextRootInstance), fiber = $407866112e362b76$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $407866112e362b76$var$pop($407866112e362b76$var$contextStackCursor);
    $407866112e362b76$var$push($407866112e362b76$var$contextStackCursor, fiber);
}
function $407866112e362b76$var$popHostContainer() {
    $407866112e362b76$var$pop($407866112e362b76$var$contextStackCursor);
    $407866112e362b76$var$pop($407866112e362b76$var$contextFiberStackCursor);
    $407866112e362b76$var$pop($407866112e362b76$var$rootInstanceStackCursor);
}
function $407866112e362b76$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $407866112e362b76$var$push($407866112e362b76$var$hostTransitionProviderCursor, fiber);
    var context = $407866112e362b76$var$contextStackCursor.current;
    var JSCompiler_inline_result = $407866112e362b76$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($407866112e362b76$var$push($407866112e362b76$var$contextFiberStackCursor, fiber), $407866112e362b76$var$push($407866112e362b76$var$contextStackCursor, JSCompiler_inline_result));
}
function $407866112e362b76$var$popHostContext(fiber) {
    $407866112e362b76$var$contextFiberStackCursor.current === fiber && ($407866112e362b76$var$pop($407866112e362b76$var$contextStackCursor), $407866112e362b76$var$pop($407866112e362b76$var$contextFiberStackCursor));
    $407866112e362b76$var$hostTransitionProviderCursor.current === fiber && ($407866112e362b76$var$pop($407866112e362b76$var$hostTransitionProviderCursor), $407866112e362b76$var$HostTransitionContext._currentValue = $407866112e362b76$var$sharedNotPendingObject);
}
var $407866112e362b76$var$hasOwnProperty = Object.prototype.hasOwnProperty, $407866112e362b76$var$scheduleCallback$3 = $hNfVH.unstable_scheduleCallback, $407866112e362b76$var$cancelCallback$1 = $hNfVH.unstable_cancelCallback, $407866112e362b76$var$shouldYield = $hNfVH.unstable_shouldYield, $407866112e362b76$var$requestPaint = $hNfVH.unstable_requestPaint, $407866112e362b76$var$now = $hNfVH.unstable_now, $407866112e362b76$var$getCurrentPriorityLevel = $hNfVH.unstable_getCurrentPriorityLevel, $407866112e362b76$var$ImmediatePriority = $hNfVH.unstable_ImmediatePriority, $407866112e362b76$var$UserBlockingPriority = $hNfVH.unstable_UserBlockingPriority, $407866112e362b76$var$NormalPriority$1 = $hNfVH.unstable_NormalPriority, $407866112e362b76$var$LowPriority = $hNfVH.unstable_LowPriority, $407866112e362b76$var$IdlePriority = $hNfVH.unstable_IdlePriority, $407866112e362b76$var$log$1 = $hNfVH.log, $407866112e362b76$var$unstable_setDisableYieldValue = $hNfVH.unstable_setDisableYieldValue, $407866112e362b76$var$rendererID = null, $407866112e362b76$var$injectedHook = null;
function $407866112e362b76$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $407866112e362b76$var$log$1 && $407866112e362b76$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($407866112e362b76$var$injectedHook && "function" === typeof $407866112e362b76$var$injectedHook.setStrictMode) try {
        $407866112e362b76$var$injectedHook.setStrictMode($407866112e362b76$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $407866112e362b76$var$clz32 = Math.clz32 ? Math.clz32 : $407866112e362b76$var$clz32Fallback, $407866112e362b76$var$log = Math.log, $407866112e362b76$var$LN2 = Math.LN2;
function $407866112e362b76$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($407866112e362b76$var$log(x) / $407866112e362b76$var$LN2 | 0) | 0;
}
var $407866112e362b76$var$nextTransitionLane = 256, $407866112e362b76$var$nextRetryLane = 4194304;
function $407866112e362b76$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $407866112e362b76$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $407866112e362b76$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $407866112e362b76$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $407866112e362b76$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $407866112e362b76$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $407866112e362b76$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $407866112e362b76$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $407866112e362b76$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $407866112e362b76$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $407866112e362b76$var$claimNextTransitionLane() {
    var lane = $407866112e362b76$var$nextTransitionLane;
    $407866112e362b76$var$nextTransitionLane <<= 1;
    0 === ($407866112e362b76$var$nextTransitionLane & 4194048) && ($407866112e362b76$var$nextTransitionLane = 256);
    return lane;
}
function $407866112e362b76$var$claimNextRetryLane() {
    var lane = $407866112e362b76$var$nextRetryLane;
    $407866112e362b76$var$nextRetryLane <<= 1;
    0 === ($407866112e362b76$var$nextRetryLane & 62914560) && ($407866112e362b76$var$nextRetryLane = 4194304);
    return lane;
}
function $407866112e362b76$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $407866112e362b76$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $407866112e362b76$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $407866112e362b76$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $407866112e362b76$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $407866112e362b76$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $407866112e362b76$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $407866112e362b76$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $407866112e362b76$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $407866112e362b76$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $407866112e362b76$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $407866112e362b76$var$resolveUpdatePriority() {
    var updatePriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $407866112e362b76$var$getEventPriority(updatePriority.type);
}
function $407866112e362b76$var$runWithPriority(priority, fn) {
    var previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
    try {
        return $407866112e362b76$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $407866112e362b76$var$randomKey = Math.random().toString(36).slice(2), $407866112e362b76$var$internalInstanceKey = "__reactFiber$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalPropsKey = "__reactProps$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalContainerInstanceKey = "__reactContainer$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalEventHandlersKey = "__reactEvents$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalEventHandlerListenersKey = "__reactListeners$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalEventHandlesSetKey = "__reactHandles$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalRootNodeResourcesKey = "__reactResources$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalHoistableMarker = "__reactMarker$" + $407866112e362b76$var$randomKey;
function $407866112e362b76$var$detachDeletedInstance(node) {
    delete node[$407866112e362b76$var$internalInstanceKey];
    delete node[$407866112e362b76$var$internalPropsKey];
    delete node[$407866112e362b76$var$internalEventHandlersKey];
    delete node[$407866112e362b76$var$internalEventHandlerListenersKey];
    delete node[$407866112e362b76$var$internalEventHandlesSetKey];
}
function $407866112e362b76$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$407866112e362b76$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$407866112e362b76$var$internalContainerInstanceKey] || parentNode[$407866112e362b76$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $407866112e362b76$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$407866112e362b76$var$internalInstanceKey]) return parentNode;
                targetNode = $407866112e362b76$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $407866112e362b76$var$getInstanceFromNode(node) {
    if (node = node[$407866112e362b76$var$internalInstanceKey] || node[$407866112e362b76$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $407866112e362b76$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($407866112e362b76$var$formatProdErrorMessage(33));
}
function $407866112e362b76$var$getResourcesFromRoot(root) {
    var resources = root[$407866112e362b76$var$internalRootNodeResourcesKey];
    resources || (resources = root[$407866112e362b76$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $407866112e362b76$var$markNodeAsHoistable(node) {
    node[$407866112e362b76$var$internalHoistableMarker] = !0;
}
var $407866112e362b76$var$allNativeEvents = new Set(), $407866112e362b76$var$registrationNameDependencies = {};
function $407866112e362b76$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $407866112e362b76$var$registerDirectEvent(registrationName, dependencies);
    $407866112e362b76$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $407866112e362b76$var$registerDirectEvent(registrationName, dependencies) {
    $407866112e362b76$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$407866112e362b76$var$allNativeEvents.add(dependencies[registrationName]);
}
var $407866112e362b76$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $407866112e362b76$var$illegalAttributeNameCache = {}, $407866112e362b76$var$validatedAttributeNameCache = {};
function $407866112e362b76$var$isAttributeNameSafe(attributeName) {
    if ($407866112e362b76$var$hasOwnProperty.call($407866112e362b76$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($407866112e362b76$var$hasOwnProperty.call($407866112e362b76$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($407866112e362b76$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $407866112e362b76$var$validatedAttributeNameCache[attributeName] = !0;
    $407866112e362b76$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $407866112e362b76$var$setValueForAttribute(node, name, value) {
    if ($407866112e362b76$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $407866112e362b76$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $407866112e362b76$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $407866112e362b76$var$prefix, $407866112e362b76$var$suffix;
function $407866112e362b76$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $407866112e362b76$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $407866112e362b76$var$prefix = match && match[1] || "";
        $407866112e362b76$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $407866112e362b76$var$prefix + name + $407866112e362b76$var$suffix;
}
var $407866112e362b76$var$reentry = !1;
function $407866112e362b76$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $407866112e362b76$var$reentry) return "";
    $407866112e362b76$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $407866112e362b76$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $407866112e362b76$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $407866112e362b76$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $407866112e362b76$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $407866112e362b76$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $407866112e362b76$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $407866112e362b76$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $407866112e362b76$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $407866112e362b76$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $407866112e362b76$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $407866112e362b76$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $407866112e362b76$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $407866112e362b76$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $407866112e362b76$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $407866112e362b76$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $407866112e362b76$var$trackValueOnNode(node) {
    var valueField = $407866112e362b76$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $407866112e362b76$var$track(node) {
    node._valueTracker || (node._valueTracker = $407866112e362b76$var$trackValueOnNode(node));
}
function $407866112e362b76$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $407866112e362b76$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $407866112e362b76$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $407866112e362b76$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $407866112e362b76$var$getToStringValue(value);
        } else element.value !== "" + $407866112e362b76$var$getToStringValue(value) && (element.value = "" + $407866112e362b76$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $407866112e362b76$var$setDefaultValue(element, type, $407866112e362b76$var$getToStringValue(value)) : null != defaultValue ? $407866112e362b76$var$setDefaultValue(element, type, $407866112e362b76$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $407866112e362b76$var$getToStringValue(name) : element.removeAttribute("name");
}
function $407866112e362b76$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $407866112e362b76$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $407866112e362b76$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $407866112e362b76$var$setDefaultValue(node, type, value) {
    "number" === type && $407866112e362b76$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $407866112e362b76$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $407866112e362b76$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $407866112e362b76$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $407866112e362b76$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $407866112e362b76$var$getToStringValue(defaultValue) : "";
}
function $407866112e362b76$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($407866112e362b76$var$formatProdErrorMessage(92));
            if ($407866112e362b76$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($407866112e362b76$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $407866112e362b76$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $407866112e362b76$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $407866112e362b76$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $407866112e362b76$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $407866112e362b76$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $407866112e362b76$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($407866112e362b76$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $407866112e362b76$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $407866112e362b76$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $407866112e362b76$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $407866112e362b76$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $407866112e362b76$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $407866112e362b76$var$sanitizeURL(url) {
    return $407866112e362b76$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $407866112e362b76$var$currentReplayingEvent = null;
function $407866112e362b76$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $407866112e362b76$var$restoreTarget = null, $407866112e362b76$var$restoreQueue = null;
function $407866112e362b76$var$restoreStateOfTarget(target) {
    var internalInstance = $407866112e362b76$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$407866112e362b76$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $407866112e362b76$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$407866112e362b76$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($407866112e362b76$var$formatProdErrorMessage(90));
                            $407866112e362b76$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $407866112e362b76$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $407866112e362b76$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $407866112e362b76$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $407866112e362b76$var$isInsideEventHandler = !1;
function $407866112e362b76$var$batchedUpdates$1(fn, a, b) {
    if ($407866112e362b76$var$isInsideEventHandler) return fn(a, b);
    $407866112e362b76$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($407866112e362b76$var$isInsideEventHandler = !1, null !== $407866112e362b76$var$restoreTarget || null !== $407866112e362b76$var$restoreQueue) {
            if ($407866112e362b76$var$flushSyncWork$1(), $407866112e362b76$var$restoreTarget && (a = $407866112e362b76$var$restoreTarget, fn = $407866112e362b76$var$restoreQueue, $407866112e362b76$var$restoreQueue = $407866112e362b76$var$restoreTarget = null, $407866112e362b76$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$407866112e362b76$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $407866112e362b76$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$407866112e362b76$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($407866112e362b76$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $407866112e362b76$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $407866112e362b76$var$passiveBrowserEventsSupported = !1;
if ($407866112e362b76$var$canUseDOM) try {
    var $407866112e362b76$var$options = {};
    Object.defineProperty($407866112e362b76$var$options, "passive", {
        get: function() {
            $407866112e362b76$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $407866112e362b76$var$options, $407866112e362b76$var$options);
    window.removeEventListener("test", $407866112e362b76$var$options, $407866112e362b76$var$options);
} catch (e) {
    $407866112e362b76$var$passiveBrowserEventsSupported = !1;
}
var $407866112e362b76$var$root = null, $407866112e362b76$var$startText = null, $407866112e362b76$var$fallbackText = null;
function $407866112e362b76$var$getData() {
    if ($407866112e362b76$var$fallbackText) return $407866112e362b76$var$fallbackText;
    var start, startValue = $407866112e362b76$var$startText, startLength = startValue.length, end, endValue = "value" in $407866112e362b76$var$root ? $407866112e362b76$var$root.value : $407866112e362b76$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $407866112e362b76$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $407866112e362b76$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $407866112e362b76$var$functionThatReturnsTrue() {
    return !0;
}
function $407866112e362b76$var$functionThatReturnsFalse() {
    return !1;
}
function $407866112e362b76$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $407866112e362b76$var$functionThatReturnsTrue : $407866112e362b76$var$functionThatReturnsFalse;
        this.isPropagationStopped = $407866112e362b76$var$functionThatReturnsFalse;
        return this;
    }
    $407866112e362b76$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $407866112e362b76$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $407866112e362b76$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $407866112e362b76$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $407866112e362b76$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $407866112e362b76$var$SyntheticEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$EventInterface), $407866112e362b76$var$UIEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$EventInterface, {
    view: 0,
    detail: 0
}), $407866112e362b76$var$SyntheticUIEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$UIEventInterface), $407866112e362b76$var$lastMovementX, $407866112e362b76$var$lastMovementY, $407866112e362b76$var$lastMouseEvent, $407866112e362b76$var$MouseEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $407866112e362b76$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $407866112e362b76$var$lastMouseEvent && ($407866112e362b76$var$lastMouseEvent && "mousemove" === event.type ? ($407866112e362b76$var$lastMovementX = event.screenX - $407866112e362b76$var$lastMouseEvent.screenX, $407866112e362b76$var$lastMovementY = event.screenY - $407866112e362b76$var$lastMouseEvent.screenY) : $407866112e362b76$var$lastMovementY = $407866112e362b76$var$lastMovementX = 0, $407866112e362b76$var$lastMouseEvent = event);
        return $407866112e362b76$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $407866112e362b76$var$lastMovementY;
    }
}), $407866112e362b76$var$SyntheticMouseEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$MouseEventInterface), $407866112e362b76$var$DragEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$MouseEventInterface, {
    dataTransfer: 0
}), $407866112e362b76$var$SyntheticDragEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$DragEventInterface), $407866112e362b76$var$FocusEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$UIEventInterface, {
    relatedTarget: 0
}), $407866112e362b76$var$SyntheticFocusEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$FocusEventInterface), $407866112e362b76$var$AnimationEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $407866112e362b76$var$SyntheticAnimationEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$AnimationEventInterface), $407866112e362b76$var$ClipboardEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $407866112e362b76$var$SyntheticClipboardEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$ClipboardEventInterface), $407866112e362b76$var$CompositionEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$EventInterface, {
    data: 0
}), $407866112e362b76$var$SyntheticCompositionEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$CompositionEventInterface), $407866112e362b76$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $407866112e362b76$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $407866112e362b76$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $407866112e362b76$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $407866112e362b76$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $407866112e362b76$var$getEventModifierState() {
    return $407866112e362b76$var$modifierStateGetter;
}
var $407866112e362b76$var$KeyboardEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $407866112e362b76$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $407866112e362b76$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $407866112e362b76$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $407866112e362b76$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $407866112e362b76$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $407866112e362b76$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $407866112e362b76$var$SyntheticKeyboardEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$KeyboardEventInterface), $407866112e362b76$var$PointerEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $407866112e362b76$var$SyntheticPointerEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$PointerEventInterface), $407866112e362b76$var$TouchEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $407866112e362b76$var$getEventModifierState
}), $407866112e362b76$var$SyntheticTouchEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$TouchEventInterface), $407866112e362b76$var$TransitionEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $407866112e362b76$var$SyntheticTransitionEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$TransitionEventInterface), $407866112e362b76$var$WheelEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $407866112e362b76$var$SyntheticWheelEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$WheelEventInterface), $407866112e362b76$var$ToggleEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $407866112e362b76$var$SyntheticToggleEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$ToggleEventInterface), $407866112e362b76$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $407866112e362b76$var$canUseCompositionEvent = $407866112e362b76$var$canUseDOM && "CompositionEvent" in window, $407866112e362b76$var$documentMode = null;
$407866112e362b76$var$canUseDOM && "documentMode" in document && ($407866112e362b76$var$documentMode = document.documentMode);
var $407866112e362b76$var$canUseTextInputEvent = $407866112e362b76$var$canUseDOM && "TextEvent" in window && !$407866112e362b76$var$documentMode, $407866112e362b76$var$useFallbackCompositionData = $407866112e362b76$var$canUseDOM && (!$407866112e362b76$var$canUseCompositionEvent || $407866112e362b76$var$documentMode && 8 < $407866112e362b76$var$documentMode && 11 >= $407866112e362b76$var$documentMode), $407866112e362b76$var$SPACEBAR_CHAR = String.fromCharCode(32), $407866112e362b76$var$hasSpaceKeypress = !1;
function $407866112e362b76$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $407866112e362b76$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $407866112e362b76$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $407866112e362b76$var$isComposing = !1;
function $407866112e362b76$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $407866112e362b76$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $407866112e362b76$var$hasSpaceKeypress = !0;
            return $407866112e362b76$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $407866112e362b76$var$SPACEBAR_CHAR && $407866112e362b76$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $407866112e362b76$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($407866112e362b76$var$isComposing) return "compositionend" === domEventName || !$407866112e362b76$var$canUseCompositionEvent && $407866112e362b76$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $407866112e362b76$var$getData(), $407866112e362b76$var$fallbackText = $407866112e362b76$var$startText = $407866112e362b76$var$root = null, $407866112e362b76$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $407866112e362b76$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $407866112e362b76$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $407866112e362b76$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$407866112e362b76$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $407866112e362b76$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $407866112e362b76$var$restoreTarget ? $407866112e362b76$var$restoreQueue ? $407866112e362b76$var$restoreQueue.push(target) : $407866112e362b76$var$restoreQueue = [
        target
    ] : $407866112e362b76$var$restoreTarget = target;
    inst = $407866112e362b76$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $407866112e362b76$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $407866112e362b76$var$activeElement$1 = null, $407866112e362b76$var$activeElementInst$1 = null;
function $407866112e362b76$var$runEventInBatch(dispatchQueue) {
    $407866112e362b76$var$processDispatchQueue(dispatchQueue, 0);
}
function $407866112e362b76$var$getInstIfValueChanged(targetInst) {
    var targetNode = $407866112e362b76$var$getNodeFromInstance(targetInst);
    if ($407866112e362b76$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $407866112e362b76$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $407866112e362b76$var$isInputEventSupported = !1;
if ($407866112e362b76$var$canUseDOM) {
    var $407866112e362b76$var$JSCompiler_inline_result$jscomp$282;
    if ($407866112e362b76$var$canUseDOM) {
        var $407866112e362b76$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$407866112e362b76$var$isSupported$jscomp$inline_417) {
            var $407866112e362b76$var$element$jscomp$inline_418 = document.createElement("div");
            $407866112e362b76$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $407866112e362b76$var$isSupported$jscomp$inline_417 = "function" === typeof $407866112e362b76$var$element$jscomp$inline_418.oninput;
        }
        $407866112e362b76$var$JSCompiler_inline_result$jscomp$282 = $407866112e362b76$var$isSupported$jscomp$inline_417;
    } else $407866112e362b76$var$JSCompiler_inline_result$jscomp$282 = !1;
    $407866112e362b76$var$isInputEventSupported = $407866112e362b76$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $407866112e362b76$var$stopWatchingForValueChange() {
    $407866112e362b76$var$activeElement$1 && ($407866112e362b76$var$activeElement$1.detachEvent("onpropertychange", $407866112e362b76$var$handlePropertyChange), $407866112e362b76$var$activeElementInst$1 = $407866112e362b76$var$activeElement$1 = null);
}
function $407866112e362b76$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $407866112e362b76$var$getInstIfValueChanged($407866112e362b76$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $407866112e362b76$var$createAndAccumulateChangeEvent(dispatchQueue, $407866112e362b76$var$activeElementInst$1, nativeEvent, $407866112e362b76$var$getEventTarget(nativeEvent));
        $407866112e362b76$var$batchedUpdates$1($407866112e362b76$var$runEventInBatch, dispatchQueue);
    }
}
function $407866112e362b76$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($407866112e362b76$var$stopWatchingForValueChange(), $407866112e362b76$var$activeElement$1 = target, $407866112e362b76$var$activeElementInst$1 = targetInst, $407866112e362b76$var$activeElement$1.attachEvent("onpropertychange", $407866112e362b76$var$handlePropertyChange)) : "focusout" === domEventName && $407866112e362b76$var$stopWatchingForValueChange();
}
function $407866112e362b76$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $407866112e362b76$var$getInstIfValueChanged($407866112e362b76$var$activeElementInst$1);
}
function $407866112e362b76$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $407866112e362b76$var$getInstIfValueChanged(targetInst);
}
function $407866112e362b76$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $407866112e362b76$var$getInstIfValueChanged(targetInst);
}
function $407866112e362b76$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $407866112e362b76$var$objectIs = "function" === typeof Object.is ? Object.is : $407866112e362b76$var$is;
function $407866112e362b76$var$shallowEqual(objA, objB) {
    if ($407866112e362b76$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$407866112e362b76$var$hasOwnProperty.call(objB, currentKey) || !$407866112e362b76$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $407866112e362b76$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $407866112e362b76$var$getNodeForCharacterOffset(root, offset) {
    var node = $407866112e362b76$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $407866112e362b76$var$getLeafNode(node);
    }
}
function $407866112e362b76$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $407866112e362b76$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $407866112e362b76$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $407866112e362b76$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $407866112e362b76$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $407866112e362b76$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $407866112e362b76$var$skipSelectionChangeEvent = $407866112e362b76$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $407866112e362b76$var$activeElement = null, $407866112e362b76$var$activeElementInst = null, $407866112e362b76$var$lastSelection = null, $407866112e362b76$var$mouseDown = !1;
function $407866112e362b76$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $407866112e362b76$var$mouseDown || null == $407866112e362b76$var$activeElement || $407866112e362b76$var$activeElement !== $407866112e362b76$var$getActiveElement(doc) || (doc = $407866112e362b76$var$activeElement, "selectionStart" in doc && $407866112e362b76$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $407866112e362b76$var$lastSelection && $407866112e362b76$var$shallowEqual($407866112e362b76$var$lastSelection, doc) || ($407866112e362b76$var$lastSelection = doc, doc = $407866112e362b76$var$accumulateTwoPhaseListeners($407866112e362b76$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $407866112e362b76$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $407866112e362b76$var$activeElement)));
}
function $407866112e362b76$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $407866112e362b76$var$vendorPrefixes = {
    animationend: $407866112e362b76$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $407866112e362b76$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $407866112e362b76$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $407866112e362b76$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $407866112e362b76$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $407866112e362b76$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $407866112e362b76$var$makePrefixMap("Transition", "TransitionEnd")
}, $407866112e362b76$var$prefixedEventNames = {}, $407866112e362b76$var$style = {};
$407866112e362b76$var$canUseDOM && ($407866112e362b76$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $407866112e362b76$var$vendorPrefixes.animationend.animation, delete $407866112e362b76$var$vendorPrefixes.animationiteration.animation, delete $407866112e362b76$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $407866112e362b76$var$vendorPrefixes.transitionend.transition);
function $407866112e362b76$var$getVendorPrefixedEventName(eventName) {
    if ($407866112e362b76$var$prefixedEventNames[eventName]) return $407866112e362b76$var$prefixedEventNames[eventName];
    if (!$407866112e362b76$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $407866112e362b76$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $407866112e362b76$var$style) return $407866112e362b76$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $407866112e362b76$var$ANIMATION_END = $407866112e362b76$var$getVendorPrefixedEventName("animationend"), $407866112e362b76$var$ANIMATION_ITERATION = $407866112e362b76$var$getVendorPrefixedEventName("animationiteration"), $407866112e362b76$var$ANIMATION_START = $407866112e362b76$var$getVendorPrefixedEventName("animationstart"), $407866112e362b76$var$TRANSITION_RUN = $407866112e362b76$var$getVendorPrefixedEventName("transitionrun"), $407866112e362b76$var$TRANSITION_START = $407866112e362b76$var$getVendorPrefixedEventName("transitionstart"), $407866112e362b76$var$TRANSITION_CANCEL = $407866112e362b76$var$getVendorPrefixedEventName("transitioncancel"), $407866112e362b76$var$TRANSITION_END = $407866112e362b76$var$getVendorPrefixedEventName("transitionend"), $407866112e362b76$var$topLevelEventsToReactNames = new Map(), $407866112e362b76$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$407866112e362b76$var$simpleEventPluginEvents.push("scrollEnd");
function $407866112e362b76$var$registerSimpleEvent(domEventName, reactName) {
    $407866112e362b76$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $407866112e362b76$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $407866112e362b76$var$CapturedStacks = new WeakMap();
function $407866112e362b76$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $407866112e362b76$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $407866112e362b76$var$getStackByFiberInDevAndProd(source)
        };
        $407866112e362b76$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $407866112e362b76$var$getStackByFiberInDevAndProd(source)
    };
}
var $407866112e362b76$var$concurrentQueues = [], $407866112e362b76$var$concurrentQueuesIndex = 0, $407866112e362b76$var$concurrentlyUpdatedLanes = 0;
function $407866112e362b76$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $407866112e362b76$var$concurrentQueuesIndex, i = $407866112e362b76$var$concurrentlyUpdatedLanes = $407866112e362b76$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $407866112e362b76$var$concurrentQueues[i];
        $407866112e362b76$var$concurrentQueues[i++] = null;
        var queue = $407866112e362b76$var$concurrentQueues[i];
        $407866112e362b76$var$concurrentQueues[i++] = null;
        var update = $407866112e362b76$var$concurrentQueues[i];
        $407866112e362b76$var$concurrentQueues[i++] = null;
        var lane = $407866112e362b76$var$concurrentQueues[i];
        $407866112e362b76$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $407866112e362b76$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $407866112e362b76$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $407866112e362b76$var$concurrentQueues[$407866112e362b76$var$concurrentQueuesIndex++] = fiber;
    $407866112e362b76$var$concurrentQueues[$407866112e362b76$var$concurrentQueuesIndex++] = queue;
    $407866112e362b76$var$concurrentQueues[$407866112e362b76$var$concurrentQueuesIndex++] = update;
    $407866112e362b76$var$concurrentQueues[$407866112e362b76$var$concurrentQueuesIndex++] = lane;
    $407866112e362b76$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $407866112e362b76$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $407866112e362b76$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $407866112e362b76$var$getRootForUpdatedFiber(fiber);
}
function $407866112e362b76$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $407866112e362b76$var$enqueueUpdate$1(fiber, null, null, lane);
    return $407866112e362b76$var$getRootForUpdatedFiber(fiber);
}
function $407866112e362b76$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $407866112e362b76$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $407866112e362b76$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $407866112e362b76$var$nestedUpdateCount) throw $407866112e362b76$var$nestedUpdateCount = 0, $407866112e362b76$var$rootWithNestedUpdates = null, Error($407866112e362b76$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $407866112e362b76$var$emptyContextObject = {};
function $407866112e362b76$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $407866112e362b76$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $407866112e362b76$var$FiberNode(tag, pendingProps, key, mode);
}
function $407866112e362b76$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $407866112e362b76$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $407866112e362b76$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $407866112e362b76$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $407866112e362b76$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $407866112e362b76$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $407866112e362b76$var$isHostHoistableType(type, pendingProps, $407866112e362b76$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $407866112e362b76$var$REACT_ACTIVITY_TYPE:
            return type = $407866112e362b76$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $407866112e362b76$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $407866112e362b76$var$REACT_FRAGMENT_TYPE:
            return $407866112e362b76$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $407866112e362b76$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $407866112e362b76$var$REACT_PROFILER_TYPE:
            return type = $407866112e362b76$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $407866112e362b76$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $407866112e362b76$var$REACT_SUSPENSE_TYPE:
            return type = $407866112e362b76$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $407866112e362b76$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $407866112e362b76$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $407866112e362b76$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $407866112e362b76$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $407866112e362b76$var$REACT_PROVIDER_TYPE:
                case $407866112e362b76$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $407866112e362b76$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $407866112e362b76$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $407866112e362b76$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $407866112e362b76$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($407866112e362b76$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $407866112e362b76$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $407866112e362b76$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $407866112e362b76$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $407866112e362b76$var$createFiberFromText(content, mode, lanes) {
    content = $407866112e362b76$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $407866112e362b76$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $407866112e362b76$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $407866112e362b76$var$forkStack = [], $407866112e362b76$var$forkStackIndex = 0, $407866112e362b76$var$treeForkProvider = null, $407866112e362b76$var$treeForkCount = 0, $407866112e362b76$var$idStack = [], $407866112e362b76$var$idStackIndex = 0, $407866112e362b76$var$treeContextProvider = null, $407866112e362b76$var$treeContextId = 1, $407866112e362b76$var$treeContextOverflow = "";
function $407866112e362b76$var$pushTreeFork(workInProgress, totalChildren) {
    $407866112e362b76$var$forkStack[$407866112e362b76$var$forkStackIndex++] = $407866112e362b76$var$treeForkCount;
    $407866112e362b76$var$forkStack[$407866112e362b76$var$forkStackIndex++] = $407866112e362b76$var$treeForkProvider;
    $407866112e362b76$var$treeForkProvider = workInProgress;
    $407866112e362b76$var$treeForkCount = totalChildren;
}
function $407866112e362b76$var$pushTreeId(workInProgress, totalChildren, index) {
    $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex++] = $407866112e362b76$var$treeContextId;
    $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex++] = $407866112e362b76$var$treeContextOverflow;
    $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex++] = $407866112e362b76$var$treeContextProvider;
    $407866112e362b76$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $407866112e362b76$var$treeContextId;
    workInProgress = $407866112e362b76$var$treeContextOverflow;
    var baseLength = 32 - $407866112e362b76$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $407866112e362b76$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $407866112e362b76$var$treeContextId = 1 << 32 - $407866112e362b76$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $407866112e362b76$var$treeContextOverflow = length + workInProgress;
    } else $407866112e362b76$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $407866112e362b76$var$treeContextOverflow = workInProgress;
}
function $407866112e362b76$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($407866112e362b76$var$pushTreeFork(workInProgress, 1), $407866112e362b76$var$pushTreeId(workInProgress, 1, 0));
}
function $407866112e362b76$var$popTreeContext(workInProgress) {
    for(; workInProgress === $407866112e362b76$var$treeForkProvider;)$407866112e362b76$var$treeForkProvider = $407866112e362b76$var$forkStack[--$407866112e362b76$var$forkStackIndex], $407866112e362b76$var$forkStack[$407866112e362b76$var$forkStackIndex] = null, $407866112e362b76$var$treeForkCount = $407866112e362b76$var$forkStack[--$407866112e362b76$var$forkStackIndex], $407866112e362b76$var$forkStack[$407866112e362b76$var$forkStackIndex] = null;
    for(; workInProgress === $407866112e362b76$var$treeContextProvider;)$407866112e362b76$var$treeContextProvider = $407866112e362b76$var$idStack[--$407866112e362b76$var$idStackIndex], $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex] = null, $407866112e362b76$var$treeContextOverflow = $407866112e362b76$var$idStack[--$407866112e362b76$var$idStackIndex], $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex] = null, $407866112e362b76$var$treeContextId = $407866112e362b76$var$idStack[--$407866112e362b76$var$idStackIndex], $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex] = null;
}
var $407866112e362b76$var$hydrationParentFiber = null, $407866112e362b76$var$nextHydratableInstance = null, $407866112e362b76$var$isHydrating = !1, $407866112e362b76$var$hydrationErrors = null, $407866112e362b76$var$rootOrSingletonContext = !1, $407866112e362b76$var$HydrationMismatchException = Error($407866112e362b76$var$formatProdErrorMessage(519));
function $407866112e362b76$var$throwOnHydrationMismatch(fiber) {
    var error = Error($407866112e362b76$var$formatProdErrorMessage(418, ""));
    $407866112e362b76$var$queueHydrationError($407866112e362b76$var$createCapturedValueAtFiber(error, fiber));
    throw $407866112e362b76$var$HydrationMismatchException;
}
function $407866112e362b76$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$407866112e362b76$var$internalInstanceKey] = fiber;
    instance[$407866112e362b76$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $407866112e362b76$var$listenToNonDelegatedEvent("cancel", instance);
            $407866112e362b76$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $407866112e362b76$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $407866112e362b76$var$mediaEventTypes.length; type++)$407866112e362b76$var$listenToNonDelegatedEvent($407866112e362b76$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $407866112e362b76$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $407866112e362b76$var$listenToNonDelegatedEvent("error", instance);
            $407866112e362b76$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $407866112e362b76$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $407866112e362b76$var$listenToNonDelegatedEvent("invalid", instance);
            $407866112e362b76$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $407866112e362b76$var$track(instance);
            break;
        case "select":
            $407866112e362b76$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $407866112e362b76$var$listenToNonDelegatedEvent("invalid", instance), $407866112e362b76$var$initTextarea(instance, props.value, props.defaultValue, props.children), $407866112e362b76$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $407866112e362b76$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($407866112e362b76$var$listenToNonDelegatedEvent("beforetoggle", instance), $407866112e362b76$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $407866112e362b76$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $407866112e362b76$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $407866112e362b76$var$noop$1), instance = !0) : instance = !1;
    instance || $407866112e362b76$var$throwOnHydrationMismatch(fiber);
}
function $407866112e362b76$var$popToNextHostParent(fiber) {
    for($407866112e362b76$var$hydrationParentFiber = fiber.return; $407866112e362b76$var$hydrationParentFiber;)switch($407866112e362b76$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $407866112e362b76$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $407866112e362b76$var$rootOrSingletonContext = !0;
            return;
        default:
            $407866112e362b76$var$hydrationParentFiber = $407866112e362b76$var$hydrationParentFiber.return;
    }
}
function $407866112e362b76$var$popHydrationState(fiber) {
    if (fiber !== $407866112e362b76$var$hydrationParentFiber) return !1;
    if (!$407866112e362b76$var$isHydrating) return $407866112e362b76$var$popToNextHostParent(fiber), $407866112e362b76$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $407866112e362b76$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $407866112e362b76$var$nextHydratableInstance && $407866112e362b76$var$throwOnHydrationMismatch(fiber);
    $407866112e362b76$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($407866112e362b76$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $407866112e362b76$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $407866112e362b76$var$nextHydratableInstance, $407866112e362b76$var$isSingletonScope(fiber.type) ? (fiber = $407866112e362b76$var$previousHydratableOnEnteringScopedSingleton, $407866112e362b76$var$previousHydratableOnEnteringScopedSingleton = null, $407866112e362b76$var$nextHydratableInstance = fiber) : $407866112e362b76$var$nextHydratableInstance = tag) : $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$hydrationParentFiber ? $407866112e362b76$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $407866112e362b76$var$resetHydrationState() {
    $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$hydrationParentFiber = null;
    $407866112e362b76$var$isHydrating = !1;
}
function $407866112e362b76$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $407866112e362b76$var$hydrationErrors;
    null !== queuedErrors && (null === $407866112e362b76$var$workInProgressRootRecoverableErrors ? $407866112e362b76$var$workInProgressRootRecoverableErrors = queuedErrors : $407866112e362b76$var$workInProgressRootRecoverableErrors.push.apply($407866112e362b76$var$workInProgressRootRecoverableErrors, queuedErrors), $407866112e362b76$var$hydrationErrors = null);
    return queuedErrors;
}
function $407866112e362b76$var$queueHydrationError(error) {
    null === $407866112e362b76$var$hydrationErrors ? $407866112e362b76$var$hydrationErrors = [
        error
    ] : $407866112e362b76$var$hydrationErrors.push(error);
}
var $407866112e362b76$var$valueCursor = $407866112e362b76$var$createCursor(null), $407866112e362b76$var$currentlyRenderingFiber$1 = null, $407866112e362b76$var$lastContextDependency = null;
function $407866112e362b76$var$pushProvider(providerFiber, context, nextValue) {
    $407866112e362b76$var$push($407866112e362b76$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $407866112e362b76$var$popProvider(context) {
    context._currentValue = $407866112e362b76$var$valueCursor.current;
    $407866112e362b76$var$pop($407866112e362b76$var$valueCursor);
}
function $407866112e362b76$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $407866112e362b76$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $407866112e362b76$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($407866112e362b76$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $407866112e362b76$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $407866112e362b76$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($407866112e362b76$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $407866112e362b76$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $407866112e362b76$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($407866112e362b76$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($407866112e362b76$var$HostTransitionContext) : current = [
                $407866112e362b76$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $407866112e362b76$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $407866112e362b76$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$407866112e362b76$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $407866112e362b76$var$prepareToReadContext(workInProgress) {
    $407866112e362b76$var$currentlyRenderingFiber$1 = workInProgress;
    $407866112e362b76$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $407866112e362b76$var$readContext(context) {
    return $407866112e362b76$var$readContextForConsumer($407866112e362b76$var$currentlyRenderingFiber$1, context);
}
function $407866112e362b76$var$readContextDuringReconciliation(consumer, context) {
    null === $407866112e362b76$var$currentlyRenderingFiber$1 && $407866112e362b76$var$prepareToReadContext(consumer);
    return $407866112e362b76$var$readContextForConsumer(consumer, context);
}
function $407866112e362b76$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $407866112e362b76$var$lastContextDependency) {
        if (null === consumer) throw Error($407866112e362b76$var$formatProdErrorMessage(308));
        $407866112e362b76$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $407866112e362b76$var$lastContextDependency = $407866112e362b76$var$lastContextDependency.next = context;
    return value;
}
var $407866112e362b76$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $407866112e362b76$var$scheduleCallback$2 = $hNfVH.unstable_scheduleCallback, $407866112e362b76$var$NormalPriority = $hNfVH.unstable_NormalPriority, $407866112e362b76$var$CacheContext = {
    $$typeof: $407866112e362b76$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $407866112e362b76$var$createCache() {
    return {
        controller: new $407866112e362b76$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $407866112e362b76$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $407866112e362b76$var$scheduleCallback$2($407866112e362b76$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $407866112e362b76$var$currentEntangledListeners = null, $407866112e362b76$var$currentEntangledPendingCount = 0, $407866112e362b76$var$currentEntangledLane = 0, $407866112e362b76$var$currentEntangledActionThenable = null;
function $407866112e362b76$var$entangleAsyncAction(transition, thenable) {
    if (null === $407866112e362b76$var$currentEntangledListeners) {
        var entangledListeners = $407866112e362b76$var$currentEntangledListeners = [];
        $407866112e362b76$var$currentEntangledPendingCount = 0;
        $407866112e362b76$var$currentEntangledLane = $407866112e362b76$var$requestTransitionLane();
        $407866112e362b76$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $407866112e362b76$var$currentEntangledPendingCount++;
    thenable.then($407866112e362b76$var$pingEngtangledActionScope, $407866112e362b76$var$pingEngtangledActionScope);
    return thenable;
}
function $407866112e362b76$var$pingEngtangledActionScope() {
    if (0 === --$407866112e362b76$var$currentEntangledPendingCount && null !== $407866112e362b76$var$currentEntangledListeners) {
        null !== $407866112e362b76$var$currentEntangledActionThenable && ($407866112e362b76$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $407866112e362b76$var$currentEntangledListeners;
        $407866112e362b76$var$currentEntangledListeners = null;
        $407866112e362b76$var$currentEntangledLane = 0;
        $407866112e362b76$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $407866112e362b76$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $407866112e362b76$var$prevOnStartTransitionFinish = $407866112e362b76$var$ReactSharedInternals.S;
$407866112e362b76$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $407866112e362b76$var$entangleAsyncAction(transition, returnValue);
    null !== $407866112e362b76$var$prevOnStartTransitionFinish && $407866112e362b76$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $407866112e362b76$var$resumedCache = $407866112e362b76$var$createCursor(null);
function $407866112e362b76$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $407866112e362b76$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $407866112e362b76$var$workInProgressRoot.pooledCache;
}
function $407866112e362b76$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $407866112e362b76$var$push($407866112e362b76$var$resumedCache, $407866112e362b76$var$resumedCache.current) : $407866112e362b76$var$push($407866112e362b76$var$resumedCache, prevCachePool.pool);
}
function $407866112e362b76$var$getSuspendedCache() {
    var cacheFromPool = $407866112e362b76$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $407866112e362b76$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $407866112e362b76$var$SuspenseException = Error($407866112e362b76$var$formatProdErrorMessage(460)), $407866112e362b76$var$SuspenseyCommitException = Error($407866112e362b76$var$formatProdErrorMessage(474)), $407866112e362b76$var$SuspenseActionException = Error($407866112e362b76$var$formatProdErrorMessage(542)), $407866112e362b76$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $407866112e362b76$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $407866112e362b76$var$noop$3() {}
function $407866112e362b76$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($407866112e362b76$var$noop$3, $407866112e362b76$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $407866112e362b76$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($407866112e362b76$var$noop$3, $407866112e362b76$var$noop$3);
            else {
                thenableState = $407866112e362b76$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($407866112e362b76$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $407866112e362b76$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $407866112e362b76$var$suspendedThenable = thenable;
            throw $407866112e362b76$var$SuspenseException;
    }
}
var $407866112e362b76$var$suspendedThenable = null;
function $407866112e362b76$var$getSuspendedThenable() {
    if (null === $407866112e362b76$var$suspendedThenable) throw Error($407866112e362b76$var$formatProdErrorMessage(459));
    var thenable = $407866112e362b76$var$suspendedThenable;
    $407866112e362b76$var$suspendedThenable = null;
    return thenable;
}
function $407866112e362b76$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $407866112e362b76$var$SuspenseException || rejectedReason === $407866112e362b76$var$SuspenseActionException) throw Error($407866112e362b76$var$formatProdErrorMessage(483));
}
var $407866112e362b76$var$hasForceUpdate = !1;
function $407866112e362b76$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $407866112e362b76$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $407866112e362b76$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $407866112e362b76$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($407866112e362b76$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $407866112e362b76$var$getRootForUpdatedFiber(fiber);
        $407866112e362b76$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $407866112e362b76$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $407866112e362b76$var$getRootForUpdatedFiber(fiber);
}
function $407866112e362b76$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $407866112e362b76$var$markRootEntangled(root, lane);
    }
}
function $407866112e362b76$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $407866112e362b76$var$didReadFromEntangledAsyncAction = !1;
function $407866112e362b76$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($407866112e362b76$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $407866112e362b76$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $407866112e362b76$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $407866112e362b76$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $407866112e362b76$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($407866112e362b76$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $407866112e362b76$var$currentEntangledLane && ($407866112e362b76$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $407866112e362b76$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $407866112e362b76$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $407866112e362b76$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $407866112e362b76$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($407866112e362b76$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $407866112e362b76$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$407866112e362b76$var$callCallback(callbacks[updateQueue], context);
}
var $407866112e362b76$var$currentTreeHiddenStackCursor = $407866112e362b76$var$createCursor(null), $407866112e362b76$var$prevEntangledRenderLanesCursor = $407866112e362b76$var$createCursor(0);
function $407866112e362b76$var$pushHiddenContext(fiber, context) {
    fiber = $407866112e362b76$var$entangledRenderLanes;
    $407866112e362b76$var$push($407866112e362b76$var$prevEntangledRenderLanesCursor, fiber);
    $407866112e362b76$var$push($407866112e362b76$var$currentTreeHiddenStackCursor, context);
    $407866112e362b76$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $407866112e362b76$var$reuseHiddenContextOnStack() {
    $407866112e362b76$var$push($407866112e362b76$var$prevEntangledRenderLanesCursor, $407866112e362b76$var$entangledRenderLanes);
    $407866112e362b76$var$push($407866112e362b76$var$currentTreeHiddenStackCursor, $407866112e362b76$var$currentTreeHiddenStackCursor.current);
}
function $407866112e362b76$var$popHiddenContext() {
    $407866112e362b76$var$entangledRenderLanes = $407866112e362b76$var$prevEntangledRenderLanesCursor.current;
    $407866112e362b76$var$pop($407866112e362b76$var$currentTreeHiddenStackCursor);
    $407866112e362b76$var$pop($407866112e362b76$var$prevEntangledRenderLanesCursor);
}
var $407866112e362b76$var$renderLanes = 0, $407866112e362b76$var$currentlyRenderingFiber = null, $407866112e362b76$var$currentHook = null, $407866112e362b76$var$workInProgressHook = null, $407866112e362b76$var$didScheduleRenderPhaseUpdate = !1, $407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $407866112e362b76$var$localIdCounter = 0, $407866112e362b76$var$thenableIndexCounter$1 = 0, $407866112e362b76$var$thenableState$1 = null, $407866112e362b76$var$globalClientIdCounter = 0;
function $407866112e362b76$var$throwInvalidHookError() {
    throw Error($407866112e362b76$var$formatProdErrorMessage(321));
}
function $407866112e362b76$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$407866112e362b76$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $407866112e362b76$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $407866112e362b76$var$renderLanes = nextRenderLanes;
    $407866112e362b76$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $407866112e362b76$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $407866112e362b76$var$HooksDispatcherOnMount : $407866112e362b76$var$HooksDispatcherOnUpdate;
    $407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $407866112e362b76$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $407866112e362b76$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $407866112e362b76$var$finishRenderingHooks(current) {
    $407866112e362b76$var$ReactSharedInternals.H = $407866112e362b76$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $407866112e362b76$var$currentHook && null !== $407866112e362b76$var$currentHook.next;
    $407866112e362b76$var$renderLanes = 0;
    $407866112e362b76$var$workInProgressHook = $407866112e362b76$var$currentHook = $407866112e362b76$var$currentlyRenderingFiber = null;
    $407866112e362b76$var$didScheduleRenderPhaseUpdate = !1;
    $407866112e362b76$var$thenableIndexCounter$1 = 0;
    $407866112e362b76$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($407866112e362b76$var$formatProdErrorMessage(300));
    null === current || $407866112e362b76$var$didReceiveUpdate || (current = current.dependencies, null !== current && $407866112e362b76$var$checkIfContextChanged(current) && ($407866112e362b76$var$didReceiveUpdate = !0));
}
function $407866112e362b76$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $407866112e362b76$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass && ($407866112e362b76$var$thenableState$1 = null);
        $407866112e362b76$var$thenableIndexCounter$1 = 0;
        $407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($407866112e362b76$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $407866112e362b76$var$workInProgressHook = $407866112e362b76$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $407866112e362b76$var$ReactSharedInternals.H = $407866112e362b76$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $407866112e362b76$var$TransitionAwareHostComponent() {
    var dispatcher = $407866112e362b76$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $407866112e362b76$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $407866112e362b76$var$currentHook ? $407866112e362b76$var$currentHook.memoizedState : null) !== dispatcher && ($407866112e362b76$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $407866112e362b76$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $407866112e362b76$var$localIdCounter;
    $407866112e362b76$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $407866112e362b76$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $407866112e362b76$var$resetHooksOnUnwind(workInProgress) {
    if ($407866112e362b76$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $407866112e362b76$var$didScheduleRenderPhaseUpdate = !1;
    }
    $407866112e362b76$var$renderLanes = 0;
    $407866112e362b76$var$workInProgressHook = $407866112e362b76$var$currentHook = $407866112e362b76$var$currentlyRenderingFiber = null;
    $407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $407866112e362b76$var$thenableIndexCounter$1 = $407866112e362b76$var$localIdCounter = 0;
    $407866112e362b76$var$thenableState$1 = null;
}
function $407866112e362b76$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $407866112e362b76$var$workInProgressHook ? $407866112e362b76$var$currentlyRenderingFiber.memoizedState = $407866112e362b76$var$workInProgressHook = hook : $407866112e362b76$var$workInProgressHook = $407866112e362b76$var$workInProgressHook.next = hook;
    return $407866112e362b76$var$workInProgressHook;
}
function $407866112e362b76$var$updateWorkInProgressHook() {
    if (null === $407866112e362b76$var$currentHook) {
        var nextCurrentHook = $407866112e362b76$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $407866112e362b76$var$currentHook.next;
    var nextWorkInProgressHook = null === $407866112e362b76$var$workInProgressHook ? $407866112e362b76$var$currentlyRenderingFiber.memoizedState : $407866112e362b76$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $407866112e362b76$var$workInProgressHook = nextWorkInProgressHook, $407866112e362b76$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $407866112e362b76$var$currentlyRenderingFiber.alternate) throw Error($407866112e362b76$var$formatProdErrorMessage(467));
            throw Error($407866112e362b76$var$formatProdErrorMessage(310));
        }
        $407866112e362b76$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $407866112e362b76$var$currentHook.memoizedState,
            baseState: $407866112e362b76$var$currentHook.baseState,
            baseQueue: $407866112e362b76$var$currentHook.baseQueue,
            queue: $407866112e362b76$var$currentHook.queue,
            next: null
        };
        null === $407866112e362b76$var$workInProgressHook ? $407866112e362b76$var$currentlyRenderingFiber.memoizedState = $407866112e362b76$var$workInProgressHook = nextCurrentHook : $407866112e362b76$var$workInProgressHook = $407866112e362b76$var$workInProgressHook.next = nextCurrentHook;
    }
    return $407866112e362b76$var$workInProgressHook;
}
function $407866112e362b76$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $407866112e362b76$var$useThenable(thenable) {
    var index = $407866112e362b76$var$thenableIndexCounter$1;
    $407866112e362b76$var$thenableIndexCounter$1 += 1;
    null === $407866112e362b76$var$thenableState$1 && ($407866112e362b76$var$thenableState$1 = []);
    thenable = $407866112e362b76$var$trackUsedThenable($407866112e362b76$var$thenableState$1, thenable, index);
    index = $407866112e362b76$var$currentlyRenderingFiber;
    null === (null === $407866112e362b76$var$workInProgressHook ? index.memoizedState : $407866112e362b76$var$workInProgressHook.next) && (index = index.alternate, $407866112e362b76$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $407866112e362b76$var$HooksDispatcherOnMount : $407866112e362b76$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $407866112e362b76$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $407866112e362b76$var$useThenable(usable);
        if (usable.$$typeof === $407866112e362b76$var$REACT_CONTEXT_TYPE) return $407866112e362b76$var$readContext(usable);
    }
    throw Error($407866112e362b76$var$formatProdErrorMessage(438, String(usable)));
}
function $407866112e362b76$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $407866112e362b76$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $407866112e362b76$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $407866112e362b76$var$createFunctionComponentUpdateQueue(), $407866112e362b76$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $407866112e362b76$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $407866112e362b76$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $407866112e362b76$var$updateReducer(reducer) {
    var hook = $407866112e362b76$var$updateWorkInProgressHook();
    return $407866112e362b76$var$updateReducerImpl(hook, $407866112e362b76$var$currentHook, reducer);
}
function $407866112e362b76$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($407866112e362b76$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($407866112e362b76$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($407866112e362b76$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $407866112e362b76$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($407866112e362b76$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $407866112e362b76$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $407866112e362b76$var$currentlyRenderingFiber.lanes |= revertLane, $407866112e362b76$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $407866112e362b76$var$currentlyRenderingFiber.lanes |= updateLane, $407866112e362b76$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$407866112e362b76$var$objectIs(pendingQueue, hook.memoizedState) && ($407866112e362b76$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $407866112e362b76$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $407866112e362b76$var$rerenderReducer(reducer) {
    var hook = $407866112e362b76$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($407866112e362b76$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $407866112e362b76$var$objectIs(newState, hook.memoizedState) || ($407866112e362b76$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $407866112e362b76$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $407866112e362b76$var$currentlyRenderingFiber, hook = $407866112e362b76$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $407866112e362b76$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($407866112e362b76$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$407866112e362b76$var$objectIs(($407866112e362b76$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $407866112e362b76$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $407866112e362b76$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $407866112e362b76$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $407866112e362b76$var$workInProgressHook && $407866112e362b76$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $407866112e362b76$var$pushSimpleEffect(9, $407866112e362b76$var$createEffectInstance(), $407866112e362b76$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $407866112e362b76$var$workInProgressRoot) throw Error($407866112e362b76$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($407866112e362b76$var$renderLanes & 124) || $407866112e362b76$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $407866112e362b76$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $407866112e362b76$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $407866112e362b76$var$createFunctionComponentUpdateQueue(), $407866112e362b76$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $407866112e362b76$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $407866112e362b76$var$checkIfSnapshotChanged(inst) && $407866112e362b76$var$forceStoreRerender(fiber);
}
function $407866112e362b76$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $407866112e362b76$var$checkIfSnapshotChanged(inst) && $407866112e362b76$var$forceStoreRerender(fiber);
    });
}
function $407866112e362b76$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$407866112e362b76$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $407866112e362b76$var$forceStoreRerender(fiber) {
    var root = $407866112e362b76$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $407866112e362b76$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $407866112e362b76$var$mountStateImpl(initialState) {
    var hook = $407866112e362b76$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $407866112e362b76$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $407866112e362b76$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $407866112e362b76$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $407866112e362b76$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $407866112e362b76$var$updateReducerImpl(hook, $407866112e362b76$var$currentHook, "function" === typeof reducer ? reducer : $407866112e362b76$var$basicStateReducer);
}
function $407866112e362b76$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($407866112e362b76$var$isRenderPhaseUpdate(fiber)) throw Error($407866112e362b76$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $407866112e362b76$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $407866112e362b76$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $407866112e362b76$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $407866112e362b76$var$ReactSharedInternals.T, currentTransition = {};
        $407866112e362b76$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $407866112e362b76$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $407866112e362b76$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $407866112e362b76$var$onActionError(actionQueue, node, error);
        } finally{
            $407866112e362b76$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $407866112e362b76$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $407866112e362b76$var$onActionError(actionQueue, node, error$38);
    }
}
function $407866112e362b76$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $407866112e362b76$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $407866112e362b76$var$onActionError(actionQueue, node, error);
    }) : $407866112e362b76$var$onActionSuccess(actionQueue, node, returnValue);
}
function $407866112e362b76$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $407866112e362b76$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $407866112e362b76$var$runActionStateAction(actionQueue, nextState)));
}
function $407866112e362b76$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $407866112e362b76$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $407866112e362b76$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $407866112e362b76$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $407866112e362b76$var$mountActionState(action, initialStateProp) {
    if ($407866112e362b76$var$isHydrating) {
        var ssrFormState = $407866112e362b76$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $407866112e362b76$var$currentlyRenderingFiber;
                if ($407866112e362b76$var$isHydrating) {
                    if ($407866112e362b76$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $407866112e362b76$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $407866112e362b76$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $407866112e362b76$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $407866112e362b76$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $407866112e362b76$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $407866112e362b76$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $407866112e362b76$var$dispatchSetState.bind(null, $407866112e362b76$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $407866112e362b76$var$mountStateImpl(!1);
    inRootOrSingleton = $407866112e362b76$var$dispatchOptimisticSetState.bind(null, $407866112e362b76$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $407866112e362b76$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $407866112e362b76$var$dispatchActionState.bind(null, $407866112e362b76$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $407866112e362b76$var$updateActionState(action) {
    var stateHook = $407866112e362b76$var$updateWorkInProgressHook();
    return $407866112e362b76$var$updateActionStateImpl(stateHook, $407866112e362b76$var$currentHook, action);
}
function $407866112e362b76$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $407866112e362b76$var$updateReducerImpl(stateHook, currentStateHook, $407866112e362b76$var$actionStateReducer)[0];
    stateHook = $407866112e362b76$var$updateReducer($407866112e362b76$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $407866112e362b76$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $407866112e362b76$var$SuspenseException) throw $407866112e362b76$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $407866112e362b76$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($407866112e362b76$var$currentlyRenderingFiber.flags |= 2048, $407866112e362b76$var$pushSimpleEffect(9, $407866112e362b76$var$createEffectInstance(), $407866112e362b76$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $407866112e362b76$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $407866112e362b76$var$rerenderActionState(action) {
    var stateHook = $407866112e362b76$var$updateWorkInProgressHook(), currentStateHook = $407866112e362b76$var$currentHook;
    if (null !== currentStateHook) return $407866112e362b76$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $407866112e362b76$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $407866112e362b76$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $407866112e362b76$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $407866112e362b76$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $407866112e362b76$var$createFunctionComponentUpdateQueue(), $407866112e362b76$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $407866112e362b76$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $407866112e362b76$var$updateRef() {
    return $407866112e362b76$var$updateWorkInProgressHook().memoizedState;
}
function $407866112e362b76$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $407866112e362b76$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $407866112e362b76$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $407866112e362b76$var$pushSimpleEffect(1 | hookFlags, $407866112e362b76$var$createEffectInstance(), create, createDeps);
}
function $407866112e362b76$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $407866112e362b76$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $407866112e362b76$var$currentHook && null !== deps && $407866112e362b76$var$areHookInputsEqual(deps, $407866112e362b76$var$currentHook.memoizedState.deps) ? hook.memoizedState = $407866112e362b76$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($407866112e362b76$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $407866112e362b76$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $407866112e362b76$var$mountEffect(create, createDeps) {
    $407866112e362b76$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $407866112e362b76$var$updateEffect(create, createDeps) {
    $407866112e362b76$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $407866112e362b76$var$updateInsertionEffect(create, deps) {
    return $407866112e362b76$var$updateEffectImpl(4, 2, create, deps);
}
function $407866112e362b76$var$updateLayoutEffect(create, deps) {
    return $407866112e362b76$var$updateEffectImpl(4, 4, create, deps);
}
function $407866112e362b76$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $407866112e362b76$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $407866112e362b76$var$updateEffectImpl(4, 4, $407866112e362b76$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $407866112e362b76$var$mountDebugValue() {}
function $407866112e362b76$var$updateCallback(callback, deps) {
    var hook = $407866112e362b76$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $407866112e362b76$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $407866112e362b76$var$updateMemo(nextCreate, deps) {
    var hook = $407866112e362b76$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $407866112e362b76$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $407866112e362b76$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $407866112e362b76$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $407866112e362b76$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($407866112e362b76$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $407866112e362b76$var$requestDeferredLane();
    $407866112e362b76$var$currentlyRenderingFiber.lanes |= hook;
    $407866112e362b76$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $407866112e362b76$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($407866112e362b76$var$objectIs(value, prevValue)) return value;
    if (null !== $407866112e362b76$var$currentTreeHiddenStackCursor.current) return hook = $407866112e362b76$var$mountDeferredValueImpl(hook, value, initialValue), $407866112e362b76$var$objectIs(hook, prevValue) || ($407866112e362b76$var$didReceiveUpdate = !0), hook;
    if (0 === ($407866112e362b76$var$renderLanes & 42)) return $407866112e362b76$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $407866112e362b76$var$requestDeferredLane();
    $407866112e362b76$var$currentlyRenderingFiber.lanes |= hook;
    $407866112e362b76$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $407866112e362b76$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
    $407866112e362b76$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $407866112e362b76$var$ReactSharedInternals.T, currentTransition = {};
    $407866112e362b76$var$ReactSharedInternals.T = currentTransition;
    $407866112e362b76$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $407866112e362b76$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $407866112e362b76$var$chainThenableValue(returnValue, finishedState);
            $407866112e362b76$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $407866112e362b76$var$requestUpdateLane(fiber));
        } else $407866112e362b76$var$dispatchSetStateInternal(fiber, queue, finishedState, $407866112e362b76$var$requestUpdateLane(fiber));
    } catch (error) {
        $407866112e362b76$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $407866112e362b76$var$requestUpdateLane());
    } finally{
        $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority, $407866112e362b76$var$ReactSharedInternals.T = prevTransition;
    }
}
function $407866112e362b76$var$noop$2() {}
function $407866112e362b76$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($407866112e362b76$var$formatProdErrorMessage(476));
    var queue = $407866112e362b76$var$ensureFormComponentIsStateful(formFiber).queue;
    $407866112e362b76$var$startTransition(formFiber, queue, pendingState, $407866112e362b76$var$sharedNotPendingObject, null === action ? $407866112e362b76$var$noop$2 : function() {
        $407866112e362b76$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $407866112e362b76$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $407866112e362b76$var$sharedNotPendingObject,
        baseState: $407866112e362b76$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $407866112e362b76$var$basicStateReducer,
            lastRenderedState: $407866112e362b76$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $407866112e362b76$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $407866112e362b76$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $407866112e362b76$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $407866112e362b76$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $407866112e362b76$var$requestUpdateLane());
}
function $407866112e362b76$var$useHostTransitionStatus() {
    return $407866112e362b76$var$readContext($407866112e362b76$var$HostTransitionContext);
}
function $407866112e362b76$var$updateId() {
    return $407866112e362b76$var$updateWorkInProgressHook().memoizedState;
}
function $407866112e362b76$var$updateRefresh() {
    return $407866112e362b76$var$updateWorkInProgressHook().memoizedState;
}
function $407866112e362b76$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $407866112e362b76$var$requestUpdateLane();
                fiber = $407866112e362b76$var$createUpdate(lane);
                var root$41 = $407866112e362b76$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($407866112e362b76$var$scheduleUpdateOnFiber(root$41, provider, lane), $407866112e362b76$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $407866112e362b76$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $407866112e362b76$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $407866112e362b76$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $407866112e362b76$var$isRenderPhaseUpdate(fiber) ? $407866112e362b76$var$enqueueRenderPhaseUpdate(queue, action) : (action = $407866112e362b76$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($407866112e362b76$var$scheduleUpdateOnFiber(action, fiber, lane), $407866112e362b76$var$entangleTransitionUpdate(action, queue, lane)));
}
function $407866112e362b76$var$dispatchSetState(fiber, queue, action) {
    var lane = $407866112e362b76$var$requestUpdateLane();
    $407866112e362b76$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $407866112e362b76$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($407866112e362b76$var$isRenderPhaseUpdate(fiber)) $407866112e362b76$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($407866112e362b76$var$objectIs(eagerState, currentState)) return $407866112e362b76$var$enqueueUpdate$1(fiber, queue, update, 0), null === $407866112e362b76$var$workInProgressRoot && $407866112e362b76$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $407866112e362b76$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $407866112e362b76$var$scheduleUpdateOnFiber(action, fiber, lane), $407866112e362b76$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $407866112e362b76$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $407866112e362b76$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($407866112e362b76$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($407866112e362b76$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $407866112e362b76$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $407866112e362b76$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $407866112e362b76$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $407866112e362b76$var$currentlyRenderingFiber || null !== alternate && alternate === $407866112e362b76$var$currentlyRenderingFiber;
}
function $407866112e362b76$var$enqueueRenderPhaseUpdate(queue, update) {
    $407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass = $407866112e362b76$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $407866112e362b76$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $407866112e362b76$var$markRootEntangled(root, lane);
    }
}
var $407866112e362b76$var$ContextOnlyDispatcher = {
    readContext: $407866112e362b76$var$readContext,
    use: $407866112e362b76$var$use,
    useCallback: $407866112e362b76$var$throwInvalidHookError,
    useContext: $407866112e362b76$var$throwInvalidHookError,
    useEffect: $407866112e362b76$var$throwInvalidHookError,
    useImperativeHandle: $407866112e362b76$var$throwInvalidHookError,
    useLayoutEffect: $407866112e362b76$var$throwInvalidHookError,
    useInsertionEffect: $407866112e362b76$var$throwInvalidHookError,
    useMemo: $407866112e362b76$var$throwInvalidHookError,
    useReducer: $407866112e362b76$var$throwInvalidHookError,
    useRef: $407866112e362b76$var$throwInvalidHookError,
    useState: $407866112e362b76$var$throwInvalidHookError,
    useDebugValue: $407866112e362b76$var$throwInvalidHookError,
    useDeferredValue: $407866112e362b76$var$throwInvalidHookError,
    useTransition: $407866112e362b76$var$throwInvalidHookError,
    useSyncExternalStore: $407866112e362b76$var$throwInvalidHookError,
    useId: $407866112e362b76$var$throwInvalidHookError,
    useHostTransitionStatus: $407866112e362b76$var$throwInvalidHookError,
    useFormState: $407866112e362b76$var$throwInvalidHookError,
    useActionState: $407866112e362b76$var$throwInvalidHookError,
    useOptimistic: $407866112e362b76$var$throwInvalidHookError,
    useMemoCache: $407866112e362b76$var$throwInvalidHookError,
    useCacheRefresh: $407866112e362b76$var$throwInvalidHookError
}, $407866112e362b76$var$HooksDispatcherOnMount = {
    readContext: $407866112e362b76$var$readContext,
    use: $407866112e362b76$var$use,
    useCallback: function(callback, deps) {
        $407866112e362b76$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $407866112e362b76$var$readContext,
    useEffect: $407866112e362b76$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $407866112e362b76$var$mountEffectImpl(4194308, 4, $407866112e362b76$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $407866112e362b76$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $407866112e362b76$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $407866112e362b76$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $407866112e362b76$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $407866112e362b76$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $407866112e362b76$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $407866112e362b76$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $407866112e362b76$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $407866112e362b76$var$dispatchReducerAction.bind(null, $407866112e362b76$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $407866112e362b76$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $407866112e362b76$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $407866112e362b76$var$dispatchSetState.bind(null, $407866112e362b76$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $407866112e362b76$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $407866112e362b76$var$mountWorkInProgressHook();
        return $407866112e362b76$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $407866112e362b76$var$mountStateImpl(!1);
        stateHook = $407866112e362b76$var$startTransition.bind(null, $407866112e362b76$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $407866112e362b76$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $407866112e362b76$var$currentlyRenderingFiber, hook = $407866112e362b76$var$mountWorkInProgressHook();
        if ($407866112e362b76$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($407866112e362b76$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $407866112e362b76$var$workInProgressRoot) throw Error($407866112e362b76$var$formatProdErrorMessage(349));
            0 !== ($407866112e362b76$var$workInProgressRootRenderLanes & 124) || $407866112e362b76$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $407866112e362b76$var$mountEffect($407866112e362b76$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $407866112e362b76$var$pushSimpleEffect(9, $407866112e362b76$var$createEffectInstance(), $407866112e362b76$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $407866112e362b76$var$mountWorkInProgressHook(), identifierPrefix = $407866112e362b76$var$workInProgressRoot.identifierPrefix;
        if ($407866112e362b76$var$isHydrating) {
            var JSCompiler_inline_result = $407866112e362b76$var$treeContextOverflow;
            var idWithLeadingBit = $407866112e362b76$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $407866112e362b76$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $407866112e362b76$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $407866112e362b76$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $407866112e362b76$var$useHostTransitionStatus,
    useFormState: $407866112e362b76$var$mountActionState,
    useActionState: $407866112e362b76$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $407866112e362b76$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $407866112e362b76$var$dispatchOptimisticSetState.bind(null, $407866112e362b76$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $407866112e362b76$var$useMemoCache,
    useCacheRefresh: function() {
        return $407866112e362b76$var$mountWorkInProgressHook().memoizedState = $407866112e362b76$var$refreshCache.bind(null, $407866112e362b76$var$currentlyRenderingFiber);
    }
}, $407866112e362b76$var$HooksDispatcherOnUpdate = {
    readContext: $407866112e362b76$var$readContext,
    use: $407866112e362b76$var$use,
    useCallback: $407866112e362b76$var$updateCallback,
    useContext: $407866112e362b76$var$readContext,
    useEffect: $407866112e362b76$var$updateEffect,
    useImperativeHandle: $407866112e362b76$var$updateImperativeHandle,
    useInsertionEffect: $407866112e362b76$var$updateInsertionEffect,
    useLayoutEffect: $407866112e362b76$var$updateLayoutEffect,
    useMemo: $407866112e362b76$var$updateMemo,
    useReducer: $407866112e362b76$var$updateReducer,
    useRef: $407866112e362b76$var$updateRef,
    useState: function() {
        return $407866112e362b76$var$updateReducer($407866112e362b76$var$basicStateReducer);
    },
    useDebugValue: $407866112e362b76$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $407866112e362b76$var$updateWorkInProgressHook();
        return $407866112e362b76$var$updateDeferredValueImpl(hook, $407866112e362b76$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $407866112e362b76$var$updateReducer($407866112e362b76$var$basicStateReducer)[0], start = $407866112e362b76$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $407866112e362b76$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $407866112e362b76$var$updateSyncExternalStore,
    useId: $407866112e362b76$var$updateId,
    useHostTransitionStatus: $407866112e362b76$var$useHostTransitionStatus,
    useFormState: $407866112e362b76$var$updateActionState,
    useActionState: $407866112e362b76$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $407866112e362b76$var$updateWorkInProgressHook();
        return $407866112e362b76$var$updateOptimisticImpl(hook, $407866112e362b76$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $407866112e362b76$var$useMemoCache,
    useCacheRefresh: $407866112e362b76$var$updateRefresh
}, $407866112e362b76$var$HooksDispatcherOnRerender = {
    readContext: $407866112e362b76$var$readContext,
    use: $407866112e362b76$var$use,
    useCallback: $407866112e362b76$var$updateCallback,
    useContext: $407866112e362b76$var$readContext,
    useEffect: $407866112e362b76$var$updateEffect,
    useImperativeHandle: $407866112e362b76$var$updateImperativeHandle,
    useInsertionEffect: $407866112e362b76$var$updateInsertionEffect,
    useLayoutEffect: $407866112e362b76$var$updateLayoutEffect,
    useMemo: $407866112e362b76$var$updateMemo,
    useReducer: $407866112e362b76$var$rerenderReducer,
    useRef: $407866112e362b76$var$updateRef,
    useState: function() {
        return $407866112e362b76$var$rerenderReducer($407866112e362b76$var$basicStateReducer);
    },
    useDebugValue: $407866112e362b76$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $407866112e362b76$var$updateWorkInProgressHook();
        return null === $407866112e362b76$var$currentHook ? $407866112e362b76$var$mountDeferredValueImpl(hook, value, initialValue) : $407866112e362b76$var$updateDeferredValueImpl(hook, $407866112e362b76$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $407866112e362b76$var$rerenderReducer($407866112e362b76$var$basicStateReducer)[0], start = $407866112e362b76$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $407866112e362b76$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $407866112e362b76$var$updateSyncExternalStore,
    useId: $407866112e362b76$var$updateId,
    useHostTransitionStatus: $407866112e362b76$var$useHostTransitionStatus,
    useFormState: $407866112e362b76$var$rerenderActionState,
    useActionState: $407866112e362b76$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $407866112e362b76$var$updateWorkInProgressHook();
        if (null !== $407866112e362b76$var$currentHook) return $407866112e362b76$var$updateOptimisticImpl(hook, $407866112e362b76$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $407866112e362b76$var$useMemoCache,
    useCacheRefresh: $407866112e362b76$var$updateRefresh
}, $407866112e362b76$var$thenableState = null, $407866112e362b76$var$thenableIndexCounter = 0;
function $407866112e362b76$var$unwrapThenable(thenable) {
    var index = $407866112e362b76$var$thenableIndexCounter;
    $407866112e362b76$var$thenableIndexCounter += 1;
    null === $407866112e362b76$var$thenableState && ($407866112e362b76$var$thenableState = []);
    return $407866112e362b76$var$trackUsedThenable($407866112e362b76$var$thenableState, thenable, index);
}
function $407866112e362b76$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $407866112e362b76$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $407866112e362b76$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($407866112e362b76$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($407866112e362b76$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $407866112e362b76$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $407866112e362b76$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $407866112e362b76$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $407866112e362b76$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $407866112e362b76$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $407866112e362b76$var$REACT_LAZY_TYPE && $407866112e362b76$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $407866112e362b76$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $407866112e362b76$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $407866112e362b76$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $407866112e362b76$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $407866112e362b76$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $407866112e362b76$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $407866112e362b76$var$REACT_ELEMENT_TYPE:
                    return lanes = $407866112e362b76$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $407866112e362b76$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $407866112e362b76$var$REACT_PORTAL_TYPE:
                    return newChild = $407866112e362b76$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $407866112e362b76$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($407866112e362b76$var$isArrayImpl(newChild) || $407866112e362b76$var$getIteratorFn(newChild)) return newChild = $407866112e362b76$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $407866112e362b76$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $407866112e362b76$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $407866112e362b76$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $407866112e362b76$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $407866112e362b76$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $407866112e362b76$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $407866112e362b76$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($407866112e362b76$var$isArrayImpl(newChild) || $407866112e362b76$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $407866112e362b76$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $407866112e362b76$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $407866112e362b76$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $407866112e362b76$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $407866112e362b76$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $407866112e362b76$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $407866112e362b76$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($407866112e362b76$var$isArrayImpl(newChild) || $407866112e362b76$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $407866112e362b76$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $407866112e362b76$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $407866112e362b76$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $407866112e362b76$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $407866112e362b76$var$isHydrating && $407866112e362b76$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $407866112e362b76$var$isHydrating && $407866112e362b76$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $407866112e362b76$var$isHydrating && $407866112e362b76$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($407866112e362b76$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $407866112e362b76$var$isHydrating && $407866112e362b76$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $407866112e362b76$var$isHydrating && $407866112e362b76$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $407866112e362b76$var$isHydrating && $407866112e362b76$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $407866112e362b76$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $407866112e362b76$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $407866112e362b76$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $407866112e362b76$var$REACT_LAZY_TYPE && $407866112e362b76$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $407866112e362b76$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $407866112e362b76$var$REACT_FRAGMENT_TYPE ? (lanes = $407866112e362b76$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $407866112e362b76$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $407866112e362b76$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $407866112e362b76$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $407866112e362b76$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $407866112e362b76$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($407866112e362b76$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($407866112e362b76$var$getIteratorFn(newChild)) {
                key = $407866112e362b76$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($407866112e362b76$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $407866112e362b76$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $407866112e362b76$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $407866112e362b76$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $407866112e362b76$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $407866112e362b76$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $407866112e362b76$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $407866112e362b76$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $407866112e362b76$var$SuspenseException || x === $407866112e362b76$var$SuspenseActionException) throw x;
            var fiber = $407866112e362b76$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $407866112e362b76$var$reconcileChildFibers = $407866112e362b76$var$createChildReconciler(!0), $407866112e362b76$var$mountChildFibers = $407866112e362b76$var$createChildReconciler(!1), $407866112e362b76$var$suspenseHandlerStackCursor = $407866112e362b76$var$createCursor(null), $407866112e362b76$var$shellBoundary = null;
function $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, $407866112e362b76$var$suspenseStackCursor.current & 1);
    $407866112e362b76$var$push($407866112e362b76$var$suspenseHandlerStackCursor, handler);
    null === $407866112e362b76$var$shellBoundary && (null === current || null !== $407866112e362b76$var$currentTreeHiddenStackCursor.current ? $407866112e362b76$var$shellBoundary = handler : null !== current.memoizedState && ($407866112e362b76$var$shellBoundary = handler));
}
function $407866112e362b76$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, $407866112e362b76$var$suspenseStackCursor.current), $407866112e362b76$var$push($407866112e362b76$var$suspenseHandlerStackCursor, fiber), null === $407866112e362b76$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($407866112e362b76$var$shellBoundary = fiber);
        }
    } else $407866112e362b76$var$reuseSuspenseHandlerOnStack(fiber);
}
function $407866112e362b76$var$reuseSuspenseHandlerOnStack() {
    $407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, $407866112e362b76$var$suspenseStackCursor.current);
    $407866112e362b76$var$push($407866112e362b76$var$suspenseHandlerStackCursor, $407866112e362b76$var$suspenseHandlerStackCursor.current);
}
function $407866112e362b76$var$popSuspenseHandler(fiber) {
    $407866112e362b76$var$pop($407866112e362b76$var$suspenseHandlerStackCursor);
    $407866112e362b76$var$shellBoundary === fiber && ($407866112e362b76$var$shellBoundary = null);
    $407866112e362b76$var$pop($407866112e362b76$var$suspenseStackCursor);
}
var $407866112e362b76$var$suspenseStackCursor = $407866112e362b76$var$createCursor(0);
function $407866112e362b76$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $407866112e362b76$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $407866112e362b76$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $407866112e362b76$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $407866112e362b76$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $407866112e362b76$var$requestUpdateLane(), update = $407866112e362b76$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $407866112e362b76$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($407866112e362b76$var$scheduleUpdateOnFiber(payload, inst, lane), $407866112e362b76$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $407866112e362b76$var$requestUpdateLane(), update = $407866112e362b76$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $407866112e362b76$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($407866112e362b76$var$scheduleUpdateOnFiber(payload, inst, lane), $407866112e362b76$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $407866112e362b76$var$requestUpdateLane(), update = $407866112e362b76$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $407866112e362b76$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($407866112e362b76$var$scheduleUpdateOnFiber(callback, inst, lane), $407866112e362b76$var$entangleTransitions(callback, inst, lane));
    }
};
function $407866112e362b76$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$407866112e362b76$var$shallowEqual(oldProps, newProps) || !$407866112e362b76$var$shallowEqual(oldState, newState) : !0;
}
function $407866112e362b76$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $407866112e362b76$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $407866112e362b76$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $407866112e362b76$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $407866112e362b76$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $407866112e362b76$var$defaultOnUncaughtError(error) {
    $407866112e362b76$var$reportGlobalError(error);
}
function $407866112e362b76$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $407866112e362b76$var$defaultOnRecoverableError(error) {
    $407866112e362b76$var$reportGlobalError(error);
}
function $407866112e362b76$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $407866112e362b76$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $407866112e362b76$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $407866112e362b76$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $407866112e362b76$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $407866112e362b76$var$createClassErrorUpdate(lane) {
    lane = $407866112e362b76$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $407866112e362b76$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $407866112e362b76$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $407866112e362b76$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed ? $407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $407866112e362b76$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $407866112e362b76$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $407866112e362b76$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $407866112e362b76$var$shellBoundary ? $407866112e362b76$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $407866112e362b76$var$workInProgressRootExitStatus && ($407866112e362b76$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $407866112e362b76$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $407866112e362b76$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $407866112e362b76$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $407866112e362b76$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($407866112e362b76$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $407866112e362b76$var$attachPingListener(root, value, rootRenderLanes);
        $407866112e362b76$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($407866112e362b76$var$isHydrating) return returnFiber = $407866112e362b76$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $407866112e362b76$var$HydrationMismatchException && (root = Error($407866112e362b76$var$formatProdErrorMessage(422), {
        cause: value
    }), $407866112e362b76$var$queueHydrationError($407866112e362b76$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $407866112e362b76$var$HydrationMismatchException && (returnFiber = Error($407866112e362b76$var$formatProdErrorMessage(423), {
        cause: value
    }), $407866112e362b76$var$queueHydrationError($407866112e362b76$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $407866112e362b76$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $407866112e362b76$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $407866112e362b76$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $407866112e362b76$var$workInProgressRootExitStatus && ($407866112e362b76$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($407866112e362b76$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $407866112e362b76$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $407866112e362b76$var$workInProgressRootConcurrentErrors ? $407866112e362b76$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $407866112e362b76$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $407866112e362b76$var$workInProgressRootExitStatus && ($407866112e362b76$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $407866112e362b76$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $407866112e362b76$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $407866112e362b76$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed || !$407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $407866112e362b76$var$createClassErrorUpdate(rootRenderLanes), $407866112e362b76$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $407866112e362b76$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $407866112e362b76$var$SelectiveHydrationException = Error($407866112e362b76$var$formatProdErrorMessage(461)), $407866112e362b76$var$didReceiveUpdate = !1;
function $407866112e362b76$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $407866112e362b76$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $407866112e362b76$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $407866112e362b76$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $407866112e362b76$var$prepareToReadContext(workInProgress);
    nextProps = $407866112e362b76$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $407866112e362b76$var$checkDidRenderIdHook();
    if (null !== current && !$407866112e362b76$var$didReceiveUpdate) return $407866112e362b76$var$bailoutHooks(current, workInProgress, renderLanes), $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $407866112e362b76$var$isHydrating && key && $407866112e362b76$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $407866112e362b76$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $407866112e362b76$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$407866112e362b76$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $407866112e362b76$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $407866112e362b76$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$407866112e362b76$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $407866112e362b76$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $407866112e362b76$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $407866112e362b76$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($407866112e362b76$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($407866112e362b76$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $407866112e362b76$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($407866112e362b76$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $407866112e362b76$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $407866112e362b76$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $407866112e362b76$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $407866112e362b76$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $407866112e362b76$var$pushHiddenContext(workInProgress, prevState) : $407866112e362b76$var$reuseHiddenContextOnStack(), $407866112e362b76$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $407866112e362b76$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($407866112e362b76$var$pushTransition(workInProgress, prevState.cachePool), $407866112e362b76$var$pushHiddenContext(workInProgress, prevState), $407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $407866112e362b76$var$pushTransition(workInProgress, null), $407866112e362b76$var$reuseHiddenContextOnStack(), $407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress));
    $407866112e362b76$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $407866112e362b76$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $407866112e362b76$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $407866112e362b76$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $407866112e362b76$var$pushTransition(workInProgress, null);
    $407866112e362b76$var$reuseHiddenContextOnStack();
    $407866112e362b76$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $407866112e362b76$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $407866112e362b76$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($407866112e362b76$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $407866112e362b76$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $407866112e362b76$var$prepareToReadContext(workInProgress);
    Component = $407866112e362b76$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $407866112e362b76$var$checkDidRenderIdHook();
    if (null !== current && !$407866112e362b76$var$didReceiveUpdate) return $407866112e362b76$var$bailoutHooks(current, workInProgress, renderLanes), $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $407866112e362b76$var$isHydrating && nextProps && $407866112e362b76$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $407866112e362b76$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $407866112e362b76$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $407866112e362b76$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $407866112e362b76$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $407866112e362b76$var$finishRenderingHooks(current);
    Component = $407866112e362b76$var$checkDidRenderIdHook();
    if (null !== current && !$407866112e362b76$var$didReceiveUpdate) return $407866112e362b76$var$bailoutHooks(current, workInProgress, renderLanes), $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $407866112e362b76$var$isHydrating && Component && $407866112e362b76$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $407866112e362b76$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $407866112e362b76$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $407866112e362b76$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $407866112e362b76$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $407866112e362b76$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $407866112e362b76$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $407866112e362b76$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $407866112e362b76$var$readContext(contextType) : $407866112e362b76$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($407866112e362b76$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $407866112e362b76$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $407866112e362b76$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $407866112e362b76$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $407866112e362b76$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $407866112e362b76$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $407866112e362b76$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $407866112e362b76$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $407866112e362b76$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $407866112e362b76$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $407866112e362b76$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $407866112e362b76$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($407866112e362b76$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $407866112e362b76$var$hasForceUpdate || $407866112e362b76$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $407866112e362b76$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $407866112e362b76$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $407866112e362b76$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $407866112e362b76$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $407866112e362b76$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $407866112e362b76$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $407866112e362b76$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $407866112e362b76$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $407866112e362b76$var$hasForceUpdate || null !== current && null !== current.dependencies && $407866112e362b76$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($407866112e362b76$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $407866112e362b76$var$hasForceUpdate || $407866112e362b76$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $407866112e362b76$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $407866112e362b76$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $407866112e362b76$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $407866112e362b76$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $407866112e362b76$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $407866112e362b76$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $407866112e362b76$var$resetHydrationState();
    workInProgress.flags |= 256;
    $407866112e362b76$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $407866112e362b76$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $407866112e362b76$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $407866112e362b76$var$getSuspendedCache()
    };
}
function $407866112e362b76$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $407866112e362b76$var$workInProgressDeferredLane);
    return current;
}
function $407866112e362b76$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($407866112e362b76$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($407866112e362b76$var$isHydrating) {
            showFallback ? $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($407866112e362b76$var$isHydrating) {
                var nextInstance = $407866112e362b76$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $407866112e362b76$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $407866112e362b76$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $407866112e362b76$var$treeContextProvider ? {
                            id: $407866112e362b76$var$treeContextId,
                            overflow: $407866112e362b76$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $407866112e362b76$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $407866112e362b76$var$hydrationParentFiber = workInProgress, $407866112e362b76$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $407866112e362b76$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $407866112e362b76$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $407866112e362b76$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $407866112e362b76$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $407866112e362b76$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $407866112e362b76$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $407866112e362b76$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $407866112e362b76$var$SUSPENDED_MARKER, nextProps;
        $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $407866112e362b76$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $407866112e362b76$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $407866112e362b76$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $407866112e362b76$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $407866112e362b76$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $407866112e362b76$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $407866112e362b76$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $407866112e362b76$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress), $407866112e362b76$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($407866112e362b76$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $407866112e362b76$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $407866112e362b76$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($407866112e362b76$var$didReceiveUpdate || $407866112e362b76$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $407866112e362b76$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $407866112e362b76$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $407866112e362b76$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $407866112e362b76$var$enqueueConcurrentRenderForLane(current, nextProps), $407866112e362b76$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $407866112e362b76$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $407866112e362b76$var$renderDidSuspendDelayIfPossible();
            workInProgress = $407866112e362b76$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$getNextHydratable(nextInstance.nextSibling), $407866112e362b76$var$hydrationParentFiber = workInProgress, $407866112e362b76$var$isHydrating = !0, $407866112e362b76$var$hydrationErrors = null, $407866112e362b76$var$rootOrSingletonContext = !1, null !== current && ($407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex++] = $407866112e362b76$var$treeContextId, $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex++] = $407866112e362b76$var$treeContextOverflow, $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex++] = $407866112e362b76$var$treeContextProvider, $407866112e362b76$var$treeContextId = current.id, $407866112e362b76$var$treeContextOverflow = current.overflow, $407866112e362b76$var$treeContextProvider = workInProgress), workInProgress = $407866112e362b76$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $407866112e362b76$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $407866112e362b76$var$createWorkInProgress(digest, showFallback) : (showFallback = $407866112e362b76$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $407866112e362b76$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $407866112e362b76$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $407866112e362b76$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $407866112e362b76$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $407866112e362b76$var$SUSPENDED_MARKER, nextProps;
    $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $407866112e362b76$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $407866112e362b76$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $407866112e362b76$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $407866112e362b76$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $407866112e362b76$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $407866112e362b76$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $407866112e362b76$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $407866112e362b76$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $407866112e362b76$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $407866112e362b76$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $407866112e362b76$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $407866112e362b76$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $407866112e362b76$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $407866112e362b76$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $407866112e362b76$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $407866112e362b76$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $407866112e362b76$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $407866112e362b76$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $407866112e362b76$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $407866112e362b76$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $407866112e362b76$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $407866112e362b76$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($407866112e362b76$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($407866112e362b76$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $407866112e362b76$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $407866112e362b76$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $407866112e362b76$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $407866112e362b76$var$checkIfContextChanged(current) ? !0 : !1;
}
function $407866112e362b76$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $407866112e362b76$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $407866112e362b76$var$pushProvider(workInProgress, $407866112e362b76$var$CacheContext, current.memoizedState.cache);
            $407866112e362b76$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $407866112e362b76$var$pushHostContext(workInProgress);
            break;
        case 4:
            $407866112e362b76$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $407866112e362b76$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $407866112e362b76$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($407866112e362b76$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $407866112e362b76$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, $407866112e362b76$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $407866112e362b76$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $407866112e362b76$var$pushProvider(workInProgress, $407866112e362b76$var$CacheContext, current.memoizedState.cache);
    }
    return $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $407866112e362b76$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $407866112e362b76$var$didReceiveUpdate = !0;
        else {
            if (!$407866112e362b76$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $407866112e362b76$var$didReceiveUpdate = !1, $407866112e362b76$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $407866112e362b76$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $407866112e362b76$var$didReceiveUpdate = !1, $407866112e362b76$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $407866112e362b76$var$pushTreeId(workInProgress, $407866112e362b76$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $407866112e362b76$var$shouldConstruct(lazyComponent) ? (current = $407866112e362b76$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $407866112e362b76$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $407866112e362b76$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $407866112e362b76$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $407866112e362b76$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $407866112e362b76$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $407866112e362b76$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $407866112e362b76$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($407866112e362b76$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $407866112e362b76$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $407866112e362b76$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $407866112e362b76$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $407866112e362b76$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($407866112e362b76$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $407866112e362b76$var$cloneUpdateQueue(current, workInProgress);
                $407866112e362b76$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $407866112e362b76$var$pushProvider(workInProgress, $407866112e362b76$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $407866112e362b76$var$propagateContextChanges(workInProgress, [
                    $407866112e362b76$var$CacheContext
                ], renderLanes, !0);
                $407866112e362b76$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $407866112e362b76$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $407866112e362b76$var$createCapturedValueAtFiber(Error($407866112e362b76$var$formatProdErrorMessage(424)), workInProgress);
                        $407866112e362b76$var$queueHydrationError(init);
                        workInProgress = $407866112e362b76$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$getNextHydratable(current.firstChild);
                        $407866112e362b76$var$hydrationParentFiber = workInProgress;
                        $407866112e362b76$var$isHydrating = !0;
                        $407866112e362b76$var$hydrationErrors = null;
                        $407866112e362b76$var$rootOrSingletonContext = !0;
                        renderLanes = $407866112e362b76$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $407866112e362b76$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $407866112e362b76$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $407866112e362b76$var$markRef(current, workInProgress), null === current ? (renderLanes = $407866112e362b76$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $407866112e362b76$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $407866112e362b76$var$getOwnerDocumentFromRootContainer($407866112e362b76$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$407866112e362b76$var$internalInstanceKey] = workInProgress, lazyComponent[$407866112e362b76$var$internalPropsKey] = current, $407866112e362b76$var$setInitialProperties(lazyComponent, renderLanes, current), $407866112e362b76$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $407866112e362b76$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $407866112e362b76$var$pushHostContext(workInProgress), null === current && $407866112e362b76$var$isHydrating && (lazyComponent = workInProgress.stateNode = $407866112e362b76$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $407866112e362b76$var$rootInstanceStackCursor.current), $407866112e362b76$var$hydrationParentFiber = workInProgress, $407866112e362b76$var$rootOrSingletonContext = !0, init = $407866112e362b76$var$nextHydratableInstance, $407866112e362b76$var$isSingletonScope(workInProgress.type) ? ($407866112e362b76$var$previousHydratableOnEnteringScopedSingleton = init, $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$getNextHydratable(lazyComponent.firstChild)) : $407866112e362b76$var$nextHydratableInstance = init), $407866112e362b76$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $407866112e362b76$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $407866112e362b76$var$isHydrating) {
                if (init = lazyComponent = $407866112e362b76$var$nextHydratableInstance) lazyComponent = $407866112e362b76$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $407866112e362b76$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $407866112e362b76$var$hydrationParentFiber = workInProgress, $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$getNextHydratable(lazyComponent.firstChild), $407866112e362b76$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $407866112e362b76$var$throwOnHydrationMismatch(workInProgress);
            }
            $407866112e362b76$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $407866112e362b76$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $407866112e362b76$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $407866112e362b76$var$renderWithHooks(current, workInProgress, $407866112e362b76$var$TransitionAwareHostComponent, null, null, renderLanes), $407866112e362b76$var$HostTransitionContext._currentValue = init);
            $407866112e362b76$var$markRef(current, workInProgress);
            $407866112e362b76$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $407866112e362b76$var$isHydrating) {
                if (current = renderLanes = $407866112e362b76$var$nextHydratableInstance) renderLanes = $407866112e362b76$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $407866112e362b76$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $407866112e362b76$var$hydrationParentFiber = workInProgress, $407866112e362b76$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $407866112e362b76$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $407866112e362b76$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $407866112e362b76$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $407866112e362b76$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $407866112e362b76$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $407866112e362b76$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $407866112e362b76$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $407866112e362b76$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $407866112e362b76$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $407866112e362b76$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $407866112e362b76$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $407866112e362b76$var$prepareToReadContext(workInProgress), init = $407866112e362b76$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $407866112e362b76$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $407866112e362b76$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $407866112e362b76$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $407866112e362b76$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $407866112e362b76$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $407866112e362b76$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $407866112e362b76$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $407866112e362b76$var$prepareToReadContext(workInProgress), lazyComponent = $407866112e362b76$var$readContext($407866112e362b76$var$CacheContext), null === current ? (init = $407866112e362b76$var$peekCacheFromPool(), null === init && (init = $407866112e362b76$var$workInProgressRoot, prevState = $407866112e362b76$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $407866112e362b76$var$initializeUpdateQueue(workInProgress), $407866112e362b76$var$pushProvider(workInProgress, $407866112e362b76$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($407866112e362b76$var$cloneUpdateQueue(current, workInProgress), $407866112e362b76$var$processUpdateQueue(workInProgress, null, null, renderLanes), $407866112e362b76$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $407866112e362b76$var$pushProvider(workInProgress, $407866112e362b76$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $407866112e362b76$var$pushProvider(workInProgress, $407866112e362b76$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $407866112e362b76$var$propagateContextChanges(workInProgress, [
                $407866112e362b76$var$CacheContext
            ], renderLanes, !0))), $407866112e362b76$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($407866112e362b76$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $407866112e362b76$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $407866112e362b76$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$407866112e362b76$var$preloadResource(resource)) {
        resource = $407866112e362b76$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($407866112e362b76$var$workInProgressRootRenderLanes & 4194048) === $407866112e362b76$var$workInProgressRootRenderLanes ? null !== $407866112e362b76$var$shellBoundary : ($407866112e362b76$var$workInProgressRootRenderLanes & 62914560) !== $407866112e362b76$var$workInProgressRootRenderLanes && 0 === ($407866112e362b76$var$workInProgressRootRenderLanes & 536870912) || resource !== $407866112e362b76$var$shellBoundary)) throw $407866112e362b76$var$suspendedThenable = $407866112e362b76$var$noopSuspenseyCommitThenable, $407866112e362b76$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $407866112e362b76$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $407866112e362b76$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $407866112e362b76$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $407866112e362b76$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$407866112e362b76$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $407866112e362b76$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $407866112e362b76$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $407866112e362b76$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $407866112e362b76$var$bubbleProperties(workInProgress), null;
        case 1:
            return $407866112e362b76$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $407866112e362b76$var$popProvider($407866112e362b76$var$CacheContext);
            $407866112e362b76$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $407866112e362b76$var$popHydrationState(workInProgress) ? $407866112e362b76$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $407866112e362b76$var$upgradeHydrationErrorsToRecoverable());
            $407866112e362b76$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($407866112e362b76$var$markUpdate(workInProgress), null !== renderLanes ? ($407866112e362b76$var$bubbleProperties(workInProgress), $407866112e362b76$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($407866112e362b76$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($407866112e362b76$var$markUpdate(workInProgress), $407866112e362b76$var$bubbleProperties(workInProgress), $407866112e362b76$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($407866112e362b76$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $407866112e362b76$var$markUpdate(workInProgress), $407866112e362b76$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $407866112e362b76$var$popHostContext(workInProgress);
            renderLanes = $407866112e362b76$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $407866112e362b76$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($407866112e362b76$var$formatProdErrorMessage(166));
                    $407866112e362b76$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $407866112e362b76$var$contextStackCursor.current;
                $407866112e362b76$var$popHydrationState(workInProgress) ? $407866112e362b76$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $407866112e362b76$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $407866112e362b76$var$markUpdate(workInProgress));
            }
            $407866112e362b76$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $407866112e362b76$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $407866112e362b76$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($407866112e362b76$var$formatProdErrorMessage(166));
                    $407866112e362b76$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $407866112e362b76$var$contextStackCursor.current;
                if ($407866112e362b76$var$popHydrationState(workInProgress)) $407866112e362b76$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $407866112e362b76$var$getOwnerDocumentFromRootContainer($407866112e362b76$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$407866112e362b76$var$internalInstanceKey] = workInProgress;
                    current[$407866112e362b76$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($407866112e362b76$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $407866112e362b76$var$markUpdate(workInProgress);
                }
            }
            $407866112e362b76$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $407866112e362b76$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($407866112e362b76$var$formatProdErrorMessage(166));
                current = $407866112e362b76$var$rootInstanceStackCursor.current;
                if ($407866112e362b76$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $407866112e362b76$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$407866112e362b76$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $407866112e362b76$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $407866112e362b76$var$throwOnHydrationMismatch(workInProgress);
                } else current = $407866112e362b76$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$407866112e362b76$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $407866112e362b76$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $407866112e362b76$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($407866112e362b76$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($407866112e362b76$var$formatProdErrorMessage(317));
                        type[$407866112e362b76$var$internalInstanceKey] = workInProgress;
                    } else $407866112e362b76$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $407866112e362b76$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $407866112e362b76$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $407866112e362b76$var$popSuspenseHandler(workInProgress), workInProgress;
                    $407866112e362b76$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $407866112e362b76$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $407866112e362b76$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $407866112e362b76$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $407866112e362b76$var$popHostContainer(), null === current && $407866112e362b76$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $407866112e362b76$var$bubbleProperties(workInProgress), null;
        case 10:
            return $407866112e362b76$var$popProvider(workInProgress.type), $407866112e362b76$var$bubbleProperties(workInProgress), null;
        case 19:
            $407866112e362b76$var$pop($407866112e362b76$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $407866112e362b76$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $407866112e362b76$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $407866112e362b76$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $407866112e362b76$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $407866112e362b76$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $407866112e362b76$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$407866112e362b76$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, $407866112e362b76$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $407866112e362b76$var$now() > $407866112e362b76$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $407866112e362b76$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $407866112e362b76$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $407866112e362b76$var$scheduleRetryEffect(workInProgress, current), $407866112e362b76$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$407866112e362b76$var$isHydrating) return $407866112e362b76$var$bubbleProperties(workInProgress), null;
                    } else 2 * $407866112e362b76$var$now() - type.renderingStartTime > $407866112e362b76$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $407866112e362b76$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $407866112e362b76$var$now(), workInProgress.sibling = null, current = $407866112e362b76$var$suspenseStackCursor.current, $407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $407866112e362b76$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $407866112e362b76$var$popSuspenseHandler(workInProgress), $407866112e362b76$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($407866112e362b76$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $407866112e362b76$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $407866112e362b76$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $407866112e362b76$var$pop($407866112e362b76$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $407866112e362b76$var$popProvider($407866112e362b76$var$CacheContext), $407866112e362b76$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($407866112e362b76$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $407866112e362b76$var$unwindWork(current, workInProgress) {
    $407866112e362b76$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $407866112e362b76$var$popProvider($407866112e362b76$var$CacheContext), $407866112e362b76$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $407866112e362b76$var$popHostContext(workInProgress), null;
        case 13:
            $407866112e362b76$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($407866112e362b76$var$formatProdErrorMessage(340));
                $407866112e362b76$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $407866112e362b76$var$pop($407866112e362b76$var$suspenseStackCursor), null;
        case 4:
            return $407866112e362b76$var$popHostContainer(), null;
        case 10:
            return $407866112e362b76$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $407866112e362b76$var$popSuspenseHandler(workInProgress), $407866112e362b76$var$popHiddenContext(), null !== current && $407866112e362b76$var$pop($407866112e362b76$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $407866112e362b76$var$popProvider($407866112e362b76$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $407866112e362b76$var$unwindInterruptedWork(current, interruptedWork) {
    $407866112e362b76$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $407866112e362b76$var$popProvider($407866112e362b76$var$CacheContext);
            $407866112e362b76$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $407866112e362b76$var$popHostContext(interruptedWork);
            break;
        case 4:
            $407866112e362b76$var$popHostContainer();
            break;
        case 13:
            $407866112e362b76$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $407866112e362b76$var$pop($407866112e362b76$var$suspenseStackCursor);
            break;
        case 10:
            $407866112e362b76$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $407866112e362b76$var$popSuspenseHandler(interruptedWork);
            $407866112e362b76$var$popHiddenContext();
            null !== current && $407866112e362b76$var$pop($407866112e362b76$var$resumedCache);
            break;
        case 24:
            $407866112e362b76$var$popProvider($407866112e362b76$var$CacheContext);
    }
}
function $407866112e362b76$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $407866112e362b76$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $407866112e362b76$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $407866112e362b76$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $407866112e362b76$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $407866112e362b76$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $407866112e362b76$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $407866112e362b76$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $407866112e362b76$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $407866112e362b76$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $407866112e362b76$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $407866112e362b76$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $407866112e362b76$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $407866112e362b76$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$407866112e362b76$var$internalPropsKey] = newProps;
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $407866112e362b76$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $407866112e362b76$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $407866112e362b76$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $407866112e362b76$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $407866112e362b76$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $407866112e362b76$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $407866112e362b76$var$noop$1));
    else if (4 !== tag && (27 === tag && $407866112e362b76$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($407866112e362b76$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$407866112e362b76$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $407866112e362b76$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $407866112e362b76$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($407866112e362b76$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$407866112e362b76$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $407866112e362b76$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $407866112e362b76$var$setInitialProperties(singleton, type, props);
        singleton[$407866112e362b76$var$internalInstanceKey] = finishedWork;
        singleton[$407866112e362b76$var$internalPropsKey] = props;
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $407866112e362b76$var$offscreenSubtreeIsHidden = !1, $407866112e362b76$var$offscreenSubtreeWasHidden = !1, $407866112e362b76$var$needsFormReset = !1, $407866112e362b76$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $407866112e362b76$var$nextEffect = null;
function $407866112e362b76$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $407866112e362b76$var$eventsEnabled = $407866112e362b76$var$_enabled;
    root = $407866112e362b76$var$getActiveElementDeep(root);
    if ($407866112e362b76$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $407866112e362b76$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $407866112e362b76$var$_enabled = !1;
    for($407866112e362b76$var$nextEffect = firstChild; null !== $407866112e362b76$var$nextEffect;)if (firstChild = $407866112e362b76$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $407866112e362b76$var$nextEffect = root;
    else for(; null !== $407866112e362b76$var$nextEffect;){
        firstChild = $407866112e362b76$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $407866112e362b76$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $407866112e362b76$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $407866112e362b76$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $407866112e362b76$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($407866112e362b76$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $407866112e362b76$var$nextEffect = root;
            break;
        }
        $407866112e362b76$var$nextEffect = firstChild.return;
    }
}
function $407866112e362b76$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $407866112e362b76$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $407866112e362b76$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $407866112e362b76$var$commitClassCallbacks(finishedWork);
            flags & 512 && $407866112e362b76$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $407866112e362b76$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $407866112e362b76$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $407866112e362b76$var$commitHostMount(finishedWork);
            flags & 512 && $407866112e362b76$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $407866112e362b76$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $407866112e362b76$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $407866112e362b76$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $407866112e362b76$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $407866112e362b76$var$offscreenSubtreeWasHidden;
                prevProps = $407866112e362b76$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $407866112e362b76$var$offscreenSubtreeWasHidden;
                $407866112e362b76$var$offscreenSubtreeIsHidden = flags;
                ($407866112e362b76$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $407866112e362b76$var$offscreenSubtreeIsHidden = prevProps;
                $407866112e362b76$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $407866112e362b76$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $407866112e362b76$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $407866112e362b76$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $407866112e362b76$var$hostParent = null, $407866112e362b76$var$hostParentIsContainer = !1;
function $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$407866112e362b76$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $407866112e362b76$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($407866112e362b76$var$injectedHook && "function" === typeof $407866112e362b76$var$injectedHook.onCommitFiberUnmount) try {
        $407866112e362b76$var$injectedHook.onCommitFiberUnmount($407866112e362b76$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $407866112e362b76$var$offscreenSubtreeWasHidden || $407866112e362b76$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $407866112e362b76$var$offscreenSubtreeWasHidden || $407866112e362b76$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $407866112e362b76$var$hostParent, prevHostParentIsContainer = $407866112e362b76$var$hostParentIsContainer;
            $407866112e362b76$var$isSingletonScope(deletedFiber.type) && ($407866112e362b76$var$hostParent = deletedFiber.stateNode, $407866112e362b76$var$hostParentIsContainer = !1);
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $407866112e362b76$var$releaseSingletonInstance(deletedFiber.stateNode);
            $407866112e362b76$var$hostParent = prevHostParent;
            $407866112e362b76$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $407866112e362b76$var$offscreenSubtreeWasHidden || $407866112e362b76$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $407866112e362b76$var$hostParent;
            prevHostParentIsContainer = $407866112e362b76$var$hostParentIsContainer;
            $407866112e362b76$var$hostParent = null;
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $407866112e362b76$var$hostParent = prevHostParent;
            $407866112e362b76$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $407866112e362b76$var$hostParent) {
                if ($407866112e362b76$var$hostParentIsContainer) try {
                    (9 === $407866112e362b76$var$hostParent.nodeType ? $407866112e362b76$var$hostParent.body : "HTML" === $407866112e362b76$var$hostParent.nodeName ? $407866112e362b76$var$hostParent.ownerDocument.body : $407866112e362b76$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $407866112e362b76$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $407866112e362b76$var$hostParent && ($407866112e362b76$var$hostParentIsContainer ? (finishedRoot = $407866112e362b76$var$hostParent, $407866112e362b76$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $407866112e362b76$var$retryIfBlockedOn(finishedRoot)) : $407866112e362b76$var$clearSuspenseBoundary($407866112e362b76$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $407866112e362b76$var$hostParent;
            prevHostParentIsContainer = $407866112e362b76$var$hostParentIsContainer;
            $407866112e362b76$var$hostParent = deletedFiber.stateNode.containerInfo;
            $407866112e362b76$var$hostParentIsContainer = !0;
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $407866112e362b76$var$hostParent = prevHostParent;
            $407866112e362b76$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $407866112e362b76$var$offscreenSubtreeWasHidden || $407866112e362b76$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $407866112e362b76$var$offscreenSubtreeWasHidden || $407866112e362b76$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $407866112e362b76$var$offscreenSubtreeWasHidden || ($407866112e362b76$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $407866112e362b76$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $407866112e362b76$var$offscreenSubtreeWasHidden = (prevHostParent = $407866112e362b76$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $407866112e362b76$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $407866112e362b76$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $407866112e362b76$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $407866112e362b76$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $407866112e362b76$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $407866112e362b76$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($407866112e362b76$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $407866112e362b76$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $407866112e362b76$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $407866112e362b76$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $407866112e362b76$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($407866112e362b76$var$isSingletonScope(parent.type)) {
                        $407866112e362b76$var$hostParent = parent.stateNode;
                        $407866112e362b76$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $407866112e362b76$var$hostParent = parent.stateNode;
                    $407866112e362b76$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $407866112e362b76$var$hostParent = parent.stateNode.containerInfo;
                    $407866112e362b76$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $407866112e362b76$var$hostParent) throw Error($407866112e362b76$var$formatProdErrorMessage(160));
        $407866112e362b76$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $407866112e362b76$var$hostParent = null;
        $407866112e362b76$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$407866112e362b76$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $407866112e362b76$var$currentHoistableRoot = null;
function $407866112e362b76$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($407866112e362b76$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $407866112e362b76$var$commitHookEffectListMount(3, finishedWork), $407866112e362b76$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($407866112e362b76$var$offscreenSubtreeWasHidden || null === current || $407866112e362b76$var$safelyDetachRef(current, current.return));
            flags & 64 && $407866112e362b76$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $407866112e362b76$var$currentHoistableRoot;
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($407866112e362b76$var$offscreenSubtreeWasHidden || null === current || $407866112e362b76$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$407866112e362b76$var$internalHoistableMarker] || currentResource[$407866112e362b76$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $407866112e362b76$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$407866112e362b76$var$internalInstanceKey] = finishedWork;
                                        $407866112e362b76$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $407866112e362b76$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $407866112e362b76$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $407866112e362b76$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $407866112e362b76$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($407866112e362b76$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$407866112e362b76$var$internalInstanceKey] = finishedWork;
                                $407866112e362b76$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $407866112e362b76$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $407866112e362b76$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $407866112e362b76$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $407866112e362b76$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $407866112e362b76$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($407866112e362b76$var$offscreenSubtreeWasHidden || null === current || $407866112e362b76$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $407866112e362b76$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($407866112e362b76$var$offscreenSubtreeWasHidden || null === current || $407866112e362b76$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $407866112e362b76$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $407866112e362b76$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($407866112e362b76$var$needsFormReset = !0);
            break;
        case 6:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($407866112e362b76$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $407866112e362b76$var$tagCaches = null;
            hoistableRoot = $407866112e362b76$var$currentHoistableRoot;
            $407866112e362b76$var$currentHoistableRoot = $407866112e362b76$var$getHoistableRoot(root.containerInfo);
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$currentHoistableRoot = hoistableRoot;
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $407866112e362b76$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $407866112e362b76$var$needsFormReset && ($407866112e362b76$var$needsFormReset = !1, $407866112e362b76$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $407866112e362b76$var$currentHoistableRoot;
            $407866112e362b76$var$currentHoistableRoot = $407866112e362b76$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            $407866112e362b76$var$currentHoistableRoot = flags;
            break;
        case 12:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($407866112e362b76$var$globalMostRecentFallbackTime = $407866112e362b76$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $407866112e362b76$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $407866112e362b76$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $407866112e362b76$var$offscreenSubtreeWasHidden;
            $407866112e362b76$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $407866112e362b76$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $407866112e362b76$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $407866112e362b76$var$offscreenSubtreeIsHidden || $407866112e362b76$var$offscreenSubtreeWasHidden || $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $407866112e362b76$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $407866112e362b76$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $407866112e362b76$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $407866112e362b76$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork), $407866112e362b76$var$commitReconciliationEffects(finishedWork);
    }
}
function $407866112e362b76$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($407866112e362b76$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($407866112e362b76$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $407866112e362b76$var$getHostSibling(finishedWork);
                    $407866112e362b76$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($407866112e362b76$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $407866112e362b76$var$getHostSibling(finishedWork);
                    $407866112e362b76$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $407866112e362b76$var$getHostSibling(finishedWork);
                    $407866112e362b76$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($407866112e362b76$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $407866112e362b76$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $407866112e362b76$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $407866112e362b76$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$407866112e362b76$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $407866112e362b76$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $407866112e362b76$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $407866112e362b76$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $407866112e362b76$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $407866112e362b76$var$safelyDetachRef(finishedWork, finishedWork.return);
                $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $407866112e362b76$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$407866112e362b76$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $407866112e362b76$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $407866112e362b76$var$commitClassCallbacks(finishedWork);
                $407866112e362b76$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $407866112e362b76$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $407866112e362b76$var$commitHostMount(finishedWork);
                $407866112e362b76$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $407866112e362b76$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $407866112e362b76$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $407866112e362b76$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $407866112e362b76$var$releaseCache(previousCache));
}
function $407866112e362b76$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $407866112e362b76$var$releaseCache(current));
}
function $407866112e362b76$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$407866112e362b76$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $407866112e362b76$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $407866112e362b76$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $407866112e362b76$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $407866112e362b76$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $407866112e362b76$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $407866112e362b76$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $407866112e362b76$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $407866112e362b76$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $407866112e362b76$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $407866112e362b76$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $407866112e362b76$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $407866112e362b76$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $407866112e362b76$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $407866112e362b76$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $407866112e362b76$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $407866112e362b76$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $407866112e362b76$var$suspenseyCommitFlag = 8192;
function $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $407866112e362b76$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$407866112e362b76$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $407866112e362b76$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $407866112e362b76$var$suspenseyCommitFlag && null !== fiber.memoizedState && $407866112e362b76$var$suspendResource($407866112e362b76$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $407866112e362b76$var$currentHoistableRoot;
            $407866112e362b76$var$currentHoistableRoot = $407866112e362b76$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $407866112e362b76$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $407866112e362b76$var$suspenseyCommitFlag, $407866112e362b76$var$suspenseyCommitFlag = 16777216, $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(fiber), $407866112e362b76$var$suspenseyCommitFlag = previousHoistableRoot) : $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $407866112e362b76$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $407866112e362b76$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $407866112e362b76$var$nextEffect = childToDelete;
            $407866112e362b76$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $407866112e362b76$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$407866112e362b76$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $407866112e362b76$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $407866112e362b76$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $407866112e362b76$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $407866112e362b76$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $407866112e362b76$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $407866112e362b76$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $407866112e362b76$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $407866112e362b76$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $407866112e362b76$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $407866112e362b76$var$nextEffect = childToDelete;
            $407866112e362b76$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $407866112e362b76$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $407866112e362b76$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $407866112e362b76$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $407866112e362b76$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $407866112e362b76$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $407866112e362b76$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $407866112e362b76$var$nextEffect;){
        var fiber = $407866112e362b76$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $407866112e362b76$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $407866112e362b76$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $407866112e362b76$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $407866112e362b76$var$nextEffect;){
            cache = $407866112e362b76$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $407866112e362b76$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $407866112e362b76$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $407866112e362b76$var$nextEffect = sibling;
                break a;
            }
            $407866112e362b76$var$nextEffect = returnFiber;
        }
    }
}
var $407866112e362b76$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $407866112e362b76$var$readContext($407866112e362b76$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $407866112e362b76$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $407866112e362b76$var$executionContext = 0, $407866112e362b76$var$workInProgressRoot = null, $407866112e362b76$var$workInProgress = null, $407866112e362b76$var$workInProgressRootRenderLanes = 0, $407866112e362b76$var$workInProgressSuspendedReason = 0, $407866112e362b76$var$workInProgressThrownValue = null, $407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings = !1, $407866112e362b76$var$workInProgressRootIsPrerendering = !1, $407866112e362b76$var$workInProgressRootDidAttachPingListener = !1, $407866112e362b76$var$entangledRenderLanes = 0, $407866112e362b76$var$workInProgressRootExitStatus = 0, $407866112e362b76$var$workInProgressRootSkippedLanes = 0, $407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes = 0, $407866112e362b76$var$workInProgressRootPingedLanes = 0, $407866112e362b76$var$workInProgressDeferredLane = 0, $407866112e362b76$var$workInProgressSuspendedRetryLanes = 0, $407866112e362b76$var$workInProgressRootConcurrentErrors = null, $407866112e362b76$var$workInProgressRootRecoverableErrors = null, $407866112e362b76$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $407866112e362b76$var$globalMostRecentFallbackTime = 0, $407866112e362b76$var$workInProgressRootRenderTargetTime = Infinity, $407866112e362b76$var$workInProgressTransitions = null, $407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed = null, $407866112e362b76$var$pendingEffectsStatus = 0, $407866112e362b76$var$pendingEffectsRoot = null, $407866112e362b76$var$pendingFinishedWork = null, $407866112e362b76$var$pendingEffectsLanes = 0, $407866112e362b76$var$pendingEffectsRemainingLanes = 0, $407866112e362b76$var$pendingPassiveTransitions = null, $407866112e362b76$var$pendingRecoverableErrors = null, $407866112e362b76$var$nestedUpdateCount = 0, $407866112e362b76$var$rootWithNestedUpdates = null;
function $407866112e362b76$var$requestUpdateLane() {
    if (0 !== ($407866112e362b76$var$executionContext & 2) && 0 !== $407866112e362b76$var$workInProgressRootRenderLanes) return $407866112e362b76$var$workInProgressRootRenderLanes & -$407866112e362b76$var$workInProgressRootRenderLanes;
    if (null !== $407866112e362b76$var$ReactSharedInternals.T) {
        var actionScopeLane = $407866112e362b76$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $407866112e362b76$var$requestTransitionLane();
    }
    return $407866112e362b76$var$resolveUpdatePriority();
}
function $407866112e362b76$var$requestDeferredLane() {
    0 === $407866112e362b76$var$workInProgressDeferredLane && ($407866112e362b76$var$workInProgressDeferredLane = 0 === ($407866112e362b76$var$workInProgressRootRenderLanes & 536870912) || $407866112e362b76$var$isHydrating ? $407866112e362b76$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $407866112e362b76$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $407866112e362b76$var$workInProgressDeferredLane;
}
function $407866112e362b76$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $407866112e362b76$var$workInProgressRoot && (2 === $407866112e362b76$var$workInProgressSuspendedReason || 9 === $407866112e362b76$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $407866112e362b76$var$prepareFreshStack(root, 0), $407866112e362b76$var$markRootSuspended(root, $407866112e362b76$var$workInProgressRootRenderLanes, $407866112e362b76$var$workInProgressDeferredLane, !1);
    $407866112e362b76$var$markRootUpdated$1(root, lane);
    if (0 === ($407866112e362b76$var$executionContext & 2) || root !== $407866112e362b76$var$workInProgressRoot) root === $407866112e362b76$var$workInProgressRoot && (0 === ($407866112e362b76$var$executionContext & 2) && ($407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $407866112e362b76$var$workInProgressRootExitStatus && $407866112e362b76$var$markRootSuspended(root, $407866112e362b76$var$workInProgressRootRenderLanes, $407866112e362b76$var$workInProgressDeferredLane, !1)), $407866112e362b76$var$ensureRootIsScheduled(root);
}
function $407866112e362b76$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($407866112e362b76$var$executionContext & 6)) throw Error($407866112e362b76$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $407866112e362b76$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $407866112e362b76$var$renderRootConcurrent(root$jscomp$0, lanes) : $407866112e362b76$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $407866112e362b76$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $407866112e362b76$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$407866112e362b76$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $407866112e362b76$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $407866112e362b76$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($407866112e362b76$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $407866112e362b76$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($407866112e362b76$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $407866112e362b76$var$workInProgressRootRecoverableErrors;
                            $407866112e362b76$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $407866112e362b76$var$workInProgressRootRecoverableErrors ? $407866112e362b76$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $407866112e362b76$var$workInProgressRootRecoverableErrors.push.apply($407866112e362b76$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $407866112e362b76$var$prepareFreshStack(root$jscomp$0, 0);
                $407866112e362b76$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($407866112e362b76$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $407866112e362b76$var$markRootSuspended(shouldTimeSlice, lanes, $407866112e362b76$var$workInProgressDeferredLane, !$407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $407866112e362b76$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($407866112e362b76$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $407866112e362b76$var$globalMostRecentFallbackTime + 300 - $407866112e362b76$var$now(), 10 < exitStatus)) {
                    $407866112e362b76$var$markRootSuspended(shouldTimeSlice, lanes, $407866112e362b76$var$workInProgressDeferredLane, !$407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $407866112e362b76$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $407866112e362b76$var$scheduleTimeout($407866112e362b76$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $407866112e362b76$var$workInProgressRootRecoverableErrors, $407866112e362b76$var$workInProgressTransitions, $407866112e362b76$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $407866112e362b76$var$workInProgressDeferredLane, $407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes, $407866112e362b76$var$workInProgressSuspendedRetryLanes, $407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $407866112e362b76$var$commitRootWhenReady(shouldTimeSlice, forceSync, $407866112e362b76$var$workInProgressRootRecoverableErrors, $407866112e362b76$var$workInProgressTransitions, $407866112e362b76$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $407866112e362b76$var$workInProgressDeferredLane, $407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes, $407866112e362b76$var$workInProgressSuspendedRetryLanes, $407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $407866112e362b76$var$ensureRootIsScheduled(root$jscomp$0);
}
function $407866112e362b76$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($407866112e362b76$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $407866112e362b76$var$noop
        }, $407866112e362b76$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $407866112e362b76$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($407866112e362b76$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $407866112e362b76$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $407866112e362b76$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $407866112e362b76$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$407866112e362b76$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $407866112e362b76$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$407866112e362b76$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $407866112e362b76$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $407866112e362b76$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $407866112e362b76$var$flushSyncWork$1() {
    return 0 === ($407866112e362b76$var$executionContext & 6) ? ($407866112e362b76$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $407866112e362b76$var$resetWorkInProgressStack() {
    if (null !== $407866112e362b76$var$workInProgress) {
        if (0 === $407866112e362b76$var$workInProgressSuspendedReason) var interruptedWork = $407866112e362b76$var$workInProgress.return;
        else interruptedWork = $407866112e362b76$var$workInProgress, $407866112e362b76$var$lastContextDependency = $407866112e362b76$var$currentlyRenderingFiber$1 = null, $407866112e362b76$var$resetHooksOnUnwind(interruptedWork), $407866112e362b76$var$thenableState = null, $407866112e362b76$var$thenableIndexCounter = 0, interruptedWork = $407866112e362b76$var$workInProgress;
        for(; null !== interruptedWork;)$407866112e362b76$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $407866112e362b76$var$workInProgress = null;
    }
}
function $407866112e362b76$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $407866112e362b76$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $407866112e362b76$var$resetWorkInProgressStack();
    $407866112e362b76$var$workInProgressRoot = root;
    $407866112e362b76$var$workInProgress = timeoutHandle = $407866112e362b76$var$createWorkInProgress(root.current, null);
    $407866112e362b76$var$workInProgressRootRenderLanes = lanes;
    $407866112e362b76$var$workInProgressSuspendedReason = 0;
    $407866112e362b76$var$workInProgressThrownValue = null;
    $407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $407866112e362b76$var$workInProgressRootIsPrerendering = $407866112e362b76$var$checkIfRootIsPrerendering(root, lanes);
    $407866112e362b76$var$workInProgressRootDidAttachPingListener = !1;
    $407866112e362b76$var$workInProgressSuspendedRetryLanes = $407866112e362b76$var$workInProgressDeferredLane = $407866112e362b76$var$workInProgressRootPingedLanes = $407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes = $407866112e362b76$var$workInProgressRootSkippedLanes = $407866112e362b76$var$workInProgressRootExitStatus = 0;
    $407866112e362b76$var$workInProgressRootRecoverableErrors = $407866112e362b76$var$workInProgressRootConcurrentErrors = null;
    $407866112e362b76$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $407866112e362b76$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $407866112e362b76$var$entangledRenderLanes = lanes;
    $407866112e362b76$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $407866112e362b76$var$handleThrow(root, thrownValue) {
    $407866112e362b76$var$currentlyRenderingFiber = null;
    $407866112e362b76$var$ReactSharedInternals.H = $407866112e362b76$var$ContextOnlyDispatcher;
    thrownValue === $407866112e362b76$var$SuspenseException || thrownValue === $407866112e362b76$var$SuspenseActionException ? (thrownValue = $407866112e362b76$var$getSuspendedThenable(), $407866112e362b76$var$workInProgressSuspendedReason = 3) : thrownValue === $407866112e362b76$var$SuspenseyCommitException ? (thrownValue = $407866112e362b76$var$getSuspendedThenable(), $407866112e362b76$var$workInProgressSuspendedReason = 4) : $407866112e362b76$var$workInProgressSuspendedReason = thrownValue === $407866112e362b76$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $407866112e362b76$var$workInProgressThrownValue = thrownValue;
    null === $407866112e362b76$var$workInProgress && ($407866112e362b76$var$workInProgressRootExitStatus = 1, $407866112e362b76$var$logUncaughtError(root, $407866112e362b76$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $407866112e362b76$var$pushDispatcher() {
    var prevDispatcher = $407866112e362b76$var$ReactSharedInternals.H;
    $407866112e362b76$var$ReactSharedInternals.H = $407866112e362b76$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $407866112e362b76$var$ContextOnlyDispatcher : prevDispatcher;
}
function $407866112e362b76$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $407866112e362b76$var$ReactSharedInternals.A;
    $407866112e362b76$var$ReactSharedInternals.A = $407866112e362b76$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $407866112e362b76$var$renderDidSuspendDelayIfPossible() {
    $407866112e362b76$var$workInProgressRootExitStatus = 4;
    $407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings || ($407866112e362b76$var$workInProgressRootRenderLanes & 4194048) !== $407866112e362b76$var$workInProgressRootRenderLanes && null !== $407866112e362b76$var$suspenseHandlerStackCursor.current || ($407866112e362b76$var$workInProgressRootIsPrerendering = !0);
    0 === ($407866112e362b76$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $407866112e362b76$var$workInProgressRoot || $407866112e362b76$var$markRootSuspended($407866112e362b76$var$workInProgressRoot, $407866112e362b76$var$workInProgressRootRenderLanes, $407866112e362b76$var$workInProgressDeferredLane, !1);
}
function $407866112e362b76$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $407866112e362b76$var$executionContext;
    $407866112e362b76$var$executionContext |= 2;
    var prevDispatcher = $407866112e362b76$var$pushDispatcher(), prevAsyncDispatcher = $407866112e362b76$var$pushAsyncDispatcher();
    if ($407866112e362b76$var$workInProgressRoot !== root || $407866112e362b76$var$workInProgressRootRenderLanes !== lanes) $407866112e362b76$var$workInProgressTransitions = null, $407866112e362b76$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $407866112e362b76$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $407866112e362b76$var$workInProgressSuspendedReason && null !== $407866112e362b76$var$workInProgress) {
            var unitOfWork = $407866112e362b76$var$workInProgress, thrownValue = $407866112e362b76$var$workInProgressThrownValue;
            switch($407866112e362b76$var$workInProgressSuspendedReason){
                case 8:
                    $407866112e362b76$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $407866112e362b76$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $407866112e362b76$var$workInProgressSuspendedReason;
                    $407866112e362b76$var$workInProgressSuspendedReason = 0;
                    $407866112e362b76$var$workInProgressThrownValue = null;
                    $407866112e362b76$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $407866112e362b76$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $407866112e362b76$var$workInProgressSuspendedReason, $407866112e362b76$var$workInProgressSuspendedReason = 0, $407866112e362b76$var$workInProgressThrownValue = null, $407866112e362b76$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $407866112e362b76$var$workLoopSync();
        exitStatus = $407866112e362b76$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $407866112e362b76$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $407866112e362b76$var$lastContextDependency = $407866112e362b76$var$currentlyRenderingFiber$1 = null;
    $407866112e362b76$var$executionContext = prevExecutionContext;
    $407866112e362b76$var$ReactSharedInternals.H = prevDispatcher;
    $407866112e362b76$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $407866112e362b76$var$workInProgress && ($407866112e362b76$var$workInProgressRoot = null, $407866112e362b76$var$workInProgressRootRenderLanes = 0, $407866112e362b76$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $407866112e362b76$var$workLoopSync() {
    for(; null !== $407866112e362b76$var$workInProgress;)$407866112e362b76$var$performUnitOfWork($407866112e362b76$var$workInProgress);
}
function $407866112e362b76$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $407866112e362b76$var$executionContext;
    $407866112e362b76$var$executionContext |= 2;
    var prevDispatcher = $407866112e362b76$var$pushDispatcher(), prevAsyncDispatcher = $407866112e362b76$var$pushAsyncDispatcher();
    $407866112e362b76$var$workInProgressRoot !== root || $407866112e362b76$var$workInProgressRootRenderLanes !== lanes ? ($407866112e362b76$var$workInProgressTransitions = null, $407866112e362b76$var$workInProgressRootRenderTargetTime = $407866112e362b76$var$now() + 500, $407866112e362b76$var$prepareFreshStack(root, lanes)) : $407866112e362b76$var$workInProgressRootIsPrerendering = $407866112e362b76$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $407866112e362b76$var$workInProgressSuspendedReason && null !== $407866112e362b76$var$workInProgress) {
            lanes = $407866112e362b76$var$workInProgress;
            var thrownValue = $407866112e362b76$var$workInProgressThrownValue;
            b: switch($407866112e362b76$var$workInProgressSuspendedReason){
                case 1:
                    $407866112e362b76$var$workInProgressSuspendedReason = 0;
                    $407866112e362b76$var$workInProgressThrownValue = null;
                    $407866112e362b76$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($407866112e362b76$var$isThenableResolved(thrownValue)) {
                        $407866112e362b76$var$workInProgressSuspendedReason = 0;
                        $407866112e362b76$var$workInProgressThrownValue = null;
                        $407866112e362b76$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $407866112e362b76$var$workInProgressSuspendedReason && 9 !== $407866112e362b76$var$workInProgressSuspendedReason || $407866112e362b76$var$workInProgressRoot !== root || ($407866112e362b76$var$workInProgressSuspendedReason = 7);
                        $407866112e362b76$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $407866112e362b76$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $407866112e362b76$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $407866112e362b76$var$isThenableResolved(thrownValue) ? ($407866112e362b76$var$workInProgressSuspendedReason = 0, $407866112e362b76$var$workInProgressThrownValue = null, $407866112e362b76$var$replaySuspendedUnitOfWork(lanes)) : ($407866112e362b76$var$workInProgressSuspendedReason = 0, $407866112e362b76$var$workInProgressThrownValue = null, $407866112e362b76$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($407866112e362b76$var$workInProgress.tag){
                        case 26:
                            resource = $407866112e362b76$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $407866112e362b76$var$workInProgress;
                            if (resource ? $407866112e362b76$var$preloadResource(resource) : 1) {
                                $407866112e362b76$var$workInProgressSuspendedReason = 0;
                                $407866112e362b76$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $407866112e362b76$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($407866112e362b76$var$workInProgress = returnFiber, $407866112e362b76$var$completeUnitOfWork(returnFiber)) : $407866112e362b76$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $407866112e362b76$var$workInProgressSuspendedReason = 0;
                    $407866112e362b76$var$workInProgressThrownValue = null;
                    $407866112e362b76$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $407866112e362b76$var$workInProgressSuspendedReason = 0;
                    $407866112e362b76$var$workInProgressThrownValue = null;
                    $407866112e362b76$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $407866112e362b76$var$resetWorkInProgressStack();
                    $407866112e362b76$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($407866112e362b76$var$formatProdErrorMessage(462));
            }
        }
        $407866112e362b76$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $407866112e362b76$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $407866112e362b76$var$lastContextDependency = $407866112e362b76$var$currentlyRenderingFiber$1 = null;
    $407866112e362b76$var$ReactSharedInternals.H = prevDispatcher;
    $407866112e362b76$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $407866112e362b76$var$executionContext = prevExecutionContext;
    if (null !== $407866112e362b76$var$workInProgress) return 0;
    $407866112e362b76$var$workInProgressRoot = null;
    $407866112e362b76$var$workInProgressRootRenderLanes = 0;
    $407866112e362b76$var$finishQueueingConcurrentUpdates();
    return $407866112e362b76$var$workInProgressRootExitStatus;
}
function $407866112e362b76$var$workLoopConcurrentByScheduler() {
    for(; null !== $407866112e362b76$var$workInProgress && !$407866112e362b76$var$shouldYield();)$407866112e362b76$var$performUnitOfWork($407866112e362b76$var$workInProgress);
}
function $407866112e362b76$var$performUnitOfWork(unitOfWork) {
    var next = $407866112e362b76$var$beginWork(unitOfWork.alternate, unitOfWork, $407866112e362b76$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $407866112e362b76$var$completeUnitOfWork(unitOfWork) : $407866112e362b76$var$workInProgress = next;
}
function $407866112e362b76$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $407866112e362b76$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $407866112e362b76$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $407866112e362b76$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $407866112e362b76$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $407866112e362b76$var$resetHooksOnUnwind(next);
        default:
            $407866112e362b76$var$unwindInterruptedWork(current, next), next = $407866112e362b76$var$workInProgress = $407866112e362b76$var$resetWorkInProgress(next, $407866112e362b76$var$entangledRenderLanes), next = $407866112e362b76$var$beginWork(current, next, $407866112e362b76$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $407866112e362b76$var$completeUnitOfWork(unitOfWork) : $407866112e362b76$var$workInProgress = next;
}
function $407866112e362b76$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $407866112e362b76$var$lastContextDependency = $407866112e362b76$var$currentlyRenderingFiber$1 = null;
    $407866112e362b76$var$resetHooksOnUnwind(unitOfWork);
    $407866112e362b76$var$thenableState = null;
    $407866112e362b76$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($407866112e362b76$var$throwException(root, returnFiber, unitOfWork, thrownValue, $407866112e362b76$var$workInProgressRootRenderLanes)) {
            $407866112e362b76$var$workInProgressRootExitStatus = 1;
            $407866112e362b76$var$logUncaughtError(root, $407866112e362b76$var$createCapturedValueAtFiber(thrownValue, root.current));
            $407866112e362b76$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $407866112e362b76$var$workInProgress = returnFiber, error;
        $407866112e362b76$var$workInProgressRootExitStatus = 1;
        $407866112e362b76$var$logUncaughtError(root, $407866112e362b76$var$createCapturedValueAtFiber(thrownValue, root.current));
        $407866112e362b76$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($407866112e362b76$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($407866112e362b76$var$workInProgressRootIsPrerendering || 0 !== ($407866112e362b76$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $407866112e362b76$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $407866112e362b76$var$unwindUnitOfWork(unitOfWork, root);
    } else $407866112e362b76$var$completeUnitOfWork(unitOfWork);
}
function $407866112e362b76$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $407866112e362b76$var$unwindUnitOfWork(completedWork, $407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $407866112e362b76$var$completeWork(completedWork.alternate, completedWork, $407866112e362b76$var$entangledRenderLanes);
        if (null !== next) {
            $407866112e362b76$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $407866112e362b76$var$workInProgress = completedWork;
            return;
        }
        $407866112e362b76$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $407866112e362b76$var$workInProgressRootExitStatus && ($407866112e362b76$var$workInProgressRootExitStatus = 5);
}
function $407866112e362b76$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $407866112e362b76$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $407866112e362b76$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $407866112e362b76$var$workInProgress = unitOfWork;
            return;
        }
        $407866112e362b76$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $407866112e362b76$var$workInProgressRootExitStatus = 6;
    $407866112e362b76$var$workInProgress = null;
}
function $407866112e362b76$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $407866112e362b76$var$flushPendingEffects();
    while (0 !== $407866112e362b76$var$pendingEffectsStatus);
    if (0 !== ($407866112e362b76$var$executionContext & 6)) throw Error($407866112e362b76$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($407866112e362b76$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $407866112e362b76$var$concurrentlyUpdatedLanes;
        $407866112e362b76$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $407866112e362b76$var$workInProgressRoot && ($407866112e362b76$var$workInProgress = $407866112e362b76$var$workInProgressRoot = null, $407866112e362b76$var$workInProgressRootRenderLanes = 0);
        $407866112e362b76$var$pendingFinishedWork = finishedWork;
        $407866112e362b76$var$pendingEffectsRoot = root;
        $407866112e362b76$var$pendingEffectsLanes = lanes;
        $407866112e362b76$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $407866112e362b76$var$pendingPassiveTransitions = transitions;
        $407866112e362b76$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $407866112e362b76$var$scheduleCallback$1($407866112e362b76$var$NormalPriority$1, function() {
            $407866112e362b76$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $407866112e362b76$var$ReactSharedInternals.T;
            $407866112e362b76$var$ReactSharedInternals.T = null;
            transitions = $407866112e362b76$var$ReactDOMSharedInternals.p;
            $407866112e362b76$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $407866112e362b76$var$executionContext;
            $407866112e362b76$var$executionContext |= 4;
            try {
                $407866112e362b76$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $407866112e362b76$var$executionContext = spawnedLane, $407866112e362b76$var$ReactDOMSharedInternals.p = transitions, $407866112e362b76$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $407866112e362b76$var$pendingEffectsStatus = 1;
        $407866112e362b76$var$flushMutationEffects();
        $407866112e362b76$var$flushLayoutEffects();
        $407866112e362b76$var$flushSpawnedWork();
    }
}
function $407866112e362b76$var$flushMutationEffects() {
    if (1 === $407866112e362b76$var$pendingEffectsStatus) {
        $407866112e362b76$var$pendingEffectsStatus = 0;
        var root = $407866112e362b76$var$pendingEffectsRoot, finishedWork = $407866112e362b76$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $407866112e362b76$var$ReactSharedInternals.T;
            $407866112e362b76$var$ReactSharedInternals.T = null;
            var previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
            $407866112e362b76$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $407866112e362b76$var$executionContext;
            $407866112e362b76$var$executionContext |= 4;
            try {
                $407866112e362b76$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $407866112e362b76$var$selectionInformation, curFocusedElem = $407866112e362b76$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $407866112e362b76$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $407866112e362b76$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $407866112e362b76$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $407866112e362b76$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $407866112e362b76$var$_enabled = !!$407866112e362b76$var$eventsEnabled;
                $407866112e362b76$var$selectionInformation = $407866112e362b76$var$eventsEnabled = null;
            } finally{
                $407866112e362b76$var$executionContext = prevExecutionContext, $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority, $407866112e362b76$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $407866112e362b76$var$pendingEffectsStatus = 2;
    }
}
function $407866112e362b76$var$flushLayoutEffects() {
    if (2 === $407866112e362b76$var$pendingEffectsStatus) {
        $407866112e362b76$var$pendingEffectsStatus = 0;
        var root = $407866112e362b76$var$pendingEffectsRoot, finishedWork = $407866112e362b76$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $407866112e362b76$var$ReactSharedInternals.T;
            $407866112e362b76$var$ReactSharedInternals.T = null;
            var previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
            $407866112e362b76$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $407866112e362b76$var$executionContext;
            $407866112e362b76$var$executionContext |= 4;
            try {
                $407866112e362b76$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $407866112e362b76$var$executionContext = prevExecutionContext, $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority, $407866112e362b76$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $407866112e362b76$var$pendingEffectsStatus = 3;
    }
}
function $407866112e362b76$var$flushSpawnedWork() {
    if (4 === $407866112e362b76$var$pendingEffectsStatus || 3 === $407866112e362b76$var$pendingEffectsStatus) {
        $407866112e362b76$var$pendingEffectsStatus = 0;
        $407866112e362b76$var$requestPaint();
        var root = $407866112e362b76$var$pendingEffectsRoot, finishedWork = $407866112e362b76$var$pendingFinishedWork, lanes = $407866112e362b76$var$pendingEffectsLanes, recoverableErrors = $407866112e362b76$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $407866112e362b76$var$pendingEffectsStatus = 5 : ($407866112e362b76$var$pendingEffectsStatus = 0, $407866112e362b76$var$pendingFinishedWork = $407866112e362b76$var$pendingEffectsRoot = null, $407866112e362b76$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $407866112e362b76$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($407866112e362b76$var$injectedHook && "function" === typeof $407866112e362b76$var$injectedHook.onCommitFiberRoot) try {
            $407866112e362b76$var$injectedHook.onCommitFiberRoot($407866112e362b76$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $407866112e362b76$var$ReactSharedInternals.T;
            remainingLanes = $407866112e362b76$var$ReactDOMSharedInternals.p;
            $407866112e362b76$var$ReactDOMSharedInternals.p = 2;
            $407866112e362b76$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $407866112e362b76$var$ReactSharedInternals.T = finishedWork, $407866112e362b76$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($407866112e362b76$var$pendingEffectsLanes & 3) && $407866112e362b76$var$flushPendingEffects();
        $407866112e362b76$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $407866112e362b76$var$rootWithNestedUpdates ? $407866112e362b76$var$nestedUpdateCount++ : ($407866112e362b76$var$nestedUpdateCount = 0, $407866112e362b76$var$rootWithNestedUpdates = root) : $407866112e362b76$var$nestedUpdateCount = 0;
        $407866112e362b76$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $407866112e362b76$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $407866112e362b76$var$releaseCache(remainingLanes)));
}
function $407866112e362b76$var$flushPendingEffects(wasDelayedCommit) {
    $407866112e362b76$var$flushMutationEffects();
    $407866112e362b76$var$flushLayoutEffects();
    $407866112e362b76$var$flushSpawnedWork();
    return $407866112e362b76$var$flushPassiveEffects(wasDelayedCommit);
}
function $407866112e362b76$var$flushPassiveEffects() {
    if (5 !== $407866112e362b76$var$pendingEffectsStatus) return !1;
    var root = $407866112e362b76$var$pendingEffectsRoot, remainingLanes = $407866112e362b76$var$pendingEffectsRemainingLanes;
    $407866112e362b76$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $407866112e362b76$var$lanesToEventPriority($407866112e362b76$var$pendingEffectsLanes), prevTransition = $407866112e362b76$var$ReactSharedInternals.T, previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
    try {
        $407866112e362b76$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $407866112e362b76$var$ReactSharedInternals.T = null;
        renderPriority = $407866112e362b76$var$pendingPassiveTransitions;
        $407866112e362b76$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $407866112e362b76$var$pendingEffectsRoot, lanes = $407866112e362b76$var$pendingEffectsLanes;
        $407866112e362b76$var$pendingEffectsStatus = 0;
        $407866112e362b76$var$pendingFinishedWork = $407866112e362b76$var$pendingEffectsRoot = null;
        $407866112e362b76$var$pendingEffectsLanes = 0;
        if (0 !== ($407866112e362b76$var$executionContext & 6)) throw Error($407866112e362b76$var$formatProdErrorMessage(331));
        var prevExecutionContext = $407866112e362b76$var$executionContext;
        $407866112e362b76$var$executionContext |= 4;
        $407866112e362b76$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $407866112e362b76$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $407866112e362b76$var$executionContext = prevExecutionContext;
        $407866112e362b76$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($407866112e362b76$var$injectedHook && "function" === typeof $407866112e362b76$var$injectedHook.onPostCommitFiberRoot) try {
            $407866112e362b76$var$injectedHook.onPostCommitFiberRoot($407866112e362b76$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority, $407866112e362b76$var$ReactSharedInternals.T = prevTransition, $407866112e362b76$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $407866112e362b76$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $407866112e362b76$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $407866112e362b76$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $407866112e362b76$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($407866112e362b76$var$markRootUpdated$1(rootFiber, 2), $407866112e362b76$var$ensureRootIsScheduled(rootFiber));
}
function $407866112e362b76$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $407866112e362b76$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $407866112e362b76$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed || !$407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $407866112e362b76$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $407866112e362b76$var$createClassErrorUpdate(2);
                instance = $407866112e362b76$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($407866112e362b76$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $407866112e362b76$var$markRootUpdated$1(instance, 2), $407866112e362b76$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $407866112e362b76$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $407866112e362b76$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($407866112e362b76$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $407866112e362b76$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $407866112e362b76$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $407866112e362b76$var$workInProgressRoot === root && ($407866112e362b76$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $407866112e362b76$var$workInProgressRootExitStatus || 3 === $407866112e362b76$var$workInProgressRootExitStatus && ($407866112e362b76$var$workInProgressRootRenderLanes & 62914560) === $407866112e362b76$var$workInProgressRootRenderLanes && 300 > $407866112e362b76$var$now() - $407866112e362b76$var$globalMostRecentFallbackTime ? 0 === ($407866112e362b76$var$executionContext & 2) && $407866112e362b76$var$prepareFreshStack(root, 0) : $407866112e362b76$var$workInProgressRootPingedLanes |= pingedLanes, $407866112e362b76$var$workInProgressSuspendedRetryLanes === $407866112e362b76$var$workInProgressRootRenderLanes && ($407866112e362b76$var$workInProgressSuspendedRetryLanes = 0));
    $407866112e362b76$var$ensureRootIsScheduled(root);
}
function $407866112e362b76$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $407866112e362b76$var$claimNextRetryLane());
    boundaryFiber = $407866112e362b76$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($407866112e362b76$var$markRootUpdated$1(boundaryFiber, retryLane), $407866112e362b76$var$ensureRootIsScheduled(boundaryFiber));
}
function $407866112e362b76$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $407866112e362b76$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $407866112e362b76$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($407866112e362b76$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $407866112e362b76$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $407866112e362b76$var$scheduleCallback$1(priorityLevel, callback) {
    return $407866112e362b76$var$scheduleCallback$3(priorityLevel, callback);
}
var $407866112e362b76$var$firstScheduledRoot = null, $407866112e362b76$var$lastScheduledRoot = null, $407866112e362b76$var$didScheduleMicrotask = !1, $407866112e362b76$var$mightHavePendingSyncWork = !1, $407866112e362b76$var$isFlushingWork = !1, $407866112e362b76$var$currentEventTransitionLane = 0;
function $407866112e362b76$var$ensureRootIsScheduled(root) {
    root !== $407866112e362b76$var$lastScheduledRoot && null === root.next && (null === $407866112e362b76$var$lastScheduledRoot ? $407866112e362b76$var$firstScheduledRoot = $407866112e362b76$var$lastScheduledRoot = root : $407866112e362b76$var$lastScheduledRoot = $407866112e362b76$var$lastScheduledRoot.next = root);
    $407866112e362b76$var$mightHavePendingSyncWork = !0;
    $407866112e362b76$var$didScheduleMicrotask || ($407866112e362b76$var$didScheduleMicrotask = !0, $407866112e362b76$var$scheduleImmediateRootScheduleTask());
}
function $407866112e362b76$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$407866112e362b76$var$isFlushingWork && $407866112e362b76$var$mightHavePendingSyncWork) {
        $407866112e362b76$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $407866112e362b76$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $407866112e362b76$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $407866112e362b76$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $407866112e362b76$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $407866112e362b76$var$getNextLanes(root$174, root$174 === $407866112e362b76$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $407866112e362b76$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $407866112e362b76$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $407866112e362b76$var$isFlushingWork = !1;
    }
}
function $407866112e362b76$var$processRootScheduleInImmediateTask() {
    $407866112e362b76$var$processRootScheduleInMicrotask();
}
function $407866112e362b76$var$processRootScheduleInMicrotask() {
    $407866112e362b76$var$mightHavePendingSyncWork = $407866112e362b76$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $407866112e362b76$var$currentEventTransitionLane && ($407866112e362b76$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $407866112e362b76$var$currentEventTransitionLane), $407866112e362b76$var$currentEventTransitionLane = 0);
    for(var currentTime = $407866112e362b76$var$now(), prev = null, root = $407866112e362b76$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $407866112e362b76$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $407866112e362b76$var$firstScheduledRoot = next : prev.next = next, null === next && ($407866112e362b76$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $407866112e362b76$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $407866112e362b76$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $407866112e362b76$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $407866112e362b76$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $407866112e362b76$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $407866112e362b76$var$workInProgressRoot;
    suspendedLanes = $407866112e362b76$var$workInProgressRootRenderLanes;
    suspendedLanes = $407866112e362b76$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $407866112e362b76$var$workInProgressSuspendedReason || 9 === $407866112e362b76$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $407866112e362b76$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $407866112e362b76$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $407866112e362b76$var$cancelCallback$1(pingedLanes);
        switch($407866112e362b76$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $407866112e362b76$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $407866112e362b76$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $407866112e362b76$var$IdlePriority;
                break;
            default:
                suspendedLanes = $407866112e362b76$var$NormalPriority$1;
        }
        pingedLanes = $407866112e362b76$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $407866112e362b76$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $407866112e362b76$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $407866112e362b76$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $407866112e362b76$var$pendingEffectsStatus && 5 !== $407866112e362b76$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($407866112e362b76$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $407866112e362b76$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $407866112e362b76$var$getNextLanes(root, root === $407866112e362b76$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $407866112e362b76$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $407866112e362b76$var$scheduleTaskForRootDuringMicrotask(root, $407866112e362b76$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $407866112e362b76$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $407866112e362b76$var$performSyncWorkOnRoot(root, lanes) {
    if ($407866112e362b76$var$flushPendingEffects()) return null;
    $407866112e362b76$var$performWorkOnRoot(root, lanes, !0);
}
function $407866112e362b76$var$scheduleImmediateRootScheduleTask() {
    $407866112e362b76$var$scheduleMicrotask(function() {
        0 !== ($407866112e362b76$var$executionContext & 6) ? $407866112e362b76$var$scheduleCallback$3($407866112e362b76$var$ImmediatePriority, $407866112e362b76$var$processRootScheduleInImmediateTask) : $407866112e362b76$var$processRootScheduleInMicrotask();
    });
}
function $407866112e362b76$var$requestTransitionLane() {
    0 === $407866112e362b76$var$currentEventTransitionLane && ($407866112e362b76$var$currentEventTransitionLane = $407866112e362b76$var$claimNextTransitionLane());
    return $407866112e362b76$var$currentEventTransitionLane;
}
function $407866112e362b76$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $407866112e362b76$var$sanitizeURL("" + actionProp);
}
function $407866112e362b76$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $407866112e362b76$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $407866112e362b76$var$coerceFormActionProp((nativeEventTarget[$407866112e362b76$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$407866112e362b76$var$internalPropsKey] || null) ? $407866112e362b76$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $407866112e362b76$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $407866112e362b76$var$currentEventTransitionLane) {
                                var formData = submitter ? $407866112e362b76$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $407866112e362b76$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $407866112e362b76$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $407866112e362b76$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $407866112e362b76$var$i$jscomp$inline_1528 = 0; $407866112e362b76$var$i$jscomp$inline_1528 < $407866112e362b76$var$simpleEventPluginEvents.length; $407866112e362b76$var$i$jscomp$inline_1528++){
    var $407866112e362b76$var$eventName$jscomp$inline_1529 = $407866112e362b76$var$simpleEventPluginEvents[$407866112e362b76$var$i$jscomp$inline_1528], $407866112e362b76$var$domEventName$jscomp$inline_1530 = $407866112e362b76$var$eventName$jscomp$inline_1529.toLowerCase(), $407866112e362b76$var$capitalizedEvent$jscomp$inline_1531 = $407866112e362b76$var$eventName$jscomp$inline_1529[0].toUpperCase() + $407866112e362b76$var$eventName$jscomp$inline_1529.slice(1);
    $407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$domEventName$jscomp$inline_1530, "on" + $407866112e362b76$var$capitalizedEvent$jscomp$inline_1531);
}
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$ANIMATION_END, "onAnimationEnd");
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$ANIMATION_ITERATION, "onAnimationIteration");
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$ANIMATION_START, "onAnimationStart");
$407866112e362b76$var$registerSimpleEvent("dblclick", "onDoubleClick");
$407866112e362b76$var$registerSimpleEvent("focusin", "onFocus");
$407866112e362b76$var$registerSimpleEvent("focusout", "onBlur");
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$TRANSITION_RUN, "onTransitionRun");
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$TRANSITION_START, "onTransitionStart");
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$TRANSITION_CANCEL, "onTransitionCancel");
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$TRANSITION_END, "onTransitionEnd");
$407866112e362b76$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$407866112e362b76$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$407866112e362b76$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$407866112e362b76$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$407866112e362b76$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$407866112e362b76$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$407866112e362b76$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$407866112e362b76$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$407866112e362b76$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$407866112e362b76$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $407866112e362b76$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $407866112e362b76$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($407866112e362b76$var$mediaEventTypes));
function $407866112e362b76$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $407866112e362b76$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $407866112e362b76$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $407866112e362b76$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$407866112e362b76$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$407866112e362b76$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($407866112e362b76$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $407866112e362b76$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $407866112e362b76$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $407866112e362b76$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $407866112e362b76$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$407866112e362b76$var$listeningMarker]) {
        rootContainerElement[$407866112e362b76$var$listeningMarker] = !0;
        $407866112e362b76$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($407866112e362b76$var$nonDelegatedEvents.has(domEventName) || $407866112e362b76$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $407866112e362b76$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$407866112e362b76$var$listeningMarker] || (ownerDocument[$407866112e362b76$var$listeningMarker] = !0, $407866112e362b76$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $407866112e362b76$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($407866112e362b76$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $407866112e362b76$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $407866112e362b76$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $407866112e362b76$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$407866112e362b76$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $407866112e362b76$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $407866112e362b76$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $407866112e362b76$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $407866112e362b76$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $407866112e362b76$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $407866112e362b76$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $407866112e362b76$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticTouchEvent;
                        break;
                    case $407866112e362b76$var$ANIMATION_END:
                    case $407866112e362b76$var$ANIMATION_ITERATION:
                    case $407866112e362b76$var$ANIMATION_START:
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticAnimationEvent;
                        break;
                    case $407866112e362b76$var$TRANSITION_END:
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $407866112e362b76$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($407866112e362b76$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $407866112e362b76$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($407866112e362b76$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$407866112e362b76$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $407866112e362b76$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $407866112e362b76$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $407866112e362b76$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $407866112e362b76$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $407866112e362b76$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $407866112e362b76$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $407866112e362b76$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $407866112e362b76$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $407866112e362b76$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $407866112e362b76$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $407866112e362b76$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $407866112e362b76$var$getParent(inCapturePhase);
                                reactEventName = $407866112e362b76$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $407866112e362b76$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $407866112e362b76$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $407866112e362b76$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $407866112e362b76$var$getTargetInstForChangeEvent;
                else if ($407866112e362b76$var$isTextInputElement(reactName)) {
                    if ($407866112e362b76$var$isInputEventSupported) getTargetInstFunc = $407866112e362b76$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $407866112e362b76$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $407866112e362b76$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $407866112e362b76$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $407866112e362b76$var$getTargetInstForChangeEvent) : getTargetInstFunc = $407866112e362b76$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $407866112e362b76$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $407866112e362b76$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $407866112e362b76$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($407866112e362b76$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $407866112e362b76$var$activeElement = handleEventFunc, $407866112e362b76$var$activeElementInst = targetInst, $407866112e362b76$var$lastSelection = null;
                    break;
                case "focusout":
                    $407866112e362b76$var$lastSelection = $407866112e362b76$var$activeElementInst = $407866112e362b76$var$activeElement = null;
                    break;
                case "mousedown":
                    $407866112e362b76$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $407866112e362b76$var$mouseDown = !1;
                    $407866112e362b76$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($407866112e362b76$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $407866112e362b76$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($407866112e362b76$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $407866112e362b76$var$isComposing ? $407866112e362b76$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($407866112e362b76$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($407866112e362b76$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $407866112e362b76$var$isComposing && (fallbackData = $407866112e362b76$var$getData()) : ($407866112e362b76$var$root = nativeEventTarget, $407866112e362b76$var$startText = "value" in $407866112e362b76$var$root ? $407866112e362b76$var$root.value : $407866112e362b76$var$root.textContent, $407866112e362b76$var$isComposing = !0)), handleEventFunc = $407866112e362b76$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $407866112e362b76$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $407866112e362b76$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $407866112e362b76$var$canUseTextInputEvent ? $407866112e362b76$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $407866112e362b76$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $407866112e362b76$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $407866112e362b76$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $407866112e362b76$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $407866112e362b76$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $407866112e362b76$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $407866112e362b76$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $407866112e362b76$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($407866112e362b76$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $407866112e362b76$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($407866112e362b76$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $407866112e362b76$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $407866112e362b76$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $407866112e362b76$var$getListener(target, registrationName), null != stateNode && listeners.unshift($407866112e362b76$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $407866112e362b76$var$getListener(target, registrationName), null != stateNode && listeners.push($407866112e362b76$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $407866112e362b76$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $407866112e362b76$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $407866112e362b76$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($407866112e362b76$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($407866112e362b76$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $407866112e362b76$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $407866112e362b76$var$normalizeMarkupForTextOrAttribute(clientText);
    return $407866112e362b76$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $407866112e362b76$var$noop$1() {}
function $407866112e362b76$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $407866112e362b76$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $407866112e362b76$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $407866112e362b76$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $407866112e362b76$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $407866112e362b76$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $407866112e362b76$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $407866112e362b76$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $407866112e362b76$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $407866112e362b76$var$setProp(domElement, tag, "name", props.name, props, null), $407866112e362b76$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $407866112e362b76$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $407866112e362b76$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($407866112e362b76$var$setProp(domElement, tag, "encType", props.encType, props, null), $407866112e362b76$var$setProp(domElement, tag, "method", props.method, props, null), $407866112e362b76$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $407866112e362b76$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $407866112e362b76$var$noop$1);
            break;
        case "onScroll":
            null != value && $407866112e362b76$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $407866112e362b76$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($407866112e362b76$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($407866112e362b76$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $407866112e362b76$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $407866112e362b76$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $407866112e362b76$var$listenToNonDelegatedEvent("toggle", domElement);
            $407866112e362b76$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $407866112e362b76$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $407866112e362b76$var$aliases.get(key) || key, $407866112e362b76$var$setValueForAttribute(domElement, key, value);
    }
}
function $407866112e362b76$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $407866112e362b76$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($407866112e362b76$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($407866112e362b76$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $407866112e362b76$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $407866112e362b76$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $407866112e362b76$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $407866112e362b76$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $407866112e362b76$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$407866112e362b76$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$407866112e362b76$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $407866112e362b76$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $407866112e362b76$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $407866112e362b76$var$listenToNonDelegatedEvent("error", domElement);
            $407866112e362b76$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($407866112e362b76$var$formatProdErrorMessage(137, tag));
                    default:
                        $407866112e362b76$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $407866112e362b76$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $407866112e362b76$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $407866112e362b76$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($407866112e362b76$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $407866112e362b76$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $407866112e362b76$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $407866112e362b76$var$track(domElement);
            return;
        case "select":
            $407866112e362b76$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $407866112e362b76$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $407866112e362b76$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $407866112e362b76$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($407866112e362b76$var$formatProdErrorMessage(91));
                    break;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $407866112e362b76$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $407866112e362b76$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $407866112e362b76$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $407866112e362b76$var$listenToNonDelegatedEvent("toggle", domElement);
            $407866112e362b76$var$listenToNonDelegatedEvent("cancel", domElement);
            $407866112e362b76$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $407866112e362b76$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $407866112e362b76$var$mediaEventTypes.length; hasSrc++)$407866112e362b76$var$listenToNonDelegatedEvent($407866112e362b76$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $407866112e362b76$var$listenToNonDelegatedEvent("error", domElement);
            $407866112e362b76$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $407866112e362b76$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $407866112e362b76$var$listenToNonDelegatedEvent("error", domElement), $407866112e362b76$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($407866112e362b76$var$formatProdErrorMessage(137, tag));
                default:
                    $407866112e362b76$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($407866112e362b76$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $407866112e362b76$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $407866112e362b76$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $407866112e362b76$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $407866112e362b76$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($407866112e362b76$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $407866112e362b76$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $407866112e362b76$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $407866112e362b76$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $407866112e362b76$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $407866112e362b76$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $407866112e362b76$var$updateOptions(domElement, !!lastProps, tag, !0) : $407866112e362b76$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($407866112e362b76$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $407866112e362b76$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $407866112e362b76$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $407866112e362b76$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($407866112e362b76$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($407866112e362b76$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $407866112e362b76$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $407866112e362b76$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $407866112e362b76$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $407866112e362b76$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $407866112e362b76$var$eventsEnabled = null, $407866112e362b76$var$selectionInformation = null;
function $407866112e362b76$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $407866112e362b76$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $407866112e362b76$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $407866112e362b76$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $407866112e362b76$var$currentPopstateTransitionEvent = null;
function $407866112e362b76$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $407866112e362b76$var$currentPopstateTransitionEvent) return !1;
        $407866112e362b76$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $407866112e362b76$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $407866112e362b76$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $407866112e362b76$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $407866112e362b76$var$localPromise = "function" === typeof Promise ? Promise : void 0, $407866112e362b76$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $407866112e362b76$var$localPromise ? function(callback) {
    return $407866112e362b76$var$localPromise.resolve(null).then(callback).catch($407866112e362b76$var$handleErrorInNextTick);
} : $407866112e362b76$var$scheduleTimeout;
function $407866112e362b76$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $407866112e362b76$var$isSingletonScope(type) {
    return "head" === type;
}
function $407866112e362b76$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $407866112e362b76$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $407866112e362b76$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $407866112e362b76$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$407866112e362b76$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $407866112e362b76$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $407866112e362b76$var$retryIfBlockedOn(suspenseInstance);
}
function $407866112e362b76$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $407866112e362b76$var$clearContainerSparingly(node);
                $407866112e362b76$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $407866112e362b76$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$407866112e362b76$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $407866112e362b76$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $407866112e362b76$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $407866112e362b76$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $407866112e362b76$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $407866112e362b76$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $407866112e362b76$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $407866112e362b76$var$previousHydratableOnEnteringScopedSingleton = null;
function $407866112e362b76$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $407866112e362b76$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $407866112e362b76$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($407866112e362b76$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($407866112e362b76$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($407866112e362b76$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($407866112e362b76$var$formatProdErrorMessage(451));
    }
}
function $407866112e362b76$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $407866112e362b76$var$detachDeletedInstance(instance);
}
var $407866112e362b76$var$preloadPropsMap = new Map(), $407866112e362b76$var$preconnectsSet = new Set();
function $407866112e362b76$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $407866112e362b76$var$previousDispatcher = $407866112e362b76$var$ReactDOMSharedInternals.d;
$407866112e362b76$var$ReactDOMSharedInternals.d = {
    f: $407866112e362b76$var$flushSyncWork,
    r: $407866112e362b76$var$requestFormReset,
    D: $407866112e362b76$var$prefetchDNS,
    C: $407866112e362b76$var$preconnect,
    L: $407866112e362b76$var$preload,
    m: $407866112e362b76$var$preloadModule,
    X: $407866112e362b76$var$preinitScript,
    S: $407866112e362b76$var$preinitStyle,
    M: $407866112e362b76$var$preinitModuleScript
};
function $407866112e362b76$var$flushSyncWork() {
    var previousWasRendering = $407866112e362b76$var$previousDispatcher.f(), wasRendering = $407866112e362b76$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $407866112e362b76$var$requestFormReset(form) {
    var formInst = $407866112e362b76$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $407866112e362b76$var$requestFormReset$1(formInst) : $407866112e362b76$var$previousDispatcher.r(form);
}
var $407866112e362b76$var$globalDocument = "undefined" === typeof document ? null : document;
function $407866112e362b76$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $407866112e362b76$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $407866112e362b76$var$preconnectsSet.has(limitedEscapedHref) || ($407866112e362b76$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $407866112e362b76$var$setInitialProperties(href, "link", rel), $407866112e362b76$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $407866112e362b76$var$prefetchDNS(href) {
    $407866112e362b76$var$previousDispatcher.D(href);
    $407866112e362b76$var$preconnectAs("dns-prefetch", href, null);
}
function $407866112e362b76$var$preconnect(href, crossOrigin) {
    $407866112e362b76$var$previousDispatcher.C(href, crossOrigin);
    $407866112e362b76$var$preconnectAs("preconnect", href, crossOrigin);
}
function $407866112e362b76$var$preload(href, as, options) {
    $407866112e362b76$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $407866112e362b76$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $407866112e362b76$var$getStyleKey(href);
                break;
            case "script":
                key = $407866112e362b76$var$getScriptKey(href);
        }
        $407866112e362b76$var$preloadPropsMap.has(key) || (href = $407866112e362b76$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $407866112e362b76$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($407866112e362b76$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($407866112e362b76$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $407866112e362b76$var$setInitialProperties(as, "link", href), $407866112e362b76$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $407866112e362b76$var$preloadModule(href, options) {
    $407866112e362b76$var$previousDispatcher.m(href, options);
    var ownerDocument = $407866112e362b76$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $407866112e362b76$var$getScriptKey(href);
        }
        if (!$407866112e362b76$var$preloadPropsMap.has(key) && (href = $407866112e362b76$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $407866112e362b76$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($407866112e362b76$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $407866112e362b76$var$setInitialProperties(as, "link", href);
            $407866112e362b76$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $407866112e362b76$var$preinitStyle(href, precedence, options) {
    $407866112e362b76$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $407866112e362b76$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $407866112e362b76$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $407866112e362b76$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($407866112e362b76$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $407866112e362b76$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $407866112e362b76$var$preloadPropsMap.get(key)) && $407866112e362b76$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $407866112e362b76$var$markNodeAsHoistable(link);
                $407866112e362b76$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $407866112e362b76$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $407866112e362b76$var$preinitScript(src, options) {
    $407866112e362b76$var$previousDispatcher.X(src, options);
    var ownerDocument = $407866112e362b76$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $407866112e362b76$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $407866112e362b76$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($407866112e362b76$var$getScriptSelectorFromKey(key)), resource || (src = $407866112e362b76$var$assign({
            src: src,
            async: !0
        }, options), (options = $407866112e362b76$var$preloadPropsMap.get(key)) && $407866112e362b76$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $407866112e362b76$var$markNodeAsHoistable(resource), $407866112e362b76$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $407866112e362b76$var$preinitModuleScript(src, options) {
    $407866112e362b76$var$previousDispatcher.M(src, options);
    var ownerDocument = $407866112e362b76$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $407866112e362b76$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $407866112e362b76$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($407866112e362b76$var$getScriptSelectorFromKey(key)), resource || (src = $407866112e362b76$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $407866112e362b76$var$preloadPropsMap.get(key)) && $407866112e362b76$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $407866112e362b76$var$markNodeAsHoistable(resource), $407866112e362b76$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $407866112e362b76$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $407866112e362b76$var$rootInstanceStackCursor.current) ? $407866112e362b76$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($407866112e362b76$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $407866112e362b76$var$getStyleKey(pendingProps.href), pendingProps = $407866112e362b76$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $407866112e362b76$var$getStyleKey(pendingProps.href);
                var styles$244 = $407866112e362b76$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($407866112e362b76$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $407866112e362b76$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $407866112e362b76$var$preloadPropsMap.set(type, pendingProps), styles$244 || $407866112e362b76$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($407866112e362b76$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($407866112e362b76$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $407866112e362b76$var$getScriptKey(pendingProps), pendingProps = $407866112e362b76$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($407866112e362b76$var$formatProdErrorMessage(444, type));
    }
}
function $407866112e362b76$var$getStyleKey(href) {
    return 'href="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $407866112e362b76$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $407866112e362b76$var$stylesheetPropsFromRawProps(rawProps) {
    return $407866112e362b76$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $407866112e362b76$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $407866112e362b76$var$setInitialProperties(key, "link", preloadProps), $407866112e362b76$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $407866112e362b76$var$getScriptKey(src) {
    return '[src="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $407866112e362b76$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $407866112e362b76$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $407866112e362b76$var$markNodeAsHoistable(instance), instance;
            var styleProps = $407866112e362b76$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $407866112e362b76$var$markNodeAsHoistable(instance);
            $407866112e362b76$var$setInitialProperties(instance, "style", styleProps);
            $407866112e362b76$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $407866112e362b76$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($407866112e362b76$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $407866112e362b76$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $407866112e362b76$var$stylesheetPropsFromRawProps(props);
            (styleProps = $407866112e362b76$var$preloadPropsMap.get(styleProps)) && $407866112e362b76$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $407866112e362b76$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $407866112e362b76$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $407866112e362b76$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $407866112e362b76$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($407866112e362b76$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $407866112e362b76$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $407866112e362b76$var$preloadPropsMap.get(instance$250)) instance = $407866112e362b76$var$assign({}, props), $407866112e362b76$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $407866112e362b76$var$markNodeAsHoistable(styleProps);
            $407866112e362b76$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($407866112e362b76$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $407866112e362b76$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $407866112e362b76$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $407866112e362b76$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $407866112e362b76$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $407866112e362b76$var$tagCaches = null;
function $407866112e362b76$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $407866112e362b76$var$tagCaches) {
        var cache = new Map();
        var caches = $407866112e362b76$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $407866112e362b76$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$407866112e362b76$var$internalHoistableMarker] || node[$407866112e362b76$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $407866112e362b76$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $407866112e362b76$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $407866112e362b76$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $407866112e362b76$var$suspendedState = null;
function $407866112e362b76$var$noop() {}
function $407866112e362b76$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $407866112e362b76$var$suspendedState) throw Error($407866112e362b76$var$formatProdErrorMessage(475));
    var state = $407866112e362b76$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $407866112e362b76$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($407866112e362b76$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $407866112e362b76$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $407866112e362b76$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $407866112e362b76$var$stylesheetPropsFromRawProps(props);
            (key = $407866112e362b76$var$preloadPropsMap.get(key)) && $407866112e362b76$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $407866112e362b76$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $407866112e362b76$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $407866112e362b76$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $407866112e362b76$var$waitForCommitToBeReady() {
    if (null === $407866112e362b76$var$suspendedState) throw Error($407866112e362b76$var$formatProdErrorMessage(475));
    var state = $407866112e362b76$var$suspendedState;
    state.stylesheets && 0 === state.count && $407866112e362b76$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $407866112e362b76$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $407866112e362b76$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $407866112e362b76$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $407866112e362b76$var$precedencesByRoot = null;
function $407866112e362b76$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $407866112e362b76$var$precedencesByRoot = new Map(), resources.forEach($407866112e362b76$var$insertStylesheetIntoRoot, state), $407866112e362b76$var$precedencesByRoot = null, $407866112e362b76$var$onUnsuspend.call(state));
}
function $407866112e362b76$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $407866112e362b76$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $407866112e362b76$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $407866112e362b76$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $407866112e362b76$var$HostTransitionContext = {
    $$typeof: $407866112e362b76$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $407866112e362b76$var$sharedNotPendingObject,
    _currentValue2: $407866112e362b76$var$sharedNotPendingObject,
    _threadCount: 0
};
function $407866112e362b76$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $407866112e362b76$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $407866112e362b76$var$createLaneMap(0);
    this.hiddenUpdates = $407866112e362b76$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $407866112e362b76$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $407866112e362b76$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $407866112e362b76$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $407866112e362b76$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $407866112e362b76$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $407866112e362b76$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $407866112e362b76$var$emptyContextObject;
    parentComponent = $407866112e362b76$var$emptyContextObject;
    return parentComponent;
}
function $407866112e362b76$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $407866112e362b76$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $407866112e362b76$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $407866112e362b76$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($407866112e362b76$var$scheduleUpdateOnFiber(element, rootFiber, lane), $407866112e362b76$var$entangleTransitions(element, rootFiber, lane));
}
function $407866112e362b76$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $407866112e362b76$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $407866112e362b76$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $407866112e362b76$var$markRetryLaneImpl(fiber, retryLane);
}
function $407866112e362b76$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $407866112e362b76$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $407866112e362b76$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $407866112e362b76$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $407866112e362b76$var$_enabled = !0;
function $407866112e362b76$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $407866112e362b76$var$ReactSharedInternals.T;
    $407866112e362b76$var$ReactSharedInternals.T = null;
    var previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
    try {
        $407866112e362b76$var$ReactDOMSharedInternals.p = 2, $407866112e362b76$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority, $407866112e362b76$var$ReactSharedInternals.T = prevTransition;
    }
}
function $407866112e362b76$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $407866112e362b76$var$ReactSharedInternals.T;
    $407866112e362b76$var$ReactSharedInternals.T = null;
    var previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
    try {
        $407866112e362b76$var$ReactDOMSharedInternals.p = 8, $407866112e362b76$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority, $407866112e362b76$var$ReactSharedInternals.T = prevTransition;
    }
}
function $407866112e362b76$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($407866112e362b76$var$_enabled) {
        var blockedOn = $407866112e362b76$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $407866112e362b76$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $407866112e362b76$var$return_targetInst, targetContainer), $407866112e362b76$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($407866112e362b76$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($407866112e362b76$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $407866112e362b76$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $407866112e362b76$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $407866112e362b76$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $407866112e362b76$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $407866112e362b76$var$ensureRootIsScheduled(fiber);
                                0 === ($407866112e362b76$var$executionContext & 6) && ($407866112e362b76$var$workInProgressRootRenderTargetTime = $407866112e362b76$var$now() + 500, $407866112e362b76$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $407866112e362b76$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $407866112e362b76$var$scheduleUpdateOnFiber(root, fiber, 2), $407866112e362b76$var$flushSyncWork$1(), $407866112e362b76$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $407866112e362b76$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $407866112e362b76$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $407866112e362b76$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $407866112e362b76$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $407866112e362b76$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $407866112e362b76$var$getEventTarget(nativeEvent);
    return $407866112e362b76$var$findInstanceBlockingTarget(nativeEvent);
}
var $407866112e362b76$var$return_targetInst = null;
function $407866112e362b76$var$findInstanceBlockingTarget(targetNode) {
    $407866112e362b76$var$return_targetInst = null;
    targetNode = $407866112e362b76$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $407866112e362b76$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $407866112e362b76$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $407866112e362b76$var$return_targetInst = targetNode;
    return null;
}
function $407866112e362b76$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($407866112e362b76$var$getCurrentPriorityLevel()){
                case $407866112e362b76$var$ImmediatePriority:
                    return 2;
                case $407866112e362b76$var$UserBlockingPriority:
                    return 8;
                case $407866112e362b76$var$NormalPriority$1:
                case $407866112e362b76$var$LowPriority:
                    return 32;
                case $407866112e362b76$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $407866112e362b76$var$hasScheduledReplayAttempt = !1, $407866112e362b76$var$queuedFocus = null, $407866112e362b76$var$queuedDrag = null, $407866112e362b76$var$queuedMouse = null, $407866112e362b76$var$queuedPointers = new Map(), $407866112e362b76$var$queuedPointerCaptures = new Map(), $407866112e362b76$var$queuedExplicitHydrationTargets = [], $407866112e362b76$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $407866112e362b76$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $407866112e362b76$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $407866112e362b76$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $407866112e362b76$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $407866112e362b76$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $407866112e362b76$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $407866112e362b76$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $407866112e362b76$var$getInstanceFromNode(blockedOn), null !== blockedOn && $407866112e362b76$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $407866112e362b76$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $407866112e362b76$var$queuedFocus = $407866112e362b76$var$accumulateOrCreateContinuousQueuedReplayableEvent($407866112e362b76$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $407866112e362b76$var$queuedDrag = $407866112e362b76$var$accumulateOrCreateContinuousQueuedReplayableEvent($407866112e362b76$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $407866112e362b76$var$queuedMouse = $407866112e362b76$var$accumulateOrCreateContinuousQueuedReplayableEvent($407866112e362b76$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $407866112e362b76$var$queuedPointers.set(pointerId, $407866112e362b76$var$accumulateOrCreateContinuousQueuedReplayableEvent($407866112e362b76$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $407866112e362b76$var$queuedPointerCaptures.set(pointerId, $407866112e362b76$var$accumulateOrCreateContinuousQueuedReplayableEvent($407866112e362b76$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $407866112e362b76$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $407866112e362b76$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $407866112e362b76$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $407866112e362b76$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $407866112e362b76$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $407866112e362b76$var$requestUpdateLane();
                            lane = $407866112e362b76$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $407866112e362b76$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $407866112e362b76$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $407866112e362b76$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $407866112e362b76$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $407866112e362b76$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $407866112e362b76$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $407866112e362b76$var$currentReplayingEvent = null;
        } else return targetContainers = $407866112e362b76$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $407866112e362b76$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $407866112e362b76$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $407866112e362b76$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $407866112e362b76$var$replayUnblockedEvents() {
    $407866112e362b76$var$hasScheduledReplayAttempt = !1;
    null !== $407866112e362b76$var$queuedFocus && $407866112e362b76$var$attemptReplayContinuousQueuedEvent($407866112e362b76$var$queuedFocus) && ($407866112e362b76$var$queuedFocus = null);
    null !== $407866112e362b76$var$queuedDrag && $407866112e362b76$var$attemptReplayContinuousQueuedEvent($407866112e362b76$var$queuedDrag) && ($407866112e362b76$var$queuedDrag = null);
    null !== $407866112e362b76$var$queuedMouse && $407866112e362b76$var$attemptReplayContinuousQueuedEvent($407866112e362b76$var$queuedMouse) && ($407866112e362b76$var$queuedMouse = null);
    $407866112e362b76$var$queuedPointers.forEach($407866112e362b76$var$attemptReplayContinuousQueuedEventInMap);
    $407866112e362b76$var$queuedPointerCaptures.forEach($407866112e362b76$var$attemptReplayContinuousQueuedEventInMap);
}
function $407866112e362b76$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $407866112e362b76$var$hasScheduledReplayAttempt || ($407866112e362b76$var$hasScheduledReplayAttempt = !0, $hNfVH.unstable_scheduleCallback($hNfVH.unstable_NormalPriority, $407866112e362b76$var$replayUnblockedEvents)));
}
var $407866112e362b76$var$lastScheduledReplayQueue = null;
function $407866112e362b76$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $407866112e362b76$var$lastScheduledReplayQueue !== formReplayingQueue && ($407866112e362b76$var$lastScheduledReplayQueue = formReplayingQueue, $hNfVH.unstable_scheduleCallback($hNfVH.unstable_NormalPriority, function() {
        $407866112e362b76$var$lastScheduledReplayQueue === formReplayingQueue && ($407866112e362b76$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $407866112e362b76$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $407866112e362b76$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $407866112e362b76$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $407866112e362b76$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $407866112e362b76$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $407866112e362b76$var$queuedFocus && $407866112e362b76$var$scheduleCallbackIfUnblocked($407866112e362b76$var$queuedFocus, unblocked);
    null !== $407866112e362b76$var$queuedDrag && $407866112e362b76$var$scheduleCallbackIfUnblocked($407866112e362b76$var$queuedDrag, unblocked);
    null !== $407866112e362b76$var$queuedMouse && $407866112e362b76$var$scheduleCallbackIfUnblocked($407866112e362b76$var$queuedMouse, unblocked);
    $407866112e362b76$var$queuedPointers.forEach(unblock);
    $407866112e362b76$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $407866112e362b76$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $407866112e362b76$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $407866112e362b76$var$queuedExplicitHydrationTargets.length && (i = $407866112e362b76$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$407866112e362b76$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $407866112e362b76$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$407866112e362b76$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $407866112e362b76$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$407866112e362b76$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $407866112e362b76$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $407866112e362b76$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $407866112e362b76$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$407866112e362b76$var$ReactDOMHydrationRoot.prototype.render = $407866112e362b76$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($407866112e362b76$var$formatProdErrorMessage(409));
    var current = root.current, lane = $407866112e362b76$var$requestUpdateLane();
    $407866112e362b76$var$updateContainerImpl(current, lane, children, root, null, null);
};
$407866112e362b76$var$ReactDOMHydrationRoot.prototype.unmount = $407866112e362b76$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $407866112e362b76$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $407866112e362b76$var$flushSyncWork$1();
        container[$407866112e362b76$var$internalContainerInstanceKey] = null;
    }
};
function $407866112e362b76$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$407866112e362b76$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $407866112e362b76$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $407866112e362b76$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $407866112e362b76$var$queuedExplicitHydrationTargets[i].priority; i++);
        $407866112e362b76$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $407866112e362b76$var$attemptExplicitHydrationTarget(target);
    }
};
var $407866112e362b76$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $8vqx4.version;
if ("19.1.0" !== $407866112e362b76$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($407866112e362b76$var$formatProdErrorMessage(527, $407866112e362b76$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$407866112e362b76$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($407866112e362b76$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($407866112e362b76$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $407866112e362b76$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $407866112e362b76$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $407866112e362b76$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $407866112e362b76$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $407866112e362b76$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$407866112e362b76$var$hook$jscomp$inline_2257.isDisabled && $407866112e362b76$var$hook$jscomp$inline_2257.supportsFiber) try {
        $407866112e362b76$var$rendererID = $407866112e362b76$var$hook$jscomp$inline_2257.inject($407866112e362b76$var$internals$jscomp$inline_2256), $407866112e362b76$var$injectedHook = $407866112e362b76$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$407866112e362b76$export$882461b6382ed46c = function(container, options) {
    if (!$407866112e362b76$var$isValidContainer(container)) throw Error($407866112e362b76$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $407866112e362b76$var$defaultOnUncaughtError, onCaughtError = $407866112e362b76$var$defaultOnCaughtError, onRecoverableError = $407866112e362b76$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $407866112e362b76$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$407866112e362b76$var$internalContainerInstanceKey] = options.current;
    $407866112e362b76$var$listenToAllSupportedEvents(container);
    return new $407866112e362b76$var$ReactDOMRoot(options);
};
$407866112e362b76$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$407866112e362b76$var$isValidContainer(container)) throw Error($407866112e362b76$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $407866112e362b76$var$defaultOnUncaughtError, onCaughtError = $407866112e362b76$var$defaultOnCaughtError, onRecoverableError = $407866112e362b76$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $407866112e362b76$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $407866112e362b76$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $407866112e362b76$var$requestUpdateLane();
    isStrictMode = $407866112e362b76$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $407866112e362b76$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $407866112e362b76$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $407866112e362b76$var$markRootUpdated$1(initialChildren, options);
    $407866112e362b76$var$ensureRootIsScheduled(initialChildren);
    container[$407866112e362b76$var$internalContainerInstanceKey] = initialChildren.current;
    $407866112e362b76$var$listenToAllSupportedEvents(container);
    return new $407866112e362b76$var$ReactDOMHydrationRoot(initialChildren);
};
$407866112e362b76$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("hNfVH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("k8s7f"));

});
parcelRegister("k8s7f", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $ea8a5d3bfd1fa17f$export$c4744153514ff05d, (v) => $ea8a5d3bfd1fa17f$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7, (v) => $ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875, (v) => $ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $ea8a5d3bfd1fa17f$export$502329bbf4b505b1, (v) => $ea8a5d3bfd1fa17f$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $ea8a5d3bfd1fa17f$export$6e3807111c4874c4, (v) => $ea8a5d3bfd1fa17f$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $ea8a5d3bfd1fa17f$export$c27134553091fb3a, (v) => $ea8a5d3bfd1fa17f$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2, (v) => $ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $ea8a5d3bfd1fa17f$export$b00a404bbd5edef2, (v) => $ea8a5d3bfd1fa17f$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b, (v) => $ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555, (v) => $ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $ea8a5d3bfd1fa17f$export$72fdf0e06517287b, (v) => $ea8a5d3bfd1fa17f$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $ea8a5d3bfd1fa17f$export$816d2913ae6b83b1, (v) => $ea8a5d3bfd1fa17f$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $ea8a5d3bfd1fa17f$export$61bcfe829111a1d0, (v) => $ea8a5d3bfd1fa17f$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f, (v) => $ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $ea8a5d3bfd1fa17f$export$b5836b71941fa3ed, (v) => $ea8a5d3bfd1fa17f$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $ea8a5d3bfd1fa17f$export$cf845f2c119da08a, (v) => $ea8a5d3bfd1fa17f$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ea8a5d3bfd1fa17f$export$c4744153514ff05d;
var $ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7;
var $ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875;
var $ea8a5d3bfd1fa17f$export$502329bbf4b505b1;
var $ea8a5d3bfd1fa17f$export$6e3807111c4874c4;
var $ea8a5d3bfd1fa17f$export$c27134553091fb3a;
var $ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2;
var $ea8a5d3bfd1fa17f$export$b00a404bbd5edef2;
var $ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b;
var $ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555;
var $ea8a5d3bfd1fa17f$export$72fdf0e06517287b;
var $ea8a5d3bfd1fa17f$export$816d2913ae6b83b1;
var $ea8a5d3bfd1fa17f$export$61bcfe829111a1d0;
var $ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f;
var $ea8a5d3bfd1fa17f$export$b5836b71941fa3ed;
var $ea8a5d3bfd1fa17f$export$cf845f2c119da08a;
"use strict";
function $ea8a5d3bfd1fa17f$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $ea8a5d3bfd1fa17f$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $ea8a5d3bfd1fa17f$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $ea8a5d3bfd1fa17f$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $ea8a5d3bfd1fa17f$var$compare(left, last)) rightIndex < length && 0 > $ea8a5d3bfd1fa17f$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $ea8a5d3bfd1fa17f$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $ea8a5d3bfd1fa17f$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$ea8a5d3bfd1fa17f$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ea8a5d3bfd1fa17f$var$localPerformance = performance;
    $ea8a5d3bfd1fa17f$export$c4744153514ff05d = function() {
        return $ea8a5d3bfd1fa17f$var$localPerformance.now();
    };
} else {
    var $ea8a5d3bfd1fa17f$var$localDate = Date, $ea8a5d3bfd1fa17f$var$initialTime = $ea8a5d3bfd1fa17f$var$localDate.now();
    $ea8a5d3bfd1fa17f$export$c4744153514ff05d = function() {
        return $ea8a5d3bfd1fa17f$var$localDate.now() - $ea8a5d3bfd1fa17f$var$initialTime;
    };
}
var $ea8a5d3bfd1fa17f$var$taskQueue = [], $ea8a5d3bfd1fa17f$var$timerQueue = [], $ea8a5d3bfd1fa17f$var$taskIdCounter = 1, $ea8a5d3bfd1fa17f$var$currentTask = null, $ea8a5d3bfd1fa17f$var$currentPriorityLevel = 3, $ea8a5d3bfd1fa17f$var$isPerformingWork = !1, $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !1, $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !1, $ea8a5d3bfd1fa17f$var$needsPaint = !1, $ea8a5d3bfd1fa17f$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $ea8a5d3bfd1fa17f$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $ea8a5d3bfd1fa17f$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime) {
    for(var timer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue); null !== timer;){
        if (null === timer.callback) $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$timerQueue);
        else if (timer.startTime <= currentTime) $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$timerQueue), timer.sortIndex = timer.expirationTime, $ea8a5d3bfd1fa17f$var$push($ea8a5d3bfd1fa17f$var$taskQueue, timer);
        else break;
        timer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue);
    }
}
function $ea8a5d3bfd1fa17f$var$handleTimeout(currentTime) {
    $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !1;
    $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
    if (!$ea8a5d3bfd1fa17f$var$isHostCallbackScheduled) {
        if (null !== $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue)) $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !0, $ea8a5d3bfd1fa17f$var$isMessageLoopRunning || ($ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !0, $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue);
            null !== firstTimer && $ea8a5d3bfd1fa17f$var$requestHostTimeout($ea8a5d3bfd1fa17f$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !1, $ea8a5d3bfd1fa17f$var$taskTimeoutID = -1, $ea8a5d3bfd1fa17f$var$frameInterval = 5, $ea8a5d3bfd1fa17f$var$startTime = -1;
function $ea8a5d3bfd1fa17f$var$shouldYieldToHost() {
    return $ea8a5d3bfd1fa17f$var$needsPaint ? !0 : $ea8a5d3bfd1fa17f$export$c4744153514ff05d() - $ea8a5d3bfd1fa17f$var$startTime < $ea8a5d3bfd1fa17f$var$frameInterval ? !1 : !0;
}
function $ea8a5d3bfd1fa17f$var$performWorkUntilDeadline() {
    $ea8a5d3bfd1fa17f$var$needsPaint = !1;
    if ($ea8a5d3bfd1fa17f$var$isMessageLoopRunning) {
        var currentTime = $ea8a5d3bfd1fa17f$export$c4744153514ff05d();
        $ea8a5d3bfd1fa17f$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !1;
                $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled && ($ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !1, $ea8a5d3bfd1fa17f$var$localClearTimeout($ea8a5d3bfd1fa17f$var$taskTimeoutID), $ea8a5d3bfd1fa17f$var$taskTimeoutID = -1);
                $ea8a5d3bfd1fa17f$var$isPerformingWork = !0;
                var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
                try {
                    b: {
                        $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
                        for($ea8a5d3bfd1fa17f$var$currentTask = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue); null !== $ea8a5d3bfd1fa17f$var$currentTask && !($ea8a5d3bfd1fa17f$var$currentTask.expirationTime > currentTime && $ea8a5d3bfd1fa17f$var$shouldYieldToHost());){
                            var callback = $ea8a5d3bfd1fa17f$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $ea8a5d3bfd1fa17f$var$currentTask.callback = null;
                                $ea8a5d3bfd1fa17f$var$currentPriorityLevel = $ea8a5d3bfd1fa17f$var$currentTask.priorityLevel;
                                var continuationCallback = callback($ea8a5d3bfd1fa17f$var$currentTask.expirationTime <= currentTime);
                                currentTime = $ea8a5d3bfd1fa17f$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $ea8a5d3bfd1fa17f$var$currentTask.callback = continuationCallback;
                                    $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $ea8a5d3bfd1fa17f$var$currentTask === $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue) && $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$taskQueue);
                                $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
                            } else $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$taskQueue);
                            $ea8a5d3bfd1fa17f$var$currentTask = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue);
                        }
                        if (null !== $ea8a5d3bfd1fa17f$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue);
                            null !== firstTimer && $ea8a5d3bfd1fa17f$var$requestHostTimeout($ea8a5d3bfd1fa17f$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $ea8a5d3bfd1fa17f$var$currentTask = null, $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel, $ea8a5d3bfd1fa17f$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline() : $ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !1;
        }
    }
}
var $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $ea8a5d3bfd1fa17f$var$localSetImmediate) $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline = function() {
    $ea8a5d3bfd1fa17f$var$localSetImmediate($ea8a5d3bfd1fa17f$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ea8a5d3bfd1fa17f$var$channel = new MessageChannel(), $ea8a5d3bfd1fa17f$var$port = $ea8a5d3bfd1fa17f$var$channel.port2;
    $ea8a5d3bfd1fa17f$var$channel.port1.onmessage = $ea8a5d3bfd1fa17f$var$performWorkUntilDeadline;
    $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline = function() {
        $ea8a5d3bfd1fa17f$var$port.postMessage(null);
    };
} else $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline = function() {
    $ea8a5d3bfd1fa17f$var$localSetTimeout($ea8a5d3bfd1fa17f$var$performWorkUntilDeadline, 0);
};
function $ea8a5d3bfd1fa17f$var$requestHostTimeout(callback, ms) {
    $ea8a5d3bfd1fa17f$var$taskTimeoutID = $ea8a5d3bfd1fa17f$var$localSetTimeout(function() {
        callback($ea8a5d3bfd1fa17f$export$c4744153514ff05d());
    }, ms);
}
$ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7 = 5;
$ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875 = 1;
$ea8a5d3bfd1fa17f$export$502329bbf4b505b1 = 4;
$ea8a5d3bfd1fa17f$export$6e3807111c4874c4 = 3;
$ea8a5d3bfd1fa17f$export$c27134553091fb3a = null;
$ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2 = 2;
$ea8a5d3bfd1fa17f$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ea8a5d3bfd1fa17f$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555 = function() {
    return $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
};
$ea8a5d3bfd1fa17f$export$72fdf0e06517287b = function(eventHandler) {
    switch($ea8a5d3bfd1fa17f$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    $ea8a5d3bfd1fa17f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$ea8a5d3bfd1fa17f$export$816d2913ae6b83b1 = function() {
    $ea8a5d3bfd1fa17f$var$needsPaint = !0;
};
$ea8a5d3bfd1fa17f$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    $ea8a5d3bfd1fa17f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $ea8a5d3bfd1fa17f$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $ea8a5d3bfd1fa17f$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $ea8a5d3bfd1fa17f$var$push($ea8a5d3bfd1fa17f$var$timerQueue, priorityLevel), null === $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue) && priorityLevel === $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue) && ($ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled ? ($ea8a5d3bfd1fa17f$var$localClearTimeout($ea8a5d3bfd1fa17f$var$taskTimeoutID), $ea8a5d3bfd1fa17f$var$taskTimeoutID = -1) : $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !0, $ea8a5d3bfd1fa17f$var$requestHostTimeout($ea8a5d3bfd1fa17f$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $ea8a5d3bfd1fa17f$var$push($ea8a5d3bfd1fa17f$var$taskQueue, priorityLevel), $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled || $ea8a5d3bfd1fa17f$var$isPerformingWork || ($ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !0, $ea8a5d3bfd1fa17f$var$isMessageLoopRunning || ($ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !0, $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$ea8a5d3bfd1fa17f$export$b5836b71941fa3ed = $ea8a5d3bfd1fa17f$var$shouldYieldToHost;
$ea8a5d3bfd1fa17f$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
        $ea8a5d3bfd1fa17f$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("8vqx4", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eij5T"));

});

parcelRegister("hiyfL", function(module, exports) {
'use strict';
function $c97eb012c82a0807$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c97eb012c82a0807$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c97eb012c82a0807$var$checkDCE();

module.exports = (parcelRequire("dDCtE"));

});
parcelRegister("dDCtE", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $028ff2a3c3210a6f$export$69ce8ef3fe5cead0, (v) => $028ff2a3c3210a6f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $028ff2a3c3210a6f$export$d39a5bbd09211389, (v) => $028ff2a3c3210a6f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $028ff2a3c3210a6f$export$cd75ccfd720a3cd4, (v) => $028ff2a3c3210a6f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $028ff2a3c3210a6f$export$a0816fa17a9e79be, (v) => $028ff2a3c3210a6f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $028ff2a3c3210a6f$export$7292efcadded39f3, (v) => $028ff2a3c3210a6f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $028ff2a3c3210a6f$export$da407abadb9b8f86, (v) => $028ff2a3c3210a6f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $028ff2a3c3210a6f$export$314cfea32580671c, (v) => $028ff2a3c3210a6f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $028ff2a3c3210a6f$export$513ccb98c53b8039, (v) => $028ff2a3c3210a6f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $028ff2a3c3210a6f$export$dbca993bc2d264a, (v) => $028ff2a3c3210a6f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $028ff2a3c3210a6f$export$4797a8006f0655d0, (v) => $028ff2a3c3210a6f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $028ff2a3c3210a6f$export$c78a37762a8d58e1, (v) => $028ff2a3c3210a6f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $028ff2a3c3210a6f$export$606f11b2eb45ecc6, (v) => $028ff2a3c3210a6f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $028ff2a3c3210a6f$export$f7e8a0bf92324b1e, (v) => $028ff2a3c3210a6f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $028ff2a3c3210a6f$export$83d89fbfd8236492, (v) => $028ff2a3c3210a6f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $028ff2a3c3210a6f$export$69ce8ef3fe5cead0;
var $028ff2a3c3210a6f$export$d39a5bbd09211389;
var $028ff2a3c3210a6f$export$cd75ccfd720a3cd4;
var $028ff2a3c3210a6f$export$a0816fa17a9e79be;
var $028ff2a3c3210a6f$export$7292efcadded39f3;
var $028ff2a3c3210a6f$export$da407abadb9b8f86;
var $028ff2a3c3210a6f$export$314cfea32580671c;
var $028ff2a3c3210a6f$export$513ccb98c53b8039;
var $028ff2a3c3210a6f$export$dbca993bc2d264a;
var $028ff2a3c3210a6f$export$4797a8006f0655d0;
var $028ff2a3c3210a6f$export$c78a37762a8d58e1;
var $028ff2a3c3210a6f$export$606f11b2eb45ecc6;
var $028ff2a3c3210a6f$export$f7e8a0bf92324b1e;
var $028ff2a3c3210a6f$export$83d89fbfd8236492;
"use strict";

var $8vqx4 = parcelRequire("8vqx4");
function $028ff2a3c3210a6f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $028ff2a3c3210a6f$var$noop() {}
var $028ff2a3c3210a6f$var$Internals = {
    d: {
        f: $028ff2a3c3210a6f$var$noop,
        r: function() {
            throw Error($028ff2a3c3210a6f$var$formatProdErrorMessage(522));
        },
        D: $028ff2a3c3210a6f$var$noop,
        C: $028ff2a3c3210a6f$var$noop,
        L: $028ff2a3c3210a6f$var$noop,
        m: $028ff2a3c3210a6f$var$noop,
        X: $028ff2a3c3210a6f$var$noop,
        S: $028ff2a3c3210a6f$var$noop,
        M: $028ff2a3c3210a6f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $028ff2a3c3210a6f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $028ff2a3c3210a6f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $028ff2a3c3210a6f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $028ff2a3c3210a6f$var$ReactSharedInternals = $8vqx4.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $028ff2a3c3210a6f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$028ff2a3c3210a6f$export$69ce8ef3fe5cead0 = $028ff2a3c3210a6f$var$Internals;
$028ff2a3c3210a6f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($028ff2a3c3210a6f$var$formatProdErrorMessage(299));
    return $028ff2a3c3210a6f$var$createPortal$1(children, container, null, key);
};
$028ff2a3c3210a6f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $028ff2a3c3210a6f$var$ReactSharedInternals.T, previousUpdatePriority = $028ff2a3c3210a6f$var$Internals.p;
    try {
        if ($028ff2a3c3210a6f$var$ReactSharedInternals.T = null, $028ff2a3c3210a6f$var$Internals.p = 2, fn) return fn();
    } finally{
        $028ff2a3c3210a6f$var$ReactSharedInternals.T = previousTransition, $028ff2a3c3210a6f$var$Internals.p = previousUpdatePriority, $028ff2a3c3210a6f$var$Internals.d.f();
    }
};
$028ff2a3c3210a6f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $028ff2a3c3210a6f$var$Internals.d.C(href, options));
};
$028ff2a3c3210a6f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $028ff2a3c3210a6f$var$Internals.d.D(href);
};
$028ff2a3c3210a6f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $028ff2a3c3210a6f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $028ff2a3c3210a6f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $028ff2a3c3210a6f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$028ff2a3c3210a6f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $028ff2a3c3210a6f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $028ff2a3c3210a6f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $028ff2a3c3210a6f$var$Internals.d.M(href);
    }
};
$028ff2a3c3210a6f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $028ff2a3c3210a6f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $028ff2a3c3210a6f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$028ff2a3c3210a6f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $028ff2a3c3210a6f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $028ff2a3c3210a6f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $028ff2a3c3210a6f$var$Internals.d.m(href);
    }
};
$028ff2a3c3210a6f$export$4797a8006f0655d0 = function(form) {
    $028ff2a3c3210a6f$var$Internals.d.r(form);
};
$028ff2a3c3210a6f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$028ff2a3c3210a6f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $028ff2a3c3210a6f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$028ff2a3c3210a6f$export$f7e8a0bf92324b1e = function() {
    return $028ff2a3c3210a6f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$028ff2a3c3210a6f$export$83d89fbfd8236492 = "19.1.0";

});



parcelRegister("jJ1eL", function(module, exports) {

var $ikdtY = parcelRequire("ikdtY");
var $e5c32dfbd2c1f48c$var$Global = $ikdtY.Global;
module.exports = {
    name: 'localStorage',
    read: $e5c32dfbd2c1f48c$var$read,
    write: $e5c32dfbd2c1f48c$var$write,
    each: $e5c32dfbd2c1f48c$var$each,
    remove: $e5c32dfbd2c1f48c$var$remove,
    clearAll: $e5c32dfbd2c1f48c$var$clearAll
};
function $e5c32dfbd2c1f48c$var$localStorage() {
    return $e5c32dfbd2c1f48c$var$Global.localStorage;
}
function $e5c32dfbd2c1f48c$var$read(key) {
    return $e5c32dfbd2c1f48c$var$localStorage().getItem(key);
}
function $e5c32dfbd2c1f48c$var$write(key, data) {
    return $e5c32dfbd2c1f48c$var$localStorage().setItem(key, data);
}
function $e5c32dfbd2c1f48c$var$each(fn) {
    for(var i = $e5c32dfbd2c1f48c$var$localStorage().length - 1; i >= 0; i--){
        var key = $e5c32dfbd2c1f48c$var$localStorage().key(i);
        fn($e5c32dfbd2c1f48c$var$read(key), key);
    }
}
function $e5c32dfbd2c1f48c$var$remove(key) {
    return $e5c32dfbd2c1f48c$var$localStorage().removeItem(key);
}
function $e5c32dfbd2c1f48c$var$clearAll() {
    return $e5c32dfbd2c1f48c$var$localStorage().clear();
}

});
parcelRegister("ikdtY", function(module, exports) {
var $d5748d95f2830628$var$assign = $d5748d95f2830628$var$make_assign();
var $d5748d95f2830628$var$create = $d5748d95f2830628$var$make_create();
var $d5748d95f2830628$var$trim = $d5748d95f2830628$var$make_trim();
var $d5748d95f2830628$var$Global = typeof window !== 'undefined' ? window : $parcel$global;
module.exports = {
    assign: $d5748d95f2830628$var$assign,
    create: $d5748d95f2830628$var$create,
    trim: $d5748d95f2830628$var$trim,
    bind: $d5748d95f2830628$var$bind,
    slice: $d5748d95f2830628$var$slice,
    each: $d5748d95f2830628$var$each,
    map: $d5748d95f2830628$var$map,
    pluck: $d5748d95f2830628$var$pluck,
    isList: $d5748d95f2830628$var$isList,
    isFunction: $d5748d95f2830628$var$isFunction,
    isObject: $d5748d95f2830628$var$isObject,
    Global: $d5748d95f2830628$var$Global
};
function $d5748d95f2830628$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$d5748d95f2830628$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $d5748d95f2830628$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $d5748d95f2830628$var$slice(arguments, 1);
        return $d5748d95f2830628$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $d5748d95f2830628$var$slice(arguments, 1);
            F.prototype = obj;
            return $d5748d95f2830628$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $d5748d95f2830628$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}
function $d5748d95f2830628$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $d5748d95f2830628$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $d5748d95f2830628$var$each(obj, fn) {
    $d5748d95f2830628$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $d5748d95f2830628$var$map(obj, fn) {
    var res = $d5748d95f2830628$var$isList(obj) ? [] : {};
    $d5748d95f2830628$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $d5748d95f2830628$var$pluck(obj, fn) {
    if ($d5748d95f2830628$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $d5748d95f2830628$var$isList(val) {
    return val != null && typeof val != 'function' && typeof val.length == 'number';
}
function $d5748d95f2830628$var$isFunction(val) {
    return val && ({}).toString.call(val) === '[object Function]';
}
function $d5748d95f2830628$var$isObject(val) {
    return val && ({}).toString.call(val) === '[object Object]';
}

});


parcelRegister("hGK7t", function(module, exports) {
// oldFF-globalStorage provides storage for Firefox
// versions 6 and 7, where no localStorage, etc
// is available.

var $ikdtY = parcelRequire("ikdtY");
var $ce0a2246a944e2fd$var$Global = $ikdtY.Global;
module.exports = {
    name: 'oldFF-globalStorage',
    read: $ce0a2246a944e2fd$var$read,
    write: $ce0a2246a944e2fd$var$write,
    each: $ce0a2246a944e2fd$var$each,
    remove: $ce0a2246a944e2fd$var$remove,
    clearAll: $ce0a2246a944e2fd$var$clearAll
};
var $ce0a2246a944e2fd$var$globalStorage = $ce0a2246a944e2fd$var$Global.globalStorage;
function $ce0a2246a944e2fd$var$read(key) {
    return $ce0a2246a944e2fd$var$globalStorage[key];
}
function $ce0a2246a944e2fd$var$write(key, data) {
    $ce0a2246a944e2fd$var$globalStorage[key] = data;
}
function $ce0a2246a944e2fd$var$each(fn) {
    for(var i = $ce0a2246a944e2fd$var$globalStorage.length - 1; i >= 0; i--){
        var key = $ce0a2246a944e2fd$var$globalStorage.key(i);
        fn($ce0a2246a944e2fd$var$globalStorage[key], key);
    }
}
function $ce0a2246a944e2fd$var$remove(key) {
    return $ce0a2246a944e2fd$var$globalStorage.removeItem(key);
}
function $ce0a2246a944e2fd$var$clearAll() {
    $ce0a2246a944e2fd$var$each(function(key, _) {
        delete $ce0a2246a944e2fd$var$globalStorage[key];
    });
}

});

parcelRegister("aaPXA", function(module, exports) {
// oldIE-userDataStorage provides storage for Internet Explorer
// versions 6 and 7, where no localStorage, sessionStorage, etc
// is available.

var $ikdtY = parcelRequire("ikdtY");
var $768324c25e5fceff$var$Global = $ikdtY.Global;
module.exports = {
    name: 'oldIE-userDataStorage',
    write: $768324c25e5fceff$var$write,
    read: $768324c25e5fceff$var$read,
    each: $768324c25e5fceff$var$each,
    remove: $768324c25e5fceff$var$remove,
    clearAll: $768324c25e5fceff$var$clearAll
};
var $768324c25e5fceff$var$storageName = 'storejs';
var $768324c25e5fceff$var$doc = $768324c25e5fceff$var$Global.document;
var $768324c25e5fceff$var$_withStorageEl = $768324c25e5fceff$var$_makeIEStorageElFunction();
var $768324c25e5fceff$var$disable = ($768324c25e5fceff$var$Global.navigator ? $768324c25e5fceff$var$Global.navigator.userAgent : '').match(/ (MSIE 8|MSIE 9|MSIE 10)\./) // MSIE 9.x, MSIE 10.x
;
function $768324c25e5fceff$var$write(unfixedKey, data) {
    if ($768324c25e5fceff$var$disable) return;
    var fixedKey = $768324c25e5fceff$var$fixKey(unfixedKey);
    $768324c25e5fceff$var$_withStorageEl(function(storageEl) {
        storageEl.setAttribute(fixedKey, data);
        storageEl.save($768324c25e5fceff$var$storageName);
    });
}
function $768324c25e5fceff$var$read(unfixedKey) {
    if ($768324c25e5fceff$var$disable) return;
    var fixedKey = $768324c25e5fceff$var$fixKey(unfixedKey);
    var res = null;
    $768324c25e5fceff$var$_withStorageEl(function(storageEl) {
        res = storageEl.getAttribute(fixedKey);
    });
    return res;
}
function $768324c25e5fceff$var$each(callback) {
    $768324c25e5fceff$var$_withStorageEl(function(storageEl) {
        var attributes = storageEl.XMLDocument.documentElement.attributes;
        for(var i = attributes.length - 1; i >= 0; i--){
            var attr = attributes[i];
            callback(storageEl.getAttribute(attr.name), attr.name);
        }
    });
}
function $768324c25e5fceff$var$remove(unfixedKey) {
    var fixedKey = $768324c25e5fceff$var$fixKey(unfixedKey);
    $768324c25e5fceff$var$_withStorageEl(function(storageEl) {
        storageEl.removeAttribute(fixedKey);
        storageEl.save($768324c25e5fceff$var$storageName);
    });
}
function $768324c25e5fceff$var$clearAll() {
    $768324c25e5fceff$var$_withStorageEl(function(storageEl) {
        var attributes = storageEl.XMLDocument.documentElement.attributes;
        storageEl.load($768324c25e5fceff$var$storageName);
        for(var i = attributes.length - 1; i >= 0; i--)storageEl.removeAttribute(attributes[i].name);
        storageEl.save($768324c25e5fceff$var$storageName);
    });
}
// Helpers
//////////
// In IE7, keys cannot start with a digit or contain certain chars.
// See https://github.com/marcuswestin/store.js/issues/40
// See https://github.com/marcuswestin/store.js/issues/83
var $768324c25e5fceff$var$forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g");
function $768324c25e5fceff$var$fixKey(key) {
    return key.replace(/^\d/, '___$&').replace($768324c25e5fceff$var$forbiddenCharsRegex, '___');
}
function $768324c25e5fceff$var$_makeIEStorageElFunction() {
    if (!$768324c25e5fceff$var$doc || !$768324c25e5fceff$var$doc.documentElement || !$768324c25e5fceff$var$doc.documentElement.addBehavior) return null;
    var scriptTag = 'script', storageOwner, storageContainer, storageEl;
    // Since #userData storage applies only to specific paths, we need to
    // somehow link our data to a specific path.  We choose /favicon.ico
    // as a pretty safe option, since all browsers already make a request to
    // this URL anyway and being a 404 will not hurt us here.  We wrap an
    // iframe pointing to the favicon in an ActiveXObject(htmlfile) object
    // (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
    // since the iframe access rules appear to allow direct access and
    // manipulation of the document element, even for a 404 page.  This
    // document can be used instead of the current document (which would
    // have been limited to the current path) to perform #userData storage.
    try {
        /* global ActiveXObject */ storageContainer = new ActiveXObject('htmlfile');
        storageContainer.open();
        storageContainer.write('<' + scriptTag + '>document.w=window</' + scriptTag + '><iframe src="/favicon.ico"></iframe>');
        storageContainer.close();
        storageOwner = storageContainer.w.frames[0].document;
        storageEl = storageOwner.createElement('div');
    } catch (e) {
        // somehow ActiveXObject instantiation failed (perhaps some special
        // security settings or otherwse), fall back to per-path storage
        storageEl = $768324c25e5fceff$var$doc.createElement('div');
        storageOwner = $768324c25e5fceff$var$doc.body;
    }
    return function(storeFunction) {
        var args = [].slice.call(arguments, 0);
        args.unshift(storageEl);
        // See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
        // and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
        storageOwner.appendChild(storageEl);
        storageEl.addBehavior('#default#userData');
        storageEl.load($768324c25e5fceff$var$storageName);
        storeFunction.apply(this, args);
        storageOwner.removeChild(storageEl);
        return;
    };
}

});

parcelRegister("5e3On", function(module, exports) {
// cookieStorage is useful Safari private browser mode, where localStorage
// doesn't work but cookies do. This implementation is adopted from
// https://developer.mozilla.org/en-US/docs/Web/API/Storage/LocalStorage

var $ikdtY = parcelRequire("ikdtY");
var $3ce1377646e34fb8$var$Global = $ikdtY.Global;
var $3ce1377646e34fb8$var$trim = $ikdtY.trim;
module.exports = {
    name: 'cookieStorage',
    read: $3ce1377646e34fb8$var$read,
    write: $3ce1377646e34fb8$var$write,
    each: $3ce1377646e34fb8$var$each,
    remove: $3ce1377646e34fb8$var$remove,
    clearAll: $3ce1377646e34fb8$var$clearAll
};
var $3ce1377646e34fb8$var$doc = $3ce1377646e34fb8$var$Global.document;
function $3ce1377646e34fb8$var$read(key) {
    if (!key || !$3ce1377646e34fb8$var$_has(key)) return null;
    var regexpStr = "(?:^|.*;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*";
    return unescape($3ce1377646e34fb8$var$doc.cookie.replace(new RegExp(regexpStr), "$1"));
}
function $3ce1377646e34fb8$var$each(callback) {
    var cookies = $3ce1377646e34fb8$var$doc.cookie.split(/; ?/g);
    for(var i = cookies.length - 1; i >= 0; i--){
        if (!$3ce1377646e34fb8$var$trim(cookies[i])) continue;
        var kvp = cookies[i].split('=');
        var key = unescape(kvp[0]);
        var val = unescape(kvp[1]);
        callback(val, key);
    }
}
function $3ce1377646e34fb8$var$write(key, data) {
    if (!key) return;
    $3ce1377646e34fb8$var$doc.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/";
}
function $3ce1377646e34fb8$var$remove(key) {
    if (!key || !$3ce1377646e34fb8$var$_has(key)) return;
    $3ce1377646e34fb8$var$doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}
function $3ce1377646e34fb8$var$clearAll() {
    $3ce1377646e34fb8$var$each(function(_, key) {
        $3ce1377646e34fb8$var$remove(key);
    });
}
function $3ce1377646e34fb8$var$_has(key) {
    return new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test($3ce1377646e34fb8$var$doc.cookie);
}

});

parcelRegister("c7hcs", function(module, exports) {

var $ikdtY = parcelRequire("ikdtY");
var $8d237b0d6193578e$var$Global = $ikdtY.Global;
module.exports = {
    name: 'sessionStorage',
    read: $8d237b0d6193578e$var$read,
    write: $8d237b0d6193578e$var$write,
    each: $8d237b0d6193578e$var$each,
    remove: $8d237b0d6193578e$var$remove,
    clearAll: $8d237b0d6193578e$var$clearAll
};
function $8d237b0d6193578e$var$sessionStorage() {
    return $8d237b0d6193578e$var$Global.sessionStorage;
}
function $8d237b0d6193578e$var$read(key) {
    return $8d237b0d6193578e$var$sessionStorage().getItem(key);
}
function $8d237b0d6193578e$var$write(key, data) {
    return $8d237b0d6193578e$var$sessionStorage().setItem(key, data);
}
function $8d237b0d6193578e$var$each(fn) {
    for(var i = $8d237b0d6193578e$var$sessionStorage().length - 1; i >= 0; i--){
        var key = $8d237b0d6193578e$var$sessionStorage().key(i);
        fn($8d237b0d6193578e$var$read(key), key);
    }
}
function $8d237b0d6193578e$var$remove(key) {
    return $8d237b0d6193578e$var$sessionStorage().removeItem(key);
}
function $8d237b0d6193578e$var$clearAll() {
    return $8d237b0d6193578e$var$sessionStorage().clear();
}

});

parcelRegister("5VbDd", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: 'memoryStorage',
    read: $44fb4c67453040c2$var$read,
    write: $44fb4c67453040c2$var$write,
    each: $44fb4c67453040c2$var$each,
    remove: $44fb4c67453040c2$var$remove,
    clearAll: $44fb4c67453040c2$var$clearAll
};
var $44fb4c67453040c2$var$memoryStorage = {};
function $44fb4c67453040c2$var$read(key) {
    return $44fb4c67453040c2$var$memoryStorage[key];
}
function $44fb4c67453040c2$var$write(key, data) {
    $44fb4c67453040c2$var$memoryStorage[key] = data;
}
function $44fb4c67453040c2$var$each(callback) {
    for(var key in $44fb4c67453040c2$var$memoryStorage)if ($44fb4c67453040c2$var$memoryStorage.hasOwnProperty(key)) callback($44fb4c67453040c2$var$memoryStorage[key], key);
}
function $44fb4c67453040c2$var$remove(key) {
    delete $44fb4c67453040c2$var$memoryStorage[key];
}
function $44fb4c67453040c2$var$clearAll(key) {
    $44fb4c67453040c2$var$memoryStorage = {};
}

});

parcelRegister("hVpG1", function(module, exports) {
module.exports = $d0cbad6fe76f79c5$var$json2Plugin;

function $d0cbad6fe76f79c5$var$json2Plugin() {
    (parcelRequire("8ByVS"));
    return {};
}

});
parcelRegister("8ByVS", function(module, exports) {
/* eslint-disable */ //  json2.js
//  2016-10-28
//  Public Domain.
//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
//  See http://www.JSON.org/js.html
//  This code should be minified before deployment.
//  See http://javascript.crockford.com/jsmin.html
//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
//  NOT CONTROL.
//  This file creates a global JSON object containing two methods: stringify
//  and parse. This file provides the ES5 JSON capability to ES3 systems.
//  If a project might run on IE8 or earlier, then this file should be included.
//  This file does nothing on ES5 systems.
//      JSON.stringify(value, replacer, space)
//          value       any JavaScript value, usually an object or array.
//          replacer    an optional parameter that determines how object
//                      values are stringified for objects. It can be a
//                      function or an array of strings.
//          space       an optional parameter that specifies the indentation
//                      of nested structures. If it is omitted, the text will
//                      be packed without extra whitespace. If it is a number,
//                      it will specify the number of spaces to indent at each
//                      level. If it is a string (such as "\t" or "&nbsp;"),
//                      it contains the characters used to indent at each level.
//          This method produces a JSON text from a JavaScript value.
//          When an object value is found, if the object contains a toJSON
//          method, its toJSON method will be called and the result will be
//          stringified. A toJSON method does not serialize: it returns the
//          value represented by the name/value pair that should be serialized,
//          or undefined if nothing should be serialized. The toJSON method
//          will be passed the key associated with the value, and this will be
//          bound to the value.
//          For example, this would serialize Dates as ISO strings.
//              Date.prototype.toJSON = function (key) {
//                  function f(n) {
//                      // Format integers to have at least two digits.
//                      return (n < 10)
//                          ? "0" + n
//                          : n;
//                  }
//                  return this.getUTCFullYear()   + "-" +
//                       f(this.getUTCMonth() + 1) + "-" +
//                       f(this.getUTCDate())      + "T" +
//                       f(this.getUTCHours())     + ":" +
//                       f(this.getUTCMinutes())   + ":" +
//                       f(this.getUTCSeconds())   + "Z";
//              };
//          You can provide an optional replacer method. It will be passed the
//          key and value of each member, with this bound to the containing
//          object. The value that is returned from your method will be
//          serialized. If your method returns undefined, then the member will
//          be excluded from the serialization.
//          If the replacer parameter is an array of strings, then it will be
//          used to select the members to be serialized. It filters the results
//          such that only members with keys listed in the replacer array are
//          stringified.
//          Values that do not have JSON representations, such as undefined or
//          functions, will not be serialized. Such values in objects will be
//          dropped; in arrays they will be replaced with null. You can use
//          a replacer function to replace those with JSON values.
//          JSON.stringify(undefined) returns undefined.
//          The optional space parameter produces a stringification of the
//          value that is filled with line breaks and indentation to make it
//          easier to read.
//          If the space parameter is a non-empty string, then that string will
//          be used for indentation. If the space parameter is a number, then
//          the indentation will be that many spaces.
//          Example:
//          text = JSON.stringify(["e", {pluribus: "unum"}]);
//          // text is '["e",{"pluribus":"unum"}]'
//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'
//          text = JSON.stringify([new Date()], function (key, value) {
//              return this[key] instanceof Date
//                  ? "Date(" + this[key] + ")"
//                  : value;
//          });
//          // text is '["Date(---current time---)"]'
//      JSON.parse(text, reviver)
//          This method parses a JSON text to produce an object or array.
//          It can throw a SyntaxError exception.
//          The optional reviver parameter is a function that can filter and
//          transform the results. It receives each of the keys and values,
//          and its return value is used instead of the original value.
//          If it returns what it received, then the structure is not modified.
//          If it returns undefined then the member is deleted.
//          Example:
//          // Parse the text. Values that look like ISO date strings will
//          // be converted to Date objects.
//          myData = JSON.parse(text, function (key, value) {
//              var a;
//              if (typeof value === "string") {
//                  a =
//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
//                  if (a) {
//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
//                          +a[5], +a[6]));
//                  }
//              }
//              return value;
//          });
//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
//              var d;
//              if (typeof value === "string" &&
//                      value.slice(0, 5) === "Date(" &&
//                      value.slice(-1) === ")") {
//                  d = new Date(value.slice(5, -1));
//                  if (d) {
//                      return d;
//                  }
//              }
//              return value;
//          });
//  This is a reference implementation. You are free to copy, modify, or
//  redistribute.
/*jslint
    eval, for, this
*/ /*property
    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/ // Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.
if (typeof JSON !== "object") JSON = {};
(function() {
    "use strict";
    var rx_one = /^[\],:{}\s]*$/;
    var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
    var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
    var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
    var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    function f(n) {
        // Format integers to have at least two digits.
        return n < 10 ? "0" + n : n;
    }
    function this_value() {
        return this.valueOf();
    }
    if (typeof Date.prototype.toJSON !== "function") {
        Date.prototype.toJSON = function() {
            return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null;
        };
        Boolean.prototype.toJSON = this_value;
        Number.prototype.toJSON = this_value;
        String.prototype.toJSON = this_value;
    }
    var gap;
    var indent;
    var meta;
    var rep;
    function quote(string) {
        // If the string contains no control characters, no quote characters, and no
        // backslash characters, then we can safely slap some quotes around it.
        // Otherwise we must also replace the offending characters with safe escape
        // sequences.
        rx_escapable.lastIndex = 0;
        return rx_escapable.test(string) ? "\"" + string.replace(rx_escapable, function(a) {
            var c = meta[a];
            return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
        }) + "\"" : "\"" + string + "\"";
    }
    function str(key, holder) {
        // Produce a string from holder[key].
        var i; // The loop counter.
        var k; // The member key.
        var v; // The member value.
        var length;
        var mind = gap;
        var partial;
        var value = holder[key];
        // If the value has a toJSON method, call it to obtain a replacement value.
        if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
        // If we were called with a replacer function, then call the replacer to
        // obtain a replacement value.
        if (typeof rep === "function") value = rep.call(holder, key, value);
        // What happens next depends on the value's type.
        switch(typeof value){
            case "string":
                return quote(value);
            case "number":
                // JSON numbers must be finite. Encode non-finite numbers as null.
                return isFinite(value) ? String(value) : "null";
            case "boolean":
            case "null":
                // If the value is a boolean or null, convert it to a string. Note:
                // typeof null does not produce "null". The case is included here in
                // the remote chance that this gets fixed someday.
                return String(value);
            // If the type is "object", we might be dealing with an object or an array or
            // null.
            case "object":
                // Due to a specification blunder in ECMAScript, typeof null is "object",
                // so watch out for that case.
                if (!value) return "null";
                // Make an array to hold the partial results of stringifying this object value.
                gap += indent;
                partial = [];
                // Is the value an array?
                if (Object.prototype.toString.apply(value) === "[object Array]") {
                    // The value is an array. Stringify every element. Use null as a placeholder
                    // for non-JSON values.
                    length = value.length;
                    for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                    // Join all of the elements together, separated with commas, and wrap them in
                    // brackets.
                    v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                    gap = mind;
                    return v;
                }
                // If the replacer is an array, use it to select the members to be stringified.
                if (rep && typeof rep === "object") {
                    length = rep.length;
                    for(i = 0; i < length; i += 1)if (typeof rep[i] === "string") {
                        k = rep[i];
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                } else {
                    // Otherwise, iterate through all of the keys in the object.
                    for(k in value)if (Object.prototype.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                }
                // Join all of the member texts together, separated with commas,
                // and wrap them in braces.
                v = partial.length === 0 ? "{}" : gap ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" : "{" + partial.join(",") + "}";
                gap = mind;
                return v;
        }
    }
    // If the JSON object does not yet have a stringify method, give it one.
    if (typeof JSON.stringify !== "function") {
        meta = {
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            "\"": "\\\"",
            "\\": "\\\\"
        };
        JSON.stringify = function(value, replacer, space) {
            // The stringify method takes a value and an optional replacer, and an optional
            // space parameter, and returns a JSON text. The replacer can be a function
            // that can replace values, or an array of strings that will select the keys.
            // A default replacer method can be provided. Use of the space parameter can
            // produce text that is more easily readable.
            var i;
            gap = "";
            indent = "";
            // If the space parameter is a number, make an indent string containing that
            // many spaces.
            if (typeof space === "number") for(i = 0; i < space; i += 1)indent += " ";
            else if (typeof space === "string") indent = space;
            // If there is a replacer, it must be a function or an array.
            // Otherwise, throw an error.
            rep = replacer;
            if (replacer && typeof replacer !== "function" && (typeof replacer !== "object" || typeof replacer.length !== "number")) throw new Error("JSON.stringify");
            // Make a fake root object containing our value under the key of "".
            // Return the result of stringifying the value.
            return str("", {
                "": value
            });
        };
    }
    // If the JSON object does not yet have a parse method, give it one.
    if (typeof JSON.parse !== "function") JSON.parse = function(text, reviver) {
        // The parse method takes a text and an optional reviver function, and returns
        // a JavaScript value if the text is a valid JSON text.
        var j;
        function walk(holder, key) {
            // The walk method is used to recursively walk the resulting structure so
            // that modifications can be made.
            var k;
            var v;
            var value = holder[key];
            if (value && typeof value === "object") {
                for(k in value)if (Object.prototype.hasOwnProperty.call(value, k)) {
                    v = walk(value, k);
                    if (v !== undefined) value[k] = v;
                    else delete value[k];
                }
            }
            return reviver.call(holder, key, value);
        }
        // Parsing happens in four stages. In the first stage, we replace certain
        // Unicode characters with escape sequences. JavaScript handles many characters
        // incorrectly, either silently deleting them, or treating them as line endings.
        text = String(text);
        rx_dangerous.lastIndex = 0;
        if (rx_dangerous.test(text)) text = text.replace(rx_dangerous, function(a) {
            return "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
        });
        // In the second stage, we run the text against regular expressions that look
        // for non-JSON patterns. We are especially concerned with "()" and "new"
        // because they can cause invocation, and "=" because it can cause mutation.
        // But just to be safe, we want to reject all unexpected forms.
        // We split the second stage into 4 regexp operations in order to work around
        // crippling inefficiencies in IE's and Safari's regexp engines. First we
        // replace the JSON backslash pairs with "@" (a non-JSON character). Second, we
        // replace all simple value tokens with "]" characters. Third, we delete all
        // open brackets that follow a colon or comma or that begin the text. Finally,
        // we look to see that the remaining characters are only whitespace or "]" or
        // "," or ":" or "{" or "}". If that is so, then the text is safe for eval.
        if (rx_one.test(text.replace(rx_two, "@").replace(rx_three, "]").replace(rx_four, ""))) {
            // In the third stage we use the eval function to compile the text into a
            // JavaScript structure. The "{" operator is subject to a syntactic ambiguity
            // in JavaScript: it can begin a block or an object literal. We wrap the text
            // in parens to eliminate the ambiguity.
            j = eval("(" + text + ")");
            // In the optional fourth stage, we recursively walk the new structure, passing
            // each name/value pair to a reviver function for possible transformation.
            return typeof reviver === "function" ? walk({
                "": j
            }, "") : j;
        }
        // If the text is not JSON parseable, then a SyntaxError is thrown.
        throw new SyntaxError("JSON.parse");
    };
})();

});


var $607ae91d1eb97195$exports = {};
'use strict';

$607ae91d1eb97195$exports = (parcelRequire("irwyI"));


parcelRequire("8vqx4");
var $ffa230115876cfd8$exports = {};
'use strict';
function $ffa230115876cfd8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($ffa230115876cfd8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$ffa230115876cfd8$var$checkDCE();

$ffa230115876cfd8$exports = (parcelRequire("5xaMB"));


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8vqx4 = parcelRequire("8vqx4");

var $hiyfL = parcelRequire("hiyfL");
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1ea4a0cb853f5c10$var$_extends() {
    $1ea4a0cb853f5c10$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1ea4a0cb853f5c10$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1ea4a0cb853f5c10$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1ea4a0cb853f5c10$export$e19cd5f9376f8cee || ($1ea4a0cb853f5c10$export$e19cd5f9376f8cee = {}));
const $1ea4a0cb853f5c10$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1ea4a0cb853f5c10$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1ea4a0cb853f5c10$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1ea4a0cb853f5c10$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1ea4a0cb853f5c10$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1ea4a0cb853f5c10$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1ea4a0cb853f5c10$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1ea4a0cb853f5c10$export$fe53371bee54353d(to);
    }
    return $1ea4a0cb853f5c10$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1ea4a0cb853f5c10$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1ea4a0cb853f5c10$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1ea4a0cb853f5c10$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1ea4a0cb853f5c10$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1ea4a0cb853f5c10$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1ea4a0cb853f5c10$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1ea4a0cb853f5c10$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1ea4a0cb853f5c10$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1ea4a0cb853f5c10$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1ea4a0cb853f5c10$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1ea4a0cb853f5c10$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1ea4a0cb853f5c10$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1ea4a0cb853f5c10$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1ea4a0cb853f5c10$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1ea4a0cb853f5c10$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Push;
        let location = $1ea4a0cb853f5c10$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1ea4a0cb853f5c10$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Replace;
        let location = $1ea4a0cb853f5c10$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1ea4a0cb853f5c10$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1ea4a0cb853f5c10$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1ea4a0cb853f5c10$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1ea4a0cb853f5c10$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1ea4a0cb853f5c10$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1ea4a0cb853f5c10$var$ResultType || ($1ea4a0cb853f5c10$var$ResultType = {}));
const $1ea4a0cb853f5c10$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1ea4a0cb853f5c10$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1ea4a0cb853f5c10$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1ea4a0cb853f5c10$var$isIndexRoute(route)) {
            let indexRoute = $1ea4a0cb853f5c10$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1ea4a0cb853f5c10$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1ea4a0cb853f5c10$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1ea4a0cb853f5c10$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1ea4a0cb853f5c10$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1ea4a0cb853f5c10$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1ea4a0cb853f5c10$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1ea4a0cb853f5c10$var$flattenRoutes(routes);
    $1ea4a0cb853f5c10$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1ea4a0cb853f5c10$export$30d21fd6d7295f52(pathname);
        matches = $1ea4a0cb853f5c10$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1ea4a0cb853f5c10$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1ea4a0cb853f5c10$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1ea4a0cb853f5c10$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1ea4a0cb853f5c10$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1ea4a0cb853f5c10$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1ea4a0cb853f5c10$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1ea4a0cb853f5c10$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1ea4a0cb853f5c10$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1ea4a0cb853f5c10$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1ea4a0cb853f5c10$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1ea4a0cb853f5c10$var$paramRe = /^:[\w-]+$/;
const $1ea4a0cb853f5c10$var$dynamicSegmentValue = 3;
const $1ea4a0cb853f5c10$var$indexRouteValue = 2;
const $1ea4a0cb853f5c10$var$emptySegmentValue = 1;
const $1ea4a0cb853f5c10$var$staticSegmentValue = 10;
const $1ea4a0cb853f5c10$var$splatPenalty = -2;
const $1ea4a0cb853f5c10$var$isSplat = (s)=>s === "*";
function $1ea4a0cb853f5c10$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1ea4a0cb853f5c10$var$isSplat)) initialScore += $1ea4a0cb853f5c10$var$splatPenalty;
    if (index) initialScore += $1ea4a0cb853f5c10$var$indexRouteValue;
    return segments.filter((s)=>!$1ea4a0cb853f5c10$var$isSplat(s)).reduce((score, segment)=>score + ($1ea4a0cb853f5c10$var$paramRe.test(segment) ? $1ea4a0cb853f5c10$var$dynamicSegmentValue : segment === "" ? $1ea4a0cb853f5c10$var$emptySegmentValue : $1ea4a0cb853f5c10$var$staticSegmentValue), initialScore);
}
function $1ea4a0cb853f5c10$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1ea4a0cb853f5c10$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1ea4a0cb853f5c10$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1ea4a0cb853f5c10$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1ea4a0cb853f5c10$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1ea4a0cb853f5c10$export$a5c6d149b50c1d86($1ea4a0cb853f5c10$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1ea4a0cb853f5c10$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1ea4a0cb853f5c10$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1ea4a0cb853f5c10$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1ea4a0cb853f5c10$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1ea4a0cb853f5c10$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1ea4a0cb853f5c10$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1ea4a0cb853f5c10$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1ea4a0cb853f5c10$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1ea4a0cb853f5c10$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1ea4a0cb853f5c10$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1ea4a0cb853f5c10$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1ea4a0cb853f5c10$var$isAbsoluteUrl = (url)=>$1ea4a0cb853f5c10$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1ea4a0cb853f5c10$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1ea4a0cb853f5c10$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $1ea4a0cb853f5c10$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1ea4a0cb853f5c10$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1ea4a0cb853f5c10$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1ea4a0cb853f5c10$var$normalizeSearch(search),
        hash: $1ea4a0cb853f5c10$var$normalizeHash(hash)
    };
}
function $1ea4a0cb853f5c10$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1ea4a0cb853f5c10$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1ea4a0cb853f5c10$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1ea4a0cb853f5c10$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1ea4a0cb853f5c10$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1ea4a0cb853f5c10$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1ea4a0cb853f5c10$var$_extends({}, toArg);
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1ea4a0cb853f5c10$var$getInvalidPathError("?", "pathname", "search", to));
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1ea4a0cb853f5c10$var$getInvalidPathError("#", "pathname", "hash", to));
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1ea4a0cb853f5c10$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1ea4a0cb853f5c10$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1ea4a0cb853f5c10$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1ea4a0cb853f5c10$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1ea4a0cb853f5c10$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1ea4a0cb853f5c10$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1ea4a0cb853f5c10$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1ea4a0cb853f5c10$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1ea4a0cb853f5c10$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1ea4a0cb853f5c10$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1ea4a0cb853f5c10$export$4051a07651545597(data, init) {
    return new $1ea4a0cb853f5c10$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1ea4a0cb853f5c10$export$42a99a7a4bc0e76a extends Error {
}
class $1ea4a0cb853f5c10$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1ea4a0cb853f5c10$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1ea4a0cb853f5c10$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1ea4a0cb853f5c10$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1ea4a0cb853f5c10$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1ea4a0cb853f5c10$var$unwrapTrackedPromise(value) {
    if (!$1ea4a0cb853f5c10$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1ea4a0cb853f5c10$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1ea4a0cb853f5c10$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1ea4a0cb853f5c10$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1ea4a0cb853f5c10$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1ea4a0cb853f5c10$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1ea4a0cb853f5c10$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1ea4a0cb853f5c10$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1ea4a0cb853f5c10$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1ea4a0cb853f5c10$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1ea4a0cb853f5c10$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1ea4a0cb853f5c10$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1ea4a0cb853f5c10$var$validMutationMethods = new Set($1ea4a0cb853f5c10$var$validMutationMethodsArr);
const $1ea4a0cb853f5c10$var$validRequestMethodsArr = [
    "get",
    ...$1ea4a0cb853f5c10$var$validMutationMethodsArr
];
const $1ea4a0cb853f5c10$var$validRequestMethods = new Set($1ea4a0cb853f5c10$var$validRequestMethodsArr);
const $1ea4a0cb853f5c10$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1ea4a0cb853f5c10$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1ea4a0cb853f5c10$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1ea4a0cb853f5c10$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1ea4a0cb853f5c10$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1ea4a0cb853f5c10$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1ea4a0cb853f5c10$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1ea4a0cb853f5c10$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1ea4a0cb853f5c10$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1ea4a0cb853f5c10$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1ea4a0cb853f5c10$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1ea4a0cb853f5c10$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1ea4a0cb853f5c10$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1ea4a0cb853f5c10$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1ea4a0cb853f5c10$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1ea4a0cb853f5c10$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1ea4a0cb853f5c10$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1ea4a0cb853f5c10$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1ea4a0cb853f5c10$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1ea4a0cb853f5c10$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1ea4a0cb853f5c10$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1ea4a0cb853f5c10$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1ea4a0cb853f5c10$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1ea4a0cb853f5c10$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1ea4a0cb853f5c10$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1ea4a0cb853f5c10$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1ea4a0cb853f5c10$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1ea4a0cb853f5c10$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1ea4a0cb853f5c10$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1ea4a0cb853f5c10$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1ea4a0cb853f5c10$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1ea4a0cb853f5c10$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1ea4a0cb853f5c10$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1ea4a0cb853f5c10$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1ea4a0cb853f5c10$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1ea4a0cb853f5c10$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1ea4a0cb853f5c10$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1ea4a0cb853f5c10$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1ea4a0cb853f5c10$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1ea4a0cb853f5c10$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1ea4a0cb853f5c10$var$findNearestBoundary(matches).route.id,
            {
                type: $1ea4a0cb853f5c10$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1ea4a0cb853f5c10$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1ea4a0cb853f5c10$var$isErrorResult(result) && $1ea4a0cb853f5c10$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1ea4a0cb853f5c10$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1ea4a0cb853f5c10$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1ea4a0cb853f5c10$var$_extends({
            matches: updatedMatches || matches
        }, $1ea4a0cb853f5c10$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1ea4a0cb853f5c10$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1ea4a0cb853f5c10$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1ea4a0cb853f5c10$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1ea4a0cb853f5c10$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1ea4a0cb853f5c10$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1ea4a0cb853f5c10$var$ResultType.error,
            error: $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1ea4a0cb853f5c10$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1ea4a0cb853f5c10$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1ea4a0cb853f5c10$var$isDeferredResult(result)) throw $1ea4a0cb853f5c10$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1ea4a0cb853f5c10$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1ea4a0cb853f5c10$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1ea4a0cb853f5c10$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1ea4a0cb853f5c10$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1ea4a0cb853f5c10$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1ea4a0cb853f5c10$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1ea4a0cb853f5c10$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1ea4a0cb853f5c10$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1ea4a0cb853f5c10$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1ea4a0cb853f5c10$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1ea4a0cb853f5c10$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1ea4a0cb853f5c10$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1ea4a0cb853f5c10$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1ea4a0cb853f5c10$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1ea4a0cb853f5c10$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1ea4a0cb853f5c10$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1ea4a0cb853f5c10$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1ea4a0cb853f5c10$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1ea4a0cb853f5c10$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1ea4a0cb853f5c10$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1ea4a0cb853f5c10$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1ea4a0cb853f5c10$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1ea4a0cb853f5c10$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1ea4a0cb853f5c10$var$isRedirectResult(actionResult) || $1ea4a0cb853f5c10$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1ea4a0cb853f5c10$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1ea4a0cb853f5c10$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1ea4a0cb853f5c10$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1ea4a0cb853f5c10$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1ea4a0cb853f5c10$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1ea4a0cb853f5c10$var$isDeferredResult(actionResult)) throw $1ea4a0cb853f5c10$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1ea4a0cb853f5c10$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1ea4a0cb853f5c10$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1ea4a0cb853f5c10$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1ea4a0cb853f5c10$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1ea4a0cb853f5c10$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1ea4a0cb853f5c10$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1ea4a0cb853f5c10$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1ea4a0cb853f5c10$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1ea4a0cb853f5c10$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1ea4a0cb853f5c10$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1ea4a0cb853f5c10$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1ea4a0cb853f5c10$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1ea4a0cb853f5c10$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1ea4a0cb853f5c10$var$isDeferredResult(result)) result = await $1ea4a0cb853f5c10$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1ea4a0cb853f5c10$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1ea4a0cb853f5c10$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1ea4a0cb853f5c10$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1ea4a0cb853f5c10$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(!$1ea4a0cb853f5c10$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1ea4a0cb853f5c10$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1ea4a0cb853f5c10$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1ea4a0cb853f5c10$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1ea4a0cb853f5c10$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1ea4a0cb853f5c10$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Replace : $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1ea4a0cb853f5c10$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1ea4a0cb853f5c10$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1ea4a0cb853f5c10$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1ea4a0cb853f5c10$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1ea4a0cb853f5c10$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1ea4a0cb853f5c10$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1ea4a0cb853f5c10$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1ea4a0cb853f5c10$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1ea4a0cb853f5c10$var$ResultType.redirect,
                response: $1ea4a0cb853f5c10$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1ea4a0cb853f5c10$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1ea4a0cb853f5c10$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1ea4a0cb853f5c10$var$ResultType.error,
                    error: $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1ea4a0cb853f5c10$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1ea4a0cb853f5c10$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1ea4a0cb853f5c10$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1ea4a0cb853f5c10$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1ea4a0cb853f5c10$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1ea4a0cb853f5c10$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1ea4a0cb853f5c10$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1ea4a0cb853f5c10$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1ea4a0cb853f5c10$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1ea4a0cb853f5c10$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1ea4a0cb853f5c10$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1ea4a0cb853f5c10$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1ea4a0cb853f5c10$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1ea4a0cb853f5c10$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1ea4a0cb853f5c10$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1ea4a0cb853f5c10$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1ea4a0cb853f5c10$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1ea4a0cb853f5c10$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1ea4a0cb853f5c10$export$4d0306f8f6a4585b = Symbol("deferred");
function $1ea4a0cb853f5c10$export$3336b097a6fbc59a(routes, opts) {
    $1ea4a0cb853f5c10$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1ea4a0cb853f5c10$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1ea4a0cb853f5c10$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1ea4a0cb853f5c10$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1ea4a0cb853f5c10$var$createLocation("", $1ea4a0cb853f5c10$export$fe53371bee54353d(url), null, "default");
        let matches = $1ea4a0cb853f5c10$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1ea4a0cb853f5c10$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1ea4a0cb853f5c10$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1ea4a0cb853f5c10$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1ea4a0cb853f5c10$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1ea4a0cb853f5c10$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1ea4a0cb853f5c10$var$createLocation("", $1ea4a0cb853f5c10$export$fe53371bee54353d(url), null, "default");
        let matches = $1ea4a0cb853f5c10$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1ea4a0cb853f5c10$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1ea4a0cb853f5c10$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1ea4a0cb853f5c10$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1ea4a0cb853f5c10$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1ea4a0cb853f5c10$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1ea4a0cb853f5c10$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1ea4a0cb853f5c10$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1ea4a0cb853f5c10$var$isResponse(result) ? result : $1ea4a0cb853f5c10$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1ea4a0cb853f5c10$var$isDataStrategyResult(e) && $1ea4a0cb853f5c10$var$isResponse(e.result)) {
                if (e.type === $1ea4a0cb853f5c10$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1ea4a0cb853f5c10$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1ea4a0cb853f5c10$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1ea4a0cb853f5c10$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1ea4a0cb853f5c10$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1ea4a0cb853f5c10$var$isDeferredResult(result)) {
            let error = $1ea4a0cb853f5c10$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1ea4a0cb853f5c10$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1ea4a0cb853f5c10$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1ea4a0cb853f5c10$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1ea4a0cb853f5c10$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1ea4a0cb853f5c10$var$_extends({}, context, {
                statusCode: $1ea4a0cb853f5c10$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1ea4a0cb853f5c10$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1ea4a0cb853f5c10$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1ea4a0cb853f5c10$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1]) ? $1ea4a0cb853f5c10$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1ea4a0cb853f5c10$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1ea4a0cb853f5c10$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1ea4a0cb853f5c10$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1ea4a0cb853f5c10$var$callDataStrategyImpl(dataStrategy || $1ea4a0cb853f5c10$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1ea4a0cb853f5c10$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1ea4a0cb853f5c10$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1ea4a0cb853f5c10$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1ea4a0cb853f5c10$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1ea4a0cb853f5c10$export$fec11da027c70692(routes, context, error) {
    let newContext = $1ea4a0cb853f5c10$var$_extends({}, context, {
        statusCode: $1ea4a0cb853f5c10$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1ea4a0cb853f5c10$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1ea4a0cb853f5c10$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1ea4a0cb853f5c10$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1ea4a0cb853f5c10$export$cae722b0cc860f13(to ? to : ".", $1ea4a0cb853f5c10$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1ea4a0cb853f5c10$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1ea4a0cb853f5c10$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1ea4a0cb853f5c10$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1ea4a0cb853f5c10$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1ea4a0cb853f5c10$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1ea4a0cb853f5c10$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1ea4a0cb853f5c10$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1ea4a0cb853f5c10$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1ea4a0cb853f5c10$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1ea4a0cb853f5c10$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1ea4a0cb853f5c10$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1ea4a0cb853f5c10$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1ea4a0cb853f5c10$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1ea4a0cb853f5c10$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1ea4a0cb853f5c10$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1ea4a0cb853f5c10$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1ea4a0cb853f5c10$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1ea4a0cb853f5c10$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1ea4a0cb853f5c10$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1ea4a0cb853f5c10$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1ea4a0cb853f5c10$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1ea4a0cb853f5c10$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1ea4a0cb853f5c10$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1ea4a0cb853f5c10$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1ea4a0cb853f5c10$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1ea4a0cb853f5c10$var$shouldRevalidateLoader(match, $1ea4a0cb853f5c10$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1ea4a0cb853f5c10$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1ea4a0cb853f5c10$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1ea4a0cb853f5c10$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1ea4a0cb853f5c10$var$shouldRevalidateLoader(fetcherMatch, $1ea4a0cb853f5c10$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1ea4a0cb853f5c10$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1ea4a0cb853f5c10$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1ea4a0cb853f5c10$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1ea4a0cb853f5c10$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1ea4a0cb853f5c10$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1ea4a0cb853f5c10$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1ea4a0cb853f5c10$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1ea4a0cb853f5c10$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1ea4a0cb853f5c10$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1ea4a0cb853f5c10$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1ea4a0cb853f5c10$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1ea4a0cb853f5c10$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1ea4a0cb853f5c10$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1ea4a0cb853f5c10$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1ea4a0cb853f5c10$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1ea4a0cb853f5c10$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1ea4a0cb853f5c10$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1ea4a0cb853f5c10$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1ea4a0cb853f5c10$var$ResultType.data,
                result: undefined
            });
        };
        return $1ea4a0cb853f5c10$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1ea4a0cb853f5c10$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1ea4a0cb853f5c10$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1ea4a0cb853f5c10$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1ea4a0cb853f5c10$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1ea4a0cb853f5c10$var$ResultType.error,
                error: e
            };
        }
        if (type === $1ea4a0cb853f5c10$var$ResultType.error) return {
            type: $1ea4a0cb853f5c10$var$ResultType.error,
            error: new $1ea4a0cb853f5c10$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1ea4a0cb853f5c10$var$ResultType.error) {
        if ($1ea4a0cb853f5c10$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1ea4a0cb853f5c10$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1ea4a0cb853f5c10$var$ResultType.error,
                error: new $1ea4a0cb853f5c10$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1ea4a0cb853f5c10$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.error,
            error: result,
            statusCode: $1ea4a0cb853f5c10$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1ea4a0cb853f5c10$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1ea4a0cb853f5c10$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1ea4a0cb853f5c10$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1ea4a0cb853f5c10$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1ea4a0cb853f5c10$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1ea4a0cb853f5c10$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1ea4a0cb853f5c10$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1ea4a0cb853f5c10$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1ea4a0cb853f5c10$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1ea4a0cb853f5c10$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1ea4a0cb853f5c10$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1ea4a0cb853f5c10$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1ea4a0cb853f5c10$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1ea4a0cb853f5c10$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1ea4a0cb853f5c10$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1ea4a0cb853f5c10$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1ea4a0cb853f5c10$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(!$1ea4a0cb853f5c10$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1ea4a0cb853f5c10$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1ea4a0cb853f5c10$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1ea4a0cb853f5c10$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1ea4a0cb853f5c10$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1ea4a0cb853f5c10$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1ea4a0cb853f5c10$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1ea4a0cb853f5c10$var$isErrorResult(result)) {
            let boundaryMatch = $1ea4a0cb853f5c10$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1ea4a0cb853f5c10$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1ea4a0cb853f5c10$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1ea4a0cb853f5c10$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1ea4a0cb853f5c10$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1ea4a0cb853f5c10$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1ea4a0cb853f5c10$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1ea4a0cb853f5c10$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1ea4a0cb853f5c10$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1ea4a0cb853f5c10$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1ea4a0cb853f5c10$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1ea4a0cb853f5c10$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1ea4a0cb853f5c10$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1ea4a0cb853f5c10$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1ea4a0cb853f5c10$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(path) : path;
    return $1ea4a0cb853f5c10$export$fe53371bee54353d($1ea4a0cb853f5c10$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1ea4a0cb853f5c10$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1ea4a0cb853f5c10$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1ea4a0cb853f5c10$var$ResultType.data || result.type === $1ea4a0cb853f5c10$var$ResultType.error);
}
function $1ea4a0cb853f5c10$var$isRedirectDataStrategyResultResult(result) {
    return $1ea4a0cb853f5c10$var$isResponse(result.result) && $1ea4a0cb853f5c10$var$redirectStatusCodes.has(result.result.status);
}
function $1ea4a0cb853f5c10$var$isDeferredResult(result) {
    return result.type === $1ea4a0cb853f5c10$var$ResultType.deferred;
}
function $1ea4a0cb853f5c10$var$isErrorResult(result) {
    return result.type === $1ea4a0cb853f5c10$var$ResultType.error;
}
function $1ea4a0cb853f5c10$var$isRedirectResult(result) {
    return (result && result.type) === $1ea4a0cb853f5c10$var$ResultType.redirect;
}
function $1ea4a0cb853f5c10$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1ea4a0cb853f5c10$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1ea4a0cb853f5c10$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1ea4a0cb853f5c10$var$isRedirectResponse(result) {
    if (!$1ea4a0cb853f5c10$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1ea4a0cb853f5c10$var$isValidMethod(method) {
    return $1ea4a0cb853f5c10$var$validRequestMethods.has(method.toLowerCase());
}
function $1ea4a0cb853f5c10$var$isMutationMethod(method) {
    return $1ea4a0cb853f5c10$var$validMutationMethods.has(method.toLowerCase());
}
async function $1ea4a0cb853f5c10$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1ea4a0cb853f5c10$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1ea4a0cb853f5c10$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1ea4a0cb853f5c10$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1ea4a0cb853f5c10$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1ea4a0cb853f5c10$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1ea4a0cb853f5c10$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1ea4a0cb853f5c10$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1ea4a0cb853f5c10$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1ea4a0cb853f5c10$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1ea4a0cb853f5c10$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1ea4a0cb853f5c10$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1ea4a0cb853f5c10$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1ea4a0cb853f5c10$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1ea4a0cb853f5c10$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1ea4a0cb853f5c10$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1ea4a0cb853f5c10$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1ea4a0cb853f5c10$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1ea4a0cb853f5c10$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1ea4a0cb853f5c10$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1ea4a0cb853f5c10$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1ea4a0cb853f5c10$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1ea4a0cb853f5c10$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1ea4a0cb853f5c10$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8vqx4 = parcelRequire("8vqx4");

function $68c2f6a70206c369$var$_extends() {
    $68c2f6a70206c369$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $68c2f6a70206c369$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $68c2f6a70206c369$export$3add0d5dce533e2e = /*#__PURE__*/ $8vqx4.createContext(null);
const $68c2f6a70206c369$export$145dfa71566a64dc = /*#__PURE__*/ $8vqx4.createContext(null);
const $68c2f6a70206c369$var$AwaitContext = /*#__PURE__*/ $8vqx4.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $68c2f6a70206c369$export$26749e8557646306 = /*#__PURE__*/ $8vqx4.createContext(null);
const $68c2f6a70206c369$export$c7914228fb69b0f5 = /*#__PURE__*/ $8vqx4.createContext(null);
const $68c2f6a70206c369$export$9072aa6dd1f93057 = /*#__PURE__*/ $8vqx4.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $68c2f6a70206c369$var$RouteErrorContext = /*#__PURE__*/ $8vqx4.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $68c2f6a70206c369$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$68c2f6a70206c369$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $8vqx4.useContext($68c2f6a70206c369$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $68c2f6a70206c369$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1ea4a0cb853f5c10$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $68c2f6a70206c369$export$9c954a9d03d32f4a() {
    return $8vqx4.useContext($68c2f6a70206c369$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $68c2f6a70206c369$export$45d76561a5302f2b() {
    !$68c2f6a70206c369$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return $8vqx4.useContext($68c2f6a70206c369$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $68c2f6a70206c369$export$1b3f31771c5d07c() {
    return $8vqx4.useContext($68c2f6a70206c369$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $68c2f6a70206c369$export$6c330e8992e8a295(pattern) {
    !$68c2f6a70206c369$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $68c2f6a70206c369$export$45d76561a5302f2b();
    return $8vqx4.useMemo(()=>(0, $1ea4a0cb853f5c10$export$81336c211d5ff295)(pattern, (0, $1ea4a0cb853f5c10$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $68c2f6a70206c369$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $68c2f6a70206c369$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8vqx4.useContext($68c2f6a70206c369$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8vqx4.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $68c2f6a70206c369$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8vqx4.useContext($68c2f6a70206c369$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $68c2f6a70206c369$var$useNavigateStable() : $68c2f6a70206c369$var$useNavigateUnstable();
}
function $68c2f6a70206c369$var$useNavigateUnstable() {
    !$68c2f6a70206c369$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let dataRouterContext = $8vqx4.useContext($68c2f6a70206c369$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8vqx4.useContext($68c2f6a70206c369$export$26749e8557646306);
    let { matches: matches } = $8vqx4.useContext($68c2f6a70206c369$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $68c2f6a70206c369$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1ea4a0cb853f5c10$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8vqx4.useRef(false);
    $68c2f6a70206c369$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8vqx4.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1ea4a0cb853f5c10$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1ea4a0cb853f5c10$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $68c2f6a70206c369$var$OutletContext = /*#__PURE__*/ $8vqx4.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $68c2f6a70206c369$export$4138103a3ae699cc() {
    return $8vqx4.useContext($68c2f6a70206c369$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $68c2f6a70206c369$export$a3be3530d8e40d0b(context) {
    let outlet = $8vqx4.useContext($68c2f6a70206c369$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $68c2f6a70206c369$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8vqx4.useContext($68c2f6a70206c369$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $68c2f6a70206c369$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8vqx4.useContext($68c2f6a70206c369$export$26749e8557646306);
    let { matches: matches } = $8vqx4.useContext($68c2f6a70206c369$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $68c2f6a70206c369$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1ea4a0cb853f5c10$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8vqx4.useMemo(()=>(0, $1ea4a0cb853f5c10$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $68c2f6a70206c369$export$5d3fca4a98652595(routes, locationArg) {
    return $68c2f6a70206c369$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $68c2f6a70206c369$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$68c2f6a70206c369$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $8vqx4.useContext($68c2f6a70206c369$export$26749e8557646306);
    let { matches: parentMatches } = $8vqx4.useContext($68c2f6a70206c369$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $68c2f6a70206c369$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1ea4a0cb853f5c10$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1ea4a0cb853f5c10$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $68c2f6a70206c369$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1ea4a0cb853f5c10$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1ea4a0cb853f5c10$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $68c2f6a70206c369$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1ea4a0cb853f5c10$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $68c2f6a70206c369$var$DefaultErrorComponent() {
    let error = $68c2f6a70206c369$export$ed527bf60f6e05f2();
    let message = (0, $1ea4a0cb853f5c10$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8vqx4.createElement($8vqx4.Fragment, null, /*#__PURE__*/ $8vqx4.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8vqx4.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8vqx4.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $68c2f6a70206c369$var$defaultErrorElement = /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$var$DefaultErrorComponent, null);
class $68c2f6a70206c369$var$RenderErrorBoundary extends $8vqx4.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $68c2f6a70206c369$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8vqx4.useContext($68c2f6a70206c369$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $68c2f6a70206c369$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $68c2f6a70206c369$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $68c2f6a70206c369$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8vqx4.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $68c2f6a70206c369$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($68c2f6a70206c369$var$DataRouterHook || {});
var $68c2f6a70206c369$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($68c2f6a70206c369$var$DataRouterStateHook || {});
function $68c2f6a70206c369$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $68c2f6a70206c369$var$useDataRouterContext(hookName) {
    let ctx = $8vqx4.useContext($68c2f6a70206c369$export$3add0d5dce533e2e);
    !ctx && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return ctx;
}
function $68c2f6a70206c369$var$useDataRouterState(hookName) {
    let state = $8vqx4.useContext($68c2f6a70206c369$export$145dfa71566a64dc);
    !state && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return state;
}
function $68c2f6a70206c369$var$useRouteContext(hookName) {
    let route = $8vqx4.useContext($68c2f6a70206c369$export$9072aa6dd1f93057);
    !route && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $68c2f6a70206c369$var$useCurrentRouteId(hookName) {
    let route = $68c2f6a70206c369$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $68c2f6a70206c369$export$5fc8298006ad9e58() {
    return $68c2f6a70206c369$var$useCurrentRouteId($68c2f6a70206c369$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $68c2f6a70206c369$export$d0fd4b7106de2769() {
    let state = $68c2f6a70206c369$var$useDataRouterState($68c2f6a70206c369$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $68c2f6a70206c369$export$600dc272ed516c15() {
    let dataRouterContext = $68c2f6a70206c369$var$useDataRouterContext($68c2f6a70206c369$var$DataRouterHook.UseRevalidator);
    let state = $68c2f6a70206c369$var$useDataRouterState($68c2f6a70206c369$var$DataRouterStateHook.UseRevalidator);
    return $8vqx4.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $68c2f6a70206c369$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $68c2f6a70206c369$var$useDataRouterState($68c2f6a70206c369$var$DataRouterStateHook.UseMatches);
    return $8vqx4.useMemo(()=>matches.map((m)=>(0, $1ea4a0cb853f5c10$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $68c2f6a70206c369$export$1448a5050d252c4d() {
    let state = $68c2f6a70206c369$var$useDataRouterState($68c2f6a70206c369$var$DataRouterStateHook.UseLoaderData);
    let routeId = $68c2f6a70206c369$var$useCurrentRouteId($68c2f6a70206c369$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $68c2f6a70206c369$export$fd5d37484eab868d(routeId) {
    let state = $68c2f6a70206c369$var$useDataRouterState($68c2f6a70206c369$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $68c2f6a70206c369$export$fdc00f3f26066d5e() {
    let state = $68c2f6a70206c369$var$useDataRouterState($68c2f6a70206c369$var$DataRouterStateHook.UseActionData);
    let routeId = $68c2f6a70206c369$var$useCurrentRouteId($68c2f6a70206c369$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $68c2f6a70206c369$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8vqx4.useContext($68c2f6a70206c369$var$RouteErrorContext);
    let state = $68c2f6a70206c369$var$useDataRouterState($68c2f6a70206c369$var$DataRouterStateHook.UseRouteError);
    let routeId = $68c2f6a70206c369$var$useCurrentRouteId($68c2f6a70206c369$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $68c2f6a70206c369$export$78a72ddb39bdd145() {
    let value = $8vqx4.useContext($68c2f6a70206c369$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $68c2f6a70206c369$export$17f53340677d5831() {
    let value = $8vqx4.useContext($68c2f6a70206c369$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $68c2f6a70206c369$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $68c2f6a70206c369$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $68c2f6a70206c369$var$useDataRouterContext($68c2f6a70206c369$var$DataRouterHook.UseBlocker);
    let state = $68c2f6a70206c369$var$useDataRouterState($68c2f6a70206c369$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8vqx4.useState("");
    let blockerFunction = $8vqx4.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $68c2f6a70206c369$var$_extends({}, currentLocation, {
                pathname: (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $68c2f6a70206c369$var$_extends({}, nextLocation, {
                pathname: (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8vqx4.useEffect(()=>{
        let key = String(++$68c2f6a70206c369$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8vqx4.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1ea4a0cb853f5c10$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $68c2f6a70206c369$var$useNavigateStable() {
    let { router: router } = $68c2f6a70206c369$var$useDataRouterContext($68c2f6a70206c369$var$DataRouterHook.UseNavigateStable);
    let id = $68c2f6a70206c369$var$useCurrentRouteId($68c2f6a70206c369$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8vqx4.useRef(false);
    $68c2f6a70206c369$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8vqx4.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $68c2f6a70206c369$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $68c2f6a70206c369$var$alreadyWarned$1 = {};
function $68c2f6a70206c369$var$warningOnce(key, cond, message) {
    if (!cond && !$68c2f6a70206c369$var$alreadyWarned$1[key]) $68c2f6a70206c369$var$alreadyWarned$1[key] = true;
}
const $68c2f6a70206c369$var$alreadyWarned = {};
function $68c2f6a70206c369$var$warnOnce(key, message) {}
const $68c2f6a70206c369$var$logDeprecation = (flag, msg, link)=>$68c2f6a70206c369$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $68c2f6a70206c369$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $68c2f6a70206c369$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $68c2f6a70206c369$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $68c2f6a70206c369$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $68c2f6a70206c369$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $68c2f6a70206c369$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $68c2f6a70206c369$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $68c2f6a70206c369$var$START_TRANSITION = "startTransition";
const $68c2f6a70206c369$var$startTransitionImpl = $8vqx4[$68c2f6a70206c369$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $68c2f6a70206c369$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8vqx4.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8vqx4.useCallback((newState)=>{
        if (v7_startTransition && $68c2f6a70206c369$var$startTransitionImpl) $68c2f6a70206c369$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8vqx4.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8vqx4.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8vqx4.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8vqx4.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $8vqx4.useEffect(()=>$68c2f6a70206c369$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8vqx4.createElement($8vqx4.Fragment, null, /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $68c2f6a70206c369$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $68c2f6a70206c369$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $68c2f6a70206c369$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8vqx4.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ea4a0cb853f5c10$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8vqx4.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8vqx4.useCallback((newState)=>{
        v7_startTransition && $68c2f6a70206c369$var$startTransitionImpl ? $68c2f6a70206c369$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8vqx4.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8vqx4.useEffect(()=>$68c2f6a70206c369$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $68c2f6a70206c369$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$68c2f6a70206c369$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $8vqx4.useContext($68c2f6a70206c369$export$26749e8557646306);
    let { matches: matches } = $8vqx4.useContext($68c2f6a70206c369$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $68c2f6a70206c369$export$45d76561a5302f2b();
    let navigate = $68c2f6a70206c369$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1ea4a0cb853f5c10$export$cae722b0cc860f13)(to, (0, $1ea4a0cb853f5c10$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8vqx4.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $68c2f6a70206c369$export$910ae8079b2c2852(props) {
    return $68c2f6a70206c369$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $68c2f6a70206c369$export$e7b0ac011bb776c6(_props) {
    (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $68c2f6a70206c369$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1ea4a0cb853f5c10$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$68c2f6a70206c369$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8vqx4.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $68c2f6a70206c369$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1ea4a0cb853f5c10$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8vqx4.useMemo(()=>{
        let trailingPathname = (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $68c2f6a70206c369$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $68c2f6a70206c369$export$5d3fca4a98652595($68c2f6a70206c369$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $68c2f6a70206c369$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$var$ResolveAwait, null, children));
}
var $68c2f6a70206c369$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($68c2f6a70206c369$var$AwaitRenderStatus || {});
const $68c2f6a70206c369$var$neverSettledPromise = new Promise(()=>{});
class $68c2f6a70206c369$var$AwaitErrorBoundary extends $8vqx4.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $68c2f6a70206c369$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $68c2f6a70206c369$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $68c2f6a70206c369$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $68c2f6a70206c369$var$AwaitRenderStatus.error : "_data" in promise ? $68c2f6a70206c369$var$AwaitRenderStatus.success : $68c2f6a70206c369$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $68c2f6a70206c369$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $68c2f6a70206c369$var$AwaitRenderStatus.error && promise._error instanceof (0, $1ea4a0cb853f5c10$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $68c2f6a70206c369$var$neverSettledPromise;
        if (status === $68c2f6a70206c369$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $68c2f6a70206c369$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $68c2f6a70206c369$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8vqx4.createElement($68c2f6a70206c369$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $68c2f6a70206c369$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $68c2f6a70206c369$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8vqx4.createElement($8vqx4.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $68c2f6a70206c369$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8vqx4.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8vqx4.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8vqx4.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $68c2f6a70206c369$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $68c2f6a70206c369$export$e7b0ac011bb776c6) && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $68c2f6a70206c369$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $68c2f6a70206c369$export$daf73786167a7f72(matches) {
    return $68c2f6a70206c369$var$_renderMatches(matches);
}
function $68c2f6a70206c369$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8vqx4.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8vqx4.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8vqx4.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $68c2f6a70206c369$export$f30f7e456d254e83(routes, opts) {
    return (0, $1ea4a0cb853f5c10$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $68c2f6a70206c369$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ea4a0cb853f5c10$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $68c2f6a70206c369$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $07071c34f63f350a$var$_extends() {
    $07071c34f63f350a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $07071c34f63f350a$var$_extends.apply(this, arguments);
}
function $07071c34f63f350a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $07071c34f63f350a$var$defaultMethod = "get";
const $07071c34f63f350a$var$defaultEncType = "application/x-www-form-urlencoded";
function $07071c34f63f350a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $07071c34f63f350a$var$isButtonElement(object) {
    return $07071c34f63f350a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $07071c34f63f350a$var$isFormElement(object) {
    return $07071c34f63f350a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $07071c34f63f350a$var$isInputElement(object) {
    return $07071c34f63f350a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $07071c34f63f350a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $07071c34f63f350a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$07071c34f63f350a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $07071c34f63f350a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $07071c34f63f350a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $07071c34f63f350a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $07071c34f63f350a$var$_formDataSupportsSubmitter = null;
function $07071c34f63f350a$var$isFormDataSubmitterSupported() {
    if ($07071c34f63f350a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $07071c34f63f350a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $07071c34f63f350a$var$_formDataSupportsSubmitter = true;
    }
    return $07071c34f63f350a$var$_formDataSupportsSubmitter;
}
const $07071c34f63f350a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $07071c34f63f350a$var$getFormEncType(encType) {
    if (encType != null && !$07071c34f63f350a$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $07071c34f63f350a$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($07071c34f63f350a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $07071c34f63f350a$var$defaultMethod;
        encType = $07071c34f63f350a$var$getFormEncType(target.getAttribute("enctype")) || $07071c34f63f350a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($07071c34f63f350a$var$isButtonElement(target) || $07071c34f63f350a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $07071c34f63f350a$var$defaultMethod;
        encType = $07071c34f63f350a$var$getFormEncType(target.getAttribute("formenctype")) || $07071c34f63f350a$var$getFormEncType(form.getAttribute("enctype")) || $07071c34f63f350a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$07071c34f63f350a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($07071c34f63f350a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $07071c34f63f350a$var$defaultMethod;
        action = null;
        encType = $07071c34f63f350a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $07071c34f63f350a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $07071c34f63f350a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $07071c34f63f350a$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $07071c34f63f350a$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $07071c34f63f350a$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $07071c34f63f350a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1ea4a0cb853f5c10$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $07071c34f63f350a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ea4a0cb853f5c10$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $07071c34f63f350a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $68c2f6a70206c369$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $07071c34f63f350a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1ea4a0cb853f5c10$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $07071c34f63f350a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ea4a0cb853f5c10$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $07071c34f63f350a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $68c2f6a70206c369$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $07071c34f63f350a$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $07071c34f63f350a$var$_extends({}, state, {
        errors: $07071c34f63f350a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $07071c34f63f350a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1ea4a0cb853f5c10$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $07071c34f63f350a$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8vqx4.createContext({
    isTransitioning: false
});
const $07071c34f63f350a$export$148fd98d095596d4 = /*#__PURE__*/ $8vqx4.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $07071c34f63f350a$var$START_TRANSITION = "startTransition";
const $07071c34f63f350a$var$startTransitionImpl = $8vqx4[$07071c34f63f350a$var$START_TRANSITION];
const $07071c34f63f350a$var$FLUSH_SYNC = "flushSync";
const $07071c34f63f350a$var$flushSyncImpl = $hiyfL[$07071c34f63f350a$var$FLUSH_SYNC];
const $07071c34f63f350a$var$USE_ID = "useId";
const $07071c34f63f350a$var$useIdImpl = $8vqx4[$07071c34f63f350a$var$USE_ID];
function $07071c34f63f350a$var$startTransitionSafe(cb) {
    if ($07071c34f63f350a$var$startTransitionImpl) $07071c34f63f350a$var$startTransitionImpl(cb);
    else cb();
}
function $07071c34f63f350a$var$flushSyncSafe(cb) {
    if ($07071c34f63f350a$var$flushSyncImpl) $07071c34f63f350a$var$flushSyncImpl(cb);
    else cb();
}
class $07071c34f63f350a$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $07071c34f63f350a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8vqx4.useState(router.state);
    let [pendingState, setPendingState] = $8vqx4.useState();
    let [vtContext, setVtContext] = $8vqx4.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8vqx4.useState();
    let [transition, setTransition] = $8vqx4.useState();
    let [interruption, setInterruption] = $8vqx4.useState();
    let fetcherData = $8vqx4.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8vqx4.useCallback((cb)=>{
        if (v7_startTransition) $07071c34f63f350a$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8vqx4.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $07071c34f63f350a$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $07071c34f63f350a$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $07071c34f63f350a$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $07071c34f63f350a$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $07071c34f63f350a$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8vqx4.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8vqx4.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $07071c34f63f350a$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8vqx4.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8vqx4.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8vqx4.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8vqx4.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8vqx4.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8vqx4.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8vqx4.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $8vqx4.useEffect(()=>(0, $68c2f6a70206c369$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8vqx4.createElement($8vqx4.Fragment, null, /*#__PURE__*/ $8vqx4.createElement((0, $68c2f6a70206c369$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8vqx4.createElement((0, $68c2f6a70206c369$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8vqx4.createElement($07071c34f63f350a$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8vqx4.createElement($07071c34f63f350a$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8vqx4.createElement((0, $68c2f6a70206c369$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8vqx4.createElement($07071c34f63f350a$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $07071c34f63f350a$var$MemoizedDataRoutes = /*#__PURE__*/ $8vqx4.memo($07071c34f63f350a$var$DataRoutes);
function $07071c34f63f350a$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $68c2f6a70206c369$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $07071c34f63f350a$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8vqx4.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ea4a0cb853f5c10$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8vqx4.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8vqx4.useCallback((newState)=>{
        v7_startTransition && $07071c34f63f350a$var$startTransitionImpl ? $07071c34f63f350a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8vqx4.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8vqx4.useEffect(()=>(0, $68c2f6a70206c369$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8vqx4.createElement((0, $68c2f6a70206c369$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $07071c34f63f350a$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8vqx4.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ea4a0cb853f5c10$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8vqx4.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8vqx4.useCallback((newState)=>{
        v7_startTransition && $07071c34f63f350a$var$startTransitionImpl ? $07071c34f63f350a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8vqx4.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8vqx4.useEffect(()=>(0, $68c2f6a70206c369$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8vqx4.createElement((0, $68c2f6a70206c369$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $07071c34f63f350a$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8vqx4.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8vqx4.useCallback((newState)=>{
        v7_startTransition && $07071c34f63f350a$var$startTransitionImpl ? $07071c34f63f350a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8vqx4.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8vqx4.useEffect(()=>(0, $68c2f6a70206c369$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8vqx4.createElement((0, $68c2f6a70206c369$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $07071c34f63f350a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $07071c34f63f350a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $07071c34f63f350a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8vqx4.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $07071c34f63f350a$var$_objectWithoutPropertiesLoose(_ref7, $07071c34f63f350a$var$_excluded);
    let { basename: basename } = $8vqx4.useContext((0, $68c2f6a70206c369$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $07071c34f63f350a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($07071c34f63f350a$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $68c2f6a70206c369$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $07071c34f63f350a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8vqx4.createElement("a", $07071c34f63f350a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $07071c34f63f350a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8vqx4.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $07071c34f63f350a$var$_objectWithoutPropertiesLoose(_ref8, $07071c34f63f350a$var$_excluded2);
    let path = (0, $68c2f6a70206c369$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $68c2f6a70206c369$export$45d76561a5302f2b)();
    let routerState = $8vqx4.useContext((0, $68c2f6a70206c369$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8vqx4.useContext((0, $68c2f6a70206c369$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $07071c34f63f350a$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8vqx4.createElement($07071c34f63f350a$export$a6c7ac8248d6e38a, $07071c34f63f350a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $07071c34f63f350a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8vqx4.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $07071c34f63f350a$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $07071c34f63f350a$var$_objectWithoutPropertiesLoose(_ref9, $07071c34f63f350a$var$_excluded3);
    let submit = $07071c34f63f350a$export$47c85c6e3a081d3();
    let formAction = $07071c34f63f350a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $8vqx4.createElement("form", $07071c34f63f350a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $07071c34f63f350a$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $07071c34f63f350a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $07071c34f63f350a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($07071c34f63f350a$var$DataRouterHook || ($07071c34f63f350a$var$DataRouterHook = {}));
var $07071c34f63f350a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($07071c34f63f350a$var$DataRouterStateHook || ($07071c34f63f350a$var$DataRouterStateHook = {}));
// Internal hooks
function $07071c34f63f350a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $07071c34f63f350a$var$useDataRouterContext(hookName) {
    let ctx = $8vqx4.useContext((0, $68c2f6a70206c369$export$3add0d5dce533e2e));
    !ctx && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return ctx;
}
function $07071c34f63f350a$var$useDataRouterState(hookName) {
    let state = $8vqx4.useContext((0, $68c2f6a70206c369$export$145dfa71566a64dc));
    !state && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $07071c34f63f350a$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $68c2f6a70206c369$export$9770f232ac06a008)();
    let location = (0, $68c2f6a70206c369$export$45d76561a5302f2b)();
    let path = (0, $68c2f6a70206c369$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8vqx4.useCallback((event)=>{
        if ($07071c34f63f350a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1ea4a0cb853f5c10$export$fe53371bee54353d)(location) === (0, $1ea4a0cb853f5c10$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $07071c34f63f350a$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8vqx4.useRef($07071c34f63f350a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8vqx4.useRef(false);
    let location = (0, $68c2f6a70206c369$export$45d76561a5302f2b)();
    let searchParams = $8vqx4.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $07071c34f63f350a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $68c2f6a70206c369$export$9770f232ac06a008)();
    let setSearchParams = $8vqx4.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $07071c34f63f350a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $07071c34f63f350a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $07071c34f63f350a$var$fetcherId = 0;
let $07071c34f63f350a$var$getUniqueFetcherId = ()=>"__" + String(++$07071c34f63f350a$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $07071c34f63f350a$export$47c85c6e3a081d3() {
    let { router: router } = $07071c34f63f350a$var$useDataRouterContext($07071c34f63f350a$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8vqx4.useContext((0, $68c2f6a70206c369$export$26749e8557646306));
    let currentRouteId = (0, $68c2f6a70206c369$export$5fc8298006ad9e58)();
    return $8vqx4.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $07071c34f63f350a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $07071c34f63f350a$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $07071c34f63f350a$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $07071c34f63f350a$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8vqx4.useContext((0, $68c2f6a70206c369$export$26749e8557646306));
    let routeContext = $8vqx4.useContext((0, $68c2f6a70206c369$export$9072aa6dd1f93057));
    !routeContext && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $07071c34f63f350a$var$_extends({}, (0, $68c2f6a70206c369$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $68c2f6a70206c369$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1ea4a0cb853f5c10$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1ea4a0cb853f5c10$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $07071c34f63f350a$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $07071c34f63f350a$var$useDataRouterContext($07071c34f63f350a$var$DataRouterHook.UseFetcher);
    let state = $07071c34f63f350a$var$useDataRouterState($07071c34f63f350a$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8vqx4.useContext($07071c34f63f350a$export$148fd98d095596d4);
    let route = $8vqx4.useContext((0, $68c2f6a70206c369$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    !route && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $07071c34f63f350a$var$useIdImpl ? $07071c34f63f350a$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8vqx4.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($07071c34f63f350a$var$getUniqueFetcherId());
    // Registration/cleanup
    $8vqx4.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8vqx4.useCallback((href, opts)=>{
        !routeId && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $07071c34f63f350a$export$47c85c6e3a081d3();
    let submit = $8vqx4.useCallback((target, opts)=>{
        submitImpl(target, $07071c34f63f350a$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8vqx4.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8vqx4.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8vqx4.createElement($07071c34f63f350a$export$a7fed597f4b8afd8, $07071c34f63f350a$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1ea4a0cb853f5c10$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8vqx4.useMemo(()=>$07071c34f63f350a$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $07071c34f63f350a$export$fa996778a3a31087() {
    let state = $07071c34f63f350a$var$useDataRouterState($07071c34f63f350a$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $07071c34f63f350a$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $07071c34f63f350a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $07071c34f63f350a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $07071c34f63f350a$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $07071c34f63f350a$var$useDataRouterContext($07071c34f63f350a$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $07071c34f63f350a$var$useDataRouterState($07071c34f63f350a$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8vqx4.useContext((0, $68c2f6a70206c369$export$26749e8557646306));
    let location = (0, $68c2f6a70206c369$export$45d76561a5302f2b)();
    let matches = (0, $68c2f6a70206c369$export$2378eb7f5ff86053)();
    let navigation = (0, $68c2f6a70206c369$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8vqx4.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $07071c34f63f350a$var$usePageHide($8vqx4.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $07071c34f63f350a$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $07071c34f63f350a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($07071c34f63f350a$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8vqx4.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $07071c34f63f350a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $07071c34f63f350a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8vqx4.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($07071c34f63f350a$var$_extends({}, location, {
                    pathname: (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($07071c34f63f350a$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8vqx4.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $07071c34f63f350a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8vqx4.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $07071c34f63f350a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8vqx4.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $07071c34f63f350a$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $68c2f6a70206c369$export$b273b3273281a049)(when);
    $8vqx4.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8vqx4.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $07071c34f63f350a$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8vqx4.useContext($07071c34f63f350a$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let { basename: basename } = $07071c34f63f350a$var$useDataRouterContext($07071c34f63f350a$var$DataRouterHook.useViewTransitionState);
    let path = (0, $68c2f6a70206c369$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1ea4a0cb853f5c10$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1ea4a0cb853f5c10$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $8vqx4 = parcelRequire("8vqx4");


parcelRequire("8vqx4");



var $8vqx4 = parcelRequire("8vqx4");

const $604ba12280ccd2a0$export$7842ed161beddbfb = [
    // { title: "All", value: "" },
    {
        title: "Male",
        value: "male"
    },
    {
        title: "Female",
        value: "female"
    }
];
const $604ba12280ccd2a0$export$4dc49ec4166f91c8 = [
    // { title: "All", value: "" },
    {
        title: "Small",
        value: "small"
    },
    {
        title: "Medium",
        value: "medium"
    },
    {
        title: "Large",
        value: "large"
    }
];
const $604ba12280ccd2a0$export$f9f9a2a324f78679 = [
    {
        title: "All",
        value: ""
    },
    {
        title: "Albania",
        value: "AL"
    }
];


function $22f2182d1b990877$export$fa8cb0654f2148f2(data) {
    return JSON.parse(JSON.stringify(data));
}
const $22f2182d1b990877$export$bd5c5d8b8dcafd78 = (error, data)=>{};
const $22f2182d1b990877$export$628514a40f204842 = (type)=>{
    const fileTypes = [
        "image/jpeg",
        "image/png"
    ];
    return fileTypes.includes(type);
};
const $22f2182d1b990877$export$d7d91ef60ed914ba = (size, limit = 2097152)=>{
    return size <= limit;
};
const $22f2182d1b990877$export$18b02663f532815c = (code)=>{
    const countryObj = (0, $604ba12280ccd2a0$export$f9f9a2a324f78679).find((c)=>c.value === code);
    return countryObj ? countryObj.title : code;
};


const $61e35487be0558dc$export$e9ddf1da8d18d6f = "https://tailtales.vorozhbit.com/api";
const $61e35487be0558dc$export$c73dcf559dad2f44 = async ()=>{
    try {
        const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (!response.ok) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(`Unable to fetch data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        const data = await response.json();
        if (!data) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)("No data in response");
            return;
        }
        return data;
    } catch (error) {
        (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(error);
    }
};
const $61e35487be0558dc$export$cb01c83fc8789b9b = async (accessToken)=>{
    try {
        const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/user/profile`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
            }
        });
        if (!response.ok) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(`Unable to fetch data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        const data = await response.json();
        if (!data || !data.data) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)("No data in response");
            return;
        }
        return data.data;
    } catch (error) {
        (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(error);
    }
};
const $61e35487be0558dc$export$c92c4ec7a2418617 = async (accessToken, dt)=>{
    try {
        const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/user/profile`, {
            method: "PUT",
            headers: {
                // "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`
            },
            body: dt
        });
        if (!response.ok) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(`Unable to update data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        const data = await response.json();
        if (!data || !data.data) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)("No data in response");
            return;
        }
        return data.data;
    } catch (error) {
        (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(error);
    }
};
const $61e35487be0558dc$export$819d9a282de0491b = async (accessToken)=>{
    try {
        const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/user/pets`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
            }
        });
        if (!response.ok) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(`Unable to fetch data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        const data = await response.json();
        if (!data || !data.data) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)("No data in response");
            return;
        }
        return data.data;
    } catch (error) {
        (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(error);
    }
};
const $61e35487be0558dc$export$dbd4fc49e5e0b54 = async (accessToken, id)=>{
    try {
        const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/user/pets/${id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
            }
        });
        if (!response.ok) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(`Unable to fetch data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        const data = await response.json();
        if (!data || !data.data) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)("No data in response");
            return;
        }
        return data.data;
    } catch (error) {
        (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(error);
    }
};
const $61e35487be0558dc$export$eade7de8e51a7c32 = async (accessToken, id, dt)=>{
    try {
        const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/user/pets/${id}`, {
            method: "PUT",
            headers: {
                // "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`
            },
            body: dt
        });
        if (!response.ok) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(`Unable to update data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        const data = await response.json();
        if (!data || !data.data) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)("No data in response");
            return;
        }
        return data.data;
    } catch (error) {
        (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(error);
    }
};
const $61e35487be0558dc$export$ea6a87eb2959fecc = async (accessToken, dt)=>{
    try {
        const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/user/pets/`, {
            method: "POST",
            headers: {
                // "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`
            },
            body: dt
        });
        if (!response.ok) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(`Unable to update data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        const data = await response.json();
        if (!data || !data.data) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)("No data in response");
            return;
        }
        return data.data;
    } catch (error) {
        (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(error);
    }
};
const $61e35487be0558dc$export$d2166c07602f53fa = async (accessToken, petIDs)=>{
    try {
        const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/user/pets`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
            },
            body: JSON.stringify({
                ids: petIDs
            })
        });
        if (!response.ok) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(`Unable to fetch data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        const data = await response.json();
        if (!data) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)("No data in response");
            return;
        }
        return data;
    } catch (error) {
        (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(error);
    }
};
const $61e35487be0558dc$export$f3d518c5e135cea6 = async (searchParams)=>{
    const data = {};
    if (searchParams.lastId) data["last"] = searchParams.lastId;
    if (searchParams.country) data["country"] = searchParams.country;
    if (searchParams.size) data["size"] = searchParams.size;
    if (searchParams.gender) data["gender"] = searchParams.gender;
    const params = new URLSearchParams(data);
    const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/pets?${params.toString()}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include"
    }).catch((error)=>{
        throw Error(error);
    });
    if (response.ok) {
        const data = await response.json();
        return data.data ?? Promise.reject(new Error(`No data`));
    } else return Promise.reject(new Error(`Unable to fetch data`));
};
const $61e35487be0558dc$export$2f54905a28ae7974 = async (id)=>{
    const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/pets/${id}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    }).catch((error)=>{
        throw Error(error);
    });
    if (response.ok) {
        const data = await response.json();
        return data.data ?? Promise.reject(new Error(`No data`));
    } else return Promise.reject(new Error(`Unable to fetch data`));
};
const $61e35487be0558dc$export$801fe16824f675f7 = async (accessToken)=>{
    const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/user`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }).catch((error)=>{
        throw Error(error);
    });
    if (response.ok) {
        const data = await response.json();
        return data.data ?? Promise.reject(new Error(`No data`));
    } else return Promise.reject(new Error(`Unable to fetch data`));
};
const $61e35487be0558dc$export$9670d83f11d4b64a = async (username, password)=>{
    const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/signin`, {
        method: "POST",
        body: JSON.stringify({
            username: username,
            password: password
        }),
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include"
    }).catch((error)=>{
        throw Error(error);
    });
    if (response.ok) {
        const data = await response.json();
        return data.data ?? Promise.reject(new Error(`No data`));
    }
    if (response.status === 401) {
        const data = await response.json();
        return data ?? Promise.reject(new Error(`No data`));
    }
    return Promise.reject(new Error(`Unable to fetch data`));
};
const $61e35487be0558dc$export$d5e2872bdefef4f0 = async (resp)=>{
    try {
        const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/googlesignin`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                credential: resp.credential
            })
        });
        if (!response.ok) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(`Unable to update data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        const data = await response.json();
        if (!data || !data.data) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)("No user in response");
            return;
        }
        return data.data;
    } catch (error) {
        (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(error);
    }
};
const $61e35487be0558dc$export$c542b5e295206b2a = async ()=>{
    const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/refresh`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include"
    }).catch((error)=>{
        throw Error(error);
    });
    if (response.ok) {
        const data = await response.json();
        return data.data ?? Promise.reject(new Error(`No data`));
    }
    if (response.status === 401) {
        const data = await response.json();
        return data ?? Promise.reject(new Error(`No data`));
    }
    return Promise.reject(new Error(`Unable to fetch data`));
};
const $61e35487be0558dc$export$6b5b844507559f2 = async (accessToken, petId)=>{
    try {
        const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/user/adoptions/pet/${petId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
            }
        });
        if (!response.ok) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(`Unable to fetch data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        const data = await response.json();
        if (!data || !data.data) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)("No data in response");
            return;
        }
        return data.data;
    } catch (error) {
        (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(error);
    }
};
const $61e35487be0558dc$export$53268acd80eaf8d = async (accessToken, petId, payload)=>{
    try {
        const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/user/adoptions`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
            },
            body: JSON.stringify({
                petId: petId,
                data: payload
            })
        });
        if (!response.ok) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(`Unable to save data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        const responseData = await response.json();
        if (!responseData || !responseData.data) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)("No data in response");
            return;
        }
        return responseData.data;
    } catch (error) {
        (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(error);
    }
};
const $61e35487be0558dc$export$53cc1e5f40ab2c45 = async (accessToken, adoptionId, payload)=>{
    try {
        const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/user/adoptions/${adoptionId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
            },
            body: JSON.stringify({
                ...payload
            })
        });
        if (!response.ok) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(`Unable to save data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        const responseData = await response.json();
        if (!responseData || !responseData.data) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)("No data in response");
            return;
        }
        return responseData.data;
    } catch (error) {
        (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(error);
    }
};
const $61e35487be0558dc$export$ce69256b89e8cf0b = async (accessToken, adoptionId)=>{
    try {
        const response = await fetch(`${$61e35487be0558dc$export$e9ddf1da8d18d6f}/user/adoptions/${adoptionId}/succeeded`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
            },
            body: JSON.stringify({})
        });
        if (!response.ok) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(`Unable to save data. ${response.status}: ${response.statusText}`, {
                status: response.status
            });
            return;
        }
        const responseData = await response.json();
        if (!responseData || !responseData.data) {
            (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)("No data in response");
            return;
        }
        return responseData.data;
    } catch (error) {
        (0, $22f2182d1b990877$export$bd5c5d8b8dcafd78)(error);
    }
};


var $a78fa6a4c32388fc$exports = {};
var $28df82a501157bba$exports = {};

var $ikdtY = parcelRequire("ikdtY");
var $28df82a501157bba$var$slice = $ikdtY.slice;
var $28df82a501157bba$var$pluck = $ikdtY.pluck;
var $28df82a501157bba$var$each = $ikdtY.each;
var $28df82a501157bba$var$bind = $ikdtY.bind;
var $28df82a501157bba$var$create = $ikdtY.create;
var $28df82a501157bba$var$isList = $ikdtY.isList;
var $28df82a501157bba$var$isFunction = $ikdtY.isFunction;
var $28df82a501157bba$var$isObject = $ikdtY.isObject;
$28df82a501157bba$exports = {
    createStore: $28df82a501157bba$var$createStore
};
var $28df82a501157bba$var$storeAPI = {
    version: '2.0.12',
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == '__storejs_' + namespace + '_';
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $28df82a501157bba$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $28df82a501157bba$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $28df82a501157bba$var$_warn() {
    var _console = typeof console == 'undefined' ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $28df82a501157bba$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = '';
    if (storages && !$28df82a501157bba$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$28df82a501157bba$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? '__storejs_' + namespace + '_' : '';
    var namespaceRegexp = namespace ? new RegExp('^' + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes');
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = '__storejs__test__';
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $28df82a501157bba$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $28df82a501157bba$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = '';
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($28df82a501157bba$var$isList(plugin)) {
                $28df82a501157bba$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $28df82a501157bba$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$28df82a501157bba$var$isFunction(plugin)) throw new Error('Plugins must be function values that return objects');
            var pluginProperties = plugin.call(this);
            if (!$28df82a501157bba$var$isObject(pluginProperties)) throw new Error('Plugins must return an object of function properties');
            // Add the plugin function properties to this store instance.
            $28df82a501157bba$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$28df82a501157bba$var$isFunction(pluginFnProp)) throw new Error('Bad plugin property: ' + propName + ' from plugin ' + plugin.name + '. Plugins should only return functions.');
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $28df82a501157bba$var$_warn('store.addStorage(storage) is deprecated. Use createStore([storages])');
            this._addStorage(storage);
        }
    };
    var store = $28df82a501157bba$var$create(_privateStoreProps, $28df82a501157bba$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $28df82a501157bba$var$each(store, function(prop, propName) {
        if ($28df82a501157bba$var$isFunction(prop)) store.raw[propName] = $28df82a501157bba$var$bind(store, prop);
    });
    $28df82a501157bba$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $28df82a501157bba$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}


var $d4bccf72c8f68e2b$exports = {};






$d4bccf72c8f68e2b$exports = [
    // Listed in order of usage preference
    (parcelRequire("jJ1eL")),
    (parcelRequire("hGK7t")),
    (parcelRequire("aaPXA")),
    (parcelRequire("5e3On")),
    (parcelRequire("c7hcs")),
    (parcelRequire("5VbDd"))
];



var $a78fa6a4c32388fc$var$plugins = [
    (parcelRequire("hVpG1"))
];
$a78fa6a4c32388fc$exports = $28df82a501157bba$exports.createStore($d4bccf72c8f68e2b$exports, $a78fa6a4c32388fc$var$plugins);



var $5e3On = parcelRequire("5e3On");
const $e4a2f0245c788599$export$5b9892d2b7215bc8 = "ttuser";
const $e4a2f0245c788599$export$ed7fe7865e115489 = "ttredirect";
const $e4a2f0245c788599$export$ddb81493dc857c94 = "ttadoption";
function $e4a2f0245c788599$export$e4c9b9bae9539063(key, optionalDefaultValue) {
    return $a78fa6a4c32388fc$exports.get(key, optionalDefaultValue);
}
function $e4a2f0245c788599$export$b4b6c1ec764d6e5(key, data) {
    return $a78fa6a4c32388fc$exports.set(key, data);
}
function $e4a2f0245c788599$export$110700823644f4a6(key, data, expDays = 1) {
    const date = new Date();
    date.setTime(date.getTime() + expDays * 86400000);
    const expires = "expires=" + date.toUTCString();
    const host = location.host;
    if (host.split(".").length === 1) document.cookie = key + "=" + data + "; " + expires + "; path=/";
    else {
        const domainParts = host.split(".");
        domainParts.shift();
        const domain = "." + domainParts.join(".");
        document.cookie = key + "=" + data + "; " + expires + "; path=/; domain=" + domain;
    }
}
function $e4a2f0245c788599$export$4be65e66cfa2648a(key) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5e3On))).read(key);
}
function $e4a2f0245c788599$export$a3e6e3b94afefd97(key) {
    return $a78fa6a4c32388fc$exports.remove(key);
}
function $e4a2f0245c788599$export$6a874b7a74007875(key) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5e3On))).remove(key);
}



const $44a22ec1fae97653$var$initialUser = {
    accessToken: "",
    page: null,
    pageParams: null
};
const $44a22ec1fae97653$var$UserContext = /*#__PURE__*/ (0, $8vqx4.createContext)({});
const $44a22ec1fae97653$var$UserDispatchContext = /*#__PURE__*/ (0, $8vqx4.createContext)(null);
const $44a22ec1fae97653$var$userReducer = (state, action)=>{
    switch(action.type){
        case "set-data":
            return {
                ...state,
                accessToken: action.payload.accessToken,
                profile: action.payload.profile
            };
        case "set-access-token":
            return {
                ...state,
                accessToken: action.payload
            };
        case "set-profile":
            return {
                ...state,
                profile: action.payload
            };
        case "set-from-storage":
            {
                const payload = {
                    ...action.payload
                };
                if (!payload.accessToken) payload.accessToken = null;
                return {
                    ...state,
                    ...payload
                };
            }
        case "set-page":
            {
                const st = {
                    ...state
                };
                st.page = action.payload.page;
                st.pageParams = action.payload.pageParams;
                return st;
            }
        case "clear":
            return $44a22ec1fae97653$var$initialUser;
        default:
            return state;
    }
};
const $44a22ec1fae97653$export$88f24fd8fcfab6ca = ({ children: children })=>{
    const [user, dispatch] = (0, $8vqx4.useReducer)($44a22ec1fae97653$var$userReducer, $44a22ec1fae97653$var$initialUser);
    (0, $8vqx4.useEffect)(()=>{
        const isValid = checkExpiredToken();
        if (user.accessToken?.length && !isValid) logout();
    }, [
        user
    ]);
    const populateFromStorage = ()=>{
        const localUser = (0, $e4a2f0245c788599$export$e4c9b9bae9539063)((0, $e4a2f0245c788599$export$5b9892d2b7215bc8), $44a22ec1fae97653$var$initialUser);
        const data = (0, $22f2182d1b990877$export$fa8cb0654f2148f2)(localUser);
        if (data) dispatch({
            type: "set-from-storage",
            payload: data
        });
    };
    const saveToStorage = ()=>{
        (0, $e4a2f0245c788599$export$b4b6c1ec764d6e5)((0, $e4a2f0245c788599$export$5b9892d2b7215bc8), user);
    };
    const checkExpiredToken = ()=>{
        if (!user.accessToken) return false;
        try {
            const token = JSON.parse(atob(user.accessToken.split(".")[1]));
            if (token && Math.floor(Date.now() / 1000) >= token.exp) return false;
        } catch (e) {
            console.log(e);
            return false;
        }
        return true;
    };
    const fetchUserInfo = async (accessToken)=>{
        try {
            const data = await (0, $61e35487be0558dc$export$801fe16824f675f7)(accessToken);
            dispatch({
                type: "set-profile",
                payload: data
            });
            return data;
        } catch (e) {
            return console.log(e);
        }
    };
    const refreshAccessToken = async ()=>{
        try {
            const data = await (0, $61e35487be0558dc$export$c542b5e295206b2a)();
            dispatch({
                type: "set-access-token",
                payload: data.accessToken
            });
            return data;
        } catch (e) {
            console.log(e);
            logout();
            return;
        }
    };
    const logout = ()=>{
        dispatch({
            type: "clear"
        });
        (0, $e4a2f0245c788599$export$a3e6e3b94afefd97)((0, $e4a2f0245c788599$export$5b9892d2b7215bc8));
        const redirectUrl = "/";
        window.location.href = redirectUrl;
    };
    const obj = {
        user: user,
        populateFromStorage: populateFromStorage,
        saveToStorage: saveToStorage,
        fetchUserInfo: fetchUserInfo,
        checkExpiredToken: checkExpiredToken,
        refreshAccessToken: refreshAccessToken,
        logout: logout
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($44a22ec1fae97653$var$UserContext.Provider, {
        value: obj,
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($44a22ec1fae97653$var$UserDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
function $44a22ec1fae97653$export$87c54b525b914dab() {
    return (0, $8vqx4.useContext)($44a22ec1fae97653$var$UserContext);
}
function $44a22ec1fae97653$export$5bd0aba7f9e819b6() {
    return (0, $8vqx4.useContext)($44a22ec1fae97653$var$UserDispatchContext);
}
function $44a22ec1fae97653$export$491fab5ec9b43e74({ children: children }) {
    const { user: user, checkExpiredToken: checkExpiredToken, refreshAccessToken: refreshAccessToken } = $44a22ec1fae97653$export$87c54b525b914dab();
    const navigate = (0, $68c2f6a70206c369$export$9770f232ac06a008)();
    const location = (0, $68c2f6a70206c369$export$45d76561a5302f2b)();
    (0, $8vqx4.useEffect)(()=>{
        // Store location.pathname in a ref or state to access previous URL
        console.log("LOCATION", location);
    }, [
        location
    ]);
    (0, $8vqx4.useEffect)(()=>{
        if (user.accessToken === undefined) return;
        if (user.accessToken === null) {
            navigate("/login");
            return;
        }
        const isValid = checkExpiredToken();
        console.log("auth check, isValid:", isValid);
        if (!isValid) refreshAccessToken();
    }, [
        user.accessToken
    ]);
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $607ae91d1eb97195$exports.Fragment), {
        children: children
    });
}




parcelRequire("8vqx4");
const $697654d10ef148cd$export$3fe541c5a0ef78e0 = (color = "#121111", width = "96", height = "20")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 96 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("g", {
                clipPath: "url(#clip0_277_498)",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                        d: "M0 8.6031V6.48189C5.41225 6.48189 4.98609 4.39024 4.98609 0H7.45783V6.48189H11.2862V8.6031H7.45783V14.1611C7.45783 16.8293 8.10417 17.6275 9.95798 17.6275C10.4552 17.6275 10.8529 17.5979 11.2862 17.5314V19.6822C10.9453 19.7487 10.3912 19.8078 9.61705 19.8078C6.90382 19.8078 4.98609 18.5883 4.98609 14.3829V8.6031H0Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                        d: "M17.8285 20C14.8028 20 12.9561 18.9061 12.9561 15.9867C12.9561 12.9046 14.9022 12.1655 18.1055 12.0029C20.1724 11.9069 21.4083 11.7443 22.3032 11.589C22.2109 9.34218 21.6213 8.53656 19.0644 8.53656C16.7489 8.53656 15.7332 8.69917 14.3411 8.92089V6.80707C15.6977 6.54839 16.8412 6.32666 19.2775 6.32666C23.6314 6.32666 24.7678 8.44787 24.7678 12.1064V19.7487H22.3032V18.1744C21.5006 19.2978 20.1795 20 17.8285 20ZM18.2618 13.8729C16.2872 13.9689 15.4846 14.2867 15.4846 15.861C15.4846 17.3392 16.1949 17.9157 18.3825 17.9157C21.0957 17.9157 22.3032 16.6962 22.3032 14.9593V13.4146C21.3798 13.6437 20.1795 13.7768 18.2618 13.8729Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                        d: "M28.1982 0H30.7907V3.14856H28.1982V0ZM28.2551 6.48189H30.7268V19.7413H28.2551V6.48189Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                        d: "M34.6111 0H37.0828V19.7487H34.6111V0Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                        d: "M54.7191 20C51.6934 20 49.8467 18.9061 49.8467 15.9867C49.8467 12.9046 51.7928 12.1655 54.9961 12.0029C57.063 11.9069 58.2989 11.7443 59.1938 11.589C59.1015 9.34218 58.512 8.53656 55.955 8.53656C53.6395 8.53656 52.6238 8.69917 51.2317 8.92089V6.80707C52.5883 6.54839 53.7319 6.32666 56.1681 6.32666C60.522 6.32666 61.6585 8.44787 61.6585 12.1064V19.7487H59.1867V18.1744C58.3912 19.2978 57.063 20 54.7191 20ZM55.1524 13.8729C53.1778 13.9689 52.3752 14.2867 52.3752 15.861C52.3752 17.3392 53.0855 17.9157 55.2731 17.9157C57.9864 17.9157 59.1938 16.6962 59.1938 14.9593V13.4146C58.2705 13.6437 57.063 13.7768 55.1524 13.8729Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                        d: "M65.1455 0H67.6172V19.7487H65.1455V0Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                        d: "M77.7393 17.6939C79.4085 17.6939 80.8219 17.5682 81.8092 17.4352V19.6155C80.8858 19.7412 79.7139 19.9038 77.5547 19.9038C73.1439 19.9038 70.7361 18.0413 70.7361 13.1632C70.7361 8.38124 73.3286 6.23047 76.9083 6.23047C81.0705 6.23047 83.0451 8.50689 83.0451 13.008V14.161H80.5449H73.2931C73.5061 17.0139 74.8059 17.6939 77.7393 17.6939ZM76.9936 8.41081C74.8983 8.41081 73.5701 9.14991 73.3215 12.0398H80.5094C80.3886 9.37164 79.373 8.41081 76.9936 8.41081Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                        d: "M90.3817 19.8447C87.91 19.8447 86.5889 19.719 85.5377 19.5268V17.3465C86.6173 17.5387 87.7253 17.7013 90.2894 17.7013C92.5693 17.7013 93.6205 17.2874 93.6205 15.9348C93.6205 14.4271 92.9742 14.1979 90.2254 14.1979C87.0505 14.1979 85.1328 13.2667 85.1328 10.1846C85.1328 7.22825 87.4767 6.39307 90.9002 6.39307C92.9671 6.39307 94.1674 6.51871 95.0624 6.68132V8.83209C93.9544 8.66949 92.9671 8.51428 91.0494 8.51428C88.2438 8.51428 87.4696 8.89861 87.4696 10.2142C87.4696 11.5963 88.1799 11.9141 90.9854 11.9141C94.345 11.9141 95.9857 12.9415 95.9857 15.957C95.9999 19.0095 94.3024 19.8447 90.3817 19.8447Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                        d: "M48.0929 8.6031V6.48189H44.2646V0H41.7928C41.7928 2.84553 42.1409 6.48189 39.4561 6.48189V8.6031H41.7928V14.3829C41.7928 18.5883 43.7035 19.8078 46.4238 19.8078C47.198 19.8078 47.752 19.7413 48.0929 19.6822V17.5314C47.6597 17.5979 47.2619 17.6275 46.7647 17.6275C44.9109 17.6275 44.2646 16.8219 44.2646 14.1611V8.6031H48.0929Z",
                        fill: color
                    })
                ]
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("clipPath", {
                    id: "clip0_277_498",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("rect", {
                        width: "96",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
const $697654d10ef148cd$export$f7d22cea9593f68a = (color = "#121111", width = "34", height = "28")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 34 28",
        fill: "none",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
            d: "M30.5999 18.9445C27.4636 31.1696 22.159 25.8467 22.159 25.8467C18.5299 21.8984 18.5241 8.62633 19.3705 5.029C20.3213 -0.241238 25.8693 0.0512283 25.7418 5.04655C25.5852 8.21103 24.333 11.3931 23.4634 14.1013C22.5938 16.8095 19.7242 26.9698 14.4022 26.9698C7.03385 26.9698 8.20491 8.25197 9.11508 4.53765C10.0484 0.0219819 15.1385 -0.416717 15.4226 4.65464C15.5733 12.4108 11.9268 19.6757 7.48024 20.4653C-1.08818 22.0037 -6.0101 -0.31143 24.9417 11.6446C32.4493 14.0896 33 6.37434 33 6.37434",
            stroke: color,
            strokeWidth: "1.5",
            strokeMiterlimit: "10"
        })
    });
};
const $697654d10ef148cd$export$71d3d2dad08b2134 = (color = "#1A1A1A", width = "26", height = "26")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 26 26",
        fill: "none",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.2 7C8.2 4.34903 10.349 2.2 13 2.2C15.6509 2.2 17.8 4.34903 17.8 7C17.8 9.65097 15.6509 11.8 13 11.8C10.349 11.8 8.2 9.65097 8.2 7ZM16.0013 12.1966C17.794 11.159 19 9.2203 19 7C19 3.6863 16.3137 1 13 1C9.6863 1 7 3.6863 7 7C7 9.2203 8.20601 11.159 9.99868 12.1966C4.80797 13.5982 1 18.5506 1 24.4C1 24.7313 1.26863 25 1.6 25C1.93137 25 2.2 24.7313 2.2 24.4C2.2 18.0746 7.06395 13 13 13C18.936 13 23.8 18.0746 23.8 24.4C23.8 24.7313 24.0687 25 24.4 25C24.7313 25 25 24.7313 25 24.4C25 18.5506 21.192 13.5982 16.0013 12.1966Z",
            fill: color,
            stroke: color,
            strokeWidth: "0.7"
        })
    });
};
const $697654d10ef148cd$export$a2066dd47ca2af20 = (color = "#ECECEC", stroke = "#E6E6E6", width = "24", height = "21")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
            d: "M11.6171 2.91245L11.9995 3.36569L12.3816 2.91217C13.672 1.38043 15.4933 0.5 17.4285 0.5C20.448 0.5 23.5 2.67726 23.5 6.90557C23.5 8.36006 22.8709 9.89933 21.8608 11.4233C20.8544 12.9418 19.4985 14.4019 18.1132 15.6876C15.344 18.2577 12.5131 20.0801 12.2877 20.2239C12.2876 20.224 12.2875 20.224 12.2875 20.2241L12.0001 20.4071L11.7127 20.224C11.4889 20.0813 8.65703 18.2586 5.88686 15.6876C4.50153 14.4019 3.1456 12.9418 2.13917 11.4233C1.12909 9.89933 0.5 8.36006 0.5 6.90557C0.5 2.67703 3.55222 0.5 6.57181 0.5C8.50337 0.5 10.3219 1.37751 11.6171 2.91245Z",
            fill: color,
            stroke: stroke
        })
    });
};
const $697654d10ef148cd$export$19ea304fadb5ce85 = (color = "#838383", width = "9", height = "17")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 9 17",
        fill: "none",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.5 8.5C6.433 8.5 8 6.933 8 5C8 3.067 6.433 1.5 4.5 1.5C2.567 1.5 1 3.067 1 5C1 6.933 2.567 8.5 4.5 8.5ZM9 5C9 7.31628 7.24998 9.22381 5 9.47254V12.5H8V13.5H5V16.5H4V13.5H1V12.5H4V9.47254C1.75002 9.22381 0 7.31628 0 5C0 2.51472 2.01472 0.5 4.5 0.5C6.98528 0.5 9 2.51472 9 5Z",
            fill: color
        })
    });
};
const $697654d10ef148cd$export$443b69c24d80059c = (color = "#838383", width = "14", height = "15")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.9998 0.75H8.49984C8.2237 0.75 7.99984 0.973858 7.99984 1.25C7.99984 1.52614 8.2237 1.75 8.49984 1.75L11.7927 1.75L8.50638 5.03636C7.6077 4.29519 6.45584 3.85 5.2 3.85C2.32812 3.85 0 6.17812 0 9.05C0 11.9219 2.32812 14.25 5.2 14.25C8.07188 14.25 10.4 11.9219 10.4 9.05C10.4 7.79408 9.95476 6.64215 9.2135 5.74345L12.4998 2.45711V5.75C12.4998 6.02614 12.7237 6.25 12.9998 6.25C13.276 6.25 13.4998 6.02614 13.4998 5.75V1.25C13.4998 0.973858 13.276 0.75 12.9998 0.75ZM9.4 9.05C9.4 11.3696 7.5196 13.25 5.2 13.25C2.8804 13.25 1 11.3696 1 9.05C1 6.73041 2.8804 4.85 5.2 4.85C7.5196 4.85 9.4 6.73041 9.4 9.05Z",
            fill: color
        })
    });
};
const $697654d10ef148cd$export$6b50bc1c8d5a27bc = (color = "#000000", width = "14", height = "9")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 14 9",
        fill: "none",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
            d: "M1 1L7 8L13 1",
            stroke: color
        })
    });
};
const $697654d10ef148cd$export$8521ae0221f903e = (color = "#1D1D1D", width = "12", height = "14")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 12 14",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("circle", {
                cx: "9.60001",
                cy: "2.7999",
                r: "1.9",
                stroke: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("circle", {
                cx: "9.60001",
                cy: "11.1998",
                r: "1.9",
                stroke: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("circle", {
                cx: "2.4",
                cy: "6.99985",
                r: "1.9",
                stroke: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("line", {
                x1: "3.96133",
                y1: "5.62583",
                x2: "7.76322",
                y2: "3.56048",
                stroke: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("line", {
                x1: "4.35685",
                y1: "7.98737",
                x2: "8.05412",
                y2: "10.1694",
                stroke: color
            })
        ]
    });
};
const $697654d10ef148cd$export$f937d5e732d2a014 = (color = "#D9D9D9", width = "25", height = "23")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 25 23",
        fill: "none",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
            d: "M12.5 0L15.3064 8.63729H24.3882L17.0409 13.9754L19.8473 22.6127L12.5 17.2746L5.15268 22.6127L7.95911 13.9754L0.611794 8.63729H9.69357L12.5 0Z",
            fill: color
        })
    });
};
const $697654d10ef148cd$export$e0297576c9c02d75 = (color = "#FFFFFF", width = "51", height = "51")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 51 51",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "49.3007",
                height: "49.611",
                rx: "24.6503",
                stroke: "white"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.3059 26.3678L35.2381 36.3L36.3 35.2381L26.3678 25.3059L36.3007 15.3729L35.2388 14.311L25.3059 24.2439L15.0619 14L14 15.0619L24.2439 25.3059L14.0007 35.5491L15.0626 36.611L25.3059 26.3678Z",
                fill: color
            })
        ]
    });
};
const $697654d10ef148cd$export$808a2a6d676a656b = (color = "#272624", width = "20", height = "20")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M1.6665 4.1665H18.3332",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("circle", {
                cx: "7.5",
                cy: "4.1665",
                r: "2.5",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M1.6665 10H18.3332",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("circle", {
                cx: "13.333",
                cy: "10",
                r: "2.5",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M1.6665 15.8335H18.3332",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("circle", {
                cx: "7.5",
                cy: "15.8335",
                r: "2.5",
                fill: color
            })
        ]
    });
};
const $697654d10ef148cd$export$a6cccece9dc8d76a = (color = "#000000", width = "19", height = "20")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 19 20",
        fill: "none",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.03708 11.0867L16.9504 19.0001L18.0124 17.9382L10.099 10.0248L18.0619 2.06191L17 1L9.03708 8.96292L1.06245 0.988281L0.000542764 2.05019L7.97518 10.0248L0 18L1.06191 19.0619L9.03708 11.0867Z",
            fill: color
        })
    });
};
const $697654d10ef148cd$export$1718df1744846756 = (color = "#FFFDF9", width = "22", height = "22")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
            d: "M1 11.1898C1 10.7733 1.17315 10.3756 1.478 10.0918L9.978 2.1799C10.5539 1.64385 11.4461 1.64385 12.022 2.1799L20.522 10.0918C20.8268 10.3755 21 10.7733 21 11.1898V19.5455C21 20.374 20.3284 21.0455 19.5 21.0455H2.5C1.67157 21.0455 1 20.374 1 19.5455V11.1898Z",
            stroke: color
        })
    });
};
const $697654d10ef148cd$export$8081465a586297e5 = (color = "#878787", width = "16", height = "18")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
            d: "M8.70711 0.292892C8.31658 -0.0976315 7.68342 -0.0976315 7.29289 0.292892L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292892ZM9 18L9 1L7 1L7 18L9 18Z",
            fill: color
        })
    });
};
const $697654d10ef148cd$export$27b4be198a414222 = (color = "#000000", width = "33", height = "35")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 33 35",
        fill: "none",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
            d: "M15.5023 34.2649C13.1945 33.7417 8.43371 32.0014 4.98 26.2991C2.85132 22.7848 1.21663 17.7556 0.976481 10.5604C0.917497 8.81483 1.5442 7.20029 2.62065 5.97994C3.69921 4.7575 5.23068 3.93136 6.97807 3.76466C7.98817 3.66821 9.08885 3.44909 10.2106 3.03183C11.1522 2.68061 12.1118 2.18681 13.0502 1.50325C14.2341 0.640411 15.6013 0.209516 16.9727 0.208467V0.205322C18.3398 0.205322 19.708 0.637266 20.894 1.5022C21.8325 2.18576 22.792 2.68061 23.7337 3.03078C24.8554 3.44909 25.9571 3.66821 26.9672 3.76466C28.7157 3.93136 30.2461 4.75855 31.3247 5.97994C32.4022 7.20029 33.0278 8.81483 32.9688 10.5604C32.7287 17.7556 31.094 22.7848 28.9653 26.2991C25.5116 32.0014 20.7518 33.7417 18.443 34.2649C17.9322 34.3802 17.4498 34.4379 16.9716 34.4379C16.4934 34.4379 16.011 34.3802 15.5002 34.2649H15.5023ZM16.9737 7.62594C19.5205 7.62594 21.8262 8.65338 23.4956 10.3151C25.1651 11.9768 26.1973 14.2718 26.1973 16.8068C26.1973 19.3419 25.1651 21.6368 23.4956 23.2986C21.8262 24.9603 19.5205 25.9877 16.9737 25.9877C14.4269 25.9877 12.1212 24.9603 10.4518 23.2986C8.78234 21.6368 7.75013 19.3419 7.75013 16.8068C7.75013 14.2718 8.78234 11.9768 10.4518 10.3151C12.1212 8.65338 14.4269 7.62594 16.9737 7.62594ZM22.356 11.4495C20.9793 10.0792 19.0761 9.23105 16.9737 9.23105C14.8714 9.23105 12.9691 10.0792 11.5914 11.4495C10.2138 12.8208 9.36165 14.7153 9.36165 16.8068C9.36165 18.8995 10.2138 20.7929 11.5914 22.1642C12.9681 23.5345 14.8714 24.3837 16.9737 24.3837C19.0761 24.3837 20.9783 23.5355 22.356 22.1642C23.7337 20.7929 24.5858 18.8984 24.5858 16.8068C24.5858 14.7142 23.7337 12.8208 22.356 11.4495ZM12.0728 16.9683C11.76 16.6548 11.761 16.1484 12.076 15.8371C12.3909 15.5257 12.8996 15.5267 13.2124 15.8402L16.0489 18.6803L20.7223 13.7665C21.0267 13.4467 21.5344 13.432 21.8557 13.735C22.178 14.038 22.1917 14.5433 21.8873 14.8631L16.6819 20.3358C16.6651 20.3557 16.6472 20.3756 16.6282 20.3945C16.3133 20.7059 15.8046 20.7048 15.4917 20.3913L12.0728 16.9672V16.9683ZM6.3598 25.4719C9.50384 30.6626 13.7833 32.2341 15.8551 32.7038C16.2375 32.7908 16.604 32.8338 16.9737 32.8338C17.3445 32.8338 17.711 32.7908 18.0923 32.7038C20.1641 32.2341 24.4436 30.6626 27.5876 25.4719C29.5931 22.161 31.134 17.3876 31.3647 10.5112C31.4089 9.18597 30.9339 7.95933 30.1165 7.03359C29.3003 6.1089 28.1406 5.483 26.8166 5.35719C25.6812 5.2492 24.4404 5.00178 23.1744 4.53C22.0979 4.12846 21.0046 3.56756 19.944 2.79384C19.0445 2.13858 18.0091 1.81043 16.9737 1.81043V1.80729C15.9415 1.80729 14.9051 2.13649 14.0024 2.79384C12.9417 3.56651 11.8495 4.12741 10.772 4.52895C9.50489 5.00073 8.26518 5.24816 7.12975 5.35614C5.80577 5.48195 4.64611 6.10785 3.82982 7.03254C3.01247 7.95829 2.53744 9.18492 2.58168 10.5101C2.81235 17.3876 4.3533 22.16 6.35874 25.4709L6.3598 25.4719Z",
            fill: color
        })
    });
};
const $697654d10ef148cd$export$1009cf4fe158a792 = (color = "#000000", width = "34", height = "35")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 34 35",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M11.5496 21.2039C9.8697 19.7107 9.2724 19.1507 8.97376 18.8894C8.67511 18.5908 8.67511 18.5907 8.18981 18.2174C7.48052 17.6201 6.84589 17.4335 6.36059 17.5082C5.98728 15.1563 4.90469 8.06344 4.56871 7.0555C4.34472 6.30888 3.67277 5.86091 2.92615 5.93557C2.21686 6.01024 1.47024 6.5702 1.39558 7.69013C1.28359 9.18336 1.02227 16.6869 0.984942 18.8894C0.87295 21.3532 1.54491 22.0999 2.25419 22.9211C2.32886 22.9958 2.36619 23.0705 2.44085 23.1451C3.26213 24.1157 5.12867 26.1689 6.54725 27.5128C7.70451 28.6328 7.70451 28.9314 7.74184 29.7527V30.0513C7.77917 31.1339 7.51785 33.9711 7.51785 34.0084C7.51785 34.1577 7.55518 34.3071 7.66717 34.4564C7.77917 34.5684 7.92849 34.643 8.07781 34.643L13.7894 34.4937C14.0881 34.4937 14.3494 34.2324 14.3494 33.9338C14.3494 33.0378 14.3494 32.1792 14.3867 31.3579C14.4614 27.1395 14.5361 23.8544 11.5496 21.2039ZM13.2295 33.3738L8.67511 33.4858C8.71244 32.8885 8.7871 31.9925 8.82443 31.1713L13.2668 30.798C13.2668 30.9846 13.2668 31.1339 13.2668 31.3206C13.2668 31.9552 13.2295 32.6645 13.2295 33.3738ZM13.3041 29.678L8.86176 30.0513V30.014V29.7527C8.86176 28.6701 8.7871 28.0728 7.3312 26.7289C5.91262 25.385 4.08341 23.3691 3.29946 22.4358C3.2248 22.3612 3.15014 22.2865 3.1128 22.2118C2.47818 21.5026 2.03021 20.9799 2.10487 18.9267C2.17953 16.3136 2.40352 9.18336 2.51551 7.80212C2.55284 7.31682 2.85149 7.13016 3.07547 7.09283H3.1128C3.2248 7.09283 3.44878 7.13016 3.52344 7.42881C3.78476 8.32475 4.90469 15.343 5.35266 18.2548C5.09134 18.7401 5.166 19.4494 5.50198 20.1213C6.28593 21.6519 7.59251 23.7797 7.66717 23.8917C7.8165 24.1531 8.18981 24.2277 8.45112 24.0784C8.71244 23.9291 8.7871 23.5558 8.63778 23.2944C8.63778 23.2571 7.25653 21.0919 6.54725 19.636C6.32326 19.188 6.32326 18.8521 6.39792 18.7401L6.43526 18.7027C6.54725 18.6281 6.92056 18.6281 7.51785 19.1507C7.96582 19.524 7.96582 19.524 8.26447 19.7853C8.56312 20.0467 9.19774 20.6066 10.8776 22.0999C13.0428 24.0037 13.3041 26.4676 13.3041 29.678Z",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M33.5003 18.852C33.4256 16.6869 33.2017 9.18334 33.0897 7.65277C33.015 6.57018 32.2311 6.01021 31.5591 5.89822C30.8125 5.82356 30.1405 6.27153 29.9165 7.01815C29.6179 8.02608 28.498 15.119 28.1247 17.4708C27.6394 17.4335 27.0047 17.5828 26.2954 18.1801C25.8101 18.5534 25.8101 18.5534 25.5115 18.852C25.2128 19.1134 24.5782 19.6733 22.9357 21.1666C19.9492 23.8171 20.0239 27.1022 20.0985 31.2832C20.0985 32.1045 20.1358 32.9631 20.1358 33.8591C20.1358 34.1577 20.3598 34.419 20.6958 34.419L26.4074 34.5684C26.5568 34.5684 26.7061 34.4937 26.8181 34.3817C26.9301 34.2697 26.9674 34.1204 26.9674 33.9337C26.9674 33.8964 26.7434 31.0593 26.7434 29.9767V29.678C26.7434 28.8567 26.7434 28.5581 27.938 27.4382C29.3566 26.0569 31.2605 24.0037 32.0444 23.0704C32.1191 22.9958 32.1564 22.9211 32.2311 22.8465C32.903 22.0998 33.575 21.3532 33.5003 18.852ZM21.2184 33.3738C21.2184 32.6645 21.2184 31.9925 21.1811 31.3206C21.1811 31.1339 21.1811 30.9846 21.1811 30.7979L25.6235 31.1712C25.6608 31.9552 25.7355 32.8885 25.7728 33.4858L21.2184 33.3738ZM31.3724 22.1745C31.2978 22.2492 31.2231 22.3238 31.1858 22.3985C30.4018 23.3318 28.5353 25.3476 27.1541 26.6915C25.7355 28.0728 25.6608 28.6327 25.6235 29.7153V29.9767V30.014L21.1811 29.6407C21.1438 26.4302 21.4424 24.0037 23.645 21.9878C25.3248 20.4946 25.9595 19.9346 26.2581 19.6733C26.5568 19.412 26.5568 19.412 27.0047 19.0387C27.602 18.5534 27.9753 18.5161 28.0873 18.5907C28.0873 18.5907 28.0873 18.6281 28.1247 18.6281C28.1993 18.7401 28.1993 19.076 27.9753 19.524C27.2287 21.0172 25.8848 23.1824 25.8848 23.1824C25.7355 23.4437 25.8101 23.7797 26.0715 23.9664C26.3328 24.1157 26.6688 24.041 26.8554 23.7797C26.9301 23.7051 28.2367 21.5399 29.0206 20.0093C29.3566 19.3 29.4312 18.6281 29.1699 18.1428C29.6179 15.2309 30.7378 8.21274 30.9991 7.31679C31.1111 6.98082 31.3724 6.98082 31.4471 6.98082C31.6711 7.01815 31.9697 7.2048 32.0071 7.6901C32.1191 9.07135 32.3431 16.2016 32.4177 18.8147C32.4177 20.9426 31.9697 21.4652 31.3724 22.1745Z",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M22.9358 16.5003H23.6825C24.7277 16.5003 25.6983 16.015 26.3329 15.1937C26.9676 14.3724 27.1916 13.3271 26.9302 12.3192L25.213 5.82362C24.2797 2.38918 21.1813 0 17.6348 0H16.7762C13.2298 0 10.1313 2.38918 9.23539 5.82362L7.51817 12.3192C7.25685 13.3271 7.48084 14.3724 8.11546 15.1937C8.75009 16.015 9.72069 16.5003 10.766 16.5003H11.5126C11.8486 17.7322 12.8938 18.6281 14.1631 18.8148C14.6484 20.0094 15.8803 20.8306 17.1869 20.8306C18.5308 20.8306 19.7254 20.0094 20.2107 18.8148C21.5546 18.6281 22.5625 17.6949 22.9358 16.5003ZM12.5205 15.6417V10.3033C12.5205 10.0047 12.2592 9.74337 11.9605 9.74337C11.6619 9.74337 11.4006 10.0047 11.4006 10.3033V15.3803H10.766C10.0567 15.3803 9.42204 15.0817 9.0114 14.5217C8.60076 13.9618 8.45144 13.2898 8.6381 12.6178L10.3553 6.12227C11.1393 3.17313 13.7898 1.15726 16.8136 1.15726H17.6722C20.696 1.15726 23.3465 3.21046 24.1304 6.12227L25.8103 12.5805C25.997 13.2525 25.8476 13.9618 25.437 14.4844C25.0264 15.0444 24.3917 15.343 23.6825 15.343H23.0478V10.3033C23.0478 10.0047 22.7865 9.74337 22.4879 9.74337C22.1892 9.74337 21.9279 10.0047 21.9279 10.3033V15.6417C21.9279 16.7616 21.032 17.6949 19.912 17.6949C19.8747 17.6949 19.8747 17.6949 19.8374 17.6949C18.7174 17.6949 17.7842 16.7616 17.7842 15.6417C17.7842 15.343 17.5229 15.0817 17.2242 15.0817C16.9256 15.0817 16.6642 15.343 16.6642 15.6417C16.6642 16.7616 15.731 17.6949 14.611 17.6949C13.4911 17.6949 12.5205 16.7616 12.5205 15.6417ZM17.2242 19.7107C16.4776 19.7107 15.8056 19.3374 15.395 18.7028C16.1416 18.5161 16.7762 18.0308 17.2242 17.3962C17.6348 18.0308 18.3068 18.4788 19.0534 18.7028C18.6428 19.3001 17.9708 19.7107 17.2242 19.7107Z",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M14.8721 12.4313V12.6179C14.8721 13.6259 15.6933 14.4098 16.664 14.4098H17.7466C18.7545 14.4098 19.5384 13.5885 19.5384 12.6179V12.4313C19.5384 11.4234 18.7172 10.6394 17.7466 10.6394H16.664C15.6933 10.6021 14.8721 11.4234 14.8721 12.4313ZM15.992 12.4313C15.992 12.058 16.2906 11.7593 16.664 11.7593H17.7466C18.1199 11.7593 18.4185 12.058 18.4185 12.4313V12.6179C18.4185 12.9913 18.1199 13.2899 17.7466 13.2899H16.664C16.2906 13.2899 15.992 12.9913 15.992 12.6179V12.4313Z",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M19.5014 8.80987H20.1733C20.472 8.80987 20.7333 8.54855 20.7333 8.24991C20.7333 7.95126 20.472 7.68994 20.1733 7.68994H19.5014C19.2027 7.68994 18.9414 7.95126 18.9414 8.24991C18.9414 8.54855 19.2027 8.80987 19.5014 8.80987Z",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M15.5067 8.24991C15.5067 7.95126 15.2454 7.68994 14.9468 7.68994H14.2748C13.9762 7.68994 13.7148 7.95126 13.7148 8.24991C13.7148 8.54855 13.9762 8.80987 14.2748 8.80987H14.9468C15.2454 8.80987 15.5067 8.54855 15.5067 8.24991Z",
                fill: color
            })
        ]
    });
};
const $697654d10ef148cd$export$4c804b2e84980796 = (color = "#000000", width = "37", height = "32")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 37 32",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M12.9826 25.2833C13.5621 25.4642 14.1799 25.3341 14.6392 24.9328C15.2023 24.4523 15.8365 24.0962 16.58 23.8531C17.657 23.5026 18.8434 23.4969 19.9259 23.8418C20.6858 24.0848 21.3364 24.441 21.905 24.9328C22.2275 25.2098 22.6321 25.3568 23.0422 25.3568C23.2116 25.3568 23.3866 25.3285 23.5561 25.2776C24.1192 25.1024 24.5566 24.6558 24.726 24.0792C25.5242 21.3432 24.8135 18.3924 22.8617 16.3799C20.8936 14.3449 18.0124 13.8135 15.5248 15.0289C15.3171 15.1306 15.2296 15.3794 15.328 15.5942C15.4264 15.8033 15.667 15.8938 15.8747 15.7977C18.0452 14.7349 20.5601 15.1985 22.2822 16.9848C24.0153 18.7824 24.655 21.4054 23.9388 23.8418C23.8458 24.147 23.6217 24.3788 23.321 24.4749C23.0093 24.571 22.6759 24.5032 22.4298 24.2884C21.7738 23.7231 21.0357 23.3161 20.1664 23.0391C18.9254 22.6434 17.5641 22.649 16.3285 23.0504C15.4811 23.3274 14.754 23.7344 14.1088 24.2884C13.8573 24.5032 13.5239 24.5766 13.2122 24.4749C12.9115 24.3788 12.6874 24.1527 12.5944 23.8474C11.8837 21.411 12.5179 18.7881 14.251 16.9905C14.4095 16.8265 14.4095 16.5552 14.251 16.3912C14.0924 16.2273 13.83 16.2273 13.6715 16.3912C11.7197 18.4093 11.009 21.3601 11.8072 24.0905C11.9876 24.6614 12.425 25.108 12.9826 25.2833Z",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M22.3368 6.03457C20.8118 5.70427 19.18 7.14932 18.7171 9.26086C18.2483 11.4078 19.1028 13.3483 20.6575 13.6904C20.8118 13.7258 20.9661 13.7375 21.1204 13.7375C22.5208 13.7375 23.85 12.3987 24.2772 10.4641C24.7401 8.34664 23.8678 6.36487 22.3368 6.03457ZM23.4109 10.2694C23.0608 11.8737 21.8918 13.0416 20.8533 12.8174C19.8208 12.5933 19.2393 11.048 19.5894 9.4437C19.9098 7.96916 20.9246 6.86621 21.8918 6.86621C21.9808 6.86621 22.0639 6.87801 22.1529 6.8957C23.1795 7.11983 23.761 8.66514 23.4109 10.2694Z",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M23.8016 15.7429C23.9366 16.5521 24.3471 17.1547 24.9544 17.4417C25.2074 17.5622 25.4717 17.6139 25.7416 17.6139C26.7818 17.6139 27.8952 16.7702 28.5137 15.41C28.8736 14.618 29.0029 13.7743 28.8736 13.0283C28.7386 12.219 28.3281 11.6164 27.7209 11.3295C27.1136 11.0425 26.3995 11.1114 25.7078 11.5303C25.0668 11.9149 24.5214 12.5634 24.1615 13.3554C23.8073 14.1474 23.6779 14.991 23.8016 15.7429ZM24.9319 13.717C25.2186 13.0856 25.6516 12.5691 26.1408 12.2707C26.4163 12.1042 26.6919 12.0182 26.9449 12.0182C27.0967 12.0182 27.2373 12.0469 27.3722 12.11C27.7209 12.2764 27.9627 12.6495 28.047 13.1717C28.1426 13.7514 28.0358 14.4171 27.749 15.0484C27.1923 16.2824 26.0733 17.0112 25.3086 16.6554C24.96 16.489 24.7182 16.1159 24.6338 15.5937C24.5382 15.0197 24.6451 14.3483 24.9319 13.717Z",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M15.4171 13.7375C15.5714 13.7375 15.7258 13.7198 15.8742 13.6903C16.6461 13.5251 17.2754 12.9468 17.6316 12.0735C17.97 11.2533 18.0353 10.256 17.8157 9.26468C17.3466 7.11677 15.7555 5.70055 14.2 6.0369C13.4282 6.20213 12.7988 6.78042 12.4426 7.65375C12.1042 8.47397 12.0389 9.47121 12.2585 10.4626C12.4782 11.4539 12.9532 12.339 13.6003 12.9409C14.1525 13.4661 14.7878 13.7375 15.4171 13.7375ZM13.2619 7.98419C13.5053 7.38821 13.9091 6.99875 14.384 6.89843C14.4671 6.88073 14.5562 6.86893 14.6453 6.86893C15.613 6.86893 16.6223 7.97239 16.9429 9.44761C17.121 10.2678 17.0735 11.0822 16.8064 11.7372C16.5629 12.3331 16.1592 12.7226 15.6843 12.8229C15.2093 12.9232 14.6809 12.7403 14.2059 12.2977C13.6894 11.8139 13.3035 11.094 13.1254 10.2737C12.9413 9.45351 12.9947 8.63919 13.2619 7.98419Z",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M8.80796 11.3295C8.20113 11.6164 7.79095 12.219 7.6561 13.0283C7.53248 13.7743 7.66172 14.6237 8.0157 15.41C8.63378 16.7702 9.74632 17.6139 10.7858 17.6139C11.0555 17.6139 11.3196 17.5565 11.5724 17.4417C12.7917 16.8678 13.1401 15.0714 12.3647 13.3611C11.5893 11.6451 10.0273 10.7555 8.80796 11.3295ZM11.2241 16.6554C10.4599 17.017 9.34176 16.2824 8.78549 15.0484C8.49893 14.4171 8.39217 13.7456 8.48769 13.1717C8.57197 12.6552 8.81358 12.2764 9.16195 12.11C9.29119 12.0469 9.43728 12.0182 9.58337 12.0182C10.2913 12.0182 11.1398 12.6954 11.6005 13.717C12.1568 14.9509 11.9882 16.2938 11.2241 16.6554Z",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M26.2543 0.821533C23.0378 0.821533 20.1011 2.34939 18.2663 4.9401C16.4315 2.34939 13.4947 0.821533 10.2783 0.821533C4.89142 0.821533 0.505859 5.156 0.505859 10.4924C0.505859 21.5417 17.3377 31.3565 18.0537 31.7717C18.1208 31.8049 18.1936 31.8215 18.2663 31.8215C18.339 31.8215 18.4117 31.8049 18.4788 31.7662C18.5236 31.7385 19.6256 31.1074 21.2758 29.9781C21.4659 29.8508 21.5163 29.5906 21.382 29.4024C21.2478 29.2142 20.9905 29.1644 20.8003 29.2972C19.5864 30.1221 18.6634 30.6922 18.2663 30.9303C16.3028 29.7456 1.34493 20.418 1.34493 10.4924C1.34493 5.621 5.35012 1.65189 10.2783 1.65189C13.4164 1.65189 16.2693 3.24618 17.9083 5.91439C17.9866 6.03618 18.1208 6.11368 18.2663 6.11368C18.4117 6.11368 18.546 6.03618 18.6243 5.91439C20.2633 3.24618 23.1161 1.65189 26.2543 1.65189C31.1768 1.65189 35.1876 5.61546 35.1876 10.4924C35.1876 17.7387 27.2052 24.6528 22.4449 28.1347C22.2603 28.2731 22.2211 28.5333 22.3554 28.716C22.4952 28.8987 22.7525 28.9374 22.9427 28.8046C27.8261 25.234 36.0267 18.104 36.0267 10.498C36.0267 5.156 31.6411 0.821533 26.2543 0.821533Z",
                fill: color
            })
        ]
    });
};
const $697654d10ef148cd$export$4a899e7a49365346 = (color = "#FFF", width = "18", height = "22")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 22",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M9.0017 -0.00219727C4.04407 -0.00219727 0.0136719 4.02798 0.0136719 8.98318C0.0136719 10.9644 0.646275 12.8415 1.85733 14.4335L7.85683 21.5125C7.85683 21.5125 7.87402 21.5297 7.88003 21.5382C8.18945 21.8477 8.59601 22.0024 8.99911 22.0024C9.40308 22.0024 9.80878 21.8477 10.1182 21.5382C10.1268 21.5297 10.1354 21.5211 10.144 21.5125L16.1899 14.3681C16.1899 14.3681 16.2011 14.3535 16.2071 14.3484C17.3717 12.7857 17.9871 10.931 17.9871 8.98674C17.9863 4.02823 13.956 -0.00219727 9.0017 -0.00219727ZM15.528 13.8231L9.50272 20.9417C9.22252 21.2107 8.77814 21.2107 8.49795 20.9417L2.52683 13.897C1.4447 12.4745 0.872274 10.7745 0.872274 8.98231C0.872274 4.50348 4.51827 0.856382 9.0015 0.856382C13.4838 0.856382 17.1307 4.50326 17.1307 8.98318C17.1307 10.7375 16.5781 12.4091 15.5277 13.8205L15.528 13.8231Z",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M13.6048 8.1761C13.2756 5.95506 11.3837 4.24648 9.07951 4.20863C9.05373 4.20863 9.02794 4.20605 9.00215 4.20605C6.42884 4.20605 4.3418 6.29296 4.3418 8.86641C4.3418 8.8922 4.34438 8.91541 4.34438 8.94119C4.38477 11.4802 6.45104 13.5267 9.00121 13.5267C9.027 13.5267 9.05279 13.5242 9.07857 13.5242C11.3339 13.4872 13.1948 11.8498 13.5842 9.70016C13.6332 9.43112 13.6616 9.1535 13.6616 8.86728C13.6616 8.63263 13.6384 8.40313 13.604 8.17709L13.6048 8.1761ZM12.8028 8.86543C12.8028 10.9609 11.0967 12.667 9.00129 12.667C6.9058 12.667 5.19973 10.9609 5.19973 8.86543C5.19973 6.76994 6.90587 5.06387 9.00129 5.06387C11.0968 5.06387 12.8028 6.77 12.8028 8.86543Z",
                fill: color
            })
        ]
    });
};
const $697654d10ef148cd$export$8e2dca508f1d472c = (color = "#B2B1B1", width = "42", height = "40")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 42 40",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M35.7667 0H7.20946C3.77753 0 0.986328 2.85673 0.986328 6.36902V25.8305C0.986328 29.2324 3.60556 32.0177 6.88755 32.1885V38.5014C6.88755 39.0765 7.20786 39.5991 7.71486 39.8501C7.91803 39.9513 8.13585 40 8.35184 40C8.67582 40 8.99613 39.8895 9.25971 39.6778L14.9116 35.1032C17.2289 33.23 20.132 32.1959 23.084 32.1959L35.7632 32.1978C39.1951 32.1978 41.9863 29.3411 41.9863 25.8288V6.36539C41.9863 2.85674 39.1966 0 35.7667 0ZM39.0577 25.8286C39.0577 27.6887 37.5788 29.2004 35.7631 29.2004H23.0839C19.4744 29.2004 15.9274 30.4611 13.0958 32.7521L9.81576 35.4066V30.6991C9.81576 29.871 9.16051 29.2004 8.35147 29.2004H7.20566C5.38994 29.2004 3.91468 27.6887 3.91468 25.8323V6.36892C3.91468 4.50876 5.3936 2.99705 7.20932 2.99705H35.7666C37.5823 2.99705 39.0575 4.50876 39.0575 6.36518L39.0577 25.8286Z",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("circle", {
                cx: "13.4863",
                cy: "16.5",
                r: "2.5",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("circle", {
                cx: "21.4863",
                cy: "16.5",
                r: "2.5",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("circle", {
                cx: "29.4863",
                cy: "16.5",
                r: "2.5",
                fill: color
            })
        ]
    });
};
const $697654d10ef148cd$export$53b4b033af362e7 = (color = "#B8B6B2", width = "41", height = "41")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 41 41",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M20.8154 8.12305C24.0256 8.12305 26.6152 10.7043 26.6152 13.873C26.6152 17.0418 24.0256 19.623 20.8154 19.623C17.6053 19.6229 15.0156 17.0417 15.0156 13.873C15.0157 10.7044 17.6053 8.12315 20.8154 8.12305Z",
                stroke: color,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M32.8164 33.9468V32.9384C32.8164 27.7938 28.6458 23.6232 23.5011 23.6232H18.1317C12.987 23.6232 8.81641 27.7938 8.81641 32.9384V33.9468",
                stroke: color,
                strokeWidth: "2"
            })
        ]
    });
};
const $697654d10ef148cd$export$9854b78a57015514 = (color = "#B8B6B2", width = "49", height = "41")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 49 41",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M30.012 20.3373L29.932 17.5213L31.116 17.4413C31.6706 17.4093 32.124 17.2493 32.476 16.9613C32.8386 16.6733 33.02 16.252 33.02 15.6973C33.02 15.228 32.8546 14.8387 32.524 14.5293C32.1933 14.22 31.7613 14.0653 31.228 14.0653C30.8546 14.0653 30.5293 14.1613 30.252 14.3533C29.9853 14.5347 29.7986 14.764 29.692 15.0413L27.772 14.4973C27.9853 13.7933 28.3906 13.228 28.988 12.8013C29.596 12.3747 30.3426 12.1613 31.228 12.1613C31.9746 12.1613 32.636 12.316 33.212 12.6253C33.788 12.924 34.236 13.34 34.556 13.8733C34.8866 14.396 35.052 15.004 35.052 15.6973C35.052 16.2627 34.9293 16.7693 34.684 17.2173C34.4386 17.6653 34.0866 18.028 33.628 18.3053C33.18 18.5827 32.6573 18.7587 32.06 18.8333L32.028 20.3373H30.012ZM31.02 23.7933C30.668 23.7933 30.364 23.6707 30.108 23.4253C29.8626 23.1693 29.74 22.86 29.74 22.4973C29.74 22.1453 29.8626 21.8467 30.108 21.6013C30.364 21.3453 30.668 21.2173 31.02 21.2173C31.372 21.2173 31.6706 21.3453 31.916 21.6013C32.172 21.8467 32.3 22.1453 32.3 22.4973C32.3 22.86 32.172 23.1693 31.916 23.4253C31.6706 23.6707 31.372 23.7933 31.02 23.7933Z",
                fill: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M42.8861 18.5162C42.8861 12.036 37.2894 6.78271 30.3864 6.78271C23.4834 6.78271 17.8867 12.036 17.8867 18.5162C17.8867 24.9964 23.4834 30.2497 30.3864 30.2497C34.5129 30.2497 38.1693 28.3735 40.443 25.4788C40.443 25.4788 44.2306 27.4086 47.6848 24.0732C48.0182 23.7516 47.9253 23.15 47.5045 23.0011C44.258 21.8754 42.8861 18.5162 42.8861 18.5162Z",
                stroke: color,
                strokeWidth: "2",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M26.8867 32.1877C24.8047 33.6499 22.2241 34.5164 19.4299 34.5164C15.2933 34.5164 11.6279 32.621 9.34867 29.6966C9.34867 29.6966 5.55177 31.6462 2.08908 28.2766C1.75487 27.9517 1.84801 27.3439 2.26989 27.1935C5.52985 26.0562 6.89958 22.6626 6.89958 22.6626C6.89958 16.9342 11.1951 12.1566 16.9041 11.0494",
                stroke: color,
                strokeWidth: "2",
                strokeMiterlimit: "10"
            })
        ]
    });
};
const $697654d10ef148cd$export$bb4762fa55cf2a3b = (color = "#B8B6B2", width = "41", height = "41")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 41 41",
        fill: "none",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
            d: "M33.957 8.03491H7.95703V33.0349L20.957 21.397L33.957 33.0349V8.03491Z",
            stroke: color,
            strokeWidth: "2"
        })
    });
};
const $697654d10ef148cd$export$bf3662556f1b3b0d = (color = "#B8B6B2", width = "41", height = "41")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 41 41",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("circle", {
                cx: "14.6318",
                cy: "15.9493",
                r: "5.15914",
                stroke: color,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M25.1366 34.4265V34.3219C25.1366 29.1773 20.966 25.0067 15.8213 25.0067H12.7137C7.56902 25.0067 3.39844 29.1773 3.39844 34.3219V34.4265",
                stroke: color,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("circle", {
                cx: "29.8328",
                cy: "11.4312",
                r: "3.78789",
                stroke: color,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M38 25.7946V25.7946C38 21.7505 34.7215 18.472 30.6773 18.472H26.9811C26.2824 18.472 25.5767 18.531 24.933 18.8027C23.9552 19.2155 22.7714 19.9706 22.3086 21.1277",
                stroke: color,
                strokeWidth: "2"
            })
        ]
    });
};
const $697654d10ef148cd$export$2fa1d1fbf2c6cbf6 = (color = "#B8B6B2", width = "41", height = "41")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 41 41",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M19.291 26.2884H7.78392",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("line", {
                x1: "38.8516",
                y1: "15.7812",
                x2: "2.02887",
                y2: "15.7812",
                stroke: color,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("rect", {
                x: "1.87891",
                y: "7.7264",
                width: "37.1241",
                height: "25.617",
                rx: "3.65763",
                stroke: color,
                strokeWidth: "2"
            })
        ]
    });
};
const $697654d10ef148cd$export$2b4875707073ca28 = (color = "#B8B6B2", width = "41", height = "41")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 41 41",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M22.2402 5.16187C23.6328 5.33498 24.9689 5.68255 26.2256 6.17944L25.8584 7.10815C27.072 7.58804 28.2065 8.21772 29.2363 8.97241L29.8262 8.16577C30.941 8.98268 31.9418 9.93767 32.8018 11.0046H32.8027L32.0244 11.6316C32.8306 12.6319 33.503 13.7368 34.0176 14.9197L34.9336 14.5203C35.4751 15.7651 35.8524 17.0928 36.042 18.4783L35.0537 18.614C35.1396 19.242 35.1836 19.8832 35.1836 20.5349C35.1836 21.1866 35.1396 21.8278 35.0537 22.4558L36.042 22.5906C35.8525 23.9761 35.4751 25.3037 34.9336 26.5486L34.0176 26.1501C33.503 27.333 32.8306 28.4379 32.0244 29.4382L32.8018 30.0642C31.9419 31.1313 30.941 32.0861 29.8262 32.9031L29.2363 32.0974C28.2065 32.8521 27.072 33.4818 25.8584 33.9617L26.2256 34.8894C24.9688 35.3864 23.6329 35.7339 22.2402 35.907L22.1182 34.9158C21.4853 34.9945 20.8395 35.0349 20.1836 35.0349C19.5277 35.0349 18.8819 34.9945 18.249 34.9158L18.126 35.907C16.7334 35.7338 15.3973 35.3864 14.1406 34.8894L14.5088 33.9617C13.2952 33.4818 12.1607 32.8521 11.1309 32.0974L10.54 32.9031C9.42525 32.0861 8.42428 31.1313 7.56445 30.0642L8.34277 29.4382C7.53662 28.4379 6.86416 27.333 6.34961 26.1501L5.43262 26.5486C4.8912 25.3038 4.51374 23.976 4.32422 22.5906L5.31348 22.4558C5.22754 21.8278 5.18359 21.1866 5.18359 20.5349C5.18359 19.8832 5.22754 19.242 5.31348 18.614L4.32422 18.4783C4.51382 17.0929 4.89114 15.765 5.43262 14.5203L6.34961 14.9197C6.86416 13.7368 7.53662 12.6319 8.34277 11.6316L7.56445 11.0046C8.4243 9.93768 9.42527 8.9827 10.54 8.16577L11.1309 8.97241C12.1607 8.21773 13.2952 7.58804 14.5088 7.10815L14.1406 6.17944C15.3973 5.68249 16.7335 5.33505 18.126 5.16187L18.249 6.15405C18.8819 6.07534 19.5277 6.03491 20.1836 6.03491C20.8395 6.03491 21.4853 6.07534 22.1182 6.15405L22.2402 5.16187Z",
                stroke: color,
                strokeWidth: "2",
                strokeDasharray: "4 4"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                d: "M13 20.2557L18.1647 25.0698L28 16.0698",
                stroke: color,
                strokeWidth: "2"
            })
        ]
    });
};
const $697654d10ef148cd$export$ca82bc100771edd6 = (color = "#ffffff", width = "16", height = "16")=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
            d: "M6.25387 8.11033L14.7179 2.18367M14.7185 2.183L7.40054 13.817L6.2872 8.08633L1.2832 5.07967L14.7185 2.183Z",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


var $3c099596e10f125c$exports = {};
$3c099596e10f125c$exports = import.meta.resolve("klbYX");


const $c5f0ee832958afb6$var$ipataImg = new URL($3c099596e10f125c$exports);
var $01a09aeb2645314d$exports = {};
$01a09aeb2645314d$exports = import.meta.resolve("igC2m");


const $c5f0ee832958afb6$var$pmsImg = new URL($01a09aeb2645314d$exports);
var $a03059c648566a85$exports = {};
$a03059c648566a85$exports = import.meta.resolve("56vgU");


const $c5f0ee832958afb6$var$smsImg = new URL($a03059c648566a85$exports);
const $c5f0ee832958afb6$var$promoItems = [
    {
        title: "100% Verified Shelters",
        icon: ()=>(0, $697654d10ef148cd$export$27b4be198a414222)()
    },
    {
        title: "Reliable Adoption Process",
        icon: ()=>(0, $697654d10ef148cd$export$1009cf4fe158a792)()
    },
    {
        title: "Save a Life!",
        icon: ()=>(0, $697654d10ef148cd$export$4c804b2e84980796)()
    }
];
function $c5f0ee832958afb6$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        id: "footer",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "border-b-[1px] border-t-[1px] border-[#E8E8E8]",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: "container mx-auto",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: "mx-auto grid grid-cols-3 px-5 py-7",
                        children: $c5f0ee832958afb6$var$promoItems.map((item)=>{
                            return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                className: "flex items-center justify-center gap-2 px-10",
                                children: [
                                    item.icon(),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                        className: "font-barlowmedium text-theme-grey-11",
                                        children: item.title
                                    })
                                ]
                            }, item.title);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "border-b-[1px] border-[#E8E8E8]",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: "container mx-auto",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "mx-auto grid grid-cols-5 gap-4 px-5 py-8",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        className: "mb-3 flex w-[130px] flex-row items-center gap-1",
                                        children: [
                                            (0, $697654d10ef148cd$export$f7d22cea9593f68a)("#121111"),
                                            (0, $697654d10ef148cd$export$3fe541c5a0ef78e0)()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                                            src: $c5f0ee832958afb6$var$smsImg.href,
                                            alt: ""
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                        className: "mb-3 font-barlowmedium text-theme-grey-11",
                                        children: "Adopting with Tailtales"
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        className: "flex flex-col gap-1 text-[12px] text-[#3D3E3D]",
                                        children: [
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: "How dog adoption with us works"
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: "Our goal"
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: "Tales from our dog shelters"
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: "What our users are saying"
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: "FAQs on Adoption"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                        className: "mb-3 font-barlowmedium text-theme-grey-11",
                                        children: "For shelters"
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        className: "flex flex-col gap-1 text-[12px] text-[#3D3E3D]",
                                        children: [
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: "How to join Tailtales"
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: "Financial support"
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: "Increased visability"
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: "Marketing assistance"
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: "Community engagement"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                        className: "mb-3 font-barlowmedium text-theme-grey-11",
                                        children: "Customer service"
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        className: "flex flex-col gap-1 text-[12px] text-[#3D3E3D]",
                                        children: [
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: "Contact us"
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: "In media"
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: "Work with us!"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "border-b-[1px] border-[#E8E8E8]",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: "container mx-auto",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "mx-auto grid grid-cols-5 gap-4 px-5 py-6",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                        className: "mb-3 font-barlowmedium text-theme-grey-11",
                                        children: "We ship with"
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                                                src: $c5f0ee832958afb6$var$ipataImg.href,
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                className: "mt-1 text-[12px] text-[#555555]",
                                                children: [
                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                        className: "underline",
                                                        children: "IPATA"
                                                    }),
                                                    " registered pet shipping companies."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                        className: "mb-3 font-barlowmedium text-theme-grey-11",
                                        children: "Payment methods"
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                                            src: $c5f0ee832958afb6$var$pmsImg.href,
                                            alt: ""
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("footer", {
                className: "flex flex-col items-center justify-center gap-4 bg-[#0C0202] py-6 text-[14px] text-[#C0C0C0]",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: "container mx-auto px-5",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "flex w-full items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                    className: "flex items-center gap-2",
                                    children: "\xa9 2025 Tailtales AB"
                                })
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("span", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        (0, $697654d10ef148cd$export$4a899e7a49365346)(),
                                        "Sweden ",
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                            className: "text-[14px] leading-none",
                                            children: "|"
                                        }),
                                        " inger@gmail.com"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                children: (0, $697654d10ef148cd$export$8e2dca508f1d472c)("#B2B1B1", "30px")
                            })
                        ]
                    })
                })
            })
        ]
    });
}




var $8vqx4 = parcelRequire("8vqx4");




parcelRequire("8vqx4");

function $187327acff8c3636$export$2e2bcd8739ae039({ title: title, to: to, active: active }) {
    let theme = "text-gray-500 hover:text-black";
    if (active) theme = "!text-black";
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $07071c34f63f350a$export$a6c7ac8248d6e38a), {
        className: `font-simianregular text-[20px] transition ${theme}`,
        to: to,
        children: title
    });
}


const $31ff363aba87b0b6$var$menu = [
    {
        to: "/",
        title: "All dogs",
        active: true
    },
    // { to: "/shelters", title: "Dog shelters" },
    // { to: "/products", title: "Products" },
    {
        to: "/about",
        title: "About"
    }
];
function $31ff363aba87b0b6$export$2e2bcd8739ae039() {
    const { user: user, logout: logout } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    const loc = (0, $68c2f6a70206c369$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "bg-[#FFFFFF]",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("header", {
            className: "container mx-auto",
            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "flex flex-row items-center justify-between px-5 pb-8 pt-6",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $07071c34f63f350a$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex flex-row items-center gap-1",
                            children: [
                                (0, $697654d10ef148cd$export$f7d22cea9593f68a)("#121111"),
                                (0, $697654d10ef148cd$export$3fe541c5a0ef78e0)()
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "flex gap-14",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("nav", {
                                className: "hidden flex-row gap-8 lg:flex",
                                children: $31ff363aba87b0b6$var$menu.map((item, index)=>{
                                    return /*#__PURE__*/ (0, $8vqx4.createElement)((0, $187327acff8c3636$export$2e2bcd8739ae039), {
                                        ...item,
                                        key: index,
                                        active: item.to === loc.pathname
                                    });
                                })
                            }),
                            !user || !user.accessToken && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $07071c34f63f350a$export$a6c7ac8248d6e38a), {
                                to: "/login",
                                children: (0, $697654d10ef148cd$export$71d3d2dad08b2134)()
                            })
                        ]
                    })
                ]
            })
        })
    });
}




var $8vqx4 = parcelRequire("8vqx4");


parcelRequire("8vqx4");


var $8vqx4 = parcelRequire("8vqx4");
// src/primitive.tsx
var $1fa4c161ce280d4f$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $1fa4c161ce280d4f$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}
function $1fa4c161ce280d4f$export$f21a1ffae260145a(element) {
    if (!$1fa4c161ce280d4f$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
function $1fa4c161ce280d4f$export$b204af158042fbac(element) {
    if (!$1fa4c161ce280d4f$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
function $1fa4c161ce280d4f$export$cd4e5573fbe2b576(node, activeDescendant = false) {
    const { activeElement: activeElement } = $1fa4c161ce280d4f$export$b204af158042fbac(node);
    if (!activeElement?.nodeName) return null;
    if ($1fa4c161ce280d4f$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $1fa4c161ce280d4f$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = $1fa4c161ce280d4f$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
function $1fa4c161ce280d4f$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}


// packages/react/compose-refs/src/compose-refs.tsx

var $8vqx4 = parcelRequire("8vqx4");
function $d64198ac8789ff5a$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $d64198ac8789ff5a$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $d64198ac8789ff5a$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $d64198ac8789ff5a$var$setRef(refs[i], null);
            }
        };
    };
}
function $d64198ac8789ff5a$export$c7b2cbe3552a0d05(...refs) {
    return $8vqx4.useCallback($d64198ac8789ff5a$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/create-context.tsx

var $8vqx4 = parcelRequire("8vqx4");

function $9ec698e3cd37fa7e$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $8vqx4.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $8vqx4.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $8vqx4.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $9ec698e3cd37fa7e$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $8vqx4.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $8vqx4.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $8vqx4.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $8vqx4.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $8vqx4.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $9ec698e3cd37fa7e$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $9ec698e3cd37fa7e$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $8vqx4.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/id/src/id.tsx

var $8vqx4 = parcelRequire("8vqx4");
// packages/react/use-layout-effect/src/use-layout-effect.tsx

var $8vqx4 = parcelRequire("8vqx4");
var $a12c289c48883425$export$e5c5a5f917a5871c = globalThis?.document ? $8vqx4.useLayoutEffect : ()=>{};


var $48f6e55cf3c4c05f$var$useReactId = $8vqx4[" useId ".trim().toString()] || (()=>void 0);
var $48f6e55cf3c4c05f$var$count = 0;
function $48f6e55cf3c4c05f$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $8vqx4.useState($48f6e55cf3c4c05f$var$useReactId());
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($48f6e55cf3c4c05f$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


// src/use-controllable-state.tsx

var $8vqx4 = parcelRequire("8vqx4");

// src/use-effect-event.tsx


var $8vqx4 = parcelRequire("8vqx4");
var $8b5f48aa44fcb4e3$var$useReactEffectEvent = $8vqx4[" useEffectEvent ".trim().toString()];
var $8b5f48aa44fcb4e3$var$useReactInsertionEffect = $8vqx4[" useInsertionEffect ".trim().toString()];
function $8b5f48aa44fcb4e3$export$7f54fc3180508a52(callback) {
    if (typeof $8b5f48aa44fcb4e3$var$useReactEffectEvent === "function") return $8b5f48aa44fcb4e3$var$useReactEffectEvent(callback);
    const ref = $8vqx4.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $8b5f48aa44fcb4e3$var$useReactInsertionEffect === "function") $8b5f48aa44fcb4e3$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $8vqx4.useMemo(()=>(...args)=>ref.current?.(...args), []);
}


var $2da738009a11930c$var$useInsertionEffect = $8vqx4[" useInsertionEffect ".trim().toString()] || (0, $a12c289c48883425$export$e5c5a5f917a5871c);
function $2da738009a11930c$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $2da738009a11930c$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $8vqx4.useRef(prop !== void 0);
        $8vqx4.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $8vqx4.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $2da738009a11930c$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $2da738009a11930c$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $8vqx4.useState(defaultProp);
    const prevValueRef = $8vqx4.useRef(value);
    const onChangeRef = $8vqx4.useRef(onChange);
    $2da738009a11930c$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $8vqx4.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $2da738009a11930c$var$isFunction(value) {
    return typeof value === "function";
}
var $2da738009a11930c$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $2da738009a11930c$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $8b5f48aa44fcb4e3$export$7f54fc3180508a52)(onChangeProp);
    {
        const isControlledRef = $8vqx4.useRef(controlledState !== void 0);
        $8vqx4.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $8vqx4.useReducer((state2, action)=>{
        if (action.type === $2da738009a11930c$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $8vqx4.useRef(uncontrolledState);
    $8vqx4.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        onChange,
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $8vqx4.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $8vqx4.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $2da738009a11930c$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}



var $8vqx4 = parcelRequire("8vqx4");

// src/primitive.tsx

var $8vqx4 = parcelRequire("8vqx4");

var $hiyfL = parcelRequire("hiyfL");
// src/slot.tsx

var $8vqx4 = parcelRequire("8vqx4");


// @__NO_SIDE_EFFECTS__
function $6fd952efea14ce9a$export$e88b45bda5c13eb9(ownerName) {
    const SlotClone = /* @__PURE__ */ $6fd952efea14ce9a$var$createSlotClone(ownerName);
    const Slot2 = $8vqx4.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        const childrenArray = $8vqx4.Children.toArray(children);
        const slottable = childrenArray.find($6fd952efea14ce9a$var$isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if ($8vqx4.Children.count(newElement) > 1) return $8vqx4.Children.only(null);
                    return $8vqx4.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: $8vqx4.isValidElement(newElement) ? $8vqx4.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $6fd952efea14ce9a$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $6fd952efea14ce9a$export$e88b45bda5c13eb9("Slot");
// @__NO_SIDE_EFFECTS__
function $6fd952efea14ce9a$var$createSlotClone(ownerName) {
    const SlotClone = $8vqx4.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        if ($8vqx4.isValidElement(children)) {
            const childrenRef = $6fd952efea14ce9a$var$getElementRef(children);
            const props2 = $6fd952efea14ce9a$var$mergeProps(slotProps, children.props);
            if (children.type !== $8vqx4.Fragment) props2.ref = forwardedRef ? (0, $d64198ac8789ff5a$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef;
            return $8vqx4.cloneElement(children, props2);
        }
        return $8vqx4.Children.count(children) > 1 ? $8vqx4.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var $6fd952efea14ce9a$var$SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $6fd952efea14ce9a$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = ({ children: children })=>{
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $607ae91d1eb97195$exports.Fragment), {
            children: children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $6fd952efea14ce9a$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $6fd952efea14ce9a$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $6fd952efea14ce9a$export$bf68c29d8281d0f7("Slottable");
function $6fd952efea14ce9a$var$isSlottable(child) {
    return $8vqx4.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $6fd952efea14ce9a$var$SLOTTABLE_IDENTIFIER;
}
function $6fd952efea14ce9a$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $6fd952efea14ce9a$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}



var $7ba09d26ee0d4423$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $7ba09d26ee0d4423$export$250ffa63cdc0d034 = $7ba09d26ee0d4423$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $6fd952efea14ce9a$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $8vqx4.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $7ba09d26ee0d4423$export$6d1a0317bde7de7f(target, event) {
    if (target) $hiyfL.flushSync(()=>target.dispatchEvent(event));
}
var $7ba09d26ee0d4423$export$be92b6f5f03c0fe9 = $7ba09d26ee0d4423$export$250ffa63cdc0d034;



// packages/react/use-callback-ref/src/use-callback-ref.tsx

var $8vqx4 = parcelRequire("8vqx4");
function $0af559af272c0534$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $8vqx4.useRef(callback);
    $8vqx4.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $8vqx4.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


// packages/react/use-escape-keydown/src/use-escape-keydown.tsx

var $8vqx4 = parcelRequire("8vqx4");

function $dbb950ce26253d41$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $0af559af272c0534$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $8vqx4.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



"use client";
var $d5c981ab09de62ee$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $d5c981ab09de62ee$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $d5c981ab09de62ee$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $d5c981ab09de62ee$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $d5c981ab09de62ee$var$originalBodyPointerEvents;
var $d5c981ab09de62ee$var$DismissableLayerContext = $8vqx4.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $d5c981ab09de62ee$export$177fb62ff3ec1f22 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $8vqx4.useContext($d5c981ab09de62ee$var$DismissableLayerContext);
    const [node, setNode] = $8vqx4.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $8vqx4.useState({});
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $d5c981ab09de62ee$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $d5c981ab09de62ee$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $dbb950ce26253d41$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $8vqx4.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $d5c981ab09de62ee$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $d5c981ab09de62ee$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $d5c981ab09de62ee$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $8vqx4.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $d5c981ab09de62ee$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $8vqx4.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($d5c981ab09de62ee$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($d5c981ab09de62ee$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$d5c981ab09de62ee$export$177fb62ff3ec1f22.displayName = $d5c981ab09de62ee$var$DISMISSABLE_LAYER_NAME;
var $d5c981ab09de62ee$var$BRANCH_NAME = "DismissableLayerBranch";
var $d5c981ab09de62ee$export$4d5eb2109db14228 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const context = $8vqx4.useContext($d5c981ab09de62ee$var$DismissableLayerContext);
    const ref = $8vqx4.useRef(null);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $8vqx4.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$d5c981ab09de62ee$export$4d5eb2109db14228.displayName = $d5c981ab09de62ee$var$BRANCH_NAME;
function $d5c981ab09de62ee$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $0af559af272c0534$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $8vqx4.useRef(false);
    const handleClickRef = $8vqx4.useRef(()=>{});
    $8vqx4.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $d5c981ab09de62ee$var$handleAndDispatchCustomEvent($d5c981ab09de62ee$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $d5c981ab09de62ee$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $0af559af272c0534$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $8vqx4.useRef(false);
    $8vqx4.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $d5c981ab09de62ee$var$handleAndDispatchCustomEvent($d5c981ab09de62ee$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $d5c981ab09de62ee$var$dispatchUpdate() {
    const event = new CustomEvent($d5c981ab09de62ee$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $d5c981ab09de62ee$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $7ba09d26ee0d4423$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $d5c981ab09de62ee$export$be92b6f5f03c0fe9 = $d5c981ab09de62ee$export$177fb62ff3ec1f22;
var $d5c981ab09de62ee$export$aecb2ddcb55c95be = $d5c981ab09de62ee$export$4d5eb2109db14228;



var $8vqx4 = parcelRequire("8vqx4");




"use client";
var $5bf0528134fa0c3c$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $5bf0528134fa0c3c$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $5bf0528134fa0c3c$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $5bf0528134fa0c3c$var$FOCUS_SCOPE_NAME = "FocusScope";
var $5bf0528134fa0c3c$export$20e40289641fbbb6 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $8vqx4.useState(null);
    const onMountAutoFocus = (0, $0af559af272c0534$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $0af559af272c0534$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $8vqx4.useRef(null);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $8vqx4.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $8vqx4.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $5bf0528134fa0c3c$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $5bf0528134fa0c3c$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $5bf0528134fa0c3c$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $8vqx4.useEffect(()=>{
        if (container) {
            $5bf0528134fa0c3c$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($5bf0528134fa0c3c$var$AUTOFOCUS_ON_MOUNT, $5bf0528134fa0c3c$var$EVENT_OPTIONS);
                container.addEventListener($5bf0528134fa0c3c$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $5bf0528134fa0c3c$var$focusFirst($5bf0528134fa0c3c$var$removeLinks($5bf0528134fa0c3c$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $5bf0528134fa0c3c$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($5bf0528134fa0c3c$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($5bf0528134fa0c3c$var$AUTOFOCUS_ON_UNMOUNT, $5bf0528134fa0c3c$var$EVENT_OPTIONS);
                    container.addEventListener($5bf0528134fa0c3c$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $5bf0528134fa0c3c$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($5bf0528134fa0c3c$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $5bf0528134fa0c3c$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $8vqx4.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $5bf0528134fa0c3c$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $5bf0528134fa0c3c$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $5bf0528134fa0c3c$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$5bf0528134fa0c3c$export$20e40289641fbbb6.displayName = $5bf0528134fa0c3c$var$FOCUS_SCOPE_NAME;
function $5bf0528134fa0c3c$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $5bf0528134fa0c3c$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $5bf0528134fa0c3c$var$getTabbableEdges(container) {
    const candidates = $5bf0528134fa0c3c$var$getTabbableCandidates(container);
    const first = $5bf0528134fa0c3c$var$findVisible(candidates, container);
    const last = $5bf0528134fa0c3c$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $5bf0528134fa0c3c$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $5bf0528134fa0c3c$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$5bf0528134fa0c3c$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $5bf0528134fa0c3c$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $5bf0528134fa0c3c$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $5bf0528134fa0c3c$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $5bf0528134fa0c3c$var$isSelectableInput(element) && select) element.select();
    }
}
var $5bf0528134fa0c3c$var$focusScopesStack = $5bf0528134fa0c3c$var$createFocusScopesStack();
function $5bf0528134fa0c3c$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $5bf0528134fa0c3c$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $5bf0528134fa0c3c$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $5bf0528134fa0c3c$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $5bf0528134fa0c3c$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $5bf0528134fa0c3c$export$be92b6f5f03c0fe9 = $5bf0528134fa0c3c$export$20e40289641fbbb6;



var $8vqx4 = parcelRequire("8vqx4");

var $hiyfL = parcelRequire("hiyfL");



"use client";
var $22f2e6a7088dcf5f$var$PORTAL_NAME = "Portal";
var $22f2e6a7088dcf5f$export$602eac185826482c = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $8vqx4.useState(false);
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($hiyfL))).createPortal(/* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$22f2e6a7088dcf5f$export$602eac185826482c.displayName = $22f2e6a7088dcf5f$var$PORTAL_NAME;
var $22f2e6a7088dcf5f$export$be92b6f5f03c0fe9 = $22f2e6a7088dcf5f$export$602eac185826482c;



var $8vqx4 = parcelRequire("8vqx4");


"use client";
function $f22016a45fcd98f7$var$useStateMachine(initialState, machine) {
    return $8vqx4.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// src/presence.tsx
var $f22016a45fcd98f7$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $f22016a45fcd98f7$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $8vqx4.Children.only(children);
    const ref = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(presence.ref, $f22016a45fcd98f7$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $8vqx4.cloneElement(child, {
        ref: ref
    }) : null;
};
$f22016a45fcd98f7$export$99c2b779aa4e8b8b.displayName = "Presence";
function $f22016a45fcd98f7$var$usePresence(present) {
    const [node, setNode] = $8vqx4.useState();
    const stylesRef = $8vqx4.useRef(null);
    const prevPresentRef = $8vqx4.useRef(present);
    const prevAnimationNameRef = $8vqx4.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $f22016a45fcd98f7$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $8vqx4.useEffect(()=>{
        const currentAnimationName = $f22016a45fcd98f7$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $f22016a45fcd98f7$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $f22016a45fcd98f7$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $f22016a45fcd98f7$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $8vqx4.useCallback((node2)=>{
            stylesRef.current = node2 ? getComputedStyle(node2) : null;
            setNode(node2);
        }, [])
    };
}
function $f22016a45fcd98f7$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $f22016a45fcd98f7$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $f22016a45fcd98f7$export$be92b6f5f03c0fe9 = $f22016a45fcd98f7$export$99c2b779aa4e8b8b;




var $8vqx4 = parcelRequire("8vqx4");
"use client";
var $dc875cc1b746c2ea$var$count = 0;
function $dc875cc1b746c2ea$export$ac5b58043b79449b(props) {
    $dc875cc1b746c2ea$export$b7ece24a22aeda8c();
    return props.children;
}
function $dc875cc1b746c2ea$export$b7ece24a22aeda8c() {
    $8vqx4.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? $dc875cc1b746c2ea$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? $dc875cc1b746c2ea$var$createFocusGuard());
        $dc875cc1b746c2ea$var$count++;
        return ()=>{
            if ($dc875cc1b746c2ea$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $dc875cc1b746c2ea$var$count--;
        };
    }, []);
}
function $dc875cc1b746c2ea$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8e874a2fb001c377$var$extendStatics = function(d, b) {
    $8e874a2fb001c377$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8e874a2fb001c377$var$extendStatics(d, b);
};
function $8e874a2fb001c377$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8e874a2fb001c377$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8e874a2fb001c377$export$18ce0697a983be9b = function() {
    $8e874a2fb001c377$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e874a2fb001c377$export$18ce0697a983be9b.apply(this, arguments);
};
function $8e874a2fb001c377$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e874a2fb001c377$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8e874a2fb001c377$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8e874a2fb001c377$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8e874a2fb001c377$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8e874a2fb001c377$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8e874a2fb001c377$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8e874a2fb001c377$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8e874a2fb001c377$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8e874a2fb001c377$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8e874a2fb001c377$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8e874a2fb001c377$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8e874a2fb001c377$export$45d3717a4c69092e(o, m, p);
}
function $8e874a2fb001c377$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8e874a2fb001c377$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8e874a2fb001c377$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8e874a2fb001c377$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8e874a2fb001c377$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8e874a2fb001c377$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8e874a2fb001c377$export$10c90e4f7922046c(v) {
    return this instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? (this.v = v, this) : new $8e874a2fb001c377$export$10c90e4f7922046c(v);
}
function $8e874a2fb001c377$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8e874a2fb001c377$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e874a2fb001c377$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8e874a2fb001c377$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8e874a2fb001c377$export$19a8beecd37a4c45 === "function" ? $8e874a2fb001c377$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8e874a2fb001c377$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8e874a2fb001c377$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8e874a2fb001c377$var$ownKeys = function(o) {
    $8e874a2fb001c377$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8e874a2fb001c377$var$ownKeys(o);
};
function $8e874a2fb001c377$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8e874a2fb001c377$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8e874a2fb001c377$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8e874a2fb001c377$var$__setModuleDefault(result, mod);
    return result;
}
function $8e874a2fb001c377$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8e874a2fb001c377$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8e874a2fb001c377$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8e874a2fb001c377$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8e874a2fb001c377$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8e874a2fb001c377$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8e874a2fb001c377$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8e874a2fb001c377$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8e874a2fb001c377$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8e874a2fb001c377$export$2e2bcd8739ae039 = {
    __extends: $8e874a2fb001c377$export$a8ba968b8961cb8a,
    __assign: $8e874a2fb001c377$export$18ce0697a983be9b,
    __rest: $8e874a2fb001c377$export$3c9a16f847548506,
    __decorate: $8e874a2fb001c377$export$29e00dfd3077644b,
    __param: $8e874a2fb001c377$export$d5ad3fd78186038f,
    __esDecorate: $8e874a2fb001c377$export$3a84e1ae4e97e9b0,
    __runInitializers: $8e874a2fb001c377$export$d831c04e792af3d,
    __propKey: $8e874a2fb001c377$export$6a2a36740a146cb8,
    __setFunctionName: $8e874a2fb001c377$export$d1a06452d3489bc7,
    __metadata: $8e874a2fb001c377$export$f1db080c865becb9,
    __awaiter: $8e874a2fb001c377$export$1050f835b63b671e,
    __generator: $8e874a2fb001c377$export$67ebef60e6f28a6,
    __createBinding: $8e874a2fb001c377$export$45d3717a4c69092e,
    __exportStar: $8e874a2fb001c377$export$f33643c0debef087,
    __values: $8e874a2fb001c377$export$19a8beecd37a4c45,
    __read: $8e874a2fb001c377$export$8d051b38c9118094,
    __spread: $8e874a2fb001c377$export$afc72e2116322959,
    __spreadArrays: $8e874a2fb001c377$export$6388937ca91ccae8,
    __spreadArray: $8e874a2fb001c377$export$1216008129fb82ed,
    __await: $8e874a2fb001c377$export$10c90e4f7922046c,
    __asyncGenerator: $8e874a2fb001c377$export$e427f37a30a4de9b,
    __asyncDelegator: $8e874a2fb001c377$export$bbd80228419bb833,
    __asyncValues: $8e874a2fb001c377$export$e3b29a3d6162315f,
    __makeTemplateObject: $8e874a2fb001c377$export$4fb47efe1390b86f,
    __importStar: $8e874a2fb001c377$export$c21735bcef00d192,
    __importDefault: $8e874a2fb001c377$export$da59b14a69baef04,
    __classPrivateFieldGet: $8e874a2fb001c377$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8e874a2fb001c377$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8e874a2fb001c377$export$81fdc39f203e4e04,
    __addDisposableResource: $8e874a2fb001c377$export$88ac25d8e944e405,
    __disposeResources: $8e874a2fb001c377$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8e874a2fb001c377$export$889dfb5d17574b0b
};



var $8vqx4 = parcelRequire("8vqx4");


var $8vqx4 = parcelRequire("8vqx4");
var $fece4924766eaae4$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $fece4924766eaae4$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $fece4924766eaae4$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $fece4924766eaae4$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



var $8vqx4 = parcelRequire("8vqx4");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $11adae2986daeb26$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $8vqx4 = parcelRequire("8vqx4");
function $eccd56b4ad6dc212$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $8vqx4.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $fc2ada935d563edf$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $8vqx4.useLayoutEffect : $8vqx4.useEffect;
var $fc2ada935d563edf$var$currentValues = new WeakMap();
function $fc2ada935d563edf$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $eccd56b4ad6dc212$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $11adae2986daeb26$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $fc2ada935d563edf$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $fc2ada935d563edf$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $11adae2986daeb26$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $11adae2986daeb26$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $fc2ada935d563edf$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $31d22b0157811307$var$ItoI(a) {
    return a;
}
function $31d22b0157811307$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $31d22b0157811307$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $31d22b0157811307$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $31d22b0157811307$var$ItoI;
    return $31d22b0157811307$var$innerCreateMedium(defaults, middleware);
}
function $31d22b0157811307$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $31d22b0157811307$var$innerCreateMedium(null);
    medium.options = (0, $8e874a2fb001c377$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $ec3205c04f451970$export$e27363444bedfeac = (0, $31d22b0157811307$export$e13ec7dd7a14088d)();


var $7f7bb178891a30a4$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $7f7bb178891a30a4$export$22940b497e769dee = $8vqx4.forwardRef(function(props, parentRef) {
    var ref = $8vqx4.useRef(null);
    var _a = $8vqx4.useState({
        onScrollCapture: $7f7bb178891a30a4$var$nothing,
        onWheelCapture: $7f7bb178891a30a4$var$nothing,
        onTouchMoveCapture: $7f7bb178891a30a4$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $8e874a2fb001c377$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $fc2ada935d563edf$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $8e874a2fb001c377$export$18ce0697a983be9b)((0, $8e874a2fb001c377$export$18ce0697a983be9b)({}, rest), callbacks);
    return $8vqx4.createElement($8vqx4.Fragment, null, enabled && $8vqx4.createElement(SideCar, {
        sideCar: (0, $ec3205c04f451970$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $8vqx4.cloneElement($8vqx4.Children.only(children), (0, $8e874a2fb001c377$export$18ce0697a983be9b)((0, $8e874a2fb001c377$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $8vqx4.createElement(Container, (0, $8e874a2fb001c377$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$7f7bb178891a30a4$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$7f7bb178891a30a4$export$22940b497e769dee.classNames = {
    fullWidth: (0, $fece4924766eaae4$export$898e37bbd2a0ae4e),
    zeroRight: (0, $fece4924766eaae4$export$1da7500147d4bc3)
};




var $8vqx4 = parcelRequire("8vqx4");
var $f8949f38fb96133d$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $8e874a2fb001c377$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $8vqx4.createElement(Target, (0, $8e874a2fb001c377$export$18ce0697a983be9b)({}, rest));
};
$f8949f38fb96133d$var$SideCar.isSideCarExport = true;
function $f8949f38fb96133d$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $f8949f38fb96133d$var$SideCar;
}




var $8vqx4 = parcelRequire("8vqx4");

var $8vqx4 = parcelRequire("8vqx4");

var $8vqx4 = parcelRequire("8vqx4");
var $160caca76e9aa0e9$var$currentNonce;
var $160caca76e9aa0e9$export$c5f670b24c0ae95a = function(nonce) {
    $160caca76e9aa0e9$var$currentNonce = nonce;
};
var $160caca76e9aa0e9$export$2b85b721e524d74b = function() {
    if ($160caca76e9aa0e9$var$currentNonce) return $160caca76e9aa0e9$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $a0cacef6a632d404$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $160caca76e9aa0e9$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $a0cacef6a632d404$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $a0cacef6a632d404$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $a0cacef6a632d404$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $a0cacef6a632d404$var$makeStyleTag()) {
                    $a0cacef6a632d404$var$injectStyles(stylesheet, style);
                    $a0cacef6a632d404$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $7e5b22151274c4cc$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $a0cacef6a632d404$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $8vqx4.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $3fea1971abfa2af6$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $7e5b22151274c4cc$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $114285f7661df19e$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $114285f7661df19e$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $114285f7661df19e$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $114285f7661df19e$var$parse(left),
        $114285f7661df19e$var$parse(top),
        $114285f7661df19e$var$parse(right)
    ];
};
var $114285f7661df19e$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $114285f7661df19e$export$efed13b5d0ca3386;
    var offsets = $114285f7661df19e$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9b672060a4542e6a$var$Style = (0, $3fea1971abfa2af6$export$c1248ee86ba532c8)();
var $9b672060a4542e6a$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9b672060a4542e6a$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $fece4924766eaae4$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9b672060a4542e6a$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $fece4924766eaae4$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $fece4924766eaae4$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $fece4924766eaae4$export$1da7500147d4bc3), " .").concat((0, $fece4924766eaae4$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $fece4924766eaae4$export$898e37bbd2a0ae4e), " .").concat((0, $fece4924766eaae4$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9b672060a4542e6a$export$65254d5f26cb9564, "] {\n    ").concat((0, $fece4924766eaae4$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9b672060a4542e6a$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9b672060a4542e6a$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $9b672060a4542e6a$export$a1939b1f9f9b02dc = function() {
    $8vqx4.useEffect(function() {
        document.body.setAttribute($9b672060a4542e6a$export$65254d5f26cb9564, ($9b672060a4542e6a$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9b672060a4542e6a$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9b672060a4542e6a$export$65254d5f26cb9564);
            else document.body.setAttribute($9b672060a4542e6a$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9b672060a4542e6a$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $9b672060a4542e6a$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $8vqx4.useMemo(function() {
        return (0, $114285f7661df19e$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $8vqx4.createElement($9b672060a4542e6a$var$Style, {
        styles: $9b672060a4542e6a$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};







var $3e61c7dccd007e34$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $3e61c7dccd007e34$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $3e61c7dccd007e34$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $3e61c7dccd007e34$var$options, $3e61c7dccd007e34$var$options);
    // @ts-ignore
    window.removeEventListener('test', $3e61c7dccd007e34$var$options, $3e61c7dccd007e34$var$options);
} catch (err) {
    $3e61c7dccd007e34$var$passiveSupported = false;
}
var $3e61c7dccd007e34$export$10a6e88623fa9454 = $3e61c7dccd007e34$var$passiveSupported ? {
    passive: false
} : false;


var $90bd94841cf15a45$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $90bd94841cf15a45$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$90bd94841cf15a45$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $90bd94841cf15a45$var$elementCouldBeVScrolled = function(node) {
    return $90bd94841cf15a45$var$elementCanBeScrolled(node, 'overflowY');
};
var $90bd94841cf15a45$var$elementCouldBeHScrolled = function(node) {
    return $90bd94841cf15a45$var$elementCanBeScrolled(node, 'overflowX');
};
var $90bd94841cf15a45$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $90bd94841cf15a45$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $90bd94841cf15a45$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $90bd94841cf15a45$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $90bd94841cf15a45$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $90bd94841cf15a45$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $90bd94841cf15a45$var$elementCouldBeVScrolled(node) : $90bd94841cf15a45$var$elementCouldBeHScrolled(node);
};
var $90bd94841cf15a45$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $90bd94841cf15a45$var$getVScrollVariables(node) : $90bd94841cf15a45$var$getHScrollVariables(node);
};
var $90bd94841cf15a45$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $90bd94841cf15a45$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $90bd94841cf15a45$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $90bd94841cf15a45$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($90bd94841cf15a45$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $c3511052dcc815a2$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $c3511052dcc815a2$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $c3511052dcc815a2$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $c3511052dcc815a2$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $c3511052dcc815a2$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $c3511052dcc815a2$var$idCounter = 0;
var $c3511052dcc815a2$var$lockStack = [];
function $c3511052dcc815a2$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $8vqx4.useRef([]);
    var touchStartRef = $8vqx4.useRef([
        0,
        0
    ]);
    var activeAxis = $8vqx4.useRef();
    var id = $8vqx4.useState($c3511052dcc815a2$var$idCounter++)[0];
    var Style = $8vqx4.useState((0, $3fea1971abfa2af6$export$c1248ee86ba532c8))[0];
    var lastProps = $8vqx4.useRef(props);
    $8vqx4.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $8vqx4.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $8e874a2fb001c377$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($c3511052dcc815a2$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $8vqx4.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $c3511052dcc815a2$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, $90bd94841cf15a45$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $90bd94841cf15a45$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $90bd94841cf15a45$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $8vqx4.useCallback(function(_event) {
        var event = _event;
        if (!$c3511052dcc815a2$var$lockStack.length || $c3511052dcc815a2$var$lockStack[$c3511052dcc815a2$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $c3511052dcc815a2$export$39efaa2ca254a28d(event) : $c3511052dcc815a2$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $c3511052dcc815a2$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($c3511052dcc815a2$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $8vqx4.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $c3511052dcc815a2$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $8vqx4.useCallback(function(event) {
        touchStartRef.current = $c3511052dcc815a2$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $8vqx4.useCallback(function(event) {
        shouldCancel(event.type, $c3511052dcc815a2$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $8vqx4.useCallback(function(event) {
        shouldCancel(event.type, $c3511052dcc815a2$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $8vqx4.useEffect(function() {
        $c3511052dcc815a2$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $3e61c7dccd007e34$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $3e61c7dccd007e34$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $3e61c7dccd007e34$export$10a6e88623fa9454));
        return function() {
            $c3511052dcc815a2$var$lockStack = $c3511052dcc815a2$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $3e61c7dccd007e34$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $3e61c7dccd007e34$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $3e61c7dccd007e34$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $8vqx4.createElement($8vqx4.Fragment, null, inert ? $8vqx4.createElement(Style, {
        styles: $c3511052dcc815a2$var$generateStyle(id)
    }) : null, removeScrollBar ? $8vqx4.createElement((0, $9b672060a4542e6a$export$9aa43b459c5ae9b9), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $c3511052dcc815a2$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $326bf718aac67951$export$2e2bcd8739ae039 = (0, $f8949f38fb96133d$export$6cacc8fb0a9b94ce)((0, $ec3205c04f451970$export$e27363444bedfeac), (0, $c3511052dcc815a2$export$a09dbff87b5da2d));


var $fb0b2d10375c2e49$var$ReactRemoveScroll = $8vqx4.forwardRef(function(props, ref) {
    return $8vqx4.createElement((0, $7f7bb178891a30a4$export$22940b497e769dee), (0, $8e874a2fb001c377$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $326bf718aac67951$export$2e2bcd8739ae039)
    }));
});
$fb0b2d10375c2e49$var$ReactRemoveScroll.classNames = (0, $7f7bb178891a30a4$export$22940b497e769dee).classNames;
var $fb0b2d10375c2e49$export$2e2bcd8739ae039 = $fb0b2d10375c2e49$var$ReactRemoveScroll;


var $5f2df6acae077059$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $5f2df6acae077059$var$counterMap = new WeakMap();
var $5f2df6acae077059$var$uncontrolledNodes = new WeakMap();
var $5f2df6acae077059$var$markerMap = {};
var $5f2df6acae077059$var$lockCount = 0;
var $5f2df6acae077059$var$unwrapHost = function(node) {
    return node && (node.host || $5f2df6acae077059$var$unwrapHost(node.parentNode));
};
var $5f2df6acae077059$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $5f2df6acae077059$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $5f2df6acae077059$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $5f2df6acae077059$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$5f2df6acae077059$var$markerMap[markerName]) $5f2df6acae077059$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $5f2df6acae077059$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($5f2df6acae077059$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $5f2df6acae077059$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $5f2df6acae077059$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $5f2df6acae077059$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $5f2df6acae077059$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $5f2df6acae077059$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$5f2df6acae077059$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $5f2df6acae077059$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $5f2df6acae077059$var$lockCount--;
        if (!$5f2df6acae077059$var$lockCount) {
            // clear
            $5f2df6acae077059$var$counterMap = new WeakMap();
            $5f2df6acae077059$var$counterMap = new WeakMap();
            $5f2df6acae077059$var$uncontrolledNodes = new WeakMap();
            $5f2df6acae077059$var$markerMap = {};
        }
    };
};
var $5f2df6acae077059$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $5f2df6acae077059$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $5f2df6acae077059$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $5f2df6acae077059$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $5f2df6acae077059$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $5f2df6acae077059$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $5f2df6acae077059$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $5f2df6acae077059$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($5f2df6acae077059$export$cc95fea82d705fca() ? $5f2df6acae077059$export$59151cc8db999a24 : $5f2df6acae077059$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};




"use client";
var $94724b4e84955d54$var$DIALOG_NAME = "Dialog";
var [$94724b4e84955d54$var$createDialogContext, $94724b4e84955d54$export$cc702773b8ea3e41] = (0, $9ec698e3cd37fa7e$export$50c7b4e9d9f19c1)($94724b4e84955d54$var$DIALOG_NAME);
var [$94724b4e84955d54$var$DialogProvider, $94724b4e84955d54$var$useDialogContext] = $94724b4e84955d54$var$createDialogContext($94724b4e84955d54$var$DIALOG_NAME);
var $94724b4e84955d54$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $8vqx4.useRef(null);
    const contentRef = $8vqx4.useRef(null);
    const [open, setOpen] = (0, $2da738009a11930c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $94724b4e84955d54$var$DIALOG_NAME
    });
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $48f6e55cf3c4c05f$export$f680877a34711e37)(),
        titleId: (0, $48f6e55cf3c4c05f$export$f680877a34711e37)(),
        descriptionId: (0, $48f6e55cf3c4c05f$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $8vqx4.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$94724b4e84955d54$export$3ddf2d174ce01153.displayName = $94724b4e84955d54$var$DIALOG_NAME;
var $94724b4e84955d54$var$TRIGGER_NAME = "DialogTrigger";
var $94724b4e84955d54$export$2e1e1122cf0cba88 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $94724b4e84955d54$var$useDialogContext($94724b4e84955d54$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $94724b4e84955d54$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$94724b4e84955d54$export$2e1e1122cf0cba88.displayName = $94724b4e84955d54$var$TRIGGER_NAME;
var $94724b4e84955d54$var$PORTAL_NAME = "DialogPortal";
var [$94724b4e84955d54$var$PortalProvider, $94724b4e84955d54$var$usePortalContext] = $94724b4e84955d54$var$createDialogContext($94724b4e84955d54$var$PORTAL_NAME, {
    forceMount: void 0
});
var $94724b4e84955d54$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $94724b4e84955d54$var$useDialogContext($94724b4e84955d54$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $8vqx4.Children.map(children, (child)=>/* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $f22016a45fcd98f7$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $22f2e6a7088dcf5f$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$94724b4e84955d54$export$dad7c95542bacce0.displayName = $94724b4e84955d54$var$PORTAL_NAME;
var $94724b4e84955d54$var$OVERLAY_NAME = "DialogOverlay";
var $94724b4e84955d54$export$bd1d06c79be19e17 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const portalContext = $94724b4e84955d54$var$usePortalContext($94724b4e84955d54$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $94724b4e84955d54$var$useDialogContext($94724b4e84955d54$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $f22016a45fcd98f7$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$94724b4e84955d54$export$bd1d06c79be19e17.displayName = $94724b4e84955d54$var$OVERLAY_NAME;
var $94724b4e84955d54$var$Slot = (0, $6fd952efea14ce9a$export$e88b45bda5c13eb9)("DialogOverlay.RemoveScroll");
var $94724b4e84955d54$var$DialogOverlayImpl = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $94724b4e84955d54$var$useDialogContext($94724b4e84955d54$var$OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $fb0b2d10375c2e49$export$2e2bcd8739ae039), {
        as: $94724b4e84955d54$var$Slot,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
            "data-state": $94724b4e84955d54$var$getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $94724b4e84955d54$var$CONTENT_NAME = "DialogContent";
var $94724b4e84955d54$export$b6d9565de1e068cf = $8vqx4.forwardRef((props, forwardedRef)=>{
    const portalContext = $94724b4e84955d54$var$usePortalContext($94724b4e84955d54$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $94724b4e84955d54$var$useDialogContext($94724b4e84955d54$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $f22016a45fcd98f7$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$94724b4e84955d54$export$b6d9565de1e068cf.displayName = $94724b4e84955d54$var$CONTENT_NAME;
var $94724b4e84955d54$var$DialogContentModal = $8vqx4.forwardRef((props, forwardedRef)=>{
    const context = $94724b4e84955d54$var$useDialogContext($94724b4e84955d54$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $8vqx4.useRef(null);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $8vqx4.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $5f2df6acae077059$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $94724b4e84955d54$var$DialogContentNonModal = $8vqx4.forwardRef((props, forwardedRef)=>{
    const context = $94724b4e84955d54$var$useDialogContext($94724b4e84955d54$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $8vqx4.useRef(false);
    const hasPointerDownOutsideRef = $8vqx4.useRef(false);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $94724b4e84955d54$var$DialogContentImpl = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $94724b4e84955d54$var$useDialogContext($94724b4e84955d54$var$CONTENT_NAME, __scopeDialog);
    const contentRef = $8vqx4.useRef(null);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    (0, $dc875cc1b746c2ea$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $5bf0528134fa0c3c$export$20e40289641fbbb6), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $d5c981ab09de62ee$export$177fb62ff3ec1f22), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": $94724b4e84955d54$var$getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$var$TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$var$DescriptionWarning, {
                        contentRef: contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var $94724b4e84955d54$var$TITLE_NAME = "DialogTitle";
var $94724b4e84955d54$export$16f7638e4a34b909 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $94724b4e84955d54$var$useDialogContext($94724b4e84955d54$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$94724b4e84955d54$export$16f7638e4a34b909.displayName = $94724b4e84955d54$var$TITLE_NAME;
var $94724b4e84955d54$var$DESCRIPTION_NAME = "DialogDescription";
var $94724b4e84955d54$export$94e94c2ec2c954d5 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $94724b4e84955d54$var$useDialogContext($94724b4e84955d54$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$94724b4e84955d54$export$94e94c2ec2c954d5.displayName = $94724b4e84955d54$var$DESCRIPTION_NAME;
var $94724b4e84955d54$var$CLOSE_NAME = "DialogClose";
var $94724b4e84955d54$export$fba2fb7cd781b7ac = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $94724b4e84955d54$var$useDialogContext($94724b4e84955d54$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$94724b4e84955d54$export$fba2fb7cd781b7ac.displayName = $94724b4e84955d54$var$CLOSE_NAME;
function $94724b4e84955d54$var$getState(open) {
    return open ? "open" : "closed";
}
var $94724b4e84955d54$var$TITLE_WARNING_NAME = "DialogTitleWarning";
var [$94724b4e84955d54$export$69b62a49393917d6, $94724b4e84955d54$var$useWarningContext] = (0, $9ec698e3cd37fa7e$export$fd42f52fd3ae1109)($94724b4e84955d54$var$TITLE_WARNING_NAME, {
    contentName: $94724b4e84955d54$var$CONTENT_NAME,
    titleName: $94724b4e84955d54$var$TITLE_NAME,
    docsSlug: "dialog"
});
var $94724b4e84955d54$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $94724b4e84955d54$var$useWarningContext($94724b4e84955d54$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $8vqx4.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var $94724b4e84955d54$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var $94724b4e84955d54$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $94724b4e84955d54$var$useWarningContext($94724b4e84955d54$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $8vqx4.useEffect(()=>{
        const describedById = contentRef.current?.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var $94724b4e84955d54$export$be92b6f5f03c0fe9 = $94724b4e84955d54$export$3ddf2d174ce01153;
var $94724b4e84955d54$export$41fb9f06171c75f4 = $94724b4e84955d54$export$2e1e1122cf0cba88;
var $94724b4e84955d54$export$602eac185826482c = $94724b4e84955d54$export$dad7c95542bacce0;
var $94724b4e84955d54$export$c6fdb837b070b4ff = $94724b4e84955d54$export$bd1d06c79be19e17;
var $94724b4e84955d54$export$7c6e2c02157bb7d2 = $94724b4e84955d54$export$b6d9565de1e068cf;
var $94724b4e84955d54$export$f99233281efd08a0 = $94724b4e84955d54$export$16f7638e4a34b909;
var $94724b4e84955d54$export$393edc798c47379d = $94724b4e84955d54$export$94e94c2ec2c954d5;
var $94724b4e84955d54$export$f39c2d165cd861fe = $94724b4e84955d54$export$fba2fb7cd781b7ac;


/**
 * Copyright 2022 Joe Bell. All rights reserved.
 *
 * This file is licensed to you under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with the
 * License. You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR REPRESENTATIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */ function $ee9d4e7b280b4edb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ee9d4e7b280b4edb$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ee9d4e7b280b4edb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ee9d4e7b280b4edb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ee9d4e7b280b4edb$export$2e2bcd8739ae039 = $ee9d4e7b280b4edb$export$4f5d2d50c9deca37;


const $433b3049f3517ea6$var$falsyToString = (value)=>typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const $433b3049f3517ea6$export$a274e22fb40f762e = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37);
const $433b3049f3517ea6$export$87dc52566e90b739 = (base, config)=>(props)=>{
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $433b3049f3517ea6$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants, defaultVariants: defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $433b3049f3517ea6$var$falsyToString(variantProp) || $433b3049f3517ea6$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $433b3049f3517ea6$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };


/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $8vqx4 = parcelRequire("8vqx4");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $c525e8d2696ef399$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $c525e8d2696ef399$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();


/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $8vqx4 = parcelRequire("8vqx4");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $a85ddcdcfebbe7c3$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $aec6512e036c5210$export$2e2bcd8739ae039 = (0, $8vqx4.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    return (0, $8vqx4.createElement)("svg", {
        ref: ref,
        ...(0, $a85ddcdcfebbe7c3$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $c525e8d2696ef399$export$3d46f4579dba46e5)("lucide", className),
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $8vqx4.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


const $55d271daf0d1362b$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $8vqx4.forwardRef)(({ className: className, ...props }, ref)=>(0, $8vqx4.createElement)((0, $aec6512e036c5210$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $c525e8d2696ef399$export$3d46f4579dba46e5)(`lucide-${(0, $c525e8d2696ef399$export$73bda83cddbc7187)(iconName)}`, className),
            ...props
        }));
    Component.displayName = `${iconName}`;
    return Component;
};


const $10805d788c1e909d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $10805d788c1e909d$export$2e2bcd8739ae039 = (0, $55d271daf0d1362b$export$2e2bcd8739ae039)("X", $10805d788c1e909d$export$3efd853dbb351e94);



var $8vqx4 = parcelRequire("8vqx4");

var $ea4a28391e99296c$exports = {};
'use strict';
Object.defineProperty($ea4a28391e99296c$exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ea4a28391e99296c$var$CLASS_PART_SEPARATOR = '-';
const $ea4a28391e99296c$var$createClassGroupUtils = (config)=>{
    const classMap = $ea4a28391e99296c$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    const getClassGroupId = (className)=>{
        const classParts = className.split($ea4a28391e99296c$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === '' && classParts.length !== 1) classParts.shift();
        return $ea4a28391e99296c$var$getGroupRecursive(classParts, classMap) || $ea4a28391e99296c$var$getGroupIdForArbitraryProperty(className);
    };
    const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier)=>{
        const conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [
            ...conflicts,
            ...conflictingClassGroupModifiers[classGroupId]
        ];
        return conflicts;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
const $ea4a28391e99296c$var$getGroupRecursive = (classParts, classPartObject)=>{
    if (classParts.length === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[0];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    const classGroupFromNextClassPart = nextClassPartObject ? $ea4a28391e99296c$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    const classRest = classParts.join($ea4a28391e99296c$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(({ validator: validator })=>validator(classRest))?.classGroupId;
};
const $ea4a28391e99296c$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
const $ea4a28391e99296c$var$getGroupIdForArbitraryProperty = (className)=>{
    if ($ea4a28391e99296c$var$arbitraryPropertyRegex.test(className)) {
        const arbitraryPropertyClassName = $ea4a28391e99296c$var$arbitraryPropertyRegex.exec(className)[1];
        const property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(':'));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return 'arbitrary..' + property;
    }
};
/**
 * Exported for testing only
 */ const $ea4a28391e99296c$var$createClassMap = (config)=>{
    const { theme: theme, prefix: prefix } = config;
    const classMap = {
        nextPart: new Map(),
        validators: []
    };
    const prefixedClassGroupEntries = $ea4a28391e99296c$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(([classGroupId, classGroup])=>{
        $ea4a28391e99296c$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
};
const $ea4a28391e99296c$var$processClassesRecursively = (classGroup, classPartObject, classGroupId, theme)=>{
    classGroup.forEach((classDefinition)=>{
        if (typeof classDefinition === 'string') {
            const classPartObjectToEdit = classDefinition === '' ? classPartObject : $ea4a28391e99296c$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === 'function') {
            if ($ea4a28391e99296c$var$isThemeGetter(classDefinition)) {
                $ea4a28391e99296c$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(([key, classGroup])=>{
            $ea4a28391e99296c$var$processClassesRecursively(classGroup, $ea4a28391e99296c$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
};
const $ea4a28391e99296c$var$getPart = (classPartObject, path)=>{
    let currentClassPartObject = classPartObject;
    path.split($ea4a28391e99296c$var$CLASS_PART_SEPARATOR).forEach((pathPart)=>{
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
};
const $ea4a28391e99296c$var$isThemeGetter = (func)=>func.isThemeGetter;
const $ea4a28391e99296c$var$getPrefixedClassGroupEntries = (classGroupEntries, prefix)=>{
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(([classGroupId, classGroup])=>{
        const prefixedClassGroup = classGroup.map((classDefinition)=>{
            if (typeof classDefinition === 'string') return prefix + classDefinition;
            if (typeof classDefinition === 'object') return Object.fromEntries(Object.entries(classDefinition).map(([key, value])=>[
                    prefix + key,
                    value
                ]));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
};
// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
const $ea4a28391e99296c$var$createLruCache = (maxCacheSize)=>{
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = new Map();
    let previousCache = new Map();
    const update = (key, value)=>{
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    };
    return {
        get (key) {
            let value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
};
const $ea4a28391e99296c$var$IMPORTANT_MODIFIER = '!';
const $ea4a28391e99296c$var$createParseClassName = (config)=>{
    const { separator: separator, experimentalParseClassName: experimentalParseClassName } = config;
    const isSeparatorSingleCharacter = separator.length === 1;
    const firstSeparatorCharacter = separator[0];
    const separatorLength = separator.length;
    // parseClassName inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    const parseClassName = (className)=>{
        const modifiers = [];
        let bracketDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        for(let index = 0; index < className.length; index++){
            let currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === '/') {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === '[') bracketDepth++;
            else if (currentCharacter === ']') bracketDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        const hasImportantModifier = baseClassNameWithImportantModifier.startsWith($ea4a28391e99296c$var$IMPORTANT_MODIFIER);
        const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
    if (experimentalParseClassName) return (className)=>experimentalParseClassName({
            className: className,
            parseClassName: parseClassName
        });
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ const $ea4a28391e99296c$var$sortModifiers = (modifiers)=>{
    if (modifiers.length <= 1) return modifiers;
    const sortedModifiers = [];
    let unsortedModifiers = [];
    modifiers.forEach((modifier)=>{
        const isArbitraryVariant = modifier[0] === '[';
        if (isArbitraryVariant) {
            sortedModifiers.push(...unsortedModifiers.sort(), modifier);
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push(...unsortedModifiers.sort());
    return sortedModifiers;
};
const $ea4a28391e99296c$var$createConfigUtils = (config)=>({
        cache: $ea4a28391e99296c$var$createLruCache(config.cacheSize),
        parseClassName: $ea4a28391e99296c$var$createParseClassName(config),
        ...$ea4a28391e99296c$var$createClassGroupUtils(config)
    });
const $ea4a28391e99296c$var$SPLIT_CLASSES_REGEX = /\s+/;
const $ea4a28391e99296c$var$mergeClassList = (classList, configUtils)=>{
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = [];
    const classNames = classList.trim().split($ea4a28391e99296c$var$SPLIT_CLASSES_REGEX);
    let result = '';
    for(let index = classNames.length - 1; index >= 0; index -= 1){
        const originalClassName = classNames[index];
        const { modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        const variantModifier = $ea4a28391e99296c$var$sortModifiers(modifiers).join(':');
        const modifierId = hasImportantModifier ? variantModifier + $ea4a28391e99296c$var$IMPORTANT_MODIFIER : variantModifier;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.includes(classId)) continue;
        classGroupsInConflict.push(classId);
        const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(let i = 0; i < conflictGroups.length; ++i){
            const group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $ea4a28391e99296c$var$twJoin() {
    let index = 0;
    let argument;
    let resolvedValue;
    let string = '';
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $ea4a28391e99296c$var$toValue(argument)) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
}
const $ea4a28391e99296c$var$toValue = (mix)=>{
    if (typeof mix === 'string') return mix;
    let resolvedValue;
    let string = '';
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $ea4a28391e99296c$var$toValue(mix[k])) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
function $ea4a28391e99296c$var$createTailwindMerge(createConfigFirst, ...createConfigRest) {
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $ea4a28391e99296c$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $ea4a28391e99296c$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall($ea4a28391e99296c$var$twJoin.apply(null, arguments));
    };
}
const $ea4a28391e99296c$var$fromTheme = (key)=>{
    const themeGetter = (theme)=>theme[key] || [];
    themeGetter.isThemeGetter = true;
    return themeGetter;
};
const $ea4a28391e99296c$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const $ea4a28391e99296c$var$fractionRegex = /^\d+\/\d+$/;
const $ea4a28391e99296c$var$stringLengths = /*#__PURE__*/ new Set([
    'px',
    'full',
    'screen'
]);
const $ea4a28391e99296c$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $ea4a28391e99296c$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $ea4a28391e99296c$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $ea4a28391e99296c$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $ea4a28391e99296c$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const $ea4a28391e99296c$var$isLength = (value)=>$ea4a28391e99296c$var$isNumber(value) || $ea4a28391e99296c$var$stringLengths.has(value) || $ea4a28391e99296c$var$fractionRegex.test(value);
const $ea4a28391e99296c$var$isArbitraryLength = (value)=>$ea4a28391e99296c$var$getIsArbitraryValue(value, 'length', $ea4a28391e99296c$var$isLengthOnly);
const $ea4a28391e99296c$var$isNumber = (value)=>Boolean(value) && !Number.isNaN(Number(value));
const $ea4a28391e99296c$var$isArbitraryNumber = (value)=>$ea4a28391e99296c$var$getIsArbitraryValue(value, 'number', $ea4a28391e99296c$var$isNumber);
const $ea4a28391e99296c$var$isInteger = (value)=>Boolean(value) && Number.isInteger(Number(value));
const $ea4a28391e99296c$var$isPercent = (value)=>value.endsWith('%') && $ea4a28391e99296c$var$isNumber(value.slice(0, -1));
const $ea4a28391e99296c$var$isArbitraryValue = (value)=>$ea4a28391e99296c$var$arbitraryValueRegex.test(value);
const $ea4a28391e99296c$var$isTshirtSize = (value)=>$ea4a28391e99296c$var$tshirtUnitRegex.test(value);
const $ea4a28391e99296c$var$sizeLabels = /*#__PURE__*/ new Set([
    'length',
    'size',
    'percentage'
]);
const $ea4a28391e99296c$var$isArbitrarySize = (value)=>$ea4a28391e99296c$var$getIsArbitraryValue(value, $ea4a28391e99296c$var$sizeLabels, $ea4a28391e99296c$var$isNever);
const $ea4a28391e99296c$var$isArbitraryPosition = (value)=>$ea4a28391e99296c$var$getIsArbitraryValue(value, 'position', $ea4a28391e99296c$var$isNever);
const $ea4a28391e99296c$var$imageLabels = /*#__PURE__*/ new Set([
    'image',
    'url'
]);
const $ea4a28391e99296c$var$isArbitraryImage = (value)=>$ea4a28391e99296c$var$getIsArbitraryValue(value, $ea4a28391e99296c$var$imageLabels, $ea4a28391e99296c$var$isImage);
const $ea4a28391e99296c$var$isArbitraryShadow = (value)=>$ea4a28391e99296c$var$getIsArbitraryValue(value, '', $ea4a28391e99296c$var$isShadow);
const $ea4a28391e99296c$var$isAny = ()=>true;
const $ea4a28391e99296c$var$getIsArbitraryValue = (value, label, testValue)=>{
    const result = $ea4a28391e99296c$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return typeof label === 'string' ? result[1] === label : label.has(result[1]);
        return testValue(result[2]);
    }
    return false;
};
const $ea4a28391e99296c$var$isLengthOnly = (value)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $ea4a28391e99296c$var$lengthUnitRegex.test(value) && !$ea4a28391e99296c$var$colorFunctionRegex.test(value);
const $ea4a28391e99296c$var$isNever = ()=>false;
const $ea4a28391e99296c$var$isShadow = (value)=>$ea4a28391e99296c$var$shadowRegex.test(value);
const $ea4a28391e99296c$var$isImage = (value)=>$ea4a28391e99296c$var$imageRegex.test(value);
const $ea4a28391e99296c$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $ea4a28391e99296c$var$isAny,
    isArbitraryImage: $ea4a28391e99296c$var$isArbitraryImage,
    isArbitraryLength: $ea4a28391e99296c$var$isArbitraryLength,
    isArbitraryNumber: $ea4a28391e99296c$var$isArbitraryNumber,
    isArbitraryPosition: $ea4a28391e99296c$var$isArbitraryPosition,
    isArbitraryShadow: $ea4a28391e99296c$var$isArbitraryShadow,
    isArbitrarySize: $ea4a28391e99296c$var$isArbitrarySize,
    isArbitraryValue: $ea4a28391e99296c$var$isArbitraryValue,
    isInteger: $ea4a28391e99296c$var$isInteger,
    isLength: $ea4a28391e99296c$var$isLength,
    isNumber: $ea4a28391e99296c$var$isNumber,
    isPercent: $ea4a28391e99296c$var$isPercent,
    isTshirtSize: $ea4a28391e99296c$var$isTshirtSize
}, Symbol.toStringTag, {
    value: 'Module'
});
const $ea4a28391e99296c$var$getDefaultConfig = ()=>{
    const colors = $ea4a28391e99296c$var$fromTheme('colors');
    const spacing = $ea4a28391e99296c$var$fromTheme('spacing');
    const blur = $ea4a28391e99296c$var$fromTheme('blur');
    const brightness = $ea4a28391e99296c$var$fromTheme('brightness');
    const borderColor = $ea4a28391e99296c$var$fromTheme('borderColor');
    const borderRadius = $ea4a28391e99296c$var$fromTheme('borderRadius');
    const borderSpacing = $ea4a28391e99296c$var$fromTheme('borderSpacing');
    const borderWidth = $ea4a28391e99296c$var$fromTheme('borderWidth');
    const contrast = $ea4a28391e99296c$var$fromTheme('contrast');
    const grayscale = $ea4a28391e99296c$var$fromTheme('grayscale');
    const hueRotate = $ea4a28391e99296c$var$fromTheme('hueRotate');
    const invert = $ea4a28391e99296c$var$fromTheme('invert');
    const gap = $ea4a28391e99296c$var$fromTheme('gap');
    const gradientColorStops = $ea4a28391e99296c$var$fromTheme('gradientColorStops');
    const gradientColorStopPositions = $ea4a28391e99296c$var$fromTheme('gradientColorStopPositions');
    const inset = $ea4a28391e99296c$var$fromTheme('inset');
    const margin = $ea4a28391e99296c$var$fromTheme('margin');
    const opacity = $ea4a28391e99296c$var$fromTheme('opacity');
    const padding = $ea4a28391e99296c$var$fromTheme('padding');
    const saturate = $ea4a28391e99296c$var$fromTheme('saturate');
    const scale = $ea4a28391e99296c$var$fromTheme('scale');
    const sepia = $ea4a28391e99296c$var$fromTheme('sepia');
    const skew = $ea4a28391e99296c$var$fromTheme('skew');
    const space = $ea4a28391e99296c$var$fromTheme('space');
    const translate = $ea4a28391e99296c$var$fromTheme('translate');
    const getOverscroll = ()=>[
            'auto',
            'contain',
            'none'
        ];
    const getOverflow = ()=>[
            'auto',
            'hidden',
            'clip',
            'visible',
            'scroll'
        ];
    const getSpacingWithAutoAndArbitrary = ()=>[
            'auto',
            $ea4a28391e99296c$var$isArbitraryValue,
            spacing
        ];
    const getSpacingWithArbitrary = ()=>[
            $ea4a28391e99296c$var$isArbitraryValue,
            spacing
        ];
    const getLengthWithEmptyAndArbitrary = ()=>[
            '',
            $ea4a28391e99296c$var$isLength,
            $ea4a28391e99296c$var$isArbitraryLength
        ];
    const getNumberWithAutoAndArbitrary = ()=>[
            'auto',
            $ea4a28391e99296c$var$isNumber,
            $ea4a28391e99296c$var$isArbitraryValue
        ];
    const getPositions = ()=>[
            'bottom',
            'center',
            'left',
            'left-bottom',
            'left-top',
            'right',
            'right-bottom',
            'right-top',
            'top'
        ];
    const getLineStyles = ()=>[
            'solid',
            'dashed',
            'dotted',
            'double',
            'none'
        ];
    const getBlendModes = ()=>[
            'normal',
            'multiply',
            'screen',
            'overlay',
            'darken',
            'lighten',
            'color-dodge',
            'color-burn',
            'hard-light',
            'soft-light',
            'difference',
            'exclusion',
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
    const getAlign = ()=>[
            'start',
            'end',
            'center',
            'between',
            'around',
            'evenly',
            'stretch'
        ];
    const getZeroAndEmpty = ()=>[
            '',
            '0',
            $ea4a28391e99296c$var$isArbitraryValue
        ];
    const getBreaks = ()=>[
            'auto',
            'avoid',
            'all',
            'avoid-page',
            'page',
            'left',
            'right',
            'column'
        ];
    const getNumberAndArbitrary = ()=>[
            $ea4a28391e99296c$var$isNumber,
            $ea4a28391e99296c$var$isArbitraryValue
        ];
    return {
        cacheSize: 500,
        separator: ':',
        theme: {
            colors: [
                $ea4a28391e99296c$var$isAny
            ],
            spacing: [
                $ea4a28391e99296c$var$isLength,
                $ea4a28391e99296c$var$isArbitraryLength
            ],
            blur: [
                'none',
                '',
                $ea4a28391e99296c$var$isTshirtSize,
                $ea4a28391e99296c$var$isArbitraryValue
            ],
            brightness: getNumberAndArbitrary(),
            borderColor: [
                colors
            ],
            borderRadius: [
                'none',
                '',
                'full',
                $ea4a28391e99296c$var$isTshirtSize,
                $ea4a28391e99296c$var$isArbitraryValue
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmptyAndArbitrary(),
            contrast: getNumberAndArbitrary(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                $ea4a28391e99296c$var$isPercent,
                $ea4a28391e99296c$var$isArbitraryLength
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumberAndArbitrary(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumberAndArbitrary(),
            scale: getNumberAndArbitrary(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        'auto',
                        'square',
                        'video',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                'container'
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $ea4a28391e99296c$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ 'break-after': [
                {
                    'break-after': getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ 'break-before': [
                {
                    'break-before': getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ 'break-inside': [
                {
                    'break-inside': [
                        'auto',
                        'avoid',
                        'avoid-page',
                        'avoid-column'
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ 'box-decoration': [
                {
                    'box-decoration': [
                        'slice',
                        'clone'
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        'border',
                        'content'
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                'block',
                'inline-block',
                'inline',
                'flex',
                'inline-flex',
                'table',
                'inline-table',
                'table-caption',
                'table-cell',
                'table-column',
                'table-column-group',
                'table-footer-group',
                'table-header-group',
                'table-row-group',
                'table-row',
                'flow-root',
                'grid',
                'inline-grid',
                'contents',
                'list-item',
                'hidden'
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        'right',
                        'left',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        'left',
                        'right',
                        'both',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                'isolate',
                'isolation-auto'
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ 'object-fit': [
                {
                    object: [
                        'contain',
                        'cover',
                        'fill',
                        'none',
                        'scale-down'
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ 'object-position': [
                {
                    object: [
                        ...getPositions(),
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-x': [
                {
                    'overflow-x': getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-y': [
                {
                    'overflow-y': getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-x': [
                {
                    'overscroll-x': getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-y': [
                {
                    'overscroll-y': getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                'static',
                'fixed',
                'absolute',
                'relative',
                'sticky'
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-x': [
                {
                    'inset-x': [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-y': [
                {
                    'inset-y': [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                'visible',
                'invisible',
                'collapse'
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        'auto',
                        $ea4a28391e99296c$var$isInteger,
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ 'flex-direction': [
                {
                    flex: [
                        'row',
                        'row-reverse',
                        'col',
                        'col-reverse'
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ 'flex-wrap': [
                {
                    flex: [
                        'wrap',
                        'wrap-reverse',
                        'nowrap'
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        '1',
                        'auto',
                        'initial',
                        'none',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        'first',
                        'last',
                        'none',
                        $ea4a28391e99296c$var$isInteger,
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ 'grid-cols': [
                {
                    'grid-cols': [
                        $ea4a28391e99296c$var$isAny
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start-end': [
                {
                    col: [
                        'auto',
                        {
                            span: [
                                'full',
                                $ea4a28391e99296c$var$isInteger,
                                $ea4a28391e99296c$var$isArbitraryValue
                            ]
                        },
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start': [
                {
                    'col-start': getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-end': [
                {
                    'col-end': getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ 'grid-rows': [
                {
                    'grid-rows': [
                        $ea4a28391e99296c$var$isAny
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start-end': [
                {
                    row: [
                        'auto',
                        {
                            span: [
                                $ea4a28391e99296c$var$isInteger,
                                $ea4a28391e99296c$var$isArbitraryValue
                            ]
                        },
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start': [
                {
                    'row-start': getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-end': [
                {
                    'row-end': getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ 'grid-flow': [
                {
                    'grid-flow': [
                        'row',
                        'col',
                        'dense',
                        'row-dense',
                        'col-dense'
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ 'auto-cols': [
                {
                    'auto-cols': [
                        'auto',
                        'min',
                        'max',
                        'fr',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ 'auto-rows': [
                {
                    'auto-rows': [
                        'auto',
                        'min',
                        'max',
                        'fr',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-x': [
                {
                    'gap-x': [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-y': [
                {
                    'gap-y': [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ 'justify-content': [
                {
                    justify: [
                        'normal',
                        ...getAlign()
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ 'justify-items': [
                {
                    'justify-items': [
                        'start',
                        'end',
                        'center',
                        'stretch'
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ 'justify-self': [
                {
                    'justify-self': [
                        'auto',
                        'start',
                        'end',
                        'center',
                        'stretch'
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ 'align-content': [
                {
                    content: [
                        'normal',
                        ...getAlign(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ 'align-items': [
                {
                    items: [
                        'start',
                        'end',
                        'center',
                        'baseline',
                        'stretch'
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ 'align-self': [
                {
                    self: [
                        'auto',
                        'start',
                        'end',
                        'center',
                        'stretch',
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ 'place-content': [
                {
                    'place-content': [
                        ...getAlign(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ 'place-items': [
                {
                    'place-items': [
                        'start',
                        'end',
                        'center',
                        'baseline',
                        'stretch'
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ 'place-self': [
                {
                    'place-self': [
                        'auto',
                        'start',
                        'end',
                        'center',
                        'stretch'
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ 'space-x': [
                {
                    'space-x': [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ 'space-x-reverse': [
                'space-x-reverse'
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ 'space-y': [
                {
                    'space-y': [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ 'space-y-reverse': [
                'space-y-reverse'
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        'auto',
                        'min',
                        'max',
                        'fit',
                        'svw',
                        'lvw',
                        'dvw',
                        $ea4a28391e99296c$var$isArbitraryValue,
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-w': [
                {
                    'min-w': [
                        $ea4a28391e99296c$var$isArbitraryValue,
                        spacing,
                        'min',
                        'max',
                        'fit'
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-w': [
                {
                    'max-w': [
                        $ea4a28391e99296c$var$isArbitraryValue,
                        spacing,
                        'none',
                        'full',
                        'min',
                        'max',
                        'fit',
                        'prose',
                        {
                            screen: [
                                $ea4a28391e99296c$var$isTshirtSize
                            ]
                        },
                        $ea4a28391e99296c$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        $ea4a28391e99296c$var$isArbitraryValue,
                        spacing,
                        'auto',
                        'min',
                        'max',
                        'fit',
                        'svh',
                        'lvh',
                        'dvh'
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-h': [
                {
                    'min-h': [
                        $ea4a28391e99296c$var$isArbitraryValue,
                        spacing,
                        'min',
                        'max',
                        'fit',
                        'svh',
                        'lvh',
                        'dvh'
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-h': [
                {
                    'max-h': [
                        $ea4a28391e99296c$var$isArbitraryValue,
                        spacing,
                        'min',
                        'max',
                        'fit',
                        'svh',
                        'lvh',
                        'dvh'
                    ]
                }
            ],
            /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */ size: [
                {
                    size: [
                        $ea4a28391e99296c$var$isArbitraryValue,
                        spacing,
                        'auto',
                        'min',
                        'max',
                        'fit'
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ 'font-size': [
                {
                    text: [
                        'base',
                        $ea4a28391e99296c$var$isTshirtSize,
                        $ea4a28391e99296c$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ 'font-smoothing': [
                'antialiased',
                'subpixel-antialiased'
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ 'font-style': [
                'italic',
                'not-italic'
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ 'font-weight': [
                {
                    font: [
                        'thin',
                        'extralight',
                        'light',
                        'normal',
                        'medium',
                        'semibold',
                        'bold',
                        'extrabold',
                        'black',
                        $ea4a28391e99296c$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ 'font-family': [
                {
                    font: [
                        $ea4a28391e99296c$var$isAny
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-normal': [
                'normal-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-ordinal': [
                'ordinal'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-slashed-zero': [
                'slashed-zero'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-figure': [
                'lining-nums',
                'oldstyle-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-spacing': [
                'proportional-nums',
                'tabular-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-fraction': [
                'diagonal-fractions',
                'stacked-fractions'
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        'tighter',
                        'tight',
                        'normal',
                        'wide',
                        'wider',
                        'widest',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ 'line-clamp': [
                {
                    'line-clamp': [
                        'none',
                        $ea4a28391e99296c$var$isNumber,
                        $ea4a28391e99296c$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        'none',
                        'tight',
                        'snug',
                        'normal',
                        'relaxed',
                        'loose',
                        $ea4a28391e99296c$var$isLength,
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ 'list-image': [
                {
                    'list-image': [
                        'none',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ 'list-style-type': [
                {
                    list: [
                        'none',
                        'disc',
                        'decimal',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ 'list-style-position': [
                {
                    list: [
                        'inside',
                        'outside'
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ 'placeholder-color': [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ 'placeholder-opacity': [
                {
                    'placeholder-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ 'text-alignment': [
                {
                    text: [
                        'left',
                        'center',
                        'right',
                        'justify',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ 'text-color': [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ 'text-opacity': [
                {
                    'text-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ 'text-decoration': [
                'underline',
                'overline',
                'line-through',
                'no-underline'
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ 'text-decoration-style': [
                {
                    decoration: [
                        ...getLineStyles(),
                        'wavy'
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ 'text-decoration-thickness': [
                {
                    decoration: [
                        'auto',
                        'from-font',
                        $ea4a28391e99296c$var$isLength,
                        $ea4a28391e99296c$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ 'underline-offset': [
                {
                    'underline-offset': [
                        'auto',
                        $ea4a28391e99296c$var$isLength,
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ 'text-decoration-color': [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ 'text-transform': [
                'uppercase',
                'lowercase',
                'capitalize',
                'normal-case'
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ 'text-overflow': [
                'truncate',
                'text-ellipsis',
                'text-clip'
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ 'text-wrap': [
                {
                    text: [
                        'wrap',
                        'nowrap',
                        'balance',
                        'pretty'
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ 'vertical-align': [
                {
                    align: [
                        'baseline',
                        'top',
                        'middle',
                        'bottom',
                        'text-top',
                        'text-bottom',
                        'sub',
                        'super',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        'normal',
                        'nowrap',
                        'pre',
                        'pre-line',
                        'pre-wrap',
                        'break-spaces'
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        'normal',
                        'words',
                        'all',
                        'keep'
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        'none',
                        'manual',
                        'auto'
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        'none',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ 'bg-attachment': [
                {
                    bg: [
                        'fixed',
                        'local',
                        'scroll'
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ 'bg-clip': [
                {
                    'bg-clip': [
                        'border',
                        'padding',
                        'content',
                        'text'
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ 'bg-opacity': [
                {
                    'bg-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ 'bg-origin': [
                {
                    'bg-origin': [
                        'border',
                        'padding',
                        'content'
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ 'bg-position': [
                {
                    bg: [
                        ...getPositions(),
                        $ea4a28391e99296c$var$isArbitraryPosition
                    ]
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ 'bg-repeat': [
                {
                    bg: [
                        'no-repeat',
                        {
                            repeat: [
                                '',
                                'x',
                                'y',
                                'round',
                                'space'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ 'bg-size': [
                {
                    bg: [
                        'auto',
                        'cover',
                        'contain',
                        $ea4a28391e99296c$var$isArbitrarySize
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ 'bg-image': [
                {
                    bg: [
                        'none',
                        {
                            'gradient-to': [
                                't',
                                'tr',
                                'r',
                                'br',
                                'b',
                                'bl',
                                'l',
                                'tl'
                            ]
                        },
                        $ea4a28391e99296c$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ 'bg-color': [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from-pos': [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via-pos': [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to-pos': [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from': [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via': [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to': [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-s': [
                {
                    'rounded-s': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-e': [
                {
                    'rounded-e': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-t': [
                {
                    'rounded-t': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-r': [
                {
                    'rounded-r': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-b': [
                {
                    'rounded-b': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-l': [
                {
                    'rounded-l': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ss': [
                {
                    'rounded-ss': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-se': [
                {
                    'rounded-se': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ee': [
                {
                    'rounded-ee': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-es': [
                {
                    'rounded-es': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tl': [
                {
                    'rounded-tl': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tr': [
                {
                    'rounded-tr': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-br': [
                {
                    'rounded-br': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-bl': [
                {
                    'rounded-bl': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w': [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-x': [
                {
                    'border-x': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-y': [
                {
                    'border-y': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-s': [
                {
                    'border-s': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-e': [
                {
                    'border-e': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-t': [
                {
                    'border-t': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-r': [
                {
                    'border-r': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-b': [
                {
                    'border-b': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-l': [
                {
                    'border-l': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ 'border-opacity': [
                {
                    'border-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ 'border-style': [
                {
                    border: [
                        ...getLineStyles(),
                        'hidden'
                    ]
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ 'divide-x': [
                {
                    'divide-x': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ 'divide-x-reverse': [
                'divide-x-reverse'
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ 'divide-y': [
                {
                    'divide-y': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ 'divide-y-reverse': [
                'divide-y-reverse'
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ 'divide-opacity': [
                {
                    'divide-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ 'divide-style': [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color': [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-x': [
                {
                    'border-x': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-y': [
                {
                    'border-y': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-s': [
                {
                    'border-s': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-e': [
                {
                    'border-e': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-t': [
                {
                    'border-t': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-r': [
                {
                    'border-r': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-b': [
                {
                    'border-b': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-l': [
                {
                    'border-l': [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ 'divide-color': [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ 'outline-style': [
                {
                    outline: [
                        '',
                        ...getLineStyles()
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ 'outline-offset': [
                {
                    'outline-offset': [
                        $ea4a28391e99296c$var$isLength,
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ 'outline-w': [
                {
                    outline: [
                        $ea4a28391e99296c$var$isLength,
                        $ea4a28391e99296c$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ 'outline-color': [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ 'ring-w': [
                {
                    ring: getLengthWithEmptyAndArbitrary()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ 'ring-w-inset': [
                'ring-inset'
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ 'ring-color': [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ 'ring-opacity': [
                {
                    'ring-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ 'ring-offset-w': [
                {
                    'ring-offset': [
                        $ea4a28391e99296c$var$isLength,
                        $ea4a28391e99296c$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ 'ring-offset-color': [
                {
                    'ring-offset': [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        '',
                        'inner',
                        'none',
                        $ea4a28391e99296c$var$isTshirtSize,
                        $ea4a28391e99296c$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ 'shadow-color': [
                {
                    shadow: [
                        $ea4a28391e99296c$var$isAny
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ 'mix-blend': [
                {
                    'mix-blend': [
                        ...getBlendModes(),
                        'plus-lighter',
                        'plus-darker'
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ 'bg-blend': [
                {
                    'bg-blend': getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        '',
                        'none'
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ 'drop-shadow': [
                {
                    'drop-shadow': [
                        '',
                        'none',
                        $ea4a28391e99296c$var$isTshirtSize,
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ 'hue-rotate': [
                {
                    'hue-rotate': [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ 'backdrop-filter': [
                {
                    'backdrop-filter': [
                        '',
                        'none'
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ 'backdrop-blur': [
                {
                    'backdrop-blur': [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ 'backdrop-brightness': [
                {
                    'backdrop-brightness': [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ 'backdrop-contrast': [
                {
                    'backdrop-contrast': [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ 'backdrop-grayscale': [
                {
                    'backdrop-grayscale': [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ 'backdrop-hue-rotate': [
                {
                    'backdrop-hue-rotate': [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ 'backdrop-invert': [
                {
                    'backdrop-invert': [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ 'backdrop-opacity': [
                {
                    'backdrop-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ 'backdrop-saturate': [
                {
                    'backdrop-saturate': [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ 'backdrop-sepia': [
                {
                    'backdrop-sepia': [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ 'border-collapse': [
                {
                    border: [
                        'collapse',
                        'separate'
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing': [
                {
                    'border-spacing': [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-x': [
                {
                    'border-spacing-x': [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-y': [
                {
                    'border-spacing-y': [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ 'table-layout': [
                {
                    table: [
                        'auto',
                        'fixed'
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        'top',
                        'bottom'
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        'none',
                        'all',
                        '',
                        'colors',
                        'opacity',
                        'shadow',
                        'transform',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        'linear',
                        'in',
                        'out',
                        'in-out',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        'none',
                        'spin',
                        'ping',
                        'pulse',
                        'bounce',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        '',
                        'gpu',
                        'none'
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-x': [
                {
                    'scale-x': [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-y': [
                {
                    'scale-y': [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        $ea4a28391e99296c$var$isInteger,
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-x': [
                {
                    'translate-x': [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-y': [
                {
                    'translate-y': [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-x': [
                {
                    'skew-x': [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-y': [
                {
                    'skew-y': [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ 'transform-origin': [
                {
                    origin: [
                        'center',
                        'top',
                        'top-right',
                        'right',
                        'bottom-right',
                        'bottom',
                        'bottom-left',
                        'left',
                        'top-left',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        'auto',
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        'auto',
                        'default',
                        'pointer',
                        'wait',
                        'text',
                        'move',
                        'help',
                        'not-allowed',
                        'none',
                        'context-menu',
                        'progress',
                        'cell',
                        'crosshair',
                        'vertical-text',
                        'alias',
                        'copy',
                        'no-drop',
                        'grab',
                        'grabbing',
                        'all-scroll',
                        'col-resize',
                        'row-resize',
                        'n-resize',
                        'e-resize',
                        's-resize',
                        'w-resize',
                        'ne-resize',
                        'nw-resize',
                        'se-resize',
                        'sw-resize',
                        'ew-resize',
                        'ns-resize',
                        'nesw-resize',
                        'nwse-resize',
                        'zoom-in',
                        'zoom-out',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ 'caret-color': [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ 'pointer-events': [
                {
                    'pointer-events': [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        'none',
                        'y',
                        'x',
                        ''
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ 'scroll-behavior': [
                {
                    scroll: [
                        'auto',
                        'smooth'
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-m': [
                {
                    'scroll-m': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mx': [
                {
                    'scroll-mx': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-my': [
                {
                    'scroll-my': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ms': [
                {
                    'scroll-ms': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-me': [
                {
                    'scroll-me': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mt': [
                {
                    'scroll-mt': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mr': [
                {
                    'scroll-mr': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mb': [
                {
                    'scroll-mb': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ml': [
                {
                    'scroll-ml': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-p': [
                {
                    'scroll-p': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-px': [
                {
                    'scroll-px': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-py': [
                {
                    'scroll-py': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-ps': [
                {
                    'scroll-ps': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pe': [
                {
                    'scroll-pe': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pt': [
                {
                    'scroll-pt': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pr': [
                {
                    'scroll-pr': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pb': [
                {
                    'scroll-pb': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pl': [
                {
                    'scroll-pl': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ 'snap-align': [
                {
                    snap: [
                        'start',
                        'end',
                        'center',
                        'align-none'
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ 'snap-stop': [
                {
                    snap: [
                        'normal',
                        'always'
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-type': [
                {
                    snap: [
                        'none',
                        'x',
                        'y',
                        'both'
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-strictness': [
                {
                    snap: [
                        'mandatory',
                        'proximity'
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        'auto',
                        'none',
                        'manipulation'
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-x': [
                {
                    'touch-pan': [
                        'x',
                        'left',
                        'right'
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-y': [
                {
                    'touch-pan': [
                        'y',
                        'up',
                        'down'
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-pz': [
                'touch-pinch-zoom'
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        'none',
                        'text',
                        'all',
                        'auto'
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ 'will-change': [
                {
                    'will-change': [
                        'auto',
                        'scroll',
                        'contents',
                        'transform',
                        $ea4a28391e99296c$var$isArbitraryValue
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        'none'
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ 'stroke-w': [
                {
                    stroke: [
                        $ea4a28391e99296c$var$isLength,
                        $ea4a28391e99296c$var$isArbitraryLength,
                        $ea4a28391e99296c$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        'none'
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                'sr-only',
                'not-sr-only'
            ],
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ 'forced-color-adjust': [
                {
                    'forced-color-adjust': [
                        'auto',
                        'none'
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                'overflow-x',
                'overflow-y'
            ],
            overscroll: [
                'overscroll-x',
                'overscroll-y'
            ],
            inset: [
                'inset-x',
                'inset-y',
                'start',
                'end',
                'top',
                'right',
                'bottom',
                'left'
            ],
            'inset-x': [
                'right',
                'left'
            ],
            'inset-y': [
                'top',
                'bottom'
            ],
            flex: [
                'basis',
                'grow',
                'shrink'
            ],
            gap: [
                'gap-x',
                'gap-y'
            ],
            p: [
                'px',
                'py',
                'ps',
                'pe',
                'pt',
                'pr',
                'pb',
                'pl'
            ],
            px: [
                'pr',
                'pl'
            ],
            py: [
                'pt',
                'pb'
            ],
            m: [
                'mx',
                'my',
                'ms',
                'me',
                'mt',
                'mr',
                'mb',
                'ml'
            ],
            mx: [
                'mr',
                'ml'
            ],
            my: [
                'mt',
                'mb'
            ],
            size: [
                'w',
                'h'
            ],
            'font-size': [
                'leading'
            ],
            'fvn-normal': [
                'fvn-ordinal',
                'fvn-slashed-zero',
                'fvn-figure',
                'fvn-spacing',
                'fvn-fraction'
            ],
            'fvn-ordinal': [
                'fvn-normal'
            ],
            'fvn-slashed-zero': [
                'fvn-normal'
            ],
            'fvn-figure': [
                'fvn-normal'
            ],
            'fvn-spacing': [
                'fvn-normal'
            ],
            'fvn-fraction': [
                'fvn-normal'
            ],
            'line-clamp': [
                'display',
                'overflow'
            ],
            rounded: [
                'rounded-s',
                'rounded-e',
                'rounded-t',
                'rounded-r',
                'rounded-b',
                'rounded-l',
                'rounded-ss',
                'rounded-se',
                'rounded-ee',
                'rounded-es',
                'rounded-tl',
                'rounded-tr',
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-s': [
                'rounded-ss',
                'rounded-es'
            ],
            'rounded-e': [
                'rounded-se',
                'rounded-ee'
            ],
            'rounded-t': [
                'rounded-tl',
                'rounded-tr'
            ],
            'rounded-r': [
                'rounded-tr',
                'rounded-br'
            ],
            'rounded-b': [
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-l': [
                'rounded-tl',
                'rounded-bl'
            ],
            'border-spacing': [
                'border-spacing-x',
                'border-spacing-y'
            ],
            'border-w': [
                'border-w-s',
                'border-w-e',
                'border-w-t',
                'border-w-r',
                'border-w-b',
                'border-w-l'
            ],
            'border-w-x': [
                'border-w-r',
                'border-w-l'
            ],
            'border-w-y': [
                'border-w-t',
                'border-w-b'
            ],
            'border-color': [
                'border-color-s',
                'border-color-e',
                'border-color-t',
                'border-color-r',
                'border-color-b',
                'border-color-l'
            ],
            'border-color-x': [
                'border-color-r',
                'border-color-l'
            ],
            'border-color-y': [
                'border-color-t',
                'border-color-b'
            ],
            'scroll-m': [
                'scroll-mx',
                'scroll-my',
                'scroll-ms',
                'scroll-me',
                'scroll-mt',
                'scroll-mr',
                'scroll-mb',
                'scroll-ml'
            ],
            'scroll-mx': [
                'scroll-mr',
                'scroll-ml'
            ],
            'scroll-my': [
                'scroll-mt',
                'scroll-mb'
            ],
            'scroll-p': [
                'scroll-px',
                'scroll-py',
                'scroll-ps',
                'scroll-pe',
                'scroll-pt',
                'scroll-pr',
                'scroll-pb',
                'scroll-pl'
            ],
            'scroll-px': [
                'scroll-pr',
                'scroll-pl'
            ],
            'scroll-py': [
                'scroll-pt',
                'scroll-pb'
            ],
            touch: [
                'touch-x',
                'touch-y',
                'touch-pz'
            ],
            'touch-x': [
                'touch'
            ],
            'touch-y': [
                'touch'
            ],
            'touch-pz': [
                'touch'
            ]
        },
        conflictingClassGroupModifiers: {
            'font-size': [
                'leading'
            ]
        }
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ const $ea4a28391e99296c$var$mergeConfigs = (baseConfig, { cacheSize: cacheSize, prefix: prefix, separator: separator, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} })=>{
    $ea4a28391e99296c$var$overrideProperty(baseConfig, 'cacheSize', cacheSize);
    $ea4a28391e99296c$var$overrideProperty(baseConfig, 'prefix', prefix);
    $ea4a28391e99296c$var$overrideProperty(baseConfig, 'separator', separator);
    $ea4a28391e99296c$var$overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
    for(const configKey in override)$ea4a28391e99296c$var$overrideConfigProperties(baseConfig[configKey], override[configKey]);
    for(const key in extend)$ea4a28391e99296c$var$mergeConfigProperties(baseConfig[key], extend[key]);
    return baseConfig;
};
const $ea4a28391e99296c$var$overrideProperty = (baseObject, overrideKey, overrideValue)=>{
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
const $ea4a28391e99296c$var$overrideConfigProperties = (baseObject, overrideObject)=>{
    if (overrideObject) for(const key in overrideObject)$ea4a28391e99296c$var$overrideProperty(baseObject, key, overrideObject[key]);
};
const $ea4a28391e99296c$var$mergeConfigProperties = (baseObject, mergeObject)=>{
    if (mergeObject) for(const key in mergeObject){
        const mergeValue = mergeObject[key];
        if (mergeValue !== undefined) baseObject[key] = (baseObject[key] || []).concat(mergeValue);
    }
};
const $ea4a28391e99296c$var$extendTailwindMerge = (configExtension, ...createConfig)=>typeof configExtension === 'function' ? $ea4a28391e99296c$var$createTailwindMerge($ea4a28391e99296c$var$getDefaultConfig, configExtension, ...createConfig) : $ea4a28391e99296c$var$createTailwindMerge(()=>$ea4a28391e99296c$var$mergeConfigs($ea4a28391e99296c$var$getDefaultConfig(), configExtension), ...createConfig);
const $ea4a28391e99296c$var$twMerge = /*#__PURE__*/ $ea4a28391e99296c$var$createTailwindMerge($ea4a28391e99296c$var$getDefaultConfig);
$ea4a28391e99296c$exports.createTailwindMerge = $ea4a28391e99296c$var$createTailwindMerge;
$ea4a28391e99296c$exports.extendTailwindMerge = $ea4a28391e99296c$var$extendTailwindMerge;
$ea4a28391e99296c$exports.fromTheme = $ea4a28391e99296c$var$fromTheme;
$ea4a28391e99296c$exports.getDefaultConfig = $ea4a28391e99296c$var$getDefaultConfig;
$ea4a28391e99296c$exports.mergeConfigs = $ea4a28391e99296c$var$mergeConfigs;
$ea4a28391e99296c$exports.twJoin = $ea4a28391e99296c$var$twJoin;
$ea4a28391e99296c$exports.twMerge = $ea4a28391e99296c$var$twMerge;
$ea4a28391e99296c$exports.validators = $ea4a28391e99296c$var$validators;


function $db53bf731136662c$export$1343a74baacb0543(...inputs) {
    return (0, $ea4a28391e99296c$exports.twMerge)((0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(inputs));
}


const $3cd8c699fee03e80$export$a9bf29f8d87ebbee = $94724b4e84955d54$export$be92b6f5f03c0fe9;
const $3cd8c699fee03e80$export$de69b9b0343a1903 = $94724b4e84955d54$export$41fb9f06171c75f4;
const $3cd8c699fee03e80$export$99d85c8298ee6511 = $94724b4e84955d54$export$f39c2d165cd861fe;
const $3cd8c699fee03e80$export$721c917f47f6cb = $94724b4e84955d54$export$602eac185826482c;
const $3cd8c699fee03e80$export$48dbb295cbd054d8 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$export$c6fdb837b070b4ff, {
        className: (0, $db53bf731136662c$export$1343a74baacb0543)(`fixed inset-0 z-50 ${!props.hideBg && "bg-black/80"}  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0`, className),
        ...props,
        ref: ref
    }));
$3cd8c699fee03e80$export$48dbb295cbd054d8.displayName = $94724b4e84955d54$export$c6fdb837b070b4ff.displayName;
const $3cd8c699fee03e80$var$sheetVariants = (0, $433b3049f3517ea6$export$87dc52566e90b739)("fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out", {
    variants: {
        side: {
            top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
            bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
            left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
            right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right"
        }
    },
    defaultVariants: {
        side: "right"
    }
});
const $3cd8c699fee03e80$export$fe5ec5b76996e2d3 = /*#__PURE__*/ $8vqx4.forwardRef(({ side: side = "right", className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)($3cd8c699fee03e80$export$721c917f47f6cb, {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($3cd8c699fee03e80$export$48dbb295cbd054d8, {
                hideBg: props.hideBg
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)($94724b4e84955d54$export$7c6e2c02157bb7d2, {
                ref: ref,
                className: (0, $db53bf731136662c$export$1343a74baacb0543)($3cd8c699fee03e80$var$sheetVariants({
                    side: side
                }), className),
                ...props,
                children: [
                    !props.hideClose && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)($94724b4e84955d54$export$f39c2d165cd861fe, {
                        className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $10805d788c1e909d$export$2e2bcd8739ae039), {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    }),
                    children
                ]
            })
        ]
    }));
$3cd8c699fee03e80$export$fe5ec5b76996e2d3.displayName = $94724b4e84955d54$export$7c6e2c02157bb7d2.displayName;
const $3cd8c699fee03e80$export$de7da2aaa45f2eb5 = ({ className: className, ...props })=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex flex-col space-y-2 text-center sm:text-left", className),
        ...props
    });
$3cd8c699fee03e80$export$de7da2aaa45f2eb5.displayName = "SheetHeader";
const $3cd8c699fee03e80$export$1adeb0155503ee5a = ({ className: className, ...props })=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
        ...props
    });
$3cd8c699fee03e80$export$1adeb0155503ee5a.displayName = "SheetFooter";
const $3cd8c699fee03e80$export$4bb009ae36731de9 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$export$f99233281efd08a0, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("text-lg font-semibold text-foreground", className),
        ...props
    }));
$3cd8c699fee03e80$export$4bb009ae36731de9.displayName = $94724b4e84955d54$export$f99233281efd08a0.displayName;
const $3cd8c699fee03e80$export$2ee64bd945b80e4a = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$export$393edc798c47379d, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("text-sm text-muted-foreground", className),
        ...props
    }));
$3cd8c699fee03e80$export$2ee64bd945b80e4a.displayName = $94724b4e84955d54$export$393edc798c47379d.displayName;



function $075513266c39e734$export$2e2bcd8739ae039({ children: children, show: show, title: title, onClose: onClose, width: width = "90%", topOffset: topOffset }) {
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $3cd8c699fee03e80$export$a9bf29f8d87ebbee), {
        open: show,
        onOpenChange: onClose,
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $3cd8c699fee03e80$export$fe5ec5b76996e2d3), {
            style: {
                width: width,
                padding: 0,
                outline: "none",
                overflow: "auto",
                ...topOffset && {
                    top: `${topOffset}px`,
                    height: `${window.innerHeight - topOffset}px`
                }
            },
            hideClose: true,
            hideBg: true,
            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "flex h-full flex-col overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: "border-b-[1px] border-theme-grey-5 px-7",
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex flex-row items-center justify-between text-[20px] font-semibold leading-none text-[#0B0B0B]",
                            children: [
                                title && typeof title === "string" && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "py-7",
                                    children: title
                                }),
                                title && typeof title === "object" && title,
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "cursor-pointer p-1",
                                    onClick: onClose,
                                    children: (0, $697654d10ef148cd$export$a6cccece9dc8d76a)("#000000")
                                })
                            ]
                        })
                    }),
                    children
                ]
            })
        })
    });
}



parcelRequire("8vqx4");
function $7dff8b7841c3531f$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "grow overflow-auto",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "p-8",
            children: children
        })
    });
}




var $8vqx4 = parcelRequire("8vqx4");


const $753fa877a4b606f8$export$92560e4a4f380d99 = [
    {
        weight: {
            imperial: "6 - 13",
            metric: "3 - 6"
        },
        height: {
            imperial: "9 - 11.5",
            metric: "23 - 29"
        },
        id: 1,
        name: "Affenpinscher",
        bred_for: "Small rodent hunting, lapdog",
        breed_group: "Toy",
        life_span: "10 - 12 years",
        temperament: "Stubborn, Curious, Playful, Adventurous, Active, Fun-loving",
        origin: "Germany, France",
        reference_image_id: "BJa4kxc4X",
        image: {
            id: "BJa4kxc4X",
            width: 1600,
            height: 1199,
            url: "https://cdn2.thedogapi.com/images/BJa4kxc4X.jpg"
        }
    },
    {
        weight: {
            imperial: "50 - 60",
            metric: "23 - 27"
        },
        height: {
            imperial: "25 - 27",
            metric: "64 - 69"
        },
        id: 2,
        name: "Afghan Hound",
        country_code: "AG",
        bred_for: "Coursing and hunting",
        breed_group: "Hound",
        life_span: "10 - 13 years",
        temperament: "Aloof, Clownish, Dignified, Independent, Happy",
        origin: "Afghanistan, Iran, Pakistan",
        reference_image_id: "hMyT4CDXR",
        image: {
            id: "hMyT4CDXR",
            width: 606,
            height: 380,
            url: "https://cdn2.thedogapi.com/images/hMyT4CDXR.jpg"
        }
    },
    {
        weight: {
            imperial: "44 - 66",
            metric: "20 - 30"
        },
        height: {
            imperial: "30",
            metric: "76"
        },
        id: 3,
        name: "African Hunting Dog",
        bred_for: "A wild pack animal",
        life_span: "11 years",
        temperament: "Wild, Hardworking, Dutiful",
        origin: "",
        reference_image_id: "rkiByec47",
        image: {
            id: "rkiByec47",
            width: 500,
            height: 335,
            url: "https://cdn2.thedogapi.com/images/rkiByec47.jpg"
        }
    },
    {
        weight: {
            imperial: "40 - 65",
            metric: "18 - 29"
        },
        height: {
            imperial: "21 - 23",
            metric: "53 - 58"
        },
        id: 4,
        name: "Airedale Terrier",
        bred_for: "Badger, otter hunting",
        breed_group: "Terrier",
        life_span: "10 - 13 years",
        temperament: "Outgoing, Friendly, Alert, Confident, Intelligent, Courageous",
        origin: "United Kingdom, England",
        reference_image_id: "1-7cgoZSh",
        image: {
            id: "1-7cgoZSh",
            width: 645,
            height: 430,
            url: "https://cdn2.thedogapi.com/images/1-7cgoZSh.jpg"
        }
    },
    {
        weight: {
            imperial: "90 - 120",
            metric: "41 - 54"
        },
        height: {
            imperial: "28 - 34",
            metric: "71 - 86"
        },
        id: 5,
        name: "Akbash Dog",
        bred_for: "Sheep guarding",
        breed_group: "Working",
        life_span: "10 - 12 years",
        temperament: "Loyal, Independent, Intelligent, Brave",
        origin: "",
        reference_image_id: "26pHT3Qk7",
        image: {
            id: "26pHT3Qk7",
            width: 600,
            height: 471,
            url: "https://cdn2.thedogapi.com/images/26pHT3Qk7.jpg"
        }
    },
    {
        weight: {
            imperial: "65 - 115",
            metric: "29 - 52"
        },
        height: {
            imperial: "24 - 28",
            metric: "61 - 71"
        },
        id: 6,
        name: "Akita",
        bred_for: "Hunting bears",
        breed_group: "Working",
        life_span: "10 - 14 years",
        temperament: "Docile, Alert, Responsive, Dignified, Composed, Friendly, Receptive, Faithful, Courageous",
        reference_image_id: "BFRYBufpm",
        image: {
            id: "BFRYBufpm",
            width: 1280,
            height: 853,
            url: "https://cdn2.thedogapi.com/images/BFRYBufpm.jpg"
        }
    },
    {
        weight: {
            imperial: "55 - 90",
            metric: "25 - 41"
        },
        height: {
            imperial: "18 - 24",
            metric: "46 - 61"
        },
        id: 7,
        name: "Alapaha Blue Blood Bulldog",
        description: "The Alapaha Blue Blood Bulldog is a well-developed, exaggerated bulldog with a broad head and natural drop ears. The prominent muzzle is covered by loose upper lips. The prominent eyes are set well apart. The Alapaha's coat is relatively short and fairly stiff. Preferred colors are blue merle, brown merle, or red merle all trimmed in white or chocolate and white. Also preferred are the glass eyes (blue) or marble eyes (brown and blue mixed in a single eye). The ears and tail are never trimmed or docked. The body is sturdy and very muscular. The well-muscled hips are narrower than the chest. The straight back is as long as the dog is high at the shoulders. The dewclaws are never removed and the feet are cat-like.",
        bred_for: "Guarding",
        breed_group: "Mixed",
        life_span: "12 - 13 years",
        history: "",
        temperament: "Loving, Protective, Trainable, Dutiful, Responsible",
        reference_image_id: "33mJ-V3RX",
        image: {
            id: "33mJ-V3RX",
            width: 1828,
            height: 2065,
            url: "https://cdn2.thedogapi.com/images/33mJ-V3RX.jpg"
        }
    },
    {
        weight: {
            imperial: "38 - 50",
            metric: "17 - 23"
        },
        height: {
            imperial: "23 - 26",
            metric: "58 - 66"
        },
        id: 8,
        name: "Alaskan Husky",
        bred_for: "Sled pulling",
        breed_group: "Mixed",
        life_span: "10 - 13 years",
        temperament: "Friendly, Energetic, Loyal, Gentle, Confident",
        reference_image_id: "-HgpNnGXl",
        image: {
            id: "-HgpNnGXl",
            width: 500,
            height: 500,
            url: "https://cdn2.thedogapi.com/images/-HgpNnGXl.jpg"
        }
    },
    {
        weight: {
            imperial: "65 - 100",
            metric: "29 - 45"
        },
        height: {
            imperial: "23 - 25",
            metric: "58 - 64"
        },
        id: 9,
        name: "Alaskan Malamute",
        bred_for: "Hauling heavy freight, Sled pulling",
        breed_group: "Working",
        life_span: "12 - 15 years",
        temperament: "Friendly, Affectionate, Devoted, Loyal, Dignified, Playful",
        reference_image_id: "dW5UucTIW",
        image: {
            id: "dW5UucTIW",
            width: 1023,
            height: 769,
            url: "https://cdn2.thedogapi.com/images/dW5UucTIW.jpg"
        }
    },
    {
        weight: {
            imperial: "60 - 120",
            metric: "27 - 54"
        },
        height: {
            imperial: "22 - 27",
            metric: "56 - 69"
        },
        id: 10,
        name: "American Bulldog",
        breed_group: "Working",
        life_span: "10 - 12 years",
        temperament: "Friendly, Assertive, Energetic, Loyal, Gentle, Confident, Dominant",
        reference_image_id: "pk1AAdloG",
        image: {
            id: "pk1AAdloG",
            width: 1669,
            height: 1377,
            url: "https://cdn2.thedogapi.com/images/pk1AAdloG.jpg"
        }
    },
    {
        weight: {
            imperial: "30 - 150",
            metric: "14 - 68"
        },
        height: {
            imperial: "14 - 17",
            metric: "36 - 43"
        },
        id: 11,
        name: "American Bully",
        country_code: "US",
        bred_for: "Family companion dog",
        breed_group: "",
        life_span: "8 \u2013 15 years",
        temperament: "Strong Willed, Stubborn, Friendly, Clownish, Affectionate, Loyal, Obedient, Intelligent, Courageous",
        reference_image_id: "sqQJDtbpY",
        image: {
            id: "sqQJDtbpY",
            width: 1024,
            height: 683,
            url: "https://cdn2.thedogapi.com/images/sqQJDtbpY.jpg"
        }
    },
    {
        weight: {
            imperial: "20 - 40",
            metric: "9 - 18"
        },
        height: {
            imperial: "15 - 19",
            metric: "38 - 48"
        },
        id: 12,
        name: "American Eskimo Dog",
        country_code: "US",
        bred_for: "Circus performer",
        breed_group: "Non-Sporting",
        life_span: "12 - 15 years",
        temperament: "Friendly, Alert, Reserved, Intelligent, Protective",
        reference_image_id: "Bymjyec4m",
        image: {
            id: "Bymjyec4m",
            width: 1000,
            height: 802,
            url: "https://cdn2.thedogapi.com/images/Bymjyec4m.jpg"
        }
    },
    {
        weight: {
            imperial: "7 - 10",
            metric: "3 - 5"
        },
        height: {
            imperial: "9 - 12",
            metric: "23 - 30"
        },
        id: 13,
        name: "American Eskimo Dog (Miniature)",
        country_code: "US",
        bred_for: "Companionship",
        life_span: "13 \u2013 15 years",
        temperament: "Friendly, Alert, Reserved, Intelligent, Protective",
        reference_image_id: "_gn8GLrE6",
        image: {
            id: "_gn8GLrE6",
            width: 730,
            height: 487,
            url: "https://cdn2.thedogapi.com/images/_gn8GLrE6.jpg"
        }
    },
    {
        weight: {
            imperial: "65 - 75",
            metric: "29 - 34"
        },
        height: {
            imperial: "21 - 28",
            metric: "53 - 71"
        },
        id: 14,
        name: "American Foxhound",
        country_code: "US",
        bred_for: "Fox hunting, scent hound",
        breed_group: "Hound",
        life_span: "8 - 15 years",
        temperament: "Kind, Sweet-Tempered, Loyal, Independent, Intelligent, Loving",
        reference_image_id: "S14n1x9NQ",
        image: {
            id: "S14n1x9NQ",
            width: 3000,
            height: 2400,
            url: "https://cdn2.thedogapi.com/images/S14n1x9NQ.jpg"
        }
    },
    {
        weight: {
            imperial: "30 - 60",
            metric: "14 - 27"
        },
        height: {
            imperial: "17 - 21",
            metric: "43 - 53"
        },
        id: 15,
        name: "American Pit Bull Terrier",
        country_code: "US",
        bred_for: "Fighting",
        breed_group: "Terrier",
        life_span: "10 - 15 years",
        temperament: "Strong Willed, Stubborn, Friendly, Clownish, Affectionate, Loyal, Obedient, Intelligent, Courageous",
        reference_image_id: "HkC31gcNm",
        image: {
            id: "HkC31gcNm",
            width: 300,
            height: 244,
            url: "https://cdn2.thedogapi.com/images/HkC31gcNm.png"
        }
    },
    {
        weight: {
            imperial: "50 - 60",
            metric: "23 - 27"
        },
        height: {
            imperial: "17 - 19",
            metric: "43 - 48"
        },
        id: 16,
        name: "American Staffordshire Terrier",
        country_code: "US",
        bred_for: "",
        breed_group: "Terrier",
        life_span: "12 - 15 years",
        temperament: "Tenacious, Friendly, Devoted, Loyal, Attentive, Courageous",
        reference_image_id: "rJIakgc4m",
        image: {
            id: "rJIakgc4m",
            width: 357,
            height: 500,
            url: "https://cdn2.thedogapi.com/images/rJIakgc4m.jpg"
        }
    },
    {
        weight: {
            imperial: "25 - 45",
            metric: "11 - 20"
        },
        height: {
            imperial: "15 - 18",
            metric: "38 - 46"
        },
        id: 17,
        name: "American Water Spaniel",
        country_code: "US",
        bred_for: "Bird flushing and retrieving",
        breed_group: "Sporting",
        life_span: "10 - 12 years",
        temperament: "Friendly, Energetic, Obedient, Intelligent, Protective, Trainable",
        reference_image_id: "SkmRJl9VQ",
        image: {
            id: "SkmRJl9VQ",
            width: 1600,
            height: 1264,
            url: "https://cdn2.thedogapi.com/images/SkmRJl9VQ.jpg"
        }
    },
    {
        weight: {
            imperial: "80 - 150",
            metric: "36 - 68"
        },
        height: {
            imperial: "27 - 29",
            metric: "69 - 74"
        },
        id: 18,
        name: "Anatolian Shepherd Dog",
        bred_for: "Livestock herding",
        breed_group: "Working",
        life_span: "11 - 13 years",
        temperament: "Steady, Bold, Independent, Confident, Intelligent, Proud",
        reference_image_id: "BJT0Jx5Nm",
        image: {
            id: "BJT0Jx5Nm",
            width: 1216,
            height: 1131,
            url: "https://cdn2.thedogapi.com/images/BJT0Jx5Nm.jpg"
        }
    },
    {
        weight: {
            imperial: "48 - 55",
            metric: "22 - 25"
        },
        height: {
            imperial: "20 - 22",
            metric: "51 - 56"
        },
        id: 19,
        name: "Appenzeller Sennenhund",
        bred_for: "Herding livestock, pulling carts, and guarding the farm",
        life_span: "12 \u2013 14 years",
        temperament: "Reliable, Fearless, Energetic, Lively, Self-assured",
        reference_image_id: "HkNkxlqEX",
        image: {
            id: "HkNkxlqEX",
            width: 400,
            height: 600,
            url: "https://cdn2.thedogapi.com/images/HkNkxlqEX.jpg"
        }
    },
    {
        weight: {
            imperial: "44 - 62",
            metric: "20 - 28"
        },
        height: {
            imperial: "17 - 20",
            metric: "43 - 51"
        },
        id: 21,
        name: "Australian Cattle Dog",
        country_code: "AU",
        bred_for: "Cattle herding, herding trials",
        breed_group: "Herding",
        life_span: "12 - 14 years",
        temperament: "Cautious, Energetic, Loyal, Obedient, Protective, Brave",
        reference_image_id: "IBkYVm4v1",
        image: {
            id: "IBkYVm4v1",
            width: 736,
            height: 850,
            url: "https://cdn2.thedogapi.com/images/IBkYVm4v1.jpg"
        }
    },
    {
        weight: {
            imperial: "31 - 46",
            metric: "14 - 21"
        },
        height: {
            imperial: "17 - 20",
            metric: "43 - 51"
        },
        id: 22,
        name: "Australian Kelpie",
        country_code: "AU",
        bred_for: "Farm dog, Cattle herding",
        breed_group: "Herding",
        life_span: "10 - 13 years",
        temperament: "Friendly, Energetic, Alert, Loyal, Intelligent, Eager",
        reference_image_id: "Hyq1ge9VQ",
        image: {
            id: "Hyq1ge9VQ",
            width: 800,
            height: 533,
            url: "https://cdn2.thedogapi.com/images/Hyq1ge9VQ.jpg"
        }
    },
    {
        weight: {
            imperial: "35 - 65",
            metric: "16 - 29"
        },
        height: {
            imperial: "18 - 23",
            metric: "46 - 58"
        },
        id: 23,
        name: "Australian Shepherd",
        country_code: "AU",
        bred_for: "Sheep herding",
        breed_group: "Herding",
        life_span: "12 - 16 years",
        temperament: "Good-natured, Affectionate, Intelligent, Active, Protective",
        reference_image_id: "B1-llgq4m",
        image: {
            id: "B1-llgq4m",
            width: 1200,
            height: 733,
            url: "https://cdn2.thedogapi.com/images/B1-llgq4m.jpg"
        }
    },
    {
        weight: {
            imperial: "14 - 16",
            metric: "6 - 7"
        },
        height: {
            imperial: "10 - 11",
            metric: "25 - 28"
        },
        id: 24,
        name: "Australian Terrier",
        country_code: "AU",
        bred_for: "Cattle herdering, hunting snakes and rodents",
        breed_group: "Terrier",
        life_span: "15 years",
        temperament: "Spirited, Alert, Loyal, Companionable, Even Tempered, Courageous",
        reference_image_id: "r1Ylge5Vm",
        image: {
            id: "r1Ylge5Vm",
            width: 1081,
            height: 720,
            url: "https://cdn2.thedogapi.com/images/r1Ylge5Vm.jpg"
        }
    },
    {
        weight: {
            imperial: "33 - 55",
            metric: "15 - 25"
        },
        height: {
            imperial: "23 - 29",
            metric: "58 - 74"
        },
        id: 25,
        name: "Azawakh",
        bred_for: "Livestock guardian, hunting",
        breed_group: "Hound",
        life_span: "10 - 13 years",
        temperament: "Aloof, Affectionate, Attentive, Rugged, Fierce, Refined",
        reference_image_id: "SkvZgx94m",
        image: {
            id: "SkvZgx94m",
            width: 1024,
            height: 768,
            url: "https://cdn2.thedogapi.com/images/SkvZgx94m.jpg"
        }
    },
    {
        weight: {
            imperial: "40 - 65",
            metric: "18 - 29"
        },
        height: {
            imperial: "20 - 26",
            metric: "51 - 66"
        },
        id: 26,
        name: "Barbet",
        bred_for: "Hunting water game",
        life_span: "13 \u2013 15 years",
        temperament: "Obedient, Companionable, Intelligent, Joyful",
        reference_image_id: "HyWGexcVQ",
        image: {
            id: "HyWGexcVQ",
            width: 853,
            height: 1280,
            url: "https://cdn2.thedogapi.com/images/HyWGexcVQ.jpg"
        }
    },
    {
        weight: {
            imperial: "22 - 24",
            metric: "10 - 11"
        },
        height: {
            imperial: "16 - 17",
            metric: "41 - 43"
        },
        id: 28,
        name: "Basenji",
        bred_for: "Hunting",
        breed_group: "Hound",
        life_span: "10 - 12 years",
        temperament: "Affectionate, Energetic, Alert, Curious, Playful, Intelligent",
        reference_image_id: "H1dGlxqNQ",
        image: {
            id: "H1dGlxqNQ",
            width: 740,
            height: 493,
            url: "https://cdn2.thedogapi.com/images/H1dGlxqNQ.jpg"
        }
    },
    {
        weight: {
            imperial: "35 - 40",
            metric: "16 - 18"
        },
        height: {
            imperial: "13 - 15",
            metric: "33 - 38"
        },
        id: 29,
        name: "Basset Bleu de Gascogne",
        bred_for: "Hunting on foot.",
        breed_group: "Hound",
        life_span: "10 - 14 years",
        temperament: "Affectionate, Lively, Agile, Curious, Happy, Active",
        reference_image_id: "BkMQll94X",
        image: {
            id: "BkMQll94X",
            width: 1280,
            height: 853,
            url: "https://cdn2.thedogapi.com/images/BkMQll94X.jpg"
        }
    },
    {
        weight: {
            imperial: "50 - 65",
            metric: "23 - 29"
        },
        height: {
            imperial: "14",
            metric: "36"
        },
        id: 30,
        name: "Basset Hound",
        bred_for: "Hunting by scent",
        breed_group: "Hound",
        life_span: "12 - 15 years",
        temperament: "Tenacious, Friendly, Affectionate, Devoted, Sweet-Tempered, Gentle",
        reference_image_id: "Sy57xx9EX",
        image: {
            id: "Sy57xx9EX",
            width: 1024,
            height: 640,
            url: "https://cdn2.thedogapi.com/images/Sy57xx9EX.jpg"
        }
    },
    {
        weight: {
            imperial: "20 - 35",
            metric: "9 - 16"
        },
        height: {
            imperial: "13 - 15",
            metric: "33 - 38"
        },
        id: 31,
        name: "Beagle",
        bred_for: "Rabbit, hare hunting",
        breed_group: "Hound",
        life_span: "13 - 16 years",
        temperament: "Amiable, Even Tempered, Excitable, Determined, Gentle, Intelligent",
        reference_image_id: "Syd4xxqEm",
        image: {
            id: "Syd4xxqEm",
            width: 1000,
            height: 667,
            url: "https://cdn2.thedogapi.com/images/Syd4xxqEm.jpg"
        }
    },
    {
        weight: {
            imperial: "45 - 55",
            metric: "20 - 25"
        },
        height: {
            imperial: "20 - 22",
            metric: "51 - 56"
        },
        id: 32,
        name: "Bearded Collie",
        bred_for: "Sheep herding",
        breed_group: "Herding",
        life_span: "12 - 14 years",
        temperament: "Self-confidence, Hardy, Lively, Alert, Intelligent, Active",
        reference_image_id: "A09F4c1qP",
        image: {
            id: "A09F4c1qP",
            width: 733,
            height: 733,
            url: "https://cdn2.thedogapi.com/images/A09F4c1qP.jpg"
        }
    },
    {
        weight: {
            imperial: "80 - 110",
            metric: "36 - 50"
        },
        height: {
            imperial: "24 - 27.5",
            metric: "61 - 70"
        },
        id: 33,
        name: "Beauceron",
        bred_for: "Boar herding, hunting, guarding",
        breed_group: "Herding",
        life_span: "10 - 12 years",
        temperament: "Fearless, Friendly, Intelligent, Protective, Calm",
        reference_image_id: "HJQ8ge5V7",
        image: {
            id: "HJQ8ge5V7",
            width: 720,
            height: 563,
            url: "https://cdn2.thedogapi.com/images/HJQ8ge5V7.jpg"
        }
    },
    {
        weight: {
            imperial: "17 - 23",
            metric: "8 - 10"
        },
        height: {
            imperial: "15 - 16",
            metric: "38 - 41"
        },
        id: 34,
        name: "Bedlington Terrier",
        bred_for: "Killing rat, badger, other vermin",
        breed_group: "Terrier",
        life_span: "14 - 16 years",
        temperament: "Affectionate, Spirited, Intelligent, Good-tempered",
        reference_image_id: "ByK8gx947",
        image: {
            id: "ByK8gx947",
            width: 804,
            height: 531,
            url: "https://cdn2.thedogapi.com/images/ByK8gx947.jpg"
        }
    },
    {
        weight: {
            imperial: "40 - 80",
            metric: "18 - 36"
        },
        height: {
            imperial: "22 - 26",
            metric: "56 - 66"
        },
        id: 36,
        name: "Belgian Malinois",
        bred_for: "Stock herding",
        breed_group: "Herding",
        life_span: "12 - 14 years",
        temperament: "Watchful, Alert, Stubborn, Friendly, Confident, Hard-working, Active, Protective",
        reference_image_id: "r1f_ll5VX",
        image: {
            id: "r1f_ll5VX",
            width: 604,
            height: 453,
            url: "https://cdn2.thedogapi.com/images/r1f_ll5VX.jpg"
        }
    },
    {
        weight: {
            imperial: "40 - 65",
            metric: "18 - 29"
        },
        height: {
            imperial: "22 - 26",
            metric: "56 - 66"
        },
        id: 38,
        name: "Belgian Tervuren",
        bred_for: "Guarding, Drafting, Police work.",
        breed_group: "Herding",
        life_span: "10 - 12 years",
        temperament: "Energetic, Alert, Loyal, Intelligent, Attentive, Protective",
        reference_image_id: "B1KdxlcNX",
        image: {
            id: "B1KdxlcNX",
            width: 645,
            height: 380,
            url: "https://cdn2.thedogapi.com/images/B1KdxlcNX.jpg"
        }
    },
    {
        weight: {
            imperial: "65 - 120",
            metric: "29 - 54"
        },
        height: {
            imperial: "23 - 27.5",
            metric: "58 - 70"
        },
        id: 41,
        name: "Bernese Mountain Dog",
        bred_for: "Draft work",
        breed_group: "Working",
        life_span: "7 - 10 years",
        temperament: "Affectionate, Loyal, Intelligent, Faithful",
        reference_image_id: "S1fFlx5Em",
        image: {
            id: "S1fFlx5Em",
            width: 640,
            height: 427,
            url: "https://cdn2.thedogapi.com/images/S1fFlx5Em.jpg"
        }
    },
    {
        weight: {
            imperial: "10 - 18",
            metric: "5 - 8"
        },
        height: {
            imperial: "9.5 - 11.5",
            metric: "24 - 29"
        },
        id: 42,
        name: "Bichon Frise",
        bred_for: "Companion",
        breed_group: "Non-Sporting",
        life_span: "15 years",
        temperament: "Feisty, Affectionate, Cheerful, Playful, Gentle, Sensitive",
        reference_image_id: "HkuYlxqEQ",
        image: {
            id: "HkuYlxqEQ",
            width: 480,
            height: 360,
            url: "https://cdn2.thedogapi.com/images/HkuYlxqEQ.jpg"
        }
    },
    {
        weight: {
            imperial: "65 - 100",
            metric: "29 - 45"
        },
        height: {
            imperial: "23 - 27",
            metric: "58 - 69"
        },
        id: 43,
        name: "Black and Tan Coonhound",
        bred_for: "Hunting raccoons, night hunting",
        breed_group: "Hound",
        life_span: "10 - 12 years",
        temperament: "Easygoing, Gentle, Adaptable, Trusting, Even Tempered, Lovable",
        reference_image_id: "HJAFgxcNQ",
        image: {
            id: "HJAFgxcNQ",
            width: 556,
            height: 380,
            url: "https://cdn2.thedogapi.com/images/HJAFgxcNQ.jpg"
        }
    },
    {
        weight: {
            imperial: "80 - 110",
            metric: "36 - 50"
        },
        height: {
            imperial: "23 - 27",
            metric: "58 - 69"
        },
        id: 45,
        name: "Bloodhound",
        bred_for: "Trailing",
        breed_group: "Hound",
        life_span: "8 - 10 years",
        temperament: "Stubborn, Affectionate, Gentle, Even Tempered",
        reference_image_id: "Skdcgx9VX",
        image: {
            id: "Skdcgx9VX",
            width: 586,
            height: 600,
            url: "https://cdn2.thedogapi.com/images/Skdcgx9VX.jpg"
        }
    },
    {
        weight: {
            imperial: "45 - 80",
            metric: "20 - 36"
        },
        height: {
            imperial: "21 - 27",
            metric: "53 - 69"
        },
        id: 47,
        name: "Bluetick Coonhound",
        bred_for: "Hunting with a superior sense of smell.",
        breed_group: "Hound",
        life_span: "12 - 14 years",
        temperament: "Friendly, Intelligent, Active",
        reference_image_id: "rJxieg9VQ",
        image: {
            id: "rJxieg9VQ",
            width: 731,
            height: 599,
            url: "https://cdn2.thedogapi.com/images/rJxieg9VQ.jpg"
        }
    },
    {
        weight: {
            imperial: "110 - 200",
            metric: "50 - 91"
        },
        height: {
            imperial: "22 - 27",
            metric: "56 - 69"
        },
        id: 48,
        name: "Boerboel",
        bred_for: "Guarding the homestead, farm work.",
        breed_group: "Working",
        life_span: "10 - 12 years",
        temperament: "Obedient, Confident, Intelligent, Dominant, Territorial",
        reference_image_id: "HyOjge5Vm",
        image: {
            id: "HyOjge5Vm",
            width: 1200,
            height: 669,
            url: "https://cdn2.thedogapi.com/images/HyOjge5Vm.jpg"
        }
    },
    {
        weight: {
            imperial: "30 - 45",
            metric: "14 - 20"
        },
        height: {
            imperial: "18 - 22",
            metric: "46 - 56"
        },
        id: 50,
        name: "Border Collie",
        bred_for: "Sheep herder",
        breed_group: "Herding",
        life_span: "12 - 16 years",
        temperament: "Tenacious, Keen, Energetic, Responsive, Alert, Intelligent",
        reference_image_id: "sGQvQUpsp",
        image: {
            id: "sGQvQUpsp",
            width: 1080,
            height: 1080,
            url: "https://cdn2.thedogapi.com/images/sGQvQUpsp.jpg"
        }
    },
    {
        weight: {
            imperial: "11.5 - 15.5",
            metric: "5 - 7"
        },
        height: {
            imperial: "11 - 16",
            metric: "28 - 41"
        },
        id: 51,
        name: "Border Terrier",
        bred_for: "Fox bolting, ratting",
        breed_group: "Terrier",
        life_span: "12 - 14 years",
        temperament: "Fearless, Affectionate, Alert, Obedient, Intelligent, Even Tempered",
        reference_image_id: "HJOpge9Em",
        image: {
            id: "HJOpge9Em",
            width: 674,
            height: 450,
            url: "https://cdn2.thedogapi.com/images/HJOpge9Em.jpg"
        }
    },
    {
        weight: {
            imperial: "10 - 25",
            metric: "5 - 11"
        },
        height: {
            imperial: "16 - 17",
            metric: "41 - 43"
        },
        id: 53,
        name: "Boston Terrier",
        bred_for: "Ratting, Companionship",
        breed_group: "Non-Sporting",
        life_span: "11 - 13 years",
        temperament: "Friendly, Lively, Intelligent",
        reference_image_id: "rkZRggqVX",
        image: {
            id: "rkZRggqVX",
            width: 1010,
            height: 673,
            url: "https://cdn2.thedogapi.com/images/rkZRggqVX.jpg"
        }
    },
    {
        weight: {
            imperial: "70 - 110",
            metric: "32 - 50"
        },
        height: {
            imperial: "23.5 - 27.5",
            metric: "60 - 70"
        },
        id: 54,
        name: "Bouvier des Flandres",
        bred_for: "Cattle herding",
        breed_group: "Herding",
        life_span: "10 - 15 years",
        temperament: "Protective, Loyal, Gentle, Intelligent, Familial, Rational",
        reference_image_id: "Byd0xl5VX",
        image: {
            id: "Byd0xl5VX",
            width: 680,
            height: 454,
            url: "https://cdn2.thedogapi.com/images/Byd0xl5VX.jpg"
        }
    },
    {
        weight: {
            imperial: "50 - 70",
            metric: "23 - 32"
        },
        height: {
            imperial: "21.5 - 25",
            metric: "55 - 64"
        },
        id: 55,
        name: "Boxer",
        bred_for: "Bull-baiting, guardian",
        breed_group: "Working",
        life_span: "8 - 10 years",
        temperament: "Devoted, Fearless, Friendly, Cheerful, Energetic, Loyal, Playful, Confident, Intelligent, Bright, Brave, Calm",
        reference_image_id: "ry1kWe5VQ",
        image: {
            id: "ry1kWe5VQ",
            width: 645,
            height: 430,
            url: "https://cdn2.thedogapi.com/images/ry1kWe5VQ.jpg"
        }
    },
    {
        weight: {
            imperial: "25 - 40",
            metric: "11 - 18"
        },
        height: {
            imperial: "14 - 18",
            metric: "36 - 46"
        },
        id: 56,
        name: "Boykin Spaniel",
        bred_for: "Turkey retrieving",
        breed_group: "Sporting",
        life_span: "10 - 14 years",
        temperament: "Friendly, Energetic, Companionable, Intelligent, Eager, Trainable",
        reference_image_id: "ryHJZlcNX",
        image: {
            id: "ryHJZlcNX",
            width: 577,
            height: 634,
            url: "https://cdn2.thedogapi.com/images/ryHJZlcNX.jpg"
        }
    },
    {
        weight: {
            imperial: "55 - 88",
            metric: "25 - 40"
        },
        height: {
            imperial: "21.5 - 26.5",
            metric: "55 - 67"
        },
        id: 57,
        name: "Bracco Italiano",
        bred_for: "Versatile gun dog",
        breed_group: "Sporting",
        life_span: "10 - 12 years",
        temperament: "Stubborn, Affectionate, Loyal, Playful, Companionable, Trainable",
        reference_image_id: "S13yZg5VQ",
        image: {
            id: "S13yZg5VQ",
            width: 750,
            height: 505,
            url: "https://cdn2.thedogapi.com/images/S13yZg5VQ.jpg"
        }
    },
    {
        weight: {
            imperial: "70 - 90",
            metric: "32 - 41"
        },
        height: {
            imperial: "22 - 27",
            metric: "56 - 69"
        },
        id: 58,
        name: "Briard",
        bred_for: "Herding, guarding sheep",
        breed_group: "Herding",
        life_span: "10 - 12 years",
        temperament: "Fearless, Loyal, Obedient, Intelligent, Faithful, Protective",
        reference_image_id: "rkVlblcEQ",
        image: {
            id: "rkVlblcEQ",
            width: 768,
            height: 576,
            url: "https://cdn2.thedogapi.com/images/rkVlblcEQ.jpg"
        }
    },
    {
        weight: {
            imperial: "30 - 45",
            metric: "14 - 20"
        },
        height: {
            imperial: "17.5 - 20.5",
            metric: "44 - 52"
        },
        id: 59,
        name: "Brittany",
        bred_for: "Pointing, retrieving",
        breed_group: "Sporting",
        life_span: "12 - 14 years",
        temperament: "Agile, Adaptable, Quick, Intelligent, Attentive, Happy",
        reference_image_id: "HJWZZxc4X",
        image: {
            id: "HJWZZxc4X",
            width: 900,
            height: 600,
            url: "https://cdn2.thedogapi.com/images/HJWZZxc4X.jpg"
        }
    },
    {
        weight: {
            imperial: "50 - 70",
            metric: "23 - 32"
        },
        height: {
            imperial: "21 - 22",
            metric: "53 - 56"
        },
        id: 61,
        name: "Bull Terrier",
        bred_for: "Bull baiting, Fighting",
        breed_group: "Terrier",
        life_span: "10 - 12 years",
        temperament: "Trainable, Protective, Sweet-Tempered, Keen, Active",
        reference_image_id: "VSraIEQGd",
        image: {
            id: "VSraIEQGd",
            width: 1080,
            height: 1080,
            url: "https://cdn2.thedogapi.com/images/VSraIEQGd.jpg"
        }
    },
    {
        weight: {
            imperial: "25 - 33",
            metric: "11 - 15"
        },
        height: {
            imperial: "10 - 14",
            metric: "25 - 36"
        },
        id: 62,
        name: "Bull Terrier (Miniature)",
        bred_for: "An elegant man's fashion statement",
        life_span: "11 \u2013 14 years",
        temperament: "Trainable, Protective, Sweet-Tempered, Keen, Active, Territorial",
        reference_image_id: "BkKZWlcVX",
        image: {
            id: "BkKZWlcVX",
            width: 674,
            height: 450,
            url: "https://cdn2.thedogapi.com/images/BkKZWlcVX.jpg"
        }
    },
    {
        weight: {
            imperial: "100 - 130",
            metric: "45 - 59"
        },
        height: {
            imperial: "24 - 27",
            metric: "61 - 69"
        },
        id: 64,
        name: "Bullmastiff",
        bred_for: "Estate guardian",
        breed_group: "Working",
        life_span: "8 - 12 years",
        temperament: "Docile, Reliable, Devoted, Alert, Loyal, Reserved, Loving, Protective, Powerful, Calm, Courageous",
        reference_image_id: "r1ifZl5E7",
        image: {
            id: "r1ifZl5E7",
            width: 850,
            height: 638,
            url: "https://cdn2.thedogapi.com/images/r1ifZl5E7.jpg"
        }
    },
    {
        weight: {
            imperial: "13 - 14",
            metric: "6 - 6"
        },
        height: {
            imperial: "9 - 10",
            metric: "23 - 25"
        },
        id: 65,
        name: "Cairn Terrier",
        bred_for: "Bolting of otter, foxes, other vermin",
        breed_group: "Terrier",
        life_span: "14 - 15 years",
        temperament: "Hardy, Fearless, Assertive, Gay, Intelligent, Active",
        reference_image_id: "Sk7Qbg9E7",
        image: {
            id: "Sk7Qbg9E7",
            width: 1254,
            height: 836,
            url: "https://cdn2.thedogapi.com/images/Sk7Qbg9E7.jpg"
        }
    },
    {
        weight: {
            imperial: "88 - 120",
            metric: "40 - 54"
        },
        height: {
            imperial: "23.5 - 27.5",
            metric: "60 - 70"
        },
        id: 67,
        name: "Cane Corso",
        bred_for: "Companion, guard dog, and hunter",
        breed_group: "Working",
        life_span: "10 - 11 years",
        temperament: "Trainable, Reserved, Stable, Quiet, Even Tempered, Calm",
        reference_image_id: "r15m-lc4m",
        image: {
            id: "r15m-lc4m",
            width: 645,
            height: 380,
            url: "https://cdn2.thedogapi.com/images/r15m-lc4m.jpg"
        }
    },
    {
        weight: {
            imperial: "25 - 38",
            metric: "11 - 17"
        },
        height: {
            imperial: "10.5 - 12.5",
            metric: "27 - 32"
        },
        id: 68,
        name: "Cardigan Welsh Corgi",
        bred_for: "Cattle droving",
        breed_group: "Herding",
        life_span: "12 - 14 years",
        temperament: "Affectionate, Devoted, Alert, Companionable, Intelligent, Active",
        reference_image_id: "SyXN-e9NX",
        image: {
            id: "SyXN-e9NX",
            width: 800,
            height: 600,
            url: "https://cdn2.thedogapi.com/images/SyXN-e9NX.jpg"
        }
    },
    {
        weight: {
            imperial: "50 - 95",
            metric: "23 - 43"
        },
        height: {
            imperial: "20 - 26",
            metric: "51 - 66"
        },
        id: 69,
        name: "Catahoula Leopard Dog",
        bred_for: "Driving livestock",
        breed_group: "Herding",
        life_span: "10 - 12 years",
        temperament: "Energetic, Inquisitive, Independent, Gentle, Intelligent, Loving",
        reference_image_id: "BJcNbec4X",
        image: {
            id: "BJcNbec4X",
            width: 650,
            height: 650,
            url: "https://cdn2.thedogapi.com/images/BJcNbec4X.jpg"
        }
    },
    {
        weight: {
            imperial: "80 - 100",
            metric: "36 - 45"
        },
        height: {
            imperial: "24 - 33.5",
            metric: "61 - 85"
        },
        id: 70,
        name: "Caucasian Shepherd (Ovcharka)",
        bred_for: "Guard dogs, defending sheep from predators, mainly wolves, jackals and bears",
        breed_group: "Working",
        life_span: "10 - 12 years",
        temperament: "Alert, Quick, Dominant, Powerful, Calm, Strong",
        reference_image_id: "r1rrWe5Em",
        image: {
            id: "r1rrWe5Em",
            width: 1024,
            height: 682,
            url: "https://cdn2.thedogapi.com/images/r1rrWe5Em.jpg"
        }
    },
    {
        weight: {
            imperial: "13 - 18",
            metric: "6 - 8"
        },
        height: {
            imperial: "12 - 13",
            metric: "30 - 33"
        },
        id: 71,
        name: "Cavalier King Charles Spaniel",
        bred_for: "Flushing small birds, companion",
        breed_group: "Toy",
        life_span: "10 - 14 years",
        temperament: "Fearless, Affectionate, Sociable, Patient, Playful, Adaptable",
        reference_image_id: "HJRBbe94Q",
        image: {
            id: "HJRBbe94Q",
            width: 961,
            height: 558,
            url: "https://cdn2.thedogapi.com/images/HJRBbe94Q.jpg"
        }
    },
    {
        weight: {
            imperial: "55 - 80",
            metric: "25 - 36"
        },
        height: {
            imperial: "21 - 26",
            metric: "53 - 66"
        },
        id: 76,
        name: "Chesapeake Bay Retriever",
        bred_for: "Water Retriever",
        breed_group: "Sporting",
        life_span: "10 - 13 years",
        temperament: "Affectionate, Intelligent, Quiet, Dominant, Happy, Protective",
        reference_image_id: "9BXwUeCc2",
        image: {
            id: "9BXwUeCc2",
            width: 600,
            height: 600,
            url: "https://cdn2.thedogapi.com/images/9BXwUeCc2.jpg"
        }
    },
    {
        weight: {
            imperial: "10 - 13",
            metric: "5 - 6"
        },
        height: {
            imperial: "11 - 13",
            metric: "28 - 33"
        },
        id: 78,
        name: "Chinese Crested",
        bred_for: "Ratting, lapdog, curio",
        breed_group: "Toy",
        life_span: "10 - 14 years",
        temperament: "Affectionate, Sweet-Tempered, Lively, Alert, Playful, Happy",
        reference_image_id: "B1pDZx9Nm",
        image: {
            id: "B1pDZx9Nm",
            width: 1200,
            height: 798,
            url: "https://cdn2.thedogapi.com/images/B1pDZx9Nm.jpg"
        }
    },
    {
        weight: {
            imperial: "45 - 60",
            metric: "20 - 27"
        },
        height: {
            imperial: "18 - 20",
            metric: "46 - 51"
        },
        id: 79,
        name: "Chinese Shar-Pei",
        bred_for: "Fighting",
        breed_group: "Non-Sporting",
        life_span: "10 years",
        temperament: "Suspicious, Affectionate, Devoted, Reserved, Independent, Loving",
        reference_image_id: "B1ruWl94Q",
        image: {
            id: "B1ruWl94Q",
            width: 1049,
            height: 761,
            url: "https://cdn2.thedogapi.com/images/B1ruWl94Q.jpg"
        }
    },
    {
        weight: {
            imperial: "50 - 90",
            metric: "23 - 41"
        },
        height: {
            imperial: "22 - 26",
            metric: "56 - 66"
        },
        id: 80,
        name: "Chinook",
        bred_for: "Sled pulling",
        breed_group: "Working",
        life_span: "12 - 15 years",
        temperament: "Friendly, Alert, Dignified, Intelligent, Calm",
        reference_image_id: "Sypubg54Q",
        image: {
            id: "Sypubg54Q",
            width: 600,
            height: 478,
            url: "https://cdn2.thedogapi.com/images/Sypubg54Q.jpg"
        }
    },
    {
        weight: {
            imperial: "40 - 70",
            metric: "18 - 32"
        },
        height: {
            imperial: "17 - 20",
            metric: "43 - 51"
        },
        id: 81,
        name: "Chow Chow",
        bred_for: "Guardian, cart pulling, hunting",
        breed_group: "Non-Sporting",
        life_span: "12 - 15 years",
        temperament: "Aloof, Loyal, Independent, Quiet",
        reference_image_id: "ry8KWgqEQ",
        image: {
            id: "ry8KWgqEQ",
            width: 1010,
            height: 673,
            url: "https://cdn2.thedogapi.com/images/ry8KWgqEQ.jpg"
        }
    },
    {
        weight: {
            imperial: "55 - 85",
            metric: "25 - 39"
        },
        height: {
            imperial: "17 - 20",
            metric: "43 - 51"
        },
        id: 84,
        name: "Clumber Spaniel",
        bred_for: "Bird flushing, retrieving",
        breed_group: "Sporting",
        life_span: "10 - 12 years",
        temperament: "Affectionate, Loyal, Dignified, Gentle, Calm, Great-hearted",
        reference_image_id: "rkeqWgq4Q",
        image: {
            id: "rkeqWgq4Q",
            width: 762,
            height: 533,
            url: "https://cdn2.thedogapi.com/images/rkeqWgq4Q.jpg"
        }
    },
    {
        weight: {
            imperial: "20 - 30",
            metric: "9 - 14"
        },
        height: {
            imperial: "14 - 15",
            metric: "36 - 38"
        },
        id: 86,
        name: "Cocker Spaniel",
        bred_for: "Bird flushing, retrieving",
        breed_group: "Sporting",
        life_span: "12 - 15 years",
        temperament: "Trainable, Friendly, Affectionate, Playful, Quiet, Faithful",
        reference_image_id: "1lFmrzECl",
        image: {
            id: "1lFmrzECl",
            width: 1080,
            height: 1080,
            url: "https://cdn2.thedogapi.com/images/1lFmrzECl.jpg"
        }
    },
    {
        weight: {
            imperial: "20 - 30",
            metric: "9 - 14"
        },
        height: {
            imperial: "14 - 15",
            metric: "36 - 38"
        },
        id: 87,
        name: "Cocker Spaniel (American)",
        bred_for: "Hunting the American woodcock",
        breed_group: "Sporting",
        life_span: "12 - 15 years",
        temperament: "Outgoing, Sociable, Trusting, Joyful, Even Tempered, Merry",
        reference_image_id: "HkRcZe547",
        image: {
            id: "HkRcZe547",
            width: 1024,
            height: 640,
            url: "https://cdn2.thedogapi.com/images/HkRcZe547.jpg"
        }
    },
    {
        weight: {
            imperial: "9 - 15",
            metric: "4 - 7"
        },
        height: {
            imperial: "9 - 11",
            metric: "23 - 28"
        },
        id: 89,
        name: "Coton de Tulear",
        bred_for: "Accompanying ladies on long sea voyages, ratters onboard ship.",
        breed_group: "Non-Sporting",
        life_span: "13 - 16 years",
        temperament: "Affectionate, Lively, Playful, Intelligent, Trainable, Vocal",
        reference_image_id: "SyviZlqNm",
        image: {
            id: "SyviZlqNm",
            width: 2464,
            height: 1638,
            url: "https://cdn2.thedogapi.com/images/SyviZlqNm.jpg"
        }
    },
    {
        weight: {
            imperial: "50 - 55",
            metric: "23 - 25"
        },
        height: {
            imperial: "19 - 23",
            metric: "48 - 58"
        },
        id: 92,
        name: "Dalmatian",
        bred_for: "Carriage dog - trot alongside carriages to protect the occupants from banditry or other interference",
        breed_group: "Non-Sporting",
        life_span: "10 - 13 years",
        temperament: "Outgoing, Friendly, Energetic, Playful, Sensitive, Intelligent, Active",
        reference_image_id: "SkJ3blcN7",
        image: {
            id: "SkJ3blcN7",
            width: 1200,
            height: 800,
            url: "https://cdn2.thedogapi.com/images/SkJ3blcN7.jpg"
        }
    },
    {
        weight: {
            imperial: "66 - 88",
            metric: "30 - 40"
        },
        height: {
            imperial: "24 - 28",
            metric: "61 - 71"
        },
        id: 94,
        name: "Doberman Pinscher",
        bred_for: "Guardian",
        breed_group: "Working",
        life_span: "10 years",
        temperament: "Fearless, Energetic, Alert, Loyal, Obedient, Confident, Intelligent",
        reference_image_id: "HyL3bl94Q",
        image: {
            id: "HyL3bl94Q",
            width: 1140,
            height: 640,
            url: "https://cdn2.thedogapi.com/images/HyL3bl94Q.jpg"
        }
    },
    {
        weight: {
            imperial: "80 - 100",
            metric: "36 - 45"
        },
        height: {
            imperial: "23.5 - 27",
            metric: "60 - 69"
        },
        id: 95,
        name: "Dogo Argentino",
        bred_for: "Big-game hunting",
        breed_group: "Working",
        life_span: "10 - 12 years",
        temperament: "Friendly, Affectionate, Cheerful, Loyal, Tolerant, Protective",
        reference_image_id: "S1nhWx94Q",
        image: {
            id: "S1nhWx94Q",
            width: 650,
            height: 467,
            url: "https://cdn2.thedogapi.com/images/S1nhWx94Q.jpg"
        }
    },
    {
        weight: {
            imperial: "50 - 70",
            metric: "23 - 32"
        },
        height: {
            imperial: "22 - 24.5",
            metric: "56 - 62"
        },
        id: 98,
        name: "Dutch Shepherd",
        bred_for: "Farms, watchdog, guard duty",
        life_span: "15 years",
        temperament: "Reliable, Affectionate, Alert, Loyal, Obedient, Trainable",
        reference_image_id: "BkE6Wg5E7",
        image: {
            id: "BkE6Wg5E7",
            width: 856,
            height: 511,
            url: "https://cdn2.thedogapi.com/images/BkE6Wg5E7.jpg"
        }
    },
    {
        weight: {
            imperial: "45 - 80",
            metric: "20 - 36"
        },
        height: {
            imperial: "24 - 25",
            metric: "61 - 64"
        },
        id: 101,
        name: "English Setter",
        bred_for: "Bird setting, retrieving",
        breed_group: "Sporting",
        life_span: "12 years",
        temperament: "Strong Willed, Mischievous, Affectionate, Energetic, Playful, Companionable, Gentle, Hard-working, Intelligent, Eager, People-Oriented",
        reference_image_id: "By4A-eqVX",
        image: {
            id: "By4A-eqVX",
            width: 1024,
            height: 683,
            url: "https://cdn2.thedogapi.com/images/By4A-eqVX.jpg"
        }
    },
    {
        weight: {
            imperial: "44 - 66",
            metric: "20 - 30"
        },
        height: {
            imperial: "18 - 23",
            metric: "46 - 58"
        },
        id: 102,
        name: "English Shepherd",
        bred_for: "Herding & guarding livestock, farm watch dog",
        breed_group: "Working",
        life_span: "10 - 13 years",
        temperament: "Kind, Energetic, Independent, Adaptable, Intelligent, Bossy",
        reference_image_id: "H1QyMe5EQ",
        image: {
            id: "H1QyMe5EQ",
            width: 1920,
            height: 1280,
            url: "https://cdn2.thedogapi.com/images/H1QyMe5EQ.jpg"
        }
    },
    {
        weight: {
            imperial: "35 - 50",
            metric: "16 - 23"
        },
        height: {
            imperial: "19 - 20",
            metric: "48 - 51"
        },
        id: 103,
        name: "English Springer Spaniel",
        bred_for: "Bird flushing, retrieving",
        breed_group: "Sporting",
        life_span: "12 - 14 years",
        temperament: "Affectionate, Cheerful, Alert, Intelligent, Attentive, Active",
        reference_image_id: "Hk0Jfe5VQ",
        image: {
            id: "Hk0Jfe5VQ",
            width: 1440,
            height: 1080,
            url: "https://cdn2.thedogapi.com/images/Hk0Jfe5VQ.jpg"
        }
    },
    {
        weight: {
            imperial: "8 - 14",
            metric: "4 - 6"
        },
        height: {
            imperial: "10",
            metric: "25"
        },
        id: 104,
        name: "English Toy Spaniel",
        bred_for: "Companion of kings",
        breed_group: "Toy",
        life_span: "10 - 12 years",
        temperament: "Affectionate, Reserved, Playful, Gentle, Happy, Loving",
        reference_image_id: "SkIgzxqNQ",
        image: {
            id: "SkIgzxqNQ",
            width: 800,
            height: 696,
            url: "https://cdn2.thedogapi.com/images/SkIgzxqNQ.jpg"
        }
    },
    {
        weight: {
            imperial: "6 - 8",
            metric: "3 - 4"
        },
        height: {
            imperial: "10 - 12",
            metric: "25 - 30"
        },
        id: 105,
        name: "English Toy Terrier",
        bred_for: "Rat-baiting",
        life_span: "12 - 13 years",
        temperament: "Stubborn, Alert, Companionable, Intelligent, Cunning, Trainable",
        reference_image_id: "SJ6eMxqEQ",
        image: {
            id: "SJ6eMxqEQ",
            width: 645,
            height: 430,
            url: "https://cdn2.thedogapi.com/images/SJ6eMxqEQ.jpg"
        }
    },
    {
        weight: {
            imperial: "40 - 70",
            metric: "18 - 32"
        },
        height: {
            imperial: "20.5 - 23.5",
            metric: "52 - 60"
        },
        id: 107,
        name: "Eurasier",
        bred_for: "Companionship",
        breed_group: "Non-Sporting",
        life_span: "12 - 14 years",
        temperament: "Alert, Reserved, Intelligent, Even Tempered, Watchful, Calm",
        reference_image_id: "S1VWGx9Nm",
        image: {
            id: "S1VWGx9Nm",
            width: 800,
            height: 532,
            url: "https://cdn2.thedogapi.com/images/S1VWGx9Nm.jpg"
        }
    },
    {
        weight: {
            imperial: "35 - 50",
            metric: "16 - 23"
        },
        height: {
            imperial: "17 - 18",
            metric: "43 - 46"
        },
        id: 108,
        name: "Field Spaniel",
        bred_for: "Bird flushing, retrieving",
        breed_group: "Sporting",
        life_span: "11 - 15 years",
        temperament: "Docile, Cautious, Sociable, Sensitive, Adaptable, Familial",
        reference_image_id: "SkJfGecE7",
        image: {
            id: "SkJfGecE7",
            width: 1280,
            height: 906,
            url: "https://cdn2.thedogapi.com/images/SkJfGecE7.jpg"
        }
    },
    {
        weight: {
            imperial: "33 - 53",
            metric: "15 - 24"
        },
        height: {
            imperial: "16 - 21",
            metric: "41 - 53"
        },
        id: 110,
        name: "Finnish Lapphund",
        bred_for: "Herding reindeer",
        breed_group: "Herding",
        life_span: "12 - 15 years",
        temperament: "Friendly, Keen, Faithful, Calm, Courageous",
        reference_image_id: "S1KMGg5Vm",
        image: {
            id: "S1KMGg5Vm",
            width: 1066,
            height: 800,
            url: "https://cdn2.thedogapi.com/images/S1KMGg5Vm.jpg"
        }
    },
    {
        weight: {
            imperial: "23 - 28",
            metric: "10 - 13"
        },
        height: {
            imperial: "15.5 - 20",
            metric: "39 - 51"
        },
        id: 111,
        name: "Finnish Spitz",
        bred_for: "Hunting birds, small mammals",
        breed_group: "Non-Sporting",
        life_span: "12 - 15 years",
        temperament: "Playful, Loyal, Independent, Intelligent, Happy, Vocal",
        reference_image_id: "3PjHlQbkV",
        image: {
            id: "3PjHlQbkV",
            width: 500,
            height: 417,
            url: "https://cdn2.thedogapi.com/images/3PjHlQbkV.jpg"
        }
    },
    {
        weight: {
            imperial: "28",
            metric: "13"
        },
        height: {
            imperial: "11 - 12",
            metric: "28 - 30"
        },
        id: 113,
        name: "French Bulldog",
        bred_for: "Lapdog",
        breed_group: "Non-Sporting",
        life_span: "9 - 11 years",
        temperament: "Playful, Affectionate, Keen, Sociable, Lively, Alert, Easygoing, Patient, Athletic, Bright",
        reference_image_id: "HyWNfxc47",
        image: {
            id: "HyWNfxc47",
            width: 740,
            height: 430,
            url: "https://cdn2.thedogapi.com/images/HyWNfxc47.jpg"
        }
    },
    {
        weight: {
            imperial: "25 - 45",
            metric: "11 - 20"
        },
        height: {
            imperial: "17 - 20",
            metric: "43 - 51"
        },
        id: 114,
        name: "German Pinscher",
        bred_for: "Watchdog, Hunting vermin on the farm.",
        breed_group: "Working",
        life_span: "12 - 14 years",
        temperament: "Spirited, Lively, Intelligent, Loving, Even Tempered, Familial",
        reference_image_id: "B1u4zgqE7",
        image: {
            id: "B1u4zgqE7",
            width: 740,
            height: 480,
            url: "https://cdn2.thedogapi.com/images/B1u4zgqE7.jpg"
        }
    },
    {
        weight: {
            imperial: "50 - 90",
            metric: "23 - 41"
        },
        height: {
            imperial: "22 - 26",
            metric: "56 - 66"
        },
        id: 115,
        name: "German Shepherd Dog",
        bred_for: "Herding, Guard dog",
        breed_group: "Herding",
        life_span: "10 - 13 years",
        temperament: "Alert, Loyal, Obedient, Curious, Confident, Intelligent, Watchful, Courageous",
        reference_image_id: "SJyBfg5NX",
        image: {
            id: "SJyBfg5NX",
            width: 600,
            height: 425,
            url: "https://cdn2.thedogapi.com/images/SJyBfg5NX.jpg"
        }
    },
    {
        weight: {
            imperial: "45 - 70",
            metric: "20 - 32"
        },
        height: {
            imperial: "21 - 25",
            metric: "53 - 64"
        },
        id: 116,
        name: "German Shorthaired Pointer",
        bred_for: "General hunting",
        breed_group: "Sporting",
        life_span: "12 - 14 years",
        temperament: "Boisterous, Bold, Affectionate, Intelligent, Cooperative, Trainable",
        reference_image_id: "SJqBMg5Nm",
        image: {
            id: "SJqBMg5Nm",
            width: 1395,
            height: 1230,
            url: "https://cdn2.thedogapi.com/images/SJqBMg5Nm.jpg"
        }
    },
    {
        weight: {
            imperial: "65 - 90",
            metric: "29 - 41"
        },
        height: {
            imperial: "23.5 - 27.5",
            metric: "60 - 70"
        },
        id: 119,
        name: "Giant Schnauzer",
        bred_for: "Herding, guarding",
        breed_group: "Working",
        life_span: "10 - 12 years",
        temperament: "Strong Willed, Kind, Loyal, Intelligent, Dominant, Powerful",
        reference_image_id: "H1NIzlcV7",
        image: {
            id: "H1NIzlcV7",
            width: 900,
            height: 600,
            url: "https://cdn2.thedogapi.com/images/H1NIzlcV7.jpg"
        }
    },
    {
        weight: {
            imperial: "32 - 40",
            metric: "15 - 18"
        },
        height: {
            imperial: "12.5 - 14",
            metric: "32 - 36"
        },
        id: 120,
        name: "Glen of Imaal Terrier",
        bred_for: "Rid the home and farm of vermin, and hunt badger and fox",
        breed_group: "Terrier",
        life_span: "12 - 15 years",
        temperament: "Spirited, Agile, Loyal, Gentle, Active, Courageous",
        reference_image_id: "H1oLMe94m",
        image: {
            id: "H1oLMe94m",
            width: 645,
            height: 380,
            url: "https://cdn2.thedogapi.com/images/H1oLMe94m.jpg"
        }
    },
    {
        weight: {
            imperial: "55 - 75",
            metric: "25 - 34"
        },
        height: {
            imperial: "21.5 - 24",
            metric: "55 - 61"
        },
        id: 121,
        name: "Golden Retriever",
        bred_for: "Retrieving",
        breed_group: "Sporting",
        life_span: "10 - 12 years",
        temperament: "Intelligent, Kind, Reliable, Friendly, Trustworthy, Confident",
        reference_image_id: "HJ7Pzg5EQ",
        image: {
            id: "HJ7Pzg5EQ",
            width: 900,
            height: 652,
            url: "https://cdn2.thedogapi.com/images/HJ7Pzg5EQ.jpg"
        }
    },
    {
        weight: {
            imperial: "45 - 80",
            metric: "20 - 36"
        },
        height: {
            imperial: "23 - 27",
            metric: "58 - 69"
        },
        id: 123,
        name: "Gordon Setter",
        bred_for: "Find and point gamebirds",
        breed_group: "Sporting",
        life_span: "10 - 12 years",
        temperament: "Fearless, Alert, Loyal, Confident, Gay, Eager",
        reference_image_id: "SJ5vzx5NX",
        image: {
            id: "SJ5vzx5NX",
            width: 622,
            height: 467,
            url: "https://cdn2.thedogapi.com/images/SJ5vzx5NX.jpg"
        }
    },
    {
        weight: {
            imperial: "110 - 190",
            metric: "50 - 86"
        },
        height: {
            imperial: "28 - 32",
            metric: "71 - 81"
        },
        id: 124,
        name: "Great Dane",
        bred_for: "Hunting & holding boars, Guardian",
        breed_group: "Working",
        life_span: "7 - 10 years",
        temperament: "Friendly, Devoted, Reserved, Gentle, Confident, Loving",
        reference_image_id: "B1Edfl9NX",
        image: {
            id: "B1Edfl9NX",
            width: 800,
            height: 732,
            url: "https://cdn2.thedogapi.com/images/B1Edfl9NX.jpg"
        }
    },
    {
        weight: {
            imperial: "85 - 115",
            metric: "39 - 52"
        },
        height: {
            imperial: "25 - 32",
            metric: "64 - 81"
        },
        id: 125,
        name: "Great Pyrenees",
        bred_for: "Sheep guardian",
        breed_group: "Working",
        life_span: "10 - 12 years",
        temperament: "Strong Willed, Fearless, Affectionate, Patient, Gentle, Confident",
        reference_image_id: "B12uzg9V7",
        image: {
            id: "B12uzg9V7",
            width: 800,
            height: 550,
            url: "https://cdn2.thedogapi.com/images/B12uzg9V7.png"
        }
    },
    {
        weight: {
            imperial: "50 - 70",
            metric: "23 - 32"
        },
        height: {
            imperial: "27 - 30",
            metric: "69 - 76"
        },
        id: 127,
        name: "Greyhound",
        bred_for: "Coursing hares",
        breed_group: "Hound",
        life_span: "10 - 13 years",
        temperament: "Affectionate, Athletic, Gentle, Intelligent, Quiet, Even Tempered",
        reference_image_id: "ryNYMx94X",
        image: {
            id: "ryNYMx94X",
            width: 1024,
            height: 681,
            url: "https://cdn2.thedogapi.com/images/ryNYMx94X.jpg"
        }
    },
    {
        weight: {
            imperial: "12",
            metric: "5"
        },
        height: {
            imperial: "9 - 11",
            metric: "23 - 28"
        },
        id: 128,
        name: "Griffon Bruxellois",
        bred_for: "Hunt and kill vermin in stables",
        life_span: "10 \u2013 15 years",
        temperament: "Self-important, Inquisitive, Alert, Companionable, Sensitive, Watchful",
        reference_image_id: "ryoYGec4Q",
        image: {
            id: "ryoYGec4Q",
            width: 645,
            height: 380,
            url: "https://cdn2.thedogapi.com/images/ryoYGec4Q.jpg"
        }
    },
    {
        weight: {
            imperial: "40 - 60",
            metric: "18 - 27"
        },
        height: {
            imperial: "18 - 22",
            metric: "46 - 56"
        },
        id: 129,
        name: "Harrier",
        bred_for: "Hunting hares by trailing them",
        breed_group: "Hound",
        life_span: "12 - 15 years",
        temperament: "Outgoing, Friendly, Cheerful, Sweet-Tempered, Tolerant, Active",
        reference_image_id: "B1IcfgqE7",
        image: {
            id: "B1IcfgqE7",
            width: 1920,
            height: 1080,
            url: "https://cdn2.thedogapi.com/images/B1IcfgqE7.jpg"
        }
    },
    {
        weight: {
            imperial: "7 - 13",
            metric: "3 - 6"
        },
        height: {
            imperial: "8.5 - 11.5",
            metric: "22 - 29"
        },
        id: 130,
        name: "Havanese",
        bred_for: "Companionship",
        breed_group: "Toy",
        life_span: "14 - 15 years",
        temperament: "Affectionate, Responsive, Playful, Companionable, Gentle, Intelligent",
        reference_image_id: "rkXiGl9V7",
        image: {
            id: "rkXiGl9V7",
            width: 800,
            height: 507,
            url: "https://cdn2.thedogapi.com/images/rkXiGl9V7.jpg"
        }
    },
    {
        weight: {
            imperial: "35 - 70",
            metric: "16 - 32"
        },
        height: {
            imperial: "24 - 27",
            metric: "61 - 69"
        },
        id: 134,
        name: "Irish Setter",
        bred_for: "Bird setting, retrieving",
        breed_group: "Sporting",
        life_span: "10 - 11 years",
        temperament: "Affectionate, Energetic, Lively, Independent, Playful, Companionable",
        reference_image_id: "S1osGeqVm",
        image: {
            id: "S1osGeqVm",
            width: 818,
            height: 522,
            url: "https://cdn2.thedogapi.com/images/S1osGeqVm.jpg"
        }
    },
    {
        weight: {
            imperial: "25 - 27",
            metric: "11 - 12"
        },
        height: {
            imperial: "18",
            metric: "46"
        },
        id: 135,
        name: "Irish Terrier",
        breed_group: "Terrier",
        life_span: "12 - 16 years",
        temperament: "Respectful, Lively, Intelligent, Dominant, Protective, Trainable",
        reference_image_id: "By-hGecVX",
        image: {
            id: "By-hGecVX",
            width: 800,
            height: 626,
            url: "https://cdn2.thedogapi.com/images/By-hGecVX.jpg"
        }
    },
    {
        weight: {
            imperial: "105 - 180",
            metric: "48 - 82"
        },
        height: {
            imperial: "30 - 35",
            metric: "76 - 89"
        },
        id: 137,
        name: "Irish Wolfhound",
        bred_for: "Coursing wolves, elk",
        breed_group: "Hound",
        life_span: "6 - 8 years",
        temperament: "Sweet-Tempered, Loyal, Dignified, Patient, Thoughtful, Generous",
        reference_image_id: "Hyd2zgcEX",
        image: {
            id: "Hyd2zgcEX",
            width: 1000,
            height: 630,
            url: "https://cdn2.thedogapi.com/images/Hyd2zgcEX.jpg"
        }
    },
    {
        weight: {
            imperial: "7 - 15",
            metric: "3 - 7"
        },
        height: {
            imperial: "13 - 15",
            metric: "33 - 38"
        },
        id: 138,
        name: "Italian Greyhound",
        bred_for: "Lapdog",
        breed_group: "Toy",
        life_span: "12 - 15 years",
        temperament: "Mischievous, Affectionate, Agile, Athletic, Companionable, Intelligent",
        reference_image_id: "SJAnzg9NX",
        image: {
            id: "SJAnzg9NX",
            width: 640,
            height: 377,
            url: "https://cdn2.thedogapi.com/images/SJAnzg9NX.jpg"
        }
    },
    {
        weight: {
            imperial: "4 - 9",
            metric: "2 - 4"
        },
        height: {
            imperial: "8 - 11",
            metric: "20 - 28"
        },
        id: 140,
        name: "Japanese Chin",
        bred_for: "Lapdog",
        breed_group: "Toy",
        life_span: "12 - 14 years",
        temperament: "Alert, Loyal, Independent, Intelligent, Loving, Cat-like",
        reference_image_id: "r1H6feqEm",
        image: {
            id: "r1H6feqEm",
            width: 900,
            height: 581,
            url: "https://cdn2.thedogapi.com/images/r1H6feqEm.jpg"
        }
    },
    {
        weight: {
            imperial: "15 - 19",
            metric: "7 - 9"
        },
        height: {
            imperial: "12 - 15",
            metric: "30 - 38"
        },
        id: 141,
        name: "Japanese Spitz",
        bred_for: "Companion",
        life_span: "10 \u2013 16 years",
        temperament: "Affectionate, Obedient, Playful, Companionable, Intelligent, Proud",
        reference_image_id: "HksaMxqNX",
        image: {
            id: "HksaMxqNX",
            width: 600,
            height: 351,
            url: "https://cdn2.thedogapi.com/images/HksaMxqNX.jpg"
        }
    },
    {
        weight: {
            imperial: "35 - 45",
            metric: "16 - 20"
        },
        height: {
            imperial: "17 - 18",
            metric: "43 - 46"
        },
        id: 142,
        name: "Keeshond",
        bred_for: "Barge watchdog",
        breed_group: "Non-Sporting",
        life_span: "12 - 15 years",
        temperament: "Agile, Obedient, Playful, Quick, Sturdy, Bright",
        reference_image_id: "S1GAGg9Vm",
        image: {
            id: "S1GAGg9Vm",
            width: 1024,
            height: 683,
            url: "https://cdn2.thedogapi.com/images/S1GAGg9Vm.jpg"
        }
    },
    {
        weight: {
            imperial: "80 - 100",
            metric: "36 - 45"
        },
        height: {
            imperial: "25.5 - 27.5",
            metric: "65 - 70"
        },
        id: 144,
        name: "Komondor",
        bred_for: "Sheep guardian",
        breed_group: "Working",
        life_span: "10 - 12 years",
        temperament: "Steady, Fearless, Affectionate, Independent, Gentle, Calm",
        reference_image_id: "Bko0fl547",
        image: {
            id: "Bko0fl547",
            width: 1030,
            height: 772,
            url: "https://cdn2.thedogapi.com/images/Bko0fl547.jpg"
        }
    },
    {
        weight: {
            imperial: "20 - 30",
            metric: "9 - 14"
        },
        height: {
            imperial: "14 - 16",
            metric: "36 - 41"
        },
        id: 145,
        name: "Kooikerhondje",
        bred_for: 'Luring ducks into traps - "tolling"',
        breed_group: "Sporting",
        life_span: "12 - 15 years",
        temperament: "Benevolent, Agile, Alert, Intelligent, Active, Territorial",
        reference_image_id: "kOMy84GQE",
        image: {
            id: "kOMy84GQE",
            width: 1080,
            height: 1080,
            url: "https://cdn2.thedogapi.com/images/kOMy84GQE.jpg"
        }
    },
    {
        weight: {
            imperial: "70 - 115",
            metric: "32 - 52"
        },
        height: {
            imperial: "26 - 30",
            metric: "66 - 76"
        },
        id: 147,
        name: "Kuvasz",
        bred_for: "Guardian, hunting large game",
        breed_group: "Working",
        life_span: "8 - 10 years",
        temperament: "Clownish, Loyal, Patient, Independent, Intelligent, Protective",
        reference_image_id: "BykZ7ecVX",
        image: {
            id: "BykZ7ecVX",
            width: 960,
            height: 768,
            url: "https://cdn2.thedogapi.com/images/BykZ7ecVX.jpg"
        }
    },
    {
        weight: {
            imperial: "55 - 80",
            metric: "25 - 36"
        },
        height: {
            imperial: "21.5 - 24.5",
            metric: "55 - 62"
        },
        id: 149,
        name: "Labrador Retriever",
        bred_for: "Water retrieving",
        breed_group: "Sporting",
        life_span: "10 - 13 years",
        temperament: "Kind, Outgoing, Agile, Gentle, Intelligent, Trusting, Even Tempered",
        reference_image_id: "B1uW7l5VX",
        image: {
            id: "B1uW7l5VX",
            width: 992,
            height: 667,
            url: "https://cdn2.thedogapi.com/images/B1uW7l5VX.jpg"
        }
    },
    {
        weight: {
            imperial: "24 - 35",
            metric: "11 - 16"
        },
        height: {
            imperial: "16 - 19",
            metric: "41 - 48"
        },
        id: 151,
        name: "Lagotto Romagnolo",
        bred_for: "Water retrieval dog in the marshes of Romagna",
        breed_group: "Sporting",
        life_span: "14 - 16 years",
        temperament: "Keen, Loyal, Companionable, Loving, Active, Trainable",
        reference_image_id: "ryzzmgqE7",
        image: {
            id: "ryzzmgqE7",
            width: 1600,
            height: 1200,
            url: "https://cdn2.thedogapi.com/images/ryzzmgqE7.jpg"
        }
    },
    {
        weight: {
            imperial: "6 - 13",
            metric: "3 - 6"
        },
        height: {
            imperial: "10 - 12",
            metric: "25 - 30"
        },
        id: 153,
        name: "Lancashire Heeler",
        bred_for: "Cattle herding, Ratting, Driving cattle to market.",
        life_span: "12 \u2013 15 years",
        temperament: "Clever, Friendly, Alert, Intelligent",
        reference_image_id: "S1RGml5Em",
        image: {
            id: "S1RGml5Em",
            width: 680,
            height: 453,
            url: "https://cdn2.thedogapi.com/images/S1RGml5Em.jpg"
        }
    },
    {
        weight: {
            imperial: "120 - 170",
            metric: "54 - 77"
        },
        height: {
            imperial: "25.5 - 31.5",
            metric: "65 - 80"
        },
        id: 155,
        name: "Leonberger",
        bred_for: "Guardian, appearance.",
        breed_group: "Working",
        life_span: "6 - 8 years",
        temperament: "Obedient, Fearless, Loyal, Companionable, Adaptable, Loving",
        reference_image_id: "ByrmQlqVm",
        image: {
            id: "ByrmQlqVm",
            width: 1024,
            height: 694,
            url: "https://cdn2.thedogapi.com/images/ByrmQlqVm.jpg"
        }
    },
    {
        weight: {
            imperial: "12 - 18",
            metric: "5 - 8"
        },
        height: {
            imperial: "10 - 11",
            metric: "25 - 28"
        },
        id: 156,
        name: "Lhasa Apso",
        bred_for: "Guarding inside the home, companion",
        breed_group: "Non-Sporting",
        life_span: "12 - 15 years",
        temperament: "Steady, Fearless, Friendly, Devoted, Assertive, Spirited, Energetic, Lively, Alert, Obedient, Playful, Intelligent",
        reference_image_id: "SJp7Qe5EX",
        image: {
            id: "SJp7Qe5EX",
            width: 680,
            height: 444,
            url: "https://cdn2.thedogapi.com/images/SJp7Qe5EX.jpg"
        }
    },
    {
        weight: {
            imperial: "4 - 7",
            metric: "2 - 3"
        },
        height: {
            imperial: "8 - 10",
            metric: "20 - 25"
        },
        id: 161,
        name: "Maltese",
        bred_for: "Lapdog",
        breed_group: "Toy",
        life_span: "15 - 18 years",
        temperament: "Playful, Docile, Fearless, Affectionate, Sweet-Tempered, Lively, Responsive, Easygoing, Gentle, Intelligent, Active",
        reference_image_id: "B1SV7gqN7",
        image: {
            id: "B1SV7gqN7",
            width: 680,
            height: 453,
            url: "https://cdn2.thedogapi.com/images/B1SV7gqN7.jpg"
        }
    },
    {
        weight: {
            imperial: "20 - 40",
            metric: "9 - 18"
        },
        height: {
            imperial: "13 - 18",
            metric: "33 - 46"
        },
        id: 165,
        name: "Miniature American Shepherd",
        breed_group: "Herding",
        life_span: "12 - 15 years",
        temperament: "Energetic, Loyal, Intelligent, Trainable",
        reference_image_id: "BkHHQgcN7",
        image: {
            id: "BkHHQgcN7",
            width: 920,
            height: 640,
            url: "https://cdn2.thedogapi.com/images/BkHHQgcN7.jpg"
        }
    },
    {
        weight: {
            imperial: "8 - 11",
            metric: "4 - 5"
        },
        height: {
            imperial: "10 - 12.5",
            metric: "25 - 32"
        },
        id: 167,
        name: "Miniature Pinscher",
        bred_for: "Small vermin hunting",
        breed_group: "Toy",
        life_span: "15 years",
        temperament: "Clever, Outgoing, Friendly, Energetic, Responsive, Playful",
        reference_image_id: "Hy3H7g94X",
        image: {
            id: "Hy3H7g94X",
            width: 1500,
            height: 1125,
            url: "https://cdn2.thedogapi.com/images/Hy3H7g94X.jpg"
        }
    },
    {
        weight: {
            imperial: "11 - 20",
            metric: "5 - 9"
        },
        height: {
            imperial: "12 - 14",
            metric: "30 - 36"
        },
        id: 168,
        name: "Miniature Schnauzer",
        bred_for: "Ratting",
        breed_group: "Terrier",
        life_span: "12 - 14 years",
        temperament: "Fearless, Friendly, Spirited, Alert, Obedient, Intelligent",
        reference_image_id: "SJIUQl9NX",
        image: {
            id: "SJIUQl9NX",
            width: 800,
            height: 533,
            url: "https://cdn2.thedogapi.com/images/SJIUQl9NX.jpg"
        }
    },
    {
        weight: {
            imperial: "100 - 150",
            metric: "45 - 68"
        },
        height: {
            imperial: "26 - 28",
            metric: "66 - 71"
        },
        id: 171,
        name: "Newfoundland",
        bred_for: "All purpose water dog, fishing aid",
        breed_group: "Working",
        life_span: "8 - 10 years",
        temperament: "Sweet-Tempered, Gentle, Trainable",
        reference_image_id: "Sk4DXl54m",
        image: {
            id: "Sk4DXl54m",
            width: 1174,
            height: 986,
            url: "https://cdn2.thedogapi.com/images/Sk4DXl54m.jpg"
        }
    },
    {
        weight: {
            imperial: "11 - 12",
            metric: "5 - 5"
        },
        height: {
            imperial: "9 - 10",
            metric: "23 - 25"
        },
        id: 172,
        name: "Norfolk Terrier",
        bred_for: "Ratting, fox bolting",
        breed_group: "Terrier",
        life_span: "12 - 15 years",
        temperament: "Self-confidence, Fearless, Spirited, Companionable, Happy, Lovable",
        reference_image_id: "B1ADQg94X",
        image: {
            id: "B1ADQg94X",
            width: 1468,
            height: 1092,
            url: "https://cdn2.thedogapi.com/images/B1ADQg94X.jpg"
        }
    },
    {
        weight: {
            imperial: "11 - 12",
            metric: "5 - 5"
        },
        height: {
            imperial: "10",
            metric: "25"
        },
        id: 176,
        name: "Norwich Terrier",
        bred_for: "Ratting, fox bolting",
        breed_group: "Terrier",
        life_span: "12 - 15 years",
        temperament: "Hardy, Affectionate, Energetic, Sensitive, Intelligent",
        reference_image_id: "BkgKXlqE7",
        image: {
            id: "BkgKXlqE7",
            width: 1140,
            height: 640,
            url: "https://cdn2.thedogapi.com/images/BkgKXlqE7.jpg"
        }
    },
    {
        weight: {
            imperial: "35 - 50",
            metric: "16 - 23"
        },
        height: {
            imperial: "17 - 21",
            metric: "43 - 53"
        },
        id: 177,
        name: "Nova Scotia Duck Tolling Retriever",
        breed_group: "Sporting",
        life_span: "12 - 14 years",
        temperament: "Outgoing, Alert, Patient, Intelligent, Loving",
        reference_image_id: "SyYtQe5V7",
        image: {
            id: "SyYtQe5V7",
            width: 630,
            height: 420,
            url: "https://cdn2.thedogapi.com/images/SyYtQe5V7.jpg"
        }
    },
    {
        weight: {
            imperial: "60 - 100",
            metric: "27 - 45"
        },
        height: {
            imperial: "21",
            metric: "53"
        },
        id: 178,
        name: "Old English Sheepdog",
        bred_for: "Driving sheep, cattle",
        breed_group: "Herding",
        life_span: "10 - 12 years",
        temperament: "Sociable, Bubbly, Playful, Adaptable, Intelligent, Loving",
        reference_image_id: "HkZ57lq4m",
        image: {
            id: "HkZ57lq4m",
            width: 1334,
            height: 889,
            url: "https://cdn2.thedogapi.com/images/HkZ57lq4m.jpg"
        }
    },
    {
        weight: {
            imperial: "65 \u2013 85",
            metric: "NaN"
        },
        height: {
            imperial: "15 - 19",
            metric: "38 - 48"
        },
        id: 179,
        name: "Olde English Bulldogge",
        life_span: "9 \u2013 14 years",
        temperament: "Friendly, Alert, Confident, Loving, Courageous, Strong",
        reference_image_id: "B1d5me547",
        image: {
            id: "B1d5me547",
            width: 554,
            height: 546,
            url: "https://cdn2.thedogapi.com/images/B1d5me547.jpg"
        }
    },
    {
        weight: {
            imperial: "3 - 12",
            metric: "1 - 5"
        },
        height: {
            imperial: "8 - 11",
            metric: "20 - 28"
        },
        id: 181,
        name: "Papillon",
        bred_for: "Lapdog",
        breed_group: "Toy",
        life_span: "13 - 17 years",
        temperament: "Hardy, Friendly, Energetic, Alert, Intelligent, Happy",
        reference_image_id: "SkJj7e547",
        image: {
            id: "SkJj7e547",
            width: 960,
            height: 765,
            url: "https://cdn2.thedogapi.com/images/SkJj7e547.jpg"
        }
    },
    {
        weight: {
            imperial: "14",
            metric: "6"
        },
        height: {
            imperial: "6 - 9",
            metric: "15 - 23"
        },
        id: 183,
        name: "Pekingese",
        bred_for: "Lapdog",
        breed_group: "Toy",
        life_span: "14 - 18 years",
        temperament: "Opinionated, Good-natured, Stubborn, Affectionate, Aggressive, Intelligent",
        reference_image_id: "ByIiml9Nm",
        image: {
            id: "ByIiml9Nm",
            width: 960,
            height: 640,
            url: "https://cdn2.thedogapi.com/images/ByIiml9Nm.jpg"
        }
    },
    {
        weight: {
            imperial: "25 - 30",
            metric: "11 - 14"
        },
        height: {
            imperial: "10 - 12",
            metric: "25 - 30"
        },
        id: 184,
        name: "Pembroke Welsh Corgi",
        bred_for: "Driving stock to market in northern Wales",
        breed_group: "Herding",
        life_span: "12 - 14 years",
        temperament: "Tenacious, Outgoing, Friendly, Bold, Playful, Protective",
        reference_image_id: "rJ6iQeqEm",
        image: {
            id: "rJ6iQeqEm",
            width: 1280,
            height: 720,
            url: "https://cdn2.thedogapi.com/images/rJ6iQeqEm.jpg"
        }
    },
    {
        weight: {
            imperial: "88 - 110",
            metric: "40 - 50"
        },
        height: {
            imperial: "22 - 25.5",
            metric: "56 - 65"
        },
        id: 185,
        name: "Perro de Presa Canario",
        breed_group: "Working",
        life_span: "10 - 12 years",
        temperament: "Strong Willed, Suspicious, Gentle, Dominant, Calm",
        reference_image_id: "S1V3Qeq4X",
        image: {
            id: "S1V3Qeq4X",
            width: 600,
            height: 483,
            url: "https://cdn2.thedogapi.com/images/S1V3Qeq4X.jpg"
        }
    },
    {
        weight: {
            imperial: "40 - 60",
            metric: "18 - 27"
        },
        height: {
            imperial: "21 - 25",
            metric: "53 - 64"
        },
        id: 188,
        name: "Pharaoh Hound",
        bred_for: "Hunting rabbits",
        breed_group: "Hound",
        life_span: "12 - 14 years",
        temperament: "Affectionate, Sociable, Playful, Intelligent, Active, Trainable",
        reference_image_id: "Byz6mgqEQ",
        image: {
            id: "Byz6mgqEQ",
            width: 3918,
            height: 2938,
            url: "https://cdn2.thedogapi.com/images/Byz6mgqEQ.jpg"
        }
    },
    {
        weight: {
            imperial: "40 - 60",
            metric: "18 - 27"
        },
        height: {
            imperial: "20 - 25",
            metric: "51 - 64"
        },
        id: 189,
        name: "Plott",
        bred_for: "Hunting big-game like Boar.",
        breed_group: "Hound",
        life_span: "12 - 14 years",
        temperament: "Bold, Alert, Loyal, Intelligent",
        reference_image_id: "B1i67l5VQ",
        image: {
            id: "B1i67l5VQ",
            width: 640,
            height: 480,
            url: "https://cdn2.thedogapi.com/images/B1i67l5VQ.jpg"
        }
    },
    {
        weight: {
            imperial: "3 - 7",
            metric: "1 - 3"
        },
        height: {
            imperial: "8 - 12",
            metric: "20 - 30"
        },
        id: 193,
        name: "Pomeranian",
        bred_for: "Companion",
        breed_group: "Toy",
        life_span: "15 years",
        temperament: "Extroverted, Friendly, Sociable, Playful, Intelligent, Active",
        reference_image_id: "HJd0XecNX",
        image: {
            id: "HJd0XecNX",
            width: 800,
            height: 532,
            url: "https://cdn2.thedogapi.com/images/HJd0XecNX.jpg"
        }
    },
    {
        weight: {
            imperial: "15 - 17",
            metric: "7 - 8"
        },
        height: {
            imperial: "11 - 15",
            metric: "28 - 38"
        },
        id: 196,
        name: "Poodle (Miniature)",
        life_span: "12 \u2013 15 years",
        reference_image_id: "Hkxk4ecVX",
        image: {
            id: "Hkxk4ecVX",
            width: 1280,
            height: 853,
            url: "https://cdn2.thedogapi.com/images/Hkxk4ecVX.jpg"
        }
    },
    {
        weight: {
            imperial: "6 - 9",
            metric: "3 - 4"
        },
        height: {
            imperial: "9 - 11",
            metric: "23 - 28"
        },
        id: 197,
        name: "Poodle (Toy)",
        life_span: "18 years",
        reference_image_id: "rJFJVxc4m",
        image: {
            id: "rJFJVxc4m",
            width: 620,
            height: 403,
            url: "https://cdn2.thedogapi.com/images/rJFJVxc4m.jpg"
        }
    },
    {
        weight: {
            imperial: "14 - 18",
            metric: "6 - 8"
        },
        height: {
            imperial: "10 - 12",
            metric: "25 - 30"
        },
        id: 201,
        name: "Pug",
        bred_for: "Lapdog",
        breed_group: "Toy",
        life_span: "12 - 14 years",
        temperament: "Docile, Clever, Charming, Stubborn, Sociable, Playful, Quiet, Attentive",
        reference_image_id: "HyJvcl9N7",
        image: {
            id: "HyJvcl9N7",
            width: 800,
            height: 600,
            url: "https://cdn2.thedogapi.com/images/HyJvcl9N7.jpg"
        }
    },
    {
        weight: {
            imperial: "25 - 35",
            metric: "11 - 16"
        },
        height: {
            imperial: "16 - 17",
            metric: "41 - 43"
        },
        id: 204,
        name: "Puli",
        bred_for: "Herding",
        breed_group: "Herding",
        life_span: "12 - 16 Years years",
        temperament: "Energetic, Agile, Loyal, Obedient, Intelligent, Faithful",
        reference_image_id: "ryPgVl5N7",
        image: {
            id: "ryPgVl5N7",
            width: 1199,
            height: 829,
            url: "https://cdn2.thedogapi.com/images/ryPgVl5N7.jpg"
        }
    },
    {
        weight: {
            imperial: "18 - 33",
            metric: "8 - 15"
        },
        height: {
            imperial: "15 - 18.5",
            metric: "38 - 47"
        },
        id: 205,
        name: "Pumi",
        breed_group: "Herding",
        life_span: "13 - 15 years",
        temperament: "Lively, Reserved, Intelligent, Active, Protective, Vocal",
        reference_image_id: "SyRe4xcN7",
        image: {
            id: "SyRe4xcN7",
            width: 695,
            height: 391,
            url: "https://cdn2.thedogapi.com/images/SyRe4xcN7.jpg"
        }
    },
    {
        weight: {
            imperial: "8 - 25",
            metric: "4 - 11"
        },
        height: {
            imperial: "10 - 13",
            metric: "25 - 33"
        },
        id: 207,
        name: "Rat Terrier",
        breed_group: "Terrier",
        life_span: "12 - 18 years",
        temperament: "Affectionate, Lively, Inquisitive, Alert, Intelligent, Loving",
        reference_image_id: "HkXWNl9E7",
        image: {
            id: "HkXWNl9E7",
            width: 825,
            height: 689,
            url: "https://cdn2.thedogapi.com/images/HkXWNl9E7.jpg"
        }
    },
    {
        weight: {
            imperial: "45 - 80",
            metric: "20 - 36"
        },
        height: {
            imperial: "21 - 27",
            metric: "53 - 69"
        },
        id: 208,
        name: "Redbone Coonhound",
        bred_for: "Hunting raccoon, deer, bear, and cougar.",
        breed_group: "Hound",
        life_span: "10 - 12 years",
        temperament: "Affectionate, Energetic, Independent, Companionable, Familial, Unflappable",
        reference_image_id: "HJMzEl5N7",
        image: {
            id: "HJMzEl5N7",
            width: 1537,
            height: 1323,
            url: "https://cdn2.thedogapi.com/images/HJMzEl5N7.jpg"
        }
    },
    {
        weight: {
            imperial: "75 - 80",
            metric: "34 - 36"
        },
        height: {
            imperial: "24 - 27",
            metric: "61 - 69"
        },
        id: 209,
        name: "Rhodesian Ridgeback",
        bred_for: "Big game hunting, guarding",
        breed_group: "Hound",
        life_span: "10 - 12 years",
        temperament: "Strong Willed, Mischievous, Loyal, Dignified, Sensitive, Intelligent",
        reference_image_id: "By9zNgqE7",
        image: {
            id: "By9zNgqE7",
            width: 1000,
            height: 667,
            url: "https://cdn2.thedogapi.com/images/By9zNgqE7.jpg"
        }
    },
    {
        weight: {
            imperial: "75 - 110",
            metric: "34 - 50"
        },
        height: {
            imperial: "22 - 27",
            metric: "56 - 69"
        },
        id: 210,
        name: "Rottweiler",
        bred_for: "Cattle drover, guardian, draft",
        breed_group: "Working",
        life_span: "8 - 10 years",
        temperament: "Steady, Good-natured, Fearless, Devoted, Alert, Obedient, Confident, Self-assured, Calm, Courageous",
        reference_image_id: "r1xXEgcNX",
        image: {
            id: "r1xXEgcNX",
            width: 736,
            height: 595,
            url: "https://cdn2.thedogapi.com/images/r1xXEgcNX.jpg"
        }
    },
    {
        weight: {
            imperial: "3 - 6",
            metric: "1 - 3"
        },
        height: {
            imperial: "7.5 - 10.5",
            metric: "19 - 27"
        },
        id: 211,
        name: "Russian Toy",
        breed_group: "Toy",
        life_span: "10 - 12 years",
        reference_image_id: "HkP7Vxc4Q",
        image: {
            id: "HkP7Vxc4Q",
            width: 645,
            height: 380,
            url: "https://cdn2.thedogapi.com/images/HkP7Vxc4Q.jpg"
        }
    },
    {
        weight: {
            imperial: "130 - 180",
            metric: "59 - 82"
        },
        height: {
            imperial: "25.5 - 27.5",
            metric: "65 - 70"
        },
        id: 212,
        name: "Saint Bernard",
        bred_for: "Draft, search, rescue",
        breed_group: "Working",
        life_span: "7 - 10 years",
        temperament: "Friendly, Lively, Gentle, Watchful, Calm",
        reference_image_id: "_Qf9nfRzL",
        image: {
            id: "_Qf9nfRzL",
            width: 1080,
            height: 1084,
            url: "https://cdn2.thedogapi.com/images/_Qf9nfRzL.png"
        }
    },
    {
        weight: {
            imperial: "35 - 65",
            metric: "16 - 29"
        },
        height: {
            imperial: "23 - 28",
            metric: "58 - 71"
        },
        id: 213,
        name: "Saluki",
        bred_for: "Coursing gazelle and hare",
        breed_group: "Hound",
        life_span: "12 - 14 years",
        temperament: "Aloof, Reserved, Intelligent, Quiet",
        reference_image_id: "fjFIuehNo",
        image: {
            id: "fjFIuehNo",
            width: 750,
            height: 450,
            url: "https://cdn2.thedogapi.com/images/fjFIuehNo.jpg"
        }
    },
    {
        weight: {
            imperial: "50 - 60",
            metric: "23 - 27"
        },
        height: {
            imperial: "19 - 23.5",
            metric: "48 - 60"
        },
        id: 214,
        name: "Samoyed",
        bred_for: "Herding reindeer, guardian, draft",
        breed_group: "Working",
        life_span: "12 - 14 years",
        temperament: "Stubborn, Friendly, Sociable, Lively, Alert, Playful",
        reference_image_id: "S1T8Ee9Nm",
        image: {
            id: "S1T8Ee9Nm",
            width: 1200,
            height: 797,
            url: "https://cdn2.thedogapi.com/images/S1T8Ee9Nm.jpg"
        }
    },
    {
        weight: {
            imperial: "10 - 16",
            metric: "5 - 7"
        },
        height: {
            imperial: "10 - 13",
            metric: "25 - 33"
        },
        id: 216,
        name: "Schipperke",
        bred_for: "Barge watchdog",
        breed_group: "Non-Sporting",
        life_span: "13 - 15 years",
        temperament: "Fearless, Agile, Curious, Independent, Confident, Faithful",
        reference_image_id: "SyBvVgc47",
        image: {
            id: "SyBvVgc47",
            width: 1024,
            height: 681,
            url: "https://cdn2.thedogapi.com/images/SyBvVgc47.jpg"
        }
    },
    {
        weight: {
            imperial: "70 - 130",
            metric: "32 - 59"
        },
        height: {
            imperial: "28 - 32",
            metric: "71 - 81"
        },
        id: 218,
        name: "Scottish Deerhound",
        bred_for: "Coursing deer",
        breed_group: "Hound",
        life_span: "8 - 10 years",
        temperament: "Docile, Friendly, Dignified, Gentle",
        reference_image_id: "SkNjqx9NQ",
        image: {
            id: "SkNjqx9NQ",
            width: 700,
            height: 480,
            url: "https://cdn2.thedogapi.com/images/SkNjqx9NQ.jpg"
        }
    },
    {
        weight: {
            imperial: "18 - 22",
            metric: "8 - 10"
        },
        height: {
            imperial: "10",
            metric: "25"
        },
        id: 219,
        name: "Scottish Terrier",
        bred_for: "Vermin hunting",
        breed_group: "Terrier",
        life_span: "11 - 13 years",
        temperament: "Feisty, Alert, Independent, Playful, Quick, Self-assured",
        reference_image_id: "Bklnce5NX",
        image: {
            id: "Bklnce5NX",
            width: 1280,
            height: 976,
            url: "https://cdn2.thedogapi.com/images/Bklnce5NX.jpg"
        }
    },
    {
        weight: {
            imperial: "30",
            metric: "14"
        },
        height: {
            imperial: "13 - 16",
            metric: "33 - 41"
        },
        id: 221,
        name: "Shetland Sheepdog",
        bred_for: "Sheep herding",
        breed_group: "Herding",
        life_span: "12 - 14 years",
        temperament: "Affectionate, Lively, Responsive, Alert, Loyal, Reserved, Playful, Gentle, Intelligent, Active, Trainable, Strong",
        reference_image_id: "rJa29l9E7",
        image: {
            id: "rJa29l9E7",
            width: 824,
            height: 640,
            url: "https://cdn2.thedogapi.com/images/rJa29l9E7.jpg"
        }
    },
    {
        weight: {
            imperial: "17 - 23",
            metric: "8 - 10"
        },
        height: {
            imperial: "13.5 - 16.5",
            metric: "34 - 42"
        },
        id: 222,
        name: "Shiba Inu",
        bred_for: "Hunting in the mountains of Japan, Alert Watchdog",
        breed_group: "Non-Sporting",
        life_span: "12 - 16 years",
        temperament: "Charming, Fearless, Keen, Alert, Confident, Faithful",
        reference_image_id: "Zn3IjPX3f",
        image: {
            id: "Zn3IjPX3f",
            width: 1080,
            height: 1080,
            url: "https://cdn2.thedogapi.com/images/Zn3IjPX3f.jpg"
        }
    },
    {
        weight: {
            imperial: "9 - 16",
            metric: "4 - 7"
        },
        height: {
            imperial: "8 - 11",
            metric: "20 - 28"
        },
        id: 223,
        name: "Shih Tzu",
        bred_for: "Lapdog",
        breed_group: "Toy",
        life_span: "10 - 18 years",
        temperament: "Clever, Spunky, Outgoing, Friendly, Affectionate, Lively, Alert, Loyal, Independent, Playful, Gentle, Intelligent, Happy, Active, Courageous",
        reference_image_id: "BkrJjgcV7",
        image: {
            id: "BkrJjgcV7",
            width: 800,
            height: 600,
            url: "https://cdn2.thedogapi.com/images/BkrJjgcV7.jpg"
        }
    },
    {
        weight: {
            imperial: "120 - 140",
            metric: "54 - 64"
        },
        height: {
            imperial: "26 - 30",
            metric: "66 - 76"
        },
        id: 225,
        name: "Shiloh Shepherd",
        bred_for: "Swimming, Carrying backpacks, Pulling carts or sleds",
        life_span: "9 \u2013 14 years",
        temperament: "Outgoing, Loyal, Companionable, Gentle, Loving, Trainable",
        reference_image_id: "SJJxjecEX",
        image: {
            id: "SJJxjecEX",
            width: 1005,
            height: 803,
            url: "https://cdn2.thedogapi.com/images/SJJxjecEX.jpg"
        }
    },
    {
        weight: {
            imperial: "35 - 60",
            metric: "16 - 27"
        },
        height: {
            imperial: "20 - 23.5",
            metric: "51 - 60"
        },
        id: 226,
        name: "Siberian Husky",
        bred_for: "Sled pulling",
        breed_group: "Working",
        life_span: "12 years",
        temperament: "Outgoing, Friendly, Alert, Gentle, Intelligent",
        reference_image_id: "S17ZilqNm",
        image: {
            id: "S17ZilqNm",
            width: 1920,
            height: 1280,
            url: "https://cdn2.thedogapi.com/images/S17ZilqNm.jpg"
        }
    },
    {
        weight: {
            imperial: "8 - 10",
            metric: "4 - 5"
        },
        height: {
            imperial: "9 - 10",
            metric: "23 - 25"
        },
        id: 228,
        name: "Silky Terrier",
        bred_for: "Small vermin hunting, companionship",
        breed_group: "Toy",
        life_span: "12 - 15 years",
        temperament: "Friendly, Responsive, Inquisitive, Alert, Quick, Joyful",
        reference_image_id: "ByzGsl5Nm",
        image: {
            id: "ByzGsl5Nm",
            width: 1599,
            height: 1142,
            url: "https://cdn2.thedogapi.com/images/ByzGsl5Nm.jpg"
        }
    },
    {
        weight: {
            imperial: "up - 18",
            metric: "NaN - 8"
        },
        height: {
            imperial: "15.5",
            metric: "39"
        },
        id: 232,
        name: "Smooth Fox Terrier",
        bred_for: "Fox bolting",
        breed_group: "Terrier",
        life_span: "12 - 14 years",
        temperament: "Fearless, Affectionate, Alert, Playful, Intelligent, Active",
        reference_image_id: "Syszjx9Em",
        image: {
            id: "Syszjx9Em",
            width: 1600,
            height: 1031,
            url: "https://cdn2.thedogapi.com/images/Syszjx9Em.jpg"
        }
    },
    {
        weight: {
            imperial: "30 - 40",
            metric: "14 - 18"
        },
        height: {
            imperial: "16 - 18",
            metric: "41 - 46"
        },
        id: 233,
        name: "Soft Coated Wheaten Terrier",
        bred_for: "Vermin hunting, guarding, all-around farm helper",
        breed_group: "Terrier",
        life_span: "12 - 15 years",
        temperament: "Affectionate, Spirited, Energetic, Playful, Intelligent, Faithful",
        reference_image_id: "HJHmix5NQ",
        image: {
            id: "HJHmix5NQ",
            width: 1200,
            height: 800,
            url: "https://cdn2.thedogapi.com/images/HJHmix5NQ.jpg"
        }
    },
    {
        weight: {
            imperial: "30 - 50",
            metric: "14 - 23"
        },
        height: {
            imperial: "16 - 20",
            metric: "41 - 51"
        },
        id: 235,
        name: "Spanish Water Dog",
        bred_for: "Herding flocks of sheep and goats from one pasture to another",
        breed_group: "Sporting",
        life_span: "12 - 15 years",
        temperament: "Trainable, Diligent, Affectionate, Loyal, Athletic, Intelligent",
        reference_image_id: "HJf4jl9VX",
        image: {
            id: "HJf4jl9VX",
            width: 1200,
            height: 922,
            url: "https://cdn2.thedogapi.com/images/HJf4jl9VX.jpg"
        }
    },
    {
        weight: {
            imperial: "61 - 85",
            metric: "28 - 39"
        },
        height: {
            imperial: "22.5 - 27.5",
            metric: "57 - 70"
        },
        id: 236,
        name: "Spinone Italiano",
        breed_group: "Sporting",
        life_span: "10 - 12 years",
        temperament: "Docile, Friendly, Affectionate, Loyal, Patient, Gentle",
        reference_image_id: "rk5Eoe5Nm",
        image: {
            id: "rk5Eoe5Nm",
            width: 1030,
            height: 772,
            url: "https://cdn2.thedogapi.com/images/rk5Eoe5Nm.jpg"
        }
    },
    {
        weight: {
            imperial: "24 - 38",
            metric: "11 - 17"
        },
        height: {
            imperial: "14 - 16",
            metric: "36 - 41"
        },
        id: 238,
        name: "Staffordshire Bull Terrier",
        bred_for: "",
        breed_group: "Terrier",
        life_span: "12 - 14 years",
        temperament: "Reliable, Fearless, Bold, Affectionate, Loyal, Intelligent, Courageous",
        reference_image_id: "H1zSie9V7",
        image: {
            id: "H1zSie9V7",
            width: 1280,
            height: 852,
            url: "https://cdn2.thedogapi.com/images/H1zSie9V7.jpg"
        }
    },
    {
        weight: {
            imperial: "30 - 50",
            metric: "14 - 23"
        },
        height: {
            imperial: "17.5 - 19.5",
            metric: "44 - 50"
        },
        id: 239,
        name: "Standard Schnauzer",
        bred_for: "Ratting, guarding",
        breed_group: "Working",
        life_span: "13 - 15 years",
        temperament: "Trainable, Good-natured, Devoted, Lively, Playful, Intelligent",
        reference_image_id: "tmzeu6ID_",
        image: {
            id: "tmzeu6ID_",
            width: 650,
            height: 585,
            url: "https://cdn2.thedogapi.com/images/tmzeu6ID_.jpg"
        }
    },
    {
        weight: {
            imperial: "20 - 30",
            metric: "9 - 14"
        },
        height: {
            imperial: "11.5 - 13.5",
            metric: "29 - 34"
        },
        id: 242,
        name: "Swedish Vallhund",
        breed_group: "Herding",
        life_span: "12 - 14 years",
        temperament: "Fearless, Friendly, Energetic, Alert, Intelligent, Watchful",
        reference_image_id: "HJ-Dix94Q",
        image: {
            id: "HJ-Dix94Q",
            width: 1280,
            height: 851,
            url: "https://cdn2.thedogapi.com/images/HJ-Dix94Q.jpg"
        }
    },
    {
        weight: {
            imperial: "35 - 55",
            metric: "16 - 25"
        },
        height: {
            imperial: "20 - 24",
            metric: "51 - 61"
        },
        id: 243,
        name: "Thai Ridgeback",
        breed_group: "Hound",
        life_span: "10 - 12 years",
        temperament: "Protective, Loyal, Independent, Intelligent, Loving, Familial",
        reference_image_id: "zv89hR-O8",
        image: {
            id: "zv89hR-O8",
            width: 1080,
            height: 720,
            url: "https://cdn2.thedogapi.com/images/zv89hR-O8.jpg"
        }
    },
    {
        weight: {
            imperial: "85 - 140",
            metric: "39 - 64"
        },
        height: {
            imperial: "24 - 26",
            metric: "61 - 66"
        },
        id: 244,
        name: "Tibetan Mastiff",
        breed_group: "Working",
        life_span: "10 - 14 years",
        temperament: "Strong Willed, Tenacious, Aloof, Stubborn, Intelligent, Protective",
        reference_image_id: "SkM9sec47",
        image: {
            id: "SkM9sec47",
            width: 1600,
            height: 1375,
            url: "https://cdn2.thedogapi.com/images/SkM9sec47.jpg"
        }
    },
    {
        weight: {
            imperial: "9 - 15",
            metric: "4 - 7"
        },
        height: {
            imperial: "10",
            metric: "25"
        },
        id: 245,
        name: "Tibetan Spaniel",
        breed_group: "Non-Sporting",
        life_span: "12 - 15 years",
        temperament: "Willful, Aloof, Assertive, Independent, Playful, Intelligent, Happy",
        reference_image_id: "Hyjcol947",
        image: {
            id: "Hyjcol947",
            width: 1023,
            height: 825,
            url: "https://cdn2.thedogapi.com/images/Hyjcol947.jpg"
        }
    },
    {
        weight: {
            imperial: "20 - 24",
            metric: "9 - 11"
        },
        height: {
            imperial: "14 - 17",
            metric: "36 - 43"
        },
        id: 246,
        name: "Tibetan Terrier",
        bred_for: "Good luck charms, mascots, watchdogs, herding dogs, and companions",
        breed_group: "Non-Sporting",
        life_span: "12 - 15 years",
        temperament: "Affectionate, Energetic, Amiable, Reserved, Gentle, Sensitive",
        reference_image_id: "6f5n_42mB",
        image: {
            id: "6f5n_42mB",
            width: 981,
            height: 1226,
            url: "https://cdn2.thedogapi.com/images/6f5n_42mB.jpg"
        }
    },
    {
        weight: {
            imperial: "4 - 9",
            metric: "2 - 4"
        },
        height: {
            imperial: "8 - 11",
            metric: "20 - 28"
        },
        id: 248,
        name: "Toy Fox Terrier",
        breed_group: "Toy",
        life_span: "12 - 15 years",
        temperament: "Friendly, Spirited, Alert, Loyal, Playful, Intelligent",
        reference_image_id: "B17ase9V7",
        image: {
            id: "B17ase9V7",
            width: 1200,
            height: 1024,
            url: "https://cdn2.thedogapi.com/images/B17ase9V7.jpg"
        }
    },
    {
        weight: {
            imperial: "45 - 80",
            metric: "20 - 36"
        },
        height: {
            imperial: "20 - 27",
            metric: "51 - 69"
        },
        id: 250,
        name: "Treeing Walker Coonhound",
        breed_group: "Hound",
        life_span: "10 - 13 years",
        temperament: "Clever, Affectionate, Confident, Intelligent, Loving, Trainable",
        reference_image_id: "SkRpsgc47",
        image: {
            id: "SkRpsgc47",
            width: 1920,
            height: 1080,
            url: "https://cdn2.thedogapi.com/images/SkRpsgc47.jpg"
        }
    },
    {
        weight: {
            imperial: "50 - 65",
            metric: "23 - 29"
        },
        height: {
            imperial: "21 - 24",
            metric: "53 - 61"
        },
        id: 251,
        name: "Vizsla",
        bred_for: "Pointing and trailing",
        breed_group: "Sporting",
        life_span: "10 - 14 years",
        temperament: "Affectionate, Energetic, Loyal, Gentle, Quiet",
        reference_image_id: "r1o0jx9Em",
        image: {
            id: "r1o0jx9Em",
            width: 2269,
            height: 1276,
            url: "https://cdn2.thedogapi.com/images/r1o0jx9Em.jpg"
        }
    },
    {
        weight: {
            imperial: "55 - 90",
            metric: "25 - 41"
        },
        height: {
            imperial: "23 - 27",
            metric: "58 - 69"
        },
        id: 253,
        name: "Weimaraner",
        bred_for: "Large game trailing and versatile gundog",
        breed_group: "Sporting",
        life_span: "12 - 15 years",
        temperament: "Steady, Aloof, Stubborn, Energetic, Alert, Intelligent, Powerful, Fast",
        reference_image_id: "SyU12l9V7",
        image: {
            id: "SyU12l9V7",
            width: 901,
            height: 954,
            url: "https://cdn2.thedogapi.com/images/SyU12l9V7.jpg"
        }
    },
    {
        weight: {
            imperial: "35 - 55",
            metric: "16 - 25"
        },
        height: {
            imperial: "17 - 19",
            metric: "43 - 48"
        },
        id: 254,
        name: "Welsh Springer Spaniel",
        bred_for: "Flushing and retrieving birds",
        breed_group: "Sporting",
        life_span: "12 - 15 years",
        temperament: "Stubborn, Friendly, Affectionate, Loyal, Playful, Active",
        reference_image_id: "BJ1gnx5Vm",
        image: {
            id: "BJ1gnx5Vm",
            width: 1331,
            height: 944,
            url: "https://cdn2.thedogapi.com/images/BJ1gnx5Vm.jpg"
        }
    },
    {
        weight: {
            imperial: "15 - 22",
            metric: "7 - 10"
        },
        height: {
            imperial: "10 - 11",
            metric: "25 - 28"
        },
        id: 256,
        name: "West Highland White Terrier",
        bred_for: "Fox, badger, vermin hunting",
        breed_group: "Terrier",
        life_span: "15 - 20 years",
        temperament: "Hardy, Friendly, Alert, Independent, Gay, Active, Courageous",
        reference_image_id: "Bkdx2g5Em",
        image: {
            id: "Bkdx2g5Em",
            width: 1065,
            height: 1032,
            url: "https://cdn2.thedogapi.com/images/Bkdx2g5Em.jpg"
        }
    },
    {
        weight: {
            imperial: "25 - 35",
            metric: "11 - 16"
        },
        height: {
            imperial: "18 - 22",
            metric: "46 - 56"
        },
        id: 257,
        name: "Whippet",
        bred_for: "Coursing, racing",
        breed_group: "Hound",
        life_span: "12 - 15 years",
        temperament: "Friendly, Affectionate, Lively, Gentle, Intelligent, Quiet",
        reference_image_id: "Hyv-ne94m",
        image: {
            id: "Hyv-ne94m",
            width: 1600,
            height: 1071,
            url: "https://cdn2.thedogapi.com/images/Hyv-ne94m.jpg"
        }
    },
    {
        weight: {
            imperial: "60 - 85",
            metric: "27 - 39"
        },
        height: {
            imperial: "22 - 25",
            metric: "56 - 64"
        },
        id: 258,
        name: "White Shepherd",
        life_span: "12 \u2013 14 years",
        temperament: "Self-confidence, Aloof, Fearless, Alert, Companionable, Eager",
        reference_image_id: "r14M3e9E7",
        image: {
            id: "r14M3e9E7",
            width: 1200,
            height: 800,
            url: "https://cdn2.thedogapi.com/images/r14M3e9E7.jpg"
        }
    },
    {
        weight: {
            imperial: "15 - 19",
            metric: "7 - 9"
        },
        height: {
            imperial: "13 - 16",
            metric: "33 - 41"
        },
        id: 259,
        name: "Wire Fox Terrier",
        bred_for: "Vermin hunting, fox bolting",
        life_span: "13 \u2013 14 years",
        history: " England",
        temperament: "Fearless, Friendly, Bold, Keen, Alert, Quick",
        reference_image_id: "SJ6f2g9EQ",
        image: {
            id: "SJ6f2g9EQ",
            width: 1000,
            height: 795,
            url: "https://cdn2.thedogapi.com/images/SJ6f2g9EQ.jpg"
        }
    },
    {
        weight: {
            imperial: "45 - 70",
            metric: "20 - 32"
        },
        height: {
            imperial: "20 - 24",
            metric: "51 - 61"
        },
        id: 260,
        name: "Wirehaired Pointing Griffon",
        bred_for: 'Gundog, "swamp-tromping", Flushing, pointing, and retrieving water fowl & game birds',
        breed_group: "Sporting",
        life_span: "12 - 14 years",
        temperament: "Loyal, Gentle, Vigilant, Trainable, Proud",
        reference_image_id: "Bkam2l9Vm",
        image: {
            id: "Bkam2l9Vm",
            width: 2328,
            height: 1604,
            url: "https://cdn2.thedogapi.com/images/Bkam2l9Vm.jpg"
        }
    },
    {
        weight: {
            imperial: "45 - 65",
            metric: "20 - 29"
        },
        height: {
            imperial: "21.5 - 25",
            metric: "55 - 64"
        },
        id: 261,
        name: "Wirehaired Vizsla",
        breed_group: "Sporting",
        life_span: "12 - 14 years",
        reference_image_id: "r1I4hl5Em",
        image: {
            id: "r1I4hl5Em",
            width: 1024,
            height: 770,
            url: "https://cdn2.thedogapi.com/images/r1I4hl5Em.jpg"
        }
    },
    {
        weight: {
            imperial: "9 - 31",
            metric: "4 - 14"
        },
        height: {
            imperial: "10 - 23",
            metric: "25 - 58"
        },
        id: 262,
        name: "Xoloitzcuintli",
        breed_group: "Non-Sporting",
        life_span: "12 - 14 years",
        temperament: "Cheerful, Alert, Companionable, Intelligent, Protective, Calm",
        reference_image_id: "HkNS3gqEm",
        image: {
            id: "HkNS3gqEm",
            width: 1500,
            height: 1350,
            url: "https://cdn2.thedogapi.com/images/HkNS3gqEm.jpg"
        }
    },
    {
        weight: {
            imperial: "4 - 7",
            metric: "2 - 3"
        },
        height: {
            imperial: "8 - 9",
            metric: "20 - 23"
        },
        id: 264,
        name: "Yorkshire Terrier",
        bred_for: "Small vermin hunting",
        breed_group: "Toy",
        life_span: "12 - 16 years",
        temperament: "Bold, Independent, Confident, Intelligent, Courageous",
        reference_image_id: "B12BnxcVQ",
        image: {
            id: "B12BnxcVQ",
            width: 1024,
            height: 683,
            url: "https://cdn2.thedogapi.com/images/B12BnxcVQ.jpg"
        }
    }
];



parcelRequire("8vqx4");
function $1284d070a00ed901$export$2e2bcd8739ae039({ theme: theme = "default", size: size = "default", title: title, onClick: onClick, border: border = true, leftIcon: leftIcon, buttonClasses: buttonClasses, textClasses: textClasses, disabled: disabled }) {
    let borderClasses = "";
    let themeClasses = "bg-white text-black";
    let sizeClasses = "text-[16px]";
    let paddingClasses = "px-[38px] py-[15px]";
    if (border) borderClasses = "border-[1px] border-[#5C5C5C]";
    if (theme === "dark") themeClasses = "bg-black text-white";
    if (theme === "transparent") themeClasses = "bg-transparent text-black";
    if (theme === "transparent-white-home") {
        themeClasses = "bg-transparent text-white";
        borderClasses = "border-[1px] border-[#FFFFFF]";
    }
    if (theme === "red") {
        themeClasses = "bg-[#EC0202] text-white";
        borderClasses = "border-[1px] border-[#EC0202]";
    }
    if (theme === "secondary") {
        themeClasses = "bg-theme-grey-1 text-black";
        borderClasses = "";
    }
    if (size === "medium") {
        sizeClasses = "text-[12px]";
        paddingClasses = "px-[24px] py-[13px]";
    }
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("button", {
        className: `flex flex-row items-center gap-2 rounded-[4px] ${themeClasses} ${paddingClasses} transition hover:opacity-90 ${borderClasses} ${buttonClasses} disabled:opacity-50`,
        type: "button",
        onClick: onClick,
        disabled: disabled,
        children: [
            leftIcon,
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                className: `w-full font-medium ${sizeClasses} leading-none ${textClasses}`,
                children: title
            })
        ]
    });
}




var $8vqx4 = parcelRequire("8vqx4");



parcelRequire("8vqx4");
function $4630c1795954adfc$export$2e2bcd8739ae039({ message: message }) {
    if (!message) return null;
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "mt-2 text-[13px] text-red-500",
        children: message
    });
}


function $e15d0f29bf23b2da$export$2e2bcd8739ae039({ multiple: multiple = false, onChangeHandler: onChangeHandler, files: files, err: err }) {
    const [error, setError] = (0, $8vqx4.useState)(false);
    (0, $8vqx4.useEffect)(()=>{
        setError(err);
    }, [
        err
    ]);
    const processFiles = (files)=>{
        for(let i = 0; i < files.length; i++){
            const file = files[i];
            if (!(0, $22f2182d1b990877$export$628514a40f204842)(file.type)) {
                setError("Current file type is not supported");
                return;
            }
            if (!(0, $22f2182d1b990877$export$d7d91ef60ed914ba)(file.size)) {
                setError("Current file size is more than 2mb");
                return;
            }
        }
        onChangeHandler(files);
    };
    const handleOnDrop = (e)=>{
        setError(false);
        if (!e.dataTransfer.files) return;
        const files = e.dataTransfer.files;
        if (!files) return;
        processFiles(files);
    };
    const handleOnChange = (e)=>{
        setError(false);
        if (!e.target.files) return;
        const files = e.target.files;
        if (!files) return;
        processFiles(files);
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        className: "flex max-w-full flex-row flex-wrap gap-6",
        children: [
            files.map((file)=>{
                if (file.preview) return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                    src: file.preview,
                    className: "h-[200px] max-h-full w-auto"
                }, file.preview);
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: `relative flex h-[200px] w-[200px] max-w-[200px] flex-shrink-0 flex-grow items-center justify-center border-[1px] bg-white transition hover:bg-gray-50 ${error ? "border-red-500 text-red-500" : "border-[#DCD7D0] text-gray-500"}`,
                onDrop: handleOnDrop,
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("input", {
                        type: "file",
                        className: "absolute inset-0 z-50 h-full w-full cursor-pointer opacity-0",
                        onChange: handleOnChange,
                        accept: "image/png, image/jpeg",
                        multiple: multiple
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: "flex h-40 w-full flex-col items-center justify-center",
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex flex-col items-center justify-center gap-2",
                            children: [
                                (0, $697654d10ef148cd$export$8081465a586297e5)(error ? "#EF4444" : "#878787"),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("p", {
                                    className: "mb-2 text-sm",
                                    children: [
                                        "Drag you image here",
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("br", {}),
                                        "or click to upload it"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $4630c1795954adfc$export$2e2bcd8739ae039), {
                message: error
            }) : null
        ]
    });
}




parcelRequire("8vqx4");
function $83934f715a68a9ab$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "border-t-[1px] border-[#DADADA] bg-white p-7",
        style: {
            filter: "drop-shadow(0px 0px 20px rgba(0,0,0,0.1))"
        },
        children: children
    });
}



parcelRequire("8vqx4");

function $19ec67d6e360fae6$export$2e2bcd8739ae039({ type: type = "text", id: id, name: name, label: label, placeholder: placeholder, required: required = false, readonly: readonly = false, onChange: onChange, customClasses: customClasses = "", value: value, error: error }) {
    let errorClasses = "";
    if (error) errorClasses = "border-red-500 text-red-500";
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: `flex w-full flex-col gap-1 rounded-[4px] border-[1px] border-[#DEDDDB] bg-white px-3 py-3 leading-[18px] ${customClasses} ${errorClasses}`,
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("label", {
                        htmlFor: name,
                        className: `font-barlowregular text-[12px] text-[#7F7F7F] ${errorClasses}`,
                        children: label
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("input", {
                        type: type,
                        id: id,
                        name: name,
                        onChange: onChange,
                        className: "bg-white placeholder:text-[#736F62] read-only:bg-[#f6f6f6] focus:outline-none",
                        placeholder: placeholder,
                        value: value !== null ? value : "",
                        required: required,
                        readOnly: readonly
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $4630c1795954adfc$export$2e2bcd8739ae039), {
                message: error
            }) : null
        ]
    });
}



parcelRequire("8vqx4");

function $20c9c3de9785db52$export$2e2bcd8739ae039({ id: id, name: name, label: label, required: required = false, onChange: onChange, customClasses: customClasses = "", placeholder: placeholder, value: value, error: error, options: options }) {
    let errorClasses = "";
    if (error) errorClasses = "border-red-500 text-red-500";
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: `relative flex w-full flex-col gap-1 rounded-[4px] border-[1px] border-[#DEDDDB] bg-white bg-no-repeat px-3 py-3 leading-[18px] ${customClasses} ${errorClasses}`,
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("label", {
                        htmlFor: name,
                        className: `font-barlowregular text-[12px] text-[#7F7F7F] ${errorClasses}`,
                        children: label
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("select", {
                        id: id,
                        className: "cursor-pointer appearance-none bg-white leading-normal placeholder:text-[#736F62] focus:outline-none",
                        name: name,
                        required: required,
                        defaultValue: value,
                        multiple: false,
                        onChange: onChange,
                        children: [
                            placeholder && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("option", {
                                value: "",
                                disabled: true,
                                className: "text-yellow",
                                children: placeholder
                            }),
                            options.map((o)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("option", {
                                    value: o[0],
                                    children: o[1]
                                }, o[0]))
                        ]
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: `absolute right-[15px] ${label?.length > 0 ? "top-[28px]" : "top-[22px]"}`,
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
                            width: "17",
                            height: "10",
                            viewBox: "0 0 17 10",
                            fill: "none",
                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                                d: "M1 1L8.5 9L16 1",
                                stroke: "#292929"
                            })
                        })
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $4630c1795954adfc$export$2e2bcd8739ae039), {
                message: error
            }) : null
        ]
    });
}



parcelRequire("8vqx4");

function $dd6be6f427e76170$export$2e2bcd8739ae039({ id: id, name: name, label: label, placeholder: placeholder, required: required = false, readonly: readonly = false, onChange: onChange, customClasses: customClasses = "", value: value, error: error, rows: rows = 4 }) {
    let errorClasses = "";
    if (error) errorClasses = "border-red-500 text-red-500";
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        className: `flex w-full flex-col gap-1 rounded-[4px] border-[1px] border-[#DEDDDB] bg-white px-3 py-3 leading-[18px] ${customClasses} ${errorClasses}`,
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("label", {
                htmlFor: name,
                className: `font-barlowregular text-[12px] text-[#7F7F7F] ${errorClasses}`,
                children: label
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("textarea", {
                id: id,
                name: name,
                onChange: onChange,
                className: "resize-none bg-white leading-[126%] placeholder:text-[#736F62] read-only:bg-[#f6f6f6] focus:outline-none",
                placeholder: placeholder,
                value: value !== null ? value : "",
                required: required,
                readOnly: readonly,
                rows: rows
            }),
            error ? /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $4630c1795954adfc$export$2e2bcd8739ae039), {
                message: error
            }) : null
        ]
    });
}


const $19dff358b96c2758$var$breedsForSelect = (0, $753fa877a4b606f8$export$92560e4a4f380d99).reduce((acc, i)=>{
    return [
        ...acc,
        [
            i.name,
            i.name
        ]
    ];
}, []);
const $19dff358b96c2758$var$defaultPet = {
    name: "",
    desc: "",
    gender: "",
    birthdate: "",
    size: "",
    breed: "",
    breedType: "",
    age: "",
    fur: "",
    mainImage: {},
    images: []
};
const $19dff358b96c2758$var$staticUrl = "https://tailtales.vorozhbit.com/static/";
const $19dff358b96c2758$var$UserPageDogEdit = ()=>{
    const [loading, setLoading] = (0, $8vqx4.useState)(true);
    const [pet, setPet] = (0, $8vqx4.useState)($19dff358b96c2758$var$defaultPet);
    const [mainImage, setMainImage] = (0, $8vqx4.useState)({});
    const [images, setImages] = (0, $8vqx4.useState)([]);
    const [errors, setErrors] = (0, $8vqx4.useState)({});
    const { user: user } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    const userDispatch = (0, $44a22ec1fae97653$export$5bd0aba7f9e819b6)();
    (0, $8vqx4.useEffect)(()=>{
        console.log("usr", user);
        if (user.pageParams && user.pageParams.id) fetchPet(user.pageParams.id);
        else {
            setPet($19dff358b96c2758$var$defaultPet);
            setMainImage({});
            setImages([]);
            setErrors({});
            setLoading(false);
        }
    }, [
        user
    ]);
    (0, $8vqx4.useEffect)(()=>{
        console.log("mainImage", mainImage);
    }, [
        mainImage
    ]);
    (0, $8vqx4.useEffect)(()=>{
        console.log("images", images);
    }, [
        images
    ]);
    const fetchPet = (petId)=>{
        if (!user.accessToken) return;
        (0, $61e35487be0558dc$export$dbd4fc49e5e0b54)(user.accessToken, petId).then((data)=>{
            if (!data) return;
            const im = data.images.find((i)=>i.main);
            if (im) setMainImage({
                preview: `${$19dff358b96c2758$var$staticUrl}${im.url}`,
                id: im.id
            });
            const imgs = data.images.filter((i)=>!i.main).reduce((acc, im)=>{
                const i = {
                    preview: `${$19dff358b96c2758$var$staticUrl}${im.url}`,
                    id: im.id
                };
                return [
                    ...acc,
                    i
                ];
            }, []);
            if (imgs) setImages(imgs);
            console.log("PET FETCHED", data);
            setPet(data);
        }).catch((e)=>console.log(e)).finally(()=>setLoading(false));
    };
    const handleMainImageChange = (file)=>{
        const img = {
            preview: URL.createObjectURL(file[0]),
            data: file[0]
        };
        setMainImage(img);
    };
    const handleImagesChange = (files)=>{
        const images = [];
        for(let i = 0; i < files.length; i++)images.push({
            preview: URL.createObjectURL(files.item(i)),
            data: files.item(i)
        });
        if (images.length) setImages(images);
    };
    const validateFields = ()=>{
        const er = {};
        Object.entries($19dff358b96c2758$var$defaultPet).map((el)=>{
            const [key] = el;
            if (typeof pet[key] === "string" && pet[key].length <= 1) er[key] = true;
            if (key === "mainImage" && Object.keys(mainImage).length === 0) er[key] = true;
            if (key === "images" && images.length === 0) er[key] = true;
        });
        setErrors(er);
        return Object.keys(er).length === 0;
    };
    const onSavePet = ()=>{
        console.log("PET", pet);
        if (!user.accessToken) return;
        const status = validateFields();
        if (!status) return;
        setLoading(true);
        const petToSave = {
            ...pet
        };
        delete petToSave.images;
        delete petToSave.mainImage;
        petToSave.vaccines = JSON.stringify(petToSave.vaccines);
        petToSave.treatments = JSON.stringify(petToSave.treatments);
        petToSave.travelRequirements = JSON.stringify(petToSave.travelRequirements);
        console.log("PETTOSAVE", petToSave);
        const fd = new FormData();
        Object.entries(petToSave).map((entry)=>{
            const [key, value] = entry;
            fd.append(key, value || "");
        });
        if (mainImage.data) fd.append("mainImage", mainImage.data);
        images.map((i)=>{
            if (i.data) fd.append("images", i.data);
        });
        console.log("PETTOSAVE FD", fd);
        if (pet.id) (0, $61e35487be0558dc$export$eade7de8e51a7c32)(user.accessToken, pet.id, fd).then(()=>{
            userDispatch({
                type: "set-page",
                payload: {
                    page: "our-dogs"
                }
            });
            return;
        }).catch((e)=>console.log(e)).finally(()=>setLoading(false));
        else (0, $61e35487be0558dc$export$ea6a87eb2959fecc)(user.accessToken, fd).then(()=>{
            userDispatch({
                type: "set-page",
                payload: {
                    page: "our-dogs"
                }
            });
            return;
        }).catch((e)=>console.log(e)).finally(()=>setLoading(false));
    };
    const renderFooter = ()=>{
        return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
            className: "flex flex-row items-center justify-end gap-4",
            children: [
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    onClick: ()=>userDispatch({
                            type: "set-page",
                            payload: {
                                page: "our-dogs"
                            }
                        }),
                    className: "cursor-pointer font-simianregular text-[18px]",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                    title: "Save changes",
                    onClick: onSavePet,
                    theme: "dark"
                })
            ]
        });
    };
    const formatBoleanValue = (val)=>{
        if (val === null) return "";
        else if (val) return "1";
        else return "0";
    };
    if (loading) return;
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $7dff8b7841c3531f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                    className: "mb-10 flex flex-col gap-10 text-[#474747]",
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "font-simianregular text-[20px] leading-none text-[#0B0B0B]",
                                    children: "Main image"
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: "Ensure your uploaded image are high-quality JPEG or PNG files, with a maximum size of 2 MB per file."
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $e15d0f29bf23b2da$export$2e2bcd8739ae039), {
                                    files: [
                                        mainImage
                                    ],
                                    onChangeHandler: handleMainImageChange,
                                    err: errors.mainImage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "relative flex flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "font-simianregular text-[20px] leading-none text-[#0B0B0B]",
                                    children: "Images"
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: "Ensure your uploaded image are high-quality JPEG or PNG files, with a maximum size of 2 MB per file."
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $e15d0f29bf23b2da$export$2e2bcd8739ae039), {
                                    files: images,
                                    onChangeHandler: handleImagesChange,
                                    err: errors.images,
                                    multiple: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex max-w-[850px] flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "font-simianregular text-[20px] leading-none text-[#0B0B0B]",
                                    children: "Dog description"
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $19ec67d6e360fae6$export$2e2bcd8739ae039), {
                                        name: "name",
                                        label: "Name",
                                        value: pet.name,
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    name: e.target.value
                                                };
                                            }),
                                        error: errors.name
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $dd6be6f427e76170$export$2e2bcd8739ae039), {
                                        name: "desc",
                                        label: "Personality and story",
                                        value: pet.desc,
                                        rows: 10,
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    desc: e.target.value
                                                };
                                            }),
                                        error: errors.desc
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "gender",
                                        label: "Sex",
                                        value: pet.gender || "",
                                        placeholder: "Select gender",
                                        options: [
                                            [
                                                "male",
                                                "Male"
                                            ],
                                            [
                                                "female",
                                                "Female"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    gender: e.target.value
                                                };
                                            }),
                                        error: errors.gender
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "size",
                                        label: "Size",
                                        value: pet.size || "",
                                        placeholder: "Select size",
                                        options: [
                                            [
                                                "small",
                                                "Up to 10 kg (22 lbs)"
                                            ],
                                            [
                                                "medium",
                                                "10\u201325 kg (22\u201355 lbs)"
                                            ],
                                            [
                                                "large",
                                                "Over 25 kg (55 lbs)"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    size: e.target.value
                                                };
                                            }),
                                        error: errors.size
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "breedType",
                                        label: "Breed type",
                                        value: pet.breedType || "",
                                        placeholder: "Select type",
                                        options: [
                                            [
                                                "pure",
                                                "Pure"
                                            ],
                                            [
                                                "mixed",
                                                "Mixed"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    breedType: e.target.value
                                                };
                                            }),
                                        error: errors.breedType
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "breed",
                                        label: "Breed",
                                        value: pet.breed || "",
                                        placeholder: "Select breed",
                                        options: $19dff358b96c2758$var$breedsForSelect,
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    breed: e.target.value
                                                };
                                            }),
                                        error: errors.breed
                                    })
                                }),
                                pet.breedType === "mixed" && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "breedAdditional",
                                        label: "Breed (secondary)",
                                        value: pet.breedAdditional?.length > 0 ? pet.breedAdditional[0] : "",
                                        placeholder: "Select secondary breed",
                                        options: $19dff358b96c2758$var$breedsForSelect,
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    breedAdditional: e.target.value
                                                };
                                            }),
                                        error: errors.breedAdditional
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "age",
                                        label: "Age",
                                        value: pet.age || "",
                                        placeholder: "Select age",
                                        options: [
                                            [
                                                "puppy",
                                                "Puppy (0\u20131 year)"
                                            ],
                                            [
                                                "young",
                                                "Young Adult (1\u20133 years)"
                                            ],
                                            [
                                                "adult",
                                                "Adult (3\u20137 years)"
                                            ],
                                            [
                                                "senior",
                                                "Senior (7\u201310+ years)"
                                            ],
                                            [
                                                "geriatric",
                                                "Geriatric (10+ years)"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    age: e.target.value
                                                };
                                            }),
                                        error: errors.age
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $19ec67d6e360fae6$export$2e2bcd8739ae039), {
                                        name: "birthdate",
                                        label: "Birthdate",
                                        value: pet.birthdate,
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    birthdate: e.target.value
                                                };
                                            }),
                                        error: errors.birthdate
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "fur",
                                        label: "Fur",
                                        value: pet.fur || "",
                                        placeholder: "Select fur",
                                        options: [
                                            [
                                                "short",
                                                "Short"
                                            ],
                                            [
                                                "medium",
                                                "Medium"
                                            ],
                                            [
                                                "long",
                                                "Long"
                                            ],
                                            [
                                                "coarse",
                                                "Coarse"
                                            ],
                                            [
                                                "curly",
                                                "Curly"
                                            ],
                                            [
                                                "double",
                                                "Double"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    fur: e.target.value
                                                };
                                            }),
                                        error: errors.fur
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex max-w-[850px] flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "font-simianregular text-[20px] leading-none text-[#0B0B0B]",
                                    children: "Dog characterisitcs"
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "housingSuitability",
                                        label: "Housing Suitability",
                                        value: pet.housingSuitability || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "large",
                                                "Requires large to extra large housing"
                                            ],
                                            [
                                                "any",
                                                "Ok with any size of home"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    housingSuitability: e.target.value
                                                };
                                            }),
                                        error: errors.childrenSuitability
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "outdoorSituation",
                                        label: "Outdoor situation",
                                        value: pet.outdoorSituation || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "city",
                                                "Works anywhere, apartment-friendly"
                                            ],
                                            [
                                                "suburban",
                                                "Strive in quieter neighborhoods with access to parks and green spaces."
                                            ],
                                            [
                                                "rural",
                                                "Requires frequent access to forests, fields, or large outdoor areas"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    outdoorSituation: e.target.value
                                                };
                                            }),
                                        error: errors.outdoorSituation
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "childrenSuitability",
                                        label: "Suitable for children below 12",
                                        value: pet.childrenSuitability || "",
                                        placeholder: "Select level",
                                        options: [
                                            [
                                                "yes",
                                                "Yes"
                                            ],
                                            [
                                                "no",
                                                "No"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    childrenSuitability: e.target.value
                                                };
                                            }),
                                        error: errors.childrenSuitability
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "dogsSuitability",
                                        label: "Suitable for to co-exist with other dogs",
                                        value: pet.dogsSuitability || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "yes",
                                                "Yes"
                                            ],
                                            [
                                                "no",
                                                "No"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    dogsSuitability: e.target.value
                                                };
                                            }),
                                        error: errors.dogsSuitability
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "dogsSuitability",
                                        label: "Suitable for to co-exist with other animals",
                                        value: pet.animalsSuitability || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "yes",
                                                "Yes"
                                            ],
                                            [
                                                "no",
                                                "No"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    animalsSuitability: e.target.value
                                                };
                                            }),
                                        error: errors.animalsSuitability
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "allergySuitability",
                                        label: "Allergy-friendly fur",
                                        value: pet.allergySuitability || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "yes",
                                                "Yes"
                                            ],
                                            [
                                                "no",
                                                "No"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    allergySuitability: e.target.value
                                                };
                                            }),
                                        error: errors.allergySuitability
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "aloneTolerance",
                                        label: "Alone tolerance",
                                        value: pet.aloneTolerance || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "1",
                                                "High support needs / emotional"
                                            ],
                                            [
                                                "4",
                                                "Some alone tolerance"
                                            ],
                                            [
                                                "7",
                                                "High alone tolerance"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    aloneTolerance: e.target.value
                                                };
                                            }),
                                        error: errors.aloneTolerance
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "activityLevel",
                                        label: "Dog Activity Level",
                                        value: pet.activityLevel || "",
                                        placeholder: "Select level",
                                        options: [
                                            [
                                                "low",
                                                "A calm dog no requirements of high activity level"
                                            ],
                                            [
                                                "moderate",
                                                "Medium activity level 2-4 normal walks/day"
                                            ],
                                            [
                                                "high",
                                                "High demand of activity"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    activityLevel: e.target.value
                                                };
                                            }),
                                        error: errors.activityLevel
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "adaptability",
                                        label: "Adaptability / Boarding need",
                                        value: pet.adaptability || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "adaptable",
                                                "High alone tolerance, longterm indipendence"
                                            ],
                                            [
                                                "medium",
                                                "Some alone tolerance, no problem to leave for 1-2 days"
                                            ],
                                            [
                                                "no",
                                                "High support needs, not comfortable with change"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    adaptability: e.target.value
                                                };
                                            }),
                                        error: errors.adaptability
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "experience",
                                        label: "Experience needed",
                                        value: pet.experience || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "no",
                                                "Suitable for first-time dog owners"
                                            ],
                                            [
                                                "some",
                                                "Best with some dog experience"
                                            ],
                                            [
                                                "yes",
                                                "Requires an experienced owner"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    experience: e.target.value
                                                };
                                            }),
                                        error: errors.experience
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "supportLevel",
                                        label: "Everyday support need",
                                        value: pet.supportLevel || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "flexible",
                                                "Low support needs. Emotionally resilient and adaptable"
                                            ],
                                            [
                                                "regular",
                                                "Moderate support needs. Benefits from routine and reassurance"
                                            ],
                                            [
                                                "stable",
                                                "High support needs. Needs stability, closeness, and extra support"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    supportLevel: e.target.value
                                                };
                                            }),
                                        error: errors.supportLevel
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "energyLevel",
                                        label: "Indoor energy level",
                                        value: pet.energyLevel || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "calm",
                                                "Calm indoor"
                                            ],
                                            [
                                                "balanced",
                                                "Balanced"
                                            ],
                                            [
                                                "high",
                                                "High indoor activity"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    energyLevel: e.target.value
                                                };
                                            }),
                                        error: errors.energyLevel
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "groomingNeeds",
                                        label: "Grooming needs",
                                        value: pet.groomingNeeds || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "1",
                                                "Low maintenance"
                                            ],
                                            [
                                                "2",
                                                "Medium"
                                            ],
                                            [
                                                "3",
                                                "High maintenance"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    groomingNeeds: e.target.value
                                                };
                                            }),
                                        error: errors.groomingNeeds
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "temperament",
                                        label: "Temperament preference",
                                        value: pet.temperament || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "independent",
                                                "Independent"
                                            ],
                                            [
                                                "balanced",
                                                "Balanced"
                                            ],
                                            [
                                                "attention",
                                                "Needs lots of attention"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    temperament: e.target.value
                                                };
                                            }),
                                        error: errors.temperament
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex max-w-[850px] flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "font-simianregular text-[20px] leading-none text-[#0B0B0B]",
                                    children: "Vaccines and Treatments"
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "vaccines",
                                        label: "Rabies",
                                        value: pet.vaccines?.rabies || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "1",
                                                "Yes"
                                            ],
                                            [
                                                "0",
                                                "No"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    vaccines: {
                                                        ...prevState.vaccines,
                                                        rabies: e.target.value
                                                    }
                                                };
                                            }),
                                        error: errors.vaccines
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "vaccines",
                                        label: "DHPP",
                                        value: pet.vaccines?.dhpp || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "1",
                                                "Yes"
                                            ],
                                            [
                                                "0",
                                                "No"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    vaccines: {
                                                        ...prevState.vaccines,
                                                        dhpp: e.target.value
                                                    }
                                                };
                                            }),
                                        error: errors.vaccines
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "treatments",
                                        label: "Flea and Tick Treatment",
                                        value: pet.treatments?.flea || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "1",
                                                "Yes"
                                            ],
                                            [
                                                "0",
                                                "No"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    treatments: {
                                                        ...prevState.treatments,
                                                        flea: e.target.value
                                                    }
                                                };
                                            }),
                                        error: errors.treatments
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "treatments",
                                        label: "Deworming",
                                        value: pet.treatments?.deworming || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "1",
                                                "Yes"
                                            ],
                                            [
                                                "0",
                                                "No"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    treatments: {
                                                        ...prevState.treatments,
                                                        deworming: e.target.value
                                                    }
                                                };
                                            }),
                                        error: errors.treatments
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex max-w-[850px] flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "font-simianregular text-[20px] leading-none text-[#0B0B0B]",
                                    children: "Travel requirements"
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $19ec67d6e360fae6$export$2e2bcd8739ae039), {
                                        name: "travelRequirements[chip]",
                                        label: "Microchipping (ISO-standard microchip)",
                                        placeholder: "15-digit ID",
                                        value: pet.travelRequirements?.chip || "",
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    travelRequirements: {
                                                        ...prevState.travelRequirements,
                                                        chip: e.target.value
                                                    }
                                                };
                                            }),
                                        error: errors.travelRequirements
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $20c9c3de9785db52$export$2e2bcd8739ae039), {
                                        name: "travelRequirements",
                                        label: "Health Certificate or Pet Passport",
                                        value: pet.travelRequirements?.passport || "",
                                        placeholder: "Select option",
                                        options: [
                                            [
                                                "1",
                                                "Yes"
                                            ],
                                            [
                                                "0",
                                                "No"
                                            ]
                                        ],
                                        onChange: (e)=>setPet((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    travelRequirements: {
                                                        ...prevState.travelRequirements,
                                                        passport: e.target.value
                                                    }
                                                };
                                            }),
                                        error: errors.travelRequirements
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $83934f715a68a9ab$export$2e2bcd8739ae039), {
                children: renderFooter()
            })
        ]
    });
};
function $19dff358b96c2758$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $44a22ec1fae97653$export$491fab5ec9b43e74), {
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($19dff358b96c2758$var$UserPageDogEdit, {})
    });
}




var $8vqx4 = parcelRequire("8vqx4");






const $17503828e15e2648$var$staticUrl = "https://tailtales.vorozhbit.com/static/";
function $17503828e15e2648$var$UserPageDogs({ onCloseHandle: onCloseHandle }) {
    const [loading, setLoading] = (0, $8vqx4.useState)(true);
    const [pets, setPets] = (0, $8vqx4.useState)([]);
    const [selected, setSelected] = (0, $8vqx4.useState)([]);
    const { user: user } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    const userDispatch = (0, $44a22ec1fae97653$export$5bd0aba7f9e819b6)();
    (0, $8vqx4.useEffect)(()=>{
        if (!user.accessToken) return;
        fetchUserPets();
    }, [
        user.accessToken
    ]);
    (0, $8vqx4.useEffect)(()=>{
        console.log("selected", selected);
    }, [
        selected
    ]);
    const fetchUserPets = ()=>{
        if (!user.accessToken) return;
        (0, $61e35487be0558dc$export$819d9a282de0491b)(user.accessToken).then((data)=>{
            if (!data) return;
            setPets(data);
        }).catch((e)=>console.log(e)).finally(()=>setLoading(false));
    };
    const deletePets = ()=>{
        if (!user.accessToken || !selected.length) return;
        (0, $61e35487be0558dc$export$d2166c07602f53fa)(user.accessToken, selected).then((data)=>{
            console.log(data);
            setSelected([]);
            fetchUserPets();
        }).catch((e)=>console.log(e));
    };
    const renderFooter = ()=>{
        if (!selected.length) return null;
        return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $83934f715a68a9ab$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "flex flex-row items-center justify-between gap-4",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        children: selected.length > 0 && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                    className: "font-barlowmedium",
                                    children: selected.length
                                }),
                                " ",
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                    className: "font-barlowlight",
                                    children: "dogs selected"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "flex flex-row items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                onClick: ()=>setSelected([]),
                                className: "cursor-pointer font-simianregular text-[18px]",
                                children: "Unselect all"
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                                title: "Remove",
                                onClick: deletePets,
                                theme: "red"
                            })
                        ]
                    })
                ]
            })
        });
    };
    const renderGenderIcon = (gender)=>{
        if (gender === "female") return (0, $697654d10ef148cd$export$19ea304fadb5ce85)("#0B0B0B");
        else return (0, $697654d10ef148cd$export$443b69c24d80059c)("#0B0B0B");
    };
    const updateSelectedPets = (id)=>{
        let list = [
            ...selected
        ];
        const isSelected = list.includes(id);
        if (isSelected) list = list.filter((s)=>s !== id);
        else list.push(id);
        setSelected(list);
    };
    const onEditDoghandle = (id)=>{
        userDispatch({
            type: "set-page",
            payload: {
                page: "edit-dog",
                pageParams: {
                    id: id
                }
            }
        });
    };
    if (loading) return;
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $7dff8b7841c3531f$export$2e2bcd8739ae039), {
                children: pets && pets.length > 0 && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "mb-6 font-barlowlight text-[12px]",
                            children: [
                                pets.length,
                                " dogs"
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            className: "grid grid-cols-2 gap-6 lg:grid-cols-4 xl:grid-cols-5",
                            children: pets.map((pet)=>{
                                const dt = new Date(pet.createdAt);
                                const date = `${dt.getDate()} ${dt.toLocaleString("en-US", {
                                    month: "short"
                                })} ${dt.getFullYear()}`;
                                return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                                                        src: `${$17503828e15e2648$var$staticUrl}${pet.images[0].url}`,
                                                        className: "h-[180px] w-full cursor-pointer object-cover",
                                                        onClick: ()=>onEditDoghandle(pet.id)
                                                    }),
                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                        className: "absolute left-[10px] top-[10px]",
                                                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("label", {
                                                            className: "relative flex cursor-pointer items-center p-1",
                                                            htmlFor: `check-${pet.id}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("input", {
                                                                    id: `check-${pet.id}`,
                                                                    type: "checkbox",
                                                                    // value={el.value}
                                                                    // name={name}
                                                                    onChange: ()=>updateSelectedPets(pet.id),
                                                                    checked: selected.includes(pet.id),
                                                                    style: {
                                                                        WebkitAppearance: "none",
                                                                        MozAppearance: "none"
                                                                    },
                                                                    className: `before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded-[4px] border border-[#727272] bg-white transition-all before:absolute before:left-2/4 before:top-2/4 before:block before:h-6 before:w-6 before:-translate-x-2/4 before:-translate-y-2/4 before:rounded-[4px] before:opacity-0 before:transition-opacity checked:border-[#727272] checked:bg-black hover:before:opacity-10`
                                                                }),
                                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                                    className: "text-theme-primary3 pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 opacity-0 transition-opacity peer-checked:opacity-100",
                                                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
                                                                        width: "12",
                                                                        height: "10",
                                                                        viewBox: "0 0 12 10",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                                                                            d: "M1 6L4 9L11 1",
                                                                            stroke: "white",
                                                                            strokeWidth: "1.5",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                className: "cursor-pointer border-[1px] border-t-0 border-[#EEEEEE] p-3",
                                                onClick: ()=>onEditDoghandle(pet.id),
                                                children: [
                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                        className: "flex flex-row items-center gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                                className: "font-barlowmedium text-[20px] text-[#0B0B0B]",
                                                                children: pet.name
                                                            }),
                                                            renderGenderIcon(pet.gender)
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                        className: "mb-3 font-barlowregular text-[12px] text-[#474747]",
                                                        children: pet.petCode
                                                    }),
                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                        className: "font-barlowregular text-[12px] text-[#0B0B0B]",
                                                        children: [
                                                            "Date added: ",
                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                                className: "font-barlowmedium",
                                                                children: date
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, pet.id);
                            })
                        })
                    ]
                })
            }),
            renderFooter()
        ]
    });
}
function $17503828e15e2648$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $44a22ec1fae97653$export$491fab5ec9b43e74), {
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($17503828e15e2648$var$UserPageDogs, {
            ...props
        })
    });
}




var $8vqx4 = parcelRequire("8vqx4");








const $54f1b2c8c35b952f$var$defaultProfile = {
    title: "",
    desc: "",
    country: "",
    street: "",
    city: "",
    postcode: "",
    phone: "",
    website: "",
    logo: {},
    header: {}
};
const $54f1b2c8c35b952f$var$staticUrl = "https://tailtales.vorozhbit.com/static/";
function $54f1b2c8c35b952f$var$UserPageOverview({ onCloseHandle: onCloseHandle }) {
    const [logo, setLogo] = (0, $8vqx4.useState)({});
    const [header, setHeader] = (0, $8vqx4.useState)({});
    const [loading, setLoading] = (0, $8vqx4.useState)(true);
    const [profile, setProfile] = (0, $8vqx4.useState)($54f1b2c8c35b952f$var$defaultProfile);
    const [errors, setErrors] = (0, $8vqx4.useState)({});
    const { user: user } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    (0, $8vqx4.useEffect)(()=>{
        if (!user.accessToken) return;
        fetchUserProfile();
    }, [
        user.accessToken
    ]);
    (0, $8vqx4.useEffect)(()=>{
    // console.log("header", header);
    }, [
        header
    ]);
    (0, $8vqx4.useEffect)(()=>{
    // console.log("logo", logo);
    }, [
        logo
    ]);
    (0, $8vqx4.useEffect)(()=>{
    // console.log("ERRORS", errors);
    }, [
        errors
    ]);
    const fetchUserProfile = ()=>{
        if (!user.accessToken) return;
        (0, $61e35487be0558dc$export$cb01c83fc8789b9b)(user.accessToken).then((data)=>{
            if (!data) return;
            setProfile(data);
            if (data.logo) setLogo({
                preview: `${$54f1b2c8c35b952f$var$staticUrl}${data.logo.url}`,
                id: data.logo.id
            });
            if (data.header) setHeader({
                preview: `${$54f1b2c8c35b952f$var$staticUrl}${data.header.url}`,
                id: data.header.id
            });
        }).catch((e)=>console.log(e)).finally(()=>setLoading(false));
    };
    const onSaveProfile = ()=>{
        if (!user.accessToken) return;
        const status = validateFields();
        if (!status) return;
        setLoading(true);
        const profileToSave = {
            ...profile
        };
        delete profileToSave.logo;
        delete profileToSave.header;
        const fd = new FormData();
        Object.entries(profileToSave).map((entry)=>{
            const [key, value] = entry;
            fd.append(key, value);
        });
        if (logo.data) fd.append("logo", logo.data);
        if (header.data) fd.append("header", header.data);
        (0, $61e35487be0558dc$export$c92c4ec7a2418617)(user.accessToken, fd).then(()=>fetchUserProfile()).catch((e)=>console.log(e)).finally(()=>setLoading(false));
    };
    const renderFooter = ()=>{
        return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
            className: "flex flex-row items-center justify-end gap-4",
            children: [
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    onClick: onCloseHandle,
                    className: "cursor-pointer font-simianregular text-[18px]",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                    title: "Save changes",
                    onClick: onSaveProfile,
                    theme: "dark"
                })
            ]
        });
    };
    const validateFields = ()=>{
        const er = {};
        Object.entries($54f1b2c8c35b952f$var$defaultProfile).map((el)=>{
            const [key] = el;
            if (typeof profile[key] === "string" && profile[key].length <= 1) er[key] = true;
            if (key === "logo" && Object.keys(logo).length === 0) er[key] = true;
            if (key === "header" && Object.keys(header).length === 0) er[key] = true;
        });
        setErrors(er);
        return Object.keys(er).length === 0;
    };
    const handleLogoChange = (fileList)=>{
        // const file = e.target.files[0];
        console.log("file", fileList[0]);
        const img = {
            preview: URL.createObjectURL(fileList[0]),
            data: fileList[0]
        };
        setLogo(img);
    };
    const handleHeaderChange = (fileList)=>{
        // const file = e.target.files[0];
        const img = {
            preview: URL.createObjectURL(fileList[0]),
            data: fileList[0]
        };
        setHeader(img);
    };
    if (loading) return;
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $7dff8b7841c3531f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                    className: "mb-10 flex flex-col gap-10 text-[#474747]",
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "font-simianregular text-[20px] leading-none text-[#0B0B0B]",
                                    children: "Shelter logo"
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: "Ensure your uploaded image are high-quality JPEG or PNG files, with a maximum size of 2 MB per file."
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $e15d0f29bf23b2da$export$2e2bcd8739ae039), {
                                    files: [
                                        logo
                                    ],
                                    onChangeHandler: handleLogoChange,
                                    err: errors.logo
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "font-simianregular text-[20px] leading-none text-[#0B0B0B]",
                                    children: "Cover image"
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: "Please upload a cover image that highlights the best aspects of your dog shelter - the happy environment, staff-dog bonds, or unique features. A compelling image not only reflects your shelter's essence but also attracts potential adopters and donators."
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: "Ensure your uploaded image are high-quality JPEG or PNG files, with a maximum size of 2 MB per file."
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $e15d0f29bf23b2da$export$2e2bcd8739ae039), {
                                    files: [
                                        header
                                    ],
                                    onChangeHandler: handleHeaderChange,
                                    err: errors.header
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex max-w-[850px] flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "font-simianregular text-[20px] leading-none text-[#0B0B0B]",
                                    children: "Shelter description"
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $19ec67d6e360fae6$export$2e2bcd8739ae039), {
                                        name: "title",
                                        label: "Shelter title",
                                        value: profile.title,
                                        onChange: (e)=>setProfile((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    title: e.target.value
                                                };
                                            }),
                                        error: errors.title
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: "Craft a compelling shelter description to connect with potential adopters. Eg. share your mission, highlight your facilities, introduce your dedicated team, showcase success stories. Your words help dogs find loving homes."
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $dd6be6f427e76170$export$2e2bcd8739ae039), {
                                        name: "desc",
                                        label: "About shelter",
                                        value: profile.desc,
                                        rows: 10,
                                        onChange: (e)=>setProfile((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    desc: e.target.value
                                                };
                                            }),
                                        error: errors.desc
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex max-w-[850px] flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "font-simianregular text-[20px] leading-none text-[#0B0B0B]",
                                    children: "Contact"
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $19ec67d6e360fae6$export$2e2bcd8739ae039), {
                                        name: "street",
                                        label: "Street",
                                        value: profile.street,
                                        onChange: (e)=>setProfile((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    street: e.target.value
                                                };
                                            }),
                                        error: errors.street
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                    className: "grid grid-cols-3 gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                            className: "col-span-2",
                                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $19ec67d6e360fae6$export$2e2bcd8739ae039), {
                                                name: "city",
                                                label: "City",
                                                value: profile.city,
                                                onChange: (e)=>setProfile((prevState)=>{
                                                        return {
                                                            ...prevState,
                                                            city: e.target.value
                                                        };
                                                    }),
                                                error: errors.city
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $19ec67d6e360fae6$export$2e2bcd8739ae039), {
                                                name: "postcode",
                                                label: "Postal code",
                                                value: profile.postcode,
                                                onChange: (e)=>setProfile((prevState)=>{
                                                        return {
                                                            ...prevState,
                                                            postcode: e.target.value
                                                        };
                                                    }),
                                                error: errors.postcode
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $19ec67d6e360fae6$export$2e2bcd8739ae039), {
                                        name: "country",
                                        label: "Country",
                                        value: profile.country,
                                        onChange: (e)=>setProfile((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    country: e.target.value
                                                };
                                            }),
                                        error: errors.country
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $19ec67d6e360fae6$export$2e2bcd8739ae039), {
                                        name: "website",
                                        label: "Website",
                                        value: profile.website,
                                        onChange: (e)=>setProfile((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    website: e.target.value
                                                };
                                            }),
                                        error: errors.website
                                    })
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $19ec67d6e360fae6$export$2e2bcd8739ae039), {
                                        name: "phone",
                                        label: "Phone",
                                        value: profile.phone,
                                        onChange: (e)=>setProfile((prevState)=>{
                                                return {
                                                    ...prevState,
                                                    phone: e.target.value
                                                };
                                            }),
                                        error: errors.phone
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $83934f715a68a9ab$export$2e2bcd8739ae039), {
                children: renderFooter()
            })
        ]
    });
}
function $54f1b2c8c35b952f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $44a22ec1fae97653$export$491fab5ec9b43e74), {
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($54f1b2c8c35b952f$var$UserPageOverview, {
            ...props
        })
    });
}


function $2771ba45fb83b94f$export$2e2bcd8739ae039() {
    const [showSidebar, setShowSidebar] = (0, $8vqx4.useState)(false);
    const { user: user } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    const userDispatch = (0, $44a22ec1fae97653$export$5bd0aba7f9e819b6)();
    (0, $8vqx4.useEffect)(()=>{
        setShowSidebar(!!user.page);
    }, [
        user.page
    ]);
    const onCloseHandle = ()=>{
        userDispatch({
            type: "set-page",
            payload: {
                page: null,
                pageParams: undefined
            }
        });
        setShowSidebar(false);
    };
    const renderHeader = ()=>{
        const menu = [
            {
                title: "Overview",
                id: "overview"
            },
            {
                title: "Our dogs",
                id: "our-dogs"
            },
            {
                title: "Add dog",
                id: "add-dog",
                pageParams: undefined
            }
        ];
        return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "flex flex-row gap-10",
            children: menu.map((item)=>{
                const isActive = user.page === item.id;
                return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: `cursor-pointer border-b-[2px] border-white pb-6 pt-8 hover:border-black ${isActive || item.id === "our-dogs" && user.page === "edit-dog" ? "!border-black" : "!text-[#838383]"}`,
                    onClick: ()=>{
                        if (isActive) return;
                        userDispatch({
                            type: "set-page",
                            payload: {
                                page: item.id,
                                pageParams: item.pageParams
                            }
                        });
                    },
                    children: item.title
                }, item.id);
            })
        });
    };
    const renderPage = ()=>{
        let page = /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $7dff8b7841c3531f$export$2e2bcd8739ae039), {
            children: "User page"
        });
        if (user.page === "overview") page = /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $54f1b2c8c35b952f$export$2e2bcd8739ae039), {
            onCloseHandle: onCloseHandle
        });
        if (user.page === "our-dogs") page = /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $17503828e15e2648$export$2e2bcd8739ae039), {});
        if (user.page === "add-dog") page = /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $19dff358b96c2758$export$2e2bcd8739ae039), {});
        if (user.page === "edit-dog") page = /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $19dff358b96c2758$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $075513266c39e734$export$2e2bcd8739ae039), {
            show: showSidebar,
            onClose: onCloseHandle,
            title: renderHeader(),
            topOffset: 62,
            children: page
        });
    };
    return renderPage();
}



parcelRequire("8vqx4");


function $dd3e4f79026e5b67$export$2e2bcd8739ae039() {
    const { user: user, logout: logout } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    const userDispatch = (0, $44a22ec1fae97653$export$5bd0aba7f9e819b6)();
    const setOverviewPage = ()=>{
        userDispatch({
            type: "set-page",
            payload: {
                page: "overview"
            }
        });
    };
    if (!user.accessToken || !user.profile) return null;
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "bg-[#131313]",
        id: "user-bar",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "font-barlowlight text-[#FFF]",
            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "flex flex-row items-center justify-between px-5 py-2.5",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "flex flex-row items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                className: "h-[10px] w-[10px] rounded-full bg-[#066B28]"
                            }),
                            " ",
                            user.profile.title
                        ]
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "flex flex-row items-center gap-5",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                className: "cursor-pointer",
                                onClick: ()=>logout(),
                                children: "Logout"
                            }),
                            user && user.profile.role === "shelter" && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                className: `flex h-[42px] w-[42px] cursor-pointer items-center justify-center rounded-full hover:bg-[#2C2619] ${user.page === "overview" ? "bg-[#2C2619]" : "bg-[#1B1B1B]"}`,
                                onClick: setOverviewPage,
                                children: (0, $697654d10ef148cd$export$1718df1744846756)()
                            })
                        ]
                    })
                ]
            })
        })
    });
}


function $002784782296ad06$export$2e2bcd8739ae039({ dark: dark = false }) {
    const { user: user, logout: logout } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("main", {
        className: `relative flex flex-grow flex-col bg-no-repeat ${dark ? "bg-[#0C0202]" : "bg-theme-white"}`,
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $dd3e4f79026e5b67$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $31ff363aba87b0b6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "flex flex-grow flex-col",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $68c2f6a70206c369$export$910ae8079b2c2852), {})
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $2771ba45fb83b94f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $c5f0ee832958afb6$export$2e2bcd8739ae039), {})
        ]
    });
}



parcelRequire("8vqx4");

function $4d846d157e816664$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("main", {
        className: "relative flex flex-grow flex-col bg-[#131313] text-white",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "flex flex-grow flex-col",
            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $68c2f6a70206c369$export$910ae8079b2c2852), {})
        })
    });
}





var $8vqx4 = parcelRequire("8vqx4");
function $d0667814149503ac$export$2e2bcd8739ae039() {
    (0, $8vqx4.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "container mx-auto",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
            className: "flex flex-col gap-4 p-5",
            children: [
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("p", {
                    children: "Welcome to Tailtales, an innovative platform designed to revolutionize the dog adoption process by uniting dog shelters across Europe on a single digital platform."
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("p", {
                    children: "Our goal is to expand the reach of shelters, increase adoption opportunities, and simplify, secure, and enhance the entire experience for everyone involved."
                })
            ]
        })
    });
}




var $8vqx4 = parcelRequire("8vqx4");



var $8vqx4 = parcelRequire("8vqx4");




var $8vqx4 = parcelRequire("8vqx4");





/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2b1309f325581922$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const $2b1309f325581922$export$2e2bcd8739ae039 = (0, $55d271daf0d1362b$export$2e2bcd8739ae039)("Check", $2b1309f325581922$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3988130f99a827cb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
            key: "ul74o6"
        }
    ],
    [
        "path",
        {
            d: "m14 7 3 3",
            key: "1r5n42"
        }
    ],
    [
        "path",
        {
            d: "M5 6v4",
            key: "ilb8ba"
        }
    ],
    [
        "path",
        {
            d: "M19 14v4",
            key: "blhpug"
        }
    ],
    [
        "path",
        {
            d: "M10 2v2",
            key: "7u0qdc"
        }
    ],
    [
        "path",
        {
            d: "M7 8H3",
            key: "zfb6yr"
        }
    ],
    [
        "path",
        {
            d: "M21 16h-4",
            key: "1cnmox"
        }
    ],
    [
        "path",
        {
            d: "M11 3H9",
            key: "1obp7u"
        }
    ]
];
const $3988130f99a827cb$export$2e2bcd8739ae039 = (0, $55d271daf0d1362b$export$2e2bcd8739ae039)("WandSparkles", $3988130f99a827cb$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4e7c658008b40246$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
];
const $4e7c658008b40246$export$2e2bcd8739ae039 = (0, $55d271daf0d1362b$export$2e2bcd8739ae039)("CircleX", $4e7c658008b40246$export$3efd853dbb351e94);



var $8vqx4 = parcelRequire("8vqx4");



parcelRequire("8vqx4");

const $8367922339ab77c6$export$48443d129636634d = (0, $433b3049f3517ea6$export$87dc52566e90b739)("inline-flex items-center rounded-md border px-2.5 py-0.5 text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
    variants: {
        variant: {
            default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
            secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
            destructive: "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
            outline: "text-foreground"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function $8367922339ab77c6$export$37acb3580601e69a({ className: className, variant: variant, ...props }) {
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: (0, $db53bf731136662c$export$1343a74baacb0543)($8367922339ab77c6$export$48443d129636634d({
            variant: variant
        }), className),
        ...props
    });
}



// src/slot.tsx

var $8vqx4 = parcelRequire("8vqx4");


var $db387db953595243$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $db387db953595243$var$use = $8vqx4[" use ".trim().toString()];
function $db387db953595243$var$isPromiseLike(value) {
    return typeof value === "object" && value !== null && "then" in value;
}
function $db387db953595243$var$isLazyComponent(element) {
    return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === $db387db953595243$var$REACT_LAZY_TYPE && "_payload" in element && $db387db953595243$var$isPromiseLike(element._payload);
}
// @__NO_SIDE_EFFECTS__
function $db387db953595243$export$e88b45bda5c13eb9(ownerName) {
    const SlotClone = /* @__PURE__ */ $db387db953595243$var$createSlotClone(ownerName);
    const Slot2 = $8vqx4.forwardRef((props, forwardedRef)=>{
        let { children: children, ...slotProps } = props;
        if ($db387db953595243$var$isLazyComponent(children) && typeof $db387db953595243$var$use === "function") children = $db387db953595243$var$use(children._payload);
        const childrenArray = $8vqx4.Children.toArray(children);
        const slottable = childrenArray.find($db387db953595243$var$isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if ($8vqx4.Children.count(newElement) > 1) return $8vqx4.Children.only(null);
                    return $8vqx4.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: $8vqx4.isValidElement(newElement) ? $8vqx4.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $db387db953595243$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $db387db953595243$export$e88b45bda5c13eb9("Slot");
// @__NO_SIDE_EFFECTS__
function $db387db953595243$var$createSlotClone(ownerName) {
    const SlotClone = $8vqx4.forwardRef((props, forwardedRef)=>{
        let { children: children, ...slotProps } = props;
        if ($db387db953595243$var$isLazyComponent(children) && typeof $db387db953595243$var$use === "function") children = $db387db953595243$var$use(children._payload);
        if ($8vqx4.isValidElement(children)) {
            const childrenRef = $db387db953595243$var$getElementRef(children);
            const props2 = $db387db953595243$var$mergeProps(slotProps, children.props);
            if (children.type !== $8vqx4.Fragment) props2.ref = forwardedRef ? (0, $d64198ac8789ff5a$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef;
            return $8vqx4.cloneElement(children, props2);
        }
        return $8vqx4.Children.count(children) > 1 ? $8vqx4.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var $db387db953595243$var$SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $db387db953595243$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = ({ children: children })=>{
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $607ae91d1eb97195$exports.Fragment), {
            children: children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $db387db953595243$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $db387db953595243$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $db387db953595243$export$bf68c29d8281d0f7("Slottable");
function $db387db953595243$var$isSlottable(child) {
    return $8vqx4.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $db387db953595243$var$SLOTTABLE_IDENTIFIER;
}
function $db387db953595243$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $db387db953595243$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}




var $8vqx4 = parcelRequire("8vqx4");

const $d0c52b32c142f53d$export$dca1ee5a936bb312 = (0, $433b3049f3517ea6$export$87dc52566e90b739)("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
            outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline"
        },
        size: {
            default: "h-9 px-4 py-2",
            sm: "h-8 rounded-md px-3 text-xs",
            lg: "h-10 rounded-md px-8",
            icon: "h-9 w-9"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
const $d0c52b32c142f53d$export$353f5b6fc5456de1 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, variant: variant, size: size, asChild: asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, $db387db953595243$export$be92b6f5f03c0fe9) : "button";
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)(Comp, {
        className: (0, $db53bf731136662c$export$1343a74baacb0543)($d0c52b32c142f53d$export$dca1ee5a936bb312({
            variant: variant,
            size: size,
            className: className
        })),
        ref: ref,
        ...props
    });
});
$d0c52b32c142f53d$export$353f5b6fc5456de1.displayName = "Button";



var $7c760635b8416a4b$var$U = 1, $7c760635b8416a4b$var$Y = .9, $7c760635b8416a4b$var$H = .8, $7c760635b8416a4b$var$J = .17, $7c760635b8416a4b$var$p = .1, $7c760635b8416a4b$var$u = .999, $7c760635b8416a4b$var$$ = .9999;
var $7c760635b8416a4b$var$k = .99, $7c760635b8416a4b$var$m = /[\\\/_+.#"@\[\(\{&]/, $7c760635b8416a4b$var$B = /[\\\/_+.#"@\[\(\{&]/g, $7c760635b8416a4b$var$K = /[\s-]/, $7c760635b8416a4b$var$X = /[\s-]/g;
function $7c760635b8416a4b$var$G(_, C, h, P, A, f, O) {
    if (f === C.length) return A === _.length ? $7c760635b8416a4b$var$U : $7c760635b8416a4b$var$k;
    var T = `${A},${f}`;
    if (O[T] !== void 0) return O[T];
    for(var L = P.charAt(f), c = h.indexOf(L, A), S = 0, E, N, R, M; c >= 0;)E = $7c760635b8416a4b$var$G(_, C, h, P, c + 1, f + 1, O), E > S && (c === A ? E *= $7c760635b8416a4b$var$U : $7c760635b8416a4b$var$m.test(_.charAt(c - 1)) ? (E *= $7c760635b8416a4b$var$H, R = _.slice(A, c - 1).match($7c760635b8416a4b$var$B), R && A > 0 && (E *= Math.pow($7c760635b8416a4b$var$u, R.length))) : $7c760635b8416a4b$var$K.test(_.charAt(c - 1)) ? (E *= $7c760635b8416a4b$var$Y, M = _.slice(A, c - 1).match($7c760635b8416a4b$var$X), M && A > 0 && (E *= Math.pow($7c760635b8416a4b$var$u, M.length))) : (E *= $7c760635b8416a4b$var$J, A > 0 && (E *= Math.pow($7c760635b8416a4b$var$u, c - A))), _.charAt(c) !== C.charAt(f) && (E *= $7c760635b8416a4b$var$$)), (E < $7c760635b8416a4b$var$p && h.charAt(c - 1) === P.charAt(f + 1) || P.charAt(f + 1) === P.charAt(f) && h.charAt(c - 1) !== P.charAt(f)) && (N = $7c760635b8416a4b$var$G(_, C, h, P, c + 1, f + 2, O), N * $7c760635b8416a4b$var$p > E && (E = N * $7c760635b8416a4b$var$p)), E > S && (S = E), c = h.indexOf(L, c + 1);
    return O[T] = S, S;
}
function $7c760635b8416a4b$var$D(_) {
    return _.toLowerCase().replace($7c760635b8416a4b$var$X, " ");
}
function $7c760635b8416a4b$export$407448d2b89b1813(_, C, h) {
    return _ = h && h.length > 0 ? `${_ + " " + h.join(" ")}` : _, $7c760635b8416a4b$var$G(_, C, $7c760635b8416a4b$var$D(_), $7c760635b8416a4b$var$D(C), 0, 0, {});
}




var $8vqx4 = parcelRequire("8vqx4");
// src/primitive.tsx

var $8vqx4 = parcelRequire("8vqx4");

var $hiyfL = parcelRequire("hiyfL");


var $be70c59ab91df9ff$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $be70c59ab91df9ff$export$250ffa63cdc0d034 = $be70c59ab91df9ff$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $db387db953595243$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $8vqx4.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $be70c59ab91df9ff$export$6d1a0317bde7de7f(target, event) {
    if (target) $hiyfL.flushSync(()=>target.dispatchEvent(event));
}
var $be70c59ab91df9ff$export$be92b6f5f03c0fe9 = $be70c59ab91df9ff$export$250ffa63cdc0d034;




"use client";
var $3aa0c79b2a27502b$var$N = '[cmdk-group=""]', $3aa0c79b2a27502b$var$Y = '[cmdk-group-items=""]', $3aa0c79b2a27502b$var$be = '[cmdk-group-heading=""]', $3aa0c79b2a27502b$var$le = '[cmdk-item=""]', $3aa0c79b2a27502b$var$ce = `${$3aa0c79b2a27502b$var$le}:not([aria-disabled="true"])`, $3aa0c79b2a27502b$var$Z = "cmdk-item-select", $3aa0c79b2a27502b$var$T = "data-value", $3aa0c79b2a27502b$export$3f6f640afaf1ec43 = (r, o, n)=>(0, $7c760635b8416a4b$export$407448d2b89b1813)(r, o, n), $3aa0c79b2a27502b$var$ue = $8vqx4.createContext(void 0), $3aa0c79b2a27502b$var$K = ()=>$8vqx4.useContext($3aa0c79b2a27502b$var$ue), $3aa0c79b2a27502b$var$de = $8vqx4.createContext(void 0), $3aa0c79b2a27502b$var$ee = ()=>$8vqx4.useContext($3aa0c79b2a27502b$var$de), $3aa0c79b2a27502b$var$fe = $8vqx4.createContext(void 0), $3aa0c79b2a27502b$export$6def88b96ee4affb = $8vqx4.forwardRef((r, o)=>{
    let n = $3aa0c79b2a27502b$var$L(()=>{
        var e, a;
        return {
            search: "",
            value: (a = (e = r.value) != null ? e : r.defaultValue) != null ? a : "",
            selectedItemId: void 0,
            filtered: {
                count: 0,
                items: new Map,
                groups: new Set
            }
        };
    }), u = $3aa0c79b2a27502b$var$L(()=>new Set), c = $3aa0c79b2a27502b$var$L(()=>new Map), d = $3aa0c79b2a27502b$var$L(()=>new Map), f = $3aa0c79b2a27502b$var$L(()=>new Set), p = $3aa0c79b2a27502b$var$pe(r), { label: b, children: m, value: R, onValueChange: x, filter: C, shouldFilter: S, loop: A, disablePointerSelection: ge = !1, vimBindings: j = !0, ...O } = r, $ = (0, $48f6e55cf3c4c05f$export$f680877a34711e37)(), q = (0, $48f6e55cf3c4c05f$export$f680877a34711e37)(), _ = (0, $48f6e55cf3c4c05f$export$f680877a34711e37)(), I = $8vqx4.useRef(null), v = $3aa0c79b2a27502b$var$ke();
    $3aa0c79b2a27502b$var$k(()=>{
        if (R !== void 0) {
            let e = R.trim();
            n.current.value = e, E.emit();
        }
    }, [
        R
    ]), $3aa0c79b2a27502b$var$k(()=>{
        v(6, ne);
    }, []);
    let E = $8vqx4.useMemo(()=>({
            subscribe: (e)=>(f.current.add(e), ()=>f.current.delete(e)),
            snapshot: ()=>n.current,
            setState: (e, a, s)=>{
                var i, l, g, y;
                if (!Object.is(n.current[e], a)) {
                    if (n.current[e] = a, e === "search") J(), z(), v(1, W);
                    else if (e === "value") {
                        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
                            let h = document.getElementById(_);
                            h ? h.focus() : (i = document.getElementById($)) == null || i.focus();
                        }
                        if (v(7, ()=>{
                            var h;
                            n.current.selectedItemId = (h = M()) == null ? void 0 : h.id, E.emit();
                        }), s || v(5, ne), ((l = p.current) == null ? void 0 : l.value) !== void 0) {
                            let h = a != null ? a : "";
                            (y = (g = p.current).onValueChange) == null || y.call(g, h);
                            return;
                        }
                    }
                    E.emit();
                }
            },
            emit: ()=>{
                f.current.forEach((e)=>e());
            }
        }), []), U = $8vqx4.useMemo(()=>({
            value: (e, a, s)=>{
                var i;
                a !== ((i = d.current.get(e)) == null ? void 0 : i.value) && (d.current.set(e, {
                    value: a,
                    keywords: s
                }), n.current.filtered.items.set(e, te(a, s)), v(2, ()=>{
                    z(), E.emit();
                }));
            },
            item: (e, a)=>(u.current.add(e), a && (c.current.has(a) ? c.current.get(a).add(e) : c.current.set(a, new Set([
                    e
                ]))), v(3, ()=>{
                    J(), z(), n.current.value || W(), E.emit();
                }), ()=>{
                    d.current.delete(e), u.current.delete(e), n.current.filtered.items.delete(e);
                    let s = M();
                    v(4, ()=>{
                        J(), (s == null ? void 0 : s.getAttribute("id")) === e && W(), E.emit();
                    });
                }),
            group: (e)=>(c.current.has(e) || c.current.set(e, new Set), ()=>{
                    d.current.delete(e), c.current.delete(e);
                }),
            filter: ()=>p.current.shouldFilter,
            label: b || r["aria-label"],
            getDisablePointerSelection: ()=>p.current.disablePointerSelection,
            listId: $,
            inputId: _,
            labelId: q,
            listInnerRef: I
        }), []);
    function te(e, a) {
        var i, l;
        let s = (l = (i = p.current) == null ? void 0 : i.filter) != null ? l : $3aa0c79b2a27502b$export$3f6f640afaf1ec43;
        return e ? s(e, n.current.search, a) : 0;
    }
    function z() {
        if (!n.current.search || p.current.shouldFilter === !1) return;
        let e = n.current.filtered.items, a = [];
        n.current.filtered.groups.forEach((i)=>{
            let l = c.current.get(i), g = 0;
            l.forEach((y)=>{
                let h = e.get(y);
                g = Math.max(h, g);
            }), a.push([
                i,
                g
            ]);
        });
        let s = I.current;
        V().sort((i, l)=>{
            var h, F;
            let g = i.getAttribute("id"), y = l.getAttribute("id");
            return ((h = e.get(y)) != null ? h : 0) - ((F = e.get(g)) != null ? F : 0);
        }).forEach((i)=>{
            let l = i.closest($3aa0c79b2a27502b$var$Y);
            l ? l.appendChild(i.parentElement === l ? i : i.closest(`${$3aa0c79b2a27502b$var$Y} > *`)) : s.appendChild(i.parentElement === s ? i : i.closest(`${$3aa0c79b2a27502b$var$Y} > *`));
        }), a.sort((i, l)=>l[1] - i[1]).forEach((i)=>{
            var g;
            let l = (g = I.current) == null ? void 0 : g.querySelector(`${$3aa0c79b2a27502b$var$N}[${$3aa0c79b2a27502b$var$T}="${encodeURIComponent(i[0])}"]`);
            l == null || l.parentElement.appendChild(l);
        });
    }
    function W() {
        let e = V().find((s)=>s.getAttribute("aria-disabled") !== "true"), a = e == null ? void 0 : e.getAttribute($3aa0c79b2a27502b$var$T);
        E.setState("value", a || void 0);
    }
    function J() {
        var a, s, i, l;
        if (!n.current.search || p.current.shouldFilter === !1) {
            n.current.filtered.count = u.current.size;
            return;
        }
        n.current.filtered.groups = new Set;
        let e = 0;
        for (let g of u.current){
            let y = (s = (a = d.current.get(g)) == null ? void 0 : a.value) != null ? s : "", h = (l = (i = d.current.get(g)) == null ? void 0 : i.keywords) != null ? l : [], F = te(y, h);
            n.current.filtered.items.set(g, F), F > 0 && e++;
        }
        for (let [g, y] of c.current)for (let h of y)if (n.current.filtered.items.get(h) > 0) {
            n.current.filtered.groups.add(g);
            break;
        }
        n.current.filtered.count = e;
    }
    function ne() {
        var a, s, i;
        let e = M();
        e && (((a = e.parentElement) == null ? void 0 : a.firstChild) === e && ((i = (s = e.closest($3aa0c79b2a27502b$var$N)) == null ? void 0 : s.querySelector($3aa0c79b2a27502b$var$be)) == null || i.scrollIntoView({
            block: "nearest"
        })), e.scrollIntoView({
            block: "nearest"
        }));
    }
    function M() {
        var e;
        return (e = I.current) == null ? void 0 : e.querySelector(`${$3aa0c79b2a27502b$var$le}[aria-selected="true"]`);
    }
    function V() {
        var e;
        return Array.from(((e = I.current) == null ? void 0 : e.querySelectorAll($3aa0c79b2a27502b$var$ce)) || []);
    }
    function X(e) {
        let s = V()[e];
        s && E.setState("value", s.getAttribute($3aa0c79b2a27502b$var$T));
    }
    function Q(e) {
        var g;
        let a = M(), s = V(), i = s.findIndex((y)=>y === a), l = s[i + e];
        (g = p.current) != null && g.loop && (l = i + e < 0 ? s[s.length - 1] : i + e === s.length ? s[0] : s[i + e]), l && E.setState("value", l.getAttribute($3aa0c79b2a27502b$var$T));
    }
    function re(e) {
        let a = M(), s = a == null ? void 0 : a.closest($3aa0c79b2a27502b$var$N), i;
        for(; s && !i;)s = e > 0 ? $3aa0c79b2a27502b$var$we(s, $3aa0c79b2a27502b$var$N) : $3aa0c79b2a27502b$var$De(s, $3aa0c79b2a27502b$var$N), i = s == null ? void 0 : s.querySelector($3aa0c79b2a27502b$var$ce);
        i ? E.setState("value", i.getAttribute($3aa0c79b2a27502b$var$T)) : Q(e);
    }
    let oe = ()=>X(V().length - 1), ie = (e)=>{
        e.preventDefault(), e.metaKey ? oe() : e.altKey ? re(1) : Q(1);
    }, se = (e)=>{
        e.preventDefault(), e.metaKey ? X(0) : e.altKey ? re(-1) : Q(-1);
    };
    return $8vqx4.createElement((0, $be70c59ab91df9ff$export$250ffa63cdc0d034).div, {
        ref: o,
        tabIndex: -1,
        ...O,
        "cmdk-root": "",
        onKeyDown: (e)=>{
            var s;
            (s = O.onKeyDown) == null || s.call(O, e);
            let a = e.nativeEvent.isComposing || e.keyCode === 229;
            if (!(e.defaultPrevented || a)) switch(e.key){
                case "n":
                case "j":
                    j && e.ctrlKey && ie(e);
                    break;
                case "ArrowDown":
                    ie(e);
                    break;
                case "p":
                case "k":
                    j && e.ctrlKey && se(e);
                    break;
                case "ArrowUp":
                    se(e);
                    break;
                case "Home":
                    e.preventDefault(), X(0);
                    break;
                case "End":
                    e.preventDefault(), oe();
                    break;
                case "Enter":
                    {
                        e.preventDefault();
                        let i = M();
                        if (i) {
                            let l = new Event($3aa0c79b2a27502b$var$Z);
                            i.dispatchEvent(l);
                        }
                    }
            }
        }
    }, $8vqx4.createElement("label", {
        "cmdk-label": "",
        htmlFor: U.inputId,
        id: U.labelId,
        style: $3aa0c79b2a27502b$var$Te
    }, b), $3aa0c79b2a27502b$var$B(r, (e)=>$8vqx4.createElement($3aa0c79b2a27502b$var$de.Provider, {
            value: E
        }, $8vqx4.createElement($3aa0c79b2a27502b$var$ue.Provider, {
            value: U
        }, e))));
}), $3aa0c79b2a27502b$export$b9b346a733d36f61 = $8vqx4.forwardRef((r, o)=>{
    var _, I;
    let n = (0, $48f6e55cf3c4c05f$export$f680877a34711e37)(), u = $8vqx4.useRef(null), c = $8vqx4.useContext($3aa0c79b2a27502b$var$fe), d = $3aa0c79b2a27502b$var$K(), f = $3aa0c79b2a27502b$var$pe(r), p = (I = (_ = f.current) == null ? void 0 : _.forceMount) != null ? I : c == null ? void 0 : c.forceMount;
    $3aa0c79b2a27502b$var$k(()=>{
        if (!p) return d.item(n, c == null ? void 0 : c.id);
    }, [
        p
    ]);
    let b = $3aa0c79b2a27502b$var$ve(n, u, [
        r.value,
        r.children,
        u
    ], r.keywords), m = $3aa0c79b2a27502b$var$ee(), R = $3aa0c79b2a27502b$export$606184d999862dff((v)=>v.value && v.value === b.current), x = $3aa0c79b2a27502b$export$606184d999862dff((v)=>p || d.filter() === !1 ? !0 : v.search ? v.filtered.items.get(n) > 0 : !0);
    $8vqx4.useEffect(()=>{
        let v = u.current;
        if (!(!v || r.disabled)) return v.addEventListener($3aa0c79b2a27502b$var$Z, C), ()=>v.removeEventListener($3aa0c79b2a27502b$var$Z, C);
    }, [
        x,
        r.onSelect,
        r.disabled
    ]);
    function C() {
        var v, E;
        S(), (E = (v = f.current).onSelect) == null || E.call(v, b.current);
    }
    function S() {
        m.setState("value", b.current, !0);
    }
    if (!x) return null;
    let { disabled: A, value: ge, onSelect: j, forceMount: O, keywords: $, ...q } = r;
    return $8vqx4.createElement((0, $be70c59ab91df9ff$export$250ffa63cdc0d034).div, {
        ref: (0, $d64198ac8789ff5a$export$43e446d32b3d21af)(u, o),
        ...q,
        id: n,
        "cmdk-item": "",
        role: "option",
        "aria-disabled": !!A,
        "aria-selected": !!R,
        "data-disabled": !!A,
        "data-selected": !!R,
        onPointerMove: A || d.getDisablePointerSelection() ? void 0 : S,
        onClick: A ? void 0 : C
    }, r.children);
}), $3aa0c79b2a27502b$export$c157b9873a7a0fbd = $8vqx4.forwardRef((r, o)=>{
    let { heading: n, children: u, forceMount: c, ...d } = r, f = (0, $48f6e55cf3c4c05f$export$f680877a34711e37)(), p = $8vqx4.useRef(null), b = $8vqx4.useRef(null), m = (0, $48f6e55cf3c4c05f$export$f680877a34711e37)(), R = $3aa0c79b2a27502b$var$K(), x = $3aa0c79b2a27502b$export$606184d999862dff((S)=>c || R.filter() === !1 ? !0 : S.search ? S.filtered.groups.has(f) : !0);
    $3aa0c79b2a27502b$var$k(()=>R.group(f), []), $3aa0c79b2a27502b$var$ve(f, p, [
        r.value,
        r.heading,
        b
    ]);
    let C = $8vqx4.useMemo(()=>({
            id: f,
            forceMount: c
        }), [
        c
    ]);
    return $8vqx4.createElement((0, $be70c59ab91df9ff$export$250ffa63cdc0d034).div, {
        ref: (0, $d64198ac8789ff5a$export$43e446d32b3d21af)(p, o),
        ...d,
        "cmdk-group": "",
        role: "presentation",
        hidden: x ? void 0 : !0
    }, n && $8vqx4.createElement("div", {
        ref: b,
        "cmdk-group-heading": "",
        "aria-hidden": !0,
        id: m
    }, n), $3aa0c79b2a27502b$var$B(r, (S)=>$8vqx4.createElement("div", {
            "cmdk-group-items": "",
            role: "group",
            "aria-labelledby": n ? m : void 0
        }, $8vqx4.createElement($3aa0c79b2a27502b$var$fe.Provider, {
            value: C
        }, S))));
}), $3aa0c79b2a27502b$export$ace649eed6990b42 = $8vqx4.forwardRef((r, o)=>{
    let { alwaysRender: n, ...u } = r, c = $8vqx4.useRef(null), d = $3aa0c79b2a27502b$export$606184d999862dff((f)=>!f.search);
    return !n && !d ? null : $8vqx4.createElement((0, $be70c59ab91df9ff$export$250ffa63cdc0d034).div, {
        ref: (0, $d64198ac8789ff5a$export$43e446d32b3d21af)(c, o),
        ...u,
        "cmdk-separator": "",
        role: "separator"
    });
}), $3aa0c79b2a27502b$export$ebdebb88e46df62a = $8vqx4.forwardRef((r, o)=>{
    let { onValueChange: n, ...u } = r, c = r.value != null, d = $3aa0c79b2a27502b$var$ee(), f = $3aa0c79b2a27502b$export$606184d999862dff((m)=>m.search), p = $3aa0c79b2a27502b$export$606184d999862dff((m)=>m.selectedItemId), b = $3aa0c79b2a27502b$var$K();
    return $8vqx4.useEffect(()=>{
        r.value != null && d.setState("search", r.value);
    }, [
        r.value
    ]), $8vqx4.createElement((0, $be70c59ab91df9ff$export$250ffa63cdc0d034).input, {
        ref: o,
        ...u,
        "cmdk-input": "",
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: !1,
        "aria-autocomplete": "list",
        role: "combobox",
        "aria-expanded": !0,
        "aria-controls": b.listId,
        "aria-labelledby": b.labelId,
        "aria-activedescendant": p,
        id: b.inputId,
        type: "text",
        value: c ? r.value : f,
        onChange: (m)=>{
            c || d.setState("search", m.target.value), n == null || n(m.target.value);
        }
    });
}), $3aa0c79b2a27502b$export$9cffcb65e9381872 = $8vqx4.forwardRef((r, o)=>{
    let { children: n, label: u = "Suggestions", ...c } = r, d = $8vqx4.useRef(null), f = $8vqx4.useRef(null), p = $3aa0c79b2a27502b$export$606184d999862dff((m)=>m.selectedItemId), b = $3aa0c79b2a27502b$var$K();
    return $8vqx4.useEffect(()=>{
        if (f.current && d.current) {
            let m = f.current, R = d.current, x, C = new ResizeObserver(()=>{
                x = requestAnimationFrame(()=>{
                    let S = m.offsetHeight;
                    R.style.setProperty("--cmdk-list-height", S.toFixed(1) + "px");
                });
            });
            return C.observe(m), ()=>{
                cancelAnimationFrame(x), C.unobserve(m);
            };
        }
    }, []), $8vqx4.createElement((0, $be70c59ab91df9ff$export$250ffa63cdc0d034).div, {
        ref: (0, $d64198ac8789ff5a$export$43e446d32b3d21af)(d, o),
        ...c,
        "cmdk-list": "",
        role: "listbox",
        tabIndex: -1,
        "aria-activedescendant": p,
        "aria-label": u,
        id: b.listId
    }, $3aa0c79b2a27502b$var$B(r, (m)=>$8vqx4.createElement("div", {
            ref: (0, $d64198ac8789ff5a$export$43e446d32b3d21af)(f, b.listInnerRef),
            "cmdk-list-sizer": ""
        }, m)));
}), $3aa0c79b2a27502b$export$98f0540b5c04f3e8 = $8vqx4.forwardRef((r, o)=>{
    let { open: n, onOpenChange: u, overlayClassName: c, contentClassName: d, container: f, ...p } = r;
    return $8vqx4.createElement($94724b4e84955d54$export$be92b6f5f03c0fe9, {
        open: n,
        onOpenChange: u
    }, $8vqx4.createElement($94724b4e84955d54$export$602eac185826482c, {
        container: f
    }, $8vqx4.createElement($94724b4e84955d54$export$c6fdb837b070b4ff, {
        "cmdk-overlay": "",
        className: c
    }), $8vqx4.createElement($94724b4e84955d54$export$7c6e2c02157bb7d2, {
        "aria-label": r.label,
        "cmdk-dialog": "",
        className: d
    }, $8vqx4.createElement($3aa0c79b2a27502b$export$6def88b96ee4affb, {
        ref: o,
        ...p
    }))));
}), $3aa0c79b2a27502b$export$f1753c65029fce09 = $8vqx4.forwardRef((r, o)=>$3aa0c79b2a27502b$export$606184d999862dff((u)=>u.filtered.count === 0) ? $8vqx4.createElement((0, $be70c59ab91df9ff$export$250ffa63cdc0d034).div, {
        ref: o,
        ...r,
        "cmdk-empty": "",
        role: "presentation"
    }) : null), $3aa0c79b2a27502b$export$8980984ffcab084a = $8vqx4.forwardRef((r, o)=>{
    let { progress: n, children: u, label: c = "Loading...", ...d } = r;
    return $8vqx4.createElement((0, $be70c59ab91df9ff$export$250ffa63cdc0d034).div, {
        ref: o,
        ...d,
        "cmdk-loading": "",
        role: "progressbar",
        "aria-valuenow": n,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": c
    }, $3aa0c79b2a27502b$var$B(r, (f)=>$8vqx4.createElement("div", {
            "aria-hidden": !0
        }, f)));
}), $3aa0c79b2a27502b$export$cc7e12c76513e857 = Object.assign($3aa0c79b2a27502b$export$6def88b96ee4affb, {
    List: $3aa0c79b2a27502b$export$9cffcb65e9381872,
    Item: $3aa0c79b2a27502b$export$b9b346a733d36f61,
    Input: $3aa0c79b2a27502b$export$ebdebb88e46df62a,
    Group: $3aa0c79b2a27502b$export$c157b9873a7a0fbd,
    Separator: $3aa0c79b2a27502b$export$ace649eed6990b42,
    Dialog: $3aa0c79b2a27502b$export$98f0540b5c04f3e8,
    Empty: $3aa0c79b2a27502b$export$f1753c65029fce09,
    Loading: $3aa0c79b2a27502b$export$8980984ffcab084a
});
function $3aa0c79b2a27502b$var$we(r, o) {
    let n = r.nextElementSibling;
    for(; n;){
        if (n.matches(o)) return n;
        n = n.nextElementSibling;
    }
}
function $3aa0c79b2a27502b$var$De(r, o) {
    let n = r.previousElementSibling;
    for(; n;){
        if (n.matches(o)) return n;
        n = n.previousElementSibling;
    }
}
function $3aa0c79b2a27502b$var$pe(r) {
    let o = $8vqx4.useRef(r);
    return $3aa0c79b2a27502b$var$k(()=>{
        o.current = r;
    }), o;
}
var $3aa0c79b2a27502b$var$k = typeof window == "undefined" ? $8vqx4.useEffect : $8vqx4.useLayoutEffect;
function $3aa0c79b2a27502b$var$L(r) {
    let o = $8vqx4.useRef();
    return o.current === void 0 && (o.current = r()), o;
}
function $3aa0c79b2a27502b$export$606184d999862dff(r) {
    let o = $3aa0c79b2a27502b$var$ee(), n = ()=>r(o.snapshot());
    return $8vqx4.useSyncExternalStore(o.subscribe, n, n);
}
function $3aa0c79b2a27502b$var$ve(r, o, n, u = []) {
    let c = $8vqx4.useRef(), d = $3aa0c79b2a27502b$var$K();
    return $3aa0c79b2a27502b$var$k(()=>{
        var b;
        let f = (()=>{
            var m;
            for (let R of n){
                if (typeof R == "string") return R.trim();
                if (typeof R == "object" && "current" in R) return R.current ? (m = R.current.textContent) == null ? void 0 : m.trim() : c.current;
            }
        })(), p = u.map((m)=>m.trim());
        d.value(r, f, p), (b = o.current) == null || b.setAttribute($3aa0c79b2a27502b$var$T, f), c.current = f;
    }), c;
}
var $3aa0c79b2a27502b$var$ke = ()=>{
    let [r, o] = $8vqx4.useState(), n = $3aa0c79b2a27502b$var$L(()=>new Map);
    return $3aa0c79b2a27502b$var$k(()=>{
        n.current.forEach((u)=>u()), n.current = new Map;
    }, [
        r
    ]), (u, c)=>{
        n.current.set(u, c), o({});
    };
};
function $3aa0c79b2a27502b$var$Me(r) {
    let o = r.type;
    return typeof o == "function" ? o(r.props) : "render" in o ? o.render(r.props) : r;
}
function $3aa0c79b2a27502b$var$B({ asChild: r, children: o }, n) {
    return r && $8vqx4.isValidElement(o) ? $8vqx4.cloneElement($3aa0c79b2a27502b$var$Me(o), {
        ref: o.ref
    }, n(o.props.children)) : n(o);
}
var $3aa0c79b2a27502b$var$Te = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: "0"
};


/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $15afd6f13c43ffb9$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "path",
        {
            d: "m21 21-4.3-4.3",
            key: "1qie3q"
        }
    ]
];
const $15afd6f13c43ffb9$export$2e2bcd8739ae039 = (0, $55d271daf0d1362b$export$2e2bcd8739ae039)("Search", $15afd6f13c43ffb9$export$3efd853dbb351e94);



var $8vqx4 = parcelRequire("8vqx4");




var $8vqx4 = parcelRequire("8vqx4");

const $ee3cd1ff864cf43a$export$3ddf2d174ce01153 = $94724b4e84955d54$export$be92b6f5f03c0fe9;
const $ee3cd1ff864cf43a$export$2e1e1122cf0cba88 = $94724b4e84955d54$export$41fb9f06171c75f4;
const $ee3cd1ff864cf43a$export$dad7c95542bacce0 = $94724b4e84955d54$export$602eac185826482c;
const $ee3cd1ff864cf43a$export$fba2fb7cd781b7ac = $94724b4e84955d54$export$f39c2d165cd861fe;
const $ee3cd1ff864cf43a$export$bd1d06c79be19e17 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$export$c6fdb837b070b4ff, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props
    }));
$ee3cd1ff864cf43a$export$bd1d06c79be19e17.displayName = $94724b4e84955d54$export$c6fdb837b070b4ff.displayName;
const $ee3cd1ff864cf43a$export$b6d9565de1e068cf = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)($ee3cd1ff864cf43a$export$dad7c95542bacce0, {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($ee3cd1ff864cf43a$export$bd1d06c79be19e17, {}),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)($94724b4e84955d54$export$7c6e2c02157bb7d2, {
                ref: ref,
                className: (0, $db53bf731136662c$export$1343a74baacb0543)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg", className),
                ...props,
                children: [
                    children,
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)($94724b4e84955d54$export$f39c2d165cd861fe, {
                        className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $10805d788c1e909d$export$2e2bcd8739ae039), {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
$ee3cd1ff864cf43a$export$b6d9565de1e068cf.displayName = $94724b4e84955d54$export$7c6e2c02157bb7d2.displayName;
const $ee3cd1ff864cf43a$export$742513523b177e3b = ({ className: className, ...props })=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex flex-col space-y-1.5 text-center sm:text-left", className),
        ...props
    });
$ee3cd1ff864cf43a$export$742513523b177e3b.displayName = "DialogHeader";
const $ee3cd1ff864cf43a$export$7bbfb2d443473050 = ({ className: className, ...props })=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
        ...props
    });
$ee3cd1ff864cf43a$export$7bbfb2d443473050.displayName = "DialogFooter";
const $ee3cd1ff864cf43a$export$16f7638e4a34b909 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$export$f99233281efd08a0, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("text-lg font-semibold leading-none tracking-tight", className),
        ...props
    }));
$ee3cd1ff864cf43a$export$16f7638e4a34b909.displayName = $94724b4e84955d54$export$f99233281efd08a0.displayName;
const $ee3cd1ff864cf43a$export$94e94c2ec2c954d5 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($94724b4e84955d54$export$393edc798c47379d, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("text-sm text-muted-foreground", className),
        ...props
    }));
$ee3cd1ff864cf43a$export$94e94c2ec2c954d5.displayName = $94724b4e84955d54$export$393edc798c47379d.displayName;



"use client";
const $076d2fb20333d587$export$cc7e12c76513e857 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $3aa0c79b2a27502b$export$cc7e12c76513e857), {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground", className),
        ...props
    }));
$076d2fb20333d587$export$cc7e12c76513e857.displayName = (0, $3aa0c79b2a27502b$export$cc7e12c76513e857).displayName;
const $076d2fb20333d587$export$98f0540b5c04f3e8 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $ee3cd1ff864cf43a$export$3ddf2d174ce01153), {
        ...props,
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $ee3cd1ff864cf43a$export$b6d9565de1e068cf), {
            className: "overflow-hidden p-0",
            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($076d2fb20333d587$export$cc7e12c76513e857, {
                className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
                children: children
            })
        })
    });
};
const $076d2fb20333d587$export$ebdebb88e46df62a = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        className: "flex items-center border-b px-3",
        "cmdk-input-wrapper": "",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $15afd6f13c43ffb9$export$2e2bcd8739ae039), {
                className: "mr-2 h-4 w-4 shrink-0 opacity-50"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $3aa0c79b2a27502b$export$cc7e12c76513e857).Input, {
                ref: ref,
                className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50", className),
                ...props
            })
        ]
    }));
$076d2fb20333d587$export$ebdebb88e46df62a.displayName = (0, $3aa0c79b2a27502b$export$cc7e12c76513e857).Input.displayName;
const $076d2fb20333d587$export$9cffcb65e9381872 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $3aa0c79b2a27502b$export$cc7e12c76513e857).List, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("max-h-[300px] overflow-y-auto overflow-x-hidden", className),
        ...props
    }));
$076d2fb20333d587$export$9cffcb65e9381872.displayName = (0, $3aa0c79b2a27502b$export$cc7e12c76513e857).List.displayName;
const $076d2fb20333d587$export$f1753c65029fce09 = /*#__PURE__*/ $8vqx4.forwardRef((props, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $3aa0c79b2a27502b$export$cc7e12c76513e857).Empty, {
        ref: ref,
        className: "py-6 text-center text-sm",
        ...props
    }));
$076d2fb20333d587$export$f1753c65029fce09.displayName = (0, $3aa0c79b2a27502b$export$cc7e12c76513e857).Empty.displayName;
const $076d2fb20333d587$export$c157b9873a7a0fbd = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $3aa0c79b2a27502b$export$cc7e12c76513e857).Group, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground", className),
        ...props
    }));
$076d2fb20333d587$export$c157b9873a7a0fbd.displayName = (0, $3aa0c79b2a27502b$export$cc7e12c76513e857).Group.displayName;
const $076d2fb20333d587$export$ace649eed6990b42 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $3aa0c79b2a27502b$export$cc7e12c76513e857).Separator, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("-mx-1 h-px bg-border", className),
        ...props
    }));
$076d2fb20333d587$export$ace649eed6990b42.displayName = (0, $3aa0c79b2a27502b$export$cc7e12c76513e857).Separator.displayName;
const $076d2fb20333d587$export$b9b346a733d36f61 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $3aa0c79b2a27502b$export$cc7e12c76513e857).Item, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", className),
        ...props
    }));
$076d2fb20333d587$export$b9b346a733d36f61.displayName = (0, $3aa0c79b2a27502b$export$cc7e12c76513e857).Item.displayName;
const $076d2fb20333d587$export$8b2995843ab6cf09 = ({ className: className, ...props })=>{
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("ml-auto text-xs tracking-widest text-muted-foreground", className),
        ...props
    });
};
$076d2fb20333d587$export$8b2995843ab6cf09.displayName = "CommandShortcut";




var $8vqx4 = parcelRequire("8vqx4");








var $8vqx4 = parcelRequire("8vqx4");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $d82c4f7c035303ab$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $d82c4f7c035303ab$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $d82c4f7c035303ab$export$803cd8101b6c182b = /*#__PURE__*/ $d82c4f7c035303ab$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $d82c4f7c035303ab$export$27b07d8a310ed8b5[0], side + "-" + $d82c4f7c035303ab$export$27b07d8a310ed8b5[1]), []);
const $d82c4f7c035303ab$export$96ec731ed4dcb222 = Math.min;
const $d82c4f7c035303ab$export$8960430cfd85939f = Math.max;
const $d82c4f7c035303ab$export$2077e0241d6afd3c = Math.round;
const $d82c4f7c035303ab$export$a3fe094919f356fd = Math.floor;
const $d82c4f7c035303ab$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $d82c4f7c035303ab$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d82c4f7c035303ab$export$7d15b64cf5a3a4c4(start, value, end) {
    return $d82c4f7c035303ab$export$8960430cfd85939f(start, $d82c4f7c035303ab$export$96ec731ed4dcb222(value, end));
}
function $d82c4f7c035303ab$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $d82c4f7c035303ab$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $d82c4f7c035303ab$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $d82c4f7c035303ab$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $d82c4f7c035303ab$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $d82c4f7c035303ab$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $d82c4f7c035303ab$export$2b57e0052a6d6d4c(placement) {
    return $d82c4f7c035303ab$export$8a000a963141ac32($d82c4f7c035303ab$export$f28e8f882010718a(placement));
}
function $d82c4f7c035303ab$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $d82c4f7c035303ab$export$f0989780f32bfcda(placement);
    const alignmentAxis = $d82c4f7c035303ab$export$2b57e0052a6d6d4c(placement);
    const length = $d82c4f7c035303ab$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $d82c4f7c035303ab$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $d82c4f7c035303ab$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $d82c4f7c035303ab$export$496432a3699e50b1(placement) {
    const oppositePlacement = $d82c4f7c035303ab$export$9c5e28bad23365fa(placement);
    return [
        $d82c4f7c035303ab$export$2b182c584985588b(placement),
        oppositePlacement,
        $d82c4f7c035303ab$export$2b182c584985588b(oppositePlacement)
    ];
}
function $d82c4f7c035303ab$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $d82c4f7c035303ab$var$lrPlacement = [
    'left',
    'right'
];
const $d82c4f7c035303ab$var$rlPlacement = [
    'right',
    'left'
];
const $d82c4f7c035303ab$var$tbPlacement = [
    'top',
    'bottom'
];
const $d82c4f7c035303ab$var$btPlacement = [
    'bottom',
    'top'
];
function $d82c4f7c035303ab$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $d82c4f7c035303ab$var$rlPlacement : $d82c4f7c035303ab$var$lrPlacement;
            return isStart ? $d82c4f7c035303ab$var$lrPlacement : $d82c4f7c035303ab$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $d82c4f7c035303ab$var$tbPlacement : $d82c4f7c035303ab$var$btPlacement;
        default:
            return [];
    }
}
function $d82c4f7c035303ab$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $d82c4f7c035303ab$export$f0989780f32bfcda(placement);
    let list = $d82c4f7c035303ab$var$getSideList($d82c4f7c035303ab$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($d82c4f7c035303ab$export$2b182c584985588b));
    }
    return list;
}
function $d82c4f7c035303ab$export$9c5e28bad23365fa(placement) {
    const side = $d82c4f7c035303ab$export$3c915306cb7fc97a(placement);
    return $d82c4f7c035303ab$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $d82c4f7c035303ab$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $d82c4f7c035303ab$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $d82c4f7c035303ab$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $d82c4f7c035303ab$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $998118a815451658$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $d82c4f7c035303ab$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $d82c4f7c035303ab$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $d82c4f7c035303ab$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $d82c4f7c035303ab$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $d82c4f7c035303ab$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $998118a815451658$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $d82c4f7c035303ab$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $d82c4f7c035303ab$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $d82c4f7c035303ab$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $d82c4f7c035303ab$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $998118a815451658$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $998118a815451658$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $998118a815451658$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $998118a815451658$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $998118a815451658$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $998118a815451658$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $998118a815451658$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $d82c4f7c035303ab$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $d82c4f7c035303ab$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $d82c4f7c035303ab$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $d82c4f7c035303ab$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $d82c4f7c035303ab$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $d82c4f7c035303ab$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $d82c4f7c035303ab$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $d82c4f7c035303ab$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $998118a815451658$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $d82c4f7c035303ab$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $d82c4f7c035303ab$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $d82c4f7c035303ab$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $d82c4f7c035303ab$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $d82c4f7c035303ab$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $998118a815451658$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $d82c4f7c035303ab$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $d82c4f7c035303ab$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $d82c4f7c035303ab$export$803cd8101b6c182b) ? $998118a815451658$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $d82c4f7c035303ab$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $d82c4f7c035303ab$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $d82c4f7c035303ab$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $d82c4f7c035303ab$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $998118a815451658$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $d82c4f7c035303ab$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $d82c4f7c035303ab$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $d82c4f7c035303ab$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $d82c4f7c035303ab$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $d82c4f7c035303ab$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $d82c4f7c035303ab$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $d82c4f7c035303ab$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $d82c4f7c035303ab$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $d82c4f7c035303ab$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $d82c4f7c035303ab$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $d82c4f7c035303ab$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $998118a815451658$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $998118a815451658$var$isAnySideFullyClipped(overflow) {
    return (0, $d82c4f7c035303ab$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $998118a815451658$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $d82c4f7c035303ab$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $998118a815451658$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $998118a815451658$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $998118a815451658$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $998118a815451658$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $998118a815451658$var$getBoundingRect(rects) {
    const minX = (0, $d82c4f7c035303ab$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $d82c4f7c035303ab$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $d82c4f7c035303ab$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $d82c4f7c035303ab$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $998118a815451658$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $d82c4f7c035303ab$export$ee05aea0aeecbad4)($998118a815451658$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $998118a815451658$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $d82c4f7c035303ab$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $998118a815451658$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $d82c4f7c035303ab$export$ee05aea0aeecbad4)($998118a815451658$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $d82c4f7c035303ab$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $d82c4f7c035303ab$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $d82c4f7c035303ab$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $d82c4f7c035303ab$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $d82c4f7c035303ab$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $d82c4f7c035303ab$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $998118a815451658$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $998118a815451658$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $d82c4f7c035303ab$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $d82c4f7c035303ab$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $d82c4f7c035303ab$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $998118a815451658$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $d82c4f7c035303ab$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $998118a815451658$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $998118a815451658$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $998118a815451658$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $d82c4f7c035303ab$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $d82c4f7c035303ab$export$f28e8f882010718a)((0, $d82c4f7c035303ab$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $d82c4f7c035303ab$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $d82c4f7c035303ab$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $d82c4f7c035303ab$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $998118a815451658$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $d82c4f7c035303ab$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $d82c4f7c035303ab$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $d82c4f7c035303ab$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $d82c4f7c035303ab$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $998118a815451658$var$originSides.has((0, $d82c4f7c035303ab$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $998118a815451658$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $d82c4f7c035303ab$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $d82c4f7c035303ab$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $d82c4f7c035303ab$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $d82c4f7c035303ab$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $d82c4f7c035303ab$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $d82c4f7c035303ab$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $d82c4f7c035303ab$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $d82c4f7c035303ab$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $d82c4f7c035303ab$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $d82c4f7c035303ab$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $d82c4f7c035303ab$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $d82c4f7c035303ab$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $c10b14d6d712af88$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $c10b14d6d712af88$export$651544f548703224(node) {
    if ($c10b14d6d712af88$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $c10b14d6d712af88$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $c10b14d6d712af88$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($c10b14d6d712af88$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $c10b14d6d712af88$export$8ee0fc9ee280b4ee(value) {
    if (!$c10b14d6d712af88$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $c10b14d6d712af88$export$38b2d434cce3ea22(value).Node;
}
function $c10b14d6d712af88$export$45a5e7f76e0caa8d(value) {
    if (!$c10b14d6d712af88$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $c10b14d6d712af88$export$38b2d434cce3ea22(value).Element;
}
function $c10b14d6d712af88$export$1b3bfaa9684536aa(value) {
    if (!$c10b14d6d712af88$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $c10b14d6d712af88$export$38b2d434cce3ea22(value).HTMLElement;
}
function $c10b14d6d712af88$export$af51f0f06c0f328a(value) {
    if (!$c10b14d6d712af88$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $c10b14d6d712af88$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $c10b14d6d712af88$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $c10b14d6d712af88$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $c10b14d6d712af88$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($c10b14d6d712af88$export$651544f548703224(element));
}
function $c10b14d6d712af88$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $c10b14d6d712af88$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $c10b14d6d712af88$var$containRe = /paint|layout|strict|content/;
const $c10b14d6d712af88$var$isNotNone = (value)=>!!value && value !== 'none';
let $c10b14d6d712af88$var$isWebKitValue;
function $c10b14d6d712af88$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $c10b14d6d712af88$export$45a5e7f76e0caa8d(elementOrCss) ? $c10b14d6d712af88$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $c10b14d6d712af88$var$isNotNone(css.transform) || $c10b14d6d712af88$var$isNotNone(css.translate) || $c10b14d6d712af88$var$isNotNone(css.scale) || $c10b14d6d712af88$var$isNotNone(css.rotate) || $c10b14d6d712af88$var$isNotNone(css.perspective) || !$c10b14d6d712af88$export$78551043582a6a98() && ($c10b14d6d712af88$var$isNotNone(css.backdropFilter) || $c10b14d6d712af88$var$isNotNone(css.filter)) || $c10b14d6d712af88$var$willChangeRe.test(css.willChange || '') || $c10b14d6d712af88$var$containRe.test(css.contain || '');
}
function $c10b14d6d712af88$export$940d8225183e1404(element) {
    let currentNode = $c10b14d6d712af88$export$4e12058fc4d51d56(element);
    while($c10b14d6d712af88$export$1b3bfaa9684536aa(currentNode) && !$c10b14d6d712af88$export$d1162fb0b6d4cd51(currentNode)){
        if ($c10b14d6d712af88$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($c10b14d6d712af88$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $c10b14d6d712af88$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $c10b14d6d712af88$export$78551043582a6a98() {
    if ($c10b14d6d712af88$var$isWebKitValue == null) $c10b14d6d712af88$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $c10b14d6d712af88$var$isWebKitValue;
}
function $c10b14d6d712af88$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($c10b14d6d712af88$export$651544f548703224(node));
}
function $c10b14d6d712af88$export$3735103072e4a80(element) {
    return $c10b14d6d712af88$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $c10b14d6d712af88$export$dc8fc79fa2800137(element) {
    if ($c10b14d6d712af88$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $c10b14d6d712af88$export$4e12058fc4d51d56(node) {
    if ($c10b14d6d712af88$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $c10b14d6d712af88$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $c10b14d6d712af88$export$e495491855dc5418(node);
    return $c10b14d6d712af88$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $c10b14d6d712af88$export$7cd01a57c8ca906c(node) {
    const parentNode = $c10b14d6d712af88$export$4e12058fc4d51d56(node);
    if ($c10b14d6d712af88$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($c10b14d6d712af88$export$1b3bfaa9684536aa(parentNode) && $c10b14d6d712af88$export$989e911fa9af580a(parentNode)) return parentNode;
    return $c10b14d6d712af88$export$7cd01a57c8ca906c(parentNode);
}
function $c10b14d6d712af88$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $c10b14d6d712af88$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $c10b14d6d712af88$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $c10b14d6d712af88$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $c10b14d6d712af88$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $c10b14d6d712af88$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $c10b14d6d712af88$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $c10b14d6d712af88$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $6e6214e3d01d472e$var$getCssDimensions(element) {
    const css = (0, $c10b14d6d712af88$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $c10b14d6d712af88$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $d82c4f7c035303ab$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $d82c4f7c035303ab$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $6e6214e3d01d472e$var$unwrapElement(element) {
    return !(0, $c10b14d6d712af88$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $6e6214e3d01d472e$var$getScale(element) {
    const domElement = $6e6214e3d01d472e$var$unwrapElement(element);
    if (!(0, $c10b14d6d712af88$export$1b3bfaa9684536aa)(domElement)) return (0, $d82c4f7c035303ab$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $6e6214e3d01d472e$var$getCssDimensions(domElement);
    let x = ($ ? (0, $d82c4f7c035303ab$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $d82c4f7c035303ab$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $6e6214e3d01d472e$var$noOffsets = /*#__PURE__*/ (0, $d82c4f7c035303ab$export$a397704b5e280835)(0);
function $6e6214e3d01d472e$var$getVisualOffsets(element) {
    const win = (0, $c10b14d6d712af88$export$38b2d434cce3ea22)(element);
    if (!(0, $c10b14d6d712af88$export$78551043582a6a98)() || !win.visualViewport) return $6e6214e3d01d472e$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $6e6214e3d01d472e$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $c10b14d6d712af88$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $6e6214e3d01d472e$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $6e6214e3d01d472e$var$unwrapElement(element);
    let scale = (0, $d82c4f7c035303ab$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $c10b14d6d712af88$export$45a5e7f76e0caa8d)(offsetParent)) scale = $6e6214e3d01d472e$var$getScale(offsetParent);
        } else scale = $6e6214e3d01d472e$var$getScale(element);
    }
    const visualOffsets = $6e6214e3d01d472e$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $6e6214e3d01d472e$var$getVisualOffsets(domElement) : (0, $d82c4f7c035303ab$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $c10b14d6d712af88$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $c10b14d6d712af88$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $c10b14d6d712af88$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $c10b14d6d712af88$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $6e6214e3d01d472e$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $c10b14d6d712af88$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $c10b14d6d712af88$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $c10b14d6d712af88$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $d82c4f7c035303ab$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $6e6214e3d01d472e$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $c10b14d6d712af88$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $6e6214e3d01d472e$var$getBoundingClientRect((0, $c10b14d6d712af88$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $6e6214e3d01d472e$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $6e6214e3d01d472e$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $6e6214e3d01d472e$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $c10b14d6d712af88$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $c10b14d6d712af88$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $d82c4f7c035303ab$export$a397704b5e280835)(1);
    const offsets = (0, $d82c4f7c035303ab$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $c10b14d6d712af88$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c10b14d6d712af88$export$651544f548703224)(offsetParent) !== 'body' || (0, $c10b14d6d712af88$export$989e911fa9af580a)(documentElement)) scroll = (0, $c10b14d6d712af88$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $6e6214e3d01d472e$var$getBoundingClientRect(offsetParent);
            scale = $6e6214e3d01d472e$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $6e6214e3d01d472e$var$getHTMLOffset(documentElement, scroll) : (0, $d82c4f7c035303ab$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $6e6214e3d01d472e$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $6e6214e3d01d472e$var$getDocumentRect(element) {
    const html = (0, $c10b14d6d712af88$export$e495491855dc5418)(element);
    const scroll = (0, $c10b14d6d712af88$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $d82c4f7c035303ab$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $d82c4f7c035303ab$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $6e6214e3d01d472e$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $c10b14d6d712af88$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $d82c4f7c035303ab$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $6e6214e3d01d472e$var$SCROLLBAR_MAX = 25;
function $6e6214e3d01d472e$var$getViewportRect(element, strategy) {
    const win = (0, $c10b14d6d712af88$export$38b2d434cce3ea22)(element);
    const html = (0, $c10b14d6d712af88$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $c10b14d6d712af88$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $6e6214e3d01d472e$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $6e6214e3d01d472e$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $6e6214e3d01d472e$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $6e6214e3d01d472e$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $6e6214e3d01d472e$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $c10b14d6d712af88$export$1b3bfaa9684536aa)(element) ? $6e6214e3d01d472e$var$getScale(element) : (0, $d82c4f7c035303ab$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $6e6214e3d01d472e$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $6e6214e3d01d472e$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $6e6214e3d01d472e$var$getDocumentRect((0, $c10b14d6d712af88$export$e495491855dc5418)(element));
    else if ((0, $c10b14d6d712af88$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $6e6214e3d01d472e$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $6e6214e3d01d472e$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $d82c4f7c035303ab$export$ee05aea0aeecbad4)(rect);
}
function $6e6214e3d01d472e$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $c10b14d6d712af88$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $c10b14d6d712af88$export$45a5e7f76e0caa8d)(parentNode) || (0, $c10b14d6d712af88$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $c10b14d6d712af88$export$3735103072e4a80)(parentNode).position === 'fixed' || $6e6214e3d01d472e$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $6e6214e3d01d472e$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $c10b14d6d712af88$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $c10b14d6d712af88$export$45a5e7f76e0caa8d)(el) && (0, $c10b14d6d712af88$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $c10b14d6d712af88$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $c10b14d6d712af88$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $c10b14d6d712af88$export$45a5e7f76e0caa8d)(currentNode) && !(0, $c10b14d6d712af88$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $c10b14d6d712af88$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $c10b14d6d712af88$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $c10b14d6d712af88$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $6e6214e3d01d472e$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $c10b14d6d712af88$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $6e6214e3d01d472e$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $c10b14d6d712af88$export$89e651af02346cd4)(element) ? [] : $6e6214e3d01d472e$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $6e6214e3d01d472e$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $6e6214e3d01d472e$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $d82c4f7c035303ab$export$8960430cfd85939f)(rect.top, top);
        right = (0, $d82c4f7c035303ab$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $d82c4f7c035303ab$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $d82c4f7c035303ab$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $6e6214e3d01d472e$var$getDimensions(element) {
    const { width: width, height: height } = $6e6214e3d01d472e$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $6e6214e3d01d472e$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $c10b14d6d712af88$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $c10b14d6d712af88$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $6e6214e3d01d472e$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $d82c4f7c035303ab$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $6e6214e3d01d472e$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c10b14d6d712af88$export$651544f548703224)(offsetParent) !== 'body' || (0, $c10b14d6d712af88$export$989e911fa9af580a)(documentElement)) scroll = (0, $c10b14d6d712af88$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $6e6214e3d01d472e$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $6e6214e3d01d472e$var$getHTMLOffset(documentElement, scroll) : (0, $d82c4f7c035303ab$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $6e6214e3d01d472e$var$isStaticPositioned(element) {
    return (0, $c10b14d6d712af88$export$3735103072e4a80)(element).position === 'static';
}
function $6e6214e3d01d472e$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $c10b14d6d712af88$export$1b3bfaa9684536aa)(element) || (0, $c10b14d6d712af88$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $c10b14d6d712af88$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $6e6214e3d01d472e$var$getOffsetParent(element, polyfill) {
    const win = (0, $c10b14d6d712af88$export$38b2d434cce3ea22)(element);
    if ((0, $c10b14d6d712af88$export$89e651af02346cd4)(element)) return win;
    if (!(0, $c10b14d6d712af88$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $c10b14d6d712af88$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $c10b14d6d712af88$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $c10b14d6d712af88$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$6e6214e3d01d472e$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $c10b14d6d712af88$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $6e6214e3d01d472e$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $c10b14d6d712af88$export$71535ffaa902797f)(offsetParent) && $6e6214e3d01d472e$var$isStaticPositioned(offsetParent))offsetParent = $6e6214e3d01d472e$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $c10b14d6d712af88$export$d1162fb0b6d4cd51)(offsetParent) && $6e6214e3d01d472e$var$isStaticPositioned(offsetParent) && !(0, $c10b14d6d712af88$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $c10b14d6d712af88$export$940d8225183e1404)(element) || win;
}
const $6e6214e3d01d472e$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $6e6214e3d01d472e$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $6e6214e3d01d472e$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $6e6214e3d01d472e$var$isRTL(element) {
    return (0, $c10b14d6d712af88$export$3735103072e4a80)(element).direction === 'rtl';
}
const $6e6214e3d01d472e$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $6e6214e3d01d472e$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $c10b14d6d712af88$export$e495491855dc5418,
    getClippingRect: $6e6214e3d01d472e$var$getClippingRect,
    getOffsetParent: $6e6214e3d01d472e$var$getOffsetParent,
    getElementRects: $6e6214e3d01d472e$var$getElementRects,
    getClientRects: $6e6214e3d01d472e$var$getClientRects,
    getDimensions: $6e6214e3d01d472e$var$getDimensions,
    getScale: $6e6214e3d01d472e$var$getScale,
    isElement: $c10b14d6d712af88$export$45a5e7f76e0caa8d,
    isRTL: $6e6214e3d01d472e$var$isRTL
};
function $6e6214e3d01d472e$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $6e6214e3d01d472e$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $c10b14d6d712af88$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $d82c4f7c035303ab$export$a3fe094919f356fd)(top);
        const insetRight = (0, $d82c4f7c035303ab$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $d82c4f7c035303ab$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $d82c4f7c035303ab$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $d82c4f7c035303ab$export$8960430cfd85939f)(0, (0, $d82c4f7c035303ab$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$6e6214e3d01d472e$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $6e6214e3d01d472e$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $6e6214e3d01d472e$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $c10b14d6d712af88$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $c10b14d6d712af88$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $6e6214e3d01d472e$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $6e6214e3d01d472e$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $6e6214e3d01d472e$var$getBoundingClientRect(reference);
        if (prevRefRect && !$6e6214e3d01d472e$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $6e6214e3d01d472e$export$37b6bde19b108ecc = (0, $998118a815451658$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $6e6214e3d01d472e$export$cc800923e997bb8 = (0, $998118a815451658$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $6e6214e3d01d472e$export$91fb6ecbd551914 = (0, $998118a815451658$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $6e6214e3d01d472e$export$fba63a578e423eb = (0, $998118a815451658$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $6e6214e3d01d472e$export$8a83211c878a3f1f = (0, $998118a815451658$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $6e6214e3d01d472e$export$346677f925de839c = (0, $998118a815451658$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $6e6214e3d01d472e$export$fe8985bb6374093c = (0, $998118a815451658$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $6e6214e3d01d472e$export$f2120bbfa5450bd2 = (0, $998118a815451658$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $6e6214e3d01d472e$export$18c8ad048e32c7d5 = (0, $998118a815451658$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $6e6214e3d01d472e$export$7bf07e38f3dc4b69 = (0, $998118a815451658$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $6e6214e3d01d472e$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $6e6214e3d01d472e$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $998118a815451658$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $8vqx4 = parcelRequire("8vqx4");

var $hiyfL = parcelRequire("hiyfL");
var $febb3d9d68909efa$var$isClient = typeof document !== 'undefined';
var $febb3d9d68909efa$var$noop = function noop() {};
var $febb3d9d68909efa$var$index = $febb3d9d68909efa$var$isClient ? (0, $8vqx4.useLayoutEffect) : $febb3d9d68909efa$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $febb3d9d68909efa$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$febb3d9d68909efa$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$febb3d9d68909efa$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $febb3d9d68909efa$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $febb3d9d68909efa$var$roundByDPR(element, value) {
    const dpr = $febb3d9d68909efa$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $febb3d9d68909efa$var$useLatestRef(value) {
    const ref = $8vqx4.useRef(value);
    $febb3d9d68909efa$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $febb3d9d68909efa$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $8vqx4.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $8vqx4.useState(middleware);
    if (!$febb3d9d68909efa$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $8vqx4.useState(null);
    const [_floating, _setFloating] = $8vqx4.useState(null);
    const setReference = $8vqx4.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $8vqx4.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $8vqx4.useRef(null);
    const floatingRef = $8vqx4.useRef(null);
    const dataRef = $8vqx4.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $febb3d9d68909efa$var$useLatestRef(whileElementsMounted);
    const platformRef = $febb3d9d68909efa$var$useLatestRef(platform);
    const openRef = $febb3d9d68909efa$var$useLatestRef(open);
    const update = $8vqx4.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $6e6214e3d01d472e$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$febb3d9d68909efa$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $hiyfL.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $febb3d9d68909efa$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $8vqx4.useRef(false);
    $febb3d9d68909efa$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $febb3d9d68909efa$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $8vqx4.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $8vqx4.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $8vqx4.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $febb3d9d68909efa$var$roundByDPR(elements.floating, data.x);
        const y = $febb3d9d68909efa$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$febb3d9d68909efa$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $8vqx4.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $febb3d9d68909efa$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $6e6214e3d01d472e$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $6e6214e3d01d472e$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $febb3d9d68909efa$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $6e6214e3d01d472e$export$cc800923e997bb8)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $febb3d9d68909efa$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $6e6214e3d01d472e$export$fba63a578e423eb)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $febb3d9d68909efa$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $6e6214e3d01d472e$export$7bf07e38f3dc4b69)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $febb3d9d68909efa$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $6e6214e3d01d472e$export$8a83211c878a3f1f)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $febb3d9d68909efa$export$346677f925de839c = (options, deps)=>{
    const result = (0, $6e6214e3d01d472e$export$346677f925de839c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $febb3d9d68909efa$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $6e6214e3d01d472e$export$91fb6ecbd551914)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $febb3d9d68909efa$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $6e6214e3d01d472e$export$fe8985bb6374093c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $febb3d9d68909efa$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $6e6214e3d01d472e$export$18c8ad048e32c7d5)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $febb3d9d68909efa$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $febb3d9d68909efa$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};


// src/arrow.tsx

var $8vqx4 = parcelRequire("8vqx4");


var $accc5bf6a37667f7$var$NAME = "Arrow";
var $accc5bf6a37667f7$export$21b07c8f274aebd5 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$accc5bf6a37667f7$export$21b07c8f274aebd5.displayName = $accc5bf6a37667f7$var$NAME;
var $accc5bf6a37667f7$export$be92b6f5f03c0fe9 = $accc5bf6a37667f7$export$21b07c8f274aebd5;







// packages/react/use-size/src/use-size.tsx

var $8vqx4 = parcelRequire("8vqx4");

function $61d0379fd4465bd5$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $8vqx4.useState(void 0);
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



"use client";
var $2077c174299ab414$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $2077c174299ab414$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $2077c174299ab414$var$POPPER_NAME = "Popper";
var [$2077c174299ab414$var$createPopperContext, $2077c174299ab414$export$722aac194ae923] = (0, $9ec698e3cd37fa7e$export$50c7b4e9d9f19c1)($2077c174299ab414$var$POPPER_NAME);
var [$2077c174299ab414$var$PopperProvider, $2077c174299ab414$var$usePopperContext] = $2077c174299ab414$var$createPopperContext($2077c174299ab414$var$POPPER_NAME);
var $2077c174299ab414$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $8vqx4.useState(null);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($2077c174299ab414$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        children: children
    });
};
$2077c174299ab414$export$badac9ada3a0bdf9.displayName = $2077c174299ab414$var$POPPER_NAME;
var $2077c174299ab414$var$ANCHOR_NAME = "PopperAnchor";
var $2077c174299ab414$export$ecd4e1ccab6ed6d = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $2077c174299ab414$var$usePopperContext($2077c174299ab414$var$ANCHOR_NAME, __scopePopper);
    const ref = $8vqx4.useRef(null);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const anchorRef = $8vqx4.useRef(null);
    $8vqx4.useEffect(()=>{
        const previousAnchor = anchorRef.current;
        anchorRef.current = virtualRef?.current || ref.current;
        if (previousAnchor !== anchorRef.current) context.onAnchorChange(anchorRef.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
$2077c174299ab414$export$ecd4e1ccab6ed6d.displayName = $2077c174299ab414$var$ANCHOR_NAME;
var $2077c174299ab414$var$CONTENT_NAME = "PopperContent";
var [$2077c174299ab414$var$PopperContentProvider, $2077c174299ab414$var$useContentContext] = $2077c174299ab414$var$createPopperContext($2077c174299ab414$var$CONTENT_NAME);
var $2077c174299ab414$export$bc4ae5855d3c4fc = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $2077c174299ab414$var$usePopperContext($2077c174299ab414$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $8vqx4.useState(null);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = $8vqx4.useState(null);
    const arrowSize = (0, $61d0379fd4465bd5$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($2077c174299ab414$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $febb3d9d68909efa$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $6e6214e3d01d472e$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $febb3d9d68909efa$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $febb3d9d68909efa$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $febb3d9d68909efa$export$7bf07e38f3dc4b69)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $febb3d9d68909efa$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $febb3d9d68909efa$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $febb3d9d68909efa$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $2077c174299ab414$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $febb3d9d68909efa$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $2077c174299ab414$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $0af559af272c0534$export$25bec8c6f54ee79a)(onPlaced);
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = $8vqx4.useState();
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($2077c174299ab414$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$2077c174299ab414$export$bc4ae5855d3c4fc.displayName = $2077c174299ab414$var$CONTENT_NAME;
var $2077c174299ab414$var$ARROW_NAME = "PopperArrow";
var $2077c174299ab414$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $2077c174299ab414$export$79d62cd4e10a3fd0 = $8vqx4.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $2077c174299ab414$var$useContentContext($2077c174299ab414$var$ARROW_NAME, __scopePopper);
    const baseSide = $2077c174299ab414$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($accc5bf6a37667f7$export$be92b6f5f03c0fe9, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$2077c174299ab414$export$79d62cd4e10a3fd0.displayName = $2077c174299ab414$var$ARROW_NAME;
function $2077c174299ab414$var$isNotNull(value) {
    return value !== null;
}
var $2077c174299ab414$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $2077c174299ab414$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $2077c174299ab414$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $2077c174299ab414$export$be92b6f5f03c0fe9 = $2077c174299ab414$export$badac9ada3a0bdf9;
var $2077c174299ab414$export$b688253958b8dfe7 = $2077c174299ab414$export$ecd4e1ccab6ed6d;
var $2077c174299ab414$export$7c6e2c02157bb7d2 = $2077c174299ab414$export$bc4ae5855d3c4fc;
var $2077c174299ab414$export$21b07c8f274aebd5 = $2077c174299ab414$export$79d62cd4e10a3fd0;










"use client";
var $01969815f5a1d3de$var$POPOVER_NAME = "Popover";
var [$01969815f5a1d3de$var$createPopoverContext, $01969815f5a1d3de$export$c8393c9e73286932] = (0, $9ec698e3cd37fa7e$export$50c7b4e9d9f19c1)($01969815f5a1d3de$var$POPOVER_NAME, [
    (0, $2077c174299ab414$export$722aac194ae923)
]);
var $01969815f5a1d3de$var$usePopperScope = (0, $2077c174299ab414$export$722aac194ae923)();
var [$01969815f5a1d3de$var$PopoverProvider, $01969815f5a1d3de$var$usePopoverContext] = $01969815f5a1d3de$var$createPopoverContext($01969815f5a1d3de$var$POPOVER_NAME);
var $01969815f5a1d3de$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $01969815f5a1d3de$var$usePopperScope(__scopePopover);
    const triggerRef = $8vqx4.useRef(null);
    const [hasCustomAnchor, setHasCustomAnchor] = $8vqx4.useState(false);
    const [open, setOpen] = (0, $2da738009a11930c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $01969815f5a1d3de$var$POPOVER_NAME
    });
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($2077c174299ab414$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($01969815f5a1d3de$var$PopoverProvider, {
            scope: __scopePopover,
            contentId: (0, $48f6e55cf3c4c05f$export$f680877a34711e37)(),
            triggerRef: triggerRef,
            open: open,
            onOpenChange: setOpen,
            onOpenToggle: $8vqx4.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
                setOpen
            ]),
            hasCustomAnchor: hasCustomAnchor,
            onCustomAnchorAdd: $8vqx4.useCallback(()=>setHasCustomAnchor(true), []),
            onCustomAnchorRemove: $8vqx4.useCallback(()=>setHasCustomAnchor(false), []),
            modal: modal,
            children: children
        })
    });
};
$01969815f5a1d3de$export$5b6b19405a83ff9d.displayName = $01969815f5a1d3de$var$POPOVER_NAME;
var $01969815f5a1d3de$var$ANCHOR_NAME = "PopoverAnchor";
var $01969815f5a1d3de$export$96e5381f42521a79 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...anchorProps } = props;
    const context = $01969815f5a1d3de$var$usePopoverContext($01969815f5a1d3de$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $01969815f5a1d3de$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    $8vqx4.useEffect(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($2077c174299ab414$export$b688253958b8dfe7, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
$01969815f5a1d3de$export$96e5381f42521a79.displayName = $01969815f5a1d3de$var$ANCHOR_NAME;
var $01969815f5a1d3de$var$TRIGGER_NAME = "PopoverTrigger";
var $01969815f5a1d3de$export$7dacb05d26466c3 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...triggerProps } = props;
    const context = $01969815f5a1d3de$var$usePopoverContext($01969815f5a1d3de$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $01969815f5a1d3de$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $01969815f5a1d3de$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
    return context.hasCustomAnchor ? trigger : /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($2077c174299ab414$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: trigger
    });
});
$01969815f5a1d3de$export$7dacb05d26466c3.displayName = $01969815f5a1d3de$var$TRIGGER_NAME;
var $01969815f5a1d3de$var$PORTAL_NAME = "PopoverPortal";
var [$01969815f5a1d3de$var$PortalProvider, $01969815f5a1d3de$var$usePortalContext] = $01969815f5a1d3de$var$createPopoverContext($01969815f5a1d3de$var$PORTAL_NAME, {
    forceMount: void 0
});
var $01969815f5a1d3de$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $01969815f5a1d3de$var$usePopoverContext($01969815f5a1d3de$var$PORTAL_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($01969815f5a1d3de$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $f22016a45fcd98f7$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $22f2e6a7088dcf5f$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$01969815f5a1d3de$export$dd679ffb4362d2d4.displayName = $01969815f5a1d3de$var$PORTAL_NAME;
var $01969815f5a1d3de$var$CONTENT_NAME = "PopoverContent";
var $01969815f5a1d3de$export$d7e1f420b25549ff = $8vqx4.forwardRef((props, forwardedRef)=>{
    const portalContext = $01969815f5a1d3de$var$usePortalContext($01969815f5a1d3de$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $01969815f5a1d3de$var$usePopoverContext($01969815f5a1d3de$var$CONTENT_NAME, props.__scopePopover);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $f22016a45fcd98f7$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($01969815f5a1d3de$var$PopoverContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($01969815f5a1d3de$var$PopoverContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$01969815f5a1d3de$export$d7e1f420b25549ff.displayName = $01969815f5a1d3de$var$CONTENT_NAME;
var $01969815f5a1d3de$var$Slot = (0, $6fd952efea14ce9a$export$e88b45bda5c13eb9)("PopoverContent.RemoveScroll");
var $01969815f5a1d3de$var$PopoverContentModal = $8vqx4.forwardRef((props, forwardedRef)=>{
    const context = $01969815f5a1d3de$var$usePopoverContext($01969815f5a1d3de$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = $8vqx4.useRef(null);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = $8vqx4.useRef(false);
    $8vqx4.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $5f2df6acae077059$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $fb0b2d10375c2e49$export$2e2bcd8739ae039), {
        as: $01969815f5a1d3de$var$Slot,
        allowPinchZoom: true,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($01969815f5a1d3de$var$PopoverContentImpl, {
            ...props,
            ref: composedRefs,
            trapFocus: context.open,
            disableOutsidePointerEvents: true,
            onCloseAutoFocus: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
                event.preventDefault();
                if (!isRightClickOutsideRef.current) context.triggerRef.current?.focus();
            }),
            onPointerDownOutside: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
                const originalEvent = event.detail.originalEvent;
                const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
                const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
                isRightClickOutsideRef.current = isRightClick;
            }, {
                checkForDefaultPrevented: false
            }),
            onFocusOutside: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
                checkForDefaultPrevented: false
            })
        })
    });
});
var $01969815f5a1d3de$var$PopoverContentNonModal = $8vqx4.forwardRef((props, forwardedRef)=>{
    const context = $01969815f5a1d3de$var$usePopoverContext($01969815f5a1d3de$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = $8vqx4.useRef(false);
    const hasPointerDownOutsideRef = $8vqx4.useRef(false);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($01969815f5a1d3de$var$PopoverContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $01969815f5a1d3de$var$PopoverContentImpl = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $01969815f5a1d3de$var$usePopoverContext($01969815f5a1d3de$var$CONTENT_NAME, __scopePopover);
    const popperScope = $01969815f5a1d3de$var$usePopperScope(__scopePopover);
    (0, $dc875cc1b746c2ea$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $5bf0528134fa0c3c$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $d5c981ab09de62ee$export$177fb62ff3ec1f22), {
            asChild: true,
            disableOutsidePointerEvents: disableOutsidePointerEvents,
            onInteractOutside: onInteractOutside,
            onEscapeKeyDown: onEscapeKeyDown,
            onPointerDownOutside: onPointerDownOutside,
            onFocusOutside: onFocusOutside,
            onDismiss: ()=>context.onOpenChange(false),
            children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($2077c174299ab414$export$7c6e2c02157bb7d2, {
                "data-state": $01969815f5a1d3de$var$getState(context.open),
                role: "dialog",
                id: context.contentId,
                ...popperScope,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...contentProps.style,
                    "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                    "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                    "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                    "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                    "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
            })
        })
    });
});
var $01969815f5a1d3de$var$CLOSE_NAME = "PopoverClose";
var $01969815f5a1d3de$export$d6ac43ebaa40d53e = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...closeProps } = props;
    const context = $01969815f5a1d3de$var$usePopoverContext($01969815f5a1d3de$var$CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$01969815f5a1d3de$export$d6ac43ebaa40d53e.displayName = $01969815f5a1d3de$var$CLOSE_NAME;
var $01969815f5a1d3de$var$ARROW_NAME = "PopoverArrow";
var $01969815f5a1d3de$export$3152841115e061b2 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...arrowProps } = props;
    const popperScope = $01969815f5a1d3de$var$usePopperScope(__scopePopover);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($2077c174299ab414$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$01969815f5a1d3de$export$3152841115e061b2.displayName = $01969815f5a1d3de$var$ARROW_NAME;
function $01969815f5a1d3de$var$getState(open) {
    return open ? "open" : "closed";
}
var $01969815f5a1d3de$export$be92b6f5f03c0fe9 = $01969815f5a1d3de$export$5b6b19405a83ff9d;
var $01969815f5a1d3de$export$b688253958b8dfe7 = $01969815f5a1d3de$export$96e5381f42521a79;
var $01969815f5a1d3de$export$41fb9f06171c75f4 = $01969815f5a1d3de$export$7dacb05d26466c3;
var $01969815f5a1d3de$export$602eac185826482c = $01969815f5a1d3de$export$dd679ffb4362d2d4;
var $01969815f5a1d3de$export$7c6e2c02157bb7d2 = $01969815f5a1d3de$export$d7e1f420b25549ff;
var $01969815f5a1d3de$export$f39c2d165cd861fe = $01969815f5a1d3de$export$d6ac43ebaa40d53e;
var $01969815f5a1d3de$export$21b07c8f274aebd5 = $01969815f5a1d3de$export$3152841115e061b2;



var $8vqx4 = parcelRequire("8vqx4");

const $5ac343943c48bdee$export$5b6b19405a83ff9d = $01969815f5a1d3de$export$be92b6f5f03c0fe9;
const $5ac343943c48bdee$export$7dacb05d26466c3 = $01969815f5a1d3de$export$41fb9f06171c75f4;
const $5ac343943c48bdee$export$96e5381f42521a79 = $01969815f5a1d3de$export$b688253958b8dfe7;
const $5ac343943c48bdee$export$d7e1f420b25549ff = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, align: align = "center", sideOffset: sideOffset = 4, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($01969815f5a1d3de$export$602eac185826482c, {
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($01969815f5a1d3de$export$7c6e2c02157bb7d2, {
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: (0, $db53bf731136662c$export$1343a74baacb0543)("z-50 w-72 origin-[--radix-popover-content-transform-origin] rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className),
            ...props
        })
    }));
$5ac343943c48bdee$export$d7e1f420b25549ff.displayName = $01969815f5a1d3de$export$7c6e2c02157bb7d2.displayName;



// src/separator.tsx

var $8vqx4 = parcelRequire("8vqx4");


var $4cf1b6a0967e50d2$var$NAME = "Separator";
var $4cf1b6a0967e50d2$var$DEFAULT_ORIENTATION = "horizontal";
var $4cf1b6a0967e50d2$var$ORIENTATIONS = [
    "horizontal",
    "vertical"
];
var $4cf1b6a0967e50d2$export$1ff3c3f08ae963c0 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { decorative: decorative, orientation: orientationProp = $4cf1b6a0967e50d2$var$DEFAULT_ORIENTATION, ...domProps } = props;
    const orientation = $4cf1b6a0967e50d2$var$isValidOrientation(orientationProp) ? orientationProp : $4cf1b6a0967e50d2$var$DEFAULT_ORIENTATION;
    const ariaOrientation = orientation === "vertical" ? orientation : void 0;
    const semanticProps = decorative ? {
        role: "none"
    } : {
        "aria-orientation": ariaOrientation,
        role: "separator"
    };
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $be70c59ab91df9ff$export$250ffa63cdc0d034).div, {
        "data-orientation": orientation,
        ...semanticProps,
        ...domProps,
        ref: forwardedRef
    });
});
$4cf1b6a0967e50d2$export$1ff3c3f08ae963c0.displayName = $4cf1b6a0967e50d2$var$NAME;
function $4cf1b6a0967e50d2$var$isValidOrientation(orientation) {
    return $4cf1b6a0967e50d2$var$ORIENTATIONS.includes(orientation);
}
var $4cf1b6a0967e50d2$export$be92b6f5f03c0fe9 = $4cf1b6a0967e50d2$export$1ff3c3f08ae963c0;



var $8vqx4 = parcelRequire("8vqx4");

"use client";
const $d9b8c56ab7fb4d47$export$1ff3c3f08ae963c0 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, orientation: orientation = "horizontal", decorative: decorative = true, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($4cf1b6a0967e50d2$export$be92b6f5f03c0fe9, {
        ref: ref,
        decorative: decorative,
        orientation: orientation,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("shrink-0 bg-border", orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]", className),
        ...props
    }));
$d9b8c56ab7fb4d47$export$1ff3c3f08ae963c0.displayName = $4cf1b6a0967e50d2$export$be92b6f5f03c0fe9.displayName;


/**
 * Variants for the multi-select component to handle different styles.
 * Uses class-variance-authority (cva) to define different styles based on "variant" prop.
 */ const $055c7b3165fc03a4$var$multiSelectVariants = (0, $433b3049f3517ea6$export$87dc52566e90b739)("transition-all duration-300 ease-in-out", {
    variants: {
        variant: {
            default: "border-foreground/10 text-foreground bg-card hover:bg-card/80",
            secondary: "border-foreground/10 bg-secondary text-secondary-foreground hover:bg-secondary/80",
            destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
            inverted: "inverted"
        },
        badgeAnimation: {
            bounce: "hover:-translate-y-1 hover:scale-110",
            pulse: "hover:animate-pulse",
            wiggle: "hover:animate-wiggle",
            fade: "hover:opacity-80",
            slide: "hover:translate-x-1",
            none: ""
        }
    },
    defaultVariants: {
        variant: "default",
        badgeAnimation: "none"
    }
});
const $055c7b3165fc03a4$export$1e7dfd31545b5809 = /*#__PURE__*/ $8vqx4.forwardRef(({ options: options, onValueChange: onValueChange, variant: variant, defaultValue: defaultValue = [], placeholder: placeholder = "Select options", label: label, animation: animation = 0, animationConfig: animationConfig, maxCount: maxCount = 3, modalPopover: modalPopover = false, asChild: asChild = false, className: className, hideSelectAll: hideSelectAll = false, searchable: searchable = true, emptyIndicator: emptyIndicator, autoSize: autoSize = false, singleLine: singleLine = false, popoverClassName: popoverClassName, disabled: disabled = false, responsive: responsive, minWidth: minWidth, maxWidth: maxWidth, deduplicateOptions: deduplicateOptions = false, resetOnDefaultValueChange: resetOnDefaultValueChange = true, closeOnSelect: closeOnSelect = false, ...props }, ref)=>{
    const [selectedValues, setSelectedValues] = $8vqx4.useState(defaultValue);
    const [isPopoverOpen, setIsPopoverOpen] = $8vqx4.useState(false);
    const [isAnimating, setIsAnimating] = $8vqx4.useState(false);
    const [searchValue, setSearchValue] = $8vqx4.useState("");
    const [politeMessage, setPoliteMessage] = $8vqx4.useState("");
    const [assertiveMessage, setAssertiveMessage] = $8vqx4.useState("");
    const prevSelectedCount = $8vqx4.useRef(selectedValues.length);
    const prevIsOpen = $8vqx4.useRef(isPopoverOpen);
    const prevSearchValue = $8vqx4.useRef(searchValue);
    const announce = $8vqx4.useCallback((message, priority = "polite")=>{
        if (priority === "assertive") {
            setAssertiveMessage(message);
            setTimeout(()=>setAssertiveMessage(""), 100);
        } else {
            setPoliteMessage(message);
            setTimeout(()=>setPoliteMessage(""), 100);
        }
    }, []);
    const multiSelectId = $8vqx4.useId();
    const listboxId = `${multiSelectId}-listbox`;
    const triggerDescriptionId = `${multiSelectId}-description`;
    const selectedCountId = `${multiSelectId}-count`;
    const prevDefaultValueRef = $8vqx4.useRef(defaultValue);
    const isGroupedOptions = $8vqx4.useCallback((opts)=>{
        return opts.length > 0 && "heading" in opts[0];
    }, []);
    const arraysEqual = $8vqx4.useCallback((a, b)=>{
        if (a.length !== b.length) return false;
        const sortedA = [
            ...a
        ].sort();
        const sortedB = [
            ...b
        ].sort();
        return sortedA.every((val, index)=>val === sortedB[index]);
    }, []);
    const resetToDefault = $8vqx4.useCallback(()=>{
        setSelectedValues(defaultValue);
        setIsPopoverOpen(false);
        setSearchValue("");
        onValueChange(defaultValue);
    }, [
        defaultValue,
        onValueChange
    ]);
    const buttonRef = $8vqx4.useRef(null);
    $8vqx4.useImperativeHandle(ref, ()=>({
            reset: resetToDefault,
            getSelectedValues: ()=>selectedValues,
            setSelectedValues: (values)=>{
                setSelectedValues(values);
                onValueChange(values);
            },
            clear: ()=>{
                setSelectedValues([]);
                onValueChange([]);
            },
            focus: ()=>{
                if (buttonRef.current) {
                    buttonRef.current.focus();
                    const originalOutline = buttonRef.current.style.outline;
                    const originalOutlineOffset = buttonRef.current.style.outlineOffset;
                    buttonRef.current.style.outline = "2px solid hsl(var(--ring))";
                    buttonRef.current.style.outlineOffset = "2px";
                    setTimeout(()=>{
                        if (buttonRef.current) {
                            buttonRef.current.style.outline = originalOutline;
                            buttonRef.current.style.outlineOffset = originalOutlineOffset;
                        }
                    }, 1000);
                }
            }
        }), [
        resetToDefault,
        selectedValues,
        onValueChange
    ]);
    const [screenSize, setScreenSize] = $8vqx4.useState("desktop");
    $8vqx4.useEffect(()=>{
        if (typeof window === "undefined") return;
        const handleResize = ()=>{
            const width = window.innerWidth;
            if (width < 640) setScreenSize("mobile");
            else if (width < 1024) setScreenSize("tablet");
            else setScreenSize("desktop");
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>{
            if (typeof window !== "undefined") window.removeEventListener("resize", handleResize);
        };
    }, []);
    const getResponsiveSettings = ()=>{
        if (!responsive) return {
            maxCount: maxCount,
            hideIcons: false,
            compactMode: false
        };
        if (responsive === true) {
            const defaultResponsive = {
                mobile: {
                    maxCount: 2,
                    hideIcons: false,
                    compactMode: true
                },
                tablet: {
                    maxCount: 4,
                    hideIcons: false,
                    compactMode: false
                },
                desktop: {
                    maxCount: 6,
                    hideIcons: false,
                    compactMode: false
                }
            };
            const currentSettings = defaultResponsive[screenSize];
            return {
                maxCount: currentSettings?.maxCount ?? maxCount,
                hideIcons: currentSettings?.hideIcons ?? false,
                compactMode: currentSettings?.compactMode ?? false
            };
        }
        const currentSettings = responsive[screenSize];
        return {
            maxCount: currentSettings?.maxCount ?? maxCount,
            hideIcons: currentSettings?.hideIcons ?? false,
            compactMode: currentSettings?.compactMode ?? false
        };
    };
    const responsiveSettings = getResponsiveSettings();
    const getBadgeAnimationClass = ()=>{
        if (animationConfig?.badgeAnimation) switch(animationConfig.badgeAnimation){
            case "bounce":
                return isAnimating ? "animate-bounce" : "hover:-translate-y-1 hover:scale-110";
            case "pulse":
                return "hover:animate-pulse";
            case "wiggle":
                return "hover:animate-wiggle";
            case "fade":
                return "hover:opacity-80";
            case "slide":
                return "hover:translate-x-1";
            case "none":
                return "";
            default:
                return "";
        }
        return isAnimating ? "animate-bounce" : "";
    };
    const getPopoverAnimationClass = ()=>{
        if (animationConfig?.popoverAnimation) switch(animationConfig.popoverAnimation){
            case "scale":
                return "animate-scaleIn";
            case "slide":
                return "animate-slideInDown";
            case "fade":
                return "animate-fadeIn";
            case "flip":
                return "animate-flipIn";
            case "none":
                return "";
            default:
                return "";
        }
        return "";
    };
    const getAllOptions = $8vqx4.useCallback(()=>{
        if (options.length === 0) return [];
        let allOptions;
        if (isGroupedOptions(options)) allOptions = options.flatMap((group)=>group.options);
        else allOptions = options;
        const valueSet = new Set();
        const duplicates = [];
        const uniqueOptions = [];
        allOptions.forEach((option)=>{
            if (valueSet.has(option.value)) {
                duplicates.push(option.value);
                if (!deduplicateOptions) uniqueOptions.push(option);
            } else {
                valueSet.add(option.value);
                uniqueOptions.push(option);
            }
        });
        return deduplicateOptions ? uniqueOptions : allOptions;
    }, [
        options,
        deduplicateOptions,
        isGroupedOptions
    ]);
    const getOptionByValue = $8vqx4.useCallback((value)=>{
        const option = getAllOptions().find((option)=>option.value === value);
        option;
        return option;
    }, [
        getAllOptions
    ]);
    const filteredOptions = $8vqx4.useMemo(()=>{
        if (!searchable || !searchValue) return options;
        if (options.length === 0) return [];
        if (isGroupedOptions(options)) return options.map((group)=>({
                ...group,
                options: group.options.filter((option)=>option.label.toLowerCase().includes(searchValue.toLowerCase()) || option.value.toLowerCase().includes(searchValue.toLowerCase()))
            })).filter((group)=>group.options.length > 0);
        return options.filter((option)=>option.label.toLowerCase().includes(searchValue.toLowerCase()) || option.value.toLowerCase().includes(searchValue.toLowerCase()));
    }, [
        options,
        searchValue,
        searchable,
        isGroupedOptions
    ]);
    const handleInputKeyDown = (event)=>{
        if (event.key === "Enter") setIsPopoverOpen(true);
        else if (event.key === "Backspace" && !event.currentTarget.value) {
            const newSelectedValues = [
                ...selectedValues
            ];
            newSelectedValues.pop();
            setSelectedValues(newSelectedValues);
            onValueChange(newSelectedValues);
        }
    };
    const toggleOption = (optionValue)=>{
        if (disabled) return;
        const option = getOptionByValue(optionValue);
        if (option?.disabled) return;
        const newSelectedValues = selectedValues.includes(optionValue) ? selectedValues.filter((value)=>value !== optionValue) : [
            ...selectedValues,
            optionValue
        ];
        setSelectedValues(newSelectedValues);
        onValueChange(newSelectedValues);
        if (closeOnSelect) setIsPopoverOpen(false);
    };
    const handleClear = ()=>{
        if (disabled) return;
        setSelectedValues([]);
        onValueChange([]);
    };
    const handleTogglePopover = ()=>{
        if (disabled) return;
        setIsPopoverOpen((prev)=>!prev);
    };
    const clearExtraOptions = ()=>{
        if (disabled) return;
        const newSelectedValues = selectedValues.slice(0, responsiveSettings.maxCount);
        setSelectedValues(newSelectedValues);
        onValueChange(newSelectedValues);
    };
    const toggleAll = ()=>{
        if (disabled) return;
        const allOptions = getAllOptions().filter((option)=>!option.disabled);
        if (selectedValues.length === allOptions.length) handleClear();
        else {
            const allValues = allOptions.map((option)=>option.value);
            setSelectedValues(allValues);
            onValueChange(allValues);
        }
        if (closeOnSelect) setIsPopoverOpen(false);
    };
    $8vqx4.useEffect(()=>{
        if (!resetOnDefaultValueChange) return;
        const prevDefaultValue = prevDefaultValueRef.current;
        if (!arraysEqual(prevDefaultValue, defaultValue)) {
            if (!arraysEqual(selectedValues, defaultValue)) setSelectedValues(defaultValue);
            prevDefaultValueRef.current = [
                ...defaultValue
            ];
        }
    }, [
        defaultValue,
        selectedValues,
        arraysEqual,
        resetOnDefaultValueChange
    ]);
    const getWidthConstraints = ()=>{
        const defaultMinWidth = screenSize === "mobile" ? "0px" : "200px";
        const effectiveMinWidth = minWidth || defaultMinWidth;
        const effectiveMaxWidth = maxWidth || "100%";
        return {
            minWidth: effectiveMinWidth,
            maxWidth: effectiveMaxWidth,
            width: autoSize ? "auto" : "100%"
        };
    };
    const widthConstraints = getWidthConstraints();
    $8vqx4.useEffect(()=>{
        if (!isPopoverOpen) setSearchValue("");
    }, [
        isPopoverOpen
    ]);
    $8vqx4.useEffect(()=>{
        const selectedCount = selectedValues.length;
        const allOptions = getAllOptions();
        const totalOptions = allOptions.filter((opt)=>!opt.disabled).length;
        if (selectedCount !== prevSelectedCount.current) {
            const diff = selectedCount - prevSelectedCount.current;
            if (diff > 0) {
                const addedItems = selectedValues.slice(-diff);
                const addedLabels = addedItems.map((value)=>allOptions.find((opt)=>opt.value === value)?.label).filter(Boolean);
                if (addedLabels.length === 1) announce(`${addedLabels[0]} selected. ${selectedCount} of ${totalOptions} options selected.`);
                else announce(`${addedLabels.length} options selected. ${selectedCount} of ${totalOptions} total selected.`);
            } else if (diff < 0) announce(`Option removed. ${selectedCount} of ${totalOptions} options selected.`);
            prevSelectedCount.current = selectedCount;
        }
        if (isPopoverOpen !== prevIsOpen.current) {
            if (isPopoverOpen) announce(`Dropdown opened. ${totalOptions} options available. Use arrow keys to navigate.`);
            else announce("Dropdown closed.");
            prevIsOpen.current = isPopoverOpen;
        }
        if (searchValue !== prevSearchValue.current && searchValue !== undefined) {
            if (searchValue && isPopoverOpen) {
                const filteredCount = allOptions.filter((opt)=>opt.label.toLowerCase().includes(searchValue.toLowerCase()) || opt.value.toLowerCase().includes(searchValue.toLowerCase())).length;
                announce(`${filteredCount} option${filteredCount === 1 ? "" : "s"} found for "${searchValue}"`);
            }
            prevSearchValue.current = searchValue;
        }
    }, [
        selectedValues,
        isPopoverOpen,
        searchValue,
        announce,
        getAllOptions
    ]);
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "sr-only",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        "aria-live": "polite",
                        "aria-atomic": "true",
                        role: "status",
                        children: politeMessage
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        "aria-live": "assertive",
                        "aria-atomic": "true",
                        role: "alert",
                        children: assertiveMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $5ac343943c48bdee$export$5b6b19405a83ff9d), {
                open: isPopoverOpen,
                onOpenChange: setIsPopoverOpen,
                modal: modalPopover,
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        id: triggerDescriptionId,
                        className: "sr-only",
                        children: "Multi-select dropdown. Use arrow keys to navigate, Enter to select, and Escape to close."
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        id: selectedCountId,
                        className: "sr-only",
                        "aria-live": "polite",
                        children: selectedValues.length === 0 ? "No options selected" : `${selectedValues.length} option${selectedValues.length === 1 ? "" : "s"} selected: ${selectedValues.map((value)=>getOptionByValue(value)?.label).filter(Boolean).join(", ")}`
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $5ac343943c48bdee$export$7dacb05d26466c3), {
                        asChild: true,
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $d0c52b32c142f53d$export$353f5b6fc5456de1), {
                            ref: buttonRef,
                            ...props,
                            onClick: handleTogglePopover,
                            disabled: disabled,
                            role: "combobox",
                            "aria-expanded": isPopoverOpen,
                            "aria-haspopup": "listbox",
                            "aria-controls": isPopoverOpen ? listboxId : undefined,
                            "aria-describedby": `${triggerDescriptionId} ${selectedCountId}`,
                            "aria-label": `Multi-select: ${selectedValues.length} of ${getAllOptions().length} options selected. ${placeholder}`,
                            className: (0, $db53bf731136662c$export$1343a74baacb0543)("relative flex h-auto min-h-10 flex-col items-center justify-between rounded-[4px] border-[1px] border-[#DEDDDB] bg-transparent px-3 py-3 hover:bg-inherit [&_svg]:pointer-events-auto", autoSize ? "w-auto" : "w-full", responsiveSettings.compactMode && "min-h-8 text-sm", screenSize === "mobile" && "min-h-12 text-base", disabled && "cursor-not-allowed opacity-50", className),
                            style: {
                                ...widthConstraints,
                                maxWidth: `min(${widthConstraints.maxWidth}, 100%)`,
                                boxShadow: "none"
                            },
                            children: [
                                label && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("label", {
                                    className: `self-start font-barlowregular text-[12px] text-[#7F7F7F]`,
                                    children: label
                                }),
                                selectedValues.length > 0 ? /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                    className: "flex w-full items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex items-center gap-1", singleLine ? "multiselect-singleline-scroll overflow-x-auto" : "flex-wrap", responsiveSettings.compactMode && "gap-0.5"),
                                            style: singleLine ? {
                                                paddingBottom: "4px"
                                            } : {},
                                            children: [
                                                selectedValues.slice(0, responsiveSettings.maxCount).map((value)=>{
                                                    const option = getOptionByValue(value);
                                                    const IconComponent = option?.icon;
                                                    const customStyle = option?.style;
                                                    if (!option) return null;
                                                    const badgeStyle = {
                                                        animationDuration: `${animation}s`,
                                                        ...customStyle?.badgeColor && {
                                                            backgroundColor: customStyle.badgeColor
                                                        },
                                                        ...customStyle?.gradient && {
                                                            background: customStyle.gradient,
                                                            color: "white"
                                                        }
                                                    };
                                                    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $8367922339ab77c6$export$37acb3580601e69a), {
                                                        className: (0, $db53bf731136662c$export$1343a74baacb0543)(getBadgeAnimationClass(), $055c7b3165fc03a4$var$multiSelectVariants({
                                                            variant: variant
                                                        }), customStyle?.gradient && "border-transparent text-white", responsiveSettings.compactMode && "px-1.5 py-0.5 text-xs", screenSize === "mobile" && "max-w-[120px] truncate", singleLine && "flex-shrink-0 whitespace-nowrap", "[&>svg]:pointer-events-auto"),
                                                        style: {
                                                            ...badgeStyle,
                                                            animationDuration: `${animationConfig?.duration || animation}s`,
                                                            animationDelay: `${animationConfig?.delay || 0}s`
                                                        },
                                                        children: [
                                                            IconComponent && !responsiveSettings.hideIcons && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)(IconComponent, {
                                                                className: (0, $db53bf731136662c$export$1343a74baacb0543)("mr-2 h-4 w-4", responsiveSettings.compactMode && "mr-1 h-3 w-3", customStyle?.iconColor && "text-current"),
                                                                ...customStyle?.iconColor && {
                                                                    style: {
                                                                        color: customStyle.iconColor
                                                                    }
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                                className: (0, $db53bf731136662c$export$1343a74baacb0543)(screenSize === "mobile" && "truncate"),
                                                                children: option.label
                                                            }),
                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                                role: "button",
                                                                tabIndex: 0,
                                                                onClick: (event)=>{
                                                                    event.stopPropagation();
                                                                    toggleOption(value);
                                                                },
                                                                onKeyDown: (event)=>{
                                                                    if (event.key === "Enter" || event.key === " ") {
                                                                        event.preventDefault();
                                                                        event.stopPropagation();
                                                                        toggleOption(value);
                                                                    }
                                                                },
                                                                "aria-label": `Remove ${option.label} from selection`,
                                                                className: "-m-0.5 ml-2 h-4 w-4 cursor-pointer rounded-sm hover:bg-white/20 focus:outline-none focus:ring-1 focus:ring-white/50",
                                                                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $4e7c658008b40246$export$2e2bcd8739ae039), {
                                                                    className: (0, $db53bf731136662c$export$1343a74baacb0543)("h-3 w-3", responsiveSettings.compactMode && "h-2.5 w-2.5")
                                                                })
                                                            })
                                                        ]
                                                    }, value);
                                                }).filter(Boolean),
                                                selectedValues.length > responsiveSettings.maxCount && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $8367922339ab77c6$export$37acb3580601e69a), {
                                                    className: (0, $db53bf731136662c$export$1343a74baacb0543)("border-foreground/1 bg-transparent text-foreground hover:bg-transparent", getBadgeAnimationClass(), $055c7b3165fc03a4$var$multiSelectVariants({
                                                        variant: variant
                                                    }), responsiveSettings.compactMode && "px-1.5 py-0.5 text-xs", singleLine && "flex-shrink-0 whitespace-nowrap", "[&>svg]:pointer-events-auto"),
                                                    style: {
                                                        animationDuration: `${animationConfig?.duration || animation}s`,
                                                        animationDelay: `${animationConfig?.delay || 0}s`
                                                    },
                                                    children: [
                                                        `+ ${selectedValues.length - responsiveSettings.maxCount} more`,
                                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $4e7c658008b40246$export$2e2bcd8739ae039), {
                                                            className: (0, $db53bf731136662c$export$1343a74baacb0543)("ml-2 h-4 w-4 cursor-pointer", responsiveSettings.compactMode && "ml-1 h-3 w-3"),
                                                            onClick: (event)=>{
                                                                event.stopPropagation();
                                                                clearExtraOptions();
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                            className: "flex items-center justify-between",
                                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                role: "button",
                                                tabIndex: 0,
                                                onClick: (event)=>{
                                                    event.stopPropagation();
                                                    handleClear();
                                                },
                                                onKeyDown: (event)=>{
                                                    if (event.key === "Enter" || event.key === " ") {
                                                        event.preventDefault();
                                                        event.stopPropagation();
                                                        handleClear();
                                                    }
                                                },
                                                "aria-label": `Clear all ${selectedValues.length} selected options`,
                                                className: "flex h-6 w-6 cursor-pointer items-center justify-center rounded-sm text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1",
                                                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $10805d788c1e909d$export$2e2bcd8739ae039), {
                                                    className: "h-8 w-8"
                                                })
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "mx-auto flex w-full items-center justify-between",
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                        className: "text-base text-[#736F62]",
                                        children: placeholder
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $5ac343943c48bdee$export$d7e1f420b25549ff), {
                        id: listboxId,
                        role: "listbox",
                        "aria-multiselectable": "true",
                        "aria-label": "Available options",
                        className: (0, $db53bf731136662c$export$1343a74baacb0543)("w-auto p-0", getPopoverAnimationClass(), screenSize === "mobile" && "w-[85vw] max-w-[280px]", screenSize === "tablet" && "w-[70vw] max-w-md", screenSize === "desktop" && "min-w-[300px]", popoverClassName),
                        style: {
                            animationDuration: `${animationConfig?.duration || animation}s`,
                            animationDelay: `${animationConfig?.delay || 0}s`,
                            maxWidth: `min(${widthConstraints.maxWidth}, 85vw)`,
                            maxHeight: screenSize === "mobile" ? "70vh" : "60vh",
                            touchAction: "manipulation"
                        },
                        align: "start",
                        onEscapeKeyDown: ()=>setIsPopoverOpen(false),
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $076d2fb20333d587$export$cc7e12c76513e857), {
                            children: [
                                searchable && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $076d2fb20333d587$export$ebdebb88e46df62a), {
                                    placeholder: "Search options...",
                                    onKeyDown: handleInputKeyDown,
                                    value: searchValue,
                                    onValueChange: setSearchValue,
                                    "aria-label": "Search through available options",
                                    "aria-describedby": `${multiSelectId}-search-help`
                                }),
                                searchable && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    id: `${multiSelectId}-search-help`,
                                    className: "sr-only",
                                    children: "Type to filter options. Use arrow keys to navigate results."
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $076d2fb20333d587$export$9cffcb65e9381872), {
                                    className: (0, $db53bf731136662c$export$1343a74baacb0543)("multiselect-scrollbar max-h-[40vh] overflow-y-auto", screenSize === "mobile" && "max-h-[50vh]", "overscroll-behavior-y-contain"),
                                    children: [
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $076d2fb20333d587$export$f1753c65029fce09), {
                                            children: emptyIndicator || "No results found."
                                        }),
                                        " ",
                                        !hideSelectAll && !searchValue && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $076d2fb20333d587$export$c157b9873a7a0fbd), {
                                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $076d2fb20333d587$export$b9b346a733d36f61), {
                                                onSelect: toggleAll,
                                                role: "option",
                                                "aria-selected": selectedValues.length === getAllOptions().filter((opt)=>!opt.disabled).length,
                                                "aria-label": `Select all ${getAllOptions().length} options`,
                                                className: "cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                        className: (0, $db53bf731136662c$export$1343a74baacb0543)("mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary", selectedValues.length === getAllOptions().filter((opt)=>!opt.disabled).length ? "bg-primary text-primary-foreground" : "opacity-50 [&_svg]:invisible"),
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $2b1309f325581922$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("span", {
                                                        children: [
                                                            "(Select All",
                                                            getAllOptions().length > 20 ? ` - ${getAllOptions().length} options` : "",
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            }, "all")
                                        }),
                                        isGroupedOptions(filteredOptions) ? filteredOptions.map((group)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $076d2fb20333d587$export$c157b9873a7a0fbd), {
                                                heading: group.heading,
                                                children: group.options.map((option)=>{
                                                    const isSelected = selectedValues.includes(option.value);
                                                    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $076d2fb20333d587$export$b9b346a733d36f61), {
                                                        onSelect: ()=>toggleOption(option.value),
                                                        role: "option",
                                                        "aria-selected": isSelected,
                                                        "aria-disabled": option.disabled,
                                                        "aria-label": `${option.label}${isSelected ? ", selected" : ", not selected"}${option.disabled ? ", disabled" : ""}`,
                                                        className: (0, $db53bf731136662c$export$1343a74baacb0543)("cursor-pointer", option.disabled && "cursor-not-allowed opacity-50"),
                                                        disabled: option.disabled,
                                                        children: [
                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                                className: (0, $db53bf731136662c$export$1343a74baacb0543)("mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary", isSelected ? "bg-primary text-primary-foreground" : "opacity-50 [&_svg]:invisible"),
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $2b1309f325581922$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4"
                                                                })
                                                            }),
                                                            option.icon && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)(option.icon, {
                                                                className: "mr-2 h-4 w-4 text-muted-foreground",
                                                                "aria-hidden": "true"
                                                            }),
                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                                children: option.label
                                                            })
                                                        ]
                                                    }, option.value);
                                                })
                                            }, group.heading)) : /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $076d2fb20333d587$export$c157b9873a7a0fbd), {
                                            children: filteredOptions.map((option)=>{
                                                const isSelected = selectedValues.includes(option.value);
                                                return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $076d2fb20333d587$export$b9b346a733d36f61), {
                                                    onSelect: ()=>toggleOption(option.value),
                                                    role: "option",
                                                    "aria-selected": isSelected,
                                                    "aria-disabled": option.disabled,
                                                    "aria-label": `${option.label}${isSelected ? ", selected" : ", not selected"}${option.disabled ? ", disabled" : ""}`,
                                                    className: (0, $db53bf731136662c$export$1343a74baacb0543)("cursor-pointer", option.disabled && "cursor-not-allowed opacity-50"),
                                                    disabled: option.disabled,
                                                    children: [
                                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                            className: (0, $db53bf731136662c$export$1343a74baacb0543)("mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary", isSelected ? "bg-primary text-primary-foreground" : "opacity-50 [&_svg]:invisible"),
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $2b1309f325581922$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4"
                                                            })
                                                        }),
                                                        option.icon && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)(option.icon, {
                                                            className: "mr-2 h-4 w-4 text-muted-foreground",
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                            children: option.label
                                                        })
                                                    ]
                                                }, option.value);
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $076d2fb20333d587$export$ace649eed6990b42), {}),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $076d2fb20333d587$export$c157b9873a7a0fbd), {
                                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    selectedValues.length > 0 && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $076d2fb20333d587$export$b9b346a733d36f61), {
                                                                onSelect: handleClear,
                                                                className: "flex-1 cursor-pointer justify-center",
                                                                children: "Clear"
                                                            }),
                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $d9b8c56ab7fb4d47$export$1ff3c3f08ae963c0), {
                                                                orientation: "vertical",
                                                                className: "flex h-full min-h-6"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $076d2fb20333d587$export$b9b346a733d36f61), {
                                                        onSelect: ()=>setIsPopoverOpen(false),
                                                        className: "max-w-full flex-1 cursor-pointer justify-center",
                                                        children: "Close"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    animation > 0 && selectedValues.length > 0 && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $3988130f99a827cb$export$2e2bcd8739ae039), {
                        className: (0, $db53bf731136662c$export$1343a74baacb0543)("my-2 h-3 w-3 cursor-pointer bg-background text-foreground", isAnimating ? "" : "text-muted-foreground"),
                        onClick: ()=>setIsAnimating(!isAnimating)
                    })
                ]
            })
        ]
    });
});
$055c7b3165fc03a4$export$1e7dfd31545b5809.displayName = "MultiSelect";




var $8vqx4 = parcelRequire("8vqx4");

var $hiyfL = parcelRequire("hiyfL");
// packages/core/number/src/number.ts
function $643e62db61bbfef1$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}




var $8vqx4 = parcelRequire("8vqx4");




"use client";
function $9e5dc6617ffc41b2$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $9ec698e3cd37fa7e$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $6fd952efea14ce9a$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $6fd952efea14ce9a$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useRef(null);
        const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}
// src/ordered-dictionary.ts
var $9e5dc6617ffc41b2$var$__instanciated = /* @__PURE__ */ new WeakMap();
var $9e5dc6617ffc41b2$var$OrderedDict = class _OrderedDict extends Map {
    #keys;
    constructor(entries){
        super(entries);
        this.#keys = [
            ...super.keys()
        ];
        $9e5dc6617ffc41b2$var$__instanciated.set(this, true);
    }
    set(key, value) {
        if ($9e5dc6617ffc41b2$var$__instanciated.get(this)) {
            if (this.has(key)) this.#keys[this.#keys.indexOf(key)] = key;
            else this.#keys.push(key);
        }
        super.set(key, value);
        return this;
    }
    insert(index, key, value) {
        const has = this.has(key);
        const length = this.#keys.length;
        const relativeIndex = $9e5dc6617ffc41b2$var$toSafeInteger(index);
        let actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
        const safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
        if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
            this.set(key, value);
            return this;
        }
        const size = this.size + (has ? 0 : 1);
        if (relativeIndex < 0) actualIndex++;
        const keys = [
            ...this.#keys
        ];
        let nextValue;
        let shouldSkip = false;
        for(let i = actualIndex; i < size; i++)if (actualIndex === i) {
            let nextKey = keys[i];
            if (keys[i] === key) nextKey = keys[i + 1];
            if (has) this.delete(key);
            nextValue = this.get(nextKey);
            this.set(key, value);
        } else {
            if (!shouldSkip && keys[i - 1] === key) shouldSkip = true;
            const currentKey = keys[shouldSkip ? i : i - 1];
            const currentValue = nextValue;
            nextValue = this.get(currentKey);
            this.delete(currentKey);
            this.set(currentKey, currentValue);
        }
        return this;
    }
    with(index, key, value) {
        const copy = new _OrderedDict(this);
        copy.insert(index, key, value);
        return copy;
    }
    before(key) {
        const index = this.#keys.indexOf(key) - 1;
        if (index < 0) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position before the given key.
   */ setBefore(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index, newKey, value);
    }
    after(key) {
        let index = this.#keys.indexOf(key);
        index = index === -1 || index === this.size - 1 ? -1 : index + 1;
        if (index === -1) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position after the given key.
   */ setAfter(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index + 1, newKey, value);
    }
    first() {
        return this.entryAt(0);
    }
    last() {
        return this.entryAt(-1);
    }
    clear() {
        this.#keys = [];
        return super.clear();
    }
    delete(key) {
        const deleted = super.delete(key);
        if (deleted) this.#keys.splice(this.#keys.indexOf(key), 1);
        return deleted;
    }
    deleteAt(index) {
        const key = this.keyAt(index);
        if (key !== void 0) return this.delete(key);
        return false;
    }
    at(index) {
        const key = $9e5dc6617ffc41b2$var$at(this.#keys, index);
        if (key !== void 0) return this.get(key);
    }
    entryAt(index) {
        const key = $9e5dc6617ffc41b2$var$at(this.#keys, index);
        if (key !== void 0) return [
            key,
            this.get(key)
        ];
    }
    indexOf(key) {
        return this.#keys.indexOf(key);
    }
    keyAt(index) {
        return $9e5dc6617ffc41b2$var$at(this.#keys, index);
    }
    from(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.at(dest);
    }
    keyFrom(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.keyAt(dest);
    }
    find(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return entry;
            index++;
        }
        return void 0;
    }
    findIndex(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return index;
            index++;
        }
        return -1;
    }
    filter(predicate, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) entries.push(entry);
            index++;
        }
        return new _OrderedDict(entries);
    }
    map(callbackfn, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            entries.push([
                entry[0],
                Reflect.apply(callbackfn, thisArg, [
                    entry,
                    index,
                    this
                ])
            ]);
            index++;
        }
        return new _OrderedDict(entries);
    }
    reduce(...args) {
        const [callbackfn, initialValue] = args;
        let index = 0;
        let accumulator = initialValue ?? this.at(0);
        for (const entry of this){
            if (index === 0 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
            index++;
        }
        return accumulator;
    }
    reduceRight(...args) {
        const [callbackfn, initialValue] = args;
        let accumulator = initialValue ?? this.at(-1);
        for(let index = this.size - 1; index >= 0; index--){
            const entry = this.at(index);
            if (index === this.size - 1 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
        }
        return accumulator;
    }
    toSorted(compareFn) {
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        return new _OrderedDict(entries);
    }
    toReversed() {
        const reversed = new _OrderedDict();
        for(let index = this.size - 1; index >= 0; index--){
            const key = this.keyAt(index);
            const element = this.get(key);
            reversed.set(key, element);
        }
        return reversed;
    }
    toSpliced(...args) {
        const entries = [
            ...this.entries()
        ];
        entries.splice(...args);
        return new _OrderedDict(entries);
    }
    slice(start, end) {
        const result = new _OrderedDict();
        let stop = this.size - 1;
        if (start === void 0) return result;
        if (start < 0) start = start + this.size;
        if (end !== void 0 && end > 0) stop = end - 1;
        for(let index = start; index <= stop; index++){
            const key = this.keyAt(index);
            const element = this.get(key);
            result.set(key, element);
        }
        return result;
    }
    every(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (!Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return false;
            index++;
        }
        return true;
    }
    some(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return true;
            index++;
        }
        return false;
    }
};
function $9e5dc6617ffc41b2$var$at(array, index) {
    if ("at" in Array.prototype) return Array.prototype.at.call(array, index);
    const actualIndex = $9e5dc6617ffc41b2$var$toSafeIndex(array, index);
    return actualIndex === -1 ? void 0 : array[actualIndex];
}
function $9e5dc6617ffc41b2$var$toSafeIndex(array, index) {
    const length = array.length;
    const relativeIndex = $9e5dc6617ffc41b2$var$toSafeInteger(index);
    const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
    return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
function $9e5dc6617ffc41b2$var$toSafeInteger(number) {
    return number !== number || number === 0 ? 0 : Math.trunc(number);
}
function $9e5dc6617ffc41b2$export$ec5c5a85b7371a0f(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $9ec698e3cd37fa7e$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionContextProvider, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionElement: null,
        collectionRef: {
            current: null
        },
        collectionRefObject: {
            current: null
        },
        itemMap: new $9e5dc6617ffc41b2$var$OrderedDict(),
        setItemMap: ()=>void 0
    });
    const CollectionProvider = ({ state: state, ...props })=>{
        return state ? /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        }) : /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(CollectionInit, {
            ...props
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const CollectionInit = (props)=>{
        const state = useInitCollection();
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        });
    };
    CollectionInit.displayName = PROVIDER_NAME + "Init";
    const CollectionProviderImpl = (props)=>{
        const { scope: scope, children: children, state: state } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useRef(null);
        const [collectionElement, setCollectionElement] = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useState(null);
        const composeRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(ref, setCollectionElement);
        const [itemMap, setItemMap] = state;
        (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useEffect(()=>{
            if (!collectionElement) return;
            const observer = $9e5dc6617ffc41b2$var$getChildListObserver(()=>{});
            observer.observe(collectionElement, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            collectionElement
        ]);
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(CollectionContextProvider, {
            scope: scope,
            itemMap: itemMap,
            setItemMap: setItemMap,
            collectionRef: composeRefs,
            collectionRefObject: ref,
            collectionElement: collectionElement,
            children: children
        });
    };
    CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $6fd952efea14ce9a$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $6fd952efea14ce9a$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useRef(null);
        const [element, setElement] = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useState(null);
        const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, ref, setElement);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        const { setItemMap: setItemMap } = context;
        const itemDataRef = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useRef(itemData);
        if (!$9e5dc6617ffc41b2$var$shallowEqual(itemDataRef.current, itemData)) itemDataRef.current = itemData;
        const memoizedItemData = itemDataRef.current;
        (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useEffect(()=>{
            const itemData2 = memoizedItemData;
            setItemMap((map)=>{
                if (!element) return map;
                if (!map.has(element)) {
                    map.set(element, {
                        ...itemData2,
                        element: element
                    });
                    return map.toSorted($9e5dc6617ffc41b2$var$sortByDocumentPosition);
                }
                return map.set(element, {
                    ...itemData2,
                    element: element
                }).toSorted($9e5dc6617ffc41b2$var$sortByDocumentPosition);
            });
            return ()=>{
                setItemMap((map)=>{
                    if (!element || !map.has(element)) return map;
                    map.delete(element);
                    return new $9e5dc6617ffc41b2$var$OrderedDict(map);
                });
            };
        }, [
            element,
            memoizedItemData,
            setItemMap
        ]);
        return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useInitCollection() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useState(new $9e5dc6617ffc41b2$var$OrderedDict());
    }
    function useCollection(scope) {
        const { itemMap: itemMap } = useCollectionContext(name + "CollectionConsumer", scope);
        return itemMap;
    }
    const functions = {
        createCollectionScope: createCollectionScope,
        useCollection: useCollection,
        useInitCollection: useInitCollection
    };
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        functions
    ];
}
function $9e5dc6617ffc41b2$var$shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if (a == null || b == null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $9e5dc6617ffc41b2$var$isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
function $9e5dc6617ffc41b2$var$sortByDocumentPosition(a, b) {
    return !a[1].element || !b[1].element ? 0 : $9e5dc6617ffc41b2$var$isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
function $9e5dc6617ffc41b2$var$getChildListObserver(callback) {
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "childList") {
            callback();
            return;
        }
    });
    return observer;
}




// packages/react/direction/src/direction.tsx

var $8vqx4 = parcelRequire("8vqx4");

var $cb91734f68068fe9$var$DirectionContext = $8vqx4.createContext(void 0);
var $cb91734f68068fe9$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($cb91734f68068fe9$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $cb91734f68068fe9$export$b39126d51d94e6f3(localDir) {
    const globalDir = $8vqx4.useContext($cb91734f68068fe9$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $cb91734f68068fe9$export$2881499e37b75b9a = $cb91734f68068fe9$export$c760c09fdd558351;













// packages/react/use-previous/src/use-previous.tsx

var $8vqx4 = parcelRequire("8vqx4");
function $dc585503d6fa4fda$export$5cae361ad82dce8b(value) {
    const ref = $8vqx4.useRef({
        value: value,
        previous: value
    });
    return $8vqx4.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}


// src/visually-hidden.tsx

var $8vqx4 = parcelRequire("8vqx4");


var $a1d908b48f2280fa$export$f23ec2f542b3b173 = Object.freeze({
    // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal"
});
var $a1d908b48f2280fa$var$NAME = "VisuallyHidden";
var $a1d908b48f2280fa$export$439d29a4e110a164 = $8vqx4.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).span, {
        ...props,
        ref: forwardedRef,
        style: {
            ...$a1d908b48f2280fa$export$f23ec2f542b3b173,
            ...props.style
        }
    });
});
$a1d908b48f2280fa$export$439d29a4e110a164.displayName = $a1d908b48f2280fa$var$NAME;
var $a1d908b48f2280fa$export$be92b6f5f03c0fe9 = $a1d908b48f2280fa$export$439d29a4e110a164;





"use client";
var $ac74e1b1d7117324$var$OPEN_KEYS = [
    " ",
    "Enter",
    "ArrowUp",
    "ArrowDown"
];
var $ac74e1b1d7117324$var$SELECTION_KEYS = [
    " ",
    "Enter"
];
var $ac74e1b1d7117324$var$SELECT_NAME = "Select";
var [$ac74e1b1d7117324$var$Collection, $ac74e1b1d7117324$var$useCollection, $ac74e1b1d7117324$var$createCollectionScope] = (0, $9e5dc6617ffc41b2$export$c74125a8e3af6bb2)($ac74e1b1d7117324$var$SELECT_NAME);
var [$ac74e1b1d7117324$var$createSelectContext, $ac74e1b1d7117324$export$286727a75dc039bd] = (0, $9ec698e3cd37fa7e$export$50c7b4e9d9f19c1)($ac74e1b1d7117324$var$SELECT_NAME, [
    $ac74e1b1d7117324$var$createCollectionScope,
    (0, $2077c174299ab414$export$722aac194ae923)
]);
var $ac74e1b1d7117324$var$usePopperScope = (0, $2077c174299ab414$export$722aac194ae923)();
var [$ac74e1b1d7117324$var$SelectProvider, $ac74e1b1d7117324$var$useSelectContext] = $ac74e1b1d7117324$var$createSelectContext($ac74e1b1d7117324$var$SELECT_NAME);
var [$ac74e1b1d7117324$var$SelectNativeOptionsProvider, $ac74e1b1d7117324$var$useSelectNativeOptionsContext] = $ac74e1b1d7117324$var$createSelectContext($ac74e1b1d7117324$var$SELECT_NAME);
var $ac74e1b1d7117324$export$ef9b1a59e592288f = (props)=>{
    const { __scopeSelect: __scopeSelect, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange, dir: dir, name: name, autoComplete: autoComplete, disabled: disabled, required: required, form: form } = props;
    const popperScope = $ac74e1b1d7117324$var$usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = $8vqx4.useState(null);
    const [valueNode, setValueNode] = $8vqx4.useState(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = $8vqx4.useState(false);
    const direction = (0, $cb91734f68068fe9$export$b39126d51d94e6f3)(dir);
    const [open, setOpen] = (0, $2da738009a11930c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $ac74e1b1d7117324$var$SELECT_NAME
    });
    const [value, setValue] = (0, $2da738009a11930c$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange,
        caller: $ac74e1b1d7117324$var$SELECT_NAME
    });
    const triggerPointerDownPosRef = $8vqx4.useRef(null);
    const isFormControl = trigger ? form || !!trigger.closest("form") : true;
    const [nativeOptionsSet, setNativeOptionsSet] = $8vqx4.useState(/* @__PURE__ */ new Set());
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value).join(";");
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($2077c174299ab414$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsxs)($ac74e1b1d7117324$var$SelectProvider, {
            required: required,
            scope: __scopeSelect,
            trigger: trigger,
            onTriggerChange: setTrigger,
            valueNode: valueNode,
            onValueNodeChange: setValueNode,
            valueNodeHasChildren: valueNodeHasChildren,
            onValueNodeHasChildrenChange: setValueNodeHasChildren,
            contentId: (0, $48f6e55cf3c4c05f$export$f680877a34711e37)(),
            value: value,
            onValueChange: setValue,
            open: open,
            onOpenChange: setOpen,
            dir: direction,
            triggerPointerDownPosRef: triggerPointerDownPosRef,
            disabled: disabled,
            children: [
                /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$var$Collection.Provider, {
                    scope: __scopeSelect,
                    children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$var$SelectNativeOptionsProvider, {
                        scope: props.__scopeSelect,
                        onNativeOptionAdd: $8vqx4.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>new Set(prev).add(option));
                        }, []),
                        onNativeOptionRemove: $8vqx4.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>{
                                const optionsSet = new Set(prev);
                                optionsSet.delete(option);
                                return optionsSet;
                            });
                        }, []),
                        children: children
                    })
                }),
                isFormControl ? /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsxs)($ac74e1b1d7117324$var$SelectBubbleInput, {
                    "aria-hidden": true,
                    required: required,
                    tabIndex: -1,
                    name: name,
                    autoComplete: autoComplete,
                    value: value,
                    onChange: (event)=>setValue(event.target.value),
                    disabled: disabled,
                    form: form,
                    children: [
                        value === void 0 ? /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)("option", {
                            value: ""
                        }) : null,
                        Array.from(nativeOptionsSet)
                    ]
                }, nativeSelectKey) : null
            ]
        })
    });
};
$ac74e1b1d7117324$export$ef9b1a59e592288f.displayName = $ac74e1b1d7117324$var$SELECT_NAME;
var $ac74e1b1d7117324$var$TRIGGER_NAME = "SelectTrigger";
var $ac74e1b1d7117324$export$3ac1e88a1c0b9f1 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, disabled: disabled = false, ...triggerProps } = props;
    const popperScope = $ac74e1b1d7117324$var$usePopperScope(__scopeSelect);
    const context = $ac74e1b1d7117324$var$useSelectContext($ac74e1b1d7117324$var$TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, context.onTriggerChange);
    const getItems = $ac74e1b1d7117324$var$useCollection(__scopeSelect);
    const pointerTypeRef = $8vqx4.useRef("touch");
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = $ac74e1b1d7117324$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.value === context.value);
        const nextItem = $ac74e1b1d7117324$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem !== void 0) context.onValueChange(nextItem.value);
    });
    const handleOpen = (pointerEvent)=>{
        if (!isDisabled) {
            context.onOpenChange(true);
            resetTypeahead();
        }
        if (pointerEvent) context.triggerPointerDownPosRef.current = {
            x: Math.round(pointerEvent.pageX),
            y: Math.round(pointerEvent.pageY)
        };
    };
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($2077c174299ab414$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).button, {
            type: "button",
            role: "combobox",
            "aria-controls": context.contentId,
            "aria-expanded": context.open,
            "aria-required": context.required,
            "aria-autocomplete": "none",
            dir: context.dir,
            "data-state": context.open ? "open" : "closed",
            disabled: isDisabled,
            "data-disabled": isDisabled ? "" : void 0,
            "data-placeholder": $ac74e1b1d7117324$var$shouldShowPlaceholder(context.value) ? "" : void 0,
            ...triggerProps,
            ref: composedRefs,
            onClick: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(triggerProps.onClick, (event)=>{
                event.currentTarget.focus();
                if (pointerTypeRef.current !== "mouse") handleOpen(event);
            }),
            onPointerDown: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(triggerProps.onPointerDown, (event)=>{
                pointerTypeRef.current = event.pointerType;
                const target = event.target;
                if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
                if (event.button === 0 && event.ctrlKey === false && event.pointerType === "mouse") {
                    handleOpen(event);
                    event.preventDefault();
                }
            }),
            onKeyDown: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(triggerProps.onKeyDown, (event)=>{
                const isTypingAhead = searchRef.current !== "";
                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                if (isTypingAhead && event.key === " ") return;
                if ($ac74e1b1d7117324$var$OPEN_KEYS.includes(event.key)) {
                    handleOpen();
                    event.preventDefault();
                }
            })
        })
    });
});
$ac74e1b1d7117324$export$3ac1e88a1c0b9f1.displayName = $ac74e1b1d7117324$var$TRIGGER_NAME;
var $ac74e1b1d7117324$var$VALUE_NAME = "SelectValue";
var $ac74e1b1d7117324$export$e288731fd71264f0 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, className: className, style: style, children: children, placeholder: placeholder = "", ...valueProps } = props;
    const context = $ac74e1b1d7117324$var$useSelectContext($ac74e1b1d7117324$var$VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange: onValueNodeHasChildrenChange } = context;
    const hasChildren = children !== void 0;
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, context.onValueNodeChange);
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).span, {
        ...valueProps,
        ref: composedRefs,
        style: {
            pointerEvents: "none"
        },
        children: $ac74e1b1d7117324$var$shouldShowPlaceholder(context.value) ? /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $607ae91d1eb97195$exports.Fragment), {
            children: placeholder
        }) : children
    });
});
$ac74e1b1d7117324$export$e288731fd71264f0.displayName = $ac74e1b1d7117324$var$VALUE_NAME;
var $ac74e1b1d7117324$var$ICON_NAME = "SelectIcon";
var $ac74e1b1d7117324$export$99b400cabb58c515 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, children: children, ...iconProps } = props;
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).span, {
        "aria-hidden": true,
        ...iconProps,
        ref: forwardedRef,
        children: children || "\u25BC"
    });
});
$ac74e1b1d7117324$export$99b400cabb58c515.displayName = $ac74e1b1d7117324$var$ICON_NAME;
var $ac74e1b1d7117324$var$PORTAL_NAME = "SelectPortal";
var $ac74e1b1d7117324$export$b2af6c9944296213 = (props)=>{
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $22f2e6a7088dcf5f$export$602eac185826482c), {
        asChild: true,
        ...props
    });
};
$ac74e1b1d7117324$export$b2af6c9944296213.displayName = $ac74e1b1d7117324$var$PORTAL_NAME;
var $ac74e1b1d7117324$var$CONTENT_NAME = "SelectContent";
var $ac74e1b1d7117324$export$c973a4b3cb86a03d = $8vqx4.forwardRef((props, forwardedRef)=>{
    const context = $ac74e1b1d7117324$var$useSelectContext($ac74e1b1d7117324$var$CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = $8vqx4.useState();
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
        const frag = fragment;
        return frag ? $hiyfL.createPortal(/* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$var$SelectContentProvider, {
            scope: props.__scopeSelect,
            children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$var$Collection.Slot, {
                scope: props.__scopeSelect,
                children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    children: props.children
                })
            })
        }), frag) : null;
    }
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$var$SelectContentImpl, {
        ...props,
        ref: forwardedRef
    });
});
$ac74e1b1d7117324$export$c973a4b3cb86a03d.displayName = $ac74e1b1d7117324$var$CONTENT_NAME;
var $ac74e1b1d7117324$var$CONTENT_MARGIN = 10;
var [$ac74e1b1d7117324$var$SelectContentProvider, $ac74e1b1d7117324$var$useSelectContentContext] = $ac74e1b1d7117324$var$createSelectContext($ac74e1b1d7117324$var$CONTENT_NAME);
var $ac74e1b1d7117324$var$CONTENT_IMPL_NAME = "SelectContentImpl";
var $ac74e1b1d7117324$var$Slot = (0, $6fd952efea14ce9a$export$e88b45bda5c13eb9)("SelectContent.RemoveScroll");
var $ac74e1b1d7117324$var$SelectContentImpl = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, position: position = "item-aligned", onCloseAutoFocus: onCloseAutoFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, side: //
    // PopperContent props
    side, sideOffset: sideOffset, align: align, alignOffset: alignOffset, arrowPadding: arrowPadding, collisionBoundary: collisionBoundary, collisionPadding: collisionPadding, sticky: sticky, hideWhenDetached: hideWhenDetached, avoidCollisions: avoidCollisions, //
    ...contentProps } = props;
    const context = $ac74e1b1d7117324$var$useSelectContext($ac74e1b1d7117324$var$CONTENT_NAME, __scopeSelect);
    const [content, setContent] = $8vqx4.useState(null);
    const [viewport, setViewport] = $8vqx4.useState(null);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [selectedItem, setSelectedItem] = $8vqx4.useState(null);
    const [selectedItemText, setSelectedItemText] = $8vqx4.useState(null);
    const getItems = $ac74e1b1d7117324$var$useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = $8vqx4.useState(false);
    const firstValidItemFoundRef = $8vqx4.useRef(false);
    $8vqx4.useEffect(()=>{
        if (content) return (0, $5f2df6acae077059$export$6e33d16126ed003c)(content);
    }, [
        content
    ]);
    (0, $dc875cc1b746c2ea$export$b7ece24a22aeda8c)();
    const focusFirst = $8vqx4.useCallback((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate?.scrollIntoView({
                block: "nearest"
            });
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate?.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = $8vqx4.useCallback(()=>focusFirst([
            selectedItem,
            content
        ]), [
        focusFirst,
        selectedItem,
        content
    ]);
    $8vqx4.useEffect(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]);
    const { onOpenChange: onOpenChange, triggerPointerDownPosRef: triggerPointerDownPosRef } = context;
    $8vqx4.useEffect(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = (event)=>{
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - (triggerPointerDownPosRef.current?.x ?? 0)),
                    y: Math.abs(Math.round(event.pageY) - (triggerPointerDownPosRef.current?.y ?? 0))
                };
            };
            const handlePointerUp = (event)=>{
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else if (!content.contains(event.target)) onOpenChange(false);
                document.removeEventListener("pointermove", handlePointerMove);
                triggerPointerDownPosRef.current = null;
            };
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener("pointermove", handlePointerMove);
                document.addEventListener("pointerup", handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener("pointermove", handlePointerMove);
                document.removeEventListener("pointerup", handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    $8vqx4.useEffect(()=>{
        const close = ()=>onOpenChange(false);
        window.addEventListener("blur", close);
        window.addEventListener("resize", close);
        return ()=>{
            window.removeEventListener("blur", close);
            window.removeEventListener("resize", close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = $ac74e1b1d7117324$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement);
        const nextItem = $ac74e1b1d7117324$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem) setTimeout(()=>nextItem.ref.current.focus());
    });
    const itemRefCallback = $8vqx4.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = $8vqx4.useCallback(()=>content?.focus(), [
        content
    ]);
    const itemTextRefCallback = $8vqx4.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === "popper" ? $ac74e1b1d7117324$var$SelectPopperPosition : $ac74e1b1d7117324$var$SelectItemAlignedPosition;
    const popperContentProps = SelectPosition === $ac74e1b1d7117324$var$SelectPopperPosition ? {
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        hideWhenDetached: hideWhenDetached,
        avoidCollisions: avoidCollisions
    } : {};
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$var$SelectContentProvider, {
        scope: __scopeSelect,
        content: content,
        viewport: viewport,
        onViewportChange: setViewport,
        itemRefCallback: itemRefCallback,
        selectedItem: selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback: itemTextRefCallback,
        focusSelectedItem: focusSelectedItem,
        selectedItemText: selectedItemText,
        position: position,
        isPositioned: isPositioned,
        searchRef: searchRef,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $fb0b2d10375c2e49$export$2e2bcd8739ae039), {
            as: $ac74e1b1d7117324$var$Slot,
            allowPinchZoom: true,
            children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $5bf0528134fa0c3c$export$20e40289641fbbb6), {
                asChild: true,
                trapped: context.open,
                onMountAutoFocus: (event)=>{
                    event.preventDefault();
                },
                onUnmountAutoFocus: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(onCloseAutoFocus, (event)=>{
                    context.trigger?.focus({
                        preventScroll: true
                    });
                    event.preventDefault();
                }),
                children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $d5c981ab09de62ee$export$177fb62ff3ec1f22), {
                    asChild: true,
                    disableOutsidePointerEvents: true,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onPointerDownOutside: onPointerDownOutside,
                    onFocusOutside: (event)=>event.preventDefault(),
                    onDismiss: ()=>context.onOpenChange(false),
                    children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)(SelectPosition, {
                        role: "listbox",
                        id: context.contentId,
                        "data-state": context.open ? "open" : "closed",
                        dir: context.dir,
                        onContextMenu: (event)=>event.preventDefault(),
                        ...contentProps,
                        ...popperContentProps,
                        onPlaced: ()=>setIsPositioned(true),
                        ref: composedRefs,
                        style: {
                            // flex layout so we can place the scroll buttons properly
                            display: "flex",
                            flexDirection: "column",
                            // reset the outline by default as the content MAY get focused
                            outline: "none",
                            ...contentProps.style
                        },
                        onKeyDown: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
                            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                            if (event.key === "Tab") event.preventDefault();
                            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                            if ([
                                "ArrowUp",
                                "ArrowDown",
                                "Home",
                                "End"
                            ].includes(event.key)) {
                                const items = getItems().filter((item)=>!item.disabled);
                                let candidateNodes = items.map((item)=>item.ref.current);
                                if ([
                                    "ArrowUp",
                                    "End"
                                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                                if ([
                                    "ArrowUp",
                                    "ArrowDown"
                                ].includes(event.key)) {
                                    const currentElement = event.target;
                                    const currentIndex = candidateNodes.indexOf(currentElement);
                                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                                }
                                setTimeout(()=>focusFirst(candidateNodes));
                                event.preventDefault();
                            }
                        })
                    })
                })
            })
        })
    });
});
$ac74e1b1d7117324$var$SelectContentImpl.displayName = $ac74e1b1d7117324$var$CONTENT_IMPL_NAME;
var $ac74e1b1d7117324$var$ITEM_ALIGNED_POSITION_NAME = "SelectItemAlignedPosition";
var $ac74e1b1d7117324$var$SelectItemAlignedPosition = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onPlaced: onPlaced, ...popperProps } = props;
    const context = $ac74e1b1d7117324$var$useSelectContext($ac74e1b1d7117324$var$CONTENT_NAME, __scopeSelect);
    const contentContext = $ac74e1b1d7117324$var$useSelectContentContext($ac74e1b1d7117324$var$CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = $8vqx4.useState(null);
    const [content, setContent] = $8vqx4.useState(null);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const getItems = $ac74e1b1d7117324$var$useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = $8vqx4.useRef(false);
    const shouldRepositionRef = $8vqx4.useRef(true);
    const { viewport: viewport, selectedItem: selectedItem, selectedItemText: selectedItemText, focusSelectedItem: focusSelectedItem } = contentContext;
    const position = $8vqx4.useCallback(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect();
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== "rtl") {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - $ac74e1b1d7117324$var$CONTENT_MARGIN;
                const clampedLeft = (0, $643e62db61bbfef1$export$7d15b64cf5a3a4c4)(left, [
                    $ac74e1b1d7117324$var$CONTENT_MARGIN,
                    // Prevents the content from going off the starting edge of the
                    // viewport. It may still go off the ending edge, but this can be
                    // controlled by the user since they may want to manage overflow in a
                    // specific way.
                    // https://github.com/radix-ui/primitives/issues/2049
                    Math.max($ac74e1b1d7117324$var$CONTENT_MARGIN, rightEdge - contentWidth)
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.left = clampedLeft + "px";
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - $ac74e1b1d7117324$var$CONTENT_MARGIN;
                const clampedRight = (0, $643e62db61bbfef1$export$7d15b64cf5a3a4c4)(right, [
                    $ac74e1b1d7117324$var$CONTENT_MARGIN,
                    Math.max($ac74e1b1d7117324$var$CONTENT_MARGIN, leftEdge - contentWidth)
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.right = clampedRight + "px";
            }
            const items = getItems();
            const availableHeight = window.innerHeight - $ac74e1b1d7117324$var$CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth;
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $ac74e1b1d7117324$var$CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = items.length > 0 && selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + // viewport might have padding bottom, include it to avoid a scrollable viewport
                (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + "px";
            } else {
                const isFirstItem = items.length > 0 && selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
                (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + "px";
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${$ac74e1b1d7117324$var$CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + "px";
            contentWrapper.style.maxHeight = availableHeight + "px";
            onPlaced?.();
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true);
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>position(), [
        position
    ]);
    const [contentZIndex, setContentZIndex] = $8vqx4.useState();
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    const handleScrollButtonChange = $8vqx4.useCallback((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem?.();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$var$SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper: contentWrapper,
        shouldExpandOnScrollRef: shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)("div", {
            ref: setContentWrapper,
            style: {
                display: "flex",
                flexDirection: "column",
                position: "fixed",
                zIndex: contentZIndex
            },
            children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
                ...popperProps,
                ref: composedRefs,
                style: {
                    // When we get the height of the content, it includes borders. If we were to set
                    // the height without having `boxSizing: 'border-box'` it would be too big.
                    boxSizing: "border-box",
                    // We need to ensure the content doesn't get taller than the wrapper
                    maxHeight: "100%",
                    ...popperProps.style
                }
            })
        })
    });
});
$ac74e1b1d7117324$var$SelectItemAlignedPosition.displayName = $ac74e1b1d7117324$var$ITEM_ALIGNED_POSITION_NAME;
var $ac74e1b1d7117324$var$POPPER_POSITION_NAME = "SelectPopperPosition";
var $ac74e1b1d7117324$var$SelectPopperPosition = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, align: align = "start", collisionPadding: collisionPadding = $ac74e1b1d7117324$var$CONTENT_MARGIN, ...popperProps } = props;
    const popperScope = $ac74e1b1d7117324$var$usePopperScope(__scopeSelect);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($2077c174299ab414$export$7c6e2c02157bb7d2, {
        ...popperScope,
        ...popperProps,
        ref: forwardedRef,
        align: align,
        collisionPadding: collisionPadding,
        style: {
            // Ensure border-box for floating-ui calculations
            boxSizing: "border-box",
            ...popperProps.style,
            "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-select-content-available-width": "var(--radix-popper-available-width)",
            "--radix-select-content-available-height": "var(--radix-popper-available-height)",
            "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$ac74e1b1d7117324$var$SelectPopperPosition.displayName = $ac74e1b1d7117324$var$POPPER_POSITION_NAME;
var [$ac74e1b1d7117324$var$SelectViewportProvider, $ac74e1b1d7117324$var$useSelectViewportContext] = $ac74e1b1d7117324$var$createSelectContext($ac74e1b1d7117324$var$CONTENT_NAME, {});
var $ac74e1b1d7117324$var$VIEWPORT_NAME = "SelectViewport";
var $ac74e1b1d7117324$export$9ed6e7b40248d36d = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, nonce: nonce, ...viewportProps } = props;
    const contentContext = $ac74e1b1d7117324$var$useSelectContentContext($ac74e1b1d7117324$var$VIEWPORT_NAME, __scopeSelect);
    const viewportContext = $ac74e1b1d7117324$var$useSelectViewportContext($ac74e1b1d7117324$var$VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = $8vqx4.useRef(0);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
                },
                nonce: nonce
            }),
            /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$var$Collection.Slot, {
                scope: __scopeSelect,
                children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
                    "data-radix-select-viewport": "",
                    role: "presentation",
                    ...viewportProps,
                    ref: composedRefs,
                    style: {
                        // we use position: 'relative' here on the `viewport` so that when we call
                        // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
                        // (independent of the scrollUpButton).
                        position: "relative",
                        flex: 1,
                        // Viewport should only be scrollable in the vertical direction.
                        // This won't work in vertical writing modes, so we'll need to
                        // revisit this if/when that is supported
                        // https://developer.chrome.com/blog/vertical-form-controls
                        overflow: "hidden auto",
                        ...viewportProps.style
                    },
                    onScroll: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(viewportProps.onScroll, (event)=>{
                        const viewport = event.currentTarget;
                        const { contentWrapper: contentWrapper, shouldExpandOnScrollRef: shouldExpandOnScrollRef } = viewportContext;
                        if (shouldExpandOnScrollRef?.current && contentWrapper) {
                            const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                            if (scrolledBy > 0) {
                                const availableHeight = window.innerHeight - $ac74e1b1d7117324$var$CONTENT_MARGIN * 2;
                                const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                                const cssHeight = parseFloat(contentWrapper.style.height);
                                const prevHeight = Math.max(cssMinHeight, cssHeight);
                                if (prevHeight < availableHeight) {
                                    const nextHeight = prevHeight + scrolledBy;
                                    const clampedNextHeight = Math.min(availableHeight, nextHeight);
                                    const heightDiff = nextHeight - clampedNextHeight;
                                    contentWrapper.style.height = clampedNextHeight + "px";
                                    if (contentWrapper.style.bottom === "0px") {
                                        viewport.scrollTop = heightDiff > 0 ? heightDiff : 0;
                                        contentWrapper.style.justifyContent = "flex-end";
                                    }
                                }
                            }
                        }
                        prevScrollTopRef.current = viewport.scrollTop;
                    })
                })
            })
        ]
    });
});
$ac74e1b1d7117324$export$9ed6e7b40248d36d.displayName = $ac74e1b1d7117324$var$VIEWPORT_NAME;
var $ac74e1b1d7117324$var$GROUP_NAME = "SelectGroup";
var [$ac74e1b1d7117324$var$SelectGroupContextProvider, $ac74e1b1d7117324$var$useSelectGroupContext] = $ac74e1b1d7117324$var$createSelectContext($ac74e1b1d7117324$var$GROUP_NAME);
var $ac74e1b1d7117324$export$ee25a334c55de1f4 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...groupProps } = props;
    const groupId = (0, $48f6e55cf3c4c05f$export$f680877a34711e37)();
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$var$SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
            role: "group",
            "aria-labelledby": groupId,
            ...groupProps,
            ref: forwardedRef
        })
    });
});
$ac74e1b1d7117324$export$ee25a334c55de1f4.displayName = $ac74e1b1d7117324$var$GROUP_NAME;
var $ac74e1b1d7117324$var$LABEL_NAME = "SelectLabel";
var $ac74e1b1d7117324$export$f67338d29bd972f8 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...labelProps } = props;
    const groupContext = $ac74e1b1d7117324$var$useSelectGroupContext($ac74e1b1d7117324$var$LABEL_NAME, __scopeSelect);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
        id: groupContext.id,
        ...labelProps,
        ref: forwardedRef
    });
});
$ac74e1b1d7117324$export$f67338d29bd972f8.displayName = $ac74e1b1d7117324$var$LABEL_NAME;
var $ac74e1b1d7117324$var$ITEM_NAME = "SelectItem";
var [$ac74e1b1d7117324$var$SelectItemContextProvider, $ac74e1b1d7117324$var$useSelectItemContext] = $ac74e1b1d7117324$var$createSelectContext($ac74e1b1d7117324$var$ITEM_NAME);
var $ac74e1b1d7117324$export$13ef48a934230896 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, value: value, disabled: disabled = false, textValue: textValueProp, ...itemProps } = props;
    const context = $ac74e1b1d7117324$var$useSelectContext($ac74e1b1d7117324$var$ITEM_NAME, __scopeSelect);
    const contentContext = $ac74e1b1d7117324$var$useSelectContentContext($ac74e1b1d7117324$var$ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = $8vqx4.useState(textValueProp ?? "");
    const [isFocused, setIsFocused] = $8vqx4.useState(false);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>contentContext.itemRefCallback?.(node, value, disabled));
    const textId = (0, $48f6e55cf3c4c05f$export$f680877a34711e37)();
    const pointerTypeRef = $8vqx4.useRef("touch");
    const handleSelect = ()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    };
    if (value === "") throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$var$SelectItemContextProvider, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textId: textId,
        isSelected: isSelected,
        onItemTextChange: $8vqx4.useCallback((node)=>{
            setTextValue((prevTextValue)=>prevTextValue || (node?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$var$Collection.ItemSlot, {
            scope: __scopeSelect,
            value: value,
            disabled: disabled,
            textValue: textValue,
            children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
                role: "option",
                "aria-labelledby": textId,
                "data-highlighted": isFocused ? "" : void 0,
                "aria-selected": isSelected && isFocused,
                "data-state": isSelected ? "checked" : "unchecked",
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                tabIndex: disabled ? void 0 : -1,
                ...itemProps,
                ref: composedRefs,
                onFocus: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(itemProps.onBlur, ()=>setIsFocused(false)),
                onClick: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(itemProps.onClick, ()=>{
                    if (pointerTypeRef.current !== "mouse") handleSelect();
                }),
                onPointerUp: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(itemProps.onPointerUp, ()=>{
                    if (pointerTypeRef.current === "mouse") handleSelect();
                }),
                onPointerDown: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(itemProps.onPointerDown, (event)=>{
                    pointerTypeRef.current = event.pointerType;
                }),
                onPointerMove: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(itemProps.onPointerMove, (event)=>{
                    pointerTypeRef.current = event.pointerType;
                    if (disabled) contentContext.onItemLeave?.();
                    else if (pointerTypeRef.current === "mouse") event.currentTarget.focus({
                        preventScroll: true
                    });
                }),
                onPointerLeave: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(itemProps.onPointerLeave, (event)=>{
                    if (event.currentTarget === document.activeElement) contentContext.onItemLeave?.();
                }),
                onKeyDown: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(itemProps.onKeyDown, (event)=>{
                    const isTypingAhead = contentContext.searchRef?.current !== "";
                    if (isTypingAhead && event.key === " ") return;
                    if ($ac74e1b1d7117324$var$SELECTION_KEYS.includes(event.key)) handleSelect();
                    if (event.key === " ") event.preventDefault();
                })
            })
        })
    });
});
$ac74e1b1d7117324$export$13ef48a934230896.displayName = $ac74e1b1d7117324$var$ITEM_NAME;
var $ac74e1b1d7117324$var$ITEM_TEXT_NAME = "SelectItemText";
var $ac74e1b1d7117324$export$3572fb0fb821ff49 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, className: className, style: style, ...itemTextProps } = props;
    const context = $ac74e1b1d7117324$var$useSelectContext($ac74e1b1d7117324$var$ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = $ac74e1b1d7117324$var$useSelectContentContext($ac74e1b1d7117324$var$ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = $ac74e1b1d7117324$var$useSelectItemContext($ac74e1b1d7117324$var$ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = $ac74e1b1d7117324$var$useSelectNativeOptionsContext($ac74e1b1d7117324$var$ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = $8vqx4.useState(null);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setItemTextNode(node), itemContext.onItemTextChange, (node)=>contentContext.itemTextRefCallback?.(node, itemContext.value, itemContext.disabled));
    const textContent = itemTextNode?.textContent;
    const nativeOption = $8vqx4.useMemo(()=>/* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)("option", {
            value: itemContext.value,
            disabled: itemContext.disabled,
            children: textContent
        }, itemContext.value), [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd: onNativeOptionAdd, onNativeOptionRemove: onNativeOptionRemove } = nativeOptionsContext;
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption);
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).span, {
                id: itemContext.textId,
                ...itemTextProps,
                ref: composedRefs
            }),
            itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? $hiyfL.createPortal(itemTextProps.children, context.valueNode) : null
        ]
    });
});
$ac74e1b1d7117324$export$3572fb0fb821ff49.displayName = $ac74e1b1d7117324$var$ITEM_TEXT_NAME;
var $ac74e1b1d7117324$var$ITEM_INDICATOR_NAME = "SelectItemIndicator";
var $ac74e1b1d7117324$export$6b9198de19accfe6 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...itemIndicatorProps } = props;
    const itemContext = $ac74e1b1d7117324$var$useSelectItemContext($ac74e1b1d7117324$var$ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).span, {
        "aria-hidden": true,
        ...itemIndicatorProps,
        ref: forwardedRef
    }) : null;
});
$ac74e1b1d7117324$export$6b9198de19accfe6.displayName = $ac74e1b1d7117324$var$ITEM_INDICATOR_NAME;
var $ac74e1b1d7117324$var$SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
var $ac74e1b1d7117324$export$d8117927658af6d7 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const contentContext = $ac74e1b1d7117324$var$useSelectContentContext($ac74e1b1d7117324$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $ac74e1b1d7117324$var$useSelectViewportContext($ac74e1b1d7117324$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp, setCanScrollUp] = $8vqx4.useState(false);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const canScrollUp2 = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp ? /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$var$SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    }) : null;
});
$ac74e1b1d7117324$export$d8117927658af6d7.displayName = $ac74e1b1d7117324$var$SCROLL_UP_BUTTON_NAME;
var $ac74e1b1d7117324$var$SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
var $ac74e1b1d7117324$export$ff951e476c12189 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const contentContext = $ac74e1b1d7117324$var$useSelectContentContext($ac74e1b1d7117324$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $ac74e1b1d7117324$var$useSelectViewportContext($ac74e1b1d7117324$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown, setCanScrollDown] = $8vqx4.useState(false);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight;
                const canScrollDown2 = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown ? /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$var$SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    }) : null;
});
$ac74e1b1d7117324$export$ff951e476c12189.displayName = $ac74e1b1d7117324$var$SCROLL_DOWN_BUTTON_NAME;
var $ac74e1b1d7117324$var$SelectScrollButtonImpl = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onAutoScroll: onAutoScroll, ...scrollIndicatorProps } = props;
    const contentContext = $ac74e1b1d7117324$var$useSelectContentContext("SelectScrollButton", __scopeSelect);
    const autoScrollTimerRef = $8vqx4.useRef(null);
    const getItems = $ac74e1b1d7117324$var$useCollection(__scopeSelect);
    const clearAutoScrollTimer = $8vqx4.useCallback(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    $8vqx4.useEffect(()=>{
        return ()=>clearAutoScrollTimer();
    }, [
        clearAutoScrollTimer
    ]);
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement);
        activeItem?.ref.current?.scrollIntoView({
            block: "nearest"
        });
    }, [
        getItems
    ]);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
        "aria-hidden": true,
        ...scrollIndicatorProps,
        ref: forwardedRef,
        style: {
            flexShrink: 0,
            ...scrollIndicatorProps.style
        },
        onPointerDown: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerMove, ()=>{
            contentContext.onItemLeave?.();
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    });
});
var $ac74e1b1d7117324$var$SEPARATOR_NAME = "SelectSeparator";
var $ac74e1b1d7117324$export$eba4b1df07cb1d3 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...separatorProps } = props;
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
        "aria-hidden": true,
        ...separatorProps,
        ref: forwardedRef
    });
});
$ac74e1b1d7117324$export$eba4b1df07cb1d3.displayName = $ac74e1b1d7117324$var$SEPARATOR_NAME;
var $ac74e1b1d7117324$var$ARROW_NAME = "SelectArrow";
var $ac74e1b1d7117324$export$314f4cb8f8099628 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...arrowProps } = props;
    const popperScope = $ac74e1b1d7117324$var$usePopperScope(__scopeSelect);
    const context = $ac74e1b1d7117324$var$useSelectContext($ac74e1b1d7117324$var$ARROW_NAME, __scopeSelect);
    const contentContext = $ac74e1b1d7117324$var$useSelectContentContext($ac74e1b1d7117324$var$ARROW_NAME, __scopeSelect);
    return context.open && contentContext.position === "popper" ? /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($2077c174299ab414$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    }) : null;
});
$ac74e1b1d7117324$export$314f4cb8f8099628.displayName = $ac74e1b1d7117324$var$ARROW_NAME;
var $ac74e1b1d7117324$var$BUBBLE_INPUT_NAME = "SelectBubbleInput";
var $ac74e1b1d7117324$var$SelectBubbleInput = $8vqx4.forwardRef(({ __scopeSelect: __scopeSelect, value: value, ...props }, forwardedRef)=>{
    const ref = $8vqx4.useRef(null);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const prevValue = (0, $dc585503d6fa4fda$export$5cae361ad82dce8b)(value);
    $8vqx4.useEffect(()=>{
        const select = ref.current;
        if (!select) return;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("change", {
                bubbles: true
            });
            setValue.call(select, value);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).select, {
        ...props,
        style: {
            ...(0, $a1d908b48f2280fa$export$f23ec2f542b3b173),
            ...props.style
        },
        ref: composedRefs,
        defaultValue: value
    });
});
$ac74e1b1d7117324$var$SelectBubbleInput.displayName = $ac74e1b1d7117324$var$BUBBLE_INPUT_NAME;
function $ac74e1b1d7117324$var$shouldShowPlaceholder(value) {
    return value === "" || value === void 0;
}
function $ac74e1b1d7117324$var$useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0, $0af559af272c0534$export$25bec8c6f54ee79a)(onSearchChange);
    const searchRef = $8vqx4.useRef("");
    const timerRef = $8vqx4.useRef(0);
    const handleTypeaheadSearch = $8vqx4.useCallback((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = $8vqx4.useCallback(()=>{
        searchRef.current = "";
        window.clearTimeout(timerRef.current);
    }, []);
    $8vqx4.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
function $ac74e1b1d7117324$var$findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = $ac74e1b1d7117324$var$wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem);
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextItem !== currentItem ? nextItem : void 0;
}
function $ac74e1b1d7117324$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $ac74e1b1d7117324$export$be92b6f5f03c0fe9 = $ac74e1b1d7117324$export$ef9b1a59e592288f;
var $ac74e1b1d7117324$export$41fb9f06171c75f4 = $ac74e1b1d7117324$export$3ac1e88a1c0b9f1;
var $ac74e1b1d7117324$export$4c8d1a57a761ef94 = $ac74e1b1d7117324$export$e288731fd71264f0;
var $ac74e1b1d7117324$export$f04a61298a47a40f = $ac74e1b1d7117324$export$99b400cabb58c515;
var $ac74e1b1d7117324$export$602eac185826482c = $ac74e1b1d7117324$export$b2af6c9944296213;
var $ac74e1b1d7117324$export$7c6e2c02157bb7d2 = $ac74e1b1d7117324$export$c973a4b3cb86a03d;
var $ac74e1b1d7117324$export$d5c6c08dc2d3ca7 = $ac74e1b1d7117324$export$9ed6e7b40248d36d;
var $ac74e1b1d7117324$export$eb2fcfdbd7ba97d4 = $ac74e1b1d7117324$export$ee25a334c55de1f4;
var $ac74e1b1d7117324$export$b04be29aa201d4f5 = $ac74e1b1d7117324$export$f67338d29bd972f8;
var $ac74e1b1d7117324$export$6d08773d2e66f8f2 = $ac74e1b1d7117324$export$13ef48a934230896;
var $ac74e1b1d7117324$export$d6e5bf9c43ea9319 = $ac74e1b1d7117324$export$3572fb0fb821ff49;
var $ac74e1b1d7117324$export$c3468e2714d175fa = $ac74e1b1d7117324$export$6b9198de19accfe6;
var $ac74e1b1d7117324$export$2f60d3ec9ad468f2 = $ac74e1b1d7117324$export$d8117927658af6d7;
var $ac74e1b1d7117324$export$bf1aedc3039c8d63 = $ac74e1b1d7117324$export$ff951e476c12189;
var $ac74e1b1d7117324$export$1ff3c3f08ae963c0 = $ac74e1b1d7117324$export$eba4b1df07cb1d3;
var $ac74e1b1d7117324$export$21b07c8f274aebd5 = $ac74e1b1d7117324$export$314f4cb8f8099628;


/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $40cee665c3968e3d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const $40cee665c3968e3d$export$2e2bcd8739ae039 = (0, $55d271daf0d1362b$export$2e2bcd8739ae039)("ChevronDown", $40cee665c3968e3d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8b52f930b2939116$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const $8b52f930b2939116$export$2e2bcd8739ae039 = (0, $55d271daf0d1362b$export$2e2bcd8739ae039)("ChevronUp", $8b52f930b2939116$export$3efd853dbb351e94);



var $8vqx4 = parcelRequire("8vqx4");

const $4f6f9d17d2d7273a$export$ef9b1a59e592288f = $ac74e1b1d7117324$export$be92b6f5f03c0fe9;
const $4f6f9d17d2d7273a$export$ee25a334c55de1f4 = $ac74e1b1d7117324$export$eb2fcfdbd7ba97d4;
const $4f6f9d17d2d7273a$export$e288731fd71264f0 = $ac74e1b1d7117324$export$4c8d1a57a761ef94;
const $4f6f9d17d2d7273a$export$3ac1e88a1c0b9f1 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)($ac74e1b1d7117324$export$41fb9f06171c75f4, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex w-full items-center justify-between whitespace-nowrap rounded-[4px] border-[1px] border-[#DEDDDB] bg-transparent px-3 py-3 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[placeholder]:text-muted-foreground [&>span]:line-clamp-1", className),
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: `absolute right-[15px] top-[22px]`,
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
                    width: "17",
                    height: "10",
                    viewBox: "0 0 17 10",
                    fill: "none",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                        d: "M1 1L8.5 9L16 1",
                        stroke: "#292929"
                    })
                })
            })
        ]
    }));
$4f6f9d17d2d7273a$export$3ac1e88a1c0b9f1.displayName = $ac74e1b1d7117324$export$41fb9f06171c75f4.displayName;
const $4f6f9d17d2d7273a$export$d8117927658af6d7 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$export$2f60d3ec9ad468f2, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $8b52f930b2939116$export$2e2bcd8739ae039), {
            className: "h-4 w-4"
        })
    }));
$4f6f9d17d2d7273a$export$d8117927658af6d7.displayName = $ac74e1b1d7117324$export$2f60d3ec9ad468f2.displayName;
const $4f6f9d17d2d7273a$export$ff951e476c12189 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$export$bf1aedc3039c8d63, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $40cee665c3968e3d$export$2e2bcd8739ae039), {
            className: "h-4 w-4"
        })
    }));
$4f6f9d17d2d7273a$export$ff951e476c12189.displayName = $ac74e1b1d7117324$export$bf1aedc3039c8d63.displayName;
const $4f6f9d17d2d7273a$export$c973a4b3cb86a03d = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, children: children, position: position = "popper", ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$export$602eac185826482c, {
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)($ac74e1b1d7117324$export$7c6e2c02157bb7d2, {
            ref: ref,
            className: (0, $db53bf731136662c$export$1343a74baacb0543)("relative z-50 max-h-[--radix-select-content-available-height] min-w-[8rem] origin-[--radix-select-content-transform-origin] overflow-y-auto overflow-x-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", className),
            position: position,
            ...props,
            children: [
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($4f6f9d17d2d7273a$export$d8117927658af6d7, {}),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$export$d5c6c08dc2d3ca7, {
                    className: (0, $db53bf731136662c$export$1343a74baacb0543)("p-1", position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"),
                    children: children
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($4f6f9d17d2d7273a$export$ff951e476c12189, {})
            ]
        })
    }));
$4f6f9d17d2d7273a$export$c973a4b3cb86a03d.displayName = $ac74e1b1d7117324$export$7c6e2c02157bb7d2.displayName;
const $4f6f9d17d2d7273a$export$f67338d29bd972f8 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$export$b04be29aa201d4f5, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("px-2 py-1.5 text-sm font-semibold", className),
        ...props
    }));
$4f6f9d17d2d7273a$export$f67338d29bd972f8.displayName = $ac74e1b1d7117324$export$b04be29aa201d4f5.displayName;
const $4f6f9d17d2d7273a$export$13ef48a934230896 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, children: children, desc: desc, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)($ac74e1b1d7117324$export$6d08773d2e66f8f2, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                className: "absolute right-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$export$c3468e2714d175fa, {
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $2b1309f325581922$export$2e2bcd8739ae039), {
                        className: "h-4 w-4"
                    })
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$export$d6e5bf9c43ea9319, {
                        children: children
                    }),
                    desc && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("span", {
                        className: "pl-1",
                        children: [
                            "(",
                            desc,
                            ")"
                        ]
                    })
                ]
            })
        ]
    }));
$4f6f9d17d2d7273a$export$13ef48a934230896.displayName = $ac74e1b1d7117324$export$6d08773d2e66f8f2.displayName;
const $4f6f9d17d2d7273a$export$eba4b1df07cb1d3 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($ac74e1b1d7117324$export$1ff3c3f08ae963c0, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("-mx-1 my-1 h-px bg-muted", className),
        ...props
    }));
$4f6f9d17d2d7273a$export$eba4b1df07cb1d3.displayName = $ac74e1b1d7117324$export$1ff3c3f08ae963c0.displayName;




var $8vqx4 = parcelRequire("8vqx4");


const $3427c6a48082f892$var$CircularProgress = ({ percentage: percentage = 88, size: size = 128, strokeWidth: strokeWidth = 10, color: color = "#0A860F" })=>{
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference * (1 - percentage / 100);
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        className: "relative",
        style: {
            width: size,
            height: size
        },
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
                className: "h-full w-full -rotate-90 transform",
                width: size,
                height: size,
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("circle", {
                        cx: size / 2,
                        cy: size / 2,
                        r: radius,
                        fill: "transparent",
                        stroke: "#e5e7eb",
                        strokeWidth: strokeWidth
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("circle", {
                        cx: size / 2,
                        cy: size / 2,
                        r: radius,
                        fill: "transparent",
                        stroke: color,
                        strokeWidth: strokeWidth,
                        strokeDasharray: circumference,
                        strokeDashoffset: offset,
                        strokeLinecap: "round",
                        style: {
                            transition: "stroke-dashoffset 0.6s ease"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "absolute inset-0 flex items-center justify-center text-2xl font-bold text-black",
                children: [
                    percentage,
                    "%"
                ]
            })
        ]
    });
};
const $3427c6a48082f892$var$AdoptResult = ({ pet: pet, scoreLog: scoreLog, onFinish: onFinish })=>{
    const [color, setColor] = (0, $8vqx4.useState)("");
    const [title, setTitle] = (0, $8vqx4.useState)("");
    const [desc, setDesc] = (0, $8vqx4.useState)([
        ""
    ]);
    const navigate = (0, $68c2f6a70206c369$export$9770f232ac06a008)();
    (0, $8vqx4.useEffect)(()=>{
        let c = "#0A860F";
        let t = `${pet.name} and you are a strong match`;
        let d = [
            `You align on the most important areas \u{2014} lifestyle, energy level, and daily needs. ${pet.name} is very likely to thrive in a home like yours.`
        ];
        const score = getScoreValue();
        if (score < 80 && score > 50) {
            c = "#FFA552";
            t = `${pet.name} and you are good match`;
            d = [
                `You align on several key areas, though some needs or routines may require extra attention. With patience and consistency, this has the potential to become a wonderful match.`
            ];
        }
        if (score <= 50) {
            c = "red";
            t = `This may not be the right fit`;
            d = [
                `There are significant differences in lifestyle or daily needs that could make long-term compatibility difficult. To protect ${pet.name}\u{2019}s wellbeing, this match can\u{2019}t move forward.`,
                `But don\u{2019}t worry \u{2014} we\u{2019}ll help you find a dog who\u{2019}s a better fit for your home.`
            ];
        }
        setColor(c);
        setTitle(t);
        setDesc(d);
    }, [
        scoreLog
    ]);
    const getScoreValue = ()=>{
        const score = scoreLog.reduce((acc, l)=>{
            return acc += l.adjustment;
        }, 0);
        return 100 - score;
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        className: "mt-3 flex max-w-xl flex-col items-center justify-center gap-4 border-t-[1px] pt-6 text-center",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "text-[20px] font-medium",
                children: title
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "text-[14px]",
                children: "Compatibility score"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($3427c6a48082f892$var$CircularProgress, {
                percentage: getScoreValue(),
                color: color
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "flex flex-col gap-3",
                children: desc.map((d, index)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        children: d
                    }, index))
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                title: getScoreValue() <= 50 ? "Explore better matches" : "Continue with adoption",
                theme: "dark",
                size: "medium",
                onClick: getScoreValue() <= 50 ? ()=>navigate("/") : onFinish
            })
        ]
    });
};
var $3427c6a48082f892$export$2e2bcd8739ae039 = $3427c6a48082f892$var$AdoptResult;


const $24076a0fc7bb8c16$export$2deac3956661e672 = [
    {
        id: 1,
        type: "select",
        name: "housingSuitability",
        title: "What size is your home?",
        param: "housingSuitability",
        options: [
            {
                label: "Small",
                value: "small",
                desc: "20-40 kvm"
            },
            {
                label: "Medium",
                value: "medium",
                desc: "40-80 kvm"
            },
            {
                label: "Large",
                value: "large",
                desc: "80-150 kvm"
            }
        ]
    },
    {
        id: 1111,
        type: "select",
        name: "outdoorSituation",
        title: "How will the dogs outdoor situation be?",
        param: "outdoorSituation",
        options: [
            {
                label: "City living",
                value: "city",
                desc: "Busy- traffic- and noisy areas"
            },
            {
                label: "Suburban areas",
                value: "suburban",
                desc: "Quieter neighborhoods, access to parks and green spaces"
            },
            {
                label: "Rural / nature-focused environments",
                value: "rural",
                desc: "Frequent access to forests, fields, or large outdoor areas"
            }
        ]
    },
    {
        id: 2,
        type: "radio",
        name: "childrenSuitability",
        title: "Will the dog live with children under 12?",
        param: "childrenSuitability",
        options: [
            {
                label: "Yes",
                value: "yes"
            },
            {
                label: "No",
                value: "no"
            }
        ]
    },
    {
        id: 3,
        type: "select",
        name: "dogsSuitability",
        param: "dogsSuitability",
        title: "Will the dog live with other dogs?",
        options: [
            {
                label: "Yes",
                value: "yes"
            },
            {
                label: "No",
                value: "no"
            },
            {
                label: "Possibly in the future",
                value: "unknown"
            }
        ]
    },
    {
        id: 3333,
        type: "select",
        name: "animalsSuitability",
        param: "animalsSuitability",
        title: "Will the dog live with other animals?",
        options: [
            {
                label: "Yes",
                value: "yes"
            },
            {
                label: "No",
                value: "no"
            },
            {
                label: "Possibly in the future",
                value: "unknown"
            }
        ]
    },
    {
        id: 4,
        type: "select",
        name: "allergySuitability",
        param: "allergySuitability",
        title: "Have there been fur allergies in the family?",
        options: [
            {
                label: "Yes",
                value: "yes"
            },
            {
                label: "No",
                value: "no"
            },
            {
                label: "Unsure",
                value: "unknown"
            }
        ]
    },
    {
        id: 5,
        type: "select",
        name: "aloneTolerance",
        param: "aloneTolerance",
        title: "On a typical weekday, for how many hours will the dog be alone?",
        options: [
            {
                label: "1-3 hours",
                value: "1"
            },
            {
                label: "4-6 hours",
                value: "4"
            },
            {
                label: "7+ hours",
                value: "7"
            }
        ]
    },
    {
        id: 6,
        type: "select",
        name: "activityLevel",
        param: "activityLevel",
        title: "How would you best describe your everyday lifestyle?",
        options: [
            {
                label: "Very active",
                value: "high",
                desc: "Long walks, frequent outdoor activities, running, hiking, or sports"
            },
            {
                label: "Moderately active",
                value: "moderate",
                desc: "Daily walks, some longer outings, occasional exercise or adventures"
            },
            {
                label: "Mostly calm",
                value: "low",
                desc: "Short daily walks, relaxed pace, lots of downtime"
            }
        ]
    },
    // {
    //   id: 7,
    //   type: "select",
    //   name: "size",
    //   param: "size",
    //   title: "What size of dog do you feel comfortable with?",
    //   options: [
    //     { label: "Small", value: "small" },
    //     { label: "Medium", value: "medium" },
    //     { label: "Large", value: "large" },
    //   ],
    // },
    {
        id: 8,
        type: "select",
        name: "adaptability",
        title: "During the dog\u2019s first year with you, how often do you expect it to stay with someone else (for example, due to travel or work)?",
        param: "adaptability",
        options: [
            {
                label: "Rarely",
                value: "no",
                desc: "Mostly at home, little to no travel"
            },
            {
                label: "Occasionally",
                value: "medium",
                desc: "Short trips or a few stays with friends, family, or boarding"
            },
            {
                label: "Regularly",
                value: "adaptable",
                desc: "Frequent travel or recurring stays with others"
            }
        ]
    },
    {
        id: 9,
        type: "select",
        name: "experience",
        param: "experience",
        title: "What is your experience with dogs?",
        options: [
            {
                label: "This would be my first dog",
                value: "no"
            },
            {
                label: "I\u2019ve lived with or cared for dogs before",
                value: "some"
            },
            {
                label: "I have extensive experience",
                value: "yes",
                desc: "Training, long-term ownership, or caring for multiple dogs"
            }
        ]
    },
    {
        id: 10,
        type: "select",
        name: "supportLevel",
        param: "supportLevel",
        title: "What kind of everyday support and routine can you offer this dog?",
        options: [
            {
                label: "A very stable, supportive routine",
                value: "stable",
                desc: "Predictable days, lots of presence, and time to help a dog settle in"
            },
            {
                label: "A mostly stable routine",
                value: "regular",
                desc: "Regular structure, with some flexibility or occasional changes"
            },
            {
                label: "A flexible, changing routine",
                value: "flexible",
                desc: "Varying days, less structure, or frequent changes"
            }
        ]
    },
    // {
    //   id: 10,
    //   type: "select",
    //   name: "energyLevel",
    //   param: "energyLevel",
    //   title: "Do you prefer a calm or energetic dog indoors?",
    //   options: [
    //     { label: "Calm", value: "calm" },
    //     { label: "Mix", value: "balanced" },
    //     { label: "Energetic", value: "high" },
    //   ],
    // },
    // {
    //   id: 11,
    //   type: "select",
    //   name: "groomingNeeds",
    //   param: "groomingNeeds",
    //   title: "How much grooming are you comfortable with?",
    //   options: [
    //     { label: "Minimal", value: "1" },
    //     { label: "Weekly", value: "2" },
    //     { label: "Daily", value: "3" },
    //   ],
    // },
    // {
    //   id: 12,
    //   type: "select",
    //   name: "temperament",
    //   param: "temperament",
    //   title: "What is your ideal dog temperament?",
    //   options: [
    //     { label: "Independent", value: "independent" },
    //     { label: "Balanced", value: "balanced" },
    //     { label: "Very affectionate", value: "attention" },
    //   ],
    // },
    {
        id: 13,
        type: "select",
        name: "insurance",
        title: "Would you like to quickly and easily create an insurance plan tailored for your dog through our partner Lassie?",
        options: [
            {
                label: "Yes, I am interested",
                value: "yes"
            },
            {
                label: "Maybe later",
                value: "maybe"
            },
            {
                label: "No, thanks",
                value: "no"
            }
        ]
    },
    {
        id: 14,
        type: "select",
        name: "foodSubscription",
        title: "Would you like to subscribe to Tailtales dog food, tailored to your chosen dog's needs, delivered straight to your door?",
        options: [
            {
                label: "Yes, subscribe",
                value: "yes"
            },
            {
                label: "Maybe later",
                value: "maybe"
            },
            {
                label: "No, thanks",
                value: "no"
            }
        ]
    }
];


const $28baec46d3686fa5$var$AdoptCompatibility = ({ pet: pet, setStageById: setStageById, adoption: adoption })=>{
    const [index, setIndex] = (0, $8vqx4.useState)(0);
    const [currentQuestions, setCurrentQuestions] = (0, $8vqx4.useState)([
        (0, $24076a0fc7bb8c16$export$2deac3956661e672)[index]
    ]);
    const [currentAnswer, setCurrentAnswer] = (0, $8vqx4.useState)([]);
    const [answers, setAnswers] = (0, $8vqx4.useState)([]);
    const [scoreLog, setScoreLog] = (0, $8vqx4.useState)([]);
    const [finish, setFinish] = (0, $8vqx4.useState)(false);
    const { user: user } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    (0, $8vqx4.useEffect)(()=>{
        if (!adoption) return;
        const data = adoption.compatibility;
        if (!data) return;
        setIndex(data.index || index);
        setCurrentQuestions(data.currentQuestions || currentQuestions);
        setCurrentAnswer(data.currentAnswer || currentAnswer);
        setAnswers(data.answers || answers);
        setScoreLog(data.scoreLog || scoreLog);
        setFinish(data.finish || finish);
    }, [
        adoption
    ]);
    const onNextQuestionChange = ()=>{
        const answersUpd = [
            ...answers,
            ...currentAnswer
        ];
        const scoreLogUpd = calculateScore(answersUpd);
        let finishUpd = finish;
        const newIndex = index + 1;
        let currentQuestionsUpd = currentQuestions, currentAnswerUpd = currentAnswer;
        if ((0, $24076a0fc7bb8c16$export$2deac3956661e672)[newIndex]) {
            currentQuestionsUpd = [
                (0, $24076a0fc7bb8c16$export$2deac3956661e672)[newIndex]
            ];
            currentAnswerUpd = [];
        } else finishUpd = true;
        setCurrentQuestions(currentQuestionsUpd);
        setCurrentAnswer(currentAnswerUpd);
        setIndex(newIndex);
        setAnswers(answersUpd);
        setScoreLog(scoreLogUpd);
        setFinish(finishUpd);
        const d = {
            index: newIndex,
            currentQuestions: currentQuestionsUpd,
            currentAnswer: currentAnswerUpd,
            answers: answersUpd,
            scoreLog: scoreLogUpd,
            finish: finishUpd
        };
        const update = async ()=>{
            console.log("run AdoptCompatibility UPDATE");
            await (0, $61e35487be0558dc$export$53cc1e5f40ab2c45)(user.accessToken, adoption.id, {
                compatibility: d
            });
        };
        update();
    };
    const finishCompatibility = ()=>{
        setStageById(3);
    };
    const setAnswer = (name, value)=>{
        const excluded = currentAnswer.filter((c)=>c.name !== name);
        const updatedAnswers = [
            ...excluded,
            {
                name: name,
                value: value
            }
        ];
        setCurrentAnswer(updatedAnswers);
        const rootQuestion = (0, $24076a0fc7bb8c16$export$2deac3956661e672)[index];
        if (!rootQuestion.children) return;
        const includeQuestions = rootQuestion.children.reduce((acc, item)=>{
            const depName = item.dependency.name;
            const depValue = item.dependency.value;
            if (updatedAnswers.find((a)=>a.name === depName && a.value === depValue)) return [
                ...acc,
                item
            ];
            return acc;
        }, []);
        setCurrentQuestions([
            rootQuestion,
            ...includeQuestions
        ]);
    };
    const calculateScore = (answersUpd)=>{
        const process = (acc, ans)=>{
            const { name: name, value: value } = ans;
            const question = (0, $24076a0fc7bb8c16$export$2deac3956661e672).find((q)=>q.name === name);
            if (!question?.param) return acc;
            const petParam = pet[question.param];
            let adj = 0;
            const adjN = 5;
            switch(name){
                case "housingSuitability":
                    if (petParam === "any") break;
                    if (petParam === "large" && value !== "large") adj = adjN;
                    break;
                case "outdoorSituation":
                    if (petParam === "city") break;
                    adj = petParam === value ? adj : adjN;
                    break;
                case "childrenSuitability":
                    if (value === "no") break;
                    if (value === "yes" && petParam === "no") adj = adjN;
                    break;
                case "dogsSuitability":
                    if (petParam === "no" && value === "yes") adj = adjN;
                    break;
                case "animalsSuitability":
                    if (petParam === "no" && value === "yes") adj = adjN;
                    break;
                case "allergySuitability":
                    if (petParam === "no" && value === "yes") adj = adjN;
                    break;
                case "aloneTolerance":
                    adj = parseInt(value) <= parseInt(petParam) ? adj : adjN;
                    break;
                case "adaptability":
                    if (value === "no") break;
                    if (value === "adaptable" && petParam === "no") adj = adjN;
                    break;
                case "experience":
                    if (value === "yes") break;
                    if (value === "some" && petParam !== "yes") break;
                    if (value === "no" && petParam === "no") break;
                    adj = adjN;
                    break;
                case "supportLevel":
                    if (petParam === "flexible" || value === "stable") break;
                    if (value === "regular" && petParam === "regular") break;
                    adj = adjN;
                    break;
                // case "groomingNeeds":
                //   adj = parseInt(value) >= parseInt(petParam) ? adj : adjN;
                //   break;
                default:
                    adj = petParam === value ? adj : adjN;
                    break;
            }
            return [
                ...acc,
                {
                    name: question.param,
                    answer: ans.value,
                    pet: petParam,
                    adjustment: adj
                }
            ];
        };
        return answersUpd.reduce(process, []);
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "flex flex-col gap-6",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: "max-w-xl",
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex flex-col gap-6 text-center",
                            children: [
                                "Hi ",
                                user.profile?.title,
                                ", let\u2019s see if you and ",
                                pet.name,
                                " are a good match. This quick test checks how well your lifestyle fits her needs."
                            ]
                        })
                    }),
                    finish && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $3427c6a48082f892$export$2e2bcd8739ae039), {
                        pet: pet,
                        scoreLog: scoreLog,
                        onFinish: finishCompatibility
                    }),
                    currentQuestions && !finish && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
                        children: [
                            currentQuestions.map((currentQuestion)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                    className: "flex max-w-xl flex-col gap-0 border",
                                    children: [
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                            className: "border-b-[1px] p-3 font-medium",
                                            children: currentQuestion.title
                                        }),
                                        currentQuestion.type === "select" && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                            className: "relative",
                                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $4f6f9d17d2d7273a$export$ef9b1a59e592288f), {
                                                onValueChange: (v)=>setAnswer(currentQuestion.name, v),
                                                name: currentQuestion.name,
                                                children: [
                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $4f6f9d17d2d7273a$export$3ac1e88a1c0b9f1), {
                                                        className: "w-full border-none",
                                                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $4f6f9d17d2d7273a$export$e288731fd71264f0), {
                                                            placeholder: "Select option"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $4f6f9d17d2d7273a$export$c973a4b3cb86a03d), {
                                                        children: currentQuestion.options.map((opt)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $4f6f9d17d2d7273a$export$13ef48a934230896), {
                                                                value: opt.value,
                                                                desc: opt.desc,
                                                                children: opt.label
                                                            }, opt.value))
                                                    })
                                                ]
                                            })
                                        }),
                                        currentQuestion.type === "radio" && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                            className: "relative",
                                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                className: "flex gap-[1px]",
                                                children: currentQuestion.options.map((opt)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                        className: `flex h-[60px] flex-1 cursor-pointer items-center justify-center transition-all hover:bg-theme-blue-5 hover:text-white ${currentAnswer.find((a)=>a.name === currentQuestion.name)?.value === opt.value && "bg-theme-blue-5 text-white"}`,
                                                        onClick: ()=>setAnswer(currentQuestion.name, opt.value),
                                                        children: opt.label
                                                    }, opt.value))
                                            })
                                        }),
                                        currentQuestion.type === "multiselect" && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                            className: "relative",
                                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $055c7b3165fc03a4$export$1e7dfd31545b5809), {
                                                options: currentQuestion.options,
                                                onValueChange: (v)=>setAnswer(currentQuestion.name, v),
                                                className: "border-none"
                                            })
                                        })
                                    ]
                                }, currentQuestion.name)),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                                        title: "Back",
                                        disabled: true,
                                        theme: "secondary",
                                        size: "medium",
                                        onClick: ()=>""
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                                        title: `${index + 1 === (0, $24076a0fc7bb8c16$export$2deac3956661e672).length ? "Finish" : "Next Question"}`,
                                        disabled: currentAnswer.length !== currentQuestions.length,
                                        theme: "dark",
                                        size: "medium",
                                        onClick: onNextQuestionChange
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            scoreLog?.length > 0 && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "mt-10 flex flex-col flex-col-reverse gap-5 text-sm",
                children: scoreLog.map((r)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                children: [
                                    "Name: ",
                                    r.name
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                children: [
                                    "Answer: ",
                                    r.answer
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                children: [
                                    "Pet: ",
                                    JSON.stringify(r.pet)
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                children: [
                                    "Adjustment: ",
                                    r.adjustment && `-${r.adjustment}`
                                ]
                            })
                        ]
                    }, r.name + "1"))
            })
        ]
    });
};
var $28baec46d3686fa5$export$2e2bcd8739ae039 = $28baec46d3686fa5$var$AdoptCompatibility;







const $d3e171b0b8f421d5$var$AdoptLogin = ()=>{
    const { user: user } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    const location = (0, $68c2f6a70206c369$export$45d76561a5302f2b)();
    const navigate = (0, $68c2f6a70206c369$export$9770f232ac06a008)();
    const navigateToLogin = ()=>{
        (0, $e4a2f0245c788599$export$b4b6c1ec764d6e5)((0, $e4a2f0245c788599$export$ed7fe7865e115489), location.pathname);
        return navigate("/login");
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "flex max-w-xl flex-col gap-6 text-center",
        children: user.accessToken ? /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            children: "You are already logged in."
        }) : /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    children: "To keep everyone safe \u2013 especially our dogs \u2013 we ask you to sign in. It only takes a moment and lets us create your account securely."
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                        title: "Login",
                        theme: "dark",
                        onClick: navigateToLogin
                    })
                })
            ]
        })
    });
};
var $d3e171b0b8f421d5$export$2e2bcd8739ae039 = $d3e171b0b8f421d5$var$AdoptLogin;




var $8vqx4 = parcelRequire("8vqx4");




const $389391f99cf9d30c$var$AdoptOverview = ({ pet: pet, adoption: adoption })=>{
    const [isSucceeded, setIsSucceeded] = (0, $8vqx4.useState)(adoption.status === "succeeded");
    const { user: user } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    const sendInquiryHandler = async ()=>{
        if (!user.accessToken) return;
        const result = await (0, $61e35487be0558dc$export$ce69256b89e8cf0b)(user.accessToken, adoption.id);
        if (result) setIsSucceeded(true);
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $607ae91d1eb97195$exports.Fragment), {
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "flex flex-col gap-6",
            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "max-w-xl",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                    className: "flex flex-col items-center gap-6 text-center",
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            children: [
                                "You and ",
                                pet.name,
                                " are a match. \uD83D\uDC3E",
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("br", {}),
                                "The next step is to contact ",
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("strong", {
                                    children: pet.user.profile.title
                                }),
                                " and let them know you\u2019re interested in ",
                                pet.name,
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                                leftIcon: (0, $697654d10ef148cd$export$ca82bc100771edd6)(),
                                title: isSucceeded ? "Inquiry has been sent" : "Send adoption inquiry",
                                theme: "dark",
                                size: "medium",
                                disabled: isSucceeded,
                                onClick: sendInquiryHandler
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $389391f99cf9d30c$export$2e2bcd8739ae039 = $389391f99cf9d30c$var$AdoptOverview;


const $312732b6c7073ddd$var$stages = [
    {
        id: 1,
        title: "Login",
        desc: "",
        icon: (c)=>(0, $697654d10ef148cd$export$53b4b033af362e7)(c),
        component: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $d3e171b0b8f421d5$export$2e2bcd8739ae039), {})
    },
    {
        id: 2,
        title: "Compatibility test",
        icon: (c)=>(0, $697654d10ef148cd$export$9854b78a57015514)(c),
        component: ({ pet: pet, adoption: adoption, setStageById: setStageById })=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $28baec46d3686fa5$export$2e2bcd8739ae039), {
                pet: pet,
                setStageById: setStageById,
                adoption: adoption
            })
    },
    {
        id: 3,
        // title: "Adoption overview",
        icon: (c)=>(0, $697654d10ef148cd$export$2b4875707073ca28)(c),
        component: ({ pet: pet, adoption: adoption, setStageById: setStageById })=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $389391f99cf9d30c$export$2e2bcd8739ae039), {
                pet: pet,
                adoption: adoption
            })
    }
];
const $312732b6c7073ddd$var$defaultStage = $312732b6c7073ddd$var$stages[0];
const $312732b6c7073ddd$var$AdoptStages = ({ pet: pet, adoption: adoption })=>{
    const [stage, setStage] = (0, $8vqx4.useState)($312732b6c7073ddd$var$defaultStage);
    const [active, setActive] = (0, $8vqx4.useState)([
        $312732b6c7073ddd$var$defaultStage
    ]);
    const { user: user } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    (0, $8vqx4.useEffect)(()=>{
        const accessToken = user.accessToken;
        if (!accessToken) return;
        setActive((prevState)=>[
                ...prevState,
                $312732b6c7073ddd$var$stages[1]
            ]);
        if (adoption?.status === "succeeded") {
            setStage($312732b6c7073ddd$var$stages[2]);
            return;
        }
        if (!adoption?.compatibility?.finish) setStage($312732b6c7073ddd$var$stages[1]);
    }, [
        user,
        pet,
        adoption
    ]);
    const checkIfActive = (st)=>active.find((s)=>s.id === st);
    const onChangeCurrentStage = (newStage)=>{
        if (newStage < 1 || newStage > $312732b6c7073ddd$var$stages.length) return;
        if (!checkIfActive(newStage)) return;
        setStage($312732b6c7073ddd$var$stages.find((s)=>s.id === newStage) || $312732b6c7073ddd$var$defaultStage);
    };
    const addStageToActiveAndCurrentById = (id)=>{
        const st = $312732b6c7073ddd$var$stages.find((s)=>s.id === id);
        setActive((prevState)=>[
                ...prevState,
                st
            ]);
        setStage(st);
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "flex flex-row items-center justify-center gap-4",
                children: $312732b6c7073ddd$var$stages.map((stg)=>{
                    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: `flex w-[100px] justify-center border-b-[5px] border-theme-grey-5 ${stage.id === stg.id && "!border-theme-green-5"} ${checkIfActive(stg.id) && "cursor-pointer !border-theme-green-5"}`,
                        onClick: ()=>onChangeCurrentStage(stg.id),
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            className: "mb-2",
                            children: stg.icon(stage.id === stg.id ? "#272624" : undefined)
                        })
                    }, stg.id);
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "mt-10 flex flex-col items-center gap-2",
                children: [
                    stage.title && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "font-bold text-theme-grey-9.5",
                        children: [
                            stage.id,
                            ". ",
                            stage.title
                        ]
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: "",
                        children: typeof stage.component === "function" ? stage.component({
                            pet: pet,
                            adoption: adoption,
                            setStageById: addStageToActiveAndCurrentById
                        }) : stage.component
                    })
                ]
            })
        ]
    });
};
var $312732b6c7073ddd$export$2e2bcd8739ae039 = $312732b6c7073ddd$var$AdoptStages;






const $c80276e460c7625c$var$ageLabels = {
    puppy: "Puppy|0\u20131 year",
    young: "Young Adult|1\u20133 years",
    adult: "Adult|3\u20137 years",
    senior: "Senior|7\u201310+ years",
    geriatric: "Geriatric|10+ years"
};
const $c80276e460c7625c$var$sizeLabels = {
    small: "Small|Up to 10 kg (22 lbs)",
    medium: "Medium|10\u201325 kg (22\u201355 lbs)",
    large: "Large|Over 25 kg (55 lbs)"
};
const $c80276e460c7625c$var$staticUrl = "https://tailtales.vorozhbit.com/static/";
function $c80276e460c7625c$export$2e2bcd8739ae039({ pet: pet, children: children, showMore: showMore }) {
    const navigate = (0, $68c2f6a70206c369$export$9770f232ac06a008)();
    const renderGenderIcon = ()=>{
        if (pet.gender === "female") return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "rounded-[4px] bg-theme-amber-5 p-[4px] text-[12px] font-semibold leading-none text-theme-white",
            children: "Female"
        });
        else return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "rounded-[4px] bg-theme-purple-5 p-[4px] text-[12px] font-semibold leading-none text-theme-white",
            children: "Male"
        });
    };
    const renderMainImage = ()=>{
        const i = pet.images.find((im)=>im.main === true);
        const src = i ? i.url : pet.images[0].url;
        return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
            className: "w-[225px] rounded-[4px]",
            src: `${$c80276e460c7625c$var$staticUrl}${src}`,
            alt: pet.name
        });
    };
    const renderBreed = ()=>{
        const breedList = [];
        if (pet.breed) breedList.push(pet.breed);
        if (pet.breedAdditional) breedList.push([
            ...pet.breedAdditional
        ]);
        return breedList.length > 0 ? breedList.join(", ") : "";
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        className: "flex flex-row justify-between",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "flex flex-row gap-6",
                children: [
                    renderMainImage(),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "flex flex-col justify-between",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                className: "text-[64px] font-medium leading-[1.05]",
                                                children: pet.name
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                children: renderGenderIcon()
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                        className: "text-[24px] font-semibold text-theme-grey-11",
                                        children: renderBreed()
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        className: "flex gap-2 text-[20px] text-theme-grey-11",
                                        children: [
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                className: "font-semibold",
                                                children: $c80276e460c7625c$var$ageLabels[pet.age]?.split("|")[0]
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                className: "",
                                                children: $c80276e460c7625c$var$ageLabels[pet.age]?.split("|")[1]
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                className: "font-semibold",
                                                children: $c80276e460c7625c$var$sizeLabels[pet.size]?.split("|")[0]
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                className: "",
                                                children: $c80276e460c7625c$var$sizeLabels[pet.size]?.split("|")[1]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            showMore && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                                    title: "Show more",
                                    theme: "secondary",
                                    onClick: ()=>navigate(`/pet/${pet.id}`)
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                children: children
            })
        ]
    });
}




const $bf24494658af9f2f$var$staticUrl = "https://tailtales.vorozhbit.com/static/";
function $bf24494658af9f2f$export$2e2bcd8739ae039() {
    const [loading, setLoading] = (0, $8vqx4.useState)(true);
    const [pet, setPet] = (0, $8vqx4.useState)({});
    const [adoption, setAdoption] = (0, $8vqx4.useState)(null);
    const navigate = (0, $68c2f6a70206c369$export$9770f232ac06a008)();
    const { user: user } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    const { id: id } = (0, $68c2f6a70206c369$export$99eaa27ddbbb95ef)();
    const containerRef = (0, $8vqx4.useRef)(null);
    (0, $8vqx4.useEffect)(()=>{
        (0, $61e35487be0558dc$export$2f54905a28ae7974)(id).then((data)=>setPet(data)).finally(()=>{
            setLoading(false);
        });
    }, []);
    (0, $8vqx4.useEffect)(()=>{
        if (!pet || !pet.id || !user.accessToken) return;
        const initAdoption = async ()=>{
            let adoptionObj = await (0, $61e35487be0558dc$export$6b5b844507559f2)(user.accessToken, pet.id);
            if (!adoptionObj) adoptionObj = await (0, $61e35487be0558dc$export$53268acd80eaf8d)(user.accessToken, pet.id, {});
            setAdoption(adoptionObj ?? null);
        };
        initAdoption();
    }, [
        pet,
        user
    ]);
    const resetAdoptionData = async ()=>{
        // removeFromStorage(`${adoptionKey}-${pet.id}`);
        await (0, $61e35487be0558dc$export$53268acd80eaf8d)(user.accessToken, pet.id, {});
        window.location.reload();
    };
    if (!pet || loading) return null;
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "container mx-auto mb-10 px-5",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "mb-6 text-theme-grey-7",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $07071c34f63f350a$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "Home"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                className: "text-theme-grey-11",
                                children: pet.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $c80276e460c7625c$export$2e2bcd8739ae039), {
                        pet: pet,
                        showMore: true,
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex gap-5",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                                    title: "Reset",
                                    theme: "transparent",
                                    size: "medium",
                                    onClick: resetAdoptionData
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                                    title: "Cancel",
                                    theme: "secondary",
                                    size: "medium",
                                    onClick: ()=>navigate(-1)
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "container mx-auto px-5",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: "mb-10",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $312732b6c7073ddd$export$2e2bcd8739ae039), {
                        pet: pet,
                        adoption: adoption
                    })
                })
            })
        ]
    });
}




var $8vqx4 = parcelRequire("8vqx4");




var $8vqx4 = parcelRequire("8vqx4");




/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e0edee75b2c3cc8e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const $e0edee75b2c3cc8e$export$2e2bcd8739ae039 = (0, $55d271daf0d1362b$export$2e2bcd8739ae039)("Plus", $e0edee75b2c3cc8e$export$3efd853dbb351e94);



var $8vqx4 = parcelRequire("8vqx4");




var $8vqx4 = parcelRequire("8vqx4");

function $9334e483a2414035$export$2e2bcd8739ae039({ label: label, defaultValue: defaultValue, value: value, values: values, border: border = true, name: name, onUpdate: onUpdate }) {
    const [val, setVal] = (0, $8vqx4.useState)(value ? value : defaultValue);
    const [selected, setSelected] = (0, $8vqx4.useState)(false);
    const [showDropdown, setShowDropdown] = (0, $8vqx4.useState)(false);
    // useEffect(() => {
    //   if (!val || val === defaultValue) {
    //     return;
    //   }
    //   onUpdate(name, val);
    // }, [val]);
    // useEffect(() => {
    //   setSelected(val !== defaultValue);
    // }, [val]);
    (0, $8vqx4.useEffect)(()=>{
        setSelected(val !== defaultValue);
    }, [
        defaultValue,
        val
    ]);
    const onValueUpdate = (v)=>{
        setVal(v);
        onUpdate(name, v);
        setShowDropdown(!showDropdown);
    };
    let theme = "bg-transparent text-theme-grey-7 border-[#eeeeee]";
    let valueTheme = "text-black";
    let iconTheme = "#000000";
    if (selected) {
        theme = "bg-[#000000] text-theme-grey-7";
        valueTheme = "text-[#FFFFFF]";
        iconTheme = "#FFFFFF";
    }
    if (selected && showDropdown) valueTheme = "text-black";
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        id: "wrp",
        className: `${theme} relative inline-block min-w-[140px] px-[12px] py-[8px] text-[14px] text-theme-grey-7 ${border && "border-[1px]"} ${showDropdown ? "rounded-t-[4px] !bg-white drop-shadow-card" : "rounded-[4px]"}`,
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "relative flex cursor-pointer flex-row items-center justify-between gap-1",
                onClick: ()=>setShowDropdown(!showDropdown),
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "flex flex-row items-center gap-1 leading-none",
                        children: [
                            label,
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                className: `font-semibold capitalize ${valueTheme}`,
                                children: values.find((v)=>v.value === val)?.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: `ml-1 transition-all ${showDropdown && "rotate-180"}`,
                        children: (0, $697654d10ef148cd$export$6b50bc1c8d5a27bc)(iconTheme)
                    })
                ]
            }),
            showDropdown && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: `${theme} absolute z-10 ml-[-13px] mt-2 w-[calc(100%+2px)] rounded-b-[4px] border-l-[1px] border-r-[1px] px-[12px] py-[8px] ${showDropdown && "!bg-white"}`,
                children: values.map((val, index)=>{
                    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: `cursor-pointer capitalize transition ${selected && border ? "hover:text-[#dfdfdf]" : "hover:text-black"} `,
                        onClick: ()=>onValueUpdate(val.value),
                        children: val.title
                    }, index);
                })
            })
        ]
    });
}




var $8vqx4 = parcelRequire("8vqx4");


var $8vqx4 = parcelRequire("8vqx4");









"use client";
var $7251fbdef66dc2b2$var$CHECKBOX_NAME = "Checkbox";
var [$7251fbdef66dc2b2$var$createCheckboxContext, $7251fbdef66dc2b2$export$b566c4ff5488ea01] = (0, $9ec698e3cd37fa7e$export$50c7b4e9d9f19c1)($7251fbdef66dc2b2$var$CHECKBOX_NAME);
var [$7251fbdef66dc2b2$var$CheckboxProviderImpl, $7251fbdef66dc2b2$var$useCheckboxContext] = $7251fbdef66dc2b2$var$createCheckboxContext($7251fbdef66dc2b2$var$CHECKBOX_NAME);
function $7251fbdef66dc2b2$export$1335a92a9ee50a8d(props) {
    const { __scopeCheckbox: __scopeCheckbox, checked: checkedProp, children: children, defaultChecked: defaultChecked, disabled: disabled, form: form, name: name, onCheckedChange: onCheckedChange, required: required, value: value = "on", internal_do_not_use_render: // @ts-expect-error
    internal_do_not_use_render } = props;
    const [checked, setChecked] = (0, $2da738009a11930c$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked ?? false,
        onChange: onCheckedChange,
        caller: $7251fbdef66dc2b2$var$CHECKBOX_NAME
    });
    const [control, setControl] = $8vqx4.useState(null);
    const [bubbleInput, setBubbleInput] = $8vqx4.useState(null);
    const hasConsumerStoppedPropagationRef = $8vqx4.useRef(false);
    const isFormControl = control ? !!form || !!control.closest("form") : // We set this to true by default so that events bubble to forms without JS (SSR)
    true;
    const context = {
        checked: checked,
        disabled: disabled,
        setChecked: setChecked,
        control: control,
        setControl: setControl,
        name: name,
        form: form,
        value: value,
        hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef,
        required: required,
        defaultChecked: $7251fbdef66dc2b2$var$isIndeterminate(defaultChecked) ? false : defaultChecked,
        isFormControl: isFormControl,
        bubbleInput: bubbleInput,
        setBubbleInput: setBubbleInput
    };
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($7251fbdef66dc2b2$var$CheckboxProviderImpl, {
        scope: __scopeCheckbox,
        ...context,
        children: $7251fbdef66dc2b2$var$isFunction(internal_do_not_use_render) ? internal_do_not_use_render(context) : children
    });
}
var $7251fbdef66dc2b2$var$TRIGGER_NAME = "CheckboxTrigger";
var $7251fbdef66dc2b2$export$1386466acbe59ca2 = $8vqx4.forwardRef(({ __scopeCheckbox: __scopeCheckbox, onKeyDown: onKeyDown, onClick: onClick, ...checkboxProps }, forwardedRef)=>{
    const { control: control, value: value, disabled: disabled, checked: checked, required: required, setControl: setControl, setChecked: setChecked, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, isFormControl: isFormControl, bubbleInput: bubbleInput } = $7251fbdef66dc2b2$var$useCheckboxContext($7251fbdef66dc2b2$var$TRIGGER_NAME, __scopeCheckbox);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, setControl);
    const initialCheckedStateRef = $8vqx4.useRef(checked);
    $8vqx4.useEffect(()=>{
        const form = control?.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        control,
        setChecked
    ]);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).button, {
        type: "button",
        role: "checkbox",
        "aria-checked": $7251fbdef66dc2b2$var$isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": $7251fbdef66dc2b2$var$getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled: disabled,
        value: value,
        ...checkboxProps,
        ref: composedRefs,
        onKeyDown: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(onKeyDown, (event)=>{
            if (event.key === "Enter") event.preventDefault();
        }),
        onClick: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(onClick, (event)=>{
            setChecked((prevChecked)=>$7251fbdef66dc2b2$var$isIndeterminate(prevChecked) ? true : !prevChecked);
            if (bubbleInput && isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    });
});
$7251fbdef66dc2b2$export$1386466acbe59ca2.displayName = $7251fbdef66dc2b2$var$TRIGGER_NAME;
var $7251fbdef66dc2b2$export$48513f6b9f8ce62d = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value, onCheckedChange: onCheckedChange, form: form, ...checkboxProps } = props;
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($7251fbdef66dc2b2$export$1335a92a9ee50a8d, {
        __scopeCheckbox: __scopeCheckbox,
        checked: checked,
        defaultChecked: defaultChecked,
        disabled: disabled,
        required: required,
        onCheckedChange: onCheckedChange,
        name: name,
        form: form,
        value: value,
        internal_do_not_use_render: ({ isFormControl: isFormControl })=>/* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($7251fbdef66dc2b2$export$1386466acbe59ca2, {
                        ...checkboxProps,
                        ref: forwardedRef,
                        __scopeCheckbox: __scopeCheckbox
                    }),
                    isFormControl && /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($7251fbdef66dc2b2$export$493083511fc9f964, {
                        __scopeCheckbox: __scopeCheckbox
                    })
                ]
            })
    });
});
$7251fbdef66dc2b2$export$48513f6b9f8ce62d.displayName = $7251fbdef66dc2b2$var$CHECKBOX_NAME;
var $7251fbdef66dc2b2$var$INDICATOR_NAME = "CheckboxIndicator";
var $7251fbdef66dc2b2$export$59aad738f51d1c05 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $7251fbdef66dc2b2$var$useCheckboxContext($7251fbdef66dc2b2$var$INDICATOR_NAME, __scopeCheckbox);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $f22016a45fcd98f7$export$99c2b779aa4e8b8b), {
        present: forceMount || $7251fbdef66dc2b2$var$isIndeterminate(context.checked) || context.checked === true,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).span, {
            "data-state": $7251fbdef66dc2b2$var$getState(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "none",
                ...props.style
            }
        })
    });
});
$7251fbdef66dc2b2$export$59aad738f51d1c05.displayName = $7251fbdef66dc2b2$var$INDICATOR_NAME;
var $7251fbdef66dc2b2$var$BUBBLE_INPUT_NAME = "CheckboxBubbleInput";
var $7251fbdef66dc2b2$export$493083511fc9f964 = $8vqx4.forwardRef(({ __scopeCheckbox: __scopeCheckbox, ...props }, forwardedRef)=>{
    const { control: control, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, name: name, value: value, form: form, bubbleInput: bubbleInput, setBubbleInput: setBubbleInput } = $7251fbdef66dc2b2$var$useCheckboxContext($7251fbdef66dc2b2$var$BUBBLE_INPUT_NAME, __scopeCheckbox);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, setBubbleInput);
    const prevChecked = (0, $dc585503d6fa4fda$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $61d0379fd4465bd5$export$1ab7ae714698c4b8)(control);
    $8vqx4.useEffect(()=>{
        const input = bubbleInput;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        const bubbles = !hasConsumerStoppedPropagationRef.current;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            input.indeterminate = $7251fbdef66dc2b2$var$isIndeterminate(checked);
            setChecked.call(input, $7251fbdef66dc2b2$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        bubbleInput,
        prevChecked,
        checked,
        hasConsumerStoppedPropagationRef
    ]);
    const defaultCheckedRef = $8vqx4.useRef($7251fbdef66dc2b2$var$isIndeterminate(checked) ? false : checked);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).input, {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: defaultChecked ?? defaultCheckedRef.current,
        required: required,
        disabled: disabled,
        name: name,
        value: value,
        form: form,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0,
            // We transform because the input is absolutely positioned but we have
            // rendered it **after** the button. This pulls it back to sit on top
            // of the button.
            transform: "translateX(-100%)"
        }
    });
});
$7251fbdef66dc2b2$export$493083511fc9f964.displayName = $7251fbdef66dc2b2$var$BUBBLE_INPUT_NAME;
function $7251fbdef66dc2b2$var$isFunction(value) {
    return typeof value === "function";
}
function $7251fbdef66dc2b2$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $7251fbdef66dc2b2$var$getState(checked) {
    return $7251fbdef66dc2b2$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}




var $8vqx4 = parcelRequire("8vqx4");

const $89347a60a6f2f63e$export$48513f6b9f8ce62d = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($7251fbdef66dc2b2$export$48513f6b9f8ce62d, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("peer h-4 w-4 shrink-0 rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground", className),
        ...props,
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($7251fbdef66dc2b2$export$59aad738f51d1c05, {
            className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex items-center justify-center text-current"),
            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $2b1309f325581922$export$2e2bcd8739ae039), {
                className: "h-4 w-4"
            })
        })
    }));
$89347a60a6f2f63e$export$48513f6b9f8ce62d.displayName = $7251fbdef66dc2b2$export$48513f6b9f8ce62d.displayName;


function $0343707ea14a49d1$export$2e2bcd8739ae039({ name: name, value: value, values: values, onChange: onChange }) {
    const [data, setData] = (0, $8vqx4.useState)(value ? value.split(",") : []);
    const onUpdate = (k, state)=>{
        let d = [
            ...data
        ];
        if (state) d.push(k);
        else d = d.filter((s)=>s != k);
        setData(d);
        onChange(name, d.length > 0 ? d.join(",") : "");
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "flex flex-col gap-3",
        children: Object.entries(values).map(([key, val])=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $89347a60a6f2f63e$export$48513f6b9f8ce62d), {
                        id: val.value,
                        defaultChecked: !!value?.split(",").find((e)=>e === val.value),
                        onCheckedChange: (e)=>{
                            console.log(val.value, e);
                            onUpdate(val.value, e);
                        }
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("label", {
                        htmlFor: val.value,
                        className: "cursor-pointer leading-none",
                        children: val.title
                    })
                ]
            }, key))
    });
}





var $8vqx4 = parcelRequire("8vqx4");







var $8vqx4 = parcelRequire("8vqx4");









"use client";
var $3f69c9cda1bc268d$var$COLLAPSIBLE_NAME = "Collapsible";
var [$3f69c9cda1bc268d$var$createCollapsibleContext, $3f69c9cda1bc268d$export$952b32dcbe73087a] = (0, $9ec698e3cd37fa7e$export$50c7b4e9d9f19c1)($3f69c9cda1bc268d$var$COLLAPSIBLE_NAME);
var [$3f69c9cda1bc268d$var$CollapsibleProvider, $3f69c9cda1bc268d$var$useCollapsibleContext] = $3f69c9cda1bc268d$var$createCollapsibleContext($3f69c9cda1bc268d$var$COLLAPSIBLE_NAME);
var $3f69c9cda1bc268d$export$6eb0f7ddcda6131f = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, open: openProp, defaultOpen: defaultOpen, disabled: disabled, onOpenChange: onOpenChange, ...collapsibleProps } = props;
    const [open, setOpen] = (0, $2da738009a11930c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $3f69c9cda1bc268d$var$COLLAPSIBLE_NAME
    });
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($3f69c9cda1bc268d$var$CollapsibleProvider, {
        scope: __scopeCollapsible,
        disabled: disabled,
        contentId: (0, $48f6e55cf3c4c05f$export$f680877a34711e37)(),
        open: open,
        onOpenToggle: $8vqx4.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
            "data-state": $3f69c9cda1bc268d$var$getState(open),
            "data-disabled": disabled ? "" : void 0,
            ...collapsibleProps,
            ref: forwardedRef
        })
    });
});
$3f69c9cda1bc268d$export$6eb0f7ddcda6131f.displayName = $3f69c9cda1bc268d$var$COLLAPSIBLE_NAME;
var $3f69c9cda1bc268d$var$TRIGGER_NAME = "CollapsibleTrigger";
var $3f69c9cda1bc268d$export$c135dce7b15bbbdc = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, ...triggerProps } = props;
    const context = $3f69c9cda1bc268d$var$useCollapsibleContext($3f69c9cda1bc268d$var$TRIGGER_NAME, __scopeCollapsible);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": $3f69c9cda1bc268d$var$getState(context.open),
        "data-disabled": context.disabled ? "" : void 0,
        disabled: context.disabled,
        ...triggerProps,
        ref: forwardedRef,
        onClick: (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$3f69c9cda1bc268d$export$c135dce7b15bbbdc.displayName = $3f69c9cda1bc268d$var$TRIGGER_NAME;
var $3f69c9cda1bc268d$var$CONTENT_NAME = "CollapsibleContent";
var $3f69c9cda1bc268d$export$aadde00976f34151 = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...contentProps } = props;
    const context = $3f69c9cda1bc268d$var$useCollapsibleContext($3f69c9cda1bc268d$var$CONTENT_NAME, props.__scopeCollapsible);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $f22016a45fcd98f7$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: ({ present: present })=>/* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($3f69c9cda1bc268d$var$CollapsibleContentImpl, {
                ...contentProps,
                ref: forwardedRef,
                present: present
            })
    });
});
$3f69c9cda1bc268d$export$aadde00976f34151.displayName = $3f69c9cda1bc268d$var$CONTENT_NAME;
var $3f69c9cda1bc268d$var$CollapsibleContentImpl = $8vqx4.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, present: present, children: children, ...contentProps } = props;
    const context = $3f69c9cda1bc268d$var$useCollapsibleContext($3f69c9cda1bc268d$var$CONTENT_NAME, __scopeCollapsible);
    const [isPresent, setIsPresent] = $8vqx4.useState(present);
    const ref = $8vqx4.useRef(null);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const heightRef = $8vqx4.useRef(0);
    const height = heightRef.current;
    const widthRef = $8vqx4.useRef(0);
    const width = widthRef.current;
    const isOpen = context.open || isPresent;
    const isMountAnimationPreventedRef = $8vqx4.useRef(isOpen);
    const originalStylesRef = $8vqx4.useRef(void 0);
    $8vqx4.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    (0, $a12c289c48883425$export$e5c5a5f917a5871c)(()=>{
        const node = ref.current;
        if (node) {
            originalStylesRef.current = originalStylesRef.current || {
                transitionDuration: node.style.transitionDuration,
                animationName: node.style.animationName
            };
            node.style.transitionDuration = "0s";
            node.style.animationName = "none";
            const rect = node.getBoundingClientRect();
            heightRef.current = rect.height;
            widthRef.current = rect.width;
            if (!isMountAnimationPreventedRef.current) {
                node.style.transitionDuration = originalStylesRef.current.transitionDuration;
                node.style.animationName = originalStylesRef.current.animationName;
            }
            setIsPresent(present);
        }
    }, [
        context.open,
        present
    ]);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
        "data-state": $3f69c9cda1bc268d$var$getState(context.open),
        "data-disabled": context.disabled ? "" : void 0,
        id: context.contentId,
        hidden: !isOpen,
        ...contentProps,
        ref: composedRefs,
        style: {
            [`--radix-collapsible-content-height`]: height ? `${height}px` : void 0,
            [`--radix-collapsible-content-width`]: width ? `${width}px` : void 0,
            ...props.style
        },
        children: isOpen && children
    });
});
function $3f69c9cda1bc268d$var$getState(open) {
    return open ? "open" : "closed";
}
var $3f69c9cda1bc268d$export$be92b6f5f03c0fe9 = $3f69c9cda1bc268d$export$6eb0f7ddcda6131f;
var $3f69c9cda1bc268d$export$41fb9f06171c75f4 = $3f69c9cda1bc268d$export$c135dce7b15bbbdc;
var $3f69c9cda1bc268d$export$7c6e2c02157bb7d2 = $3f69c9cda1bc268d$export$aadde00976f34151;





"use client";
var $fa4abcfcbaf9a237$var$ACCORDION_NAME = "Accordion";
var $fa4abcfcbaf9a237$var$ACCORDION_KEYS = [
    "Home",
    "End",
    "ArrowDown",
    "ArrowUp",
    "ArrowLeft",
    "ArrowRight"
];
var [$fa4abcfcbaf9a237$var$Collection, $fa4abcfcbaf9a237$var$useCollection, $fa4abcfcbaf9a237$var$createCollectionScope] = (0, $9e5dc6617ffc41b2$export$c74125a8e3af6bb2)($fa4abcfcbaf9a237$var$ACCORDION_NAME);
var [$fa4abcfcbaf9a237$var$createAccordionContext, $fa4abcfcbaf9a237$export$9748edc328a73be1] = (0, $9ec698e3cd37fa7e$export$50c7b4e9d9f19c1)($fa4abcfcbaf9a237$var$ACCORDION_NAME, [
    $fa4abcfcbaf9a237$var$createCollectionScope,
    (0, $3f69c9cda1bc268d$export$952b32dcbe73087a)
]);
var $fa4abcfcbaf9a237$var$useCollapsibleScope = (0, $3f69c9cda1bc268d$export$952b32dcbe73087a)();
var $fa4abcfcbaf9a237$export$a766cd26d0d69044 = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).forwardRef((props, forwardedRef)=>{
    const { type: type, ...accordionProps } = props;
    const singleProps = accordionProps;
    const multipleProps = accordionProps;
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$var$Collection.Provider, {
        scope: props.__scopeAccordion,
        children: type === "multiple" ? /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$var$AccordionImplMultiple, {
            ...multipleProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$var$AccordionImplSingle, {
            ...singleProps,
            ref: forwardedRef
        })
    });
});
$fa4abcfcbaf9a237$export$a766cd26d0d69044.displayName = $fa4abcfcbaf9a237$var$ACCORDION_NAME;
var [$fa4abcfcbaf9a237$var$AccordionValueProvider, $fa4abcfcbaf9a237$var$useAccordionValueContext] = $fa4abcfcbaf9a237$var$createAccordionContext($fa4abcfcbaf9a237$var$ACCORDION_NAME);
var [$fa4abcfcbaf9a237$var$AccordionCollapsibleProvider, $fa4abcfcbaf9a237$var$useAccordionCollapsibleContext] = $fa4abcfcbaf9a237$var$createAccordionContext($fa4abcfcbaf9a237$var$ACCORDION_NAME, {
    collapsible: false
});
var $fa4abcfcbaf9a237$var$AccordionImplSingle = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, collapsible: collapsible = false, ...accordionSingleProps } = props;
    const [value, setValue] = (0, $2da738009a11930c$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue ?? "",
        onChange: onValueChange,
        caller: $fa4abcfcbaf9a237$var$ACCORDION_NAME
    });
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$var$AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useMemo(()=>value ? [
                value
            ] : [], [
            value
        ]),
        onItemOpen: setValue,
        onItemClose: (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useCallback(()=>collapsible && setValue(""), [
            collapsible,
            setValue
        ]),
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$var$AccordionCollapsibleProvider, {
            scope: props.__scopeAccordion,
            collapsible: collapsible,
            children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$var$AccordionImpl, {
                ...accordionSingleProps,
                ref: forwardedRef
            })
        })
    });
});
var $fa4abcfcbaf9a237$var$AccordionImplMultiple = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, ...accordionMultipleProps } = props;
    const [value, setValue] = (0, $2da738009a11930c$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue ?? [],
        onChange: onValueChange,
        caller: $fa4abcfcbaf9a237$var$ACCORDION_NAME
    });
    const handleItemOpen = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]), [
        setValue
    ]);
    const handleItemClose = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value2)=>value2 !== itemValue)), [
        setValue
    ]);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$var$AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value: value,
        onItemOpen: handleItemOpen,
        onItemClose: handleItemClose,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$var$AccordionCollapsibleProvider, {
            scope: props.__scopeAccordion,
            collapsible: true,
            children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$var$AccordionImpl, {
                ...accordionMultipleProps,
                ref: forwardedRef
            })
        })
    });
});
var [$fa4abcfcbaf9a237$var$AccordionImplProvider, $fa4abcfcbaf9a237$var$useAccordionContext] = $fa4abcfcbaf9a237$var$createAccordionContext($fa4abcfcbaf9a237$var$ACCORDION_NAME);
var $fa4abcfcbaf9a237$var$AccordionImpl = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion, disabled: disabled, dir: dir, orientation: orientation = "vertical", ...accordionProps } = props;
    const accordionRef = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useRef(null);
    const composedRefs = (0, $d64198ac8789ff5a$export$c7b2cbe3552a0d05)(accordionRef, forwardedRef);
    const getItems = $fa4abcfcbaf9a237$var$useCollection(__scopeAccordion);
    const direction = (0, $cb91734f68068fe9$export$b39126d51d94e6f3)(dir);
    const isDirectionLTR = direction === "ltr";
    const handleKeyDown = (0, $1fa4c161ce280d4f$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
        if (!$fa4abcfcbaf9a237$var$ACCORDION_KEYS.includes(event.key)) return;
        const target = event.target;
        const triggerCollection = getItems().filter((item)=>!item.ref.current?.disabled);
        const triggerIndex = triggerCollection.findIndex((item)=>item.ref.current === target);
        const triggerCount = triggerCollection.length;
        if (triggerIndex === -1) return;
        event.preventDefault();
        let nextIndex = triggerIndex;
        const homeIndex = 0;
        const endIndex = triggerCount - 1;
        const moveNext = ()=>{
            nextIndex = triggerIndex + 1;
            if (nextIndex > endIndex) nextIndex = homeIndex;
        };
        const movePrev = ()=>{
            nextIndex = triggerIndex - 1;
            if (nextIndex < homeIndex) nextIndex = endIndex;
        };
        switch(event.key){
            case "Home":
                nextIndex = homeIndex;
                break;
            case "End":
                nextIndex = endIndex;
                break;
            case "ArrowRight":
                if (orientation === "horizontal") {
                    if (isDirectionLTR) moveNext();
                    else movePrev();
                }
                break;
            case "ArrowDown":
                if (orientation === "vertical") moveNext();
                break;
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    if (isDirectionLTR) movePrev();
                    else moveNext();
                }
                break;
            case "ArrowUp":
                if (orientation === "vertical") movePrev();
                break;
        }
        const clampedIndex = nextIndex % triggerCount;
        triggerCollection[clampedIndex].ref.current?.focus();
    });
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$var$AccordionImplProvider, {
        scope: __scopeAccordion,
        disabled: disabled,
        direction: dir,
        orientation: orientation,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$var$Collection.Slot, {
            scope: __scopeAccordion,
            children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).div, {
                ...accordionProps,
                "data-orientation": orientation,
                ref: composedRefs,
                onKeyDown: disabled ? void 0 : handleKeyDown
            })
        })
    });
});
var $fa4abcfcbaf9a237$var$ITEM_NAME = "AccordionItem";
var [$fa4abcfcbaf9a237$var$AccordionItemProvider, $fa4abcfcbaf9a237$var$useAccordionItemContext] = $fa4abcfcbaf9a237$var$createAccordionContext($fa4abcfcbaf9a237$var$ITEM_NAME);
var $fa4abcfcbaf9a237$export$d99097c13d4dac9f = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion, value: value, ...accordionItemProps } = props;
    const accordionContext = $fa4abcfcbaf9a237$var$useAccordionContext($fa4abcfcbaf9a237$var$ITEM_NAME, __scopeAccordion);
    const valueContext = $fa4abcfcbaf9a237$var$useAccordionValueContext($fa4abcfcbaf9a237$var$ITEM_NAME, __scopeAccordion);
    const collapsibleScope = $fa4abcfcbaf9a237$var$useCollapsibleScope(__scopeAccordion);
    const triggerId = (0, $48f6e55cf3c4c05f$export$f680877a34711e37)();
    const open = value && valueContext.value.includes(value) || false;
    const disabled = accordionContext.disabled || props.disabled;
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$var$AccordionItemProvider, {
        scope: __scopeAccordion,
        open: open,
        disabled: disabled,
        triggerId: triggerId,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($3f69c9cda1bc268d$export$be92b6f5f03c0fe9, {
            "data-orientation": accordionContext.orientation,
            "data-state": $fa4abcfcbaf9a237$var$getState(open),
            ...collapsibleScope,
            ...accordionItemProps,
            ref: forwardedRef,
            disabled: disabled,
            open: open,
            onOpenChange: (open2)=>{
                if (open2) valueContext.onItemOpen(value);
                else valueContext.onItemClose(value);
            }
        })
    });
});
$fa4abcfcbaf9a237$export$d99097c13d4dac9f.displayName = $fa4abcfcbaf9a237$var$ITEM_NAME;
var $fa4abcfcbaf9a237$var$HEADER_NAME = "AccordionHeader";
var $fa4abcfcbaf9a237$export$5e3e5deaaf81ee41 = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion, ...headerProps } = props;
    const accordionContext = $fa4abcfcbaf9a237$var$useAccordionContext($fa4abcfcbaf9a237$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $fa4abcfcbaf9a237$var$useAccordionItemContext($fa4abcfcbaf9a237$var$HEADER_NAME, __scopeAccordion);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)((0, $7ba09d26ee0d4423$export$250ffa63cdc0d034).h3, {
        "data-orientation": accordionContext.orientation,
        "data-state": $fa4abcfcbaf9a237$var$getState(itemContext.open),
        "data-disabled": itemContext.disabled ? "" : void 0,
        ...headerProps,
        ref: forwardedRef
    });
});
$fa4abcfcbaf9a237$export$5e3e5deaaf81ee41.displayName = $fa4abcfcbaf9a237$var$HEADER_NAME;
var $fa4abcfcbaf9a237$var$TRIGGER_NAME = "AccordionTrigger";
var $fa4abcfcbaf9a237$export$94e939b1f85bdd73 = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion, ...triggerProps } = props;
    const accordionContext = $fa4abcfcbaf9a237$var$useAccordionContext($fa4abcfcbaf9a237$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $fa4abcfcbaf9a237$var$useAccordionItemContext($fa4abcfcbaf9a237$var$TRIGGER_NAME, __scopeAccordion);
    const collapsibleContext = $fa4abcfcbaf9a237$var$useAccordionCollapsibleContext($fa4abcfcbaf9a237$var$TRIGGER_NAME, __scopeAccordion);
    const collapsibleScope = $fa4abcfcbaf9a237$var$useCollapsibleScope(__scopeAccordion);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$var$Collection.ItemSlot, {
        scope: __scopeAccordion,
        children: /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($3f69c9cda1bc268d$export$41fb9f06171c75f4, {
            "aria-disabled": itemContext.open && !collapsibleContext.collapsible || void 0,
            "data-orientation": accordionContext.orientation,
            id: itemContext.triggerId,
            ...collapsibleScope,
            ...triggerProps,
            ref: forwardedRef
        })
    });
});
$fa4abcfcbaf9a237$export$94e939b1f85bdd73.displayName = $fa4abcfcbaf9a237$var$TRIGGER_NAME;
var $fa4abcfcbaf9a237$var$CONTENT_NAME = "AccordionContent";
var $fa4abcfcbaf9a237$export$985b9a77379b54a0 = (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion, ...contentProps } = props;
    const accordionContext = $fa4abcfcbaf9a237$var$useAccordionContext($fa4abcfcbaf9a237$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $fa4abcfcbaf9a237$var$useAccordionItemContext($fa4abcfcbaf9a237$var$CONTENT_NAME, __scopeAccordion);
    const collapsibleScope = $fa4abcfcbaf9a237$var$useCollapsibleScope(__scopeAccordion);
    return /* @__PURE__ */ (0, $607ae91d1eb97195$exports.jsx)($3f69c9cda1bc268d$export$7c6e2c02157bb7d2, {
        role: "region",
        "aria-labelledby": itemContext.triggerId,
        "data-orientation": accordionContext.orientation,
        ...collapsibleScope,
        ...contentProps,
        ref: forwardedRef,
        style: {
            ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
            ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
            ...props.style
        }
    });
});
$fa4abcfcbaf9a237$export$985b9a77379b54a0.displayName = $fa4abcfcbaf9a237$var$CONTENT_NAME;
function $fa4abcfcbaf9a237$var$getState(open) {
    return open ? "open" : "closed";
}
var $fa4abcfcbaf9a237$export$be92b6f5f03c0fe9 = $fa4abcfcbaf9a237$export$a766cd26d0d69044;
var $fa4abcfcbaf9a237$export$6d08773d2e66f8f2 = $fa4abcfcbaf9a237$export$d99097c13d4dac9f;
var $fa4abcfcbaf9a237$export$8b251419efc915eb = $fa4abcfcbaf9a237$export$5e3e5deaaf81ee41;
var $fa4abcfcbaf9a237$export$41fb9f06171c75f4 = $fa4abcfcbaf9a237$export$94e939b1f85bdd73;
var $fa4abcfcbaf9a237$export$7c6e2c02157bb7d2 = $fa4abcfcbaf9a237$export$985b9a77379b54a0;




var $8vqx4 = parcelRequire("8vqx4");

const $ffe8aa15e98dc4cc$export$a766cd26d0d69044 = $fa4abcfcbaf9a237$export$be92b6f5f03c0fe9;
const $ffe8aa15e98dc4cc$export$d99097c13d4dac9f = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$export$6d08773d2e66f8f2, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("mb-4 border-b-[1px] border-theme-grey-5", className),
        ...props
    }));
$ffe8aa15e98dc4cc$export$d99097c13d4dac9f.displayName = "AccordionItem";
const $ffe8aa15e98dc4cc$export$94e939b1f85bdd73 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$export$8b251419efc915eb, {
        className: "flex",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)($fa4abcfcbaf9a237$export$41fb9f06171c75f4, {
            ref: ref,
            className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex flex-1 items-center justify-between pb-6 pt-2 text-left text-[20px] font-semibold text-theme-grey-10.5 outline-none transition-all [&[data-state=open]>svg]:rotate-180", className),
            ...props,
            children: [
                children,
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $40cee665c3968e3d$export$2e2bcd8739ae039), {
                    className: "h-[22px] w-[22px] shrink-0 transition-transform duration-200"
                })
            ]
        })
    }));
$ffe8aa15e98dc4cc$export$94e939b1f85bdd73.displayName = $fa4abcfcbaf9a237$export$41fb9f06171c75f4.displayName;
const $ffe8aa15e98dc4cc$export$985b9a77379b54a0 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$export$7c6e2c02157bb7d2, {
        ref: ref,
        className: "overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
        ...props,
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: (0, $db53bf731136662c$export$1343a74baacb0543)("pb-4 pt-0", className),
            children: children
        })
    }));
$ffe8aa15e98dc4cc$export$985b9a77379b54a0.displayName = $fa4abcfcbaf9a237$export$7c6e2c02157bb7d2.displayName;


function $8b9aabd33b90a7a4$export$2e2bcd8739ae039({ searchParams: searchParams, onFilterValueUpdate: onFilterValueUpdate }) {
    const [showSidebar, setShowSidebar] = (0, $8vqx4.useState)(false);
    const onShowSidebar = ()=>{
        setShowSidebar(true);
    };
    const onHideSidebar = ()=>{
        setShowSidebar(false);
    };
    const renderFiltersDemo = ()=>{
        return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $9334e483a2414035$export$2e2bcd8739ae039), {
                    label: "Sex",
                    name: "gender",
                    defaultValue: "",
                    value: searchParams["gender"],
                    values: (0, $604ba12280ccd2a0$export$7842ed161beddbfb),
                    onUpdate: onFilterValueUpdate
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $9334e483a2414035$export$2e2bcd8739ae039), {
                    label: "Size",
                    name: "size",
                    defaultValue: "",
                    value: searchParams["size"],
                    values: (0, $604ba12280ccd2a0$export$4dc49ec4166f91c8),
                    onUpdate: onFilterValueUpdate
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $9334e483a2414035$export$2e2bcd8739ae039), {
                    label: "Country",
                    name: "country",
                    defaultValue: "",
                    value: searchParams["country"],
                    values: (0, $604ba12280ccd2a0$export$f9f9a2a324f78679),
                    onUpdate: onFilterValueUpdate
                })
            ]
        });
    };
    const accordionDefaultValue = ()=>[
            "gender",
            "size"
        ].reduce((acc, val)=>{
            return searchParams[val]?.length > 0 ? [
                ...acc,
                val
            ] : acc;
        }, []);
    const renderSelectedFiters = ()=>{
        const out = [];
        if (searchParams.gender || searchParams.gender?.length > 0) {
            const elemsGender = searchParams.gender?.split(",").reduce((acc, v)=>{
                const val = v.trim();
                const title = (0, $604ba12280ccd2a0$export$7842ed161beddbfb).find((e)=>e.value === val).title;
                return [
                    ...acc,
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "flex cursor-pointer items-center gap-0.5 rounded-full bg-theme-grey-1 px-4 py-2 text-[14px] font-semibold",
                        onClick: ()=>{
                            const values = searchParams.gender?.split(",");
                            const excludedValue = values?.reduce((acc, v)=>{
                                if (v === val) return acc;
                                return [
                                    ...acc,
                                    v
                                ];
                            }, []);
                            onFilterValueUpdate("gender", excludedValue.join(","));
                        },
                        children: [
                            title,
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                className: "[&>svg]:rotate-45",
                                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $e0edee75b2c3cc8e$export$2e2bcd8739ae039), {
                                    className: "h-[20px] w-[20px]"
                                })
                            })
                        ]
                    }, title)
                ];
            }, []);
            out.push(elemsGender);
        }
        return out;
    };
    console.log("searchParams", searchParams);
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $075513266c39e734$export$2e2bcd8739ae039), {
                title: "Filter",
                show: showSidebar,
                onClose: onHideSidebar,
                width: "40%",
                barHeight: "screen",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: "p-7",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $ffe8aa15e98dc4cc$export$a766cd26d0d69044), {
                        type: "multiple",
                        className: "w-full",
                        defaultValue: accordionDefaultValue(),
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $ffe8aa15e98dc4cc$export$d99097c13d4dac9f), {
                                value: "gender",
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $ffe8aa15e98dc4cc$export$94e939b1f85bdd73), {
                                        children: [
                                            "Sex",
                                            searchParams["gender"]?.length > 0 ? ` (${searchParams["gender"]?.split(",").length})` : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $ffe8aa15e98dc4cc$export$985b9a77379b54a0), {
                                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $0343707ea14a49d1$export$2e2bcd8739ae039), {
                                            name: "gender",
                                            value: searchParams["gender"],
                                            values: (0, $604ba12280ccd2a0$export$7842ed161beddbfb),
                                            onChange: onFilterValueUpdate
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $ffe8aa15e98dc4cc$export$d99097c13d4dac9f), {
                                value: "size",
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $ffe8aa15e98dc4cc$export$94e939b1f85bdd73), {
                                        children: [
                                            "Size",
                                            searchParams["size"]?.length > 0 ? ` (${searchParams["size"]?.split(",").length})` : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $ffe8aa15e98dc4cc$export$985b9a77379b54a0), {
                                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $0343707ea14a49d1$export$2e2bcd8739ae039), {
                                            name: "size",
                                            value: searchParams["size"],
                                            values: (0, $604ba12280ccd2a0$export$4dc49ec4166f91c8),
                                            onChange: onFilterValueUpdate
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "flex flex-col gap-3",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: "flex w-full flex-row",
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex flex-row items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                    className: "flex cursor-pointer items-center gap-1 rounded-[4px] border-[1px] border-theme-grey-10.5 px-4 py-2 font-simianregular",
                                    onClick: onShowSidebar,
                                    children: [
                                        (0, $697654d10ef148cd$export$808a2a6d676a656b)(),
                                        " ",
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                            className: "font-medium leading-none",
                                            children: "Filter dogs"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "flex gap-2",
                                    children: renderSelectedFiters()
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "relative z-10",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                className: "text-[14px] text-theme-grey-7",
                                children: "Sort by"
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $9334e483a2414035$export$2e2bcd8739ae039), {
                                label: "",
                                defaultValue: "Default",
                                values: [
                                    {
                                        title: "Default",
                                        value: "Default"
                                    }
                                ],
                                border: false,
                                name: "order",
                                onUpdate: onFilterValueUpdate
                            })
                        ]
                    })
                ]
            })
        ]
    });
}






const $c31765a2df3e58dc$var$ageLabels = {
    puppy: "Puppy|0\u20131 year",
    young: "Young Adult|1\u20133 years",
    adult: "Adult|3\u20137 years",
    senior: "Senior|7\u201310+ years",
    geriatric: "Geriatric|10+ years"
};
const $c31765a2df3e58dc$var$sizeLabels = {
    small: "Small|Up to 10 kg (22 lbs)",
    medium: "Medium|10\u201325 kg (22\u201355 lbs)",
    large: "Large|Over 25 kg (55 lbs)"
};
function $c31765a2df3e58dc$export$2e2bcd8739ae039({ name: name, gender: gender, image: image, breed: breed, age: age, birthdate: birthdate, size: size, transfer: transfer, shelter: shelter, country: country, id: id }) {
    const renderGenderIcon = ()=>{
        if (gender === "female") return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "rounded-[4px] bg-theme-amber-5 p-[4px] text-[12px] font-semibold leading-none text-theme-white",
            children: "Female"
        });
        else return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "rounded-[4px] bg-theme-purple-5 p-[4px] text-[12px] font-semibold leading-none text-theme-white",
            children: "Male"
        });
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "rounded-[6px] border-[1px] border-theme-grey-1 bg-theme-white p-[12px] transition hover:bg-theme-grey-0.25",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $07071c34f63f350a$export$a6c7ac8248d6e38a), {
            to: `/pet/${id}`,
            className: "flex w-full flex-col gap-[10px]",
            children: [
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: "relative aspect-[4/3] overflow-hidden rounded-[4px]",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                        className: "h-full w-full object-cover object-center",
                        src: image,
                        alt: name
                    })
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: "flex",
                    children: renderGenderIcon()
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                    className: "flex flex-col gap-[4px]",
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            className: "text-[16px] font-bold leading-tight text-theme-grey-11",
                            children: name
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            className: "text-[14px] font-semibold text-theme-grey-9.5",
                            children: breed
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "text-[14px] text-theme-grey-9.5",
                            children: [
                                $c31765a2df3e58dc$var$ageLabels[age]?.split("|")[0],
                                " ",
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                    className: "text-theme-grey-7",
                                    children: $c31765a2df3e58dc$var$ageLabels[age]?.split("|")[1]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "text-[14px] text-theme-grey-9.5",
                            children: [
                                $c31765a2df3e58dc$var$sizeLabels[size]?.split("|")[0],
                                " ",
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                    className: "text-theme-grey-7",
                                    children: $c31765a2df3e58dc$var$sizeLabels[size].split("|")[1]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex flex-row items-center gap-[3px] text-[12px] font-semibold text-theme-grey-9.5",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
                                    width: "12",
                                    height: "13",
                                    viewBox: "0 0 12 13",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M5.09389 11.3931C5.24447 11.5893 5.39245 11.7821 5.53559 11.9712H5.54789C5.65583 12.1151 5.82577 12.2 6.00615 12.2C6.1865 12.2 6.35599 12.1151 6.46393 11.9712C6.60449 11.7858 6.74971 11.5968 6.89748 11.4044C8.3453 9.51958 10.038 7.31598 9.99935 5.13804C9.95342 2.88396 8.27236 1.20001 6 1.20001C3.72764 1.20001 2.04042 2.88408 2.00065 5.13804C1.96202 7.31183 3.64825 9.50921 5.09389 11.3931ZM6 7.20001C7.10457 7.20001 8 6.30458 8 5.20001C8 4.09544 7.10457 3.20001 6 3.20001C4.89543 3.20001 4 4.09544 4 5.20001C4 6.30458 4.89543 7.20001 6 7.20001Z",
                                        fill: "#454340"
                                    })
                                }),
                                (0, $22f2182d1b990877$export$18b02663f532815c)(country)
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


const $9b169bd9aff8c7c8$var$staticUrl = "https://tailtales.vorozhbit.com/static/";
function $9b169bd9aff8c7c8$export$2e2bcd8739ae039({ pets: pets, total: total }) {
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $607ae91d1eb97195$exports.Fragment), {
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "mb-8 grid grid-cols-1 gap-6 lg:grid-cols-4",
            children: pets.map((pet)=>{
                return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $c31765a2df3e58dc$export$2e2bcd8739ae039), {
                    image: `${$9b169bd9aff8c7c8$var$staticUrl}${pet.images[0].url}`,
                    shelter: pet.user.profile.title,
                    country: pet.user.profile.country,
                    ...pet
                }, pet.id);
            })
        })
    });
}


const $000194bdf4d5d981$var$defaultSearchParams = {
    lastId: "",
    page: 1,
    perPage: 8
};
function $000194bdf4d5d981$export$2e2bcd8739ae039({ showFilter: showFilter = true, gridWrapperCss: gridWrapperCss = "" }) {
    const [loading, setLoading] = (0, $8vqx4.useState)(true);
    const [queryParams, setQueryParams] = (0, $07071c34f63f350a$export$f1a78c17382fe22a)();
    const [searchParams, setSearchParams] = (0, $8vqx4.useState)();
    const [total, setTotal] = (0, $8vqx4.useState)(0);
    const [lastId, setLastId] = (0, $8vqx4.useState)("");
    const [pets, setPets] = (0, $8vqx4.useState)([]);
    (0, $8vqx4.useEffect)(()=>{
        const pagePrm = queryParams.get("page");
        const perPagePrm = queryParams.get("perPage");
        const genderParam = queryParams.get("gender");
        const sizeParam = queryParams.get("size");
        const countryParam = queryParams.get("country");
        const pr = {
            ...$000194bdf4d5d981$var$defaultSearchParams,
            page: pagePrm ? parseInt(pagePrm) : $000194bdf4d5d981$var$defaultSearchParams.page,
            perPage: perPagePrm ? parseInt(perPagePrm) : $000194bdf4d5d981$var$defaultSearchParams.perPage
        };
        if (genderParam) pr.gender = genderParam;
        if (sizeParam) pr.size = sizeParam;
        if (countryParam) pr.country = countryParam;
        setSearchParams(pr);
        fetchDogs(pr);
    }, []);
    (0, $8vqx4.useEffect)(()=>{
        console.log("searchParams", searchParams);
        if (!searchParams) return;
        setQueryParams(()=>{
            const { page: page, perPage: perPage, lastId: lastId, ...rest } = searchParams;
            const spms = Object.entries(rest).reduce((acc, entry)=>{
                const [key, value] = entry;
                if (value !== "") acc[key] = value;
                return acc;
            }, {});
            return spms;
        });
    }, [
        searchParams
    ]);
    const fetchDogs = async (params, clear = false)=>{
        params;
        try {
            await (0, $61e35487be0558dc$export$f3d518c5e135cea6)(params).then((data)=>{
                if (params.page === 1 || clear) setPets([
                    ...data.items
                ]);
                else setPets((prev)=>[
                        ...prev,
                        ...data.items
                    ]);
                if (data.items.length > 0) setLastId(data.items[data.items.length - 1].id);
                if (data.total) setTotal(data.total);
            }).finally(()=>{
                console.log("loaded");
                setLoading(false);
            });
        } catch (e) {
            console.log(e);
        }
    };
    const loadMore = ()=>{
        if (!searchParams || searchParams.page * searchParams.perPage >= total) return;
        const params = {
            ...searchParams
        };
        params.page = params.page + 1;
        params.lastId = lastId;
        setSearchParams(params);
        fetchDogs(params);
    };
    const onFilterValueUpdate = (name, value)=>{
        const params = {
            ...searchParams,
            ...$000194bdf4d5d981$var$defaultSearchParams,
            [name]: value
        };
        setSearchParams(params);
        fetchDogs(params, true);
    };
    if (loading || !searchParams) return null;
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $607ae91d1eb97195$exports.Fragment), {
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
            className: "relative mt-6 flex flex-col gap-5 px-5",
            children: [
                showFilter && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $8b9aabd33b90a7a4$export$2e2bcd8739ae039), {
                    searchParams: searchParams,
                    onFilterValueUpdate: onFilterValueUpdate
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: gridWrapperCss,
                    children: pets.length > 0 ? /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $9b169bd9aff8c7c8$export$2e2bcd8739ae039), {
                                pets: pets,
                                total: total
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                className: "mb-8 flex flex-col items-center justify-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        className: "font-simianregular leading-none text-[#A19D9D]",
                                        children: [
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                className: "text-[#0B0B0B]",
                                                children: pets.length
                                            }),
                                            " out of",
                                            " ",
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                className: "text-[#0B0B0B]",
                                                children: total
                                            }),
                                            " dogs"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                        className: "relative w-[140px] rounded-full bg-[#EAE4E0]",
                                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                            className: "h-[2px] rounded-full bg-black",
                                            style: {
                                                width: `${pets.length / total * 100}%`
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                                        title: "Load more",
                                        onClick: loadMore,
                                        size: "medium"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $607ae91d1eb97195$exports.Fragment), {
                        children: "No dogs found."
                    })
                })
            ]
        })
    });
}



var $67763902aaf9090d$exports = {};
$67763902aaf9090d$exports = import.meta.resolve("cfY5d");


// const heroImg = new URL("../assets/images/hero.jpg", import.meta.url);
const $83dda0001dc982aa$var$heroImg = new URL($67763902aaf9090d$exports);
var $5bbd333b406c8b10$exports = {};
$5bbd333b406c8b10$exports = import.meta.resolve("d0UBy");


const $83dda0001dc982aa$var$europeShelterImg = new URL($5bbd333b406c8b10$exports);
function $83dda0001dc982aa$export$2e2bcd8739ae039() {
    const navigate = (0, $68c2f6a70206c369$export$9770f232ac06a008)();
    (0, $8vqx4.useEffect)(()=>{
        window.scrollTo(0, 0);
        console.log("index");
        (0, $61e35487be0558dc$export$c73dcf559dad2f44)();
    }, []);
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $607ae91d1eb97195$exports.Fragment), {
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
            className: "container mx-auto pb-8",
            children: [
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: "px-5",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "relative h-[400px] overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                className: "absolute z-10 h-full w-full",
                                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                    className: "grid h-full w-full grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            className: "flex flex-col justify-center gap-4 p-14",
                                            children: [
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                    className: "text-theme-orange-5",
                                                    children: "2 dog shelters, 8 dogs"
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                    className: "max-w-[480px] font-simianregular text-[40px] leading-none text-white",
                                                    children: "Find your perfect rescue dog \u2013 easier than ever"
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                                                        title: "Learn more",
                                                        border: true,
                                                        onClick: ()=>navigate("/about")
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                            className: "flex justify-end p-8 text-theme-white",
                                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                className: "flex w-[200px] flex-col items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                                                        className: "w-[124px]",
                                                        src: $83dda0001dc982aa$var$europeShelterImg.href
                                                    }),
                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                        className: "text-right text-label-regular",
                                                        children: "Europe's leading dog shelter hub"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                                className: "block h-full w-full rounded-[16px] object-cover object-center",
                                src: $83dda0001dc982aa$var$heroImg.href,
                                alt: "tailtales adopt from dog shelters worldwide"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $000194bdf4d5d981$export$2e2bcd8739ae039), {
                    gridWrapperCss: "rounded-[8px] bg-theme-white"
                })
            ]
        })
    });
}




var $8vqx4 = parcelRequire("8vqx4");






function $0dbf38b1cf68f14f$export$2e2bcd8739ae039() {
    const [loading, setLoading] = (0, $8vqx4.useState)(false);
    const [email, setEmail] = (0, $8vqx4.useState)("");
    const [error, setError] = (0, $8vqx4.useState)("");
    const [password, setPassword] = (0, $8vqx4.useState)("");
    const navigate = (0, $68c2f6a70206c369$export$9770f232ac06a008)();
    const { user: user } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    const userDispatch = (0, $44a22ec1fae97653$export$5bd0aba7f9e819b6)();
    (0, $8vqx4.useEffect)(()=>{
        if (user.accessToken) {
            navigate("/");
            return;
        }
        window.scrollTo(0, 0);
    }, []);
    (0, $8vqx4.useEffect)(()=>{
        /* global google */ if (window.google) {
            google.accounts.id.initialize({
                client_id: "1014973080017-qbjbh7qviqplps4q3vn413ae283s67oh.apps.googleusercontent.com",
                callback: async (googleRes)=>{
                    const res = await (0, $61e35487be0558dc$export$d5e2872bdefef4f0)(googleRes);
                    if (res.accessToken) {
                        const payload = {
                            accessToken: res.accessToken,
                            profile: {
                                ...res.profile
                            }
                        };
                        userDispatch({
                            type: "set-data",
                            payload: payload
                        });
                        checkRedirectAndNavigate();
                    }
                }
            });
            google.accounts.id.renderButton(document.getElementById("signUpDiv"), {
                // type: "standard",
                theme: "filled_black",
                // size: "small",
                text: "continue_with",
                shape: "pill"
            });
            google.accounts.id.prompt();
        }
    }, []);
    const onSubmitForm = ()=>{
        if (email.length <= 1 || password.length <= 1) return;
        try {
            setLoading(true);
            setError("");
            (0, $61e35487be0558dc$export$9670d83f11d4b64a)(email, password).then((d)=>{
                console.log("DATA", d);
                if (d.error) setError(d.error);
                if (d.accessToken) {
                    const payload = {
                        accessToken: d.accessToken,
                        profile: {
                            ...d.profile
                        }
                    };
                    userDispatch({
                        type: "set-data",
                        payload: payload
                    });
                    checkRedirectAndNavigate();
                }
            }).catch((e)=>{
                console.log(e);
            }).finally(()=>{
                setLoading(false);
            });
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    };
    const checkRedirectAndNavigate = ()=>{
        const redirectUrl = (0, $e4a2f0245c788599$export$e4c9b9bae9539063)((0, $e4a2f0245c788599$export$ed7fe7865e115489));
        if (redirectUrl) {
            (0, $e4a2f0245c788599$export$a3e6e3b94afefd97)((0, $e4a2f0245c788599$export$ed7fe7865e115489));
            return navigate(redirectUrl);
        }
        return navigate("/");
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "flex w-full justify-end p-5 lg:p-10",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $07071c34f63f350a$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: (0, $697654d10ef148cd$export$e0297576c9c02d75)()
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "container mx-auto",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                    className: "flex flex-col items-center gap-6 p-5 lg:gap-12",
                    children: [
                        (0, $697654d10ef148cd$export$f7d22cea9593f68a)(),
                        (0, $697654d10ef148cd$export$3fe541c5a0ef78e0)("#ffffff", "202px", "100%"),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            className: "font-simianregular text-[32px]",
                            children: "Sign In"
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "flex flex-col gap-16 lg:w-[500px]",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("input", {
                                    type: "text",
                                    className: "w-full border-b-[1px] border-white bg-transparent px-3 pb-1 text-[32px] outline-0",
                                    placeholder: "Email",
                                    value: email,
                                    onChange: (e)=>setEmail(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("input", {
                                    type: "password",
                                    className: "w-full border-b-[1px] border-white bg-transparent px-3 pb-1 text-[32px] outline-0",
                                    placeholder: "Password",
                                    value: password,
                                    onChange: (e)=>setPassword(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                                    title: "Sing In",
                                    onClick: onSubmitForm,
                                    textClasses: "text-[32px]",
                                    buttonClasses: "py-8",
                                    disabled: loading
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            className: "text-red-500",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "mt-8 text-center font-simianregular",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "mb-5 text-[32px]",
                                    children: "Doesn\u2019t your dog shelter have a Tailtales account?"
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    className: "inline-block border-b-[1px] border-[#FFB55E] pb-1 text-[24px] text-[#FFB55E]",
                                    children: "Register for one now"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                id: "signUpDiv",
                                "data-text": "signup_with"
                            })
                        })
                    ]
                })
            })
        ]
    });
}




var $8vqx4 = parcelRequire("8vqx4");





var $8vqx4 = parcelRequire("8vqx4");

const $f2cf7a65030e2d25$export$a766cd26d0d69044 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex flex-col gap-4", className),
        ...props
    }));
$f2cf7a65030e2d25$export$a766cd26d0d69044.displayName = $fa4abcfcbaf9a237$export$be92b6f5f03c0fe9.displayName;
const $f2cf7a65030e2d25$export$d99097c13d4dac9f = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$export$6d08773d2e66f8f2, {
        ref: ref,
        className: (0, $db53bf731136662c$export$1343a74baacb0543)("rounded-[4px] bg-theme-grey-1 px-4", className),
        ...props
    }));
$f2cf7a65030e2d25$export$d99097c13d4dac9f.displayName = "AccordionItem";
const $f2cf7a65030e2d25$export$94e939b1f85bdd73 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$export$8b251419efc915eb, {
        className: "flex",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)($fa4abcfcbaf9a237$export$41fb9f06171c75f4, {
            ref: ref,
            className: (0, $db53bf731136662c$export$1343a74baacb0543)("flex flex-1 items-center justify-between py-5 text-left font-semibold text-theme-grey-10.5 transition-all [&[data-state=open]>svg]:rotate-45", className),
            ...props,
            children: [
                children,
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $e0edee75b2c3cc8e$export$2e2bcd8739ae039), {
                    className: "h-[18px] w-[18px] shrink-0 transition-transform duration-200"
                })
            ]
        })
    }));
$f2cf7a65030e2d25$export$94e939b1f85bdd73.displayName = $fa4abcfcbaf9a237$export$41fb9f06171c75f4.displayName;
const $f2cf7a65030e2d25$export$985b9a77379b54a0 = /*#__PURE__*/ $8vqx4.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)($fa4abcfcbaf9a237$export$7c6e2c02157bb7d2, {
        ref: ref,
        className: "overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
        ...props,
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: (0, $db53bf731136662c$export$1343a74baacb0543)("pb-4 pt-0", className),
            children: children
        })
    }));
$f2cf7a65030e2d25$export$985b9a77379b54a0.displayName = $fa4abcfcbaf9a237$export$7c6e2c02157bb7d2.displayName;






var $8vqx4 = parcelRequire("8vqx4");
function $88c531d5bc366ca9$export$2e2bcd8739ae039({ children: children, refId: refId, refObj: refObj }) {
    const containerRef = (0, $8vqx4.useRef)(null);
    (0, $8vqx4.useEffect)(()=>{
        const wrapper = containerRef.current;
        let footer = null;
        if (refObj && typeof refObj !== "function" && "current" in refObj) footer = refObj.current;
        else if (typeof refId === "string") footer = document.getElementById(refId);
        function onScroll() {
            if (!wrapper || !footer) return;
            const wrapperRect = wrapper.getBoundingClientRect();
            const footerRect = footer.getBoundingClientRect();
            // If the bottom of the wrapper would overlap the top of the footer
            if (wrapperRect.bottom > footerRect.top) {
                wrapper.style.position = "absolute";
                wrapper.style.top = `${window.scrollY + footerRect.top - wrapper.offsetHeight}px`;
            } else {
                wrapper.style.position = "sticky";
                wrapper.style.top = "20px";
            }
        }
        window.addEventListener("scroll", onScroll);
        return ()=>window.removeEventListener("scroll", onScroll);
    }, [
        refObj,
        refId
    ]);
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        ref: containerRef,
        children: children
    });
}



const $5cfd821ecf9b3d78$var$staticUrl = "https://tailtales.vorozhbit.com/static/";
function $5cfd821ecf9b3d78$export$2e2bcd8739ae039() {
    const [loading, setLoading] = (0, $8vqx4.useState)(true);
    const [pet, setPet] = (0, $8vqx4.useState)({});
    const navigate = (0, $68c2f6a70206c369$export$9770f232ac06a008)();
    const { id: id } = (0, $68c2f6a70206c369$export$99eaa27ddbbb95ef)();
    const containerRef = (0, $8vqx4.useRef)(null);
    (0, $8vqx4.useEffect)(()=>{
        console.log(pet);
    }, [
        pet
    ]);
    (0, $8vqx4.useEffect)(()=>{
        (0, $61e35487be0558dc$export$2f54905a28ae7974)(id).then((data)=>setPet(data)).finally(()=>{
            setLoading(false);
        });
    }, []);
    (0, $8vqx4.useEffect)(()=>{
        if (!pet.images || loading) return;
        window.scrollTo(0, 0);
    }, [
        pet.images,
        loading
    ]);
    const getNav = ()=>{
        return [
            {
                title: "About dog",
                url: `/pet/${id}`,
                active: true
            },
            {
                title: "About shelter",
                url: `/pet/${id}/shelter`
            }
        ];
    };
    const getParamsList = ()=>{
        const list = [
            {
                title: "Dog code",
                value: pet.petCode
            }
        ];
        if (pet.birthdate) list.push({
            title: "Birth date",
            value: pet.birthdate
        });
        if (pet.travelRequirements?.chip) list.push({
            title: "Chip",
            value: "Yes"
        });
        if (pet.travelRequirements?.passport) list.push({
            title: "Pet passport",
            value: "Yes"
        });
        if (pet.treatments?.flea) list.push({
            title: "Flea and Tick Treatment",
            value: "Yes"
        });
        if (pet.treatments?.deworming) list.push({
            title: "Deworming",
            value: "Yes"
        });
        return list;
    };
    const getVaccinesList = ()=>{
        const list = [];
        if (pet.vaccines?.dhpp) list.push("DHPP");
        if (pet.vaccines?.rabies) list.push("Rabies");
        return list;
    };
    if (!pet || loading) return null;
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "container mx-auto px-5",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "mb-6 text-theme-grey-7",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $07071c34f63f350a$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "Home"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                className: "text-theme-grey-11",
                                children: pet.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $c80276e460c7625c$export$2e2bcd8739ae039), {
                        pet: pet,
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                            title: "Explore Adoption",
                            onClick: ()=>navigate(`/adopt/${pet.id}`),
                            theme: "dark"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "relative my-8 border-b-[1px] border-theme-grey-1",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: "container mx-auto flex flex-col items-center justify-between gap-4 px-5 lg:flex-row",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: "flex h-full w-full flex-row items-center gap-6",
                        children: getNav().map((i)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                className: "flex h-full items-center",
                                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $07071c34f63f350a$export$a6c7ac8248d6e38a), {
                                    to: i.url,
                                    className: `cursor-pointer border-b-2 border-transparent pb-1 font-semibold text-theme-grey-11 hover:border-[#000000] ${i.active && "!border-[#000000]"}`,
                                    children: i.title
                                })
                            }, i.title))
                    })
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "container mx-auto mb-8 px-5",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                    className: "grid grid-cols-3 gap-5",
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            id: "pet-scroll",
                            className: "pet-images-scroll relative col-span-2 flex flex-col gap-5",
                            children: pet.images && [
                                ...pet.images
                            ].filter((i)=>!i.main).sort((a, b)=>{
                                if (a.main) return -1;
                                else if (b.main) return 1;
                                return 0;
                            }).map((i)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                                    src: `${$5cfd821ecf9b3d78$var$staticUrl}${i.url}`,
                                    className: "w-full rounded-[4px]"
                                }, i.url))
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            className: "relative flex flex-col gap-5",
                            ref: containerRef,
                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $88c531d5bc366ca9$export$2e2bcd8739ae039), {
                                refId: "footer",
                                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $f2cf7a65030e2d25$export$a766cd26d0d69044), {
                                    type: "single",
                                    collapsible: true,
                                    className: "w-full",
                                    defaultValue: "item-2",
                                    children: [
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $f2cf7a65030e2d25$export$d99097c13d4dac9f), {
                                            value: "item-1",
                                            children: [
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $f2cf7a65030e2d25$export$94e939b1f85bdd73), {
                                                    children: "Description"
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $f2cf7a65030e2d25$export$985b9a77379b54a0), {
                                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                        className: "flex flex-col gap-6 whitespace-pre-wrap leading-[135%] text-[#5C5C5C]",
                                                        dangerouslySetInnerHTML: {
                                                            __html: pet.desc
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $f2cf7a65030e2d25$export$d99097c13d4dac9f), {
                                            value: "item-2",
                                            children: [
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $f2cf7a65030e2d25$export$94e939b1f85bdd73), {
                                                    children: "Details"
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $f2cf7a65030e2d25$export$985b9a77379b54a0), {
                                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                        className: "grid grid-cols-2 border-l-[1px] border-t-[1px] border-[#DBDBDB]",
                                                        children: getParamsList().map((p)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                                className: "border-b-[1px] border-r-[1px] border-[#DBDBDB] p-3 text-[#242424]",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                                        className: "font-barlowmedium",
                                                                        children: p.title
                                                                    }),
                                                                    p.value
                                                                ]
                                                            }, p.title))
                                                    })
                                                })
                                            ]
                                        }),
                                        getVaccinesList().length > 0 && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $f2cf7a65030e2d25$export$d99097c13d4dac9f), {
                                            value: "item-3",
                                            children: [
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $f2cf7a65030e2d25$export$94e939b1f85bdd73), {
                                                    children: "Vaccinations"
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $f2cf7a65030e2d25$export$985b9a77379b54a0), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                            className: "mb-4 flex flex-row flex-wrap gap-2",
                                                            children: getVaccinesList().map((v)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                                    className: "inline-block rounded-[5px] bg-[#F8F5F2] px-4 py-2 font-barlowmedium text-[#242424]",
                                                                    children: v
                                                                }, v))
                                                        }),
                                                        Math.round(Math.random()) ? /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                            className: "mb-4",
                                                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                                className: "flex items-center gap-1 text-[12px]",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("svg", {
                                                                        width: "10",
                                                                        height: "9",
                                                                        viewBox: "0 0 10 9",
                                                                        fill: "none",
                                                                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                                                                            d: "M1 3.08696L2.97763 7.36773C3.30648 8.07956 4.28935 8.15321 4.72061 7.49833L9 1",
                                                                            stroke: "#096807",
                                                                            strokeWidth: "2",
                                                                            strokeLinecap: "round"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                                        children: [
                                                                            "Meets all",
                                                                            " ",
                                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                                                className: "font-barlowmedium",
                                                                                children: "EU requirements for dog vaccinations"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }) : /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                            className: "mb-4 inline-block",
                                                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                                className: "flex items-center gap-1 border-b-[1px] border-[#F6520B] pb-2 text-[12px] text-[#F6520B]",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
                                                                        width: "10",
                                                                        height: "10",
                                                                        viewBox: "0 0 10 10",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                                                                                d: "M8.07129 1.46436L1.00022 8.53542",
                                                                                stroke: "#F6520B",
                                                                                strokeWidth: "2",
                                                                                strokeLinecap: "round"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                                                                                d: "M8.07129 8.53564L1.00022 1.46458",
                                                                                stroke: "#F6520B",
                                                                                strokeWidth: "2",
                                                                                strokeLinecap: "round"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                                        children: "Does not yet meet all EU requirements for dog vaccinations."
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $f2cf7a65030e2d25$export$d99097c13d4dac9f), {
                                            value: "item-4",
                                            children: [
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $f2cf7a65030e2d25$export$94e939b1f85bdd73), {
                                                    children: "Ask shelter about this dog"
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $f2cf7a65030e2d25$export$985b9a77379b54a0), {
                                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                        className: "flex flex-col gap-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("textarea", {
                                                                rows: 5,
                                                                className: "w-full resize-none rounded-[4px] border-[1px] border-[#DBDBDB] p-[10px] outline-0",
                                                                placeholder: "Message"
                                                            }),
                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                                                                title: "Send",
                                                                onClick: ()=>"",
                                                                theme: "dark"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $f2cf7a65030e2d25$export$d99097c13d4dac9f), {
                                            value: "item-5",
                                            children: [
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $f2cf7a65030e2d25$export$94e939b1f85bdd73), {
                                                    children: "Share this dog with a friend"
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $f2cf7a65030e2d25$export$985b9a77379b54a0), {
                                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                                                        title: "Share",
                                                        onClick: ()=>"",
                                                        theme: "transparent",
                                                        buttonClasses: "w-full"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}




var $8vqx4 = parcelRequire("8vqx4");
function $77dade0162085f34$export$2e2bcd8739ae039() {
    (0, $8vqx4.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "container mx-auto",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "p-5",
            children: "Products"
        })
    });
}




var $8vqx4 = parcelRequire("8vqx4");








const $c79cf27e25c5a08c$var$staticUrl = "https://tailtales.vorozhbit.com/static/";
function $c79cf27e25c5a08c$export$2e2bcd8739ae039() {
    const [loading, setLoading] = (0, $8vqx4.useState)(true);
    const [pet, setPet] = (0, $8vqx4.useState)({});
    const [shelter, setShelter] = (0, $8vqx4.useState)({});
    const navigate = (0, $68c2f6a70206c369$export$9770f232ac06a008)();
    const petListRef = (0, $8vqx4.useRef)(null);
    const { id: id } = (0, $68c2f6a70206c369$export$99eaa27ddbbb95ef)();
    (0, $8vqx4.useEffect)(()=>{
        (0, $61e35487be0558dc$export$2f54905a28ae7974)(id).then((data)=>{
            setPet(data);
            setShelter(data.user.profile);
        }).finally(()=>setLoading(false));
    }, []);
    (0, $8vqx4.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    const getNav = ()=>{
        return [
            {
                title: "About dog",
                url: `/pet/${id}`
            },
            {
                title: "About shelter",
                url: `/pet/${id}/shelter`,
                active: true
            }
        ];
    };
    if (loading) return null;
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "container mx-auto px-5",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "mb-6 text-theme-grey-7",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $07071c34f63f350a$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "Home"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                className: "text-theme-grey-11",
                                children: pet.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $c80276e460c7625c$export$2e2bcd8739ae039), {
                        pet: pet,
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $1284d070a00ed901$export$2e2bcd8739ae039), {
                            title: "Explore Adoption",
                            onClick: ()=>navigate(`/adopt/${pet.id}`),
                            theme: "dark"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "relative my-8 border-b-[1px] border-theme-grey-1",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: "container mx-auto flex flex-col items-center justify-between gap-4 px-5 lg:flex-row",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: "flex h-full w-full flex-row items-center gap-6",
                        children: getNav().map((i)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                className: "flex h-full items-center",
                                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $07071c34f63f350a$export$a6c7ac8248d6e38a), {
                                    to: i.url,
                                    className: `cursor-pointer border-b-2 border-transparent pb-1 font-semibold text-theme-grey-11 hover:border-[#000000] ${i.active && "!border-[#000000]"}`,
                                    children: i.title
                                })
                            }, i.title))
                    })
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "container mx-auto mb-8 px-5",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                    className: "relative flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                            src: `${$c79cf27e25c5a08c$var$staticUrl}${shelter.logo.url}`,
                            className: "h-auto w-[110px] rounded-[4px]"
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            className: "text-[30px] font-medium leading-none text-theme-grey-9.5 lg:text-[64px]",
                            children: shelter.title
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            className: "text-[20px] font-semibold text-theme-grey-9.5",
                            children: (0, $22f2182d1b990877$export$18b02663f532815c)(shelter.country)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "container mx-auto mb-8 px-5",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                    className: "mb-10 grid grid-cols-3 gap-5",
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            className: "col-span-2",
                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                                src: `${$c79cf27e25c5a08c$var$staticUrl}${shelter.header.url}`,
                                className: "h-auto w-full rounded-[4px]"
                            })
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $88c531d5bc366ca9$export$2e2bcd8739ae039), {
                                refObj: petListRef,
                                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $f2cf7a65030e2d25$export$a766cd26d0d69044), {
                                    type: "single",
                                    collapsible: true,
                                    className: "w-full",
                                    defaultValue: "item-1",
                                    children: [
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $f2cf7a65030e2d25$export$d99097c13d4dac9f), {
                                            value: "item-1",
                                            className: "bg-theme-grey-1 px-5",
                                            children: [
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $f2cf7a65030e2d25$export$94e939b1f85bdd73), {
                                                    children: "About shelter"
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $f2cf7a65030e2d25$export$985b9a77379b54a0), {
                                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                        className: "flex flex-col gap-6 whitespace-pre-wrap leading-[135%] text-[#5C5C5C]",
                                                        dangerouslySetInnerHTML: {
                                                            __html: shelter.desc
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $f2cf7a65030e2d25$export$d99097c13d4dac9f), {
                                            value: "item-2",
                                            className: "bg-theme-grey-1 px-5",
                                            children: [
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $f2cf7a65030e2d25$export$94e939b1f85bdd73), {
                                                    children: "Contact"
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $f2cf7a65030e2d25$export$985b9a77379b54a0), {
                                                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                        className: "flex flex-col gap-5",
                                                        children: [
                                                            {
                                                                title: "Address",
                                                                value: `${shelter.street}, ${shelter.city}, ${shelter.postcode}, ${shelter.country}`
                                                            },
                                                            {
                                                                title: "Telephone",
                                                                value: shelter.phone
                                                            },
                                                            {
                                                                title: "Website",
                                                                value: shelter.website
                                                            }
                                                        ].map((p)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                                className: "text-[#868686]",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                                        className: "font-barlowmedium text-[#242424]",
                                                                        children: p.title
                                                                    }),
                                                                    p.value
                                                                ]
                                                            }, p.title))
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "container mx-auto mb-8",
                id: "dogs-list",
                ref: petListRef,
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "mb-8 px-5 text-[24px] leading-none text-[#161616]",
                        children: [
                            "All dogs from ",
                            shelter.title
                        ]
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $000194bdf4d5d981$export$2e2bcd8739ae039), {
                        showFilter: false
                    })
                ]
            })
        ]
    });
}




var $8vqx4 = parcelRequire("8vqx4");
function $9cc00f0a07a82f20$export$2e2bcd8739ae039() {
    (0, $8vqx4.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "container mx-auto",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "p-5",
            children: "Shelters"
        })
    });
}


function $b361742d0ca82417$export$2e2bcd8739ae039() {
    const { user: user, populateFromStorage: populateFromStorage, saveToStorage: saveToStorage } = (0, $44a22ec1fae97653$export$87c54b525b914dab)();
    (0, $8vqx4.useEffect)(()=>{
        populateFromStorage();
    }, []);
    (0, $8vqx4.useEffect)(()=>{
        saveToStorage();
    }, [
        user
    ]);
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $68c2f6a70206c369$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $68c2f6a70206c369$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $002784782296ad06$export$2e2bcd8739ae039), {}),
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $68c2f6a70206c369$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $83dda0001dc982aa$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $68c2f6a70206c369$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $002784782296ad06$export$2e2bcd8739ae039), {}),
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $68c2f6a70206c369$export$e7b0ac011bb776c6), {
                        path: "/pet/:id",
                        element: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $5cfd821ecf9b3d78$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $68c2f6a70206c369$export$e7b0ac011bb776c6), {
                        path: "/pet/:id/shelter",
                        element: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $c79cf27e25c5a08c$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $68c2f6a70206c369$export$e7b0ac011bb776c6), {
                        path: "/adopt/:id",
                        element: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $bf24494658af9f2f$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $68c2f6a70206c369$export$e7b0ac011bb776c6), {
                        path: "/about",
                        element: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $d0667814149503ac$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $68c2f6a70206c369$export$e7b0ac011bb776c6), {
                        path: "/products",
                        element: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $77dade0162085f34$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $68c2f6a70206c369$export$e7b0ac011bb776c6), {
                        path: "/shelters",
                        element: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $9cc00f0a07a82f20$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $68c2f6a70206c369$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $4d846d157e816664$export$2e2bcd8739ae039), {}),
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $68c2f6a70206c369$export$e7b0ac011bb776c6), {
                    path: "/login",
                    element: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $0dbf38b1cf68f14f$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
}



const $cd5295f0fa5bf664$var$baseurl = "";
const $cd5295f0fa5bf664$var$container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const $cd5295f0fa5bf664$var$root = (0, $ffa230115876cfd8$exports.createRoot)($cd5295f0fa5bf664$var$container);
$cd5295f0fa5bf664$var$root.render(/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $07071c34f63f350a$export$9ba4e89fdfa1fc54), {
    basename: $cd5295f0fa5bf664$var$baseurl,
    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $44a22ec1fae97653$export$88f24fd8fcfab6ca), {
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $b361742d0ca82417$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=tt-web.3e3bbbed.js.map
